import { $ as e, $n as t, $r as n, $t as r, A as i, An as a, Ar as o, At as s, B as c, Bn as l, Br as u, Bt as d, C as f, Cn as p, Cr as m, Ct as h, D as g, Dn as _, Dr as v, Dt as y, E as b, En as x, Er as S, Et as C, F as w, Fn as T, Fr as E, Ft as D, G as ee, Gn as te, Gr as O, Gt as ne, H as re, Hn as ie, Hr as ae, Ht as oe, I as se, In as ce, Ir as le, It as ue, J as de, Jn as fe, Jr as pe, Jt as me, K as he, Kn as ge, Kr as _e, Kt as ve, L as ye, Ln as be, Lr as xe, Lt as Se, M as Ce, Mn as we, Mr as Te, Mt as Ee, N as De, Nn as Oe, Nr as ke, Nt as Ae, O as je, On as Me, Or as Ne, Ot as Pe, P as Fe, Pn as Ie, Pr as Le, Pt as Re, Q as ze, Qn as Be, Qr as Ve, Qt as He, R as Ue, Rn as We, Rr as Ge, Rt as Ke, S as qe, Sn as Je, Sr as Ye, St as Xe, T as Ze, Tn as Qe, Tr as $e, Tt as et, U as tt, Un as nt, Ur as rt, Ut as it, V as at, Vn as ot, Vr as st, Vt as ct, W as lt, Wn as ut, Wr as dt, Wt as ft, X as pt, Xn as mt, Xr as ht, Xt as gt, Y as _t, Yn as vt, Yr as yt, Yt as bt, Z as xt, Zn as St, Zr as Ct, Zt as wt, _ as Tt, _n as Et, _r as Dt, _t as k, a as Ot, an as kt, ar as At, at as jt, b as Mt, bn as Nt, br as Pt, bt as Ft, c as It, cn as Lt, cr as Rt, ct as zt, d as Bt, dn as Vt, dr as Ht, dt as A, ei as Ut, en as Wt, er as Gt, et as Kt, f as qt, fn as Jt, fr as Yt, ft as Xt, g as Zt, gn as Qt, gr as $t, gt as en, h as tn, hn as j, hr as nn, ht as M, i as rn, ii as an, in as on, ir as sn, it as cn, j as ln, jn as un, jr as dn, jt as fn, k as pn, kn as mn, kr as hn, kt as gn, l as _n, ln as vn, lr as yn, lt as bn, m as xn, mn as N, mr as Sn, mt as P, n as Cn, ni as wn, nn as Tn, nr as En, nt as Dn, o as On, on as kn, or as An, ot as jn, p as Mn, pn as Nn, pr as Pn, pt as Fn, q as In, qn as Ln, qr as Rn, qt as zn, r as Bn, ri as Vn, rn as Hn, rr as Un, rt as Wn, s as Gn, sn as Kn, sr as qn, st as Jn, t as Yn, ti as Xn, tn as Zn, tr as Qn, tt as $n, u as er, un as tr, ur as nr, ut as rr, v as ir, vn as ar, vr as or, vt as F, w as sr, wn as cr, wr as lr, wt as ur, x as dr, xn as fr, xr as pr, xt as I, y as mr, yn as hr, yr as gr, yt as L, z as _r, zn as vr, zr as yr, zt as br } from "./theme-CQlMItXo.js";
import { Accordion as xr, AccordionButton as Sr, AccordionIcon as Cr, AccordionItem as wr, AccordionPanel as Tr, Avatar as Er, Box as Dr, Box as R, Button as Or, ButtonGroup as kr, Card as Ar, CardBody as jr, CardHeader as Mr, Center as Nr, Center as z, Checkbox as Pr, CircularProgress as Fr, Collapse as Ir, Divider as Lr, Divider as Rr, Drawer as zr, DrawerBody as Br, DrawerContent as Vr, Flex as Hr, Flex as B, FocusLock as Ur, FormLabel as Wr, Grid as Gr, Grid as Kr, GridItem as qr, GridItem as Jr, HStack as Yr, Icon as Xr, IconButton as Zr, Image as Qr, Input as $r, InputGroup as ei, InputLeftAddon as ti, InputRightAddon as ni, Link as ri, Menu as ii, MenuButton as ai, MenuDivider as oi, MenuItem as si, MenuList as ci, Modal as li, ModalContent as ui, ModalOverlay as di, NumberInput as fi, NumberInputField as pi, Popover as mi, PopoverAnchor as hi, PopoverArrow as gi, PopoverBody as _i, PopoverContent as vi, PopoverHeader as yi, PopoverTrigger as bi, Portal as xi, Portal as Si, Radio as Ci, RadioGroup as wi, SimpleGrid as Ti, Skeleton as Ei, Spacer as Di, Spinner as Oi, Spinner as ki, Stack as Ai, Switch as ji, Table as Mi, Table as Ni, TableContainer as Pi, Tbody as Fi, Tbody as Ii, Td as Li, Td as Ri, Text as zi, Text as V, Textarea as Bi, Tfoot as Vi, Th as Hi, Th as Ui, Thead as Wi, Thead as Gi, Tooltip as Ki, Tr as qi, Tr as Ji, forwardRef as Yi, useMenuContext as Xi } from "@chakra-ui/react";
import { Fragment as H, jsx as U, jsxs as W } from "react/jsx-runtime";
import { IconProgress100 as Zi } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconProgress100";
import { IconProgress50 as Qi } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconProgress50";
import { IconFormCircle as $i } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFormCircle";
import { Icon3dBoxTop as ea } from "@central-icons-react/round-outlined-radius-2-stroke-2/Icon3dBoxTop";
import { Icon3dPackage2 as ta } from "@central-icons-react/round-outlined-radius-2-stroke-2/Icon3dPackage2";
import { IconAgent as na } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAgent";
import { IconAlignmentCenter as ra } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAlignmentCenter";
import { IconAlignmentLeft as ia } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAlignmentLeft";
import { IconAlignmentRight as aa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAlignmentRight";
import { IconArchive1 as oa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArchive1";
import { IconArmchair as sa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArmchair";
import { IconArrowBoxLeft as ca } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowBoxLeft";
import { IconArrowCornerDownLeft as la } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowCornerDownLeft";
import { IconArrowCornerDownRight as ua } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowCornerDownRight";
import { IconArrowDown as da } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowDown";
import { IconArrowInbox as fa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowInbox";
import { IconArrowLeft as pa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowLeft";
import { IconArrowOutOfBox as ma } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowOutOfBox";
import { IconArrowRight as ha } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRight";
import { IconArrowRightLeft as ga } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRightLeft";
import { IconArrowRotateRightLeft as _a } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowRotateRightLeft";
import { IconArrowTopBottom as va } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowTopBottom";
import { IconArrowUp as ya } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowUp";
import { IconArrowUpRight as ba } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowUpRight";
import { IconArrowsRepeat as xa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconArrowsRepeat";
import { IconAt as Sa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconAt";
import { IconBag3 as Ca } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBag3";
import { IconBank as wa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBank";
import { IconBanknote2 as Ta } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBanknote2";
import { IconChart4 as Ea } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChart4";
import { IconChart2 as Da } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChart2";
import { IconBarsThree as Oa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBarsThree";
import { IconBarsThree2 as ka } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBarsThree2";
import { IconBell as Aa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBell";
import { IconBold as ja } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBold";
import { IconNewspaper1 as Ma } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconNewspaper1";
import { IconBookmark as Na } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBookmark";
import { IconBooks as Pa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBooks";
import { IconBrokenChainLink3 as Fa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBrokenChainLink3";
import { IconBubbleDots as Ia } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBubbleDots";
import { IconBug as La } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBug";
import { IconBuildings as Ra } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconBuildings";
import { IconCalculator as za } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCalculator";
import { IconCalendar2 as Ba } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCalendar2";
import { IconCalendarDays as Va } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCalendarDays";
import { IconCalendarRemove4 as Ha } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCalendarRemove4";
import { IconChainLink3 as Ua } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChainLink3";
import { IconChairModern as Wa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChairModern";
import { IconCheckCircle2 as Ga } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCheckCircle2";
import { IconCheckmark1Medium as Ka } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCheckmark1Medium";
import { IconChevronDoubleLeft as qa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronDoubleLeft";
import { IconChevronDoubleRight as Ja } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronDoubleRight";
import { IconChevronDownMedium as Ya } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronDownMedium";
import { IconChevronDownSmall as Xa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronDownSmall";
import { IconChevronGrabberVertical as Za } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronGrabberVertical";
import { IconChevronLeftMedium as Qa } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronLeftMedium";
import { IconChevronRightMedium as $a } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronRightMedium";
import { IconChevronTopMedium as eo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChevronTopMedium";
import { IconChipSimple as to } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconChipSimple";
import { IconCircleBanSign as no } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleBanSign";
import { IconCircleDashed as ro } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleDashed";
import { IconCircleInfo as io } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleInfo";
import { IconCircleMinus as ao } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleMinus";
import { IconCirclePlus as oo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCirclePlus";
import { IconCircleQuestionmark as so } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleQuestionmark";
import { IconCircleX as co } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCircleX";
import { IconClipboard2 as lo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconClipboard2";
import { IconClock3OClock as uo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconClock3OClock";
import { IconCode as fo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCode";
import { IconCoinStack as po } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCoinStack";
import { IconColumns3 as mo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconColumns3";
import { IconConsole as ho } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconConsole";
import { IconCreditCard2 as go } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCreditCard2";
import { IconDotGrid2x3 as _o } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconDotGrid2x3";
import { IconEditBig as vo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEditBig";
import { IconDotGrid1x3HorizontalTight as yo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconDotGrid1x3HorizontalTight";
import { IconDotGrid1x3VerticalTight as bo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconDotGrid1x3VerticalTight";
import { IconEmail2 as xo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEmail2";
import { IconExclamationCircle as So } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExclamationCircle";
import { IconExclamationTriangle as Co } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExclamationTriangle";
import { IconExpand45 as wo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconExpand45";
import { IconEyeOpen as To } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEyeOpen";
import { IconEyeSlash as Eo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconEyeSlash";
import { IconFileBend as Do } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFileBend";
import { IconFilePdf as Oo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFilePdf";
import { IconFileText as ko } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFileText";
import { IconFilter2 as Ao } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFilter2";
import { IconFlag2 as jo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFlag2";
import { IconFocusExposure as Mo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconFocusExposure";
import { IconGraduateCap as No } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconGraduateCap";
import { IconH1 as Po } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconH1";
import { IconH2 as Fo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconH2";
import { IconH3 as Io } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconH3";
import { IconHashtag as Lo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHashtag";
import { IconHomeRoofDoor as Ro } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconHomeRoofDoor";
import { IconImages1 as zo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconImages1";
import { IconItalic as Bo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconItalic";
import { IconKey2 as Vo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconKey2";
import { IconLab as Ho } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLab";
import { IconLayersThree as Uo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLayersThree";
import { IconLayoutGrid2 as Wo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLayoutGrid2";
import { IconLayoutSidebar as Go } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLayoutSidebar";
import { IconLayoutTopbar as Ko } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLayoutTopbar";
import { IconLightningBolt as qo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLightningBolt";
import { IconLightningBoltOff as Jo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLightningBoltOff";
import { IconListBullets as Yo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconListBullets";
import { IconLock as Xo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLock";
import { IconMagnifyingGlass2 as Zo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMagnifyingGlass2";
import { IconMaintenance as Qo } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMaintenance";
import { IconMapPin as $o } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMapPin";
import { IconMathScientific as es } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMathScientific";
import { IconMinimize45 as ts } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMinimize45";
import { IconMinusMedium as ns } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconMinusMedium";
import { IconNewspaper as rs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconNewspaper";
import { IconNumberedList as is } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconNumberedList";
import { IconPageAdd as as } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPageAdd";
import { IconPageText as os } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPageText";
import { IconPaperclip1 as ss } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPaperclip1";
import { IconPaperPlaneTopRight as cs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPaperPlaneTopRight";
import { IconPencil as ls } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPencil";
import { IconPencilWave as us } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPencilWave";
import { IconPeopleCircle as ds } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPeopleCircle";
import { IconPeopleIdCard as fs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPeopleIdCard";
import { IconPieChart2 as ps } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPieChart2";
import { IconPlay as ms } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlay";
import { IconPlayCircle as hs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlayCircle";
import { IconPlusMedium as gs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPlusMedium";
import { IconProjects as _s } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconProjects";
import { IconReceiptBill as vs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconReceiptBill";
import { IconReceiptStorno as ys } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconReceiptStorno";
import { IconReceiptTax as bs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconReceiptTax";
import { IconRescueRing as xs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconRescueRing";
import { IconPush as Ss } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconPush";
import { IconLaw as Cs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLaw";
import { IconServer2 as ws } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconServer2";
import { IconSettingsGear2 as Ts } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSettingsGear2";
import { IconSettingsSliderHor as Es } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSettingsSliderHor";
import { IconShieldCheck as Ds } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconShieldCheck";
import { IconLiveFull as Os } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconLiveFull";
import { IconSignature as ks } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSignature";
import { IconSparkles3Bold as As } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSparkles3Bold";
import { IconSpeedHigh as js } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSpeedHigh";
import { IconSquareArrowTopRight as Ms } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSquareArrowTopRight";
import { IconSquareBehindSquare6 as Ns } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSquareBehindSquare6";
import { IconSquareGridCircle as Ps } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSquareGridCircle";
import { IconStackedBarChartAxis2 as Fs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStackedBarChartAxis2";
import { IconStepBack as Is } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStepBack";
import { IconStepForwards as Ls } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStepForwards";
import { IconStop as Rs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStop";
import { IconStore2 as zs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStore2";
import { IconStrikeThrough as Bs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconStrikeThrough";
import { IconSubscriptionTick2 as Vs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconSubscriptionTick2";
import { IconTable as Hs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTable";
import { IconTag as Us } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTag";
import { IconText1 as Ws } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconText1";
import { IconTextColor as Gs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTextColor";
import { IconThumbsDown as Ks } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconThumbsDown";
import { IconThumbsUp as qs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconThumbsUp";
import { IconTower as Js } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTower";
import { IconTrashCan as Ys } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTrashCan";
import { IconTrending6 as Xs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTrending6";
import { IconTrending3 as Zs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconTrending3";
import { IconUnderline as Qs } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUnderline";
import { IconUser as $s } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUser";
import { IconUserDuo as ec } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUserDuo";
import { IconUserGroup as tc } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconUserGroup";
import { IconWallet1 as nc } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconWallet1";
import { IconWorld as rc } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconWorld";
import { IconCrossMedium as ic } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconCrossMedium";
import { IconZoomIn as ac } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconZoomIn";
import { IconZoomOut as oc } from "@central-icons-react/round-outlined-radius-2-stroke-2/IconZoomOut";
import * as sc from "react";
import cc, { Children as lc, Fragment as uc, cloneElement as dc, createContext as fc, createElement as pc, forwardRef as mc, isValidElement as hc, memo as gc, useCallback as G, useContext as _c, useEffect as K, useImperativeHandle as vc, useLayoutEffect as yc, useMemo as q, useReducer as bc, useRef as J, useState as Y, useSyncExternalStore as xc } from "react";
import { P as Sc, match as X } from "ts-pattern";
import Cc from "lodash/countBy";
import { inflect as wc, pluralize as Tc } from "inflection";
import Ec from "lodash/fp/sortBy";
import { dateTimeWithFormat as Dc, fixMenuPosition as Oc, formatAddress as kc, isDisplayableCreditNoteApplicationStatus as Ac, localDateWithFormat as jc, logError as Mc, nth as Nc, percentageFromDecimal as Pc, relativeTimeToNow as Fc, toBillingScheduleStatusBadgeProps as Ic, toCreditNoteApplicationStatusBadgeProps as Lc, toCreditNoteStatusBadgeProps as Rc, toCurrencySymbol as zc, toInvoicePaymentStatusBadgeProps as Bc, toInvoiceStatusBadgeProps as Vc, toMoney as Hc, toPercentage as Uc, toQuoteStatusBadgeProps as Wc, unfixMenuPosition as Gc, useDisclosure as Kc, useId as qc, useOutsideClick as Jc, usePrevious as Yc } from "@sequencehq/utils";
import { SECONDS as Xc, add as Zc, durationsToDateAdapter as Qc, endOfMonth as $c, endOfQuarter as el, endOfYear as tl, format as nl, formatDateRange as rl, formatDuration as il, getMonth as al, isDurationLessThan as ol, isEqual as sl, isSameDay as cl, parse as ll, previousCalendarQuarter as ul, startOfDay as dl, startOfMonth as fl, startOfQuarter as pl, startOfYear as ml, stringToUTCDate as hl, sub as gl, tz as _l } from "@sequencehq/utils/dates";
import { useDayzed as vl } from "dayzed";
import { EMAIL_PATTERN as yl, isValidDate as bl } from "@sequencehq/utils/validation";
import xl from "lodash/fp/equals";
import Sl from "lodash/fp/pick";
import Cl from "lodash/fp/partition";
import wl from "react-infinite-scroll-hook";
import Tl from "lodash/difference";
import El from "lodash/flatten";
import Dl from "lodash/fp/uniq";
import Ol, { css as kl, keyframes as Al } from "styled-components";
import { AnimatePresence as jl, invariant as Ml, motion as Nl, useAnimation as Pl } from "framer-motion";
import Fl from "lodash/debounce";
import { Link as Il, useInRouterContext as Ll, useLocation as Rl, useNavigate as zl, useSearchParams as Bl } from "react-router-dom";
import { Helmet as Vl } from "react-helmet";
import { Toaster as Hl, toast as Ul } from "sonner";
import { createPortal as Wl } from "react-dom";
import { Circle as Gl, Image as Kl, Link as ql, Page as Jl, Path as Yl, Rect as Xl, Svg as Zl, Text as Ql, View as $l } from "@react-pdf/renderer";
import { dequal as eu } from "dequal";
import { Bar as tu, BarRounded as nu, Line as ru } from "@visx/shape";
import { Group as iu } from "@visx/group";
import { LinearGradient as au } from "@visx/gradient";
import { GridColumns as ou, GridRows as su } from "@visx/grid";
import { scaleBand as cu, scaleLinear as lu } from "@visx/scale";
import { AxisBottom as uu, AxisLeft as du } from "@visx/axis";
import { useTooltip as fu } from "@visx/tooltip";
import { ParentSize as pu } from "@visx/responsive";
import { AnimatedAxis as mu, AnimatedBarSeries as hu, AnimatedGrid as gu, AnimatedLineSeries as _u, Axis as vu, Grid as yu, Tooltip as bu, XYChart as xu, buildChartTheme as Su } from "@visx/xychart";
import { getStringWidth as Cu } from "@visx/text";
import { curveLinear as wu, curveMonotoneX as Tu, curveStepAfter as Eu } from "@visx/curve";
import { DndContext as Du, PointerSensor as Ou, closestCenter as ku, useSensor as Au, useSensors as ju } from "@dnd-kit/core";
import { SortableContext as Mu, horizontalListSortingStrategy as Nu, useSortable as Pu, verticalListSortingStrategy as Fu } from "@dnd-kit/sortable";
import Iu from "lodash/isEmpty";
import { CSS as Lu } from "@dnd-kit/utilities";
import { atom as Ru, useAtom as zu } from "jotai";
import { useVirtualizer as Bu } from "@tanstack/react-virtual";
import { useQuery as Vu, useSequenceInfiniteQuery as Hu } from "@sequencehq/api/utils";
import Uu from "lodash/isFunction";
import { OTPInput as Wu, OTPInputContext as Gu, REGEXP_ONLY_CHARS as Ku, REGEXP_ONLY_DIGITS as qu, REGEXP_ONLY_DIGITS_AND_CHARS as Ju } from "input-otp";
import { Global as Yu, css as Xu } from "@emotion/react";
import { EditorContent as Zu, NodeViewWrapper as Qu, ReactNodeViewRenderer as $u, ReactRenderer as ed, mergeAttributes as td, posToDOMRect as nd, useEditor as rd, useEditorState as id } from "@tiptap/react";
import { AllSelection as ad, NodeSelection as od, Plugin as sd, PluginKey as cd, Selection as ld, TextSelection as ud } from "@tiptap/pm/state";
import dd from "@tiptap/extension-document";
import fd from "@tiptap/extension-paragraph";
import pd from "@tiptap/extension-text";
import md from "@tiptap/extension-bold";
import hd from "@tiptap/extension-italic";
import gd from "@tiptap/extension-underline";
import _d from "@tiptap/extension-link";
import { Dropcursor as vd, Gapcursor as yd, Placeholder as bd, UndoRedo as xd } from "@tiptap/extensions";
import { autoUpdate as Sd, computePosition as Cd, flip as wd, hide as Td, offset as Ed, shift as Dd, size as Od } from "@floating-ui/dom";
import { Extension as kd, InputRule as Ad, Mark as jd, Node as Md, findChildren as Nd, getMarkRange as Pd, isTextSelection as Fd, mergeAttributes as Id, nodeInputRule as Ld, posToDOMRect as Rd, wrappingInputRule as zd } from "@tiptap/core";
import { baseKeymap as Bd } from "@tiptap/pm/commands";
import { DOMParser as Vd, Fragment as Hd, Slice as Ud } from "@tiptap/pm/model";
import { BubbleMenu as Wd } from "@tiptap/react/menus";
import Gd, { SuggestionPluginKey as Kd, exitSuggestion as qd, findSuggestionMatch as Jd } from "@tiptap/suggestion";
import Yd from "@tiptap/extension-mention";
import Xd from "react-use-measure";
import Zd from "dompurify";
import Qd from "linkify-html";
import $d from "lodash/escape";
import ef from "@tiptap/extension-hard-break";
import tf from "@tiptap/extension-heading";
import nf from "@tiptap/extension-strike";
import rf from "@tiptap/extension-text-align";
import { dropPoint as af, insertPoint as of } from "@tiptap/pm/transform";
import { BulletList as sf, ListItem as cf, OrderedList as lf, listHelpers as uf } from "@tiptap/extension-list";
import { Table as df, TableCell as ff, TableRow as pf } from "@tiptap/extension-table";
import { CellSelection as mf, TableMap as hf, TableView as gf, addColumn as _f, addRow as vf, cellAround as yf, columnResizing as bf, isInTable as xf, moveTableColumn as Sf, moveTableRow as Cf, removeColumn as wf, removeRow as Tf, tableEditing as Ef } from "@tiptap/pm/tables";
import { Marked as Df, Renderer as Of } from "marked";
import { wrapRangeInList as kf } from "@tiptap/pm/schema-list";
import { Decoration as Af, DecorationSet as jf } from "@tiptap/pm/view";
import Mf from "@tiptap/extension-horizontal-rule";
import Nf from "lodash/clamp";
import { GapCursor as Pf } from "@tiptap/pm/gapcursor";
//#region src/components/Avatar.tsx
var Ff = (e) => /* @__PURE__ */ U(Er, { ...e }), Z = (e, t = 16) => ({ size: n, ...r }) => /* @__PURE__ */ U(e, {
	...r,
	size: n ?? t
}), If = Z(Zi), Lf = (e) => /* @__PURE__ */ U(If, {
	...e,
	color: y
}), Rf = Z(Qi), zf = (e) => /* @__PURE__ */ U(Rf, {
	...e,
	color: y
}), Bf = Z($i), Vf = (e) => /* @__PURE__ */ U(Bf, {
	...e,
	color: Qn
}), Hf = (e) => /* @__PURE__ */ U(Bf, {
	...e,
	color: en
}), Uf = ({ height: e = 16, width: t = 16, ...n }) => /* @__PURE__ */ W("svg", {
	width: t,
	height: e,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ U("path", {
			d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ U("path", {
			d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ U("path", {
			d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ U("path", {
			d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z",
			fill: "#34A853"
		})
	]
}), Wf = ({ height: e = 16, width: t = 22, ...n }) => /* @__PURE__ */ W("svg", {
	width: t,
	height: e,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [/* @__PURE__ */ W("g", {
		clipPath: "url(#clip0_164_23823)",
		children: [
			/* @__PURE__ */ U("path", {
				d: "M1.78786 16H5.1818V7.75758L0.333313 4.12121V14.5455C0.333313 15.3503 0.985434 16 1.78786 16Z",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ U("path", {
				d: "M16.8182 16H20.2121C21.017 16 21.6667 15.3479 21.6667 14.5455V4.12121L16.8182 7.75758",
				fill: "#34A853"
			}),
			/* @__PURE__ */ U("path", {
				d: "M16.8182 1.45454V7.75757L21.6667 4.12121V2.18182C21.6667 0.383029 19.6133 -0.642425 18.1758 0.436362",
				fill: "#FBBC04"
			}),
			/* @__PURE__ */ U("path", {
				d: "M5.18182 7.75757V1.45454L11 5.81818L16.8182 1.45454V7.75757L11 12.1212",
				fill: "#EA4335"
			}),
			/* @__PURE__ */ U("path", {
				d: "M0.333313 2.18182V4.12121L5.1818 7.75757V1.45454L3.82422 0.436362C2.38422 -0.642425 0.333313 0.383029 0.333313 2.18182Z",
				fill: "#C5221F"
			})
		]
	}), /* @__PURE__ */ U("defs", { children: /* @__PURE__ */ U("clipPath", {
		id: "clip0_164_23823",
		children: /* @__PURE__ */ U("rect", {
			width: "21.3333",
			height: "16",
			fill: "white",
			transform: "translate(0.333313)"
		})
	}) })]
}), Gf = ({ height: e = 20, width: t = 20, ...n }) => /* @__PURE__ */ W("svg", {
	width: t,
	height: e,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [/* @__PURE__ */ W("g", {
		clipPath: "url(#clip0_164_23831)",
		children: [
			/* @__PURE__ */ U("path", {
				d: "M12.9886 4.24038V8.15249L14.3558 9.01333C14.3918 9.02385 14.47 9.0246 14.506 9.01333L20.39 5.04639C20.39 4.5769 19.952 4.24038 19.7049 4.24038H12.9886Z",
				fill: "#0072C6"
			}),
			/* @__PURE__ */ U("path", {
				d: "M12.9887 9.61202L14.2364 10.4691C14.4121 10.5983 14.624 10.4691 14.624 10.4691C14.4129 10.5983 20.3907 6.62761 20.3907 6.62761V13.8178C20.3907 14.6006 19.8897 14.9288 19.3263 14.9288H12.9879V9.61202H12.9887Z",
				fill: "#0072C6"
			}),
			/* @__PURE__ */ U("path", {
				d: "M6.52859 7.80845C6.10342 7.80845 5.76464 8.00826 5.5145 8.40714C5.26436 8.80601 5.13892 9.33408 5.13892 9.99136C5.13892 10.6584 5.26436 11.1857 5.5145 11.5733C5.76464 11.9617 6.09291 12.1547 6.49854 12.1547C6.91694 12.1547 7.24896 11.9662 7.49385 11.5891C7.73873 11.212 7.86192 10.6884 7.86192 10.0192C7.86192 9.32131 7.74324 8.77822 7.50511 8.38986C7.26699 8.00225 6.94173 7.80845 6.52859 7.80845Z",
				fill: "#0072C6"
			}),
			/* @__PURE__ */ U("path", {
				d: "M0.609314 2.25352V17.5587L12.2525 20V0L0.609314 2.25352ZM8.40049 12.4935C7.90847 13.141 7.26697 13.4655 6.47523 13.4655C5.70377 13.4655 5.07579 13.1516 4.58978 12.5243C4.10453 11.8963 3.86115 11.0791 3.86115 10.071C3.86115 9.00657 4.10753 8.14573 4.60105 7.48845C5.09457 6.83117 5.74809 6.50216 6.56161 6.50216C7.33007 6.50216 7.95204 6.81615 8.42603 7.44564C8.90077 8.07512 9.13814 8.90441 9.13814 9.93427C9.13889 10.9927 8.89251 11.846 8.40049 12.4935Z",
				fill: "#0072C6"
			})
		]
	}), /* @__PURE__ */ U("defs", { children: /* @__PURE__ */ U("clipPath", {
		id: "clip0_164_23831",
		children: /* @__PURE__ */ U("rect", {
			width: "19.7814",
			height: "20",
			fill: "white",
			transform: "translate(0.609314)"
		})
	}) })]
}), Kf = ({ width: e = "44px" }) => /* @__PURE__ */ U("svg", {
	width: e,
	viewBox: "0 0 44 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ U("path", {
		d: "M22.0007 0C26.4126 0.000150118 29.9898 3.55538 29.9898 7.94033C29.9898 7.95726 29.9872 7.97416 29.987 7.99106C29.9872 8.00885 29.9898 8.02683 29.9898 8.04463V10.2479L31.9099 9.14694C31.9447 9.12624 31.9794 9.10517 32.0147 9.08492C35.8355 6.89258 40.7224 8.19286 42.9285 11.9901C45.1346 15.7877 43.8248 20.6447 40.0038 22.8371C39.989 22.8456 39.9733 22.8526 39.9585 22.8611C39.9384 22.8728 39.9192 22.886 39.8989 22.8976L37.976 24L39.8976 25.1023C39.933 25.1227 39.9674 25.1449 40.0024 25.1657L40.3538 25.3786C43.9024 27.6602 45.0642 32.3323 42.9272 36.0112C40.7212 39.8085 35.8355 41.1099 32.0147 38.9179C31.9851 38.9009 31.9562 38.8817 31.9269 38.8643C31.9209 38.8609 31.9144 38.8578 31.9084 38.8544L29.9898 37.7522V39.9567L29.9885 40.0075C29.9885 40.0251 29.9898 40.0433 29.9898 40.0611C29.9895 44.4457 26.4123 47.9999 22.0007 48C17.5889 48 14.012 44.4458 14.0116 40.0611V37.7522L12.0916 38.8544L12.0788 38.86C12.0475 38.8786 12.017 38.8997 11.9853 38.9179C8.16449 41.1099 3.27888 39.8085 1.07292 36.0112C-1.13319 32.2137 0.176665 27.3581 3.99761 25.1657C4.03269 25.1449 4.06697 25.1227 4.10248 25.1023L6.0211 24L4.10248 22.899L4.10106 22.8976L4.0132 22.8469C4.01044 22.8453 4.00745 22.8429 4.0047 22.8413C4.00197 22.8397 3.99894 22.8386 3.99621 22.8371C0.175243 20.6447 -1.1346 15.7877 1.07149 11.9901C3.27762 8.19284 8.16449 6.89256 11.9853 9.08492C12.0116 9.1 12.0372 9.11611 12.0632 9.13144C12.0722 9.13656 12.0812 9.14179 12.0902 9.14694L14.0116 10.2493V7.94033C14.0116 3.55528 17.5888 0 22.0007 0ZM22.0007 34.1096C18.7111 34.1096 16.041 36.7452 16.0124 40.0075C16.0404 43.2703 18.7109 45.9067 22.0007 45.9067C25.2905 45.9066 27.9582 43.2701 27.9862 40.0075C27.9576 36.7454 25.2901 34.1098 22.0007 34.1096ZM13.177 29.0661C11.5304 26.2316 7.8922 25.2526 5.03345 26.8671C2.22382 28.5295 1.27089 32.1311 2.91077 34.9541C4.56337 37.7985 8.22221 38.7738 11.0855 37.1347C13.8716 35.4645 14.8108 31.8788 13.177 29.0661ZM38.9666 26.8671C36.1078 25.2526 32.4697 26.2316 30.8231 29.0661C29.1892 31.8788 30.1285 35.4645 32.9146 37.1347C35.7779 38.774 39.4366 37.7985 41.0893 34.9541C42.7293 32.1311 41.7764 28.5293 38.9666 26.8671ZM24.0001 32.0193L27.989 34.3084V29.7314L24.0001 32.0193ZM16.0124 34.307L19.9985 32.0207L16.0124 29.7329V34.307ZM16.0124 20.5634V27.4366L21.9993 30.8719L27.989 27.4352V20.5647L21.9993 17.1282L16.0124 20.5634ZM10.0227 24L14.0116 26.2878V21.7122L10.0227 24ZM29.9898 26.2878L33.9759 24L29.9898 21.7122V26.2878ZM11.0572 10.8498C8.19793 9.2327 4.55797 10.2119 2.91077 13.0473C1.27181 15.8686 2.2216 19.468 5.02778 21.1314C7.88727 22.7501 11.5294 21.7727 13.177 18.9367C14.8165 16.1146 13.8649 12.5127 11.0572 10.8498ZM41.0906 13.0473C39.4462 10.2165 35.8141 9.23538 32.9571 10.8413C30.1382 12.5005 29.1808 16.1098 30.8231 18.9367C32.4704 21.7724 36.1115 22.7492 38.9708 21.1314C41.7778 19.4684 42.7295 15.8691 41.0906 13.0473ZM16.0124 18.2685L19.9985 15.9808L16.0124 13.6915V18.2685ZM24.0001 15.9808L27.989 18.2685V13.6915L24.0001 15.9808ZM22.0007 2.09326C18.7113 2.09326 16.0427 4.72901 16.0139 7.99106C16.0416 11.2541 18.7107 13.8917 22.0007 13.8917C25.2906 13.8916 27.9599 11.254 27.9876 7.99106C27.9588 4.72909 25.2899 2.09342 22.0007 2.09326Z",
		fill: "#505050"
	})
}), qf = Z(ea), Jf = Z(ta), Yf = Z(na), Xf = Z(ra), Zf = Z(ia), Qf = Z(aa), $f = Z(oa), ep = Z(sa), tp = Z(ca), np = Z(la), rp = Z(ua), ip = Z(da), ap = Z(fa), op = Z(pa), sp = Z(ma), cp = Z(ha), lp = Z(ga), up = Z(_a), dp = Z(va), fp = Z(ya), pp = Z(ba), mp = Z(xa), hp = Z(Sa), gp = Z(Ca), _p = Z(wa), vp = Z(Ta), yp = Z(Ea), bp = Z(Da), xp = Z(Oa), Sp = Z(ka), Cp = Z(Aa), wp = Z(ja), Tp = Z(Ma), Ep = Z(Na), Dp = Z(Pa), Op = Z(Fa), kp = Z(Ia), Ap = Z(La), jp = Z(Ra), Mp = Z(za), Np = Z(Ba), Pp = Z(Va), Fp = Z(Ha), Ip = Z(Ua), Lp = Z(Wa), Rp = Z(Ga), zp = Z(Ka), Bp = Z(qa), Vp = Z(Ja), Hp = Z(Ya), Up = Z(Ya, 20), Wp = Z(Xa), Gp = Z(Za), Kp = Z(Qa), qp = Z($a), Jp = Z($a, 20), Yp = Z(eo), Xp = Z(eo, 20), Zp = Z(to), Qp = Z(no), $p = Z(ro), em = Z(io), tm = Z(ao), nm = Z(oo), rm = Z(so), im = Z(co), am = Z(lo), om = Z(uo), sm = Z(fo), cm = Z(po), lm = Z(mo), um = Z(ho), dm = Z(go), fm = Z(_o), pm = Z(vo), mm = Z(yo), hm = Z(bo), gm = Z(xo), _m = Z(So), vm = Z(Co), ym = Z(wo), bm = Z(To), xm = Z(Eo), Sm = Z(Do), Cm = Z(Oo), wm = Z(ko), Tm = Z(Ao), Em = Z(jo), Dm = Z(Mo), Om = Z(No), km = Z(Po), Am = Z(Fo), jm = Z(Io), Mm = Z(Lo), Nm = Z(Ro), Pm = Z(zo), Fm = Z(Bo), Im = Z(Vo), Lm = Z(Ho), Rm = Z(Uo), zm = Z(Wo), Bm = Z(Go), Vm = Z(Ko), Hm = Z(qo), Um = Z(Jo), Wm = Z(Yo), Gm = Z(Xo), Km = Z(Zo), qm = Z(Qo), Jm = Z($o), Ym = Z(es), Xm = Z(ts), Zm = Z(ns), Qm = Z(rs), $m = Z(is), eh = Z(as), th = Z(os), nh = Z(ss), rh = Z(cs), ih = Z(ls), ah = Z(us), oh = Z(ds), sh = Z(fs), ch = Z(ps), lh = Z(ms), uh = Z(hs), dh = Z(gs), fh = Z(_s), ph = Z(vs), mh = Z(ys), hh = Z(bs), gh = Z(xs), _h = Z(Ss), vh = Z(Cs), yh = Z(ws), bh = Z(Ts), xh = Z(Es), Sh = Z(Ds), Ch = Z(Os), wh = Z(ks), Th = Z(As), Eh = Z(js), Dh = Z(Ms), Oh = Z(Ns), kh = Z(Ps), Ah = Z(Fs), jh = Z(Is), Mh = Z(Ls), Nh = Z(Rs), Ph = Z(zs), Fh = Z(Bs), Ih = Z(Vs), Lh = Z(Hs), Rh = Z(Us), zh = Z(Ws), Bh = Z(Gs), Vh = Z(Ks), Hh = Z(qs), Uh = Z(Js), Wh = Z(Ys), Gh = Z(Xs), Kh = Z(Zs), qh = Z(Qs), Jh = Z($s), Yh = Z(ec), Xh = Z(tc), Zh = Z(nc), Qh = Z(rc), $h = Z(ic), eg = Z(ic, 20), tg = Z(ac), ng = Z(oc), rg = /* @__PURE__ */ an({
	Icon3dBox: () => qf,
	Icon3dPackage2: () => Jf,
	IconAgent: () => Yf,
	IconAlignmentCenter: () => Xf,
	IconAlignmentLeft: () => Zf,
	IconAlignmentRight: () => Qf,
	IconArchive: () => $f,
	IconArmchair: () => ep,
	IconArrowBoxLeft: () => tp,
	IconArrowCornerDownLeft: () => np,
	IconArrowCornerDownRight: () => rp,
	IconArrowDown: () => ip,
	IconArrowInbox: () => ap,
	IconArrowLeft: () => op,
	IconArrowOutOfBox: () => sp,
	IconArrowRight: () => cp,
	IconArrowRightLeft: () => lp,
	IconArrowRotateRightLeft: () => up,
	IconArrowTopBottom: () => dp,
	IconArrowUp: () => fp,
	IconArrowUpRight: () => pp,
	IconArrowsRepeat: () => mp,
	IconAt: () => hp,
	IconBag: () => gp,
	IconBank: () => _p,
	IconBanknote: () => vp,
	IconBarChart: () => yp,
	IconBarChartPresentation: () => bp,
	IconBarsThree: () => xp,
	IconBarsThreeBottomLeft: () => Sp,
	IconBell: () => Cp,
	IconBold: () => wp,
	IconBookOpen: () => Tp,
	IconBookmark: () => Ep,
	IconBooks: () => Dp,
	IconBrokenChainLink: () => Op,
	IconBubbleDots: () => kp,
	IconBug: () => Ap,
	IconBuildings: () => jp,
	IconCalculator: () => Mp,
	IconCalendar: () => Np,
	IconCalendarDays: () => Pp,
	IconCalendarRemove: () => Fp,
	IconChainLink: () => Ip,
	IconChairModern: () => Lp,
	IconCheckCircle: () => Rp,
	IconCheckmark: () => zp,
	IconChevronDoubleLeft: () => Bp,
	IconChevronDoubleRight: () => Vp,
	IconChevronDown: () => Hp,
	IconChevronDownLarge: () => Up,
	IconChevronDownSmall: () => Wp,
	IconChevronGrabberVertical: () => Gp,
	IconChevronLeft: () => Kp,
	IconChevronRight: () => qp,
	IconChevronRightLarge: () => Jp,
	IconChevronTop: () => Yp,
	IconChevronTopLarge: () => Xp,
	IconChip: () => Zp,
	IconCircle: () => Bf,
	IconCircleBanSign: () => Qp,
	IconCircleDashed: () => $p,
	IconCircleInfo: () => em,
	IconCircleMinus: () => tm,
	IconCirclePlus: () => nm,
	IconCircleQuestionmark: () => rm,
	IconCircleX: () => im,
	IconClipboard: () => am,
	IconClock: () => om,
	IconCode: () => sm,
	IconCoinStack: () => cm,
	IconColumns: () => lm,
	IconConsole: () => um,
	IconCreditCard: () => dm,
	IconDragHandle: () => fm,
	IconEdit: () => pm,
	IconEllipsisHorizontal: () => mm,
	IconEllipsisVertical: () => hm,
	IconEmail: () => gm,
	IconExclamationCircle: () => _m,
	IconExclamationTriangle: () => vm,
	IconExpand: () => ym,
	IconEyeOpen: () => bm,
	IconEyeSlash: () => xm,
	IconFileBend: () => Sm,
	IconFilePdf: () => Cm,
	IconFileText: () => wm,
	IconFilter: () => Tm,
	IconFlag: () => Em,
	IconFocusExposure: () => Dm,
	IconGoogle: () => Uf,
	IconGoogleMail: () => Wf,
	IconGraduateCap: () => Om,
	IconH1: () => km,
	IconH2: () => Am,
	IconH3: () => jm,
	IconHashtag: () => Mm,
	IconHome: () => Nm,
	IconImages: () => Pm,
	IconItalic: () => Fm,
	IconKey: () => Im,
	IconLab: () => Lm,
	IconLayers: () => Rm,
	IconLayoutGrid: () => zm,
	IconLayoutSidebar: () => Bm,
	IconLayoutTopbar: () => Vm,
	IconLightningBolt: () => Hm,
	IconLightningBoltOff: () => Um,
	IconListBullets: () => Wm,
	IconLock: () => Gm,
	IconMagnifyingGlass: () => Km,
	IconMaintenance: () => qm,
	IconMapPin: () => Jm,
	IconMathScientific: () => Ym,
	IconMinimize: () => Xm,
	IconMinus: () => Zm,
	IconNewspaper: () => Qm,
	IconNumberedList: () => $m,
	IconOutlook: () => Gf,
	IconPageAdd: () => eh,
	IconPageText: () => th,
	IconPaid: () => Lf,
	IconPaperPlaneTopRight: () => rh,
	IconPaperclip: () => nh,
	IconPartiallyPaid: () => zf,
	IconPencil: () => ih,
	IconPencilWave: () => ah,
	IconPeopleCircle: () => oh,
	IconPeopleIdCard: () => sh,
	IconPieChart: () => ch,
	IconPlay: () => lh,
	IconPlayCircle: () => uh,
	IconPlus: () => dh,
	IconProgress100: () => If,
	IconProgress50: () => Rf,
	IconProjects: () => fh,
	IconReceiptBill: () => ph,
	IconReceiptCredit: () => mh,
	IconReceiptTax: () => hh,
	IconRescueRing: () => gh,
	IconRocket: () => _h,
	IconScale: () => vh,
	IconSequence: () => Kf,
	IconServer: () => yh,
	IconSettingsGear: () => bh,
	IconSettingsSliderHorizontal: () => xh,
	IconShieldCheck: () => Sh,
	IconSignal: () => Ch,
	IconSignature: () => wh,
	IconSparkles: () => Th,
	IconSpeedHigh: () => Eh,
	IconSquareArrowTopRight: () => Dh,
	IconSquareBehindSquare: () => Oh,
	IconSquareGridCircle: () => kh,
	IconStackedBarChart: () => Ah,
	IconStepBack: () => jh,
	IconStepForwards: () => Mh,
	IconStop: () => Nh,
	IconStore: () => Ph,
	IconStrikeThrough: () => Fh,
	IconSubscriptionTick: () => Ih,
	IconTable: () => Lh,
	IconTag: () => Rh,
	IconText: () => zh,
	IconTextColor: () => Bh,
	IconThumbsDown: () => Vh,
	IconThumbsUp: () => Hh,
	IconTower: () => Uh,
	IconTrashCan: () => Wh,
	IconTrendingDown: () => Gh,
	IconTrendingUp: () => Kh,
	IconUncollectible: () => Vf,
	IconUnderline: () => qh,
	IconUnpaid: () => Hf,
	IconUser: () => Jh,
	IconUserDuo: () => Yh,
	IconUserGroup: () => Xh,
	IconWallet: () => Zh,
	IconWorld: () => Qh,
	IconXMark: () => $h,
	IconXMarkLarge: () => eg,
	IconZoomIn: () => tg,
	IconZoomOut: () => ng
}), ig = ({ children: e, sentiment: t = "neutral", size: n = "md", onDelete: r, containerStyle: i, icon: a, textTransform: o, "data-testid": s, truncate: c = !1 }) => {
	let { color: l, backgroundColor: u, border: d, ...f } = ag[t], p = og[n](!e);
	return /* @__PURE__ */ W(B, {
		color: l,
		backgroundColor: u,
		...d ? { border: d } : {},
		...f.textStyle,
		...p,
		alignItems: "center",
		gap: "4px",
		flexShrink: c ? void 0 : 0,
		style: { overflow: "hidden" },
		sx: i,
		borderRadius: "6px",
		height: "24px",
		textTransform: o,
		display: "inline-flex",
		placeItems: "center",
		"data-testid": s,
		children: [
			a && /* @__PURE__ */ U(Xr, {
				as: a,
				boxSize: "16px"
			}),
			c ? /* @__PURE__ */ U(R, {
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				children: e
			}) : e,
			r ? /* @__PURE__ */ U(Zr, {
				"aria-label": `Delete ${typeof e == "string" ? e : ""}`,
				icon: /* @__PURE__ */ U($h, {}),
				onClick: r,
				variant: "clear",
				minWidth: "16px",
				height: "16px"
			}) : null
		]
	});
}, ag = {
	success: {
		backgroundColor: $n,
		color: zt,
		textStyle: Nn
	},
	neutral: {
		backgroundColor: Fn,
		color: F,
		textStyle: Nn
	},
	neutralRegular: {
		backgroundColor: Fn,
		color: F,
		textStyle: tr
	},
	error: {
		backgroundColor: Be,
		color: At,
		textStyle: Nn
	},
	info: {
		backgroundColor: Xe,
		color: Pe,
		textStyle: Nn
	},
	highlight: {
		backgroundColor: yt,
		color: wn,
		textStyle: Nn
	},
	warning: {
		color: Lt,
		backgroundColor: Zn,
		textStyle: Nn
	},
	monospaced: {
		color: Rn,
		backgroundColor: u,
		textStyle: ft
	},
	upcoming: {
		color: Rn,
		backgroundColor: u,
		textStyle: Nn
	},
	infoStrong: {
		color: I,
		backgroundColor: y,
		textStyle: j
	},
	draft: {
		color: F,
		backgroundColor: rr,
		border: `1px dashed ${M}`,
		textStyle: Nn
	}
}, og = {
	md: (e = !1) => ({
		py: "4px",
		px: e ? "4px" : "6px",
		width: "max-content",
		height: "min-content",
		borderRadius: "4px"
	}),
	sm: (e = !1) => ({
		py: "2px",
		px: e ? "2px" : "4px",
		width: "max-content",
		height: "min-content",
		borderRadius: "4px"
	})
}, Q = Yi((e, t) => {
	let { children: n, variant: r = "primary", disabled: i, active: a, size: o, width: s, fullWidth: c, keyboardShortcut: l, onClick: u, hideKeyboardShortcut: d, leadingIcon: f, trailingIcon: p, submitting: m, submittingText: h, hover: g, focus: _, activeStyle: v, ...y } = e;
	lg(l?.map((e) => e.toLowerCase()), (e) => {
		i || u?.(e);
	});
	let b = {
		type: "button",
		isDisabled: i || m,
		isActive: a,
		width: s ?? (c ? "100%" : o),
		height: o,
		variant: `component-library-${r === "destructive" ? "warning" : r}`,
		ref: t,
		onClick: u,
		fontSize: "13px",
		borderRadius: "6px",
		...g ? { _hover: g } : {},
		..._ ? { _focus: _ } : {},
		...v ? { _active: v } : {},
		...y
	};
	if (cg(e)) return /* @__PURE__ */ U(Zr, {
		...b,
		"aria-label": e["aria-label"],
		width: o ?? {
			base: "36px",
			md: "32px"
		},
		height: o ?? {
			base: "36px",
			md: "32px"
		}
	});
	let x = m ? /* @__PURE__ */ W(B, {
		gap: "8px",
		alignItems: "center",
		children: [/* @__PURE__ */ U(ki, {
			height: "16px",
			width: "16px",
			color: "currentColor",
			"data-testid": y["data-testid"] ? `${y["data-testid"]}.spinner` : void 0
		}), h ?? n]
	}) : n;
	return /* @__PURE__ */ W(Or, {
		...b,
		leftIcon: m ? void 0 : f,
		rightIcon: m ? void 0 : p,
		children: [x, !!l && !d && /* @__PURE__ */ U(ug, {
			variant: r,
			keys: l?.map((e) => e.toLowerCase()) || []
		})]
	});
}), sg = navigator.userAgent.indexOf("Mac") > -1, cg = (e) => "icon" in e, lg = (e, t) => {
	K(() => {
		if (!e || !t) return;
		let n = (n) => {
			let r = [];
			n.altKey && r.push("alt"), n.shiftKey && r.push("shift"), n.metaKey && sg && r.push("mod"), n.ctrlKey && !sg && r.push("mod"), n.key !== "Meta" && n.key !== "Control" && n.key !== "Alt" && n.key !== "Shift" && r.push(n.key.toLowerCase()), e.length === r.length && e.every((e) => r.includes(e.toLowerCase())) && (n.preventDefault(), t(n));
		};
		return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
	}, [e, t]);
}, ug = ({ keys: e, variant: t }) => {
	let n = (e) => {
		switch (e.toLowerCase()) {
			case "mod": return sg ? "⌘" : "^";
			case "meta": return "⌘";
			case "ctrl": return "⌃";
			case "enter": return "↵";
			case "shift": return "⇧";
			case "alt": return "⌥";
			case "escape": return "⎋";
			case "arrowleft": return "←";
			case "arrowright": return "→";
			case "arrowup": return "↑";
			case "arrowdown": return "↓";
			default: return e.toUpperCase();
		}
	}, r = X(t).with("secondary", "ghost", () => ({
		backgroundColor: Fn,
		color: F
	})).otherwise(() => ({
		backgroundColor: "rgba(255, 255, 255, 0.2)",
		color: "currentColor"
	}));
	return /* @__PURE__ */ U(Yr, {
		spacing: "4px",
		ml: 2,
		children: e.map((e, t) => /* @__PURE__ */ U("div", {
			style: {
				width: "16px",
				height: "16px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				fontSize: "13px",
				borderRadius: "4px",
				...r
			},
			children: n(e)
		}, t))
	});
}, dg = (e) => /* @__PURE__ */ U(B, {
	...e,
	borderRadius: "6px",
	boxShadow: Ht,
	sx: {
		"& > button": {
			borderRadius: 0,
			boxShadow: "none !important"
		},
		"& > button:first-of-type": { borderRadius: "6px 0 0 6px" },
		"& > button:last-of-type": { borderRadius: "0 6px 6px 0" },
		"& > button:only-of-type": { borderRadius: "6px" },
		"& > button:not(:first-of-type)": { marginLeft: "-1px" },
		"& > button:hover, & > button:focus, & > button:active": { zIndex: 1 }
	}
}), fg = ({ onClick: e, ...t }) => /* @__PURE__ */ U(Or, {
	onClick: e,
	variant: "unstyled",
	minWidth: "initial",
	height: "initial",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	borderRadius: "4px",
	color: k,
	_hover: {
		color: L,
		background: P
	},
	...t,
	children: /* @__PURE__ */ U($h, { color: "inherit" })
}), pg = "min(414px, calc(100vw - 32px))", mg = "220px", hg = fc(void 0), gg = () => _c(hg), _g = {
	default: {
		isCentered: !0,
		motionPreset: "scale"
	},
	drawer: {
		isCentered: !1,
		motionPreset: "slideInRight"
	},
	dialog: {
		isCentered: !0,
		motionPreset: "scale"
	}
}, vg = ({ children: e, width: t, height: n, isOpen: r, onClose: i, onKeyDown: a, variant: o = "default", hideOverlay: s = !1, "data-testid": c, dialogPosition: l, userClosable: u = !0, allowOutsideScroll: d = !1, motionPreset: f, overlayBackground: p, overlayBlur: m = !1, boxShadow: h, top: g }) => {
	let _ = s ? uc : di, v = o === "dialog" && l === "top", y = g ?? (v ? "128px" : void 0), b = {
		..._g[o],
		isCentered: y === void 0 && _g[o].isCentered
	}, x = f ?? _g[o].motionPreset, S = x !== void 0 && x !== "none", [C, w] = Y(!1);
	K(() => {
		r || w(!1);
	}, [r]);
	let T = S ? () => w(!0) : i;
	return !r && !S ? null : /* @__PURE__ */ U(li, {
		isOpen: r && !C,
		onClose: T,
		onCloseComplete: C ? i : void 0,
		onEsc: u ? T : void 0,
		closeOnEsc: u,
		closeOnOverlayClick: u,
		blockScrollOnMount: !d,
		variant: d ? "outsideScroll" : void 0,
		...b,
		motionPreset: x,
		children: /* @__PURE__ */ U(_, {
			background: p ?? "rgba(0,0,0,0.2)",
			backdropFilter: m ? "blur(4px)" : void 0,
			"data-testid": `${c}.overlay`,
			children: /* @__PURE__ */ U(yg, {
				width: t,
				height: n,
				variant: o,
				onKeyDown: a,
				"data-testid": c,
				boxShadow: h,
				top: y,
				maxHeight: v ? "calc(100dvh - 320px)" : void 0,
				children: /* @__PURE__ */ U(hg.Provider, {
					value: T,
					children: e
				})
			})
		})
	});
}, yg = ({ children: e, onKeyDown: t, variant: n, width: r, height: i, padding: a, "data-testid": o, top: s, maxHeight: c = "90vh", boxShadow: l }) => {
	let u = {
		minW: r ?? (n === "dialog" ? "min(414px, calc(100vw - 32px))" : "min(480px, calc(100vw - 32px))"),
		borderRadius: 8,
		overflowY: "auto",
		onKeyDown: t
	};
	return n === "drawer" ? /* @__PURE__ */ U(ui, {
		position: "absolute",
		right: 0,
		top: 0,
		bottom: 0,
		margin: 2,
		"data-testid": o,
		padding: a,
		...u,
		children: e
	}) : /* @__PURE__ */ U(ui, {
		height: i,
		maxHeight: c,
		"data-testid": o,
		...u,
		maxWidth: n === "dialog" ? pg : void 0,
		top: s,
		boxShadow: l,
		children: e
	});
}, bg = ({ children: e, showCloseButton: t = !1, withBorder: n = !0, onClose: r, minHeight: i, padding: a, "data-testid": o }) => {
	let s = _c(hg), c = r ?? s;
	return /* @__PURE__ */ W(Kr, {
		px: 4,
		py: 3,
		gridTemplateColumns: "1fr auto",
		padding: a,
		borderBottom: n ? `1px solid ${P}` : void 0,
		minHeight: i,
		"data-testid": o,
		alignItems: "center",
		children: [/* @__PURE__ */ U(R, {
			paddingX: 1,
			...ar,
			children: e
		}), t && /* @__PURE__ */ U("button", {
			type: "button",
			onClick: c,
			"data-testid": `${o}.close`,
			children: /* @__PURE__ */ U(B, {
				justifyContent: "center",
				alignItems: "center",
				height: "24px",
				width: "24px",
				color: "#64748b",
				_hover: { color: "#334155" },
				children: /* @__PURE__ */ U(eg, {})
			})
		})]
	});
}, xg = ({ children: e, padding: t = 5, minHeight: n = mg, maxHeight: r }) => /* @__PURE__ */ U(R, {
	padding: t,
	color: L,
	...N,
	minHeight: n,
	maxHeight: r,
	overflow: "auto",
	flex: 1,
	children: e
}), Sg = ({ children: e, withBorder: t = !0, justifyContent: n = "flex-end", padding: r }) => /* @__PURE__ */ U(B, {
	paddingX: 3,
	paddingY: 2,
	padding: r,
	borderTop: t ? `1px solid ${P}` : void 0,
	gap: 2,
	width: "100%",
	justifyContent: n,
	children: e
}), Cg = ({ height: e = mg }) => /* @__PURE__ */ U(B, {
	height: e,
	alignItems: "center",
	justifyContent: "center",
	children: /* @__PURE__ */ U(ki, {
		height: "24px",
		width: "24px",
		color: k
	})
}), wg = ({ variant: e = "primary", type: t = "submit", text: n, submitting: r, submittingText: i, "data-testid": a, ...o }) => /* @__PURE__ */ U(Q, {
	"data-testid": a ? `${a}.submit` : "modal.footer.submit",
	variant: e,
	type: t,
	submitting: r,
	submittingText: i,
	...o,
	children: n
}), Tg = ({ children: e = "Cancel", "data-testid": t = "modal.footer.cancel", fullWidth: n, disabled: r }) => /* @__PURE__ */ U(Q, {
	"data-testid": t,
	variant: "secondary",
	onClick: _c(hg),
	fullWidth: n,
	disabled: r,
	children: e
}), Eg = Object.assign(vg, {
	Header: bg,
	Content: xg,
	Footer: Sg,
	LoadingSpinner: Cg,
	SubmitButton: wg,
	CancelButton: Tg
}), Dg = () => {
	let [e, t] = Y(!1);
	return {
		isModalOpen: e,
		openModal: () => t(!0),
		closeModal: () => t(!1)
	};
}, Og = ({ trigger: e, ...t }) => {
	let { isModalOpen: n, openModal: r, closeModal: i } = Dg();
	return e ? /* @__PURE__ */ W(H, { children: [kg({
		trigger: e,
		openModal: r,
		isModalOpen: n
	}), /* @__PURE__ */ U(Ag, {
		...t,
		isOpen: n,
		onClose: () => {
			t.onClose?.(), i();
		}
	})] }) : null;
}, kg = ({ trigger: e, openModal: t, isModalOpen: n }) => {
	let r = (n) => {
		n.stopPropagation(), e.props.onClick && e.props.onClick(n), t();
	};
	if (e.type === m_) {
		let t = e.props.children;
		if (cc.isValidElement(t) && t.type === Q) {
			let i = cc.cloneElement(t, { onClick: r });
			return cc.cloneElement(e, {
				key: n ? "modal-open" : "modal-closed",
				children: i
			});
		}
	}
	return cc.cloneElement(e, { onClick: r });
}, Ag = ({ isOpen: e, title: t, onSubmit: n, onClose: r, onCancel: i, children: a, cancelButtonText: o = "Cancel", submitButtonText: s = "Save", submitButtonTrailingIcon: c, submittingButtonText: l = "Saving", submitDisabled: u = !1, variant: d, contentProps: f = {}, hideOverlay: p = !1, "data-testid": m, isLoading: h = !1, isDestructive: g = !1, minHeight: _, width: v, showFooter: y = !0, showCloseButton: b, showSubmitButton: x = !0, showCancelButton: S = !0, disableSubmitOnEnter: C = !1, dialogPosition: w = "center", submitting: T = !1, closeOnUpdate: E = !0, allowOutsideScroll: D = !1 }) => {
	let [ee, te] = Y(!1), O = T || ee, ne = u || O, re = y && (x || S), ie = async () => {
		if (!ne) {
			te(!0);
			try {
				await n?.() && E && r();
			} catch (e) {
				console.error(e);
			} finally {
				te(!1);
			}
		}
	};
	return /* @__PURE__ */ U(Eg, {
		isOpen: e,
		variant: d,
		onKeyDown: (e) => {
			X(e.key).with("Enter", () => {
				e.stopPropagation(), !(ne || C) && ie();
			}).with("Escape", () => {
				O || r();
			});
		},
		hideOverlay: p,
		onClose: r,
		"data-testid": m,
		width: v,
		dialogPosition: w,
		allowOutsideScroll: D,
		children: /* @__PURE__ */ W(Kr, {
			gridTemplateAreas: "\n        \"header\"\n        \"content\"\n        \"footer\"\n        ",
			gridTemplateRows: "auto 1fr auto",
			overflow: "hidden",
			height: "100%",
			width: "100%",
			children: [
				t !== void 0 && /* @__PURE__ */ U(Jr, {
					gridArea: "header",
					children: /* @__PURE__ */ U(Eg.Header, {
						showCloseButton: b ?? d !== "dialog",
						withBorder: d !== "dialog",
						padding: d === "dialog" ? "16px 16px 8px 12px" : void 0,
						children: t
					})
				}),
				/* @__PURE__ */ U(Jr, {
					gridArea: "content",
					overflow: "auto",
					children: h ? /* @__PURE__ */ U(Eg.LoadingSpinner, { height: d === "dialog" ? "100px" : void 0 }) : /* @__PURE__ */ U(Eg.Content, {
						...f,
						padding: d === "dialog" ? `0px 16px ${re ? "16px" : "0px"}` : void 0,
						minHeight: d === "dialog" ? "auto" : _,
						children: a
					})
				}),
				re && /* @__PURE__ */ U(Jr, {
					gridArea: "footer",
					children: /* @__PURE__ */ W(Eg.Footer, {
						withBorder: d !== "dialog",
						padding: d === "dialog" ? "0 16px 16px" : void 0,
						children: [
							d !== "dialog" && /* @__PURE__ */ U(R, { flex: 1 }),
							S && (i ? /* @__PURE__ */ U(Q, {
								"data-testid": m ? `${m}.cancel` : "modal.footer.cancel",
								variant: "secondary",
								onClick: i,
								fullWidth: d === "dialog",
								children: o
							}) : /* @__PURE__ */ U(Tg, {
								"data-testid": m ? `${m}.cancel` : void 0,
								fullWidth: d === "dialog",
								children: o
							})),
							x && /* @__PURE__ */ U(Q, {
								"data-testid": m ? `${m}.submit` : "modal.footer.submit",
								variant: g ? "destructive" : "primary",
								onClick: ie,
								disabled: ne,
								fullWidth: d === "dialog",
								trailingIcon: O ? void 0 : c,
								children: /* @__PURE__ */ W(B, {
									gap: "8px",
									alignItems: "center",
									children: [O && /* @__PURE__ */ U(ki, {
										height: "16px",
										width: "16px",
										color: "#475569"
									}), O ? l : s]
								})
							})
						]
					})
				})
			]
		})
	});
}, jg = (e) => "trigger" in e ? /* @__PURE__ */ U(Og, { ...e }) : /* @__PURE__ */ U(Ag, { ...e }), Mg = ({ isOpen: e, title: t, submitTitle: n = "Leave", cancelTitle: r = "Keep editing", onLeave: i, onStay: a, children: o, "data-testid": s = "common.blocker" }) => /* @__PURE__ */ U(jg, {
	variant: "dialog",
	isOpen: e,
	title: t,
	onClose: a,
	onSubmit: () => (i(), !1),
	submitButtonText: n,
	cancelButtonText: r,
	isDestructive: !0,
	disableSubmitOnEnter: !0,
	"data-testid": s,
	children: o
}), Ng = (e) => {
	let t = document.activeElement, n = document.querySelectorAll("button.date-button");
	n.forEach((r, i) => {
		let a = i + e;
		r == t && (a <= n.length - 1 && a >= 0 ? n[a].focus() : n[0].focus());
	});
}, Pg = ({ selected: e, today: t, dateProps: n, inRange: r, selectableDate: i, label: a, position: o, initialRef: s, hasInitialFocus: c, focusedInput: l, "data-testid": u }) => {
	let d = Fg({
		today: t,
		selected: e,
		selectable: i,
		inRange: r,
		position: o,
		focusedInput: l
	});
	return /* @__PURE__ */ U(Or, {
		...n,
		...d,
		"data-testid": u,
		className: "date-button",
		ref: c ? s : null,
		tabIndex: -1,
		isDisabled: !i,
		_focus: {
			zIndex: 1,
			boxShadow: `0 0 0 2px ${C}`
		},
		onKeyDown: (e) => {
			X(e.key).with("ArrowUp", () => {
				e.preventDefault(), Ng(-7);
			}).with("ArrowRight", () => (e.preventDefault(), Ng(1))).with("ArrowLeft", () => (e.preventDefault(), Ng(-1))).with("ArrowDown", () => (e.preventDefault(), Ng(7))).otherwise(() => {});
		},
		children: a
	});
}, Fg = ({ today: e, selected: t, selectable: n, inRange: r, position: i, focusedInput: a }) => {
	let o = {};
	return o.border = "1px solid", o.bg = "white", o.borderColor = "white", o.fontWeight = "400", o.fontSize = "14px", o.lineHeight = "16px", o.width = "40px", o.height = "40px", o.borderRadius = "0", o._hover = {}, e && (o.borderRadius = "8px"), n && (t ? (o.bg = ot, o.borderColor = ot, o.color = "white", i === "start" ? (o.borderRadius = "8px 0 0 8px", a === "start" && (o.bg = l)) : i === "end" ? (o.borderRadius = "0 8px 8px 0", a === "end" && (o.bg = l)) : o.borderRadius = "8px") : r ? (o.bg = "gray.20", o.borderColor = "gray.20") : (o.color = "gray.100", o._hover = {
		bg: "gray.20",
		borderColor: "gray.20"
	})), e && (o.borderColor = ot), o;
}, Ig = ({ onChange: e, value: t }) => /* @__PURE__ */ W(B, {
	flexDirection: "column",
	width: "max-content",
	children: [
		/* @__PURE__ */ U(Wr, {
			textAlign: "center",
			children: "Choose a day of the month"
		}),
		/* @__PURE__ */ U(R, { height: 4 }),
		/* @__PURE__ */ U(Ti, {
			columns: 7,
			spacing: "1px",
			textAlign: "center",
			children: Array.from(Array(31), (n, r) => /* @__PURE__ */ U(Pg, {
				selected: t === r + 1,
				label: r + 1,
				today: !1,
				selectableDate: !0,
				dateProps: { onClick: (t) => {
					t.preventDefault(), e(r + 1);
				} }
			}, r))
		})
	]
}), Lg = Yi(({ onChange: e, autoHighlightText: t = !1, trailingIcon: n, ...r }, i) => {
	let a = J(null);
	return K(() => {
		!a.current || !t || a.current.select();
	}, []), /* @__PURE__ */ W(B, {
		position: "relative",
		height: r.height ?? "40px",
		width: "100%",
		alignItems: "center",
		children: [/* @__PURE__ */ U($r, {
			...N,
			ref: (e) => {
				Rg(a, e), i && Rg(i, e);
			},
			height: "40px",
			width: "100%",
			border: `1px solid ${r.isInvalid ? En : M}`,
			boxShadow: Ht,
			borderRadius: "6px",
			backgroundColor: I,
			_hover: {
				border: `1px solid ${r.isInvalid ? En : en}`,
				boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.07)"
			},
			_focus: {
				outline: `1px solid ${r.isInvalid ? En : C}`,
				outlineOffset: "-1px",
				boxShadow: "1px 1px 3px 0px rgba(15, 23, 42, 0.06)"
			},
			...r,
			onChange: (t) => e?.(t.target.value)
		}), n && /* @__PURE__ */ U(B, {
			marginRight: 2,
			alignItems: "center",
			position: "absolute",
			right: 0,
			zIndex: 2,
			children: /* @__PURE__ */ U(z, {
				width: "20px",
				color: "#64748b",
				children: n
			})
		})]
	});
});
function Rg(e, t) {
	typeof e == "function" ? e(t) : e && (e.current = t);
}
var zg = {
	backgroundColor: A,
	color: en,
	border: `1px solid ${P}`,
	cursor: "not-allowed",
	boxShadow: "none"
}, Bg = { border: `1px solid ${En}` }, Vg = { border: `1px solid ${C}` }, Hg = mc(({ fullWidth: e = !0, isInvalid: t = !1, isDisabled: n = !1, prefix: r, suffix: i, onBlur: a, onFocus: o, autoFocus: s, preventScrollOnAutoFocus: c, borderColor: l = M, height: u = "32px", inputGroupStyles: d = void 0, textAlign: f = "left", suffixStyles: p = void 0, ...m }, h) => {
	let g = J(null), _ = e ? "100%" : "unset", v = G(() => {
		g?.current?.focus({ preventScroll: c || !1 });
	}, [c]);
	return yc(() => {
		s && v();
	}, [s, v]), /* @__PURE__ */ W(ei, {
		borderRadius: "6px",
		boxShadow: Pn,
		border: `1px solid ${l}`,
		backgroundColor: I,
		onClick: v,
		onFocus: o,
		onBlur: a,
		...n && zg,
		...t && Bg,
		height: u,
		width: m.width,
		display: "flex",
		alignItems: "center",
		_focusWithin: { ...Vg },
		style: d,
		children: [
			r && /* @__PURE__ */ U(ti, {
				h: u,
				pl: "8px",
				pr: "4px",
				pointerEvents: "none",
				border: "none",
				color: "#64748b",
				backgroundColor: "transparent",
				...N,
				children: r
			}),
			/* @__PURE__ */ U($r, {
				ref: (e) => {
					Rg(g, e), h && Rg(h, e);
				},
				border: "none",
				height: u,
				boxShadow: "none",
				pl: r ? "0" : "8px",
				pr: i ? "0" : "8px",
				backgroundColor: "transparent",
				width: _,
				isInvalid: t,
				isDisabled: n,
				...N,
				...m,
				_placeholder: { color: en },
				_focus: {
					border: "none",
					boxShadow: "none"
				},
				_invalid: {
					border: "none",
					boxShadow: "none"
				},
				_disabled: {
					border: "none",
					boxShadow: "none",
					cursor: "not-allowed"
				},
				maxLength: m.maxLength,
				textAlign: f
			}),
			i && /* @__PURE__ */ U(ni, {
				h: u,
				pl: "4px",
				pr: "8px",
				pointerEvents: "none",
				border: "none",
				color: "#64748b",
				backgroundColor: "transparent",
				...N,
				style: p,
				children: i
			})
		]
	});
}), Ug = ({ isDisabled: e, isInvalid: t, value: n, onChange: r, width: i = "184px", "data-testid": a, suffix: o }) => /* @__PURE__ */ U(mi, {
	placement: "bottom-start",
	isLazy: !0,
	closeOnBlur: !0,
	lazyBehavior: "unmount",
	children: ({ onClose: s, isOpen: c }) => /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(ei, {
		width: i,
		tabIndex: e ? void 0 : 0,
		boxShadow: Ht,
		children: /* @__PURE__ */ U(Hg, {
			isDisabled: e,
			isInvalid: t,
			width: i,
			placeholder: "Select billing date",
			value: Wg(n),
			"data-testid": a,
			suffix: /* @__PURE__ */ W(H, { children: [o, /* @__PURE__ */ U(z, {
				width: "20px",
				children: U(c ? Xp : Up, {})
			})] })
		})
	}) }), /* @__PURE__ */ U(vi, { children: /* @__PURE__ */ U(_i, { children: /* @__PURE__ */ U(R, {
		"data-testid": a && `${a}.dateSelection`,
		children: /* @__PURE__ */ U(Ig, {
			onChange: (e) => {
				r(e), s();
			},
			value: n
		})
	}) }) })] })
}), Wg = (e) => typeof e == "number" ? `${Nc(`${e}`)} of the month` : "Select billing date";
//#endregion
//#region src/forms/inputs/numberFormatting.ts
function Gg(e) {
	if (typeof e == "number") return Gg(String(e));
	if (!e || e === "-") return e;
	let t = e.replace(/,/g, ""), n = t.split("."), r = n[0];
	if (!r || r === "-") return n.length > 1 ? `${r || ""}.${n[1]}` : r || "";
	let i = r.startsWith("-"), a = i ? r.slice(1) : r;
	if (!/^\d+$/.test(a)) return e;
	let o = a.replace(/\B(?=(\d{3})+(?!\d))/g, ","), s = i ? "-" : "";
	return n.length > 1 ? `${s}${o}.${n[1]}` : t.endsWith(".") ? `${s}${o}.` : `${s}${o}`;
}
function Kg(e) {
	return String(e).replace(/,/g, "");
}
function qg(e) {
	let t = e.startsWith("-"), [n, ...r] = e.replace(/[^0-9.]/g, "").split("."), i = r.length > 0 ? `${n}.${r.join("")}` : n;
	return t ? `-${i}` : i;
}
function Jg(e, t, n) {
	let r = 0;
	for (let t = 0; t < n; t++) e[t] !== "," && r++;
	if (r === 0) return 0;
	let i = 0;
	for (let e = 0; e < t.length; e++) if (t[e] !== "," && (i++, i === r)) return e + 1;
	return t.length;
}
function Yg(e) {
	let { key: t, metaKey: n, ctrlKey: r } = e;
	if (n || r) return !0;
	let i = e.target, a = Kg(i.value);
	if (t === "-") {
		let e = Xg(i);
		return (a === "" || e === 0) && !a.includes("-");
	}
	return t === "." && a.includes(".") ? !1 : !!(t.match(/^[0-9.]$/) || t === "Backspace" || t === "Delete" || t.startsWith("Arrow") || t === "Tab" || t === "Enter" || t === "Escape");
}
function Xg(e) {
	let t = e.selectionStart ?? 0, n = 0;
	for (let r = 0; r < t; r++) e.value[r] !== "," && n++;
	return n;
}
function Zg() {
	let e = J(null), t = J(null);
	return yc(() => {
		t.current !== null && e.current && (e.current.setSelectionRange(t.current, t.current), t.current = null);
	}), {
		inputRef: e,
		onChangeCaptureCursor: G((e) => {
			let n = e.target.value, r = e.target.selectionStart ?? n.length, i = Gg(Kg(n).replace(/[^0-9.\-]/g, ""));
			t.current = Jg(n, i, r);
		}, []),
		onKeyDownSkipCommas: G((e) => {
			let t = e.target, n = t.selectionStart ?? 0, r = t.value;
			e.key === "Backspace" && n > 0 && r[n - 1] === "," && t.setSelectionRange(n - 1, n - 1), e.key === "Delete" && n < r.length && r[n] === "," && t.setSelectionRange(n + 1, n + 1);
		}, [])
	};
}
//#endregion
//#region src/forms/inputs/SteppedNumberInput.tsx
var Qg = ({ onChange: e, onBlur: t, isDisabled: n, isInvalid: r, width: i = "100%", ...a }) => {
	let { inputRef: o, onChangeCaptureCursor: s, onKeyDownSkipCommas: c } = Zg();
	return /* @__PURE__ */ U(fi, {
		precision: a.precision,
		step: .01,
		value: a.value,
		onChange: (t, n) => {
			e(t, n);
		},
		clampValueOnBlur: !!a.precision,
		onBlur: t,
		isDisabled: n,
		isInvalid: r,
		width: i,
		format: Gg,
		parse: Kg,
		children: /* @__PURE__ */ U(pi, {
			...N,
			ref: o,
			onChange: s,
			onKeyDown: c,
			_focus: {
				outline: `2px solid ${C}`,
				outlineOffset: "-1px",
				boxShadow: "0px 1px 3px 0px rgba(15, 23, 42, 0.06)"
			},
			height: "32px",
			width: "100%",
			border: `1px solid ${M}`,
			boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
			borderRadius: "6px",
			paddingLeft: "8px",
			onBlur: t,
			...a
		})
	});
}, $g = ({ onChange: e, isDisabled: t, isInvalid: n, width: r = "100%", variant: i = "standard", precision: a, clampValueOnBlur: o = !!a, ...s }) => {
	let { inputRef: c, onChangeCaptureCursor: l, onKeyDownSkipCommas: u } = Zg();
	return i === "v2" ? /* @__PURE__ */ U(r_, {
		onChange: e,
		isDisabled: t,
		isInvalid: n,
		width: r,
		precision: a,
		clampValueOnBlur: o,
		...s
	}) : /* @__PURE__ */ W(ei, {
		...i === "table" ? {} : { boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)" },
		width: r,
		children: [/* @__PURE__ */ U(ti, {
			...i === "table" ? {
				...N,
				backgroundColor: "transparent",
				border: "none",
				boxShadow: "none",
				borderRadius: "0",
				height: "32px",
				padding: "0 4px 0 12px",
				width: "fit-content",
				display: "flex",
				alignContent: "center"
			} : { backgroundColor: rr },
			...t ? { opacity: .4 } : {},
			children: "%"
		}), /* @__PURE__ */ U(fi, {
			precision: a,
			step: .01,
			value: s.value,
			onChange: e,
			isDisabled: t,
			isInvalid: n,
			width: "100%",
			clampValueOnBlur: o,
			min: typeof s.min == "number" ? s.min : void 0,
			max: typeof s.max == "number" ? s.max : void 0,
			format: Gg,
			parse: Kg,
			children: /* @__PURE__ */ U(pi, {
				...N,
				ref: c,
				onChange: l,
				onKeyDown: u,
				width: "100%",
				borderTopLeftRadius: "0",
				borderBottomLeftRadius: "0",
				_focus: {
					outline: `2px solid ${C}`,
					outlineOffset: "-1px",
					boxShadow: "0px 1px 3px 0px rgba(15, 23, 42, 0.06)"
				},
				...i === "table" ? {
					paddingLeft: "4px",
					paddingRight: "4px",
					height: "32px"
				} : { height: "40px" },
				...s
			})
		})]
	});
}, e_ = {
	backgroundColor: A,
	color: en,
	border: `1px solid ${P}`,
	cursor: "not-allowed",
	boxShadow: "none"
}, t_ = { border: `1px solid ${En}` }, n_ = { border: `1px solid ${C}` }, r_ = ({ isDisabled: e, isInvalid: t, width: n, precision: r, value: i, onChange: a, clampValueOnBlur: o = !!r, ...s }) => {
	let { inputRef: c, onChangeCaptureCursor: l, onKeyDownSkipCommas: u } = Zg();
	return /* @__PURE__ */ W(ei, {
		height: "32px",
		borderRadius: "6px",
		boxShadow: Pn,
		border: `1px solid ${M}`,
		backgroundColor: I,
		onClick: () => {
			c?.current?.focus();
		},
		...e && e_,
		...t && t_,
		_focusWithin: { ...n_ },
		children: [/* @__PURE__ */ U(ti, {
			h: "32px",
			pl: "8px",
			pr: "4px",
			pointerEvents: "none",
			border: "none",
			color: k,
			backgroundColor: "transparent",
			...N,
			children: "%"
		}), /* @__PURE__ */ U(fi, {
			precision: r,
			step: .01,
			value: i,
			onChange: a,
			isDisabled: e,
			isInvalid: t,
			width: "100%",
			clampValueOnBlur: o,
			min: typeof s.min == "number" ? s.min : void 0,
			max: typeof s.max == "number" ? s.max : void 0,
			format: Gg,
			parse: Kg,
			children: /* @__PURE__ */ U(pi, {
				...N,
				ref: c,
				onChange: l,
				onKeyDown: u,
				border: "none",
				height: "32px",
				boxShadow: "none",
				pl: "0",
				backgroundColor: "transparent",
				width: n,
				...N,
				...s,
				_placeholder: { color: en },
				_focus: {
					border: "none",
					boxShadow: "none"
				},
				_invalid: {
					border: "none",
					boxShadow: "none"
				},
				_disabled: {
					border: "none",
					boxShadow: "none",
					cursor: "not-allowed"
				}
			})
		})]
	});
}, i_ = ({ onChange: e, onBlur: t, value: n, isDisabled: r, isInvalid: i, width: a = "100%", variant: o = "standard", "data-testid": s, ...c }) => {
	let { inputRef: l, onChangeCaptureCursor: u, onKeyDownSkipCommas: d } = Zg();
	return o === "v2" ? /* @__PURE__ */ U(c_, {
		onChange: e,
		onBlur: t,
		value: n,
		isDisabled: r,
		isInvalid: i,
		width: a,
		"data-testid": s,
		...c
	}) : /* @__PURE__ */ W(ei, {
		...o === "table" ? {} : { boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)" },
		width: a,
		borderRadius: "6px",
		children: [/* @__PURE__ */ U(ti, {
			...o === "table" ? {
				...N,
				backgroundColor: "transparent",
				border: "none",
				boxShadow: "none",
				borderRadius: "0",
				height: "32px",
				padding: "0 4px 0 12px",
				width: "fit-content",
				display: "flex",
				alignContent: "center"
			} : { backgroundColor: rr },
			...r ? { opacity: .4 } : {},
			children: zc(c.currency)
		}), /* @__PURE__ */ U(fi, {
			precision: c.precision,
			value: n,
			clampValueOnBlur: !!c.precision,
			isDisabled: r,
			onChange: (t, n) => {
				e(t, n);
			},
			onBlur: t,
			isInvalid: i,
			width: "100%",
			format: Gg,
			parse: Kg,
			children: /* @__PURE__ */ U(pi, {
				...N,
				ref: l,
				onChange: u,
				onKeyDown: d,
				width: "100%",
				position: "relative",
				zIndex: 1,
				borderTopLeftRadius: "0",
				borderBottomLeftRadius: "0",
				"data-testid": s,
				_focus: {
					outline: `2px solid ${C}`,
					outlineOffset: "-1px",
					boxShadow: "0px 1px 3px 0px rgba(15, 23, 42, 0.06)"
				},
				...o === "table" ? {
					paddingLeft: "4px",
					paddingRight: "4px",
					height: "32px"
				} : { height: "40px" },
				...c
			})
		})]
	});
}, a_ = {
	backgroundColor: A,
	color: en,
	border: `1px solid ${P}`,
	cursor: "not-allowed",
	boxShadow: "none"
}, o_ = { border: `1px solid ${En}` }, s_ = { border: `1px solid ${C}` }, c_ = ({ onChange: e, onBlur: t, value: n, isDisabled: r, isInvalid: i, width: a, height: o = "32px", "data-testid": s, ...c }) => {
	let { inputRef: l, onChangeCaptureCursor: u, onKeyDownSkipCommas: d } = Zg();
	return /* @__PURE__ */ W(ei, {
		height: o,
		borderRadius: "6px",
		boxShadow: Pn,
		border: `1px solid ${M}`,
		backgroundColor: I,
		onClick: () => {
			l?.current?.focus();
		},
		...r && a_,
		...i && o_,
		_focusWithin: { ...s_ },
		alignItems: "center",
		children: [/* @__PURE__ */ U(ti, {
			h: o,
			pl: "8px",
			pr: "4px",
			pointerEvents: "none",
			border: "none",
			color: k,
			backgroundColor: "transparent",
			...N,
			children: zc(c.currency)
		}), /* @__PURE__ */ U(fi, {
			precision: c.precision,
			value: n,
			clampValueOnBlur: c.precision !== void 0,
			isDisabled: r,
			onChange: (t, n) => {
				e(t, n);
			},
			onBlur: t,
			isInvalid: i,
			width: "100%",
			format: Gg,
			parse: Kg,
			children: /* @__PURE__ */ U(pi, {
				...N,
				ref: l,
				onChange: u,
				onKeyDown: d,
				border: "none",
				height: o,
				boxShadow: "none",
				pl: "0",
				backgroundColor: "transparent",
				width: a,
				"data-testid": s,
				...c,
				_placeholder: { color: en },
				_focus: {
					border: "none",
					boxShadow: "none"
				},
				_invalid: {
					border: "none",
					boxShadow: "none"
				},
				_disabled: {
					border: "none",
					boxShadow: "none",
					cursor: "not-allowed"
				}
			})
		})]
	});
}, l_ = (e) => /* @__PURE__ */ U(Bi, {
	...N,
	height: "40px",
	width: "100%",
	border: `1px solid ${M}`,
	boxShadow: "0px 1px 2px 0px rgba(15, 23, 42, 0.04)",
	borderRadius: "6px",
	backgroundColor: I,
	padding: "10px 12px",
	_hover: {
		border: `1px solid ${en}`,
		boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.07)"
	},
	_focus: {
		outline: `2px solid ${C}`,
		outlineOffset: "-1px",
		boxShadow: "0px 1px 3px 0px rgba(15, 23, 42, 0.06)"
	},
	...e,
	onChange: (t) => e.onChange(t.target.value)
}), u_ = {
	backgroundColor: A,
	color: en,
	border: `1px solid ${P}`,
	cursor: "not-allowed",
	boxShadow: "none"
}, d_ = {
	border: `1px solid ${En}`,
	boxShadow: "none"
}, f_ = {
	border: `1px solid ${C}`,
	boxShadow: "none"
}, p_ = ({ fullWidth: e = !0, isInvalid: t = !1, isDisabled: n = !1, prefix: r, onBlur: i, onFocus: a, autoFocus: o, style: s, ...c }) => /* @__PURE__ */ U(Bi, {
	px: "8px",
	width: e ? "100%" : "unset",
	isInvalid: t,
	isDisabled: n,
	borderRadius: "6px",
	boxShadow: Pn,
	border: `1px solid ${M}`,
	backgroundColor: I,
	...N,
	...c,
	style: s,
	_placeholder: { color: en },
	_focus: f_,
	_invalid: d_,
	_disabled: u_,
	autoFocus: o
}), m_ = ({ children: e, hasArrow: t = !0, shouldWrapChildren: n = !0, containerRef: r, isInteractive: i, ...a }) => i ? /* @__PURE__ */ U(h_, {
	hasArrow: t,
	containerRef: r,
	...a,
	children: e
}) : /* @__PURE__ */ U(Ki, {
	hasArrow: t,
	p: "8px",
	bg: Ft,
	borderRadius: "6px",
	arrowSize: 8,
	shouldWrapChildren: n,
	maxWidth: "400px",
	whiteSpace: "wrap",
	portalProps: { containerRef: r },
	...a,
	...N,
	children: e
}), h_ = ({ children: e, label: t, placement: n = "top", isDisabled: r, hasArrow: i, openDelay: a, containerRef: o, "data-testid": s }) => r || !t ? /* @__PURE__ */ U(H, { children: e }) : /* @__PURE__ */ W(mi, {
	trigger: "hover",
	placement: n,
	variant: "unstyled",
	openDelay: a,
	isLazy: !0,
	children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(R, {
		display: "inline-block",
		"data-testid": s ? `${s}.trigger` : void 0,
		children: e
	}) }), /* @__PURE__ */ U(Si, {
		containerRef: o,
		children: /* @__PURE__ */ W(vi, {
			padding: "8px",
			backgroundColor: Ft,
			color: I,
			borderRadius: "6px",
			maxWidth: "400px",
			width: "max-content",
			whiteSpace: "wrap",
			boxShadow: "none",
			_focusVisible: { outline: "none" },
			"data-testid": s,
			...N,
			children: [i && /* @__PURE__ */ U(gi, { backgroundColor: "#1e293b" }), t]
		})
	})]
}), g_ = (e) => {
	let { onOpen: t, onClose: n, isOpen: r } = Kc(), i = J(null), a = J(null), o = J(null), s = G(() => {
		o.current ||= (a.current &&= (clearTimeout(a.current), null), setTimeout(t, e.delay ?? 250));
	}, [t, e.delay]), c = G(() => {
		o.current && clearTimeout(o.current), o.current = null, a.current = setTimeout(() => n(), e.delay ?? 250);
	}, [n, e.delay]);
	return /* @__PURE__ */ W(mi, {
		isOpen: !e.disabled && r,
		placement: e.placement ?? "top",
		children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(R, {
			onMouseEnter: s,
			onMouseLeave: c,
			...e.style?.wrapper ?? {},
			children: e.children
		}) }), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(vi, {
			ref: i,
			padding: "12px",
			borderRadius: "8px",
			border: `1px solid ${P}`,
			boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
			backgroundColor: I,
			onMouseEnter: s,
			onMouseLeave: c,
			overflow: "visible",
			...e.style?.content ?? {},
			children: /* @__PURE__ */ W(R, { children: [e.title && /* @__PURE__ */ U(R, {
				...ar,
				color: "#0f172a",
				marginBottom: "8px",
				children: e.title
			}), /* @__PURE__ */ U(R, {
				...N,
				color: Xt,
				children: e.content
			})] })
		}) })]
	});
}, __ = ({ title: e, body: t, placement: n, padding: r, minimal: i, icon: a, variant: o = "fieldInfo", "data-testid": s }) => /* @__PURE__ */ W(mi, {
	placement: n || "left",
	variant: o,
	trigger: "hover",
	children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(Zr, {
		minWidth: i ? "16px" : "24px",
		height: i ? "16px" : "24px",
		"aria-label": "Show info",
		icon: a || /* @__PURE__ */ U(em, { color: "#334155" }),
		variant: "clear",
		padding: r || "0px",
		"data-testid": s
	}) }), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ W(vi, {
		"data-testid": s ? `${s}.content` : void 0,
		children: [e ? /* @__PURE__ */ U(yi, { children: e }) : null, /* @__PURE__ */ U(_i, {
			pt: e ? "0" : "20px",
			children: t
		})]
	}) })]
}), v_ = {
	label: {
		...j,
		color: F,
		marginBottom: "8px"
	},
	error: {
		marginTop: "8px",
		...N,
		color: Un
	},
	description: {
		marginTop: "8px",
		...tr
	}
}, y_ = (e, t = {}) => ({ validationErrors: n, label: r, description: i, styles: a, tooltip: o, fieldTooltip: s, infoPopover: c, showValidationMessage: l = !0, ...u }) => {
	let d = /* @__PURE__ */ U(e, {
		isInvalid: !!n?.length,
		...u
	});
	return /* @__PURE__ */ W(R, {
		width: u.width ?? t.defaultWidth ?? "100%",
		...a?.wrapper ?? {},
		children: [
			r && /* @__PURE__ */ W(B, {
				"data-testid": "data-testid" in u ? `${u["data-testid"]}.label` : "select.label",
				alignItems: "center",
				height: "16px",
				...v_.label,
				...a?.label ?? {},
				gap: "8px",
				children: [
					r,
					c && /* @__PURE__ */ U(__, { ...c }),
					!!o && /* @__PURE__ */ U(g_, {
						title: o?.title,
						content: o?.content,
						children: /* @__PURE__ */ U(em, {
							"data-testid": "data-testid" in u ? `${u["data-testid"]}.tooltip` : void 0,
							color: "#64748b"
						})
					})
				]
			}),
			l && s ? /* @__PURE__ */ U(m_, {
				label: s.label,
				placement: s.placement,
				children: d
			}) : d,
			n && n.length > 0 && /* @__PURE__ */ U(R, {
				"data-testid": "data-testid" in u ? `${u["data-testid"]}.error` : void 0,
				...v_.error,
				...a?.error ?? {},
				children: n[0].message
			}, n[0].message),
			i && /* @__PURE__ */ U(R, {
				"data-testid": "data-testid" in u ? `${u["data-testid"]}.description` : void 0,
				...v_.description,
				...a?.description ?? {},
				children: i
			})
		]
	});
}, b_ = (e) => {
	let t = e["data-testid"];
	return /* @__PURE__ */ U(wi, {
		onChange: e.onChange,
		value: e.value,
		isDisabled: e.isDisabled,
		"data-testid": t,
		children: /* @__PURE__ */ U(Ai, { children: e.options.map((n) => /* @__PURE__ */ U(Ci, {
			isInvalid: e.isInvalid,
			value: n.value,
			isDisabled: n.disabled,
			"data-testid": t ? `${t}.option.${n.value}` : void 0,
			children: /* @__PURE__ */ W(B, {
				...N,
				gap: "4px",
				alignItems: "center",
				children: [/* @__PURE__ */ U(R, {
					...ar,
					children: n.label
				}), n.description && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(R, {
					color: "#475569",
					children: "-"
				}), /* @__PURE__ */ U(R, {
					color: "#475569",
					children: n.description
				})] })]
			})
		}, n.value)) })
	});
}, x_ = {
	dateToString: (e, t) => {
		if (!e) return "";
		try {
			return nl(e, t) ?? "";
		} catch {
			return "";
		}
	},
	stringToDate: (e, t) => {
		try {
			return ll(e, t, /* @__PURE__ */ new Date());
		} catch {
			return;
		}
	}
}, S_ = (e) => {
	let t = e.dateFormat ?? "yyyy-MM-dd", [n, r] = Y(x_.dateToString(e.value, t)), [i, a] = Y(!1), o = J(null), s = J(null), c = G((e) => {
		r(e);
	}, []), l = G(() => {
		let i = x_.stringToDate(n, t);
		e.onChange(n ? i : void 0), r(x_.dateToString(i, t));
	}, [n, e]), u = G((n) => {
		e.onChange(n), r(x_.dateToString(n, t)), a(!1);
	}, [e]), d = G((e) => {
		[
			"ArrowUp",
			"ArrowDown",
			"ArrowLeft",
			"ArrowRight"
		].includes(e.key) && e.stopPropagation();
	}, []), f = G((e) => {
		a(e);
	}, []);
	return K(() => {
		r(x_.dateToString(e.value, t));
	}, [e.value, t]), Jc({
		ref: s,
		handler: (e) => {
			e.target !== o.current && a(!1);
		}
	}), {
		handleInputBlur: l,
		handlePickerSelection: u,
		handleInputUpdate: c,
		handleInputKeydown: d,
		popoverOpen: i,
		updatePopoverOpen: f,
		formattedDateString: n,
		refs: {
			input: o,
			popover: s
		}
	};
}, C_ = {
	toDayzed: (e) => {
		let t = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return ll(nl(e, "yyyy-MM-dd"), "yyyy-MM-dd", /* @__PURE__ */ new Date(), { in: _l(t) });
	},
	fromDayzed: (e) => {
		let t = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return ll(nl(e, "yyyy-MM-dd", { in: _l(t) }), "yyyy-MM-dd", /* @__PURE__ */ new Date(), { in: _l("UTC") });
	}
}, w_ = (e) => {
	let [t, n] = Y(0), [r, i] = Y(e.selectedDate && bl(e.selectedDate) ? e.selectedDate : void 0);
	K(() => {
		bl(e.selectedDate) && (i(e.selectedDate), n(0));
	}, [e.selectedDate]);
	let { calendars: a, getDateProps: o, getBackProps: s, getForwardProps: c } = vl({
		selected: [e.selectedDate && C_.toDayzed(e.selectedDate)].filter(Boolean),
		onDateSelected: (t) => {
			e.onDateSelected(C_.fromDayzed(t.date));
		},
		date: e.selectedDate && C_.toDayzed(e.selectedDate),
		minDate: e.minDate && C_.toDayzed(e.minDate),
		maxDate: e.maxDate && C_.toDayzed(e.maxDate),
		monthsToDisplay: 1,
		offset: t,
		onOffsetChanged: (e) => n(e),
		firstDayOfWeek: 1
	});
	return { calendarView: {
		calendar: a[0],
		getDateProps: o,
		getBackProps: s,
		getForwardProps: c,
		selectedDate: r
	} };
}, T_ = ({ calendar: e, directionProps: t, offset: n, children: r, type: i, "data-testid": a }) => {
	let o = n === 1 && i === "back" ? "Previous month" : n === 1 && i === "forward" ? "Next month" : n === 12 && i === "back" ? "Previous year" : n === 12 && i === "forward" ? "Next year" : "";
	return /* @__PURE__ */ U(Ki, {
		label: o,
		placement: "top",
		isDisabled: !o,
		hasArrow: !0,
		bg: "#171923",
		color: "white",
		px: "8px",
		py: "4px",
		fontSize: "14px",
		fontWeight: "400",
		borderRadius: "4px",
		children: /* @__PURE__ */ U(Or, {
			...t({
				calendars: [e],
				offset: n
			}),
			"data-testid": a,
			tabIndex: -1,
			variant: "dateSkipper",
			width: "24px",
			height: "24px",
			minWidth: "24px",
			px: 0,
			sx: { svg: { flexShrink: 0 } },
			children: r
		})
	});
}, E_ = ({ getBackProps: e, getForwardProps: t, calendar: n, monthLabel: r, hideYearSkippers: i, "data-testid": a = "datePicker" }) => /* @__PURE__ */ W(B, {
	w: "100%",
	onClick: (e) => e.stopPropagation(),
	children: [
		!i && /* @__PURE__ */ U(T_, {
			calendar: n,
			directionProps: e,
			offset: 12,
			type: "back",
			"data-testid": `${a}.previousYear`,
			children: /* @__PURE__ */ U(Bp, {})
		}),
		/* @__PURE__ */ U(T_, {
			calendar: n,
			directionProps: e,
			offset: 1,
			type: "back",
			"data-testid": `${a}.previousMonth`,
			children: /* @__PURE__ */ U(Kp, {})
		}),
		/* @__PURE__ */ U(Di, {}),
		/* @__PURE__ */ U(B, {
			justify: "center",
			align: "center",
			children: /* @__PURE__ */ U(R, {
				fontWeight: 700,
				children: r
			})
		}),
		/* @__PURE__ */ U(Di, {}),
		/* @__PURE__ */ U(T_, {
			calendar: n,
			directionProps: t,
			offset: 1,
			type: "forward",
			"data-testid": `${a}.nextMonth`,
			children: /* @__PURE__ */ U(qp, {})
		}),
		!i && /* @__PURE__ */ U(T_, {
			calendar: n,
			directionProps: t,
			offset: 12,
			type: "forward",
			"data-testid": `${a}.nextYear`,
			children: /* @__PURE__ */ U(Vp, {})
		})
	]
}), D_ = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
], O_ = [
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat",
	"Sun"
], k_ = ({ calendar: e, getDateProps: t, getBackProps: n, getForwardProps: r, initialRef: i, "data-testid": a = "datePicker", calendarHeaderTestId: o = a, ...s }) => /* @__PURE__ */ W(B, {
	flexDirection: "column",
	width: "max-content",
	"data-testid": "calendarView",
	children: [/* @__PURE__ */ U(E_, {
		getForwardProps: r,
		getBackProps: n,
		calendar: e,
		monthLabel: `${D_[e.month]} ${e.year}`,
		"data-testid": o
	}), /* @__PURE__ */ W(Ti, {
		columns: 7,
		spacingY: "1px",
		textAlign: "center",
		children: [O_.map((e) => /* @__PURE__ */ U(R, {
			color: "gray.60",
			fontSize: "12px",
			lineHeight: "16px",
			py: 4,
			children: e
		}, e)), e.weeks.map((e) => e.map((e, n) => {
			if (typeof e == "string") return /* @__PURE__ */ U(R, { outline: "none" }, n);
			let { date: r, selectable: o, selected: c, today: l } = e, u = D_[r.getMonth()];
			return /* @__PURE__ */ U(Pg, {
				"data-testid": `${a}.button.${u}.${e.date.getDate()}`,
				initialRef: i,
				selected: c,
				selectableDate: o,
				today: l,
				label: e.date.getDate(),
				dateProps: { ...t({ dateObj: e }) },
				...A_({
					...s,
					date: r,
					selected: c,
					today: l
				})
			}, nl(r, "yyyy-MM-dd"));
		}))]
	})]
}), A_ = ({ selected: e, date: t, today: n, ...r }) => {
	if (r.type === "single") return;
	let { selectedDates: i, focusedInput: a } = r;
	return {
		position: j_({
			selected: e,
			date: t,
			selectedDates: i
		}),
		hasInitialFocus: N_({
			today: n,
			date: t,
			selectedDates: i,
			focusedInput: a
		}),
		inRange: !!M_({
			date: t,
			selectedDates: i
		}),
		focusedInput: a
	};
}, j_ = ({ selected: e, date: t, selectedDates: n }) => {
	if (e) {
		if (bl(n[0]) && bl(n[1]) && t.getTime() === n[0].getTime()) return "start";
		if (bl(n[0]) && bl(n[1]) && t.getTime() === n[1].getTime()) return "end";
	}
}, M_ = ({ date: e, selectedDates: t }) => {
	if (!bl(t[0]) || !bl(t[1])) return !1;
	let [n, r] = t, i = new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime(), a = new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime(), o = new Date(r.getFullYear(), r.getMonth(), r.getDate()).getTime();
	return a && o && a <= i && o >= i;
}, N_ = ({ today: e, date: t, selectedDates: n, focusedInput: r }) => X(r).with("start", () => n[0] && bl(n[0]) ? t.getTime() === n[0].getTime() : n[1] && bl(n[1]) ? t.getTime() === Zc(n[1], { days: -1 }).getTime() : e).with("end", () => n[1] && bl(n[1]) ? t.getTime() === n[1].getTime() : n[0] && bl(n[0]) ? t.getTime() === Zc(n[0], { days: 0 }).getTime() : t.getTime() === (/* @__PURE__ */ new Date()).getTime()).otherwise(() => !1), P_ = ({ selectedDate: e, minDate: t, maxDate: n, onDateSelected: r, initialRef: i }) => {
	let { calendarView: a } = w_({
		selectedDate: e,
		minDate: t,
		maxDate: n,
		onDateSelected: r
	});
	return /* @__PURE__ */ U(B, { children: /* @__PURE__ */ U(B, {
		height: "320px",
		children: /* @__PURE__ */ U(k_, {
			...a,
			initialRef: i,
			type: "single"
		})
	}) });
}, F_ = ({ value: e, name: t, onChange: n, minDate: r, maxDate: i, isDisabled: a, isInvalid: o, width: s = "226px", height: c, variant: l, trigger: u, placeholder: d = "Select date", "data-testid": f, suffix: p, dateFormat: m, hideCalendarIcon: h }) => {
	let g = f ?? "datePicker", _ = S_({
		value: e,
		onChange: n,
		dateFormat: m
	}), v = J(null);
	return /* @__PURE__ */ W(mi, {
		variant: "dateRange",
		isOpen: _.popoverOpen,
		placement: "bottom-start",
		onClose: () => _.updatePopoverOpen(!1),
		autoFocus: !1,
		returnFocusOnClose: !1,
		closeOnBlur: !1,
		isLazy: !0,
		lazyBehavior: "unmount",
		initialFocusRef: v,
		children: [/* @__PURE__ */ U(hi, { children: /* @__PURE__ */ U("div", {
			style: { cursor: a ? "not-allowed" : "auto" },
			children: /* @__PURE__ */ U(ei, {
				"data-testid": `${g}`,
				ref: v,
				height: c,
				width: s,
				onBlur: _.handleInputBlur,
				onClick: () => _.updatePopoverOpen(!0),
				tabIndex: a ? void 0 : 0,
				pointerEvents: a ? "none" : "auto",
				children: u ?? /* @__PURE__ */ U(Hg, {
					"data-testid": `${g}.textInput`,
					name: t,
					isDisabled: a,
					isInvalid: o,
					width: s,
					placeholder: d,
					value: _.formattedDateString,
					readOnly: !0,
					autoComplete: "off",
					suffix: /* @__PURE__ */ W(H, { children: [p, !h && (l === "new" ? /* @__PURE__ */ U(Xr, {
						"data-testid": `${g}.popover.iconInput`,
						as: Np,
						height: "16px",
						width: "16px",
						color: "#64748b"
					}) : /* @__PURE__ */ U(Np, {}))] })
				})
			})
		}) }), _.popoverOpen && /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(vi, {
			"data-testid": `${g}.popover.content`,
			children: /* @__PURE__ */ U(_i, {
				ref: _.refs.popover,
				children: /* @__PURE__ */ U(R, {
					"data-testid": f,
					children: /* @__PURE__ */ U(P_, {
						selectedDate: e,
						onDateSelected: _.handlePickerSelection,
						minDate: r,
						maxDate: i
					})
				})
			})
		}) })]
	});
}, I_ = (e) => {
	let [t, n] = Y(0), [r, i] = Y(bl(e.selectedDate) ? e.selectedDate : /* @__PURE__ */ new Date());
	K(() => {
		bl(e.selectedDate) && (i(e.selectedDate), n(0));
	}, [e.selectedDate]);
	let { calendars: a, getDateProps: o, getBackProps: s, getForwardProps: c } = vl({
		selected: [C_.toDayzed(e.selectedDate)],
		onDateSelected: (t) => {
			e.onDateSelected(C_.fromDayzed(t.date));
		},
		date: C_.toDayzed(e.selectedDate),
		minDate: e.minDate && C_.toDayzed(e.minDate),
		maxDate: e.maxDate && C_.toDayzed(e.maxDate),
		monthsToDisplay: 1,
		offset: t,
		onOffsetChanged: (e) => n(e),
		firstDayOfWeek: 1
	});
	return { calendarView: {
		calendar: a[0],
		getDateProps: o,
		getBackProps: s,
		getForwardProps: c,
		selectedDate: r
	} };
}, L_ = ({ selectedDate: e, minDate: t, maxDate: n, onDateSelected: r, initialRef: i, "data-testid": a }) => {
	let { calendarView: o } = I_({
		selectedDate: e,
		minDate: t,
		maxDate: n,
		onDateSelected: r
	});
	return /* @__PURE__ */ U(B, { children: /* @__PURE__ */ U(B, {
		height: "fit-content",
		"data-testid": a,
		children: /* @__PURE__ */ U(k_, {
			...o,
			initialRef: i,
			type: "single",
			calendarHeaderTestId: a
		})
	}) });
}, R_ = [
	{
		diff: {
			months: 1,
			days: -1
		},
		label: "1 month",
		value: "1-month"
	},
	{
		diff: {
			months: 2,
			days: -1
		},
		label: "2 months",
		value: "2-month"
	},
	{
		diff: {
			months: 3,
			days: -1
		},
		label: "3 months",
		value: "3-month"
	},
	{
		diff: {
			months: 6,
			days: -1
		},
		label: "6 months",
		value: "6-month"
	},
	{
		diff: {
			months: 9,
			days: -1
		},
		label: "9 months",
		value: "9-month"
	},
	{
		diff: {
			years: 1,
			days: -1
		},
		label: "1 year",
		value: "1-year"
	},
	{
		diff: {
			years: 2,
			days: -1
		},
		label: "2 years",
		value: "2-year"
	},
	{
		diff: {
			years: 3,
			days: -1
		},
		label: "3 years",
		value: "3-year"
	},
	{
		diff: "FOREVER",
		label: "Open ended",
		value: "FOREVER"
	},
	{
		diff: "CUSTOM",
		label: "Choose date...",
		value: "CUSTOM"
	},
	{
		diff: "CUSTOM_DURATION",
		label: "Choose duration...",
		value: "CUSTOM_DURATION"
	}
], z_ = ({ value: e, mode: t, fromDate: n, durations: r = R_, onChange: i, showAbsoluteDate: a = !1, durationFilterFn: o }) => {
	let [s, c] = Y(!1), [l, u] = Y(!1), d = q(() => {
		let e = o ? r.filter((e) => o(e)) : r;
		return n ? e : e.filter((e) => typeof e.diff != "string").map((e) => ({
			...e,
			absolute: Qc.toDate(n)(e.diff)
		}));
	}, [
		o,
		r,
		n
	]), f = q(() => {
		if (!e) return "FOREVER";
		let r = d.find((r) => {
			if (typeof r.diff == "string") return;
			let i = new Date(nl(n ?? /* @__PURE__ */ new Date(), "yyyy-MM-dd"));
			if (t === "absolute" && e) return xl(e)(Qc.toDate(i)({
				years: 0,
				months: 0,
				days: 0,
				...r.diff
			}));
			let a = Qc.toDuration(i)(Qc.toDate(i)({
				years: 0,
				months: 0,
				days: 0,
				...Sl([
					"years",
					"months",
					"days"
				])(e)
			})), o = Qc.toDuration(i)(Qc.toDate(i)({
				years: 0,
				months: 0,
				days: 0,
				...r.diff
			}));
			return xl(a)(o);
		}) ?? "";
		return r ? r?.value : "CURRENT_CUSTOM";
	}, [
		d,
		n,
		e,
		t
	]), p = q(() => {
		let r = d.map((e) => ({
			value: e.value,
			label: e.label,
			diff: e.diff
		}));
		if (!n) return r.filter((e) => typeof e.diff != "string");
		if (f === "CURRENT_CUSTOM" && e) {
			let i = t === "absolute" ? Qc.toDuration(n)(e) : e;
			if (!i) throw Error("Invalid custom duration length");
			return [{
				diff: "CURRENT_CUSTOM",
				label: a && t === "absolute" ? nl(e, "d MMMM yyyy") : il({
					...i,
					days: i.days === -1 ? 0 : (i?.days ?? 0) + 1
				}, { format: [
					"years",
					"months",
					"days"
				] }),
				value: "CURRENT_CUSTOM"
			}, ...r];
		}
		return r;
	}, [
		e,
		n,
		f,
		a,
		t,
		d
	]), m = J(null), h = J(null), g = G((e) => {
		if (e === "CURRENT_CUSTOM") {
			u(!1), c(!1);
			return;
		}
		if (e === "CUSTOM") {
			u(!1), c(!0);
			return;
		}
		if (e === "CUSTOM_DURATION") {
			u(!0), c(!1);
			return;
		}
		let a = r.find((t) => t.value === e), o = p.find((t) => t.value === e)?.diff;
		return i(!o || e === "FOREVER" ? void 0 : t === "absolute" ? Qc.toDate(n)(o) : {
			years: 0,
			months: 0,
			days: 0,
			...o
		}, a);
	}, [
		i,
		p,
		n,
		t,
		r
	]);
	return {
		handlePickerSelection: G((e) => {
			if (t === "relative") {
				i(Qc.toDuration(n)(e)), c(!1);
				return;
			}
			i(e), c(!1);
		}, [
			i,
			t,
			n
		]),
		handleDurationPickerSelection: G((e) => {
			if (t === "absolute") {
				i(Qc.toDate(n)(e)), u(!1);
				return;
			}
			i(e), u(!1);
		}, [
			i,
			t,
			n
		]),
		handleInputSelection: g,
		handleInputKeydown: G((e) => {
			[
				"ArrowUp",
				"ArrowDown",
				"ArrowLeft",
				"ArrowRight"
			].includes(e.key) && e.stopPropagation();
		}, []),
		datePickerPopoverOpen: s,
		durationPickerPopoverOpen: l,
		closePopover: G(() => {
			u(!1), c(!1);
		}, []),
		selectedOption: f,
		availableOptions: p,
		selectedDate: q(() => {
			if (!(!n || !f || f === "FOREVER")) return t === "absolute" ? e : Qc.toDate(n)(e);
		}, [
			n,
			f,
			t,
			e
		]),
		selectedDuration: q(() => {
			if (!(!n || !f || f === "FOREVER")) return t === "absolute" ? Qc.toDuration(n)(e) : e;
		}, [
			n,
			f,
			t,
			e
		]),
		refs: {
			input: m,
			popover: h
		}
	};
}, B_ = (e, t = {}) => {
	let { height: n = 300, viewportPadding: r = 20 } = t, i = e.getBoundingClientRect(), a = window.innerHeight - i.bottom - r, o = i.top - r;
	return a >= n ? "bottom-start" : o > a ? "top-start" : "bottom-start";
}, V_ = (e = {}) => {
	let t = J(null), [n, r] = Y("bottom-start"), i = G(() => t.current ? B_(t.current, e) : "bottom-start", [e]);
	return {
		triggerRef: t,
		placement: n,
		recalculatePlacement: G(() => {
			let e = i();
			return r(e), e;
		}, [i])
	};
}, H_ = {
	isLazy: !0,
	placement: "bottom-start",
	setPlacement: () => {
		console.warn("ControlContextProvider not found, setPlacement not implemented");
	},
	menuHeight: 300,
	menuWidth: 300,
	maxWidth: void 0,
	minWidth: 250,
	matchWidth: !1,
	showAllOptions: !1,
	showSearchInPopover: !0,
	searchTerm: "",
	isOpen: !1,
	setSearchTerm: () => {
		console.warn("ControlContextProvider not found, setSearchTerm not implemented");
	},
	setIsOpen: () => {
		console.warn("ControlContextProvider not found, setIsOpen not implemented");
	}
}, U_ = fc(H_), W_ = () => _c(U_), G_ = ({ children: e, ...t }) => {
	let [n, r] = Y(""), [i, a] = Y(t.isOpen ?? !1), [o, s] = Y(t.placement ?? H_.placement);
	return /* @__PURE__ */ U(U_.Provider, {
		value: {
			...H_,
			...t,
			placement: o,
			setPlacement: s,
			searchTerm: n,
			setSearchTerm: r,
			isOpen: i,
			setIsOpen: a
		},
		children: e
	});
}, K_ = ({ trigger: e, menuItems: t, closeOnSelect: n = !0, onCreate: r, onToggle: i, createLabel: a = "New", disabled: o = !1, style: s, "data-testid": c, autoSelect: l, openOnMount: u }) => {
	let d = Kc(), f = W_();
	return K(() => {
		i && i(d.isOpen);
	}, [d.isOpen, i]), K(() => {
		u && d.onOpen();
	}, [u, d.onOpen]), /* @__PURE__ */ W(ii, {
		computePositionOnMount: !0,
		variant: "component-library",
		closeOnSelect: n,
		isOpen: d.isOpen,
		onOpen: d.onOpen,
		onClose: d.onClose,
		isLazy: f.isLazy,
		placement: f.placement,
		strategy: "fixed",
		matchWidth: !0,
		autoSelect: l,
		children: [/* @__PURE__ */ U(ai, {
			type: "button",
			style: s,
			sx: { "& > span": { pointerEvents: "all" } },
			disabled: o,
			cursor: o ? "default" : "pointer",
			children: e
		}), /* @__PURE__ */ W(ci, {
			maxWidth: `${f.menuWidth}px`,
			minWidth: `${f.menuWidth}px`,
			children: [/* @__PURE__ */ U(R, {
				maxHeight: `${f.menuHeight}px`,
				width: "100%",
				overflowY: "auto",
				overflowX: "hidden",
				style: { contentVisibility: "auto" },
				"data-testid": c,
				children: t
			}), r && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(J_, {}), /* @__PURE__ */ U(q_, {
				onClick: r,
				children: a
			})] })]
		})]
	});
}, q_ = ({ onClick: e, children: t }) => /* @__PURE__ */ W(si, {
	as: "div",
	onClick: e,
	fontWeight: "bold",
	children: [/* @__PURE__ */ U(dh, {}), t]
}), J_ = (e) => /* @__PURE__ */ U(Rr, {
	variant: "component-library",
	position: "relative",
	left: "-4px",
	width: "calc(100% + 8px)",
	my: 1,
	...e
}), Y_ = Zc(/* @__PURE__ */ new Date(), { months: -12 }), X_ = Zc(/* @__PURE__ */ new Date(), { months: 12 }), Z_ = ({ trigger: e, minDate: t, maxDate: n, value: r = /* @__PURE__ */ new Date(), disabled: i = !1, onChange: a, onToggle: o, autoSelect: s = !1, openOnMount: c = !1, popoverTestId: l }) => {
	let [u, d] = Y(r);
	return K(() => {
		d(r);
	}, [r]), /* @__PURE__ */ U(K_, {
		disabled: i,
		trigger: e,
		onToggle: o,
		autoSelect: s,
		openOnMount: c,
		menuItems: /* @__PURE__ */ U(si, {
			background: "none",
			_hover: { background: "none" },
			_focus: { background: "none" },
			_active: { background: "none" },
			children: /* @__PURE__ */ U(L_, {
				selectedDate: u,
				minDate: t === null ? void 0 : t ?? Y_,
				maxDate: n === null ? void 0 : n ?? X_,
				onDateSelected: (e) => {
					d(e), a(e);
				},
				"data-testid": l
			})
		})
	});
}, Q_ = Yi(({ value: e, onChange: t, placeholder: n, showDivider: r = !1, marginBottom: i = void 0, paddingTop: a = "4px", paddingBottom: o = "4px", paddingLeft: s = "8px", isLoading: c, onKeyDown: l, disableFocusLock: u = !1, hideSearchIcon: d = !1, stickyTop: f = "0", "data-testid": p }, m) => {
	let h = /* @__PURE__ */ W(B, {
		alignItems: "center",
		justifyContent: "center",
		gap: "8px",
		width: "100%",
		paddingLeft: s,
		paddingRight: "8px",
		py: "6px",
		children: [
			!d && /* @__PURE__ */ U(Km, { color: "currentColor" }),
			/* @__PURE__ */ U($r, {
				ref: m,
				autoComplete: "off",
				variant: "unstyled",
				placeholder: n,
				flex: "1",
				minWidth: "0",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				...N,
				color: L,
				_placeholder: { color: k },
				spellCheck: !1,
				value: e,
				onChange: (e) => t(e.target.value),
				onKeyDown: l,
				autoFocus: !0,
				"data-1p-ignore": !0,
				borderRadius: 0,
				"data-testid": p
			}),
			c && /* @__PURE__ */ U(z, {
				boxSize: "16px",
				children: /* @__PURE__ */ U(ki, {
					boxSize: "16px",
					color: "#94a3b8"
				})
			})
		]
	});
	return /* @__PURE__ */ W(B, {
		paddingTop: a,
		paddingBottom: o,
		position: "sticky",
		top: f,
		left: "0",
		background: I,
		zIndex: "1",
		marginBottom: i,
		color: L,
		children: [u ? h : /* @__PURE__ */ U(Ur, { children: h }), r && /* @__PURE__ */ U(Rr, {
			position: "absolute",
			bottom: "0",
			left: "-4px",
			width: "calc(100% + 8px)",
			borderColor: "#e2e8f0"
		})]
	});
}), $_ = (e) => /* @__PURE__ */ U(Ei, {
	height: e.height ?? "100%",
	width: e.width ?? "100%",
	minHeight: e.minHeight,
	minWidth: e.minWidth,
	borderRadius: e.borderRadius ?? "8px",
	margin: e.margin,
	marginLeft: e.marginLeft,
	marginRight: e.marginRight,
	marginTop: e.marginTop,
	marginBottom: e.marginBottom,
	backgroundColor: Fn,
	endColor: Fn,
	startColor: rr,
	opacity: "unset"
}), ev = ({ option: e, isSelected: t, isFocused: n, isDisabled: r = !1, onSelect: i, variant: a = "default", scrollIntoView: o = !0, size: s = "default", minHeight: c, minWidth: l, paddingX: u, paddingY: d, "data-testid": f, children: p }) => {
	let m = J(null);
	K(() => {
		o && (n || t) && m.current?.scrollIntoView({ block: "center" });
	}, [
		o,
		n,
		t
	]);
	let h = !r && (a === "checkbox" ? n : t || n), g = r ? .4 : 1, _ = X(s).with("small", () => ({
		padding: 1,
		minHeight: "24px"
	})).with("default", () => ({
		padding: 2,
		minHeight: "32px"
	})).exhaustive(), v = /* @__PURE__ */ W(B, {
		ref: m,
		"data-testid": f,
		onMouseDown: (e) => e.preventDefault(),
		onClick: r ? () => {} : i,
		background: h ? Fn : void 0,
		borderRadius: 6,
		_hover: { background: r ? "none" : Fn },
		padding: _.padding,
		paddingX: u,
		paddingY: d,
		cursor: "pointer",
		gap: "4px",
		alignItems: "center",
		maxWidth: "100%",
		minHeight: c ?? _.minHeight,
		minWidth: l,
		role: "group",
		"aria-disabled": r ? "true" : "false",
		marginX: 1,
		_disabled: {
			background: "none",
			cursor: "not-allowed"
		},
		children: [
			a === "checkbox" && /* @__PURE__ */ U(Pr, {
				isChecked: t,
				opacity: g,
				pointerEvents: "none",
				marginRight: "4px"
			}),
			e.icon && /* @__PURE__ */ U(B, {
				shrink: 0,
				grow: 0,
				opacity: g,
				children: e.icon
			}),
			p,
			r && e.disabledReason && /* @__PURE__ */ U(B, {
				shrink: 0,
				color: "#64748b",
				alignItems: "center",
				"data-testid": f ? `${f}.disabledReason` : void 0,
				children: /* @__PURE__ */ U(em, {})
			}),
			a === "default" && t && /* @__PURE__ */ U(B, {
				shrink: 0,
				opacity: g,
				"data-testid": f ? `${f}.selected` : void 0,
				children: /* @__PURE__ */ U(zp, {})
			})
		]
	});
	return /* @__PURE__ */ W(H, { children: [r && e.disabledReason ? /* @__PURE__ */ U(m_, {
		label: e.disabledReason,
		placement: "right",
		shouldWrapChildren: !1,
		"data-testid": f ? `${f}.disabledReason.tooltip` : void 0,
		children: v
	}) : v, e.dividerAfter && /* @__PURE__ */ U(Rr, {
		marginTop: 0,
		variant: "component-library"
	})] });
}, tv = ({ children: e, truncate: t = !1, size: n = "default", "data-testid": r }) => /* @__PURE__ */ U(V, {
	as: "span",
	"data-testid": r ? `${r}.label` : void 0,
	...rv(n),
	...t ? {
		width: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	} : {},
	children: e
}), nv = ({ children: e, size: t = "default", "data-testid": n }) => /* @__PURE__ */ U(V, {
	as: "span",
	"data-testid": n ? `${n}.secondaryLabel` : void 0,
	...rv(t),
	color: k,
	children: e
}), rv = (e) => X(e).with("small", () => tr).with("default", () => N).exhaustive(), iv = Object.assign((e) => {
	let { option: t, isDisabled: n = !1, indented: r = !1, isLoading: i = !1, "data-testid": a, justifyLabels: o = "initial", size: s = "default" } = e, c = n ? .4 : 1;
	return /* @__PURE__ */ U(ev, {
		...e,
		children: /* @__PURE__ */ U(B, {
			opacity: c,
			ml: r ? 2 : 0,
			grow: 1,
			shrink: 1,
			overflow: "hidden",
			textOverflow: "ellipsis",
			gap: 2,
			alignItems: "flex-start",
			children: i ? /* @__PURE__ */ U($_, {
				height: "16px",
				width: "90%",
				"data-testid": a ? `${a}.loading` : void 0,
				marginLeft: "4px"
			}) : /* @__PURE__ */ W(B, {
				width: "100%",
				textAlign: "left",
				flexWrap: "wrap",
				columnGap: "6px",
				justifyContent: o,
				children: [/* @__PURE__ */ U(tv, {
					"data-testid": a,
					size: s,
					truncate: !t.secondaryLabel,
					children: t.label
				}), /* @__PURE__ */ U(nv, {
					"data-testid": a,
					size: s,
					children: t.secondaryLabel
				})]
			})
		})
	});
}, {
	Container: ev,
	Label: tv,
	SecondaryLabel: nv
}), av = "data-searchable-list-popover", ov = { [av]: "" }, sv = ({ onClick: e, children: t, color: n, disabled: r = !1, isFocused: i = !1, "data-testid": a, ...o }) => {
	let s = i && !r;
	return /* @__PURE__ */ W(B, {
		...o,
		"data-testid": a,
		onMouseDown: (e) => e.preventDefault(),
		onClick: r ? void 0 : e,
		"aria-disabled": r,
		color: r ? en : n,
		background: s ? Fn : void 0,
		...N,
		fontWeight: "bold",
		borderRadius: 6,
		_hover: r ? void 0 : { background: Fn },
		padding: 2,
		maxHeight: "32px",
		cursor: r ? "not-allowed" : "pointer",
		alignItems: "center",
		m: 1,
		children: [/* @__PURE__ */ U(B, {
			shrink: 0,
			marginRight: 2,
			children: /* @__PURE__ */ U(dh, {})
		}), t]
	});
}, cv = ({ trigger: e, triggerRef: t, children: n, placeholder: r, initialFocusRef: i, searchTerm: a, setSearchTerm: o, disabled: s = !1, onToggle: c, onCreate: l, createLabel: u, searchInputPaddingLeft: d, isCreateDisabled: f, isCreateFocused: p = !1, onScrollEnd: m, isLoadingMore: h = !1, "data-testid": g }) => {
	let _ = f?.(a) ?? !1, v = W_(), y = J(null), { setIsOpen: b, isOpen: x } = v, [S, { rootRef: C }] = wl({
		loading: h,
		hasNextPage: !!m,
		onLoadMore: m ?? (() => {}),
		rootMargin: "0px 0px 50px 0px"
	});
	Jc({
		ref: y,
		handler: G((e) => {
			x && (e.composedPath().some((e) => e instanceof HTMLElement && e !== y.current && e.hasAttribute(av)) || (b(!1), c?.(!1)));
		}, [
			x,
			b,
			c
		])
	});
	let w = v.showSearchInPopover && !!o;
	return /* @__PURE__ */ W(mi, {
		placement: v.placement,
		initialFocusRef: i,
		isOpen: !s && v.isOpen,
		isLazy: v.isLazy,
		onOpen: () => {
			s || c?.(!0);
		},
		onClose: () => {
			s || c?.(!1);
		},
		computePositionOnMount: !0,
		matchWidth: v.matchWidth,
		children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(B, {
			ref: t,
			onClick: () => b(!x),
			onKeyDown: (e) => {
				if (!x && [
					"ArrowUp",
					"ArrowDown",
					"Enter"
				].includes(e.key)) {
					b(!0);
					return;
				}
				if (e.key === "Enter") {
					b(!1), e.stopPropagation();
					return;
				}
				if (e.key === "Escape") {
					b(!1), e.stopPropagation();
					return;
				}
				if (e.key === "Tab") {
					b(!1), e.stopPropagation();
					return;
				}
			},
			cursor: s ? "default" : "pointer",
			height: "fit-content",
			children: e
		}) }), v.isOpen && /* @__PURE__ */ U(Si, { children: (v.showSearchInPopover || n || l || h) && /* @__PURE__ */ W(vi, {
			opacity: !n && !l && !v.showSearchInPopover && !h ? 0 : 1,
			minWidth: v.matchWidth ? void 0 : v.minWidth,
			width: "inherit",
			maxHeight: v.showAllOptions ? void 0 : v.menuHeight,
			maxWidth: v.maxWidth,
			overflowX: "hidden",
			style: { contentVisibility: "auto" },
			borderRadius: 8,
			paddingTop: 0,
			fontSize: "13px",
			ref: y,
			"data-testid": g,
			...ov,
			children: [
				w && /* @__PURE__ */ U(Q_, {
					ref: i,
					value: a,
					onChange: (e) => o(e),
					showDivider: !!n || h,
					placeholder: r,
					paddingLeft: d,
					"data-testid": g ? `${g}.search` : void 0
				}),
				(n || h) && /* @__PURE__ */ W(B, {
					ref: C,
					overflowY: "auto",
					paddingY: 1,
					gap: 1,
					direction: "column",
					children: [n, (h || m) && /* @__PURE__ */ U("div", {
						ref: S,
						children: h && /* @__PURE__ */ U(z, {
							padding: 2,
							children: /* @__PURE__ */ U(ki, {
								size: "sm",
								color: "#475569"
							})
						})
					})]
				}),
				l && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Rr, {
					marginTop: 0,
					variant: "component-library"
				}), /* @__PURE__ */ U(sv, {
					"data-testid": g ? `${g}.create` : void 0,
					disabled: !!_,
					isFocused: p,
					onClick: () => {
						l(), b(!1);
					},
					children: u
				})] })
			]
		}) })]
	});
}, lv = "create", uv = (e, t, n, r, i = !1) => {
	let [a, o] = Y(null), s = !!r && !i, c = e.length + +!!s, l = a === lv ? null : a, u = a === lv, d = J(a);
	d.current = a;
	let f = G((e) => {
		o(e);
	}, []);
	return K(() => {
		l && !e.includes(l) && o(null);
	}, [e, l]), K(() => {
		u && !s && o(null);
	}, [u, s]), {
		handleKeyDown: G((i) => {
			if (i.key === "Escape") {
				i.stopPropagation(), i.preventDefault(), n?.();
				return;
			}
			if (c === 0) return;
			let a = s ? e.length : -1, l = (t) => t === lv ? a : t ? e.indexOf(t) : -1, u = (t) => t === a ? lv : e[t] ?? null;
			switch (i.key) {
				case "ArrowDown":
					i.preventDefault(), o((e) => {
						let t = l(e);
						return u(t === -1 ? 0 : (t + 1) % c);
					});
					break;
				case "ArrowUp":
					i.preventDefault(), o((e) => {
						let t = l(e);
						return u(t === -1 ? c - 1 : (t - 1 + c) % c);
					});
					break;
				case "Enter": {
					i.stopPropagation(), i.preventDefault();
					let e = d.current;
					e === lv && s ? r?.() : e && e !== lv && t(e);
					break;
				}
			}
		}, [
			e,
			c,
			s,
			t,
			n,
			r
		]),
		setFocusedOption: f,
		focusedOption: l,
		isCreateFocused: u
	};
}, dv = (e) => Array.isArray(e) ? e.join("") : e, fv = (e) => {
	let { fontWeight: t, fontSize: n, fontFamily: r } = window.getComputedStyle(e);
	return `${t} ${n} ${r}`;
}, pv = (e, t, n) => {
	let r = 0, i = e.length;
	for (; r < i;) {
		let a = Math.ceil((r + i) / 2);
		n.measureText(e.slice(-a)).width <= t ? r = a : i = a - 1;
	}
	return r;
}, mv = ({ children: e, splitPercentage: t = 70, showTooltipOnOverflow: n = !0, textAlign: r }) => {
	let i = J(null), [a, o] = Y(!1), [s, c] = Y(""), l = dv(e);
	return yc(() => {
		let e = i.current;
		if (!e) return;
		let n = document.createElement("canvas").getContext("2d");
		n.font = fv(e);
		let r = n.measureText(l).width, a = e.clientWidth;
		if (r <= a + 2) {
			o(!1), c("");
			return;
		}
		o(!0);
		let s = a * (100 - t) / 100, u = pv(l, s, n);
		c(u > 0 ? l.slice(-u) : "");
	}, [l, t]), /* @__PURE__ */ U(m_, {
		label: a ? l : "",
		isDisabled: !n || !a,
		shouldWrapChildren: !1,
		containerRef: i,
		children: /* @__PURE__ */ W("div", {
			ref: i,
			style: {
				overflow: "hidden",
				whiteSpace: "nowrap",
				display: "flex",
				textAlign: r
			},
			children: [/* @__PURE__ */ U("div", {
				style: {
					flex: a ? t : 1,
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap"
				},
				children: e
			}), a && /* @__PURE__ */ U("div", {
				"aria-hidden": !0,
				style: {
					flex: 100 - t,
					whiteSpace: "nowrap"
				},
				children: s
			})]
		})
	});
}, hv = ({ label: e, hasSelection: t, isInvalid: n = !1, disabled: r = !1, isLoading: i = !1, "data-testid": a }) => {
	let { isOpen: o } = W_();
	return /* @__PURE__ */ U(Q, {
		"data-testid": a,
		variant: "secondary",
		fullWidth: !0,
		disabled: r,
		style: {
			justifyContent: "flex-start",
			...n ? { borderColor: Un } : {}
		},
		trailingIcon: U(o ? Xp : Up, { color: k }),
		children: i ? /* @__PURE__ */ U(R, {
			flex: "1",
			textAlign: "left",
			children: /* @__PURE__ */ U($_, {
				width: "120px",
				height: "16px",
				borderRadius: "4px"
			})
		}) : /* @__PURE__ */ U(R, {
			...N,
			flex: "1",
			minWidth: 0,
			color: t ? L : en,
			children: /* @__PURE__ */ U(mv, {
				splitPercentage: 100,
				textAlign: "left",
				children: e
			})
		})
	});
}, gv = ({ options: e, values: t, entityName: n, emptyLabel: r }) => {
	if (t.length === 0) return r;
	let i = `${t.length} ${wc(n, t.length)}`;
	if (t.length > 1) return i;
	let a = t.at(0);
	return e.find((e) => e.value === a)?.label || i;
}, _v = (e) => `Select ${wc(e, 2)}...`, vv = (e) => {
	let { trigger: t, options: n, entityName: r, emptyLabel: i, isInvalid: a = !1, placeholder: o, filterOptions: s = yv, MenuItemComponent: c = iv, onChange: l, onToggle: u, onCreate: d, createLabel: f, disabled: p = !1, "data-testid": m } = e, h = "initialValues" in e ? e.initialValues : void 0, g = "values" in e ? e.values : void 0, _ = g !== void 0, v = J(!1), { searchTerm: y, setSearchTerm: b, isOpen: x, setIsOpen: S } = W_(), [C, w] = Y(h ?? []), T = J(null), E = g ?? C, D = (e) => E.includes(e.value), ee = Cl((e) => D(e)), te = (e) => {
		if (_) {
			l(e);
			return;
		}
		w(e);
	}, O = (e) => {
		te(E.filter((t) => t !== e.value));
	}, ne = (e) => {
		te([...E, e.value]);
	}, [re, ie] = Y(0);
	K(() => {
		x && ie((e) => e + 1);
	}, [x]);
	let [ae, oe] = q(() => ee(n), [re]), se = q(() => s(oe, y), [
		oe,
		y,
		s
	]);
	K(() => {
		_ || !v.current || (v.current = !1, w((e) => {
			let t = e.filter((e) => n.map((e) => e.value).includes(e)), r = Tl(h || [], t);
			return [...t, ...r];
		}));
	}, [JSON.stringify(n), re]), K(() => {
		if (!_) {
			if (!v.current) {
				v.current = !0;
				return;
			}
			l(C);
		}
	}, [C]);
	let { handleKeyDown: ce, focusedOption: le } = uv(se, ne, () => S(!1));
	K(() => {
		let e = T?.current;
		return e?.addEventListener("keydown", ce, !1), () => {
			e?.removeEventListener("keydown", ce, !1);
		};
	}, [ce, x]);
	let ue = r ? /* @__PURE__ */ U(hv, {
		label: gv({
			options: n,
			values: E,
			entityName: r,
			emptyLabel: i ?? _v(r)
		}),
		hasSelection: E.length > 0,
		isInvalid: a,
		disabled: p,
		"data-testid": m ? `${m}.trigger` : void 0
	}) : null;
	return /* @__PURE__ */ U(cv, {
		trigger: t ?? ue,
		placeholder: o,
		initialFocusRef: T,
		searchTerm: y,
		setSearchTerm: b,
		disabled: p,
		onToggle: u,
		onCreate: d,
		createLabel: f,
		searchInputPaddingLeft: "12px",
		"data-testid": m,
		children: !ae.length && !se.length ? null : /* @__PURE__ */ W(H, { children: [
			ae.map((e) => /* @__PURE__ */ U(c, {
				option: e,
				isSelected: D(e),
				isFocused: !1,
				onSelect: () => {
					D(e) ? O(e) : ne(e);
				},
				variant: "checkbox",
				scrollIntoView: !1,
				"data-testid": m ? `${m}.option.${e.value}` : void 0
			}, e.value)),
			!!ae.length && !!se.length && /* @__PURE__ */ U(Rr, {
				variant: "component-library",
				marginY: 0
			}),
			se.map((e) => /* @__PURE__ */ U(c, {
				option: e,
				isSelected: D(e),
				variant: "checkbox",
				isFocused: le === e,
				onSelect: () => D(e) ? O(e) : ne(e),
				scrollIntoView: !D(e),
				isDisabled: e.disabled,
				"data-testid": m ? `${m}.option.${e.value}` : void 0
			}, e.value))
		] })
	});
};
function yv(e, t) {
	return e.filter((e) => e.label.toLowerCase().includes(t.toLowerCase()));
}
//#endregion
//#region src/components/Control/core/SelectControl.tsx
var bv = ({ trigger: e, onChange: t, onCreate: n, onToggle: r, options: i, filterOptionGroups: a = Sv, MenuItemComponent: o = iv, initialValue: s = null, placeholder: c, createLabel: l, isCreateDisabled: u, disabled: d = !1, name: f, externalFocusRef: p, emptyState: m = null, noResultsState: h = null, onScrollEnd: g, isLoadingMore: _, "data-testid": v, justifyLabels: y = "initial", enableSmartPlacement: b = !0 }) => {
	let x = W_(), { triggerRef: S, recalculatePlacement: C } = V_({ height: x.menuHeight }), [w, T] = Y(s), E = J(null), D = !x.showSearchInPopover && p ? p : E, ee = (e) => {
		T(e.value), t(e.value), x.setIsOpen(!1);
	}, te = (e) => {
		if (e && C && b) {
			let e = C();
			x.setPlacement(e);
		}
		r?.(e);
	}, O = q(() => wv(i), [i]), ne = q(() => a ? a(O, x.searchTerm) : O, [
		O,
		a,
		x.searchTerm
	]), re = q(() => El(ne.map((e) => e.options)), [ne]), { handleKeyDown: ie, setFocusedOption: ae, focusedOption: oe, isCreateFocused: se } = uv(re, ee, () => x.setIsOpen(!1), n ? () => {
		n(), x.setIsOpen(!1);
	} : void 0, u?.(x.searchTerm) ?? !1);
	K(() => {
		let e = D?.current;
		return e?.addEventListener("keydown", ie, !1), () => {
			e?.removeEventListener("keydown", ie, !1);
		};
	}, [
		D,
		ie,
		x.isOpen
	]), K(() => {
		let e = D?.current;
		e && (oe || se ? e.dataset.hasFocusedOption = "true" : delete e.dataset.hasFocusedOption);
	}, [
		D,
		oe,
		se
	]), K(() => {
		T(s), ae(re.find((e) => e.value === s) ?? null);
	}, [
		s,
		re,
		ae
	]);
	let ce = q(() => O.length === 0, [O]), le = q(() => x.searchTerm !== "" && ne.every((e) => e.options.length === 0 && !e.emptyState), [x.searchTerm, ne]), ue = q(() => ce ? "empty" : le ? "noResults" : "default", [ce, le]);
	return /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(cv, {
		trigger: e,
		triggerRef: S,
		placeholder: c,
		initialFocusRef: D,
		searchTerm: x.searchTerm,
		setSearchTerm: a ? x.setSearchTerm : void 0,
		disabled: d,
		onToggle: te,
		onCreate: n,
		createLabel: l,
		isCreateDisabled: u,
		isCreateFocused: se,
		"data-testid": v ? `${v}.listbox` : void 0,
		onScrollEnd: g,
		isLoadingMore: _,
		children: X(ue).with("empty", () => m).with("noResults", () => h).otherwise(() => ne.map((e) => /* @__PURE__ */ U(xv, {
			optionGroup: e,
			selectOption: ee,
			focusedOption: oe,
			selectedOptionValue: w,
			baseDataTestId: v,
			MenuItemComponent: o,
			justifyLabels: y
		}, e.key ?? e.label)))
	}), /* @__PURE__ */ U("input", {
		name: f,
		type: "hidden",
		value: w ?? ""
	})] });
}, xv = ({ optionGroup: { label: e, options: t, emptyState: n }, MenuItemComponent: r, focusedOption: i, selectedOptionValue: a, selectOption: o, baseDataTestId: s, justifyLabels: c = "initial" }) => !t.length && !n ? null : /* @__PURE__ */ W("div", { children: [e && /* @__PURE__ */ U(R, {
	borderRadius: 6,
	padding: 2,
	maxWidth: "100%",
	marginX: 1,
	color: "#1e293b",
	...j,
	children: e
}), t.length ? /* @__PURE__ */ U(B, {
	gap: 1,
	direction: "column",
	children: t.map((t) => /* @__PURE__ */ U(r, {
		option: t,
		isSelected: a == t.value,
		isFocused: i === t,
		isDisabled: t.disabled ?? !1,
		onSelect: () => o(t),
		indented: e != null,
		"data-testid": s ? `${s}.option.${t.value}` : `select.option.${t.value}`,
		justifyLabels: c
	}, t.value))
}) : n] });
function Sv(e, t) {
	return e.reduce((e, n) => {
		if (n.label?.toLowerCase().includes(t.toLowerCase())) return [...e, n];
		let r = {
			...n,
			options: n.options.filter((e) => e.label.toLowerCase().includes(t.toLowerCase()))
		};
		return r.options.length ? [...e, r] : e;
	}, []);
}
function Cv(e, t) {
	return e.reduce((e, n) => n.label?.toLowerCase().includes(t.toLowerCase()) ? [...e, n] : e, []);
}
function wv(e) {
	return Tv(e) || e.length === 0 ? e : [{
		label: null,
		options: e
	}];
}
function Tv(e) {
	return e.length > 0 && "options" in e[0];
}
//#endregion
//#region src/components/Control/ControlEmptyState.tsx
var Ev = ({ title: e, content: t, button: n }) => /* @__PURE__ */ W(B, {
	justifyContent: "center",
	flexDirection: "column",
	gap: 1,
	background: I,
	p: 2,
	children: [
		/* @__PURE__ */ U(V, {
			...j,
			textAlign: "center",
			children: e
		}),
		/* @__PURE__ */ U(V, {
			...N,
			textAlign: "center",
			children: t
		}),
		n && /* @__PURE__ */ U(Q, {
			leadingIcon: /* @__PURE__ */ U(dh, {}),
			style: {
				flex: 0,
				marginTop: "4px"
			},
			onClick: n.onClick,
			"data-testid": `control-empty-state-button-${n.text.toLowerCase().replaceAll(" ", "-")}`,
			children: n.text
		})
	]
}), Dv = ({ selectedDays: e, onDaysSelected: t, "data-testid": n }) => {
	let [r, i] = Y(String(e));
	function a(e) {
		let t = Zc(/* @__PURE__ */ new Date(), { days: e }), n = nl(t, "EEE"), r = t.getDate(), i = nl(t, "MMM"), a = [
			"th",
			"st",
			"nd",
			"rd"
		], o = r % 100;
		return `(${n}, ${r}${a[(o - 20) % 10] || a[o] || a[0]} ${i})`;
	}
	let o = (e) => {
		e.key === "Enter" && (e.preventDefault(), t(Math.max(parseInt(r) || 1, 1)));
	}, s = (e) => {
		if (parseInt(e) <= 0) {
			i("1");
			return;
		}
		i(e);
	}, c = () => {
		let e = Math.max(parseInt(r) || 1, 1);
		i(String(e)), t(e);
	};
	return /* @__PURE__ */ W(B, {
		gap: "8px",
		...N,
		color: Ft,
		alignItems: "center",
		width: "200px",
		children: [/* @__PURE__ */ U(Lg, {
			autoFocus: !0,
			type: "number",
			"data-testid": n,
			height: "32px",
			width: "56px",
			value: r,
			min: "1",
			onChange: s,
			onBlur: c,
			onKeyDown: o
		}), /* @__PURE__ */ W("span", {
			style: { whiteSpace: "nowrap" },
			children: [
				wc("day", parseInt(r) || 1),
				" ",
				a(parseInt(r) || 1)
			]
		})]
	});
}, Ov = ({ label: e, date: t, isFocused: n, onFocus: r, dateFormat: i = "d MMM yyyy" }) => /* @__PURE__ */ U(Qy, {
	label: e,
	suffix: /* @__PURE__ */ U(Np, {}),
	value: t ? Dc(t.toISOString(), i) : void 0,
	placeholder: "Select end date",
	onFocus: r || void 0,
	borderColor: n ? C : M,
	styles: {
		label: { ...j },
		wrapper: { marginBottom: "0px" }
	}
}), kv = ({ defaultDates: e, onChange: t }) => {
	let [n, r] = Y(e ?? [/* @__PURE__ */ new Date(), void 0]), [i, a] = Y(e?.[0] ?? /* @__PURE__ */ new Date());
	K(() => {
		e && e.length === 2 && (e[0] !== n[0] || e[1] !== n[1]) && r(e);
	}, [e]);
	let [o, s] = Y("start"), [c, l] = Y(0), u = (e) => {
		t?.(e);
	}, { calendars: d, ...f } = vl({
		selected: n.filter(Boolean).map(C_.toDayzed),
		onDateSelected: ({ selectable: e, date: t }) => {
			if (!e) return;
			let i = C_.fromDayzed(t), c = d.map((e) => e.month);
			o === "start" && (n[1] && i > n[1] ? (r([i, void 0]), u([i, void 0])) : (r([i, n[1]]), u([i, n[1]])), s("end"), a(i), al(i) === c[1] ? l(-1) : l(0)), o === "end" && (r([n[0], i]), u([n[0], i]), s("start"));
		},
		minDate: o === "start" ? void 0 : n[0] && C_.toDayzed(n[0]),
		offset: c,
		onOffsetChanged: (e) => {
			l(e);
		},
		monthsToDisplay: 2,
		firstDayOfWeek: 1,
		date: i
	}), p = bl(n[0]) && bl(n[1]);
	return {
		selectedDates: [n[0], n[1]],
		focusedInput: o,
		setFocusedInput: s,
		calendars: d,
		dayzedProps: f,
		isComplete: p,
		getSelectedRange: () => bl(n[0]) && bl(n[1]) ? [n[0], n[1]] : void 0
	};
}, Av = ({ defaultDates: e, onChange: t, onSubmit: n, onCancel: r, showFooter: i = !0, "data-testid": a }) => {
	let { selectedDates: o, focusedInput: s, setFocusedInput: c, calendars: l, dayzedProps: u, isComplete: d, getSelectedRange: f } = kv({
		defaultDates: e,
		onChange: t
	});
	return /* @__PURE__ */ W(R, {
		"data-testid": a,
		children: [
			/* @__PURE__ */ W(Ai, {
				gap: 2,
				direction: "row",
				padding: 2,
				children: [/* @__PURE__ */ U(R, {
					width: "100%",
					borderRadius: "6px",
					backgroundColor: A,
					padding: "8px",
					children: /* @__PURE__ */ U(Ov, {
						label: "Start date",
						date: o[0],
						isFocused: s === "start",
						onFocus: () => c("start")
					})
				}), /* @__PURE__ */ U(R, {
					width: "100%",
					borderRadius: "6px",
					backgroundColor: A,
					padding: "8px",
					children: /* @__PURE__ */ U(Ov, {
						label: "End date",
						date: o[1],
						isFocused: s === "end",
						onFocus: () => c("end")
					})
				})]
			}),
			/* @__PURE__ */ U(Ai, {
				gap: 4,
				direction: "row",
				padding: 2,
				pt: 0,
				children: l.map((e, t) => /* @__PURE__ */ U(B, {
					height: "320px",
					children: /* @__PURE__ */ U(k_, {
						...u,
						calendar: e,
						type: "range",
						focusedInput: s,
						selectedDates: [o[0], o[1]]
					})
				}, t))
			}),
			i && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Rr, { color: Cn }), /* @__PURE__ */ W(B, {
				justifyContent: "flex-end",
				gap: "4px",
				p: 2,
				children: [r && /* @__PURE__ */ U(Q, {
					variant: "secondary",
					onClick: r,
					"data-testid": "dateRangePicker.cancel",
					children: "Cancel"
				}), /* @__PURE__ */ U(Q, {
					"data-testid": "dateRangePicker.submit",
					onClick: () => {
						let e = f();
						e && n?.(e);
					},
					disabled: !d,
					children: "Done"
				})]
			})] })
		]
	});
}, jv = (e) => /* @__PURE__ */ U(B, {
	gap: 2,
	style: e.styleWrapper,
	children: /* @__PURE__ */ U(mi, {
		placement: e.popoverPlacement ?? "bottom",
		onClose: () => {
			e.onClose?.(), e.onOpenChange?.(!1);
		},
		isOpen: e.isOpen,
		onOpen: () => e.onOpenChange?.(!0),
		children: ({ isOpen: t, onClose: n }) => /* @__PURE__ */ W(H, { children: [e.isDisabled ? e.children : /* @__PURE__ */ U(hi, { children: /* @__PURE__ */ U(bi, { children: e.children }) }), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ W(vi, {
			zIndex: "50",
			width: "100%",
			boxShadow: Ht,
			borderRadius: 6,
			"data-testid": e["data-testid"],
			children: [/* @__PURE__ */ U(gi, {}), /* @__PURE__ */ U(_i, {
				p: 0,
				zIndex: "2",
				children: /* @__PURE__ */ U(Av, {
					defaultDates: e.defaultDates,
					onChange: e.onChange,
					onCancel: n,
					onSubmit: (t) => {
						e.onSubmit?.(t), n();
					}
				}, String(t))
			})]
		}) })] })
	})
});
//#endregion
//#region src/components/Control/hooks/useSelectedOption.ts
function Mv(e, t) {
	let n = q(() => wv(e), [e]), r = q(() => n.flatMap((e) => e.options), [n]);
	return q(() => r.find((e) => e.value === t), [r, t]);
}
//#endregion
//#region src/components/Control/InputSelectControl.tsx
var Nv = "24px", Pv = 16, Fv = "120px", Iv = "2px", Lv = "16px", Rv = (e) => /* @__PURE__ */ U(iv, {
	...e,
	size: "small"
}), zv = ({ matchWidth: e, menuWidth: t, initiallyOpen: n, showAllOptions: r, ...i }) => {
	let a = i.variant === "small" ? "small" : "default", o = X(a).with("small", () => ({
		matchWidth: !1,
		minWidth: Fv
	})).with("default", () => ({
		matchWidth: !0,
		minWidth: void 0
	})).exhaustive();
	return /* @__PURE__ */ U(G_, {
		showSearchInPopover: !1,
		matchWidth: e ?? o.matchWidth,
		isOpen: n,
		maxWidth: t?.max,
		minWidth: t?.min ?? o.minWidth,
		showAllOptions: r,
		children: /* @__PURE__ */ U(Vv, {
			...i,
			variant: a
		})
	});
}, Bv = y_(zv), Vv = ({ isInvalid: e = !1, options: t, onChange: n, onCreate: r, onSearch: i, onToggle: a, createLabel: o, isCreateDisabled: s, placeholder: c, disabled: l = !1, name: u, triggerStyle: d, filterable: f = !0, emptyState: p, noResultsState: m, filterOptionGroups: h, overrideSelectedLabel: g, leadingIcon: _, trailingIcon: v, onClear: y, inputRef: b, "data-testid": x, id: S, justifyLabels: C = "initial", allowLabelClick: w = !1, hideChevron: T = !1, variant: E = "default", ...D }) => {
	let ee = "initialValue" in D ? D.initialValue : void 0, te = "value" in D ? D.value : void 0, [O, ne] = Y(ee), re = J(null);
	b && (re = b);
	let { setSearchTerm: ie, searchTerm: ae } = W_(), oe = (e) => {
		"value" in D || ne(e), n?.(e), ie("");
	};
	K(() => {
		i && i(ae);
	}, [ae, i]), K(() => {
		ne(ee), ie("");
	}, [ee, ie]);
	let se = te ?? O, ce = Mv(t, se), le = y && se ? () => {
		"value" in D || ne(void 0), y(), re.current?.focus();
	} : void 0, ue = X(E).with("small", () => !1).with("default", () => f).exhaustive(), de = X(E).with("small", () => Rv).with("default", () => void 0).exhaustive();
	return /* @__PURE__ */ U(bv, {
		name: u,
		initialValue: se,
		options: t,
		onChange: oe,
		placeholder: c,
		onCreate: r,
		createLabel: o,
		isCreateDisabled: s,
		disabled: l,
		externalFocusRef: re,
		filterOptionGroups: ue ? h : null,
		MenuItemComponent: de,
		onToggle: a,
		emptyState: p,
		noResultsState: m,
		trigger: /* @__PURE__ */ U(Hv, {
			id: S,
			allowLabelClick: w,
			"data-testid": x,
			ref: re,
			filterable: ue,
			variant: E,
			selectedOption: ce,
			placeholder: c,
			style: d,
			disabled: l,
			overrideSelectedLabel: g,
			leadingIcon: _,
			trailingIcon: v,
			onClear: le,
			justifyLabels: C,
			isInvalid: e,
			isCreateDisabled: s,
			options: t,
			onCommit: oe,
			hideChevron: T
		}),
		"data-testid": x,
		justifyLabels: C
	});
}, Hv = Yi(({ isInvalid: e = !1, id: t, placeholder: n, style: r, selectedOption: i, filterable: a, disabled: o, overrideSelectedLabel: s, leadingIcon: c, trailingIcon: l, onClear: u, "data-testid": d, justifyLabels: f = "initial", allowLabelClick: p = !1, isCreateDisabled: m, options: h, onCommit: g, hideChevron: _ = !1, variant: v = "default" }, y) => {
	let { searchTerm: b, setSearchTerm: x, isOpen: S, setIsOpen: w } = W_(), T = q(() => wv(h).flatMap((e) => e.options), [h]), E = (e) => {
		let t = e.trim().toLowerCase();
		if (t !== "") return T.find((e) => typeof e.label == "string" && e.label.toLowerCase() === t);
	}, D = () => {
		w(!S);
	}, ee = (e) => {
		if (!S && !["Shift", "Tab"].includes(e.key) && w(!0), e.key === "Tab" && w(!1), e.key === "Tab" && m?.(b)) {
			let t = E(b);
			t ? (e.preventDefault(), g(t.value), w(!1)) : x("");
		}
	}, te = S || !i, O = !!(c || i?.icon), ne = !!i?.icon && !S, re = !!u && !o, ie = !!l || re, ae = s ? typeof s == "function" ? s(i) : s : i?.label;
	return X(v).with("default", () => /* @__PURE__ */ W(B, {
		alignItems: "center",
		width: "100%",
		position: "relative",
		height: "32px",
		onKeyDown: (e) => {
			e.stopPropagation();
		},
		children: [/* @__PURE__ */ U(Lg, {
			"data-testid": d,
			"data-1p-ignore": !0,
			value: S ? b : "",
			onChange: a ? x : void 0,
			onKeyDown: ee,
			onClick: D,
			ref: y,
			placeholder: te ? n : "",
			style: {
				caretColor: S ? void 0 : "transparent",
				...r ?? {}
			},
			isReadOnly: !a,
			height: "32px",
			color: Ft,
			isDisabled: o,
			...N,
			lineHeight: "32px",
			boxShadow: Ht,
			paddingLeft: O ? 7 : 3,
			paddingRight: ie ? 14 : 8,
			_hover: {
				background: rr,
				cursor: a ? "text" : "pointer"
			},
			_readOnly: { boxShadow: Ht },
			_disabled: {
				borderColor: P,
				background: A,
				cursor: "not-allowed",
				color: en,
				boxShadow: "none"
			},
			_focus: { border: `1px solid ${C}` },
			_focusVisible: { outline: "none" },
			id: t,
			...e && { border: "1px solid #ef4444" }
		}), /* @__PURE__ */ W(B, {
			position: "absolute",
			width: "100%",
			height: "100%",
			top: 0,
			left: 0,
			pointerEvents: "none",
			alignItems: "center",
			zIndex: 2,
			opacity: o ? .5 : 1,
			children: [
				ne && /* @__PURE__ */ U(R, {
					minWidth: "20px",
					marginLeft: 2,
					alignItems: "end",
					children: i?.icon
				}),
				c && !ne && /* @__PURE__ */ U(R, {
					width: "20px",
					marginLeft: 2,
					alignItems: "end",
					color: "#64748b",
					children: c
				}),
				/* @__PURE__ */ U(B, {
					flex: 1,
					width: "100%",
					overflowX: "hidden",
					paddingLeft: O ? 0 : 3,
					pointerEvents: p ? "auto" : void 0,
					children: !S && /* @__PURE__ */ W(V, {
						display: f === "initial" ? void 0 : "flex",
						justifyContent: f,
						width: "100%",
						textOverflow: "ellipsis",
						overflowX: "hidden",
						whiteSpace: "nowrap",
						children: [/* @__PURE__ */ U(V, {
							as: "span",
							color: "#1e293b",
							"data-testid": `${d}-label`,
							...N,
							children: ae
						}), i?.secondaryLabel && /* @__PURE__ */ U(V, {
							as: "span",
							color: "#64748b",
							marginLeft: "6px",
							...N,
							children: i.secondaryLabel
						})]
					})
				}),
				/* @__PURE__ */ W(B, {
					marginRight: 2,
					alignItems: "center",
					gap: +!!ie,
					children: [
						l,
						re && /* @__PURE__ */ U(z, {
							as: "button",
							type: "button",
							"aria-label": "Clear selection",
							"data-testid": `${d}.clear`,
							width: "20px",
							color: "#64748b",
							cursor: "pointer",
							pointerEvents: "auto",
							_hover: { color: "#334155" },
							onClick: (e) => {
								e.preventDefault(), e.stopPropagation(), u?.();
							},
							onMouseDown: (e) => {
								e.preventDefault(), e.stopPropagation();
							},
							children: /* @__PURE__ */ U($h, {})
						}),
						!_ && /* @__PURE__ */ U(z, {
							width: "20px",
							color: "#64748b",
							children: U(S ? Xp : Up, {})
						})
					]
				})
			]
		})]
	})).with("small", () => /* @__PURE__ */ W(B, {
		alignItems: "center",
		width: "fit-content",
		position: "relative",
		height: Nv,
		onKeyDown: (e) => {
			e.stopPropagation();
		},
		children: [/* @__PURE__ */ U(R, {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			children: /* @__PURE__ */ U(Lg, {
				"data-testid": d,
				"data-1p-ignore": !0,
				value: "",
				onKeyDown: ee,
				onClick: D,
				ref: y,
				style: {
					caretColor: "transparent",
					...r ?? {}
				},
				isReadOnly: !0,
				height: "100%",
				padding: 0,
				borderRadius: "6px",
				boxShadow: Pn,
				isDisabled: o,
				_hover: {
					background: rr,
					cursor: "pointer"
				},
				_readOnly: { boxShadow: Pn },
				_disabled: {
					borderColor: P,
					background: A,
					cursor: "not-allowed",
					boxShadow: "none"
				},
				_focus: { border: `1px solid ${C}` },
				_focusVisible: { outline: "none" },
				id: t,
				...e && { border: "1px solid #ef4444" }
			})
		}), /* @__PURE__ */ W(B, {
			alignItems: "center",
			gap: "2px",
			padding: "4px",
			pointerEvents: "none",
			zIndex: 2,
			opacity: o ? .5 : 1,
			children: [/* @__PURE__ */ U(R, {
				"data-testid": `${d}-label`,
				...tr,
				fontWeight: 500,
				color: ae ? L : en,
				whiteSpace: "nowrap",
				paddingX: Iv,
				height: Lv,
				children: ae || n
			}), !_ && /* @__PURE__ */ U(z, {
				color: "#64748b",
				children: U(S ? Xp : Up, { size: Pv })
			})]
		})]
	})).exhaustive();
}), Uv = (e) => /* @__PURE__ */ U(zv, {
	...e,
	matchWidth: !0,
	triggerStyle: {
		height: "40px",
		paddingLeft: "16px",
		...e.triggerStyle
	}
}), Wv = y_(Uv), Gv = (e) => {
	let [t, n] = Y(e.fixedWidth ?? "150px"), r = J(null);
	yc(() => {
		if (e.fixedWidth) return;
		if (!e.value) {
			n("150px");
			return;
		}
		let t = document.createElement("span");
		t.style.visibility = "hidden", t.style.position = "absolute", t.style.whiteSpace = "pre", t.style.fontFamily = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif", t.style.fontSize = "13px", t.style.fontWeight = "400", t.innerText = e.value, document.body.appendChild(t);
		let r = t.getBoundingClientRect().width + 24 + 20;
		document.body.removeChild(t), n(`${r}px`);
	}, [e.value, e.fixedWidth]);
	let i = () => {
		r?.current?.focus();
	}, a = { border: `1px solid ${C}` }, o = {
		h: "32px",
		...e.iconPlacement === "leading" ? {
			pl: "8px",
			pr: "4px"
		} : {
			pl: "4px",
			pr: "8px"
		},
		pointerEvents: "none",
		border: "none",
		color: e.isDisabled ? en : k,
		background: "transparent",
		...N
	}, s = /* @__PURE__ */ U(Np, {});
	return /* @__PURE__ */ W(ei, {
		borderRadius: "6px",
		boxShadow: Pn,
		border: `1px solid ${e.isDisabled ? P : M}`,
		borderColor: e.isInvalid ? Un : void 0,
		backgroundColor: e.isDisabled ? A : I,
		onClick: i,
		height: "32px",
		width: t,
		display: "flex",
		alignItems: "center",
		style: e.style,
		_focusWithin: { ...a },
		children: [
			e.iconPlacement === "leading" && /* @__PURE__ */ U(ti, {
				...o,
				children: s
			}),
			/* @__PURE__ */ U($r, {
				ref: r,
				border: "none",
				height: "32px",
				boxShadow: "none",
				pl: e.iconPlacement === "leading" ? "0" : "8px",
				backgroundColor: "transparent",
				width: "100%",
				...N,
				value: e.value,
				placeholder: e.placeholder,
				"data-testid": e["data-testid"],
				_placeholder: { color: en },
				_focus: {
					border: "none",
					boxShadow: "none"
				},
				isDisabled: e.isDisabled
			}),
			e.iconPlacement === "trailing" && /* @__PURE__ */ U(ni, {
				...o,
				children: s
			})
		]
	});
}, Kv = /* @__PURE__ */ new Date(), qv = "custom", Jv = [
	{
		label: "This month",
		value: "thisMonth",
		getDateRange: () => [fl(Kv), $c(Kv)]
	},
	{
		label: "This quarter",
		value: "thisQuarter",
		getDateRange: () => [pl(Kv), el(Kv)]
	},
	{
		label: "This year",
		value: "thisYear",
		getDateRange: () => [ml(Kv), tl(Kv)]
	},
	{
		label: "Last month",
		value: "lastMonth",
		getDateRange: () => {
			let e = gl(Kv, { months: 1 });
			return [fl(e), $c(e)];
		}
	},
	{
		label: "Last quarter",
		value: "lastQuarter",
		getDateRange: () => ul()
	},
	{
		label: "Last year",
		value: "lastYear",
		getDateRange: () => {
			let e = Kv.getFullYear() - 1;
			return [new Date(Date.UTC(e, 0, 1)), new Date(Date.UTC(e, 11, 31))];
		}
	},
	{
		label: "Custom",
		value: qv,
		getDateRange: () => [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()],
		dividerAfter: !0
	},
	{
		label: "Month-to-date",
		value: "monthToDate",
		getDateRange: () => [fl(Kv), Kv]
	},
	{
		label: "Quarter-to-date",
		value: "quarterToDate",
		getDateRange: () => [pl(Kv), Kv]
	},
	{
		label: "Year-to-date",
		value: "yearToDate",
		getDateRange: () => [ml(Kv), Kv]
	}
], Yv = (e, t) => {
	if (!e) return;
	let [n, r] = e;
	if (!(!n || !r)) return t.find((e) => {
		if (e.value === qv) return !1;
		let [t, i] = e.getDateRange();
		return cl(t, n) && cl(i, r);
	})?.value || null;
}, Xv = ({ value: e, onChange: t, withOptions: n = !0, options: r = Jv, placeholder: i = "Select date range", style: a, "data-testid": o, popoverPlacement: s = "bottom", inputWidth: c, iconPlacement: l = "leading", isDisabled: u = !1, openOnMount: d = !1, isInvalid: f = !1 }) => {
	let [p, m] = Y(Yv(e, r) || qv), [h, g] = Y(!1);
	K(() => {
		let t = Yv(e, r);
		m(t || qv);
	}, [e, r]), K(() => {
		d && g(!0);
	}, [d]);
	let _ = (e) => {
		let n = r.find((t) => t.value === e);
		if (n) {
			if (m(e), e === qv) {
				g(!0);
				return;
			}
			t(n.getDateRange());
		}
	}, v = (e) => {
		t(e), g(!1);
		let n = Yv(e, r);
		m(n || qv);
	};
	return /* @__PURE__ */ W("div", {
		style: {
			display: "flex",
			alignItems: "center",
			...a,
			height: "32px"
		},
		"data-testid": o,
		children: [n && /* @__PURE__ */ U(zv, {
			initialValue: p,
			onChange: _,
			triggerStyle: {
				width: "160px",
				borderTopRightRadius: 0,
				borderBottomRightRadius: 0
			},
			options: r.map((e) => ({
				label: e.label,
				value: e.value,
				dividerAfter: e.dividerAfter
			})),
			"data-testid": o ? `${o}-select` : void 0,
			disabled: u,
			isInvalid: f
		}), /* @__PURE__ */ U(jv, {
			"data-testid": `dateRangePicker.${o || ""}`,
			defaultDates: e,
			onSubmit: v,
			isOpen: h,
			onOpenChange: g,
			popoverPlacement: s,
			styleWrapper: { width: c },
			isDisabled: u,
			isInvalid: f,
			children: /* @__PURE__ */ U("span", {
				style: { width: c },
				children: /* @__PURE__ */ U(Gv, {
					style: n ? {
						borderTopLeftRadius: 0,
						borderBottomLeftRadius: 0,
						borderLeft: "none"
					} : {},
					value: e && e[0] && e[1] ? rl({
						from: e[0],
						to: e[1],
						separator: "-"
					}) : void 0,
					placeholder: i,
					"data-testid": o ? `${o}-input` : void 0,
					fixedWidth: c,
					iconPlacement: l,
					isDisabled: u,
					isInvalid: f
				})
			})
		}, e?.[0]?.getTime())]
	});
};
Object.assign(Xv, { defaultOptions: Jv });
//#endregion
//#region src/forms/inputs/CheckboxLineInput.tsx
var Zv = ({ onChange: e, value: t, text: n, description: r, isDisabled: i, styles: a, "data-testid": o }) => /* @__PURE__ */ W(B, {
	alignItems: "flex-start",
	onClick: () => !i && e(!t),
	onKeyDown: G((n) => {
		n.key === "Enter" && (n.preventDefault(), n.stopPropagation(), i || e(!t));
	}, [
		i,
		e,
		t
	]),
	tabIndex: i ? -1 : 0,
	role: "checkbox",
	"aria-checked": t,
	width: "100%",
	children: [/* @__PURE__ */ U(R, {
		paddingRight: "8px",
		children: /* @__PURE__ */ U(Vy, {
			isChecked: t,
			disabled: i,
			"data-testid": o
		})
	}), /* @__PURE__ */ W(B, {
		flexDirection: "column",
		width: "100%",
		children: [/* @__PURE__ */ U(R, {
			cursor: "pointer",
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
			...N,
			color: Ft,
			fontWeight: 600,
			...a?.label || {},
			children: n
		}), /* @__PURE__ */ U(R, {
			cursor: "pointer",
			color: L,
			textAlign: "left",
			overflow: "hidden",
			...tr,
			...a?.description || {},
			children: r
		})]
	})]
}), Qv = (e) => {
	let t = (t) => (n) => n ? e.onChange(Dl([...e.value, t])) : e.onChange(e.value.filter((e) => e !== t));
	return /* @__PURE__ */ U(Ai, {
		padding: "12px 16px",
		borderRadius: "8px",
		backgroundColor: A,
		gap: "16px",
		outline: e.isInvalid ? `1px solid ${Un}` : "none",
		children: e.options.map((n) => /* @__PURE__ */ U(Zv, {
			value: e.value.includes(n.value),
			onChange: t(n.value),
			text: n.label,
			isDisabled: e.isDisabled || n.disabled,
			description: n.description,
			styles: {
				description: {
					width: "220px",
					opacity: n.disabled ? .4 : 1
				},
				label: { opacity: n.disabled ? .4 : 1 }
			}
		}, n.value))
	});
}, $v = ({ values: e, onChange: t, isInvalid: n, isDisabled: r, ...i }) => {
	let a = J(null), o = Yc(e), [s, c] = Y(!1), [l, u] = Y("");
	return K(() => {
		!o || !s || e.length !== o.length && a.current?.focus();
	}, [
		e,
		o,
		s
	]), /* @__PURE__ */ U(ei, {
		borderRadius: "6px",
		border: "1px solid",
		outline: "2px solid",
		borderColor: n ? "transparent" : Cn,
		outlineColor: n ? Un : "transparent",
		_focusWithin: {
			outlineColor: C,
			borderColor: "transparent"
		},
		display: "flex",
		alignItems: "center",
		position: "relative",
		tabIndex: r ? void 0 : 0,
		gap: "8px",
		px: "12px",
		py: 2,
		flexWrap: "wrap",
		onFocus: () => {
			a.current?.focus(), c(!0);
		},
		onBlur: () => c(!1),
		...i,
		children: /* @__PURE__ */ W(H, { children: [e.map((n, r) => /* @__PURE__ */ U(ig, {
			sentiment: "monospaced",
			textTransform: "none",
			size: "md",
			onDelete: () => t(e.filter((e) => e !== n)),
			children: n
		}, `badge-${n}-${r}`)), /* @__PURE__ */ U(ey, {
			index: e.length,
			value: l,
			inputRef: a,
			onChange: (e) => u(e),
			onKeyDown: (n) => {
				n.key === "Enter" && (n.preventDefault(), l && (t([...e, l]), u("")));
			}
		})] })
	});
}, ey = ({ value: e, inputRef: t, onChange: n, onKeyDown: r }) => {
	let [i, a] = Y();
	return yc(() => {
		a(ty(e));
	}, [e]), /* @__PURE__ */ U($r, {
		ref: t,
		variant: "plain",
		p: 0,
		...N,
		height: "20px",
		minHeight: "28px",
		value: e,
		onChange: (e) => n(e.target.value),
		onKeyDown: r,
		width: i ? `${i + 24}px` : "30px"
	});
}, ty = (e) => {
	let t = document.createElement("canvas").getContext("2d");
	if (!t) return;
	t.font = "16px -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif";
	let { width: n } = t.measureText(e);
	return n;
}, ny = ({ children: e, ...t }) => /* @__PURE__ */ U(R, {
	...ar,
	marginBottom: "8px",
	...t,
	children: e
}), ry = (e) => {
	let { onOpen: t, onClose: n, isOpen: r } = Kc(), i = J(null), a = G(() => {
		t();
	}, [t]), o = G(() => {
		n();
	}, [n]);
	return /* @__PURE__ */ W(mi, {
		isOpen: !e.isDisabled,
		placement: "left",
		autoFocus: !1,
		children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(Ji, {
			onMouseEnter: a,
			onMouseLeave: o,
			_notLast: { borderBottom: `1px solid ${P}` },
			_last: { borderBottom: "1px solid transparent" },
			children: e.row.columns.map((t) => /* @__PURE__ */ U(Ri, {
				outline: t.invalid ? `1px solid ${Qn}` : "none",
				width: t.width ?? `${100 / e.context.columns.filter((e) => !e.width).length}%`,
				border: "none",
				padding: "0",
				_notLast: { borderRight: `1px solid ${P}` },
				children: t.cell ? pc(t.cell, {
					invalid: t.invalid ?? !1,
					value: t.value,
					rowData: e.row.data,
					onChange: t.onChange,
					rowIndex: e.rowIndex,
					rows: e.context.rows.map((e) => e.data),
					disabled: e.isDisabled,
					config: e.context.config,
					onBlur: t.onBlur
				}) : /* @__PURE__ */ U(B, {
					alignItems: "center",
					justifyContent: "flex-start",
					padding: "12px",
					...t.invalid ? { borderColor: `1px solid ${Qn}` } : {},
					...N,
					children: t.value
				})
			}, `${e.row.id}-${String(t.property)}`))
		}, e.row.id) }), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(vi, {
			width: "fit-content",
			border: "none",
			right: "-12px",
			ref: i,
			onMouseEnter: a,
			onMouseLeave: o,
			backgroundColor: "transparent",
			boxShadow: "none",
			children: /* @__PURE__ */ W(B, {
				height: "34px",
				userSelect: "none",
				children: [/* @__PURE__ */ U(R, {
					width: "fit-content",
					height: "34px",
					borderLeftRadius: "8px",
					borderRightRadius: "0",
					border: `1px solid ${P}`,
					boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
					backgroundColor: I,
					overflow: "visible",
					opacity: +!!r,
					transition: "opacity 0.1s ease-out",
					children: !e.isDisabled && e.rowActions && pc(e.rowActions.component, {
						rowData: e.row.data,
						rowIndex: e.rowIndex
					})
				}), /* @__PURE__ */ U(R, {
					width: "4px",
					height: "34px",
					backgroundColor: I,
					opacity: +!!r,
					transition: "opacity 0.1s ease-out",
					borderTop: `1px solid ${P}`,
					borderBottom: `1px solid ${P}`
				})]
			})
		}) })]
	});
}, iy = ({ rows: e, rowActions: t, columns: n, onChange: r, onBlur: i, invalidRows: a, isDisabled: o = !1, config: s = {}, "data-testid": c }) => {
	let l = q(() => e ? e.map((t) => {
		let o = (a ?? []).find((e) => e.id === t.id)?.invalidProperties ?? [];
		return {
			id: t.id,
			data: t,
			columns: n.map((a) => ({
				width: a.width ?? `${100 / n.filter((e) => !e.width).length}%`,
				value: a.property ? t[a.property] : null,
				property: a.property ?? null,
				invalid: o.includes(a.property ?? ""),
				onBlur: i,
				onChange: (n) => {
					r(e.map((e) => e.id === t.id && a.property ? {
						...e,
						[a.property]: n
					} : e));
				},
				cell: a.bodyComponent
			}))
		};
	}) : [], [
		e,
		n,
		r,
		a,
		i
	]);
	return /* @__PURE__ */ U(R, {
		position: "relative",
		borderRadius: "6px",
		border: `1px solid ${P}`,
		top: "0",
		left: "0",
		right: "0",
		bottom: "0",
		boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
		overflow: "hidden",
		children: /* @__PURE__ */ W(Ni, {
			position: "relative",
			"data-testid": c,
			children: [/* @__PURE__ */ U(Gi, {
				backgroundColor: rr,
				overflow: "hidden",
				children: /* @__PURE__ */ U(Ji, {
					borderBottom: `1px solid ${P}`,
					children: n.map((e) => /* @__PURE__ */ U(Ui, {
						width: e.width ?? `${100 / n.length}%`,
						padding: "0",
						border: "none",
						_notLast: { borderRight: `1px solid ${P}` },
						children: e.headerComponent ? pc(e.headerComponent, { label: e.label ?? "" }) : /* @__PURE__ */ U(B, {
							alignItems: "center",
							justifyItems: "center",
							justifyContent: "flex-start",
							color: k,
							height: "32px",
							padding: "0 12px",
							textTransform: "none",
							...j,
							children: e.label
						})
					}, String(e.property)))
				})
			}), /* @__PURE__ */ U(Ii, {
				position: "relative",
				zIndex: "1",
				children: l.map((e, r) => /* @__PURE__ */ U(ry, {
					row: e,
					rowIndex: r,
					context: {
						rows: l,
						columns: n,
						config: s
					},
					isDisabled: o,
					rowActions: t
				}, e.id))
			})]
		})
	});
}, ay = ({ onChange: e, children: t, checked: n, disabled: r, size: i = "sm", ...a }) => /* @__PURE__ */ U(ji, {
	variant: "default",
	size: i,
	style: {
		alignItems: "center",
		display: "flex"
	},
	disabled: r,
	cursor: r ? "not-allowed" : "pointer",
	isChecked: n,
	defaultChecked: n,
	...a,
	onChange: (t) => e(t.target.checked),
	children: t
}), oy = ({ onChange: e, value: t, text: n, isInvalid: r, isDisabled: i, styles: a, "data-testid": o, switchSize: s, switchSide: c = "left", allowMultiLineLabel: l = !1 }) => /* @__PURE__ */ W(Kr, {
	alignItems: "center",
	onClick: () => !i && e(!t),
	width: "100%",
	columnGap: "8px",
	gridTemplateAreas: `"${c === "right" ? "label switch" : "switch label"}"`,
	gridTemplateColumns: c === "right" ? "1fr auto" : "auto 1fr",
	...a?.container || {},
	children: [/* @__PURE__ */ U(B, {
		alignItems: "center",
		gridArea: "switch",
		onClick: (e) => {
			e.stopPropagation();
		},
		children: /* @__PURE__ */ U(ay, {
			checked: t,
			disabled: i,
			isInvalid: r,
			onChange: (t) => !i && e(t),
			"data-testid": o,
			size: s
		})
	}), /* @__PURE__ */ U(R, {
		cursor: i ? "not-allowed" : "pointer",
		color: r ? Un : L,
		...l ? { whiteSpace: "normal" } : {
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		...N,
		userSelect: "none",
		...a?.label || {},
		gridArea: "label",
		"data-testid": o ? `${o}.label` : void 0,
		children: n
	})]
}), sy = ({ onChange: e, onBlur: t, value: n, min: r, ...i }) => {
	let a = String(n ?? ""), o = G((t) => {
		if (!e) return;
		let n = { value: t };
		e({
			target: n,
			currentTarget: n
		});
	}, [e]), { displayValue: s, inputRef: c, handleChange: l, handleKeyDown: u, handlePaste: d, handleBlur: f } = cy({
		value: a,
		onChange: (e) => o(e),
		onBlur: t,
		min: r
	});
	return /* @__PURE__ */ U(Hg, {
		inputMode: "decimal",
		...i,
		ref: c,
		value: s,
		onChange: l,
		onKeyDown: u,
		onPaste: d,
		onBlur: f
	});
};
function cy({ value: e, onChange: t, onBlur: n, precision: r, clampValueOnBlur: i = r !== void 0, min: a, max: o }) {
	let s = J(null), c = J(null), l = Gg(e);
	return yc(() => {
		if (c.current !== null && s.current) {
			let e = c.current;
			s.current.setSelectionRange(e, e), c.current = null;
		}
	}), {
		displayValue: l,
		inputRef: s,
		handleChange: G((e) => {
			let n = e.target.value, r = e.target.selectionStart ?? n.length, i = Kg(n).replace(/[^0-9.\-]/g, ""), a = Jg(n, Gg(i), r);
			c.current = a;
			let o = parseFloat(i);
			t(i, isNaN(o) ? 0 : o);
		}, [t]),
		handleKeyDown: G((e) => {
			let t = e.target, n = t.selectionStart ?? 0, r = t.value;
			e.key === "Backspace" && n > 0 && r[n - 1] === "," && t.setSelectionRange(n - 1, n - 1), e.key === "Delete" && n < r.length && r[n] === "," && t.setSelectionRange(n + 1, n + 1), Yg(e) || e.preventDefault();
		}, []),
		handlePaste: G((e) => {
			e.preventDefault();
			let n = e.target, r = qg(e.clipboardData.getData("text")), i = n.selectionStart ?? 0, a = n.selectionEnd ?? 0, o = Kg(n.value), s = Xg(n), l = o.slice(0, s) + r + o.slice(s + Kg(n.value.slice(i, a)).length), u = Gg(l), d = Jg(n.value.slice(0, i) + r + n.value.slice(a), u, i + r.length);
			c.current = d;
			let f = parseFloat(l);
			t(l, isNaN(f) ? 0 : f);
		}, [t]),
		handleBlur: G((e) => {
			let s = Kg(e.target.value), c = parseFloat(s);
			isNaN(c) || (a !== void 0 && c < a && (c = a), o !== void 0 && c > o && (c = o), i && r !== void 0 && (c = parseFloat(c.toFixed(r))), t(X(r).with(void 0, () => String(c)).otherwise((e) => c.toFixed(e)), c)), n?.(e);
		}, [
			n,
			t,
			r,
			i,
			a,
			o
		])
	};
}
//#endregion
//#region src/forms/inputs/RadioButtonGroup.tsx
var ly = ({ options: e, initialValue: t, value: n, onChange: r, fullWidth: i = !1, isDisabled: a, "data-testid": o, buttonPadding: s }) => {
	let c = q(() => e, [e]), [l, u] = Y(e.find((e) => e.value === t) ?? e[0]);
	K(() => {
		let e = c.find((e) => e.value === t);
		e && u(e);
	}, [t]), K(() => {
		let e = c.find((e) => e.value === n);
		e && l.value !== e.value && u(e);
	}, [n]);
	let d = c.some((e) => e.secondaryLabel), f = J(/* @__PURE__ */ new Map()), p = (e) => {
		a || e.disabled || (u(e), r(e.value));
	}, m = (e, t) => {
		let n = c.filter((e) => !e.disabled), r = n[(n.findIndex((t) => t.value === e.value) + t + n.length) % n.length];
		r && f.current.get(r.value)?.focus();
	}, h = (e, t) => {
		let n = (n) => {
			e.preventDefault(), e.stopPropagation(), m(t, n);
		};
		X(e.key).with("Enter", " ", () => e.stopPropagation()).with("ArrowLeft", "ArrowUp", () => n(-1)).with("ArrowRight", "ArrowDown", () => n(1)).otherwise(() => {});
	};
	return /* @__PURE__ */ U(kr, {
		role: "radiogroup",
		variant: "component-library-button-group",
		spacing: "0px",
		borderRadius: "6px",
		position: "relative",
		width: i ? "100%" : void 0,
		"data-testid": o,
		backgroundColor: Fn,
		height: "fit-content",
		children: c.map((e) => {
			let t = l.value === e.value;
			return /* @__PURE__ */ U(Or, {
				ref: (t) => {
					t ? f.current.set(e.value, t) : f.current.delete(e.value);
				},
				role: "radio",
				type: "button",
				"aria-checked": t,
				"data-selected": t || void 0,
				onClick: () => p(e),
				onKeyDown: (t) => h(t, e),
				isDisabled: a || e.disabled,
				border: "1px solid transparent",
				"data-testid": o ? `${o}.option.${e.value}` : e.value,
				_focus: {},
				minHeight: d ? void 0 : {
					base: "36px",
					md: "32px"
				},
				flex: "1",
				minWidth: {
					base: 0,
					md: "auto"
				},
				whiteSpace: {
					base: "normal",
					md: "nowrap"
				},
				padding: s || (d ? "12px 16px" : "4px 12px"),
				children: /* @__PURE__ */ W(B, {
					flexDirection: "column",
					justifyContent: "center",
					height: "100%",
					width: "100%",
					alignItems: e.secondaryLabel ? "flex-start" : "center",
					children: [/* @__PURE__ */ U(R, { children: e.label }), e.secondaryLabel && /* @__PURE__ */ U(R, {
						...N,
						whiteSpace: "wrap",
						textAlign: "left",
						children: e.secondaryLabel
					})]
				})
			}, e.value);
		})
	});
}, uy = ({ name: e, label: t, disabled: n, isChecked: r = !1, onChange: i, id: a, "data-testid": o, marginTop: s = "2px" }) => /* @__PURE__ */ W(B, {
	gap: "8px",
	alignItems: "start",
	...N,
	children: [/* @__PURE__ */ U("input", {
		type: "radio",
		name: e,
		checked: r,
		disabled: n,
		id: a,
		onChange: () => {
			n || i?.(!r);
		},
		style: {
			cursor: n ? "not-allowed" : "pointer",
			marginTop: s
		},
		"data-testid": o
	}), /* @__PURE__ */ U(R, {
		as: "label",
		htmlFor: a,
		cursor: n ? "not-allowed" : "pointer",
		onClick: () => {
			n || i?.(!r);
		},
		children: t
	})]
}), dy = "d MMM yyyy", fy = (e) => e ? nl(e, dy) : "", py = ({ value: e, onChange: t, ...n }) => {
	let [r, i] = Y(fy(e)), a = () => {
		let n = hl(r);
		n ? sl(n, e) || t(n) : i(fy(e));
	};
	return K(() => {
		i(fy(e));
	}, [e]), /* @__PURE__ */ U(Lg, {
		...n,
		value: r,
		onChange: (e) => i(e),
		onBlur: a,
		trailingIcon: /* @__PURE__ */ U(Np, { style: {
			position: "relative",
			left: 1
		} })
	});
}, my = ({ value: e, onChange: t, inputProps: n = {}, popoverTestId: r, closeOnSelect: i = !0, ...a }) => /* @__PURE__ */ U(Z_, {
	...a,
	autoSelect: !1,
	popoverTestId: r,
	closeOnSelect: i,
	trigger: /* @__PURE__ */ U(py, {
		...n,
		value: e,
		onChange: t,
		onKeyUp: (e) => {
			[" "].includes(e.key) && (e.stopPropagation(), e.preventDefault());
		}
	}),
	onChange: t,
	value: e
}), hy = `
  background: ${I};
  color: ${L};
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 2px rgba(0, 0, 0, 0.02);
`, gy = Ol.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${(e) => e.$iconOnly ? "4px" : "0px 6px"};
  gap: ${(e) => e.$iconOnly ? "0px" : "6px"};
  font-size: 12px;
  font-weight: 600;
  user-select: none;

  height: 24px;
  width: ${(e) => e.$iconOnly ? "24px" : "auto"};
  border: 1px solid transparent;
  outline: none;

  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;

  ${(e) => e.$variant === "default" && `
    ${hy}
    border: ${e.$noBorder ? "1px solid transparent" : "1px solid #cbd5e1"};
  `}

  border-radius: 6px;

  ${(e) => e.$interactive && `
    cursor: pointer;
    &:focus-visible {
      outline: 2px solid #6366f1;
      outline-offset: 1px;
    }
    &:hover {
      ${hy}
      background: ${e.$noBorder ? "#f1f5f9" : "#f8fafc"};
      border: ${e.$noBorder ? "1px solid transparent" : "1px solid #cbd5e1"};
    }
  `}

  ${(e) => e.$optional && `
    box-shadow: none;
    border: ${e.$noBorder ? "1px solid transparent" : "#f1f5f9 1px solid"};
    background: #f1f5f9;
    color: #475569;
  `}

  ${(e) => e.$disabled && `
    box-shadow: none;
    background: #ffffff;
    color: #94a3b8;
    border: ${e.$noBorder ? "1px solid transparent" : "1px solid #e2e8f0"};
    cursor: not-allowed;
  `}

  ${(e) => e.$error && "\n    box-shadow: none;\n    background: #ffffff;\n    color: #ef4444;\n    border: 1px solid #ef4444;\n  "}

  > svg {
    min-width: 16px;
  }
`, _y = Ol.div`
  background: ${Fn};
  color: ${F};
  padding: 1px 4px;
  border-radius: 4px;
  margin-right: -2px;

  ${(e) => e.$disabled && "\n    color: #94a3b8;\n  "}
`, vy = ({ variant: e = "default", icon: t, iconSide: n = "leading", children: r, interactive: i = !1, more: a = 0, optional: o = !1, disabled: s = !1, error: c = !1, onClear: l, onClick: u, "aria-label": d, "data-testid": f, noBorder: p = !1 }) => {
	let m = !!t && (!r || r === void 0), h = i && !!u && !s, g = (e) => {
		let t = e.key === "Enter" || e.key === " ";
		e.target !== e.currentTarget || !t || (e.preventDefault(), e.currentTarget.click());
	}, _ = t ? /* @__PURE__ */ U(R, {
		flex: 0,
		minWidth: "fit-content",
		width: m ? "16px" : "auto",
		height: m ? "16px" : "auto",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		children: t
	}) : null;
	return /* @__PURE__ */ W(gy, {
		$error: c,
		$disabled: s,
		$interactive: i,
		$optional: o,
		$variant: e,
		$iconOnly: m,
		onClick: u,
		role: h ? "button" : void 0,
		tabIndex: h ? 0 : void 0,
		onKeyDown: h ? g : void 0,
		"aria-label": h ? d : void 0,
		"data-testid": f,
		$noBorder: p,
		disabled: s,
		children: [
			_ && n === "leading" && _,
			/* @__PURE__ */ U(R, {
				overflow: "hidden",
				textOverflow: "ellipsis",
				children: r
			}),
			a > 0 && /* @__PURE__ */ W(_y, {
				$disabled: s,
				children: ["+", a]
			}),
			_ && n === "trailing" && _,
			!!l && !s && /* @__PURE__ */ U(fg, {
				onClick: l,
				"aria-label": "Clear",
				marginRight: "-3px",
				isDisabled: s,
				"data-testid": `${f}.clear`
			})
		]
	});
}, yy = Ol.div`
  display: flex;
  gap: 8px;
  padding-bottom: 2px;
  flex-wrap: wrap;
`, by = ({ width: e = "unset", maxWidth: t = 250, showArrow: n = !0, header: r, content: i, contentRef: a, dataTestId: o, variant: s = "standard" }) => /* @__PURE__ */ W(vi, {
	ref: a,
	"data-testid": o,
	w: e,
	maxW: t,
	...X(s).with("standard", () => ({
		boxShadow: Ht,
		borderRadius: 6,
		padding: 4
	})).with("standard-v2", () => ({
		boxShadow: Pn,
		borderRadius: "8px",
		padding: "8px",
		border: `${P} 1px solid`
	})).exhaustive(),
	children: [
		n && /* @__PURE__ */ U(gi, {}),
		r && /* @__PURE__ */ U(yi, {
			border: "none",
			px: 0,
			pt: 0,
			pb: 2,
			children: /* @__PURE__ */ U(V, {
				...j,
				color: "#1e293b",
				children: r
			})
		}),
		/* @__PURE__ */ U(_i, {
			p: 0,
			children: typeof i == "string" ? /* @__PURE__ */ U(V, {
				...N,
				color: Ft,
				children: i
			}) : i
		})
	]
}), xy = ({ width: e = "unset", maxWidth: t = 250, maxHeight: n, header: r, content: i, contentRef: a, dataTestId: o }) => /* @__PURE__ */ U(vi, {
	ref: a,
	"data-testid": o,
	w: e,
	maxW: t,
	boxShadow: Ht,
	borderRadius: 8,
	maxHeight: n,
	overflowY: "auto",
	position: "relative",
	children: /* @__PURE__ */ W(Ni, {
		variant: "v2",
		width: "100%",
		height: "100%",
		borderRadius: 8,
		children: [r && /* @__PURE__ */ U(Gi, {
			position: "sticky",
			top: 0,
			zIndex: "docked",
			children: /* @__PURE__ */ U(Ji, { children: /* @__PURE__ */ U(Ui, { children: r }) })
		}), /* @__PURE__ */ U(Ii, {
			height: "100%",
			children: i
		})]
	})
}), Sy = Ol.div`
  width: 100%;
  height: 5px;
  background: transparent;
`, Cy = Ol.div`
  width: 100%;
  border-radius: ${"6px"};
  background-color: ${I};
  box-shadow: ${nr};
  border: ${P} 1px solid;
  overflow: hidden;
`, wy = ({ children: e, popover: t, disabled: n = !1, placement: r = "bottom-start", isOpen: i, offset: a = [0, 0], openDelay: o, trigger: s = "hover" }) => /* @__PURE__ */ W(mi, {
	variant: "unstyled",
	trigger: s,
	placement: r,
	offset: a,
	isOpen: i,
	openDelay: o,
	children: [/* @__PURE__ */ U(R, {
		maxWidth: "100%",
		children: /* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U(R, { children: e }) })
	}), /* @__PURE__ */ U(Si, { children: !n && /* @__PURE__ */ W(vi, { children: [/* @__PURE__ */ U(Sy, {}), /* @__PURE__ */ U(Cy, { children: t })] }) })]
}), Ty = Object.assign(({ variant: e = "standard", defaultIsOpen: t = !1, closeOnBlur: n = !0, gutter: r = 8, position: i = "bottom", trigger: a = "hover", offset: o, children: s, isDisabled: c, isOpen: l, contentRef: u, ...d }) => {
	let f;
	return c ? f = !c : l !== void 0 && (f = l), /* @__PURE__ */ W(mi, {
		trigger: a,
		arrowSize: 10,
		placement: i,
		gutter: r,
		defaultIsOpen: t,
		closeOnBlur: n,
		offset: o,
		isOpen: f,
		children: [/* @__PURE__ */ U(bi, { children: /* @__PURE__ */ U("span", { children: s }) }), /* @__PURE__ */ U(Si, { children: X(e).with("standard", "standard-v2", (e) => /* @__PURE__ */ U(by, {
			...d,
			variant: e
		})).with("table", () => /* @__PURE__ */ U(xy, {
			...d,
			contentRef: u
		})).exhaustive() })]
	});
}, {
	Root: mi,
	Anchor: hi,
	Body: _i,
	Content: vi,
	Trigger: bi
}), Ey = ({ options: e, initialValue: t, onChange: n, onCreate: r, createLabel: i, icon: a, labelWhenNoSelection: o, labelOverride: s, placeholder: c, errorMessage: l, disabled: u = !1, popover: d, name: f, "data-testid": p, iconSide: m = "leading", showSearchInPopover: h = !0, minWidth: g, placement: _, enableSmartPlacement: v }) => {
	let [y, b] = Y(t), [x, S] = Y(!1), C = (e) => {
		b(e), n(e), S(!1);
	};
	K(() => {
		b(t);
	}, [t]);
	let w = Mv(e, y), T = /* @__PURE__ */ U(G_, {
		showSearchInPopover: h,
		minWidth: g,
		placement: _,
		children: /* @__PURE__ */ U(bv, {
			name: f,
			initialValue: t,
			options: e,
			onChange: C,
			placeholder: c,
			onCreate: r,
			createLabel: i,
			disabled: u,
			trigger: /* @__PURE__ */ U(vy, {
				disabled: u,
				icon: w?.icon ? w.icon : typeof a == "function" ? a(x) : a,
				interactive: !0,
				error: !!l,
				"data-testid": p,
				iconSide: m,
				children: l ?? s ?? w?.label ?? o
			}),
			onToggle: S,
			"data-testid": p,
			enableSmartPlacement: v
		})
	});
	return d ? /* @__PURE__ */ U(wy, {
		disabled: x,
		popover: d,
		children: T
	}) : T;
};
//#endregion
//#region src/components/Control/hooks/useAsyncKeyboardState.ts
function Dy({ options: e, selectedValue: t, onSelect: n, onSearch: r, onOpen: i, onClose: a }) {
	let [o, s] = Y(t ? "CLOSED_SELECTED" : "CLOSED_EMPTY"), [c, l] = Y(-1), u = J(""), d = G(() => {
		l(-1);
	}, []), f = G(() => {
		s("OPEN_SEARCHING"), l(-1), i();
	}, [i]), p = G(() => {
		s("OPEN_NAVIGATING");
	}, []), m = (e, t) => t && (t.ctrlKey || t.metaKey || t.altKey) ? !1 : e.length === 1 && (/[a-zA-Z0-9]/.test(e) || /[\s\-\_\.]/.test(e));
	return G((e) => {
		(o === "CLOSED_EMPTY" || o === "CLOSED_SELECTED") && s(e ? "CLOSED_SELECTED" : "CLOSED_EMPTY");
	}, [o]), {
		keyboardState: o,
		focusedIndex: c,
		handleKeyDown: G((d) => {
			let { key: h } = d, g = !1;
			switch (o) {
				case "CLOSED_EMPTY":
					m(h, d) ? (f(), g = !1) : h === "Enter" ? (d.preventDefault(), f(), g = !0) : h === "ArrowDown" ? (d.preventDefault(), e.length > 0 && (p(), l(0), i()), g = !0) : h === "ArrowUp" && (d.preventDefault(), e.length > 0 && (p(), l(e.length - 1), i()), g = !0);
					break;
				case "CLOSED_SELECTED":
					m(h, d) ? (f(), g = !1) : h === "Enter" ? (d.preventDefault(), f(), g = !0) : h === "ArrowDown" ? (d.preventDefault(), e.length > 0 && (p(), l(0), i()), g = !0) : h === "ArrowUp" ? (d.preventDefault(), e.length > 0 && (p(), l(e.length - 1), i()), g = !0) : (h === "Backspace" || h === "Delete") && (d.preventDefault(), s("CLOSED_EMPTY"), a(), g = !0);
					break;
				case "OPEN_SEARCHING":
					h === "ArrowDown" ? (d.preventDefault(), e.length > 0 && (p(), l(0)), g = !0) : h === "ArrowUp" ? (d.preventDefault(), e.length > 0 && (p(), l(e.length - 1)), g = !0) : h === "Enter" ? (d.preventDefault(), e.length > 0 && (n(e[0].value), s("CLOSED_SELECTED"), a()), g = !0) : h === "Escape" ? (d.preventDefault(), s(t ? "CLOSED_SELECTED" : "CLOSED_EMPTY"), a(), g = !0) : h === "Tab" ? (s(t ? "CLOSED_SELECTED" : "CLOSED_EMPTY"), a(), g = !1) : m(h, d) && (u.current += h, g = !1);
					break;
				case "OPEN_NAVIGATING":
					h === "ArrowDown" ? (d.preventDefault(), e.length > 0 && l((t) => t < 0 ? 0 : (t + 1) % e.length), g = !0) : h === "ArrowUp" ? (d.preventDefault(), e.length > 0 && l((t) => t <= 0 ? e.length - 1 : t - 1), g = !0) : h === "Enter" ? (d.preventDefault(), c >= 0 && c < e.length && (n(e[c].value), s("CLOSED_SELECTED"), a()), g = !0) : m(h, d) ? (f(), r(h), u.current = h, g = !1) : h === "Escape" ? (d.preventDefault(), s(t ? "CLOSED_SELECTED" : "CLOSED_EMPTY"), a(), g = !0) : h === "Tab" && (s(t ? "CLOSED_SELECTED" : "CLOSED_EMPTY"), a(), g = !1);
					break;
			}
			return g;
		}, [
			o,
			e,
			c,
			t,
			n,
			r,
			i,
			a,
			f,
			p
		]),
		resetNavigation: d,
		setSearchMode: f,
		setNavigationMode: p
	};
}
//#endregion
//#region src/components/Control/hooks/useAsyncOptions.ts
function Oy({ fetcher: e, paginatedFetcher: t, mapToOption: n, debounceMs: r = 300, onSearch: i, skipInitialFetch: a = !1 }) {
	let [o, s] = Y([]), [c, l] = Y(!1), [u, d] = Y(!1), [f, p] = Y(null), [m, h] = Y(""), [g, _] = Y(void 0), [v, y] = Y(!1), b = J(), x = J(), S = J(!1), C = o.flatMap((e) => {
		let t = n(e);
		return t ? [t] : [];
	}), w = G(async (n) => {
		x.current && x.current.abort(), x.current = new AbortController(), S.current = !1, l(!0), p(null);
		try {
			if (t) {
				let e = await t(n, void 0);
				if (x.current?.signal.aborted) return;
				s(e.items), _(e.cursor), y(e.hasMore);
			} else if (e) {
				let t = await e(n);
				if (x.current?.signal.aborted) return;
				s(t), _(void 0), y(!1);
			}
			i?.(n);
		} catch (e) {
			if (x.current?.signal.aborted) return;
			p(e instanceof Error ? e.message : "An error occurred"), s([]), _(void 0), y(!1);
		} finally {
			x.current?.signal.aborted || l(!1);
		}
	}, [
		e,
		t,
		i
	]), T = G(() => {
		if (!t || !v || S.current || !g) return;
		S.current = !0, d(!0);
		let e = m;
		t(m, g).then((t) => {
			e === m && (s((e) => {
				let n = new Set(e.map((e) => e.id ?? e)), r = t.items.filter((e) => !n.has(e.id ?? e));
				return [...e, ...r];
			}), _(t.cursor), y(t.hasMore));
		}).catch((e) => {
			p(e instanceof Error ? e.message : "An error occurred");
		}).finally(() => {
			S.current = !1, d(!1);
		});
	}, [
		t,
		v,
		g,
		m
	]), E = G((e) => {
		h(e), b.current && clearTimeout(b.current), b.current = setTimeout(() => {
			w(e);
		}, r);
	}, [w, r]), D = G(() => {
		h(""), s([]), p(null), l(!1), _(void 0), y(!1), b.current && clearTimeout(b.current), x.current && x.current.abort();
	}, []), ee = G(() => {
		m !== void 0 && w(m);
	}, [w, m]);
	return K(() => {
		a || w("");
	}, [w, a]), K(() => () => {
		b.current && clearTimeout(b.current), x.current && x.current.abort();
	}, []), {
		options: C,
		isLoading: c,
		error: f,
		search: E,
		clearSearch: D,
		retry: ee,
		fetchMore: T,
		hasMore: v,
		isFetchingMore: u
	};
}
//#endregion
//#region src/components/Control/AsyncInputSelectControl.tsx
var ky = ({ matchWidth: e = !0, initiallyOpen: t, ...n }) => /* @__PURE__ */ U(G_, {
	showSearchInPopover: !1,
	matchWidth: e ?? !0,
	isOpen: t,
	placement: n.flip ? "auto" : "bottom-start",
	children: /* @__PURE__ */ U(My, { ...n })
}), Ay = (e) => y_(ky)(e);
function jy(e, t) {
	K(() => {
		let n = e?.current;
		if (n) {
			let e = (e) => {
				t({
					key: e.key,
					ctrlKey: e.ctrlKey,
					metaKey: e.metaKey,
					altKey: e.altKey,
					preventDefault: () => e.preventDefault(),
					stopPropagation: () => e.stopPropagation()
				}) && (e.preventDefault(), e.stopPropagation());
			};
			return n.addEventListener("keydown", e, !0), () => {
				n.removeEventListener("keydown", e, !0);
			};
		}
	}, [e, t]);
}
var My = ({ isInvalid: e = !1, fetcher: t, paginatedFetcher: n, mapToOption: r, onSearch: i, debounceMs: a = 300, onChange: o, onCreate: s, onToggle: c, createLabel: l, placeholder: u, disabled: d = !1, name: f, triggerStyle: p, emptyState: m, noResultsState: h, overrideSelectedLabel: g, leadingIcon: _, trailingIcon: v, flip: y = !1, inputRef: b, "data-testid": x, id: S, justifyLabels: C = "initial", allowLabelClick: w = !1, skipInitialFetch: T = !1, resolveValue: E, value: D }) => {
	let ee = J(null);
	b && (ee = b);
	let { setSearchTerm: te, setIsOpen: O } = W_(), { options: ne, isLoading: re, error: ie, search: ae, clearSearch: oe, retry: se, fetchMore: ce, hasMore: le, isFetchingMore: ue } = Oy({
		fetcher: t,
		paginatedFetcher: n,
		mapToOption: r,
		debounceMs: a,
		onSearch: i,
		skipInitialFetch: T
	}), de = G((e) => {
		te(e), ae(e), i?.(e);
	}, [
		te,
		ae,
		i
	]), [fe, pe] = Y(null), [me, he] = Y(!1), ge = Mv(ne, D);
	K(() => {
		D ? ge && pe(ge) : pe(null);
	}, [D, ge]), K(() => {
		let e = !!D, t = !!E, n = !!ge, r = fe?.value === D;
		if (!e || !t || n || r) {
			he(!1);
			return;
		}
		let i = !0;
		return he(!0), E(D).then((e) => {
			i && pe(e);
		}).catch(() => {}).finally(() => {
			i && he(!1);
		}), () => {
			i = !1;
		};
	}, [
		D,
		E,
		ge,
		fe?.value
	]);
	let _e = q(() => !fe || ne.some((e) => e.value === fe.value) ? ne : [fe, ...ne], [ne, fe]), ve = Mv(_e, D), ye = Dy({
		options: _e,
		selectedValue: D,
		onSelect: (e) => {
			o?.(e), te("");
		},
		onSearch: de,
		onOpen: () => O(!0),
		onClose: () => {
			ne.length === 0 && !re && !T && (te(""), oe(), ae("")), O(!1);
		}
	});
	jy(ee, ye.handleKeyDown);
	let be = J(_e);
	be.current = _e;
	let xe = J(ye.focusedIndex);
	xe.current = ye.focusedIndex;
	let Se = G((e) => {
		let t = be.current.findIndex((t) => t.value === e.option.value), n = xe.current === t;
		return /* @__PURE__ */ U(iv, {
			...e,
			isFocused: n || e.isFocused,
			scrollIntoView: !0
		});
	}, []), Ce = (e) => {
		o?.(e), te("");
	}, we = () => ie ? /* @__PURE__ */ W(z, {
		padding: 4,
		flexDirection: "column",
		gap: 2,
		children: [/* @__PURE__ */ U(V, {
			color: k,
			...N,
			children: ie
		}), /* @__PURE__ */ U(V, {
			as: "button",
			color: "blue.500",
			cursor: "pointer",
			onClick: se,
			...N,
			textDecoration: "underline",
			children: "Try again"
		})]
	}) : re ? null : m || /* @__PURE__ */ U(z, {
		padding: 4,
		children: /* @__PURE__ */ U(V, {
			color: "#64748b",
			...N,
			children: "No results found"
		})
	}), Te = () => ie ? /* @__PURE__ */ W(z, {
		padding: 4,
		flexDirection: "column",
		gap: 2,
		children: [/* @__PURE__ */ U(V, {
			color: k,
			...N,
			children: ie
		}), /* @__PURE__ */ U(V, {
			as: "button",
			color: "blue.500",
			cursor: "pointer",
			onClick: se,
			...N,
			textDecoration: "underline",
			children: "Try again"
		})]
	}) : h || /* @__PURE__ */ U(z, {
		padding: 4,
		children: /* @__PURE__ */ U(V, {
			color: "#64748b",
			...N,
			children: "No results found"
		})
	}), Ee = G((e) => {
		e || (te(""), oe(), T || ae("")), c?.(e);
	}, [
		te,
		oe,
		ae,
		c,
		T
	]), De = d || me, Oe = me ? /* @__PURE__ */ U(ki, {
		size: "xs",
		color: F
	}) : v;
	return /* @__PURE__ */ U(bv, {
		name: f,
		initialValue: D,
		options: _e,
		onChange: Ce,
		placeholder: u,
		onCreate: s,
		createLabel: l,
		disabled: De,
		externalFocusRef: ee,
		filterOptionGroups: null,
		MenuItemComponent: Se,
		onToggle: Ee,
		emptyState: we(),
		noResultsState: Te(),
		trigger: /* @__PURE__ */ U(Ny, {
			id: S,
			allowLabelClick: w,
			"data-testid": x,
			ref: ee,
			selectedOption: ve,
			placeholder: u,
			style: p,
			disabled: De,
			overrideSelectedLabel: g,
			leadingIcon: _,
			trailingIcon: Oe,
			justifyLabels: C,
			isInvalid: e,
			onSearch: de
		}),
		"data-testid": x,
		justifyLabels: C,
		onScrollEnd: le ? ce : void 0,
		isLoadingMore: re || ue
	});
}, Ny = Yi(({ isInvalid: e = !1, id: t, placeholder: n, style: r, selectedOption: i, disabled: a, overrideSelectedLabel: o, leadingIcon: s, trailingIcon: c, "data-testid": l, justifyLabels: u = "initial", allowLabelClick: d = !1, onSearch: f }, p) => {
	let { searchTerm: m, isOpen: h, setIsOpen: g } = W_(), _ = (e) => {
		let t = e.target;
		t.selectionStart === t.selectionEnd && g(!h);
	}, v = h || !i, y = !!(s || i?.icon), b = !!i?.icon && !h, x = o ? typeof o == "function" ? o(i) : o : i?.label;
	return /* @__PURE__ */ W(B, {
		alignItems: "center",
		width: "100%",
		position: "relative",
		height: "32px",
		children: [/* @__PURE__ */ U(Lg, {
			"data-testid": l,
			"data-1p-ignore": !0,
			value: h ? m : "",
			onChange: f,
			onClick: _,
			onKeyDown: void 0,
			ref: p,
			placeholder: v ? n : "",
			style: r,
			height: "32px",
			color: Ft,
			isDisabled: a,
			...N,
			lineHeight: "32px",
			boxShadow: Ht,
			paddingLeft: y ? 7 : 3,
			paddingRight: 4,
			_hover: {
				background: rr,
				cursor: "text"
			},
			_disabled: {
				borderColor: P,
				background: A,
				cursor: "not-allowed",
				color: en,
				boxShadow: "none"
			},
			_focus: { border: `1px solid ${C}` },
			_focusVisible: { outline: "none" },
			id: t,
			...e && { border: "1px solid #ef4444" }
		}), /* @__PURE__ */ W(B, {
			position: "absolute",
			width: "100%",
			height: "100%",
			top: 0,
			left: 0,
			pointerEvents: "none",
			alignItems: "center",
			zIndex: 2,
			opacity: a ? .5 : 1,
			children: [
				b && /* @__PURE__ */ U(R, {
					minWidth: "20px",
					marginLeft: 2,
					alignItems: "end",
					children: i?.icon
				}),
				s && !b && /* @__PURE__ */ U(R, {
					width: "20px",
					marginLeft: 2,
					alignItems: "end",
					color: "#64748b",
					children: s
				}),
				/* @__PURE__ */ U(B, {
					flex: 1,
					width: "100%",
					overflowX: "hidden",
					paddingLeft: y ? 0 : 3,
					pointerEvents: d ? "auto" : void 0,
					children: !h && /* @__PURE__ */ W(V, {
						display: u === "initial" ? void 0 : "flex",
						justifyContent: u,
						width: "100%",
						textOverflow: "ellipsis",
						overflowX: "hidden",
						whiteSpace: "nowrap",
						children: [/* @__PURE__ */ U(V, {
							as: "span",
							color: "#1e293b",
							"data-testid": `${l}-label`,
							...N,
							children: x
						}), i?.secondaryLabel && /* @__PURE__ */ U(V, {
							as: "span",
							color: "#64748b",
							marginLeft: "6px",
							...N,
							children: i.secondaryLabel
						})]
					})
				}),
				/* @__PURE__ */ W(B, {
					marginRight: 2,
					alignItems: "center",
					children: [c, /* @__PURE__ */ U(z, {
						width: "20px",
						color: k,
						children: U(h ? Xp : Up, {})
					})]
				})
			]
		})]
	});
}), Py = Object.assign((e) => /* @__PURE__ */ U(G_, {
	isOpen: e.initiallyOpen,
	children: /* @__PURE__ */ U(vv, { ...e })
}), { DefaultMenuItem: iv }), Fy = y_(Py), Iy = Object.assign((e) => /* @__PURE__ */ U(G_, {
	showSearchInPopover: !0,
	isOpen: e.initiallyOpen,
	children: /* @__PURE__ */ U(Ly, { ...e })
}), { DefaultMenuItem: iv }), Ly = ({ trigger: e, entityName: t, emptyLabel: n, isInvalid: r = !1, value: i, onChange: a, mapToOption: o, paginatedFetcher: s, resolveValue: c, placeholder: l, debounceMs: u = 300, disabled: d = !1, onToggle: f, "data-testid": p }) => {
	let { searchTerm: m, setSearchTerm: h, setIsOpen: g } = W_(), _ = J(null), { options: v, isLoading: y, search: b, clearSearch: x, fetchMore: S, hasMore: C, isFetchingMore: w } = Oy({
		paginatedFetcher: s,
		mapToOption: o,
		debounceMs: u
	}), [T, E] = Y({}), D = J(/* @__PURE__ */ new Set()), [ee, te] = Y(0), O = JSON.stringify(i), ne = q(() => new Map(v.map((e) => [e.value, e])), [v]);
	K(() => {
		if (!c) return;
		let e = i.filter((e) => !ne.has(e) && !T[e] && !D.current.has(e));
		e.length !== 0 && (D.current = /* @__PURE__ */ new Set([...D.current, ...e]), te((e) => e + 1), c(e).then((e) => {
			E((t) => ({
				...t,
				...Object.fromEntries(e.map((e) => [e.value, e]))
			}));
		}).catch(() => {}).finally(() => te((e) => e - 1)));
	}, [
		O,
		ne,
		c,
		T
	]);
	let re = G((e) => i.includes(e), [i]), ie = G((e) => {
		a(re(e) ? i.filter((t) => t !== e) : [...i, e]);
	}, [
		i,
		re,
		a
	]), ae = G((e) => {
		h(e), b(e);
	}, [h, b]), oe = G((e) => {
		e || (h(""), x(), b("")), f?.(e);
	}, [
		h,
		x,
		b,
		f
	]), se = q(() => i.map((e) => {
		let t = ne.get(e) ?? T[e];
		return t ? {
			option: t,
			isLoading: !1
		} : {
			option: {
				label: "",
				value: e
			},
			isLoading: !0
		};
	}), [
		i,
		ne,
		T
	]), ce = q(() => v.filter((e) => !re(e.value)), [v, re]), { handleKeyDown: le, focusedOption: ue } = uv(ce, (e) => ie(e.value), () => g(!1));
	K(() => {
		let e = _.current;
		return e?.addEventListener("keydown", le, !1), () => {
			e?.removeEventListener("keydown", le, !1);
		};
	}, [le]);
	let de = se.length > 0 || ce.length > 0, fe = se.length === 1 && !!se.at(0)?.isLoading && ee > 0, pe = t ? /* @__PURE__ */ U(hv, {
		label: gv({
			options: se.map(({ option: e }) => e),
			values: i,
			entityName: t,
			emptyLabel: n ?? _v(t)
		}),
		hasSelection: i.length > 0,
		isInvalid: r,
		disabled: d,
		isLoading: fe,
		"data-testid": p ? `${p}.trigger` : void 0
	}) : null;
	return /* @__PURE__ */ U(cv, {
		trigger: e ?? pe,
		placeholder: l,
		initialFocusRef: _,
		searchTerm: m,
		setSearchTerm: ae,
		disabled: d,
		onToggle: oe,
		onScrollEnd: C ? S : void 0,
		isLoadingMore: y || w,
		searchInputPaddingLeft: "12px",
		"data-testid": p,
		children: de ? /* @__PURE__ */ W(H, { children: [
			se.map(({ option: e, isLoading: t }) => /* @__PURE__ */ U(iv, {
				option: e,
				isSelected: !0,
				isFocused: !1,
				isLoading: t,
				onSelect: () => ie(e.value),
				variant: "checkbox",
				scrollIntoView: !1,
				"data-testid": p ? `${p}.option.${e.value}` : void 0
			}, e.value)),
			se.length > 0 && ce.length > 0 && /* @__PURE__ */ U(Rr, {
				variant: "component-library",
				marginY: 0
			}),
			ce.map((e) => /* @__PURE__ */ U(iv, {
				option: e,
				isSelected: !1,
				isFocused: ue === e,
				onSelect: () => ie(e.value),
				variant: "checkbox",
				scrollIntoView: !1,
				isDisabled: e.disabled,
				"data-testid": p ? `${p}.option.${e.value}` : void 0
			}, e.value))
		] }) : null
	});
}, Ry = "new-tag::", zy = ({ onChange: e, value: t, options: n, allowCreate: r = !1, onCommitWithEnter: i, unavailableKeys: a, ...o }) => {
	let [s, c] = Y([]), [l, u] = Y(""), d = J(null), f = G((e) => {
		let t = e.trim();
		return n.some((e) => e.label === t) || s.some((e) => e.label === t) || !!a?.includes(t);
	}, [
		n,
		s,
		a
	]), p = G(() => {
		let t = l.trim();
		if (t === "" || f(l)) return;
		let n = {
			label: t,
			value: t
		};
		c((e) => [n, ...e]), e(n.value);
	}, [
		l,
		f,
		e
	]), m = q(() => {
		let e = n, t = new Set(e.map((e) => e.value)), r = s.filter((e) => !t.has(e.value));
		return [...e, ...r];
	}, [n, s]), h = l.trim() !== "", g = r && h ? {
		createLabel: `Add ${l}`,
		onCreate: p,
		isCreateDisabled: f
	} : {};
	K(() => {
		if (!r) return;
		let e = d.current;
		if (!e) return;
		let t = (t) => {
			if (t.key === "Enter") {
				let n = l.trim() !== "", r = e.dataset.hasFocusedOption === "true";
				n && !r && (t.preventDefault(), p()), i && window.setTimeout(() => i(), 0);
			} else if (t.key === "Tab") {
				let e = l.trim() !== "";
				if (e && f(l)) return;
				p(), e && i && (t.preventDefault(), window.setTimeout(() => i(), 0));
			}
		};
		return e.addEventListener("keydown", t), () => {
			e.removeEventListener("keydown", t);
		};
	}, [
		r,
		p,
		l,
		i,
		f
	]);
	let _ = !!t && !o.disabled;
	return /* @__PURE__ */ U(zv, {
		...o,
		...g,
		onClear: () => e(""),
		hideChevron: _,
		inputRef: d,
		onSearch: u,
		initialValue: t,
		onChange: e,
		options: m,
		isCreateDisabled: f
	});
}, By = y_(zy), Vy = ({ label: e, disabled: t, isChecked: n = !1, onChange: r, isIndeterminate: i = !1, "data-testid": a }) => {
	let o = qc(), s = J(null);
	return K(() => {
		s.current && (s.current.indeterminate = i);
	}, [i]), /* @__PURE__ */ W(B, {
		gap: "8px",
		alignItems: "start",
		...N,
		children: [/* @__PURE__ */ U("input", {
			"data-testid": a,
			type: "checkbox",
			id: o,
			checked: n,
			disabled: t,
			onChange: (e) => {
				t || (r?.(e), e.stopPropagation());
			},
			ref: s,
			style: {
				cursor: t ? "not-allowed" : "pointer",
				marginTop: "2px"
			}
		}), e && /* @__PURE__ */ U(R, {
			as: "label",
			htmlFor: o,
			cursor: t ? "not-allowed" : "pointer",
			children: e
		})]
	});
}, Hy = {
	isOpen: !1,
	focusedIndex: 0,
	searchTerm: "",
	currentItems: [],
	selectedItems: /* @__PURE__ */ new Set(),
	canGoBack: !1,
	title: "Add context"
}, Uy = ({ option: e, isSelected: t, isFocused: n, onSelect: r, showCheckmark: i = !0 }) => {
	let a = J(null);
	return K(() => {
		n && a.current?.scrollIntoView({ block: "nearest" });
	}, [n]), /* @__PURE__ */ W(B, {
		ref: a,
		onClick: r,
		background: n ? Fn : void 0,
		borderRadius: 6,
		_hover: { background: Fn },
		padding: 2,
		cursor: "pointer",
		gap: "4px",
		alignItems: "center",
		maxWidth: "100%",
		marginX: 1,
		children: [
			i && /* @__PURE__ */ U(B, {
				shrink: 0,
				children: /* @__PURE__ */ U(Vy, { isChecked: t })
			}),
			e.icon && /* @__PURE__ */ U(B, {
				shrink: 0,
				grow: 0,
				children: e.icon
			}),
			/* @__PURE__ */ U(B, {
				grow: 1,
				shrink: 1,
				overflow: "hidden",
				textOverflow: "ellipsis",
				gap: 2,
				alignItems: "flex-start",
				children: /* @__PURE__ */ W(B, {
					width: "100%",
					textAlign: "left",
					flexWrap: "wrap",
					columnGap: "6px",
					children: [/* @__PURE__ */ U(V, {
						as: "span",
						...N,
						...e.secondaryLabel ? {} : {
							width: "100%",
							overflow: "hidden",
							textOverflow: "ellipsis"
						},
						color: L,
						children: e.label
					}), e.secondaryLabel && /* @__PURE__ */ U(V, {
						as: "span",
						...N,
						color: "#64748b",
						children: e.secondaryLabel
					})]
				})
			})
		]
	});
}, Wy = ({ trigger: e, options: t, onSelect: n, onUnselect: r, placeholder: i = "Search", onClose: a }) => {
	let [o, s] = Y({
		...Hy,
		isOpen: !0
	}), c = J(null), l = J(null), u = t.map((e) => ({
		label: e.label,
		value: e.value,
		icon: e.icon,
		searchValues: e.searchValues
	}));
	Jc({
		ref: c,
		handler: G(() => {
			a();
		}, [a])
	}), K(() => {
		o.isOpen && o.currentItems.length === 0 && s((e) => ({
			...e,
			currentItems: u,
			focusedIndex: 0
		}));
	}, [
		o.isOpen,
		o.currentItems.length,
		u
	]);
	let d = o.currentItems.filter((e) => {
		if (!o.searchTerm.trim()) return !0;
		let t = o.searchTerm.toLowerCase();
		return e.label.toLowerCase().includes(t) || e.searchValues?.some((e) => e.toLowerCase().includes(t));
	}), f = o.searchTerm.trim() && d.length === 0, p = G((e) => {
		if (!o.canGoBack && e.value !== "current-page") {
			let n = t.find((t) => t.value === e.value);
			if (n && (n.options || n.footerOptions)) {
				let e = [...n.options || [], ...n.footerOptions || []];
				s((t) => ({
					...t,
					currentItems: e,
					canGoBack: !0,
					title: n.label,
					searchTerm: "",
					focusedIndex: 0
				}));
				return;
			}
		}
		s((t) => {
			let i = new Set(t.selectedItems);
			return i.has(e.value) ? (i.delete(e.value), r(e.value)) : (i.add(e.value), n(e.value)), {
				...t,
				selectedItems: i
			};
		});
	}, [
		o.canGoBack,
		t,
		n
	]), m = G(() => {
		o.canGoBack && s((e) => ({
			...e,
			currentItems: u,
			canGoBack: !1,
			title: "Add context",
			searchTerm: "",
			focusedIndex: 0
		}));
	}, [o.canGoBack, u]);
	return K(() => {
		if (!o.isOpen) return;
		let e = (e) => {
			let t = document.activeElement;
			if (!(!c.current?.contains(t) && t !== l.current)) switch (e.key) {
				case "ArrowDown":
					e.preventDefault(), s((e) => ({
						...e,
						focusedIndex: e.focusedIndex >= d.length - 1 ? 0 : e.focusedIndex + 1
					}));
					break;
				case "ArrowUp":
					e.preventDefault(), s((e) => ({
						...e,
						focusedIndex: e.focusedIndex <= 0 ? d.length - 1 : e.focusedIndex - 1
					}));
					break;
				case "Enter":
					e.preventDefault(), d[o.focusedIndex] && p(d[o.focusedIndex]);
					break;
				case "Escape":
					e.preventDefault(), a();
					break;
				case "Backspace":
					!o.searchTerm && o.canGoBack && (e.preventDefault(), m());
					break;
			}
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [
		o.isOpen,
		o.focusedIndex,
		o.searchTerm,
		o.canGoBack,
		d,
		p,
		m
	]), K(() => {
		o.isOpen && l.current && setTimeout(() => {
			l.current?.focus();
		}, 100);
	}, [o.isOpen]), /* @__PURE__ */ W(mi, {
		placement: "top-start",
		isOpen: o.isOpen,
		isLazy: !0,
		computePositionOnMount: !0,
		flip: !1,
		children: [/* @__PURE__ */ U(bi, { children: e }), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ W(vi, {
			minWidth: 250,
			width: "280px",
			maxHeight: 400,
			overflowX: "hidden",
			borderRadius: 8,
			paddingTop: 0,
			fontSize: "13px",
			ref: c,
			border: `1px solid ${P}`,
			bg: I,
			boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.08)",
			children: [/* @__PURE__ */ W(B, {
				direction: "column",
				position: "sticky",
				top: 0,
				bg: I,
				zIndex: 1,
				children: [o.canGoBack && /* @__PURE__ */ W(B, {
					alignItems: "center",
					p: 2,
					borderBottom: "1px solid #e2e8f0",
					gap: 2,
					children: [/* @__PURE__ */ U(B, {
						as: "button",
						alignItems: "center",
						p: 1,
						borderRadius: 4,
						cursor: "pointer",
						_hover: { bg: "#f1f5f9" },
						onClick: m,
						children: /* @__PURE__ */ U(op, { color: "#334155" })
					}), /* @__PURE__ */ U(V, {
						...j,
						color: "#334155",
						children: o.title
					})]
				}), /* @__PURE__ */ U(B, {
					p: "4px",
					borderBottom: f ? "none" : `1px solid ${P}`,
					children: /* @__PURE__ */ U(Q_, {
						ref: l,
						value: o.searchTerm,
						onChange: (e) => s((t) => ({
							...t,
							searchTerm: e,
							focusedIndex: 0
						})),
						height: "32px",
						placeholder: i,
						showDivider: !1
					})
				})]
			}), /* @__PURE__ */ U(B, {
				overflowY: "auto",
				paddingY: 1,
				gap: 1,
				direction: "column",
				children: d.map((e, t) => {
					let n = !o.canGoBack && e.value !== "current-page";
					return /* @__PURE__ */ U(Uy, {
						option: e,
						isSelected: o.selectedItems.has(e.value),
						isFocused: t === o.focusedIndex,
						onSelect: () => p(e),
						showCheckmark: !n
					}, e.value);
				})
			})]
		}) })]
	});
}, Gy = mc(({ options: e, onSelect: t, onUnselect: n, onClose: r, icon: i, labelWhenNoSelection: a, placeholder: o = "Search", errorMessage: s, disabled: c = !1, "data-testid": l, iconOnly: u = !1 }, d) => {
	let [f, p] = Y(!1), m = /* @__PURE__ */ U(B, {
		as: "button",
		ref: d,
		onClick: () => p(!0),
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p(!0));
		},
		cursor: c ? "default" : "pointer",
		height: "fit-content",
		border: "none",
		background: "transparent",
		padding: 0,
		margin: 0,
		borderRadius: "6px",
		tabIndex: c ? -1 : 0,
		transition: "box-shadow 0.2s ease-in-out",
		_focus: {
			boxShadow: "none",
			outline: "none"
		},
		_focusVisible: {
			boxShadow: `0 0 0 2px ${et}`,
			outline: "none",
			_disabled: { boxShadow: "none" }
		},
		disabled: c,
		children: /* @__PURE__ */ U(vy, {
			disabled: c,
			icon: i,
			interactive: !0,
			error: !!s,
			"data-testid": l,
			children: u ? void 0 : s ?? a
		})
	});
	return f ? /* @__PURE__ */ U(Wy, {
		trigger: m,
		options: e,
		onSelect: t,
		onUnselect: n,
		placeholder: o,
		onClose: () => {
			r?.(), p(!1);
		}
	}) : m;
}), Ky = (e) => /* @__PURE__ */ U(Ey, {
	...e,
	icon: (e) => U(e ? Yp : Hp, { color: "inherit" }),
	iconSide: "trailing"
}), qy = (e) => {
	let [t, n] = Y(), [r, i] = Y({
		days: 0,
		months: 0,
		years: 0
	}), a = G(() => {
		if (ol(r, e.minDuration)) {
			n(`Minimum duration is ${il(e.minDuration)}`);
			return;
		}
		if (!r.days && !r.months && !r.years) {
			e.onDurationSelected(e.selectedDuration);
			return;
		}
		e.onDurationSelected({
			days: r.days ? r.days - 1 : -1,
			months: r.months || 0,
			years: r.years || 0
		});
	}, [
		e.onDurationSelected,
		r,
		e.selectedDuration,
		e.minDuration
	]), o = J(null);
	return Jc({
		ref: o,
		handler: () => {
			if (!r.days && !r.months && !r.years) {
				e.onDurationSelected(e.selectedDuration);
				return;
			}
			a();
		}
	}), /* @__PURE__ */ W(R, {
		ref: o,
		width: "194px",
		children: [/* @__PURE__ */ W(B, {
			gap: "8px",
			...N,
			color: Ft,
			alignItems: "center",
			onKeyDown: (t) => {
				if (t.key === "Enter") {
					a();
					return;
				}
				if (t.key === "Escape") {
					e.onDurationSelected(e.selectedDuration);
					return;
				}
			},
			children: [
				/* @__PURE__ */ U(Qy, {
					autoFocus: !0,
					preventScrollOnAutoFocus: !0,
					label: "Years",
					type: "number",
					"data-testid": `${e["data-testid"]}.years`,
					height: "32px",
					width: "56px",
					value: r.years || "",
					placeholder: "0",
					isInvalid: !!t,
					onChange: (e) => {
						n((e) => e && null), i((t) => ({
							...t,
							years: Math.max(parseInt(e.target.value), 0)
						}));
					},
					onBlur: (e) => {
						e.stopPropagation();
					}
				}),
				/* @__PURE__ */ U(Qy, {
					label: "Months",
					type: "number",
					"data-testid": `${e["data-testid"]}.months`,
					height: "32px",
					width: "56px",
					value: r.months || "",
					placeholder: "0",
					isInvalid: !!t,
					onChange: (e) => {
						n((e) => e && null), r.years && r.years, i((t) => ({
							...t,
							months: Math.max(parseInt(e.target.value), 0)
						}));
					},
					onBlur: (e) => {
						e.stopPropagation();
					}
				}),
				/* @__PURE__ */ U(Qy, {
					label: "Days",
					type: "number",
					"data-testid": `${e["data-testid"]}.days`,
					height: "32px",
					width: "56px",
					value: r.days || "",
					placeholder: "0",
					isInvalid: !!t,
					onChange: (e) => {
						n((e) => e && null), i((t) => ({
							...t,
							days: e.target.value ? Math.max(parseInt(e.target.value), 0) : void 0
						}));
					},
					onBlur: (e) => {
						e.stopPropagation();
					}
				})
			]
		}), t && /* @__PURE__ */ U(R, { children: /* @__PURE__ */ U(R, {
			"data-testid": `${e["data-testid"]}.error`,
			color: "#dc2626",
			...N,
			marginTop: "8px",
			children: t
		}) })]
	});
}, Jy = R_, Yy = (e) => {
	if (e.selectedOption === "CURRENT_CUSTOM") return e.availableOptions.find((t) => t.value === e.selectedOption)?.label;
	if (e.isDurationPickerOpen) return "Choose duration...";
	if (e.isDatePickerOpen) return "Choose date...";
}, Xy = ({ value: e, name: t, onChange: n, mode: r, isDisabled: i, fromDate: a = /* @__PURE__ */ new Date(), durations: o, minDate: s, minDuration: c = {
	months: 0,
	years: 0,
	days: 2
}, width: l = "226px", height: u = "36px", showAbsoluteDate: d = !1, durationFilterFn: f, "data-testid": p, trailingIcon: m }) => {
	let h = z_({
		value: e,
		mode: r,
		onChange: n,
		fromDate: a,
		durations: o,
		showAbsoluteDate: d,
		durationFilterFn: f
	}), g = Yy({
		selectedOption: h.selectedOption,
		availableOptions: h.availableOptions,
		isDurationPickerOpen: h.durationPickerPopoverOpen,
		isDatePickerOpen: h.datePickerPopoverOpen
	});
	return Jc({
		ref: h.refs.popover,
		enabled: !h.durationPickerPopoverOpen,
		handler: () => {
			h.closePopover();
		}
	}), /* @__PURE__ */ W(mi, {
		variant: "dateRange",
		isOpen: h.datePickerPopoverOpen || h.durationPickerPopoverOpen,
		placement: "bottom-start",
		autoFocus: !0,
		returnFocusOnClose: !1,
		closeOnBlur: !1,
		isLazy: !0,
		lazyBehavior: "unmount",
		children: [/* @__PURE__ */ U(hi, { children: /* @__PURE__ */ U(R, { children: /* @__PURE__ */ U(ei, {
			variant: "input-in-group-2",
			width: l,
			height: u,
			tabIndex: -1,
			position: "relative",
			transition: "border-color 0.2s ease-in-out",
			isolation: "auto",
			children: /* @__PURE__ */ U(zv, {
				name: t,
				inputRef: h.refs.input,
				value: h.selectedDate || h.selectedOption === "FOREVER" ? h.selectedOption : void 0,
				triggerStyle: {
					width: l,
					...N
				},
				overrideSelectedLabel: g,
				onChange: h.handleInputSelection,
				options: h.availableOptions,
				disabled: i,
				matchWidth: !0,
				placeholder: "Select duration",
				"data-testid": p,
				trailingIcon: m
			})
		}) }) }), (h.datePickerPopoverOpen || h.durationPickerPopoverOpen) && /* @__PURE__ */ U(vi, { children: /* @__PURE__ */ W(_i, {
			ref: h.refs.popover,
			children: [h.datePickerPopoverOpen && /* @__PURE__ */ U(L_, {
				selectedDate: h.selectedDate ?? /* @__PURE__ */ new Date(),
				onDateSelected: h.handlePickerSelection,
				minDate: s ?? gl(Zc(a, c), { days: 1 }),
				"data-testid": `${p}.calendar`
			}), h.durationPickerPopoverOpen && /* @__PURE__ */ U(qy, {
				minDuration: c,
				selectedDuration: h.selectedDuration ?? {
					years: 0,
					months: 1,
					days: -1
				},
				onDurationSelected: h.handleDurationPickerSelection,
				"data-testid": `${p}.durationPicker`
			})]
		}) })]
	});
}, Zy = y_(Lg), Qy = y_(Hg), $y = y_(l_), eb = y_(Qg), tb = y_(i_), nb = y_($g), rb = y_(Ug), ib = y_(b_), ab = y_(F_), ob = y_(Xv), sb = y_(Xy), cb = y_(Zv), lb = y_(Qv), ub = y_($v), db = y_(oy), fb = y_(ly), pb = ({ validationErrors: e, "data-testid": t }) => {
	let n = e?.at(0);
	return n ? /* @__PURE__ */ U(V, {
		...N,
		color: Un,
		"data-testid": t,
		children: n.message
	}) : null;
}, mb = 40, hb = ({ children: e, maxHeight: t, height: n, "data-testid": r }) => {
	let [i, a] = Y(null), o = J(null), s = G((e) => {
		if (e.scrollHeight <= e.clientHeight) {
			a(0);
			return;
		}
		let t = e.scrollHeight - e.scrollTop - e.clientHeight;
		a(t < mb ? t : null);
	}, []);
	return yc(() => {
		o.current && s(o.current);
	}, [s]), /* @__PURE__ */ W(R, {
		maxHeight: t,
		height: n,
		position: "relative",
		overflowY: "hidden",
		"data-testid": r,
		children: [/* @__PURE__ */ U(R, {
			overflowY: "auto",
			maxHeight: t,
			height: "100%",
			onScroll: (e) => {
				s(e.currentTarget);
			},
			ref: o,
			children: e
		}), /* @__PURE__ */ U(R, {
			position: "absolute",
			left: "0",
			width: "100%",
			height: `${mb}px`,
			bgGradient: "linear(to-b, rgba(255, 255, 255, 0.00), #FFF)",
			pointerEvents: "none",
			bottom: i === null ? 0 : `-${mb - i}px`
		})]
	});
}, gb = 120, _b = 234, vb = 33, yb = 16, bb = ({ title: e, actions: t }) => {
	let n = Cc(t, "status"), [r, i] = Y("all"), a = Math.max(Math.min(_b, yb + t.length * vb), gb), o = [
		{
			label: `All\u00A0\u00A0${t.length}`,
			value: "all"
		},
		{
			label: `Success\u00A0\u00A0${n.success ?? 0}`,
			value: "success"
		},
		...n.skipped ? [{
			label: `Skipped\u00A0\u00A0${n.skipped ?? 0}`,
			value: "skipped"
		}] : [],
		{
			label: `Failed\u00A0\u00A0${n.failure ?? 0}`,
			value: "failure"
		}
	], s = r === "all" ? t : t.filter((e) => e.status === r), c = Ec([(e) => ({
		success: 3,
		skipped: 2,
		failure: 1
	})[e.status]])(s);
	return /* @__PURE__ */ W(B, {
		gap: "16px",
		paddingTop: "16px",
		flexDirection: "column",
		children: [/* @__PURE__ */ U(R, {
			padding: "0 16px",
			children: /* @__PURE__ */ U(ly, {
				"data-testid": "bulkActionList.tabs",
				fullWidth: !0,
				options: o,
				onChange: i
			})
		}), c.length === 0 ? /* @__PURE__ */ U(R, {
			padding: "0 16px",
			children: /* @__PURE__ */ W(B, {
				marginBottom: "16px",
				"data-testid": `bulkActionList.${r}.empty`,
				borderRadius: "6px",
				backgroundColor: A,
				alignItems: "center",
				justifyContent: "center",
				height: a + 12,
				...j,
				color: F,
				children: ["No matching ", wc(e.toLowerCase(), 2)]
			})
		}) : /* @__PURE__ */ W(R, { children: [/* @__PURE__ */ U(V, {
			...j,
			color: F,
			padding: "0 16px 12px",
			children: e
		}), /* @__PURE__ */ U(hb, {
			"data-testid": `bulkActionList.${r}.table`,
			height: a,
			children: c.map((e) => /* @__PURE__ */ U(R, {
				padding: "0 16px",
				children: /* @__PURE__ */ W(B, {
					borderTop: `1px solid ${P}`,
					py: 1,
					alignItems: "center",
					"data-testid": `bulkActionList.action.${e.id}`,
					children: [/* @__PURE__ */ U(R, {
						flex: 1,
						fontSize: 13,
						children: e.title
					}), /* @__PURE__ */ U(ig, {
						sentiment: xb[e.status],
						children: Sb[e.status]
					})]
				})
			}, e.id))
		})] })]
	});
}, xb = {
	success: "success",
	skipped: "neutral",
	failure: "error"
}, Sb = {
	success: "Successful",
	skipped: "Skipped",
	failure: "Failed"
}, Cb = ({ actions: e, title: t, listTitle: n, status: r, onDismiss: i, onChangeReviewing: a, isReviewing: o = !1, cancelAction: s = {}, showReview: c = !0 }) => {
	let l = Cc(e, "status");
	return /* @__PURE__ */ W(R, {
		backgroundColor: "white",
		"data-testid": "bulkActions",
		children: [/* @__PURE__ */ U(R, {
			px: 4,
			children: /* @__PURE__ */ U(ex, {
				title: t,
				status: r,
				counts: {
					success: l.success ?? 0,
					failure: l.failure ?? 0,
					skipped: l.skipped ?? 0
				},
				isReviewing: o,
				onChangeReviewing: a,
				onDismiss: i,
				onCancel: s.available && s.handler ? s.handler : void 0,
				isCancelling: s.isRunning,
				showReview: c
			})
		}), c && o && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Rr, { color: "#e2e8f0" }), /* @__PURE__ */ U(R, {
			"data-testid": "bulkActionsList",
			children: /* @__PURE__ */ U(bb, {
				title: n,
				actions: Eb(e)
			})
		})] })]
	});
}, wb = ({ children: e }) => /* @__PURE__ */ U(R, {
	position: "absolute",
	w: "420px",
	bottom: "20px",
	background: "white",
	left: "50%",
	transform: "translateX(-50%)",
	borderRadius: "8px",
	boxShadow: yn,
	border: "1px solid",
	borderColor: M,
	overflow: "hidden",
	children: e
});
function Tb(e) {
	return e.status !== "pending";
}
function Eb(e) {
	return e.filter(Tb);
}
//#endregion
//#region src/components/SequenceMenu/useMousePosition.tsx
var Db = () => {
	let [e, t] = Y({
		x: 0,
		y: 0
	}), n = J(!1), r = Fl(G((e) => {
		t({
			x: e.clientX,
			y: e.clientY
		}), n.current = !0;
	}, []), n.current ? 150 : 0);
	return K(() => (window.addEventListener("mousemove", r), () => {
		window.removeEventListener("mousemove", r);
	}), [r]), e;
}, Ob = ({ subMenu: e, showSubmenuOnLeft: t }) => {
	let { x: n, y: r } = Db(), { height: i, width: a, x: o, y: s } = e.getBoundingClientRect(), c = t ? n - o + 4 : o - n + 4, l = i, u = `M 0, ${r - s} 
            L ${c},${l}  
            L ${c},0 z`, d = `M ${c}, ${r - s} 
            L 0,${l}  
            L 0,0 z`;
	return /* @__PURE__ */ W("svg", {
		style: {
			position: "fixed",
			width: c,
			height: i,
			pointerEvents: "none",
			zIndex: 2,
			top: s,
			left: t ? o + a - 2 : n - 2
		},
		children: [/* @__PURE__ */ U("path", {
			pointerEvents: "none",
			width: "100%",
			height: "100%",
			fill: "transparent",
			d: `M 0,0 L ${c},0 L ${c},${l} L 0,${l} z`
		}), /* @__PURE__ */ U("path", {
			pointerEvents: "auto",
			fill: "transparent",
			d: t ? d : u
		})]
	});
}, kb = ({ children: e, refMenu: t, width: n, maxHeight: r, overflowY: i, "data-testid": a, ...o }) => /* @__PURE__ */ U(B, {
	ref: t,
	flexDirection: "column",
	width: `${n}px`,
	border: `${M} 1px solid`,
	borderRadius: "8px",
	padding: "4px",
	background: I,
	boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
	zIndex: "1",
	maxHeight: r,
	overflowY: i,
	_focus: { outline: "none" },
	"data-testid": a,
	...o,
	children: e
}), Ab = "data-sequence-menu-item", jb = "data-sequence-submenu-trigger", Mb = "data-sequence-submenu-side", Nb = "data-sequence-submenu-item", Pb = ({ background: e, setIsOpen: t, isDisabled: n, selected: r, navigable: i, subMenuTriggerUuid: a, subMenuSide: o, subMenuParentUuid: s, onOpenSubMenu: c, ...l }) => {
	let u = !!(l.subItems?.length || l.renderSubMenu);
	return /* @__PURE__ */ W(Or, {
		...i ? { [Ab]: "true" } : {},
		"data-testid": l["data-testid"],
		...a ? {
			[jb]: a,
			[Mb]: o
		} : {},
		...s ? { [Nb]: s } : {},
		variant: "unstyled",
		width: "100%",
		textAlign: "left",
		padding: "8px",
		color: L,
		isDisabled: n,
		_hover: n ? void 0 : { background: Fn },
		_focus: n ? void 0 : {
			background: Fn,
			boxShadow: "none"
		},
		_active: u || n ? void 0 : {
			background: C,
			color: I
		},
		background: r ? Fn : e,
		transition: "none",
		cursor: "pointer",
		alignItems: "center",
		gap: "8px",
		display: "flex",
		flexDirection: "row",
		height: "initial",
		...l.style,
		onClick: (e) => {
			if (!n) {
				if (u) {
					c?.();
					return;
				}
				l.onClick?.(e), t?.(!1);
			}
		},
		children: [
			l.iconLeft && /* @__PURE__ */ U(z, {
				flexShrink: "0",
				children: l.iconLeft
			}),
			/* @__PURE__ */ U(V, {
				...N,
				flex: "1",
				color: "inherit",
				textOverflow: "ellipsis",
				overflow: "hidden",
				...l.labelStyle,
				children: l.label
			}),
			l.iconRight && /* @__PURE__ */ U(z, {
				flexShrink: "0",
				children: l.iconRight
			}),
			u && /* @__PURE__ */ U(z, {
				flexShrink: "0",
				children: /* @__PURE__ */ U(qp, { color: "#64748b" })
			})
		]
	});
}, Fb = () => /* @__PURE__ */ U(R, {
	mx: "-4px",
	height: "1px",
	background: P,
	my: "4px"
}), Ib = ({ menuLeft: e, menuRight: t, subMenuWidth: n, windowWidth: r }) => r > t + n ? "right" : e > n ? "left" : "overlay", Lb = ({ itemTop: e, itemBottom: t, subMenuHeight: n, windowHeight: r }) => {
	let i = e + n <= r, a = t - n >= 0;
	return !i && a;
}, Rb = {
	right: ({ menuWidth: e }) => `${e - 2 - 8}px`,
	left: ({ subMenuWidth: e }) => `-${e + 32 + 8}px`,
	overlay: () => "-8px"
}, zb = ({ visibleSubMenuUuid: e, setVisibleSubMenuUuid: t, width: n = 220, setIsOpen: r, subItems: i, "data-testid": a, destructive: o, selected: s, canFlip: c = !1, ...l }) => {
	let u = J(null), d = J(null), [f, p] = Y(!1), m = e ? (i || l.renderSubMenu) && e === l.uuid : f, h = l.subMenuWidth ?? n, [g, _] = Y("right"), [v, y] = Y(!1);
	yc(() => {
		let e = d.current?.getBoundingClientRect();
		_(Ib({
			menuLeft: e?.left ?? 0,
			menuRight: e?.right ?? 0,
			subMenuWidth: h,
			windowWidth: window.innerWidth
		})), y(c && Lb({
			itemTop: e?.top ?? 0,
			itemBottom: e?.bottom ?? 0,
			subMenuHeight: u.current?.offsetHeight ?? 0,
			windowHeight: window.innerHeight
		}));
	});
	let b = g === "left", x = q(() => i?.filter((e) => !e.hidden), [i]), S = !!(x?.length || l.renderSubMenu), C = () => {
		t?.(l.uuid), p(!0);
	};
	return /* @__PURE__ */ U(l.tooltip ? m_ : uc, {
		...l.tooltip ? {
			label: l.tooltip,
			placement: "right",
			...a ? { "data-testid": `${a}.tooltip` } : {}
		} : {},
		children: /* @__PURE__ */ W(R, {
			ref: d,
			position: "relative",
			onMouseEnter: C,
			onMouseLeave: () => {
				t?.(void 0), p(!1);
			},
			"data-testid": a,
			"data-disabled": l.isDisabled ? "true" : void 0,
			children: [
				/* @__PURE__ */ U(Pb, {
					...l,
					style: {
						color: o ? En : l.style?.color,
						...l.style ?? {}
					},
					subItems: x,
					background: m ? Fn : void 0,
					selected: s,
					setIsOpen: r,
					navigable: !0,
					subMenuTriggerUuid: S ? l.uuid : void 0,
					subMenuSide: b ? "left" : "right",
					onOpenSubMenu: C
				}),
				m && u.current && /* @__PURE__ */ U(Ob, {
					subMenu: u.current,
					showSubmenuOnLeft: b
				}),
				S && n && /* @__PURE__ */ U(R, {
					position: "absolute",
					left: Rb[g]({
						menuWidth: n,
						subMenuWidth: h
					}),
					top: v ? void 0 : "-37px",
					bottom: v ? "-37px" : void 0,
					paddingTop: "32px",
					paddingBottom: "32px",
					paddingLeft: b ? "32px" : "8px",
					paddingRight: b ? "8px" : "32px",
					pointerEvents: m ? "auto" : "none",
					children: /* @__PURE__ */ W(kb, {
						refMenu: u,
						visibility: m ? "visible" : "hidden",
						width: h,
						maxHeight: "80vh",
						"data-testid": a && `${a}.subMenu`,
						children: [l.subItemsHeader && /* @__PURE__ */ W(H, { children: [l.subItemsHeader, /* @__PURE__ */ U(Fb, {})] }), /* @__PURE__ */ W(R, {
							overflowY: "auto",
							maxHeight: "calc(80vh - 60px)",
							children: [l.renderSubMenu?.({ closeMenu: () => r?.(!1) }), x?.map((e, t) => /* @__PURE__ */ W(uc, { children: [/* @__PURE__ */ U(Bb, {
								...e,
								setIsOpen: r,
								subMenuParentUuid: l.uuid
							}), e.divider && /* @__PURE__ */ U(Fb, {})] }, e["data-testid"] ?? `${t}-${e.label}`))]
						})]
					})
				})
			]
		})
	});
}, Bb = ({ setIsOpen: e, subMenuParentUuid: t, ...n }) => {
	let r = /* @__PURE__ */ U(Pb, {
		...n,
		setIsOpen: e,
		subMenuParentUuid: t
	});
	if (!n.tooltip) return r;
	let i = n["data-testid"];
	return /* @__PURE__ */ U(m_, {
		label: n.tooltip,
		placement: "left",
		shouldWrapChildren: !1,
		...i ? { "data-testid": `${i}.tooltip` } : {},
		children: /* @__PURE__ */ U(R, { children: r })
	});
}, Vb = ({ itemCount: e, onSelect: t, highlightFirstItemOnOpen: n = !1 }) => {
	let r = n ? 0 : null, [i, a] = Y(r), [o, s] = Y(e);
	return e !== o && (s(e), a(r)), {
		activeIndex: i,
		setActiveIndex: a,
		handleKeyDown: G((n) => e !== 0 && X(n.key).with("ArrowUp", () => (a((t) => t === null ? e - 1 : (t + e - 1) % e), !0)).with("ArrowDown", () => (a((t) => t === null ? 0 : (t + 1) % e), !0)).with("Enter", () => i === null ? !1 : (t(i), !0)).otherwise(() => !1), [
			i,
			e,
			t
		])
	};
}, Hb = (e, t) => e === "ArrowRight" || t === "left" && e === "ArrowLeft", Ub = (e) => e === "left" ? "ArrowRight" : "ArrowLeft", Wb = ({ alignment: e, menuButtonTop: t, menuButtonBottom: n, menuHeight: r, offsetY: i, windowHeight: a }) => {
	let o = n + i + r <= a, s = t - i - r >= 0;
	return o || !s ? e : X(e).returnType().with("bottom-left", () => "top-left").with("bottom-center", () => "top-center").with("bottom-right", () => "top-right").otherwise(() => e);
}, Gb = (e) => X(e).with("bottom-left", () => "top left").with("bottom-center", () => "top center").with("bottom-right", () => "top right").with("top-left", () => "bottom left").with("top-center", () => "bottom center").with("top-right", () => "bottom right").exhaustive(), Kb = ({ items: e, refMenuButton: t, setIsOpen: n, "data-testid": r, closeMenuOnItemClick: i, canFlip: a = !1, ...o }) => {
	let [s, c] = Y(), l = q(() => Array.isArray(e) ? e.reduce((e, t) => qb(t) ? t.hidden ? e : [...e, {
		...t,
		uuid: `menu-item-${e.length}`
	}] : [...e, t], []) : e, [e]), u = J(null), [d, f] = Y(), p = G(() => Array.from(u.current?.querySelectorAll("[data-sequence-menu-item]:not([disabled]):not([aria-disabled=\"true\"])") ?? []), []), m = G((e) => Array.from(u.current?.querySelectorAll(`[data-sequence-submenu-item="${e}"]:not([disabled]):not([aria-disabled="true"])`) ?? []), []), [h, g] = Y(0), [_, v] = Y(null), [y, b] = Y(0), { activeIndex: x, handleKeyDown: S } = Vb({
		itemCount: h,
		onSelect: (e) => p()[e]?.click()
	});
	K(() => {
		if (!t.current || !u.current) return;
		let [e, n] = o.offset, { x: r, y: i, height: s, width: c } = t.current.getBoundingClientRect(), { height: l, width: d } = u.current.getBoundingClientRect(), p = a ? u.current.offsetHeight : l, m = a ? Wb({
			alignment: o.alignment,
			menuButtonTop: i,
			menuButtonBottom: i + s,
			menuHeight: p,
			offsetY: n,
			windowHeight: window.innerHeight
		}) : o.alignment;
		X(m).with("bottom-left", () => {
			f({
				alignment: m,
				left: `${r + e + window.scrollX}px`,
				top: `${i + s + n + window.scrollY}px`
			});
		}).with("bottom-center", () => {
			f({
				alignment: m,
				left: `${r + e + c / 2 - d / 2 + window.scrollX}px`,
				top: `${i + s + n + window.scrollY}px`
			});
		}).with("bottom-right", () => {
			f({
				alignment: m,
				left: `${r + e + c - d + window.scrollX}px`,
				top: `${i + s + n + window.scrollY}px`
			});
		}).with("top-left", () => {
			f({
				alignment: m,
				left: `${r + e + window.scrollX}px`,
				top: `${i - p - n + window.scrollY}px`
			});
		}).with("top-center", () => {
			f({
				alignment: m,
				left: `${r + e + c / 2 - d / 2 + window.scrollX}px`,
				top: `${i - p - n + window.scrollY}px`
			});
		}).with("top-right", () => {
			f({
				alignment: m,
				left: `${r + e + c - d + window.scrollX}px`,
				top: `${i - p - n + window.scrollY}px`
			});
		}).exhaustive();
	}, [
		o.alignment,
		o.offset,
		t,
		a
	]), K(() => {
		g(p().length);
	}), K(() => {
		if (!(!d || h === 0 || _)) {
			if (x === null) {
				u.current?.focus();
				return;
			}
			p()[x]?.focus();
		}
	}, [
		d,
		h,
		x,
		p,
		_
	]), K(() => {
		_ && m(_.uuid)[y]?.focus();
	}, [
		_,
		y,
		m
	]), K(() => {
		_ && s !== _.uuid && v(null);
	}, [_, s]);
	let C = (e, t) => {
		let n = Ub(t.side);
		if (e.key === n) {
			v(null), c(void 0), e.preventDefault();
			return;
		}
		let r = m(t.uuid), i = r.length;
		i !== 0 && X(e.key).with("ArrowUp", () => {
			b((e) => (e + i - 1) % i), e.preventDefault();
		}).with("ArrowDown", () => {
			b((e) => (e + 1) % i), e.preventDefault();
		}).with("Enter", () => {
			r[y]?.click(), e.preventDefault();
		}).otherwise(() => {});
	};
	return /* @__PURE__ */ U(Nl.div, {
		style: {
			position: "absolute",
			left: d?.left,
			top: d?.top,
			visibility: d ? void 0 : "hidden",
			transformOrigin: Gb(d?.alignment ?? o.alignment),
			zIndex: 1
		},
		initial: {
			opacity: 0,
			scale: .95
		},
		animate: {
			opacity: 1,
			scale: 1
		},
		exit: {
			opacity: 0,
			scale: .95
		},
		transition: {
			duration: .12,
			ease: "easeOut"
		},
		children: /* @__PURE__ */ U(kb, {
			refMenu: u,
			width: o.width,
			"data-testid": `${r}.menuItems`,
			role: "menu",
			tabIndex: -1,
			onKeyDown: (e) => {
				if (h === 0) return;
				if (e.key === "Escape") {
					n(!1), t.current?.focus();
					return;
				}
				if (_) {
					C(e, _);
					return;
				}
				let r = x === null ? void 0 : p()[x], i = r?.getAttribute(jb), a = r?.getAttribute("data-sequence-submenu-side") === "left" ? "left" : "right";
				if (i && Hb(e.key, a) && m(i).length > 0) {
					c(i), v({
						uuid: i,
						side: a
					}), b(0), e.preventDefault();
					return;
				}
				S(e) && e.preventDefault();
			},
			onClick: () => {
				i && n(!1);
			},
			children: Array.isArray(l) ? l.map((e) => Jb(e) ? /* @__PURE__ */ W(uc, { children: [/* @__PURE__ */ U(zb, {
				...e,
				visibleSubMenuUuid: s,
				setVisibleSubMenuUuid: c,
				setIsOpen: n,
				width: o.width,
				canFlip: a
			}), e.divider && /* @__PURE__ */ U(Fb, {})] }, e.uuid) : typeof e == "function" ? e({
				...o,
				setIsOpen: n
			}) : hc(e) ? e : null) : l
		})
	});
}, qb = (e) => e.label !== void 0, Jb = (e) => e.uuid !== void 0, Yb = ({ isOpen: e, setIsOpen: t }) => /* @__PURE__ */ U(R, {
	position: "fixed",
	top: "0",
	left: "0",
	width: "100vw",
	height: "100vh",
	onClick: (n) => {
		n.stopPropagation(), t(!e);
	}
}), Xb = Object.assign(({ menuButton: e, items: t, onOpenChange: n, offset: r = [0, 4], alignment: i = "bottom-left", width: a = 220, "data-testid": o, closeMenuOnItemClick: s, "aria-label": c, variant: l, disabled: u = !1, buttonSize: d, buttonIcon: f, canFlip: p }) => {
	let m = J(null), [h, g] = Y(!1), _ = G((e) => {
		g(e);
		let t = typeof e == "function" ? e(h) : e;
		n?.(t);
	}, [h, n]), v = e ?? /* @__PURE__ */ U(Q, {
		variant: l ?? "secondary",
		"aria-label": c ?? "menu",
		size: d === "small" ? "24px" : "32px",
		icon: f ?? /* @__PURE__ */ U(mm, { color: "#64748b" }),
		disabled: u
	});
	return /* @__PURE__ */ W(H, { children: [dc(v, {
		ref: m,
		onClick: G((e) => {
			_((e) => !e), typeof v.props.onClick == "function" && v.props.onClick(e), e.stopPropagation();
		}, [v, _]),
		...o ? { "data-testid": o } : {}
	}), /* @__PURE__ */ U(jl, { children: h && /* @__PURE__ */ W(Si, { children: [/* @__PURE__ */ U(Kb, {
		items: t,
		refMenuButton: m,
		setIsOpen: _,
		alignment: i,
		offset: r,
		width: a,
		"data-testid": o,
		closeMenuOnItemClick: s,
		canFlip: p
	}), /* @__PURE__ */ U(Yb, {
		isOpen: h,
		setIsOpen: _
	})] }) })] });
}, {
	Item: zb,
	Container: kb
}), Zb = ({ count: e, children: t, onDismiss: n, summary: r }) => /* @__PURE__ */ W(B, {
	alignItems: "center",
	gap: 1,
	"data-testid": "bulkActions.container",
	children: [
		/* @__PURE__ */ U(ig, {
			sentiment: "infoStrong",
			children: e
		}),
		/* @__PURE__ */ U(V, {
			...j,
			ml: 1,
			children: "selected"
		}),
		r != null && /* @__PURE__ */ U(B, {
			alignItems: "center",
			ml: 2,
			children: r
		}),
		/* @__PURE__ */ U(z, {
			height: "16px",
			px: 2,
			children: /* @__PURE__ */ U(Rr, {
				orientation: "vertical",
				color: M
			})
		}),
		t,
		/* @__PURE__ */ U(Q, {
			onClick: n,
			variant: "ghost",
			icon: /* @__PURE__ */ U($h, { color: k }),
			"data-testid": "bulkActions.dismiss",
			"aria-label": "dismiss bulk actions"
		})
	]
}), Qb = ({ count: e, showCount: t, children: n, icon: r, onClick: i, isDisabled: a, tooltip: o, "data-testid": s, showCaret: c = !1 }) => {
	let l = e === 0 || !!a, u = /* @__PURE__ */ U(Q, {
		variant: "secondary",
		"data-testid": s,
		leadingIcon: r,
		disabled: l,
		onClick: l ? void 0 : i,
		trailingIcon: /* @__PURE__ */ W(H, { children: [t && /* @__PURE__ */ U(ig, { children: e }), c && /* @__PURE__ */ U(Up, { style: { marginLeft: 4 } })] }),
		children: n
	});
	return o ? /* @__PURE__ */ U(m_, {
		label: o,
		children: u
	}) : u;
}, $b = Object.assign(Zb, {
	Button: Qb,
	Dropdown: Object.assign(({ menuItems: e, disabled: t, "data-testid": n, ...r }) => /* @__PURE__ */ U(G_, {
		placement: "top-end",
		menuWidth: 172,
		children: /* @__PURE__ */ U(K_, {
			"data-testid": `${n}.dropdown`,
			disabled: r.count === 0,
			trigger: /* @__PURE__ */ U(Qb, {
				...r,
				"data-testid": n,
				showCaret: !0
			}),
			menuItems: e
		})
	}), { Item: si }),
	KebabMenu: ({ items: e }) => /* @__PURE__ */ U("div", {
		style: { marginRight: "-8px" },
		children: /* @__PURE__ */ U(Xb, {
			"data-testid": "bulkActions.menu",
			variant: "ghost",
			items: e,
			alignment: "top-right"
		})
	})
}), ex = ({ title: e, status: t, counts: n, onDismiss: r, isReviewing: i = !1, onChangeReviewing: a, onCancel: o, isCancelling: s = !1, showReview: c = !0 }) => {
	let l = [
		`${n.success} successful`,
		n.skipped ? `${n.skipped} skipped` : "",
		`${n.failure} failed`
	].filter(Boolean).join(", ");
	return /* @__PURE__ */ W(B, {
		gap: 4,
		py: 4,
		alignItems: "center",
		children: [
			/* @__PURE__ */ U(B, {
				w: 5,
				justifyContent: "center",
				children: t === "PROCESSING" ? /* @__PURE__ */ U(ki, {
					height: "16px",
					width: "16px",
					color: en
				}) : t === "COMPLETED" ? /* @__PURE__ */ U(ig, {
					sentiment: "success",
					icon: Rp
				}) : /* @__PURE__ */ U(ig, {
					sentiment: "highlight",
					icon: vm
				})
			}),
			/* @__PURE__ */ W(R, {
				flex: 1,
				children: [/* @__PURE__ */ U(V, {
					color: Ft,
					...ar,
					mb: 1,
					"data-testid": "bulkActions.title",
					children: e
				}), /* @__PURE__ */ U(V, {
					color: F,
					...N,
					children: l
				})]
			}),
			/* @__PURE__ */ W(B, {
				gap: "4px",
				children: [
					o && /* @__PURE__ */ U(Q, {
						variant: "secondary",
						onClick: o,
						"data-testid": "bulkActions.cancel",
						disabled: s,
						children: "Cancel"
					}),
					c && t !== "PROCESSING" ? /* @__PURE__ */ U(Q, {
						variant: "secondary",
						onClick: () => a?.(!i),
						disabled: i,
						"data-testid": "bulkActions.review",
						children: "Review"
					}) : null,
					t !== "PROCESSING" && /* @__PURE__ */ U(Q, {
						onClick: r,
						variant: "ghost",
						icon: /* @__PURE__ */ U(eg, { color: "#64748b" }),
						"data-testid": "bulkActions.dismiss",
						"aria-label": "dismiss bulk actions"
					})
				]
			})
		]
	});
}, tx = Object.assign($b, {
	MarkAsDropdown: ({ count: e, showCount: t, onSelect: n }) => /* @__PURE__ */ U($b.Dropdown, {
		count: e,
		showCount: t,
		"data-testid": "invoices.bulkActions.markAs",
		menuItems: /* @__PURE__ */ W(H, { children: [
			/* @__PURE__ */ U($b.Dropdown.Item, {
				icon: /* @__PURE__ */ U(Lf, {}),
				onClick: () => n("PAID"),
				"data-testid": "invoices.bulkActions.markAs.paid",
				children: "Paid"
			}),
			/* @__PURE__ */ U($b.Dropdown.Item, {
				icon: /* @__PURE__ */ U(Vf, {}),
				onClick: () => n("UNCOLLECTIBLE"),
				"data-testid": "invoices.bulkActions.markAs.uncollectible",
				children: "Uncollectable"
			}),
			/* @__PURE__ */ U($b.Dropdown.Item, {
				icon: /* @__PURE__ */ U(Hf, {}),
				onClick: () => n("UNPAID"),
				"data-testid": "invoices.bulkActions.markAs.unpaid",
				children: "Unpaid"
			})
		] }),
		children: "Mark as..."
	}),
	RecalculateButton: (e) => /* @__PURE__ */ U($b.Button, {
		...e,
		"data-testid": "invoices.bulkActions.recalculate",
		icon: /* @__PURE__ */ U(Mp, {}),
		children: "Recalculate"
	}),
	FinalizeButton: (e) => /* @__PURE__ */ U($b.Button, {
		...e,
		"data-testid": "invoices.bulkActions.finalize",
		icon: /* @__PURE__ */ U(Gm, {}),
		children: "Finalize"
	}),
	SendButton: (e) => /* @__PURE__ */ U($b.Button, {
		...e,
		"data-testid": "invoices.bulkActions.send",
		icon: /* @__PURE__ */ U(gm, {}),
		children: "Send"
	}),
	KebabMenu: Object.assign($b.KebabMenu, {
		Merge: ({ count: e, showCount: t, onClick: n }) => {
			let r = `Merge ${t && e ? `${e} ` : ""}${wc("invoice", e ?? 0)}`;
			return /* @__PURE__ */ U(Xb.Item, {
				label: r,
				uuid: "merge",
				"data-testid": "invoices.bulkActions.merge",
				onClick: n,
				isDisabled: e === 0
			}, "merge");
		},
		Download: ({ count: e, showCount: t, onClick: n, isDisabled: r, tooltip: i }) => {
			let a = `Download ${t && e ? `${e} ` : ""}${wc("invoice", e ?? 0)} as PDF`;
			return /* @__PURE__ */ U(Xb.Item, {
				label: a,
				uuid: "download",
				"data-testid": "invoices.bulkActions.download",
				onClick: n,
				isDisabled: e === 0 || r,
				tooltip: i
			}, "download");
		},
		Void: ({ count: e, showCount: t, onClick: n }) => {
			let r = `Void ${t && e ? `${e} ` : ""}${wc("invoice", e ?? 0)}`;
			return /* @__PURE__ */ U(Xb.Item, {
				label: r,
				uuid: "void",
				"data-testid": "invoices.bulkActions.void",
				style: { color: Un },
				onClick: n,
				isDisabled: e === 0
			}, "void");
		},
		Delete: ({ count: e, showCount: t, onClick: n }) => {
			let r = `Delete ${t && e ? `${e} ` : ""}${wc("invoice", e ?? 0)}`;
			return /* @__PURE__ */ U(Xb.Item, {
				label: r,
				uuid: "delete",
				"data-testid": "invoices.bulkActions.delete",
				style: { color: Un },
				onClick: n,
				isDisabled: e === 0
			}, "delete");
		},
		MarkAsSent: ({ count: e, showCount: t, onClick: n }) => {
			let r = `Mark ${t && e ? `${e} ` : ""}${wc("invoice", e ?? 0)} as sent`;
			return /* @__PURE__ */ U(Xb.Item, {
				label: r,
				uuid: "markAsSent",
				"data-testid": "invoices.bulkActions.markAsSent",
				onClick: n,
				isDisabled: e === 0
			}, "markAsSent");
		}
	})
}), nx = ({ isOpen: e, onClose: t, onConfirm: n, title: r, confirmButtonText: i, isDestructive: a, "data-testid": o, children: s }) => /* @__PURE__ */ U(jg, {
	variant: "dialog",
	"data-testid": o,
	isOpen: e,
	onClose: t,
	title: r,
	submitButtonText: i,
	isDestructive: a,
	disableSubmitOnEnter: !0,
	onSubmit: () => (n(), !0),
	children: s
}), rx = ({ count: e, ...t }) => /* @__PURE__ */ W(nx, {
	...t,
	"data-testid": "invoices.bulkActions.recalculate.dialog",
	title: `Recalculate ${e} ${wc("invoice", e)}`,
	confirmButtonText: "Recalculate",
	children: [
		"You're about to recalculate",
		" ",
		/* @__PURE__ */ W("strong", { children: [
			e,
			" ",
			wc("invoice", e)
		] }),
		"."
	]
}), ix = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		"data-testid": "invoices.bulkActions.send.dialog",
		title: `Send ${e} ${n}`,
		confirmButtonText: "Send",
		children: [
			"You're about to send",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] }),
			". After sending you can no longer edit the ",
			n,
			"."
		]
	});
}, ax = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		"data-testid": "invoices.bulkActions.finalize.dialog",
		title: `Finalize ${e} ${n}`,
		confirmButtonText: "Finalize",
		children: [
			"You're about to finalize",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] }),
			". This will lock the ",
			n,
			" and prevent editing."
		]
	});
}, ox = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		"data-testid": "invoices.bulkActions.void.dialog",
		title: `Void ${e} ${n}`,
		confirmButtonText: "Void",
		isDestructive: !0,
		children: [
			"You're about to void",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] }),
			". You won't be able to make any further changes to the ",
			n,
			" after voiding."
		]
	});
}, sx = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		title: `Send payment reminder for ${e} ${n}`,
		confirmButtonText: "Send reminder",
		children: [
			"You're about to send payment reminders for",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] })
		]
	});
}, cx = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		title: `Merge ${e} ${n}`,
		confirmButtonText: "Merge",
		children: [
			"You're about to merge",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] }),
			". This action can't be undone. The original invoices will be voided."
		]
	});
}, lx = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		"data-testid": "invoices.bulkActions.delete.dialog",
		title: `Delete ${e} ${n}`,
		confirmButtonText: "Delete",
		isDestructive: !0,
		children: [
			"You're about to delete",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" ",
				n
			] }),
			". This action can't be undone."
		]
	});
}, ux = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		title: `Convert ${e} upcoming ${n} to draft`,
		confirmButtonText: "Convert",
		children: [
			"You're about to convert",
			" ",
			/* @__PURE__ */ W("strong", { children: [
				e,
				" upcoming ",
				n
			] }),
			" ",
			"to draft. This action can't be undone."
		]
	});
}, dx = ({ count: e, ...t }) => {
	let n = wc("invoice", e);
	return /* @__PURE__ */ W(nx, {
		...t,
		"data-testid": "invoices.bulkActions.markAsSent.dialog",
		title: `Mark ${e} ${n} as sent`,
		confirmButtonText: "Mark as sent",
		children: [
			"You're about to mark",
			" ",
			/* @__PURE__ */ W("span", {
				style: { fontWeight: Vt.fontWeight },
				children: [
					e,
					" ",
					n
				]
			}),
			" ",
			"as ",
			/* @__PURE__ */ U("span", {
				style: { fontWeight: Vt.fontWeight },
				children: "Sent"
			}),
			". No email will be sent and the invoice will not automatically sync to your connections. You will no longer be able to edit this invoice. This action cannot be undone."
		]
	});
}, fx = ({ value: e, enableGroupHover: t = !0, "data-testid": n }) => {
	let [r, i] = Y(!1), a = (e) => {
		navigator.clipboard.writeText(e).catch(() => {
			console.error("Failed to copy to clipboard");
		}), i(!0), setTimeout(() => {
			i(!1);
		}, 1500);
	};
	return /* @__PURE__ */ U(B, {
		"data-testid": n,
		display: t ? "none" : void 0,
		height: "24px",
		width: "24px",
		borderRadius: "50%",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "transparent",
		cursor: "pointer",
		_groupHover: t ? { display: "flex" } : void 0,
		_hover: {
			backgroundColor: "gray.30",
			boxShadow: "0px 2px 4px rgba(15, 23, 42, 0.08)"
		},
		_active: { backgroundColor: "gray.40" },
		onClick: (t) => {
			t.preventDefault(), t.stopPropagation(), a(e);
		},
		children: U(r ? zp : Oh, {})
	});
}, px = ({ to: e, children: t, target: n }) => /* @__PURE__ */ U(ri, {
	as: Il,
	border: `1px solid ${Cn}`,
	borderRadius: "8px",
	padding: "3px 6px",
	to: e,
	target: n,
	color: y,
	...N,
	sx: {
		"[role=\"row\"] &": { borderColor: "transparent" },
		":hover": {
			borderColor: Cn,
			textDecoration: "none"
		}
	},
	children: t
}), mx = ({ environment: e, children: t }) => {
	function n() {
		switch (e) {
			case "local":
			case "dev": return "green.20";
			case "test": return "indigo.20";
			case "stable": return "red.20";
			case "sandbox": return "yellow.20";
			case "demo": return "orange.40";
			default: return;
		}
	}
	function r() {
		switch (e) {
			case "local":
			case "dev": return "green.90";
			case "test": return "indigo.90";
			case "stable": return "red.90";
			case "sandbox": return "yellow.90";
			case "demo": return "white";
			default: return;
		}
	}
	return e === "production" ? /* @__PURE__ */ U(H, {}) : /* @__PURE__ */ W(B, {
		flexDirection: "column",
		children: [/* @__PURE__ */ U(R, {
			height: "4px",
			backgroundColor: n()
		}), /* @__PURE__ */ U(z, { children: /* @__PURE__ */ U(R, {
			backgroundColor: n(),
			borderBottomRadius: "4px",
			padding: "2px 4px",
			height: "20px",
			children: /* @__PURE__ */ U(V, {
				"data-testid": "environment-name",
				color: r(),
				fontSize: "12px",
				children: t ?? ((e) => e ? e.replace(/\w\S*/g, function(e) {
					return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
				}) : "")(e)
			})
		}) })]
	});
}, hx = ({ children: e, "data-testid": t, ...n }) => /* @__PURE__ */ U(B, {
	p: 5,
	bg: A,
	borderRadius: "6px",
	gap: "4px",
	flexDirection: "column",
	"data-testid": t,
	...n,
	children: e
}), gx = ({ label: e, children: t }) => /* @__PURE__ */ W(B, {
	justifyContent: "space-between",
	width: "100%",
	alignItems: "baseline",
	minHeight: "24px",
	gap: "8px",
	children: [/* @__PURE__ */ U(V, {
		...N,
		color: k,
		children: e
	}), typeof t == "string" ? /* @__PURE__ */ U(V, {
		...N,
		color: Xt,
		textAlign: "right",
		children: t
	}) : t]
}), _x = {
	cursor: "pointer",
	textDecoration: "none",
	outline: "none",
	color: "inherit",
	_hover: { textDecoration: "underline" },
	_focusVisible: { boxShadow: "outline" }
}, vx = ({ to: e, replace: t, state: n }) => {
	let r = Ll();
	return e !== void 0 && r ? {
		as: Il,
		to: e,
		replace: t,
		state: n
	} : { href: typeof e == "string" ? e : void 0 };
}, yx = mc(({ to: e, replace: t, state: n, ...r }, i) => {
	let a = vx({
		to: e,
		replace: t,
		state: n
	});
	return /* @__PURE__ */ U(ri, {
		ref: i,
		..._x,
		...a,
		...r
	});
});
yx.displayName = "Link";
var bx = mc(({ to: e, replace: t, state: n, ...r }, i) => /* @__PURE__ */ U(ri, {
	ref: i,
	...vx({
		to: e,
		replace: t,
		state: n
	}),
	...r
}));
bx.displayName = "Link.Unstyled";
var xx = Object.assign(yx, { Unstyled: bx }), Sx = ({ title: e, defaultTitle: t = "Sequence" }) => /* @__PURE__ */ U(Vl, { children: /* @__PURE__ */ U("title", { children: e ? `${[...e, t].join(" – ")}` : t }) }), Cx = {
	success: "#059669",
	error: "#DC2626",
	warning: "#D97706",
	info: "#2563EB",
	loading: "#6366F1"
}, wx = Ol(({ duration: e = 4e3, visibleToasts: t = 3, className: n, ...r }) => Wl(/* @__PURE__ */ U(Hl, {
	position: "bottom-right",
	offset: 20,
	theme: "light",
	duration: e,
	visibleToasts: t,
	toastOptions: {
		style: {
			background: "#FFFFFF",
			color: L,
			border: `1px solid ${P}`,
			boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
			fontFamily: N.fontFamily,
			fontSize: N.fontSize,
			fontWeight: N.fontWeight,
			lineHeight: N.lineHeight,
			padding: 0,
			right: 0,
			width: "fit-content",
			minWidth: "360px",
			maxWidth: "500px"
		},
		className: n
	},
	style: { "--width": "500px" },
	...r
}), document.body))`
  [data-icon] {
    display: none;
  }
`, Tx = (e) => X(e).with("success", () => /* @__PURE__ */ U(Rp, { color: Cx.success })).with("error", () => /* @__PURE__ */ U(im, { color: Cx.error })).with("warning", () => /* @__PURE__ */ U(vm, { color: Cx.warning })).with("info", () => /* @__PURE__ */ U(em, { color: Cx.info })).with("loading", () => /* @__PURE__ */ U(ki, {
	size: "sm",
	color: Cx.loading
})).exhaustive(), Ex = ({ toastId: e, type: t, children: n, description: r, onClickView: i, viewLabel: a, "data-testid": o, truncate: s = !0 }) => /* @__PURE__ */ W(B, {
	gap: "12px",
	width: "100%",
	alignItems: "center",
	padding: i ? "10px 16px" : "16px",
	"data-testid": o,
	children: [
		t && /* @__PURE__ */ U(R, { children: Tx(t) }),
		/* @__PURE__ */ W(B, {
			flexDirection: "column",
			width: "100%",
			gap: "2px",
			overflow: "hidden",
			children: [/* @__PURE__ */ U(R, {
				...N,
				fontWeight: "500",
				color: L,
				overflow: "hidden",
				"data-testid": o ? `${o}.message` : void 0,
				children: s && typeof n == "string" ? /* @__PURE__ */ U(mv, {
					splitPercentage: 100,
					children: n
				}) : n
			}), r && /* @__PURE__ */ U(R, {
				...N,
				color: "#64748b",
				"data-description": !0,
				"data-testid": o ? `${o}.description` : void 0,
				children: r
			})]
		}),
		/* @__PURE__ */ W(B, {
			alignItems: "center",
			gap: "6px",
			children: [i && /* @__PURE__ */ U(Q, {
				variant: "secondary",
				onClick: () => {
					Ax(e), i();
				},
				"data-testid": o ? `${o}.viewButton` : void 0,
				children: a ?? "View"
			}), /* @__PURE__ */ U(Q, {
				variant: "ghost",
				onClick: () => {
					Ax(e);
				},
				"data-testid": o ? `${o}.closeButton` : "closeButton",
				style: {
					width: "24px",
					height: "24px",
					padding: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				},
				children: /* @__PURE__ */ U($h, { color: k })
			})]
		})
	]
}), Dx = 0, Ox = () => `notification-${Dx += 1}`, kx = (e) => e === "neutral" ? void 0 : e, Ax = (e) => {
	let t = Ul.getToasts().find((t) => t.id === e || t?.title?.props?.toastId === e)?.id;
	t && Ul.dismiss(t);
}, jx = () => ({
	displayNotification: G((e, t = {}) => {
		let n = {
			success: Ul.success,
			error: Ul.error,
			warning: Ul.warning,
			neutral: Ul,
			info: Ul.info,
			loading: Ul.loading
		}, r = t.type ?? "info", i = n[r], a = t.id ?? Ox();
		return i(/* @__PURE__ */ U(Ex, {
			toastId: a,
			type: kx(r),
			description: t.description,
			onClickView: t.onClickView,
			viewLabel: t.viewLabel,
			truncate: t.truncate,
			"data-testid": t["data-testid"],
			children: e
		}), {
			id: a,
			duration: t.duration,
			dismissible: t.isClosable ?? !0,
			style: t.style
		}), a;
	}, []),
	displayPromiseNotification: G((e, t, n) => {
		let r = n?.id ?? Ox();
		return Ul.promise(e, {
			id: r,
			loading: t.loading ? /* @__PURE__ */ U(Ex, {
				toastId: r,
				type: "loading",
				children: t.loading
			}) : void 0,
			success: (e) => /* @__PURE__ */ U(Ex, {
				toastId: r,
				type: "success",
				children: typeof t.success == "function" ? t.success(e) : t.success
			}),
			error: (e) => /* @__PURE__ */ U(Ex, {
				toastId: r,
				type: "error",
				children: typeof t.error == "function" ? t.error(e) : t.error
			})
		}), e;
	}, []),
	hideNotification: (e) => {
		Ul.dismiss(e);
	}
}), Mx = ({ children: e, variant: t = "default", ...n }) => /* @__PURE__ */ U(R, {
	borderRadius: "8px",
	border: `1px solid ${t === "v2" ? M : P}`,
	overflow: "hidden",
	boxShadow: t === "v2" ? Pn : "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
	backgroundColor: I,
	height: "fit-content",
	padding: "16px",
	...n,
	children: e
}), Nx = Object.assign(zr, {
	Content: Vr,
	Body: Br
}), Px = Ol.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 8px;
  font-size: 13px;
  line-height: 16px;
  padding: 8px 12px;
  border-radius: 8px;
  width: 100%;
  align-items: center;

  ${(e) => X(e.$variant).with("neutral", () => `
          background-color: ${Fn};
          color: ${L};
        `).with("info", () => `
          background-color: ${Xe};
          color: ${Pe};
        `).with("success", () => `
          background-color: ${$n};
          color: ${zt};
        `).with("warning", () => `
          background-color: ${Zn};
          color: ${Lt};
        `).with("error", () => `
          background-color: ${Be};
          color: ${At};
        `).with("loading", () => `
        background-color: ${A};
        color: ${F};
      `).exhaustive()}
`, Fx = Ol.div`
  ${(e) => e.$hasAction ? "\n    display: grid;\n    grid-template-columns: 1fr auto;\n    column-gap: 12px;\n    align-items: center;\n    width: 100%;\n  " : ""}
`, Ix = Ol.div`
  strong {
    font-weight: 600;
  }
`, Lx = Ol.div`
  flex-shrink: 0;
  height: fit-content;
`, Rx = ({ variant: e, withIcon: t = !0, alignIcon: n = "start", "data-testid": r, children: i, IconComponent: a, action: o }) => {
	let s = {
		size: "16px",
		color: "inherit"
	}, c = a ? /* @__PURE__ */ U(a, { ...s }) : X(e).with("neutral", "info", () => /* @__PURE__ */ U(em, { ...s })).with("success", () => /* @__PURE__ */ U(Rp, { ...s })).with("warning", () => /* @__PURE__ */ U(vm, { ...s })).with("error", () => /* @__PURE__ */ U(im, { ...s })).with("loading", () => /* @__PURE__ */ U(ki, {
		boxSize: "16px",
		color: "inherit"
	})).exhaustive();
	return /* @__PURE__ */ W(Px, {
		$variant: e,
		"data-testid": r,
		children: [t ? /* @__PURE__ */ U(Lx, {
			style: { alignSelf: n },
			children: c
		}) : null, /* @__PURE__ */ W(Fx, {
			$hasAction: !!o,
			children: [/* @__PURE__ */ U(Ix, { children: i }), o]
		})]
	});
}, zx = "https://docs.sequencehq.com/compliance/privacy-policy", Bx = Al`
  from { opacity: 0; transform: scale(0.98); }
  to  { opacity: 1; transform: scale(1); }
`, Vx = Ol(B)`
  animation: ${Bx} 200ms ease-out forwards;
`, Hx = ({ isOpen: e, onAccept: t, onReject: n, "data-testid": r = "consentBanner" }) => e ? /* @__PURE__ */ U(R, {
	position: "fixed",
	bottom: "16px",
	left: "16px",
	right: "16px",
	zIndex: "banner",
	display: "flex",
	transformOrigin: "center",
	justifyContent: "flex-start",
	pointerEvents: "none",
	"data-testid": r,
	children: /* @__PURE__ */ W(Vx, {
		maxWidth: "28rem",
		width: "100%",
		padding: "16px",
		gap: "16px",
		flexDir: "column",
		flexWrap: "wrap",
		pointerEvents: "auto",
		backgroundColor: I,
		border: `1px solid ${P}`,
		borderRadius: "8px",
		boxShadow: yn,
		"data-testid": `${r}.card`,
		children: [/* @__PURE__ */ W(V, {
			...N,
			color: F,
			flex: "1",
			minWidth: "220px",
			children: [
				"We use tracking technologies to analyze usage, help resolve support issues, and improve your experience. Read our",
				" ",
				/* @__PURE__ */ U(ri, {
					href: zx,
					isExternal: !0,
					color: y,
					textDecoration: "underline",
					"data-testid": `${r}.privacyPolicy`,
					children: "Privacy policy"
				})
			]
		}), /* @__PURE__ */ W(B, {
			gap: "8px",
			flexShrink: 0,
			children: [/* @__PURE__ */ U(Q, {
				variant: "secondary",
				onClick: n,
				"data-testid": `${r}.reject`,
				children: "Deny"
			}), /* @__PURE__ */ U(Q, {
				variant: "primary",
				onClick: t,
				"data-testid": `${r}.accept`,
				children: "Accept all"
			})]
		})]
	})
}) : null, Ux = (e) => {
	let [t, n] = Y(null), [r, i] = Y([]), [a, o] = Y(!1), s = e.expanded !== void 0, [c, l] = Y(s ? e.expanded : e.showContentOnMount ?? !1), u = Yc(e.showItemId);
	K(() => {
		e.showItemId !== void 0 && u !== e.showItemId && n(e.showItemId ?? null);
	}, [e.showItemId, u]);
	let d = Yc(e.expanded);
	K(() => {
		if (d !== e.expanded) {
			if (e.expanded === void 0) return;
			l(!!e.expanded), e.expanded || n(null);
		}
	}, [e.expanded, d]);
	let f = G(async (r) => {
		if (!e.showItemId) {
			if (t === r) {
				s || l(!1), await new Promise((e) => setTimeout(e, 250)), n(null);
				return;
			}
			s || l(!0), n(r);
		}
	}, [
		t,
		s,
		e.showItemId
	]), p = q(() => r.map((e) => ({
		...e,
		active: e.id === t,
		onSelect: () => {
			f(e.id);
		}
	})), [
		r,
		t,
		f
	]), m = G((e) => (i((t) => [...t, e]), { remove: () => {
		i((t) => t.filter((t) => t.id !== e.id));
	} }), []), h = q(() => p.find((e) => e.active)?.content, [p]);
	return K(() => {
		!h && c && r.length && f(r[0].id);
	}, [
		h,
		c,
		f,
		r
	]), K(() => {
		if (!(a || !r.length || t)) {
			if (e.showContentOnMount) {
				let t = r.find((t) => t.id === e.defaultItemId);
				n(t?.id ?? r[0].id);
			} else n(null);
			o(!0);
		}
	}, [
		a,
		r,
		e.showContentOnMount,
		e.defaultItemId,
		t
	]), K(() => {
		if (!r.length || !e.defaultItemId) return;
		let t = r.find((t) => t.id === e.defaultItemId);
		t && !e.showItemId && n(t.id);
	}, [
		e.defaultItemId,
		r,
		e.showItemId
	]), K(() => {
		if (!a) {
			let e = setTimeout(() => o(!0), 3e3);
			return () => {
				clearTimeout(e);
			};
		}
	}, [a]), {
		showInspector: r.length > 0,
		activeContent: h,
		loaded: a,
		activeItemId: t,
		expanded: e.expanded ?? c,
		registerItem: m,
		updateActiveItem: (e) => void f(e)
	};
}, Wx = fc(null), Gx = () => {
	let e = _c(Wx);
	if (!e) throw Error("Inspector item needs to be mounted as a child of an Inspector component");
	return e;
}, Kx = ({ showContentOnMount: e, displayPlaceholderDuringInitialization: t = !0, children: n, defaultItemId: r, expanded: i, showItemId: a, withFloatingDrawer: o = !1 }) => {
	let s = Ux({
		showContentOnMount: e,
		defaultItemId: r,
		expanded: i,
		showItemId: a
	}), c = J(null), [l, u] = Y(!1), [d, f] = Y(0);
	yc(() => {
		let e = c.current?.firstChild;
		if (e) {
			let t = new ResizeObserver(() => {
				f(e.offsetWidth);
			});
			return t.observe(e), () => {
				t.disconnect();
			};
		}
	}, [s.activeContent]), yc(() => {
		s.loaded && (d > 0 || !s.activeContent) && setTimeout(() => u(!0), 100);
	}, [
		s.loaded,
		d,
		s.activeContent
	]);
	let p = q(() => s.loaded ? s.activeContent : t ? /* @__PURE__ */ U(R, {
		padding: "16px",
		height: "100%",
		width: "320px",
		children: /* @__PURE__ */ U($_, {
			height: "100%",
			width: "100%"
		})
	}) : null, [
		s.loaded,
		s.activeContent,
		t
	]), m = q(() => s.loaded && d ? {
		width: s.expanded ? d : "0",
		maxWidth: s.expanded ? d : "0"
	} : t && s.expanded ? {
		width: "320px",
		maxWidth: "320px"
	} : {
		width: "0",
		maxWidth: "0"
	}, [
		d,
		s.expanded,
		s.loaded,
		t
	]), h = s.showInspector || !s.loaded && t;
	return /* @__PURE__ */ U(Wx.Provider, {
		value: s,
		children: /* @__PURE__ */ W(Kr, {
			display: h ? "grid" : "none",
			gridTemplateColumns: "auto auto",
			gridTemplateAreas: "\"content tabList\"",
			height: "100%",
			overflow: "hidden",
			backgroundColor: I,
			"data-testid": "inspector",
			children: [/* @__PURE__ */ U(Jr, {
				borderLeft: s.expanded ? `1px solid ${P}` : "0px solid transparent",
				...m,
				transition: l ? "width 0.25s ease-out, border-left 0.25s ease-out, max-width 0.25s ease-out" : "none",
				gridArea: "content",
				height: "100%",
				overflow: "hidden",
				ref: c,
				...o ? {
					position: "absolute",
					right: "0px",
					background: I,
					zIndex: "1"
				} : {},
				children: p
			}), /* @__PURE__ */ U(Jr, {
				gridArea: "tabList",
				height: "100%",
				overflow: "auto",
				borderLeft: `1px solid ${P}`,
				width: "min-content",
				children: n
			})]
		})
	});
}, qx = (e) => {
	let t = e.padding ?? "16px", n = !!e.title || !!e.titleAction;
	return /* @__PURE__ */ W(B, {
		width: e.width ?? "320px",
		height: "100%",
		overflow: "auto",
		padding: t,
		paddingTop: e.titleAction ? "12px" : t,
		gap: e.titleAction ? "12px" : "16px",
		"data-testid": e["data-testid"],
		flexDirection: "column",
		children: [n && /* @__PURE__ */ W(B, {
			alignItems: "center",
			justifyContent: "space-between",
			"data-testid": e["data-testid"] ? `${e["data-testid"]}.header` : void 0,
			children: [e.title && /* @__PURE__ */ W(B, {
				...ar,
				gap: "8px",
				children: [e.icon ? e.icon : null, e.title]
			}), e.titleAction && e.titleAction]
		}), /* @__PURE__ */ U(R, {
			flex: "1",
			children: e.children
		})]
	});
}, Jx = (e) => {
	let t = qc(), n = e.id ?? t, { registerItem: r, activeItemId: i, updateActiveItem: a } = Gx();
	K(() => {
		let { remove: t } = r({
			id: n,
			content: e.content
		});
		return () => {
			t();
		};
	}, [
		e.content,
		r,
		n
	]);
	let o = G(() => {
		a(n);
	}, [a, n]);
	return {
		active: i === n,
		onClick: o
	};
}, Yx = (e) => {
	let { active: t, onClick: n } = Jx({
		content: e.content,
		id: e.id
	});
	return e.children({
		active: t,
		onClick: n
	});
}, Xx = (e) => {
	let t = e.tooltip ? m_ : uc, n = e.activeIcon || e.icon;
	return /* @__PURE__ */ U(Yx, {
		id: e.id,
		content: e.content,
		children: ({ active: r, onClick: i }) => /* @__PURE__ */ U(t, {
			...e.tooltip ? {
				label: e.tooltip,
				placement: "left"
			} : {},
			children: /* @__PURE__ */ U(B, {
				"data-testid": e["data-testid"],
				textDecoration: "none",
				height: "32px",
				width: "32px",
				alignItems: "center",
				justifyContent: "center",
				borderRadius: "8px",
				cursor: "pointer",
				backgroundColor: r ? Fn : "transparent",
				_hover: { backgroundColor: Fn },
				onClick: () => {
					e.onClick?.(!r), i();
				},
				children: r ? n : e.icon
			})
		})
	});
}, Zx = (e) => /* @__PURE__ */ U(Kr, {
	"data-testid": "inspector.itemGroup",
	display: "grid",
	alignContent: "start",
	rowGap: "2px",
	gridAutoFlow: "row",
	padding: "8px",
	children: e.children
}), Qx = fc(null), $x = () => {
	let e = _c(Qx);
	if (!e) throw Error("Inspector item needs to be mounted as a child of an Inspector component");
	return e;
}, eS = Object.assign(Kx, {
	Content: qx,
	Item: Yx,
	IconItem: Xx,
	ItemGroup: Zx
}), tS = ({ accept: e, multiple: t = !1, onFilesPicked: n, ...r }) => {
	let i = J(null), a = () => {
		i.current?.click();
	};
	return /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U("input", {
		type: "file",
		style: { display: "none" },
		ref: i,
		accept: e,
		multiple: t,
		onChange: () => {
			let e = i.current?.files;
			e && (n?.(Array.from(e)), i.current.value = "");
		}
	}), /* @__PURE__ */ U(Q, {
		...r,
		onClick: a
	})] });
}, nS = (e) => /* @__PURE__ */ U(Qr, { ...e }), rS = ({ start: e, ...t }) => /* @__PURE__ */ U(R, {
	as: "ol",
	start: e,
	listStyleType: "decimal",
	marginInlineStart: "1em",
	...t
}), iS = ({ styleType: e = "disc", ...t }) => /* @__PURE__ */ U(R, {
	as: "ul",
	listStyleType: e,
	marginInlineStart: "1em",
	...t
}), aS = (e) => /* @__PURE__ */ U(R, {
	as: "li",
	...e
}), oS = ({ children: e, header: t, subheader: n, amount: r, inputElement: i, isUpdating: a, width: o = "100%", height: s = "100%" }) => /* @__PURE__ */ W(B, {
	borderRadius: "6px",
	padding: "16px",
	border: `1px solid ${P}`,
	boxShadow: Pn,
	width: o,
	height: s,
	flexDirection: "column",
	gap: "16px",
	children: [/* @__PURE__ */ W(B, {
		alignItems: "flex-start",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ W(B, {
			flexDirection: "column",
			gap: "8px",
			children: [
				/* @__PURE__ */ U(V, {
					...j,
					fontWeight: 600,
					color: k,
					children: t
				}),
				/* @__PURE__ */ U(V, {
					...Je,
					color: Ft,
					children: r
				}),
				/* @__PURE__ */ U(V, {
					...N,
					color: k,
					children: n
				})
			]
		}), i && /* @__PURE__ */ U(R, {
			flexBasis: "33.3%",
			children: i
		})]
	}), /* @__PURE__ */ U(R, {
		width: "100%",
		height: "100%",
		opacity: a ? .5 : 1,
		transition: "opacity 250ms",
		children: e
	})]
}), sS = Object.assign(({ children: e }) => {
	let t = lc.toArray(e), n = t.length - 1;
	return /* @__PURE__ */ U(B, {
		alignItems: "center",
		gap: "8px",
		children: t.map((e, t) => /* @__PURE__ */ W(uc, { children: [t > 0 && /* @__PURE__ */ U(V, {
			...ar,
			color: "#64748b",
			children: "/"
		}), hc(e) ? dc(e, { color: t === n ? L : k }) : e] }, t))
	});
}, { Breadcrumb: ({ children: e, href: t, color: n }) => {
	let r = /* @__PURE__ */ U(V, {
		...ar,
		color: n,
		children: e
	});
	return t ? /* @__PURE__ */ U(Il, {
		to: t,
		children: r
	}) : r;
} }), cS = "8px", lS = "14px", uS = mc(({ children: e, hideOuterBorders: t = !1, ...n }, r) => /* @__PURE__ */ U(R, {
	ref: r,
	backgroundColor: I,
	overflow: "hidden",
	...t ? {} : {
		border: {
			base: "none",
			md: `1px solid ${P}`
		},
		borderRadius: {
			base: "0",
			md: lS
		},
		boxShadow: {
			base: "none",
			md: Pn
		}
	},
	...n,
	children: e
}));
uS.displayName = "Panel";
//#endregion
//#region src/components/Layouts/layoutChrome.tsx
var dS = fc({}), fS = ({ headerLeading: e, children: t }) => {
	let n = q(() => ({ headerLeading: e }), [e]);
	return /* @__PURE__ */ U(dS.Provider, {
		value: n,
		children: t
	});
}, pS = () => _c(dS), mS = () => {
	let { headerLeading: e } = pS();
	return /* @__PURE__ */ U(H, { children: e });
}, hS = "8px", gS = (e) => {
	let { overlayInspector: t = !1 } = e, [n, r] = Y(null), [i, a] = Y(0);
	if (K(() => {
		if (!n) return;
		let e = new ResizeObserver((e) => {
			for (let t of e) a(t.borderBoxSize[0].blockSize);
		});
		return e.observe(n), a(n.offsetHeight), () => {
			e.disconnect();
		};
	}, [n]), e.asModal) {
		let n = /* @__PURE__ */ U(fS, { children: /* @__PURE__ */ W(Kr, {
			"data-testid": e["data-testid"],
			gridTemplateAreas: t ? "\"header\" \"content\"" : "\"header header\" \"content inspector\"",
			gridTemplateColumns: t ? "1fr" : "1fr auto",
			gridTemplateRows: "auto 1fr",
			backgroundColor: e.backgroundColor ?? "#fbfcfe",
			overflow: "hidden",
			position: "absolute",
			top: hS,
			left: hS,
			right: hS,
			bottom: hS,
			borderRadius: "8px",
			outline: "1px solid rgba(0, 0, 0, 0.08)",
			boxShadow: yn,
			children: [
				/* @__PURE__ */ U(Jr, {
					ref: r,
					gridArea: "header",
					children: e.header
				}),
				/* @__PURE__ */ U(Jr, {
					gridArea: "content",
					minHeight: "0",
					height: "100%",
					overflow: "auto",
					paddingRight: t ? "48px" : "0",
					children: e.content
				}),
				e.inspector && (t ? /* @__PURE__ */ U(R, {
					position: "absolute",
					top: `${i}px`,
					right: "0",
					bottom: "0",
					zIndex: 100,
					backgroundColor: "#ffffff",
					boxShadow: "0 0 2px 0 #00000005, 0 1px 1px 0 #0000000d",
					children: e.inspector
				}) : /* @__PURE__ */ U(Jr, {
					gridArea: "inspector",
					height: `calc(100dvh - ${i}px - ${parseInt(hS) * 2}px)`,
					children: e.inspector
				}))
			]
		}) });
		return e.portalTarget ? Wl(/* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Nl.div, {
			initial: { opacity: 0 },
			animate: { opacity: 1 },
			exit: { opacity: 0 },
			transition: {
				duration: .18,
				ease: [
					.16,
					1,
					.3,
					1
				]
			},
			style: {
				position: "absolute",
				inset: 0,
				zIndex: 35,
				backgroundColor: "rgba(0, 0, 0, 0.16)"
			}
		}), /* @__PURE__ */ U(Nl.div, {
			initial: {
				opacity: 0,
				scale: .98
			},
			animate: {
				opacity: 1,
				scale: 1
			},
			exit: {
				opacity: 0,
				scale: .98
			},
			transition: {
				duration: .18,
				ease: [
					.16,
					1,
					.3,
					1
				]
			},
			style: {
				position: "absolute",
				inset: 0,
				zIndex: 35,
				transformOrigin: "center"
			},
			children: n
		})] }), e.portalTarget) : null;
	}
	let o = {
		position: "relative",
		minWidth: "min(600px, 100%)",
		height: "100%",
		maxHeight: "100%",
		width: "100%",
		backgroundColor: e.backgroundColor ?? "transparent"
	};
	if (!e.header && !e.inspector && !t) return /* @__PURE__ */ U(R, {
		...o,
		"data-testid": e["data-testid"],
		children: e.content
	});
	if (t) return /* @__PURE__ */ U(R, {
		...o,
		"data-testid": e["data-testid"],
		children: /* @__PURE__ */ W(uS, {
			position: "relative",
			display: "grid",
			gridTemplateAreas: "\"header\" \"content\"",
			gridTemplateRows: "auto 1fr",
			height: "100%",
			children: [
				/* @__PURE__ */ U(Jr, {
					ref: r,
					gridArea: "header",
					children: e.header
				}),
				/* @__PURE__ */ U(Jr, {
					gridArea: "content",
					minHeight: "0",
					overflow: "auto",
					paddingRight: "48px",
					children: e.content
				}),
				e.inspector && /* @__PURE__ */ U(R, {
					position: "absolute",
					top: `${i}px`,
					right: "0",
					bottom: "0",
					zIndex: 100,
					backgroundColor: "#ffffff",
					boxShadow: "0 0 2px 0 #00000005, 0 1px 1px 0 #0000000d",
					children: e.inspector
				})
			]
		})
	});
	let s = e.inspectorFullHeight ? "\"header inspector\" \"content inspector\"" : "\"header header\" \"content inspector\"", c = e.inspector ? s : "\"header\" \"content\"";
	return /* @__PURE__ */ W(uS, {
		"data-testid": e["data-testid"],
		display: "grid",
		gridTemplateAreas: c,
		gridTemplateColumns: e.inspector ? "1fr auto" : "1fr",
		gridTemplateRows: "auto 1fr",
		minWidth: "min(600px, 100%)",
		height: "100%",
		maxHeight: "100%",
		width: "100%",
		children: [
			/* @__PURE__ */ U(Jr, {
				gridArea: "header",
				children: e.header
			}),
			/* @__PURE__ */ U(Jr, {
				gridArea: "content",
				minHeight: "0",
				overflow: "auto",
				children: e.content
			}),
			e.inspector && /* @__PURE__ */ U(Jr, {
				gridArea: "inspector",
				minHeight: "0",
				overflow: "hidden",
				children: e.inspector
			})
		]
	});
}, _S = (e) => {
	let t = e.backgroundColor ?? "#ffffff", { headerLeading: n } = pS();
	return /* @__PURE__ */ W(Kr, {
		gridArea: "header",
		gridTemplateColumns: "1fr auto",
		height: "48px",
		alignItems: "center",
		padding: e.padding ?? "0 8px",
		borderBottom: `1px solid ${P}`,
		backgroundColor: t,
		flexShrink: "0",
		children: [/* @__PURE__ */ U(Jr, {
			paddingLeft: "8px",
			minWidth: "0",
			children: /* @__PURE__ */ W(B, {
				alignItems: "center",
				gap: "8px",
				children: [n, /* @__PURE__ */ U(R, {
					flex: "1",
					minWidth: "0",
					children: typeof e.title == "string" ? /* @__PURE__ */ W(CS.Title, { children: [/* @__PURE__ */ U(Sx, { title: [e.title] }), e.title] }) : e.title
				})]
			})
		}), /* @__PURE__ */ W(Jr, { children: [e.actions, e.onClose && /* @__PURE__ */ U(xS, { onClick: e.onClose })] })]
	});
}, vS = (e) => /* @__PURE__ */ U(R, {
	...ar,
	children: e.children
}), yS = (e) => /* @__PURE__ */ U(B, {
	gap: "8px",
	children: e.children
}), bS = (e) => /* @__PURE__ */ U(R, {
	padding: "16px",
	height: "100%",
	backgroundColor: e.backgroundColor ?? "#ffffff",
	overflowY: e.scrollable ? "auto" : void 0,
	children: e.children
}), xS = ({ onClick: e, disabled: t, disableEscapeShortcut: n = !1, "data-testid": r }) => /* @__PURE__ */ U(Q, {
	variant: "ghost",
	icon: /* @__PURE__ */ U(eg, { color: t ? M : k }),
	onClick: e,
	keyboardShortcut: n ? void 0 : ["Escape"],
	disabled: t,
	"data-testid": r,
	children: "Close"
}), SS = ({ columns: e = "1fr 1fr", leadingSide: t, trailingSide: n, hideOuterBorders: r = !1 }) => /* @__PURE__ */ W(uS, {
	display: "grid",
	maxHeight: "100%",
	height: "100%",
	width: "100%",
	gridTemplateColumns: e,
	hideOuterBorders: r,
	children: [/* @__PURE__ */ U(Jr, {
		minWidth: "0",
		minHeight: "0",
		height: "100%",
		position: "relative",
		overflow: "hidden",
		children: t
	}), /* @__PURE__ */ U(Jr, {
		minWidth: "0",
		minHeight: "0",
		overflowX: "auto",
		overflowY: "hidden",
		children: n
	})]
}), CS = Object.assign(gS, {
	Header: _S,
	Title: vS,
	Actions: yS,
	Content: bS,
	SplitContent: SS,
	ButtonClose: xS,
	Breadcrumbs: sS
}), wS = ({ logoSrc: e, title: t, subtitle: n, content: r, button: i, kebabMenu: a, showBorder: o, fullWidth: s = !1, onClick: c, "data-testid": l }) => {
	let u = !!(i || a);
	return /* @__PURE__ */ W(R, {
		"data-testid": l,
		width: s ? "100%" : "330px",
		p: 2,
		backgroundColor: I,
		...N,
		cursor: c ? "pointer" : void 0,
		onClick: c ? (e) => {
			e.stopPropagation(), c();
		} : TS,
		border: o ? `1px solid ${P}` : void 0,
		borderRadius: "8px",
		children: [
			/* @__PURE__ */ W(B, {
				px: 2,
				gap: 4,
				my: 2,
				children: [e && /* @__PURE__ */ U(R, {
					maxWidth: 8,
					children: /* @__PURE__ */ U("img", { src: e })
				}), /* @__PURE__ */ W(R, {
					flex: 1,
					children: [/* @__PURE__ */ U(V, {
						mb: 1,
						...j,
						children: t
					}), /* @__PURE__ */ U(R, {
						...N,
						children: n
					})]
				})]
			}),
			r,
			u && /* @__PURE__ */ W(B, {
				mt: 2,
				gap: 2,
				children: [i && (i.to ? /* @__PURE__ */ U(Q, {
					as: Il,
					to: i.to,
					...i.openInNewTab === !1 ? {} : {
						target: "_blank",
						rel: "noopener noreferrer"
					},
					variant: "secondary",
					style: { flex: 1 },
					"data-testid": l ? `${l}.button` : void 0,
					children: i.label
				}) : /* @__PURE__ */ U(Q, {
					variant: "secondary",
					onClick: i.onClick,
					style: { flex: 1 },
					"data-testid": l ? `${l}.button` : void 0,
					children: i.label
				})), a]
			})
		]
	});
}, TS = (e) => e.stopPropagation(), ES = 3, DS = "32px", OS = "48px", kS = fc({
	currency: "GBP",
	selectable: !1,
	editable: !1,
	registerEditableLineItem: () => {}
}), AS = ({ children: e, currency: t, selected: n = !1, onChangeSelected: r, variant: i }) => {
	let [a, o] = Y(0), s = () => {
		r?.(!n);
	}, c = r, l = G((e) => {
		o(e ? (e) => e + 1 : (e) => e - 1);
	}, []), u = a > 0;
	return /* @__PURE__ */ U(kS.Provider, {
		value: {
			currency: t,
			selectable: !!r,
			registerEditableLineItem: l,
			editable: u
		},
		children: /* @__PURE__ */ W(NS, { children: [/* @__PURE__ */ U(Gi, { children: /* @__PURE__ */ W(Ji, { children: [
			c && /* @__PURE__ */ U(Ui, {
				width: DS,
				children: /* @__PURE__ */ U(Vy, {
					onChange: s,
					isChecked: [!0, "indeterminate"].includes(n),
					isIndeterminate: n === "indeterminate",
					"data-testid": "lineItemGroupCheckbox"
				})
			}),
			/* @__PURE__ */ U(Ui, {
				colSpan: ES,
				style: { paddingLeft: c ? "2px" : "12px" },
				children: /* @__PURE__ */ U("span", {
					style: {
						cursor: "pointer",
						display: "inline-block",
						minWidth: 95
					},
					onClick: c ? s : void 0,
					children: "Description"
				})
			}),
			/* @__PURE__ */ U(Ui, {
				textAlign: "right",
				width: "90px",
				children: "Qty"
			}),
			/* @__PURE__ */ U(Ui, {
				textAlign: "right",
				width: "124px",
				children: "Rate"
			}),
			/* @__PURE__ */ U(Ui, {
				textAlign: "right",
				width: "64px",
				children: "Tax"
			}),
			/* @__PURE__ */ U(Ui, {
				textAlign: "right",
				width: "128px",
				children: i === "default" ? "Amount" : "Credit amount"
			}),
			u && /* @__PURE__ */ U(Ui, { width: OS })
		] }) }), /* @__PURE__ */ U(Ii, { children: e })] })
	});
}, jS = ({ title: e, quantity: t, taxRate: n, rate: r, rateDisplay: i, netTotal: a, subtitleContent: o }) => {
	let { currency: s } = _c(kS);
	return /* @__PURE__ */ W(Ji, { children: [
		/* @__PURE__ */ W(Ri, {
			colSpan: ES,
			children: [/* @__PURE__ */ U(R, {
				minWidth: "95px",
				children: /* @__PURE__ */ U(mv, { children: e })
			}), o]
		}),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			children: t
		}),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			children: /* @__PURE__ */ U(PS, {
				rate: r,
				rateDisplay: i,
				currency: s
			})
		}),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			children: Uc(Pc(n))
		}),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			children: Hc({
				currency: s,
				value: a,
				maximumFractionDigits: 10
			})
		})
	] });
}, MS = ({ title: e, quantity: t, rate: n, rateDisplay: r, taxRate: i, netTotal: a, selected: o, onChangeSelected: s, onChangeQuantity: c, onChangeTotal: l, onTriggerAdvancedEdit: u, onDelete: d, inputsDisabled: f = !1, testIdPrefix: p = "", subtitleContent: m }) => {
	let { currency: h, selectable: g, registerEditableLineItem: _ } = _c(kS);
	K(() => (_(!0), () => {
		_(!1);
	}), [_]);
	let v = () => {
		s?.(!o);
	};
	return /* @__PURE__ */ W(Ji, { children: [
		g && /* @__PURE__ */ U(Ri, {
			width: DS,
			children: /* @__PURE__ */ U(Vy, {
				onChange: v,
				isChecked: !!o,
				"data-testid": `${p}checkbox`
			})
		}),
		/* @__PURE__ */ W(Ri, {
			colSpan: ES,
			style: { paddingLeft: g ? "2px" : "12px" },
			children: [/* @__PURE__ */ U(R, {
				cursor: "pointer",
				minWidth: "95px",
				onClick: g ? v : void 0,
				children: /* @__PURE__ */ U(mv, { children: e })
			}), m]
		}),
		/* @__PURE__ */ U(Ri, { children: /* @__PURE__ */ U(Hg, {
			type: "number",
			value: t,
			onChange: (e) => {
				e.stopPropagation(), c(e.target.value);
			},
			isDisabled: f,
			onClick: IS,
			height: "28px",
			style: { textAlign: "right" },
			"data-testid": `${p}quantity`
		}) }),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			children: /* @__PURE__ */ U(PS, {
				"data-testid": `${p}rate`,
				rate: n,
				rateDisplay: r,
				currency: h
			})
		}),
		/* @__PURE__ */ U(Ri, {
			textAlign: "right",
			"data-testid": `${p}tax`,
			children: Uc(Pc(i))
		}),
		/* @__PURE__ */ U(Ri, { children: /* @__PURE__ */ U(Hg, {
			type: "number",
			value: a,
			onChange: (e) => {
				e.stopPropagation(), l(e.target.value);
			},
			prefix: zc(h),
			style: { textAlign: "right" },
			isDisabled: f,
			onClick: IS,
			height: "28px",
			"data-testid": `${p}value`
		}) }),
		/* @__PURE__ */ U(Ri, { children: /* @__PURE__ */ U(Xb, {
			variant: "ghost",
			alignment: "bottom-right",
			"data-testid": `${p}kebab`,
			closeMenuOnItemClick: !0,
			disabled: f,
			items: /* @__PURE__ */ W(H, { children: [u && /* @__PURE__ */ U(Xb.Item, {
				uuid: "edit",
				label: "Edit line item",
				onClick: u,
				"data-testid": `${p}edit`
			}, "edit"), /* @__PURE__ */ U(Xb.Item, {
				uuid: "delete",
				label: "Delete line item",
				onClick: d,
				style: { color: En },
				"data-testid": `${p}delete`
			}, "delete")] })
		}) })
	] });
}, NS = ({ children: e }) => /* @__PURE__ */ U(Mx, {
	padding: "0px",
	variant: "v2",
	children: /* @__PURE__ */ U(Ni, {
		variant: "v2-without-hover",
		children: e
	})
}), PS = ({ rateDisplay: e = "ABSOLUTE", rate: t, currency: n }) => /* @__PURE__ */ U(H, { children: e === "PERCENTAGE" ? Uc(Pc(t)) : Hc({
	currency: n,
	value: t,
	maximumFractionDigits: 10
}) }), FS = Object.assign(AS, {
	LineItem: jS,
	EditableLineItem: MS,
	Subtotal: ({ value: e }) => {
		let { currency: t, editable: n } = _c(kS);
		return /* @__PURE__ */ W(Ji, {
			width: "100%",
			children: [/* @__PURE__ */ U(Ri, {
				colSpan: 2,
				children: "Subtotal"
			}), /* @__PURE__ */ U(Ri, {
				textAlign: "right",
				colSpan: n ? 7 : 5,
				children: /* @__PURE__ */ U(V, {
					...j,
					align: "right",
					children: Hc({
						currency: t,
						value: e,
						maximumFractionDigits: 10
					})
				})
			})]
		});
	},
	AddLineItem: ({ onClick: e, "data-testid": t }) => /* @__PURE__ */ U(Ji, { children: /* @__PURE__ */ U(Ri, {
		colSpan: 7,
		children: /* @__PURE__ */ U(Q, {
			onClick: e,
			variant: "ghost",
			leadingIcon: /* @__PURE__ */ U(dh, {}),
			"data-testid": t,
			children: "Add line item"
		})
	}) })
}), IS = (e) => {
	e.stopPropagation();
}, LS = fc({ currency: "GBP" }), RS = ({ currency: e, children: t }) => /* @__PURE__ */ U(LS.Provider, {
	value: { currency: e },
	children: /* @__PURE__ */ U(Ni, {
		variant: "totals",
		children: /* @__PURE__ */ U(Ii, { children: t })
	})
}), zS = ({ title: e, amount: t, emphasised: n, emphasisedTitle: r = !1, breakdown: i = !1, appendCurrencyCode: a = !1, formatAmount: o = !0, color: s, titleHref: c, testId: l, info: u }) => {
	let { currency: d } = _c(LS), f = l ?? `Totals.${e}`, p = o ? Hc({
		currency: d,
		value: t.toString(),
		appendCurrencyCode: a
	}) : t.toString(), m = s ?? (c ? "#6366f1" : "#475569"), h = /* @__PURE__ */ U(V, {
		"data-testid": `${f}.title`,
		...n || r ? j : N,
		color: m,
		wordBreak: "break-word",
		children: e
	}), g = c ? /* @__PURE__ */ U(Il, {
		to: c,
		"data-testid": `${f}.link`,
		children: h
	}) : h, _ = u ? /* @__PURE__ */ W(B, {
		alignItems: "center",
		gap: "4px",
		children: [g, u]
	}) : g;
	return /* @__PURE__ */ W(Ji, {
		fontWeight: n ? "bold" : "normal",
		style: i ? { height: "24px" } : {},
		children: [/* @__PURE__ */ U(Ri, {
			width: "100%",
			...i && {
				pt: "0",
				pb: "8px"
			},
			children: _
		}), /* @__PURE__ */ U(Ri, {
			textAlign: "right",
			overflow: "hidden",
			...i && {
				pt: "0",
				pb: "8px"
			},
			children: /* @__PURE__ */ U(V, {
				"data-testid": f,
				...n ? j : N,
				color: s ?? (n ? "#1e293b" : "#475569"),
				textAlign: "right",
				whiteSpace: "nowrap",
				title: p,
				children: p
			})
		})]
	});
}, BS = Object.assign(RS, {
	Row: zS,
	Tax: ({ amount: e, percentage: t }) => /* @__PURE__ */ U(zS, {
		title: `Tax (${t}%)`,
		amount: e
	}),
	Total: ({ title: e = "Total", amount: t, appendCurrencyCode: n = !1, color: r, testId: i }) => /* @__PURE__ */ U(zS, {
		title: e,
		amount: t,
		emphasised: !0,
		appendCurrencyCode: n,
		color: r,
		testId: i
	}),
	Divider: ({ strong: e }) => /* @__PURE__ */ U(Ji, { children: /* @__PURE__ */ U(Ri, {
		colSpan: 2,
		children: /* @__PURE__ */ U(Rr, { color: e ? k : P })
	}) }),
	Description: ({ title: e, emphasised: t = !1 }) => /* @__PURE__ */ U(Ji, { children: /* @__PURE__ */ U(Ri, { children: /* @__PURE__ */ U(V, {
		...t ? j : N,
		color: t ? F : k,
		wordBreak: "break-word",
		children: e
	}) }) }),
	Spacer: ({ height: e = "4px" }) => /* @__PURE__ */ U(Ji, { height: e })
}), VS = (e) => e.replace(/\//g, "-"), HS = {
	grey: {
		gradient: Fn,
		gradientOpacity: .5,
		secondaryGradientOpacity: .7,
		text: Ft,
		border: en
	},
	orange: {
		gradient: Zn,
		gradientOpacity: .3,
		secondaryGradientOpacity: .2,
		text: kt,
		border: Tn
	},
	red: {
		gradient: Be,
		gradientOpacity: .3,
		secondaryGradientOpacity: .2,
		text: Un,
		border: t
	}
}, US = ({ quantity: e, title: t, description: n, href: r, variant: i = "grey", icon: a, isLoading: o = !1 }) => {
	let s = `overview-card-${VS(r)}`, c = !o && e === 0, l = J(null);
	return /* @__PURE__ */ U(ri, {
		as: Il,
		to: r,
		_hover: { textDecoration: "none" },
		ref: l,
		onMouseMove: (e) => {
			if (!l.current) return;
			let t = e.currentTarget.getBoundingClientRect(), n = e.clientX - t.left, r = e.clientY - t.top;
			l.current.style.setProperty("--x", `${n}px`), l.current.style.setProperty("--y", `${r}px`);
		},
		"aria-labelledby": s,
		className: "group",
		css: {
			position: "relative",
			background: "white",
			"[data-icon]": {
				display: "inline-block",
				verticalAlign: "middle",
				transform: "translateX(-4px)",
				transition: "transform ease-out 100ms, opacity ease-out 80ms, blur ease-out 80ms",
				filter: "blur(2px)",
				opacity: 0
			},
			"&:hover [data-icon]": {
				transform: "translateX(1px)",
				filter: "blur(0)",
				opacity: 1
			},
			"&:hover:after": { opacity: 1 },
			"&:hover:before": { opacity: HS[i].secondaryGradientOpacity }
		},
		_before: {
			position: "absolute",
			inset: 0,
			content: "\" \"",
			userSelect: "none",
			pointerEvents: "none",
			transition: "opacity 300ms",
			borderRadius: "8px",
			opacity: 0,
			background: `radial-gradient(circle 150px at var(--x, -200px) var(--y, -200px), ${HS[i].gradient},transparent 85%)`
		},
		_after: {
			position: "absolute",
			inset: 0,
			content: "\" \"",
			userSelect: "none",
			pointerEvents: "none",
			transition: "opacity 300ms",
			borderRadius: "8px",
			opacity: 0,
			border: `1px solid ${c ? en : HS[i].border}`,
			maskImage: "radial-gradient(circle 180px at var(--x, -180px) var(--y, -180px), white 40%, transparent)"
		},
		children: /* @__PURE__ */ W(B, {
			flexDirection: "column",
			width: "full",
			height: "full",
			p: "16px",
			borderRadius: "8px",
			borderStyle: "solid",
			borderWidth: "1px",
			borderColor: M,
			boxShadow: nr,
			position: "relative",
			overflow: "clip",
			transition: "border-color 100ms, box-shadow 150ms",
			background: c ? A : "transparent",
			_before: {
				content: "\" \"",
				position: "absolute",
				width: "160px",
				height: "160px",
				left: "-20%",
				top: "-20%",
				background: c ? "transparent" : `radial-gradient(${HS[i].gradient},transparent 85%)`,
				opacity: o ? 0 : HS[i].gradientOpacity,
				transition: "opacity 100ms"
			},
			_groupHover: { boxShadow: yn },
			children: [
				/* @__PURE__ */ U(Nl.div, {
					initial: !1,
					animate: { opacity: +!!c },
					transition: { duration: .2 },
					children: /* @__PURE__ */ U(Kr, {
						position: "absolute",
						inset: "-6px 0",
						templateColumns: "repeat(8,1fr)",
						templateRows: "repeat(auto-fill,20px)",
						columnGap: "0px",
						rowGap: "8px",
						"aria-hidden": "true",
						pointerEvents: "none",
						css: {
							maskComposite: "add",
							maskImage: "linear-gradient(30deg,transparent 60%, rgba(0,0,0,0.9)), radial-gradient(circle 120px at var(--x, -200px) var(--y, -200px), rgba(0,0,0,0.4) 40%,  rgba(0,0,0,0))",
							"& > svg": {
								width: "20px",
								height: "20px",
								color: P
							}
						},
						children: Array.from({ length: 40 }).map((e, t) => /* @__PURE__ */ U(uc, { children: a }, t))
					})
				}),
				/* @__PURE__ */ U(V, {
					position: "relative",
					color: c ? en : HS[i].text,
					pb: "12px",
					minHeight: "40px",
					opacity: +!o,
					transition: "opacity 250ms ease-out",
					...x,
					children: e
				}),
				/* @__PURE__ */ W(V, {
					position: "relative",
					id: s,
					...j,
					color: L,
					pb: "4px",
					children: [t, /* @__PURE__ */ U(qp, {
						"data-icon": !0,
						size: 14,
						"aria-hidden": "true"
					})]
				}),
				/* @__PURE__ */ U(V, {
					position: "relative",
					"data-testid": "overviewCard.description",
					display: {
						base: "none",
						md: "block"
					},
					opacity: +!o,
					transition: "opacity 250ms ease-out",
					...N,
					color: k,
					children: n
				})
			]
		})
	});
}, WS = ({ title: e, children: t, dateLabel: n, dateIcon: r, date: i, href: a }) => {
	let o = `activity-card-${VS(a)}`;
	return /* @__PURE__ */ W(ri, {
		as: Il,
		to: a,
		width: "full",
		borderRadius: "8px",
		"aria-labelledby": o,
		border: `1px solid ${M}`,
		_hover: {
			textDecoration: "none",
			borderColor: en
		},
		boxShadow: nr,
		backgroundColor: I,
		transition: "border-color 100ms",
		p: "8px",
		css: {
			"[data-icon]": {
				transform: "translateX(-4px)",
				width: "14px",
				height: "14px",
				transition: "transform ease-out 100ms, opacity ease-out 80ms, blur ease-out 80ms",
				filter: "blur(2px)",
				opacity: 0
			},
			"&:hover [data-icon]": {
				transform: "translateX(1px)",
				filter: "blur(0)",
				opacity: 1
			}
		},
		children: [/* @__PURE__ */ W(B, {
			paddingTop: "4px",
			paddingX: "4px",
			paddingBottom: "8px",
			justifyItems: "center",
			justifyContent: "space-between",
			children: [/* @__PURE__ */ W(B, {
				position: "relative",
				alignItems: "center",
				id: o,
				children: [/* @__PURE__ */ U(R, {
					...j,
					color: k,
					children: e
				}), /* @__PURE__ */ U(qp, {
					"data-icon": !0,
					"aria-hidden": "true",
					color: k
				})]
			}), t]
		}), /* @__PURE__ */ W(B, {
			p: "4px",
			backgroundColor: A,
			borderRadius: "4px",
			justifyItems: "center",
			justifyContent: "space-between",
			children: [/* @__PURE__ */ W(B, {
				...N,
				alignItems: "center",
				color: F,
				css: { "&>svg": {
					width: "16px",
					height: "16px",
					color: k,
					marginRight: "4px"
				} },
				children: [
					r,
					n,
					Fc({
						dateTarget: i,
						dateNow: (/* @__PURE__ */ new Date()).toString()
					})
				]
			}), /* @__PURE__ */ U(V, {
				...N,
				color: F,
				children: Dc(i, "d MMM yyyy")
			})]
		})]
	});
}, GS = "Oops! Something went wrong", KS = "Try reloading the page if you believe this is an error.", qS = ({ title: e = GS, message: t = KS, button: n, graphic: r, ...i }) => /* @__PURE__ */ W(B, {
	flexDirection: "column",
	alignItems: "center",
	gap: "16px",
	"data-testid": i["data-testid"],
	children: [
		r || /* @__PURE__ */ U(z, {
			width: "48px",
			height: "48px",
			borderRadius: "48px",
			backgroundColor: yt,
			children: /* @__PURE__ */ U(vm, {
				size: 24,
				color: Ut
			})
		}),
		/* @__PURE__ */ W(B, {
			flexDirection: "column",
			alignItems: "center",
			gap: "4px",
			textAlign: "center",
			children: [/* @__PURE__ */ U(V, {
				...Nt,
				color: L,
				children: e
			}), /* @__PURE__ */ U(V, {
				...Qt,
				color: k,
				children: t
			})]
		}),
		n
	]
}), JS = ({ src: e, size: t = 16, fallbackSize: n, "data-testid": r }) => e ? /* @__PURE__ */ U(R, {
	"data-testid": r,
	width: `${t}px`,
	height: `${t}px`,
	backgroundImage: `url(${e}), none`,
	backgroundPosition: "center center",
	backgroundSize: "contain",
	backgroundRepeat: "no-repeat"
}) : /* @__PURE__ */ U(jp, {
	"data-testid": r,
	size: n ?? t
}), YS = ({ height: e = "42", width: t = "193", color: n = "#505050" }) => /* @__PURE__ */ U("svg", {
	width: t,
	height: e,
	viewBox: "0 0 193 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ W("g", {
		fill: n,
		stroke: n,
		strokeWidth: ".197609",
		children: [
			/* @__PURE__ */ U("path", { d: "m19.1914.901466c3.6677.000142 6.6414 2.970354 6.6416 6.634764 0 .01322-.0009.02684-.0009.04004.0001.01592.0009.0319.0009.04785v1.8418l1.5967-.9209c.0075-.0043.015-.00843.0225-.01269.0216-.01278.0426-.0265.0644-.03907 3.1766-1.83224 7.2392-.74492 9.0733 2.42874 1.834 3.1737.7449 7.2322-2.4317 9.0644-.0054.0032-.0111.0057-.0166.0088-.0236.014-.0465.0292-.0703.043l-1.5976.9209 1.5966.9209c.0258.0148.0508.0308.0762.0459.0038.0022.0079.0046.0117.0068 3.1762 1.8323 4.2644 5.89 2.4307 9.0635-1.834 3.1736-5.8957 4.2609-9.0723 2.4287-.0261-.0151-.0513-.0315-.0771-.0469-.0035-.002-.0073-.0038-.0108-.0058l-1.5957-.9209v1.8427l-.0009.042c.0001.0149.0009.0301.0009.045-.0001 3.6315-2.9207 6.579-6.5429 6.6318v.0029h-.1973v-.0029c-3.6224-.0526-6.5428-3.0001-6.543-6.6318 0-.0149.0009-.0301.001-.045-.0001-.0142-.001-.0286-.001-.0429v-1.8428l-1.5966.9219-.001.0009-.0244.0127c-.0211.0125-.0412.0268-.0625.0391-3.14826 1.8159-7.16472.7637-9.02152-2.3447l-.00195.0019-.04883-.0859-.04981-.085.00196-.0019c-1.7092894-3.0608-.73582-6.9098 2.18652-8.7988l.29199-.1778c.02929-.0175.05824-.0356.08789-.0527l1.59571-.9209-1.59668-.9209v-.001l-.07324-.042v-.001h.00097c-.00496-.0028-.01066-.0049-.01562-.0078-3.14773-1.8158-4.2437284-5.817-2.47852-8.9775l-.00195-.001.0498-.0859.04981-.085.00097.001c1.85683-3.1081 5.87341-4.16037 9.0215-2.34474.0194.0112.0383.02379.0576.03516.01.00569.0203.01085.0303.0166l1.5976.9209v-1.8418c0-.01595.0009-.03192.001-.04785-.0001-.0132-.001-.02682-.001-.04004.0003-3.6645 2.9739-6.634764 6.6416-6.634764zm0 28.505834c-2.7346 0-4.9535 2.2025-4.9775 4.9287.023 2.727 2.2423 4.9307 4.9775 4.9307 2.7351-.0001 4.9545-2.2038 4.9776-4.9307-.024-2.7261-2.243-4.9285-4.9776-4.9287zm-7.3359-4.2148c-1.3747-2.3788-4.41866-3.1937-6.79981-1.8203-2.23961 1.3527-3.04157 4.2034-1.85742 6.5156l.12305.2246.13379.2188c1.43067 2.209 4.35936 2.9319 6.66599 1.6015 2.3129-1.397 3.0919-4.3911 1.7344-6.7402zm21.2461-1.9434c-2.3448-1.1988-5.2444-.3612-6.5762 1.9434-1.3581 2.3506-.5769 5.3474 1.7393 6.7431 2.3805 1.3701 5.422.5542 6.7959-1.8232 1.3574-2.3491.5785-5.3433-1.7344-6.7402zm-12.2481 4.4121 3.3165 1.9121v-3.8252zm-6.6406 1.9112 3.3135-1.9121-3.3135-1.9112zm0-11.4854v5.7432l4.9766 2.8711 4.9805-2.8721v-5.7422l-4.9795-2.8711zm-4.97947 2.8711 3.31637 1.9131v-3.8252zm16.59957 1.9121 3.3135-1.9121-3.3135-1.9111zm-15.7421-12.90233c-2.37676-1.34966-5.40156-.53201-6.77056 1.83693-1.3632 2.3589-.57161 5.3684 1.76367 6.7578 2.37685 1.3503 5.40229.5333 6.77149-1.8359 1.3633-2.3592.5713-5.3696-1.7646-6.75883zm24.9707 1.83693c-1.3692-2.36921-4.3947-3.18723-6.7715-1.83693-2.2621 1.34563-3.0755 4.21183-1.8858 6.53423l.1221.2246.1338.2187c1.4249 2.2 4.3354 2.9246 6.6377 1.6162 2.335-1.3895 3.1268-4.398 1.7637-6.7568zm-14.2081 2.4512 3.3165 1.913v-3.8252zm-6.6406 1.9121 3.3145-1.9121-3.3145-1.9122zm4.9785-13.51761c-2.7335 0-4.9518 2.20107-4.9775 4.92578.0213 2.72853 2.2412 4.93363 4.9775 4.93363 2.7362-.0002 4.9563-2.2052 4.9776-4.93363-.0257-2.72462-2.2441-4.92564-4.9776-4.92578z" }),
			/* @__PURE__ */ U("path", { d: "m183.511 14.8164c2.685.0001 4.834 1.0371 6.311 2.7314 1.477 1.693 2.277 4.0359 2.277 6.6416v.6338h-14.619c.089 2.0372.754 3.6625 1.818 4.7823 1.081 1.1376 2.579 1.7616 4.319 1.7617 1.393 0 2.559-.3352 3.471-.9766.911-.641 1.577-1.5935 1.964-2.8418l.021-.0703h2.912l-.032.1231c-.938 3.7183-4.118 6.3173-8.336 6.3173-2.681 0-4.937-.9457-6.522-2.6123-1.585-1.6664-2.493-4.0466-2.493-6.9033 0-2.8575.935-5.2547 2.519-6.9385 1.585-1.684 3.814-2.6484 6.39-2.6484zm0 2.5156c-2.917 0-5.521 1.9561-5.951 5.2959h11.616c-.389-3.076-2.515-5.2958-5.665-5.2959z" }),
			/* @__PURE__ */ U("path", { d: "m165.213 14.8164c2.142 0 4.038.6296 5.497 1.8047 1.461 1.1754 2.479 2.8924 2.875 5.0537l.022.1162h-2.908l-.018-.0771c-.317-1.3899-.974-2.4563-1.903-3.1758-.929-.7199-2.138-1.0986-3.565-1.0987-3.397 0-6.107 2.6938-6.107 6.9278 0 4.3039 2.78 6.9287 6.107 6.9287 1.427 0 2.643-.3875 3.586-1.125.943-.7376 1.619-1.8316 1.953-3.2578l.019-.0762h2.907l-.021.1162c-.794 4.2923-4.045 6.9658-8.444 6.9658-2.556 0-4.838-.928-6.481-2.5888-1.643-1.6612-2.642-4.0504-2.642-6.9629 0-5.8326 4.111-9.5508 9.123-9.5508z" }),
			/* @__PURE__ */ U("path", { d: "m148.649 14.8164c1.844.0001 3.413.6511 4.522 1.8232 1.108 1.1718 1.748 2.8565 1.748 4.9102v11.834h-2.909v-11.0498c0-1.4488-.336-2.6627-1.038-3.5127-.7-.8469-1.776-1.3467-3.286-1.3467-2.868.0003-4.895 2.3079-4.895 4.8242v11.085h-2.908v-18.0322h2.908v2.6142c1.222-1.8388 3.278-3.1494 5.858-3.1494z" }),
			/* @__PURE__ */ U("path", { d: "m130.01 14.8164c2.685.0001 4.834 1.0371 6.311 2.7314 1.477 1.693 2.277 4.0359 2.277 6.6416v.6338h-14.619c.089 2.0372.754 3.6625 1.818 4.7823 1.081 1.1376 2.579 1.7616 4.319 1.7617 1.393 0 2.559-.3352 3.471-.9766.911-.641 1.577-1.5935 1.964-2.8418l.021-.0703h2.912l-.032.1231c-.938 3.7183-4.118 6.3173-8.336 6.3173-2.681 0-4.937-.9457-6.522-2.6123-1.585-1.6664-2.493-4.0466-2.493-6.9033 0-2.8575.935-5.2547 2.519-6.9385 1.585-1.684 3.814-2.6484 6.39-2.6484zm0 2.5156c-2.917 0-5.521 1.9561-5.951 5.2959h11.616c-.389-3.076-2.515-5.2958-5.665-5.2959z" }),
			/* @__PURE__ */ U("path", { d: "m107.98 15.3528v11.0488c0 1.4487.335 2.6634 1.025 3.5137.687.8469 1.736 1.3455 3.191 1.3457 2.831 0 4.825-2.3055 4.825-4.8233v-11.0849h2.908v18.0322h-2.908v-2.4551c-1.249 1.7725-3.269 2.9902-5.751 2.9902-1.808 0-3.361-.6521-4.46-1.8242-1.099-1.1716-1.739-2.8557-1.739-4.9092v-11.8339z" }),
			/* @__PURE__ */ U("path", { d: "m94.2141 14.8164c2.7309 0 4.9933 1.5527 6.3219 3.5771v-3.0419h2.909v24.8095h-2.909v-9.7773c-1.3001 2.0203-3.5691 3.5351-6.4645 3.5351-5.1649 0-8.6592-4.1214-8.6592-9.4091.0002-5.5372 3.637-9.6933 8.8018-9.6934zm.3564 2.5869c-1.8609.0001-3.385.7632-4.4453 2.0117-1.0615 1.2501-1.662 2.9923-1.6621 4.9522 0 3.9548 2.4662 6.9636 6.1074 6.9638 3.4314 0 6.0725-2.7278 6.0725-6.9638 0-4.2358-2.6412-6.9639-6.0725-6.9639z" }),
			/* @__PURE__ */ U("path", { d: "m75.8813 14.8164c2.6846.0001 4.834 1.0371 6.3115 2.7314 1.4762 1.693 2.2763 4.0359 2.2763 6.6416v.6338h-14.6191c.0889 2.0372.7546 3.6625 1.8184 4.7823 1.0809 1.1376 2.5787 1.7616 4.3193 1.7617 1.3931 0 2.5588-.3352 3.4707-.9766.9112-.641 1.577-1.5935 1.9639-2.8418l.0215-.0703h2.9111l-.0313.1231c-.9386 3.7183-4.1178 6.3173-8.3359 6.3173-2.6811 0-4.937-.9457-6.5225-2.6123-1.5851-1.6664-2.4931-4.0466-2.4931-6.9033 0-2.8575.9351-5.2547 2.5195-6.9385 1.5847-1.684 3.8137-2.6484 6.3897-2.6484zm0 2.5156c-2.9173 0-5.5213 1.9561-5.9512 5.2959h11.6162c-.3893-3.076-2.5151-5.2958-5.665-5.2959z" }),
			/* @__PURE__ */ U("path", { d: "m56.656 8.1684c2.6402 0 4.6533.72766 6.1016 1.9902 1.4477 1.2622 2.3217 3.0505 2.6992 5.1534l.0205.1162h-2.9785l-.0176-.0752c-.3884-1.6244-1.0918-2.7708-2.0635-3.5118-.9722-.7411-2.2246-1.0858-3.7256-1.0859-1.8027 0-3.1791.469-4.1025 1.2139-.9219.7436-1.3994 1.7672-1.3994 2.8965 0 1.1886.3655 2.0603 1.165 2.7431.8063.6886 2.0627 1.192 3.8604 1.6192v.0009l3.1377.7481h.0009c1.6833.394 3.3508 1.0321 4.5987 2.1172 1.2518 1.0886 2.0761 2.623 2.0762 4.792 0 4.1381-3.559 7.1621-8.8379 7.1621-2.9426 0-5.2661-.7903-6.9278-2.1133-1.6621-1.3234-2.6548-3.1752-2.9433-5.2852l-.0157-.1123h2.9737l.0176.0762c.422 1.7407 1.3611 2.9493 2.583 3.7246 1.2242.7767 2.7387 1.1221 4.3125 1.1221 1.7495 0 3.1982-.4507 4.207-1.2149 1.0069-.7628 1.5791-1.8403 1.5791-3.1093 0-1.2937-.4261-2.2189-1.2793-2.9248-.8599-.7114-2.1608-1.2069-3.9229-1.6162l-3.1748-.7491c-1.6143-.3767-3.2191-1.0418-4.4218-2.1269-1.2058-1.0879-2.0039-2.5951-2.0039-4.6397.0002-3.9228 3.4154-6.91108 8.4814-6.9111z" })
		]
	})
}), XS = ({ title: e, id: t, footer: n, isLoading: r, rows: i = 1, height: a, children: o, action: s, headers: c, maxWidth: l = "600px" }) => {
	let u = qc(t, "settings");
	return /* @__PURE__ */ W(B, {
		as: "section",
		width: "full",
		maxWidth: l,
		"aria-labelledby": e ? u : void 0,
		flexDirection: "column",
		children: [
			e && /* @__PURE__ */ U(V, {
				as: "h3",
				marginBottom: "16px",
				id: u,
				...ar,
				color: "#334155",
				children: e
			}),
			s,
			/* @__PURE__ */ W(B, {
				width: "100%",
				flexDirection: "column",
				borderRadius: "8px",
				justifyContent: "center",
				border: `1px solid ${M}`,
				boxShadow: Pn,
				backgroundColor: I,
				children: [c && /* @__PURE__ */ U(B, {
					borderBottom: "1px solid #cbd5e1",
					height: "44px",
					px: "16px",
					justifyContent: "center",
					alignItems: "center",
					children: c.map((e, t) => /* @__PURE__ */ pc(R, {
						color: "#64748b",
						...Vt,
						key: t,
						width: e.width
					}, e.label))
				}), /* @__PURE__ */ U(B, {
					px: "16px",
					flexDirection: "column",
					justifyContent: "center",
					width: "100%",
					children: r ? /* @__PURE__ */ U(z, {
						height: `${a ?? i * 64}px`,
						children: /* @__PURE__ */ U(ki, {})
					}) : o
				})]
			}),
			typeof n == "string" ? /* @__PURE__ */ U(ZS, { children: n }) : n
		]
	});
}, ZS = ({ children: e }) => /* @__PURE__ */ U(V, {
	as: "span",
	marginTop: "8px",
	...tr,
	color: k,
	children: e
}), QS = Object.assign(XS, { Footer: ZS }), $S = ({ icon: e, label: t, helper: n, htmlFor: r, onClick: i, children: a, showBorderBottom: o = !0 }) => /* @__PURE__ */ W(B, {
	height: "64px",
	backgroundColor: I,
	alignItems: "center",
	justifyContent: "space-between",
	borderBottomWidth: "1px",
	borderBottomStyle: "solid",
	borderBottomColor: o ? "gray.30" : "transparent",
	transition: "height 150ms cubic-bezier(0.25, 0.46, 0.45, 0.94)",
	css: { "&:has([aria-invalid=true])": { height: "88px" } },
	_last: {
		borderBottomColor: "transparent",
		...i && {
			marginBottom: "8px",
			"&:before": { "border-radius": "0 0 6px 6px" }
		}
	},
	position: "relative",
	...i && {
		onClick: (e) => {
			e.preventDefault(), i();
		},
		className: "group",
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), i());
		},
		cursor: "pointer",
		tabIndex: 0,
		_first: {
			marginTop: "8px",
			"&:before": { "border-radius": "6px 6px 0 0" }
		},
		_before: {
			content: "\" \"",
			position: "absolute",
			inset: "0px -8px",
			transition: "background-color 80ms ease-out"
		},
		_hover: { "&:before": { backgroundColor: "#f8fafc" } },
		_focusVisible: {
			outline: "none",
			"&:before": { backgroundColor: "#f8fafc" }
		}
	},
	children: [t || e ? /* @__PURE__ */ W(B, {
		alignItems: "center",
		gap: "16px",
		width: "100%",
		height: "100%",
		overflow: "hidden",
		children: [e && /* @__PURE__ */ U(R, {
			position: "relative",
			children: e
		}), t ? /* @__PURE__ */ W(B, {
			position: "relative",
			flexDirection: "column",
			height: "fit-content",
			gap: "2px",
			width: "fit-content",
			paddingRight: "8px",
			overflow: "hidden",
			children: [/* @__PURE__ */ W(V, {
				as: "label",
				htmlFor: r,
				color: F,
				...j,
				cursor: i ? "pointer" : "default",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				title: typeof t == "string" && t.length > 80 ? t : void 0,
				children: [t, i && /* @__PURE__ */ U(R, {
					display: "inline-block",
					transform: "translateX(-4px)",
					width: "14px",
					height: "14px",
					filter: "blur(2px)",
					opacity: 0,
					verticalAlign: "sub",
					transition: "transform cubic-bezier(0.175, 0.885, 0.32, 1.275) 300ms, filter ease-out 150ms, opacity ease-out 100ms",
					_groupHover: {
						transform: "translateX(1px)",
						filter: "blur(0px)",
						opacity: 1
					},
					_groupFocusVisible: {
						transform: "translateX(1px)",
						filter: "blur(0px)",
						opacity: 1
					},
					children: /* @__PURE__ */ U(qp, {
						"aria-hidden": "true",
						color: "#64748b"
					})
				})]
			}), n && /* @__PURE__ */ U(V, {
				as: "span",
				color: "#64748b",
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap",
				...tr,
				children: n
			})]
		}) : null]
	}) : null, a]
}), eC = (e) => /* @__PURE__ */ U(B, {
	borderRadius: "6px",
	backgroundColor: Fn,
	width: "32px",
	height: "32px",
	alignItems: "center",
	justifyContent: "center",
	css: { "&>svg": {
		width: "16px",
		height: "16px",
		color: F
	} },
	children: e.children
}), tC = ({ styles: e, ...t }) => /* @__PURE__ */ U(Qy, {
	prefix: /* @__PURE__ */ U(Km, {}),
	styles: {
		wrapper: { marginBottom: "16px" },
		...e
	},
	height: "32px",
	width: "250px",
	...t
}), nC = (e) => /* @__PURE__ */ U(B, {
	height: "64px",
	backgroundColor: I,
	alignItems: "center",
	justifyContent: "space-between",
	borderBottomWidth: "1px",
	borderBottomStyle: "solid",
	borderBottomColor: "gray.30",
	_last: { borderBottomWidth: "0px" },
	transition: "height 150ms  cubic-bezier(0.25, 0.46, 0.45, 0.94)",
	css: { "&:has([aria-invalid=true])": { height: "88px" } },
	children: /* @__PURE__ */ W(B, {
		alignItems: "center",
		width: "100%",
		gap: "8px",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ U(Q, {
			variant: "ghost",
			"aria-label": "Remove",
			onClick: e.onRemove,
			children: /* @__PURE__ */ U(tm, { fill: F })
		}), /* @__PURE__ */ U(B, {
			width: "100%",
			alignItems: "center",
			gap: "16px",
			justifyContent: "space-between",
			children: e.children
		})]
	})
}), rC = (e, t) => {
	if (!t) return e;
	let n = RegExp(`(${t})`, "ig");
	return e.split(n).map((e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ U("mark", {
		style: { backgroundColor: Xe },
		children: e
	}, n) : e);
}, iC = {
	sm: {
		backgroundSize: "32px",
		size: "20px"
	},
	md: {
		backgroundSize: "36px",
		size: "24px"
	}
}, aC = ({ icon: e, iconSize: t = "md", variant: n = "default", title: r, body: i, button: a, helperText: o, ...s }) => {
	let c = n === "subtle";
	return /* @__PURE__ */ U(Kr, {
		justifyContent: "center",
		alignContent: "center",
		minHeight: "100%",
		textAlign: "center",
		padding: 10,
		...s,
		children: /* @__PURE__ */ W(B, {
			direction: "column",
			alignItems: "center",
			maxWidth: 280,
			gap: 4,
			children: [
				e && /* @__PURE__ */ U(Kr, {
					width: iC[t].backgroundSize,
					height: iC[t].backgroundSize,
					backgroundColor: c ? void 0 : "#f1f5f9",
					borderRadius: "6px",
					justifyContent: "center",
					alignContent: "center",
					children: /* @__PURE__ */ U(e, {
						size: iC[t].size,
						color: "#475569"
					})
				}),
				/* @__PURE__ */ W(B, {
					flexDir: "column",
					gap: 1,
					children: [/* @__PURE__ */ U(V, {
						...c ? N : j,
						color: L,
						children: r
					}), i && /* @__PURE__ */ U(V, {
						...N,
						color: "#64748b",
						children: i
					})]
				}),
				(a || o) && /* @__PURE__ */ W(B, {
					flexDir: "column",
					gap: 1,
					children: [a && /* @__PURE__ */ U(R, { children: a }), o && /* @__PURE__ */ U(V, {
						...tr,
						color: "#94a3b8",
						children: o
					})]
				})
			]
		})
	});
}, oC = (e) => /* @__PURE__ */ U(R, {
	borderRadius: "6px",
	border: e.isInvalid ? `1px solid ${En}` : `1px solid ${P}`,
	width: "100%",
	overflow: "hidden",
	"data-testid": e["data-testid"],
	children: e.options.map((t) => {
		let n = `${e["data-testid"] ?? e.name}.option.${t.value}`, r = e.value === t.value, i = r && !!t.selectedFooter;
		return /* @__PURE__ */ W(R, {
			_notLast: { borderBottom: `1px solid ${P}` },
			width: "100%",
			children: [/* @__PURE__ */ U(m_, {
				isDisabled: !t.disabledReason,
				label: t.disabledReason,
				shouldWrapChildren: !1,
				"data-testid": `${n}.disabledReason`,
				children: /* @__PURE__ */ W(Kr, {
					gridTemplateAreas: "\n              \"radio label labelAnnotation\" \n              \"radio description description\"\n              \"radio additionalComponent additionalComponent\"\n            ",
					gridTemplateColumns: "22px 1fr auto",
					gridTemplateRows: "auto auto auto",
					"data-testid": n,
					width: "100%",
					padding: t.padding ?? "16px",
					onClick: () => !t.disabled && e.onChange(t.value),
					cursor: t.disabled ? "default" : "pointer",
					userSelect: "none",
					_hover: t.disabled ? {} : { backgroundColor: A },
					transition: "background-color 0.2s ease-in-out",
					children: [
						/* @__PURE__ */ U(Jr, {
							gridArea: "radio",
							opacity: t.disabled ? .5 : 1,
							display: "flex",
							alignItems: t.radioAlignment,
							children: /* @__PURE__ */ U(uy, {
								name: e.name,
								"data-testid": `${n}.radio`,
								isChecked: r,
								disabled: t.disabled,
								marginTop: t.radioAlignment === "center" ? "0px" : void 0
							})
						}),
						/* @__PURE__ */ U(Jr, {
							gridArea: "label",
							...j,
							color: L,
							paddingBottom: t.description ? "4px" : "0px",
							opacity: t.disabled ? .5 : 1,
							overflow: "hidden",
							marginRight: t.labelAnnotation ? "8px" : "0px",
							display: "flex",
							alignItems: "center",
							children: t.label
						}),
						/* @__PURE__ */ U(Jr, {
							gridArea: "labelAnnotation",
							...tr,
							color: k,
							opacity: t.disabled ? t.disabledLabelAnnotationOpacity ?? .5 : 1,
							children: t.labelAnnotation
						}),
						/* @__PURE__ */ U(Jr, {
							gridArea: "description",
							...tr,
							color: k,
							opacity: t.disabled ? .5 : 1,
							children: t.description
						}),
						/* @__PURE__ */ U(Jr, {
							gridArea: "additionalComponent",
							opacity: t.disabled ? .5 : 1,
							children: t.additionalComponent
						})
					]
				})
			}), i && /* @__PURE__ */ U(R, {
				borderTop: "1px solid #e2e8f0",
				padding: t.padding ?? "16px",
				"data-testid": `${n}.selectedFooter`,
				children: t.selectedFooter
			})]
		}, `${t.value}`);
	})
}), sC = ({ boxSize: e, fill: t, style: n }) => /* @__PURE__ */ U(Zl, {
	viewBox: "0 0 16 16",
	fill: t,
	width: e,
	height: e,
	style: n,
	children: /* @__PURE__ */ U(Yl, {
		fillRule: "evenodd",
		d: "M2 8c0 .414.336.75.75.75h8.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06l1.22 1.22H2.75A.75.75 0 0 0 2 8Z"
	})
}), cC = ({ isSaving: e, "data-testId": t }) => {
	let n = Yc(e), [r, i] = Y(!1);
	return K(() => {
		n && !e && (i(!0), setTimeout(() => {
			i(!1);
		}, 3e3));
	}, [n, e]), e ? /* @__PURE__ */ W(B, {
		gap: "6px",
		"data-testid": t ? `${t}.saving` : void 0,
		children: [/* @__PURE__ */ U(up, { color: k }), /* @__PURE__ */ U(V, {
			color: k,
			...N,
			children: "Saving..."
		})]
	}) : r ? /* @__PURE__ */ W(B, {
		gap: "6px",
		"data-testid": t ? `${t}.saved` : void 0,
		children: [/* @__PURE__ */ U(zp, { color: k }), /* @__PURE__ */ U(V, {
			color: k,
			...N,
			children: "Saved"
		})]
	}) : null;
}, lC = .875, uC = (e) => {
	if (typeof e != "string" || !e.endsWith("px")) return e;
	let t = parseFloat(e);
	return isNaN(t) ? e : `${t * lC}px`;
}, dC = (e) => {
	if (e) return Array.isArray(e) ? e.map(dC) : Object.entries(e).reduce((e, [t, n]) => ({
		...e,
		[t]: uC(n)
	}), {});
}, fC = ({ style: e, ...t }) => /* @__PURE__ */ U($l, {
	...t,
	style: dC(e)
}), pC = ({ style: e, ...t }) => /* @__PURE__ */ U(Ql, {
	...t,
	style: dC(e)
}), mC = ({ style: e, ...t }) => /* @__PURE__ */ U(Jl, {
	...t,
	style: dC(e)
}), hC = ({ style: e, ...t }) => /* @__PURE__ */ U(ql, {
	...t,
	style: dC(e)
}), gC = ({ src: e, style: t, ...n }) => {
	let r = typeof window < "u", i = _C((r ? window?.location?.hostname : null) || null, e?.toString()) ? { "sequence-skip-optimizer": "true" } : { "Cache-Control": "no-cache" }, a = r ? {
		uri: e,
		method: "GET",
		headers: i,
		body: ""
	} : e;
	return /* @__PURE__ */ U(Kl, {
		...n,
		style: dC(t),
		src: a
	});
}, _C = (e, t) => {
	if (!e || !t) return !1;
	let n = e.split(".").slice(-2).join(".");
	return new URL(t).hostname.endsWith(n);
}, vC = ({ style: e, width: t, height: n, ...r }) => /* @__PURE__ */ U(Zl, {
	...r,
	style: dC({
		...e,
		width: t,
		height: n
	})
}), yC = (e) => /* @__PURE__ */ U(Zl, {
	width: e.width,
	height: e.height,
	viewBox: `0 0 ${e.width} ${e.height}`,
	children: /* @__PURE__ */ U(Gl, {
		cx: e.width / 2,
		cy: e.height / 2,
		r: e.height / 2 - 1,
		fill: L
	})
}), bC = (e) => /* @__PURE__ */ U(Zl, {
	width: e.width,
	height: e.height,
	viewBox: `0 0 ${e.width} ${e.height}`,
	children: /* @__PURE__ */ U(Gl, {
		cx: e.width / 2,
		cy: e.height / 2,
		r: e.height / 2 - 1,
		fill: "none",
		stroke: L,
		strokeWidth: "1"
	})
}), xC = (e) => /* @__PURE__ */ U(Zl, {
	width: e.width,
	height: e.height,
	viewBox: `0 0 ${e.width} ${e.height}`,
	children: /* @__PURE__ */ U(Xl, {
		x: "1",
		y: "1",
		width: e.width - 2,
		height: e.height - 2,
		fill: L
	})
}), SC = ({ legalName: e, logoSrc: t, taxStatus: n, customerId: r, address: i, billingEmail: a }) => {
	let o = i ? kc(i) : [], s = [...[a].filter(Boolean), ...o];
	return /* @__PURE__ */ W(R, {
		"data-testid": "customer.view",
		children: [/* @__PURE__ */ W(B, {
			gap: 4,
			children: [t && /* @__PURE__ */ U(R, {
				flexShrink: 0,
				children: /* @__PURE__ */ U(Il, {
					to: `/customers/${r}`,
					children: /* @__PURE__ */ U(JS, {
						src: t,
						size: 32
					})
				})
			}), /* @__PURE__ */ W(R, { children: [/* @__PURE__ */ U(Il, {
				to: `/customers/${r}`,
				color: L,
				children: /* @__PURE__ */ U(V, {
					...j,
					"data-testid": "customer.legalName",
					children: e
				})
			}), /* @__PURE__ */ U(R, { children: s.map((e, t) => /* @__PURE__ */ U(V, {
				...N,
				lineHeight: "18px",
				color: L,
				"data-testid": `customer.address[${t}]`,
				children: e
			}, t)) })] })]
		}), !!n && /* @__PURE__ */ U(R, {
			marginTop: 4,
			children: /* @__PURE__ */ U("div", {
				"data-testid": "customer.taxStatus",
				children: /* @__PURE__ */ U(Rx, {
					variant: "neutral",
					IconComponent: vh,
					children: CC[n]
				})
			})
		})]
	});
}, CC = {
	TAX_EXEMPT: "Tax exempt",
	REVERSE_CHARGED: "Reverse charged",
	TAXED: "Customer will be charged tax based on the included product's tax category"
}, wC = ({ title: e, description: t, icon: n, onDismiss: r, link: i, "data-testid": a }) => /* @__PURE__ */ W(Mx, {
	padding: "12px",
	color: F,
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	position: "relative",
	"data-testid": a,
	children: [
		/* @__PURE__ */ U(B, {
			position: "absolute",
			right: "6px",
			top: "6px",
			width: "20px",
			height: "20px",
			children: /* @__PURE__ */ U(Q, {
				variant: "ghost",
				size: "20px",
				onClick: r,
				icon: /* @__PURE__ */ U($h, { color: k }),
				"aria-label": "Dismiss card"
			})
		}),
		/* @__PURE__ */ W(B, {
			gap: "4px",
			alignItems: "center",
			children: [/* @__PURE__ */ U(n, {
				"aria-hidden": "true",
				color: "inherit"
			}), /* @__PURE__ */ U(V, {
				...Vt,
				as: "span",
				color: "inherit",
				children: e
			})]
		}),
		/* @__PURE__ */ U(V, {
			...tr,
			color: "inherit",
			whiteSpace: "wrap",
			children: t
		}),
		i && /* @__PURE__ */ U(ri, {
			href: i.href,
			target: "_blank",
			color: "#4f46e5",
			width: "fit-content",
			_hover: { color: "#818cf8" },
			_focusVisible: {
				outline: "none",
				boxShadow: "0 0 0 2px #818cf8 ",
				_disabled: { boxShadow: "none" }
			},
			children: /* @__PURE__ */ U(V, {
				...tr,
				color: "inherit",
				children: i.label
			})
		})
	]
}), TC = ({ children: e }) => /* @__PURE__ */ U(B, {
	flexDir: "column",
	border: `${M} 1px solid`,
	borderRadius: "6px",
	children: e
}), EC = ({ name: e, email: t, isLast: n, "data-testid": r }) => /* @__PURE__ */ U(B, {
	borderBottom: n ? void 0 : `${M} 1px solid`,
	padding: "12px 16px",
	children: /* @__PURE__ */ U(DC, {
		name: e,
		email: t,
		"data-testid": r
	})
}), DC = ({ name: e, email: t, "data-testid": n }) => /* @__PURE__ */ W(B, {
	flexDir: "column",
	gap: "4px",
	whiteSpace: "nowrap",
	overflow: "hidden",
	"data-testid": n ? `${n}.item.${t}` : void 0,
	children: [/* @__PURE__ */ U(V, {
		...j,
		color: L,
		textOverflow: "ellipsis",
		overflow: "hidden",
		children: e ?? t
	}), e && /* @__PURE__ */ U(V, {
		...N,
		color: "#64748b",
		textOverflow: "ellipsis",
		overflow: "hidden",
		children: t
	})]
}), OC = Object.assign(TC, {
	Row: EC,
	Item: DC
}), kC = (e) => {
	let [t, n] = Y(0);
	return K(() => {
		e.percentage !== t && setTimeout(() => {
			n(Math.min(e.percentage, 100));
		}, e.animation?.delayBeforeStart ?? 0);
	}, [
		e.percentage,
		t,
		e.animation?.delayBeforeStart
	]), /* @__PURE__ */ U(Fr, {
		thickness: e.thickness ?? "16px",
		size: e.size ?? "16px",
		value: t,
		color: y,
		trackColor: ur,
		sx: { "& > div:first-child": { transition: `width ${e.animation?.duration ?? 500}ms cubic-bezier(0.165, 0.84, 0.44, 1)` } }
	});
}, AC = (e) => {
	let t = e.height ?? "8px";
	return /* @__PURE__ */ U(B, {
		"data-testid": e["data-testid"],
		"data-steps-total": e.stepsTotal,
		"data-steps-completed": e.stepsCompleted,
		"data-is-active": e.isActive,
		height: t,
		width: "100%",
		gap: "4px",
		children: Array.from({ length: e.stepsTotal }).map((t, n) => {
			let r = e.isActive && n === e.stepsCompleted, i = e.stepTooltips?.at(n), a = /* @__PURE__ */ U(B, {
				height: "100%",
				flex: "1",
				borderRadius: "2px",
				border: `${C} 1px solid`,
				backgroundColor: n < e.stepsCompleted ? C : I,
				animation: r ? "colorLoop 4s infinite" : void 0,
				sx: { "@keyframes colorLoop": {
					"0%, 100%": { backgroundColor: `${C}26` },
					"50%": { backgroundColor: `${C}80` }
				} }
			}, n);
			return i ? /* @__PURE__ */ U(m_, {
				label: i,
				shouldWrapChildren: !1,
				children: a
			}, n) : a;
		})
	});
}, jC = ({ value: e, onChange: t, placeholder: n, showBorderBottom: r = !1, "data-testid": i }) => /* @__PURE__ */ U(B, {
	height: "36px",
	alignItems: "center",
	padding: "0px 4px",
	width: "100%",
	borderBottom: r ? `1px solid ${P}` : void 0,
	children: /* @__PURE__ */ U(Q_, {
		"data-testid": i,
		value: e,
		onChange: t,
		placeholder: n,
		showDivider: !1,
		paddingTop: "0px",
		paddingBottom: "0px"
	})
}), MC = ({ label: e, isChecked: t, onClick: n, "data-testid": r }) => /* @__PURE__ */ W(si, {
	"data-testid": r,
	onClick: n,
	gap: "8px",
	children: [/* @__PURE__ */ U(Pr, {
		pointerEvents: "none",
		isChecked: t
	}), /* @__PURE__ */ U(V, {
		...N,
		color: "inherit",
		wordBreak: "break-word",
		children: e
	})]
}), NC = ({ filterType: e, label: t, count: n, icon: r, options: i, asyncConfig: a, selectedIds: o, onChange: s, onClear: c }) => {
	let l = J(crypto.randomUUID()), [u, d] = Y(!1), [f, p] = Y(""), [m, h] = Y(() => a?.cachedOptions ?? []), [g, _] = Y(() => a?.cachedOptions ?? []), [v, y] = Y(!1), b = a?.debounceMs ?? 300, x = !!a, S = G((e) => {
		e.length && h((t) => {
			let n = e.filter((e) => e && e.value);
			if (!n.length) return t;
			let r = /* @__PURE__ */ new Map();
			n.forEach((e) => {
				e.value && r.set(e.value, e);
			}), t.forEach((e) => {
				e.value && !r.has(e.value) && r.set(e.value, e);
			});
			let i = Array.from(r.values());
			return i.length === t.length && i.every((e, n) => {
				let r = t[n];
				return r?.value === e.value && r?.label === e.label;
			}) ? t : i;
		});
	}, []);
	K(() => {
		if (!x) return;
		let e = a?.cachedOptions ?? [];
		S(e), _(e);
	}, [
		a,
		x,
		S
	]), K(() => {
		if (!x) return;
		let e = o.map((e) => m.find((t) => t.value === e) || g.find((t) => t.value === e) || a?.cachedOptions?.find((t) => t.value === e) || i?.find((t) => t.value === e) || null).filter((e) => !!e);
		e.length && S(e);
	}, [
		a?.cachedOptions,
		g,
		x,
		m,
		i,
		S,
		o
	]), K(() => {
		if (!x || !a) return;
		let e = o.filter((e) => !m.some((t) => t.value === e));
		if (e.length === 0) return;
		let n = !1;
		return (async () => {
			let r = await Promise.all(e.map(async (e) => {
				try {
					return await a.fetchOptionById(e);
				} catch (n) {
					return console.warn(`Failed to fetch option for ${t} id ${e}`, n), null;
				}
			}));
			if (n) return;
			let i = r.filter((e) => !!e);
			i.length !== 0 && S(i);
		})(), () => {
			n = !0;
		};
	}, [
		a,
		x,
		t,
		S,
		o,
		m
	]), K(() => {
		if (!x || !a || !u) return;
		let e = !1, n = f.trim(), r = setTimeout(async () => {
			try {
				y(!0);
				let t = await a.fetchOptions(n);
				if (e) return;
				S(t), _(t);
			} catch (r) {
				e || (console.error(`Failed to fetch ${t} options for search "${n}":`, r), _([]));
			} finally {
				e || y(!1);
			}
		}, b);
		return () => {
			e = !0, clearTimeout(r), y(!1);
		};
	}, [
		a,
		b,
		x,
		u,
		t,
		f
	]);
	let { selectedOptions: C, unselectedOptions: w } = q(() => {
		if (!x) {
			let e = (i ?? []).filter((e) => e.label.toLowerCase().includes(f.toLowerCase()));
			return {
				selectedOptions: e.filter((e) => o.includes(e.value)),
				unselectedOptions: e.filter((e) => !o.includes(e.value))
			};
		}
		return {
			selectedOptions: o.map((e) => m.find((t) => t.value === e) ?? {
				value: e,
				label: e
			}),
			unselectedOptions: g.filter((e) => !o.includes(e.value))
		};
	}, [
		g,
		x,
		m,
		i,
		f,
		o
	]);
	K(() => {
		u ? Oc(l.current) : Gc(l.current);
	}, [u]), K(() => {
		!u && f && p("");
	}, [u, f]);
	let T = C.length > 0 || w.length > 0, E = q(() => o.length === 1 ? C[0]?.label ?? o[0] : null, [o, C]);
	return /* @__PURE__ */ W(B, {
		"data-testid": `entityFilters.pill.${e}`,
		background: I,
		borderRadius: "8px",
		border: `${M} 1px solid`,
		color: F,
		width: "fit-content",
		boxShadow: Ht,
		children: [
			/* @__PURE__ */ W(B, {
				gap: "5px",
				p: "7px",
				alignItems: "center",
				children: [r && /* @__PURE__ */ U(r, {}), /* @__PURE__ */ U(V, {
					fontSize: "13px",
					fontWeight: 600,
					color: "inherit",
					children: t
				})]
			}),
			/* @__PURE__ */ W(B, {
				py: "3px",
				gap: "4px",
				children: [/* @__PURE__ */ U(R, {
					background: Fn,
					py: "4px",
					px: "6px",
					borderRadius: "4px",
					height: "24px",
					children: /* @__PURE__ */ U(V, {
						...j,
						color: "inherit",
						noOfLines: 1,
						children: n === 1 ? "is" : "is any of"
					})
				}), /* @__PURE__ */ W(ii, {
					id: l.current,
					variant: "component-library",
					closeOnSelect: !1,
					isLazy: !0,
					isOpen: u,
					onOpen: () => d(!0),
					onClose: () => d(!1),
					children: [/* @__PURE__ */ U(ai, {
						as: R,
						"data-testid": `entityFilters.pill.${e}.menu`,
						background: Fn,
						py: "4px",
						px: "6px",
						borderRadius: "4px",
						height: "24px",
						maxWidth: "200px",
						_hover: { background: P },
						_active: { background: P },
						_focus: { outline: "none" },
						cursor: "pointer",
						children: /* @__PURE__ */ U(B, {
							gap: "4px",
							alignItems: "center",
							children: /* @__PURE__ */ U(V, {
								...j,
								color: "inherit",
								noOfLines: 1,
								children: n === 1 ? E || "1 item" : `${n} items`
							})
						})
					}), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ W(ci, {
						width: "320px",
						maxHeight: "516px",
						overflowY: "auto",
						padding: "0px !important",
						children: [/* @__PURE__ */ U(jC, {
							value: f,
							onChange: p,
							placeholder: `Search ${Tc(t.toLowerCase())}`,
							showBorderBottom: T
						}), /* @__PURE__ */ U(R, {
							maxHeight: "300px",
							overflowY: "auto",
							children: x && v ? /* @__PURE__ */ W(B, {
								px: "12px",
								py: "10px",
								alignItems: "center",
								justifyContent: "center",
								gap: "8px",
								children: [/* @__PURE__ */ U(ki, { size: "sm" }), /* @__PURE__ */ W(V, {
									...N,
									color: k,
									children: [
										"Loading ",
										Tc(t.toLowerCase()),
										"…"
									]
								})]
							}) : T ? /* @__PURE__ */ W(R, {
								padding: "4px",
								children: [C.map((t) => /* @__PURE__ */ U(MC, {
									"data-testid": `entityFilters.pill.${e}.option.${t.value}`,
									label: t.label,
									isChecked: !0,
									onClick: () => {
										s(o.filter((e) => e !== t.value));
									}
								}, t.value)), w.map((t) => /* @__PURE__ */ U(MC, {
									"data-testid": `entityFilters.pill.${e}.option.${t.value}`,
									label: t.label,
									isChecked: !1,
									onClick: () => {
										s([...o, t.value]);
									}
								}, t.value))]
							}) : /* @__PURE__ */ U(R, {
								px: "12px",
								py: "10px",
								children: /* @__PURE__ */ U(V, {
									...N,
									color: k,
									"data-testid": "entityFilters.noResults",
									children: f ? `No ${Tc(t.toLowerCase())} found` : `No ${Tc(t.toLowerCase())} available`
								})
							})
						})]
					}) })]
				})]
			}),
			/* @__PURE__ */ U(B, {
				p: "3px",
				children: /* @__PURE__ */ U(R, {
					as: "button",
					"data-testid": `entityFilters.pill.${e}.clear`,
					onClick: (e) => {
						e.stopPropagation(), c();
					},
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: "4px",
					boxSize: "24px",
					color: k,
					_hover: {
						color: L,
						background: P
					},
					children: /* @__PURE__ */ U($h, { color: "inherit" })
				})
			})
		]
	});
}, PC = ({ items: e, searchOn: t }) => {
	let [n, r] = Y(""), i = q(() => e.filter((e) => typeof e[t] == "string" && e[t].toLowerCase().includes(n.toLowerCase())), [
		e,
		n,
		t
	]), a = G(() => {
		r("");
	}, []);
	return {
		results: i,
		input: {
			value: n,
			onChange: (e) => r(e)
		},
		reset: a
	};
}, FC = (e, t) => Object.hasOwn(e, t), IC = (e, t) => {
	e[t.value] = t;
}, LC = (e, t) => e[t], RC = (e, t) => Object.hasOwn(e, t), zC = ({ filterConfigs: e, selectedFilters: t, hasActiveFilters: n, onFilterChange: r, renderButton: i, showIconsInMenu: a = !0 }) => {
	let o = J(crypto.randomUUID()), [s, c] = Y(!1), [l, u] = Y(null), [d, f] = Y(""), p = J({}), m = J({}), [h, g] = Y([]), [_, v] = Y(!1), y = q(() => e.filter(({ type: e }) => !t[e]?.length), [e, t]), b = y.length > 0, { results: x, input: S } = PC({
		items: y,
		searchOn: "label"
	});
	K(() => {
		s ? Oc(o.current) : Gc(o.current);
	}, [s]);
	let C = () => {
		c(!1), u(null), f(""), p.current = {}, m.current = {}, g([]), v(!1);
	}, w = (e) => {
		u(e);
	}, T = (e, t) => {
		r(e, t);
	}, E = q(() => l ? e.find(({ type: e }) => e === l) : null, [l, e]), D = !!E?.asyncConfig, ee = E?.asyncConfig?.debounceMs ?? 300;
	K(() => {
		if (!(!E || !E.asyncConfig)) if (E.asyncConfig.cachedOptions?.length) {
			E.asyncConfig.cachedOptions.forEach((e) => {
				IC(p.current, e);
			});
			let e = [...E.asyncConfig.cachedOptions];
			g(e), m.current[""] = e;
		} else g([]), delete m.current[""];
	}, [E]), K(() => {
		if (!E || !E.asyncConfig) return;
		let e = (t[E.type] || []).filter((e) => !FC(p.current, e));
		if (e.length === 0) return;
		let n = !1;
		return (async () => {
			let t = await Promise.all(e.map(async (e) => {
				try {
					return await E.asyncConfig.fetchOptionById(e);
				} catch (t) {
					return console.warn(`Failed to fetch option for ${E.label} id ${e}`, t), null;
				}
			}));
			if (n) return;
			let r = t.filter((e) => !!e);
			r.length && (r.forEach((e) => {
				IC(p.current, e);
			}), g((e) => {
				let t = [...e];
				return r.forEach((e) => {
					t.some((t) => t.value === e.value) || t.push(e);
				}), t;
			}));
		})(), () => {
			n = !0;
		};
	}, [E, t]), K(() => {
		if (!s || !E || !E.asyncConfig) return;
		let e = !1, t = d.trim();
		if (!t && E.asyncConfig.cachedOptions?.length) return g([...E.asyncConfig.cachedOptions]), () => {
			e = !0;
		};
		if (t && RC(m.current, t)) {
			let n = m.current[t] ?? [];
			return n.forEach((e) => {
				IC(p.current, e);
			}), g([...n]), () => {
				e = !0;
			};
		}
		let n = setTimeout(async () => {
			try {
				v(!0);
				let n = await E.asyncConfig.fetchOptions(t);
				if (e) return;
				n.forEach((e) => {
					IC(p.current, e);
				}), g(n), m.current[t] = n;
			} catch (n) {
				e || (console.error(`Failed to fetch ${E.label} options for search "${t}":`, n), g([]), delete m.current[t]);
			} finally {
				e || v(!1);
			}
		}, ee);
		return () => {
			e = !0, clearTimeout(n), v(!1);
		};
	}, [
		E,
		ee,
		D,
		s,
		d
	]);
	let te = q(() => {
		if (!E) return [];
		if (D) {
			let e = new Set(t[E.type] || []), n = Array.from(e).map((e) => LC(p.current, e)).filter((e) => !!e), r = h.filter((t) => !e.has(t.value));
			return [...n, ...r];
		}
		return (E.options ?? []).filter((e) => e.label.toLowerCase().includes(d.toLowerCase()));
	}, [
		E,
		h,
		D,
		d,
		t
	]), O = l && t[l] || [];
	return /* @__PURE__ */ W(ii, {
		id: o.current,
		isOpen: s,
		onOpen: () => c(!0),
		onClose: C,
		variant: "component-library",
		closeOnSelect: !1,
		offset: [0, 4],
		autoSelect: !1,
		isLazy: !0,
		children: [/* @__PURE__ */ U(ai, {
			"data-testid": "entityFilters.add",
			disabled: !b,
			cursor: b ? void 0 : "not-allowed",
			children: i ? i({
				hasActiveFilters: n,
				disabled: !b
			}) : /* @__PURE__ */ U(Q, {
				...n ? { icon: /* @__PURE__ */ U(Tm, { color: "inherit" }) } : { leadingIcon: /* @__PURE__ */ U(Tm, { color: "inherit" }) },
				variant: "secondary",
				disabled: !b,
				children: n ? null : "Filters"
			})
		}), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(ci, {
			"data-testid": "entityFilters.menu",
			width: "320px",
			maxHeight: "516px",
			overflowY: "auto",
			padding: "0px !important",
			children: E ? /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(jC, {
				"data-testid": "entityFilters.search",
				value: d,
				onChange: f,
				placeholder: `Search ${Tc(E.label.toLowerCase())}`,
				showBorderBottom: te.length > 0
			}), /* @__PURE__ */ U(R, {
				maxHeight: "300px",
				overflowY: "auto",
				children: D && _ ? /* @__PURE__ */ W(B, {
					px: "12px",
					py: "10px",
					alignItems: "center",
					justifyContent: "center",
					gap: "8px",
					children: [/* @__PURE__ */ U(ki, { size: "sm" }), /* @__PURE__ */ W(V, {
						...N,
						color: k,
						children: [
							"Loading ",
							Tc(E.label.toLowerCase()),
							"…"
						]
					})]
				}) : te.length === 0 ? /* @__PURE__ */ U(R, {
					px: "12px",
					py: "10px",
					children: /* @__PURE__ */ U(V, {
						...N,
						color: k,
						children: d ? `No ${Tc(E.label.toLowerCase())} found` : `No ${Tc(E.label.toLowerCase())} available`
					})
				}) : !!te.length && /* @__PURE__ */ U(R, {
					padding: "4px",
					children: te.map((e) => {
						let t = O.includes(e.value);
						return /* @__PURE__ */ U(MC, {
							"data-testid": `entityFilters.type.${E.type}.option.${e.value}`,
							label: e.label,
							isChecked: t,
							onClick: () => {
								let n = t ? O.filter((t) => t !== e.value) : [...O, e.value];
								T(E.type, n);
							}
						}, e.value);
					})
				})
			})] }) : /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(jC, {
				"data-testid": "entityFilters.search",
				value: S.value,
				onChange: S.onChange,
				placeholder: "Search filters",
				showBorderBottom: !!x
			}), !!x && /* @__PURE__ */ U(R, {
				padding: "4px",
				children: x.map((e) => /* @__PURE__ */ U(si, {
					"data-testid": `entityFilters.type.${e.type}`,
					icon: e.icon && a ? /* @__PURE__ */ U(e.icon, {}) : void 0,
					iconSpacing: "8px",
					onClick: (t) => {
						t.preventDefault(), t.stopPropagation(), w(e.type);
					},
					children: e.label
				}, e.type))
			})] })
		}) })]
	});
}, BC = ({ filters: e, initialFilters: t, selectedFilters: n, onFilterChange: r }) => {
	Ml(!(t && n), "Cannot provide both initialFilters and selectedFilters. Please choose either to use the component in controlled or uncontrolled mode.");
	let [i, a] = Y(t ?? {}), o = n !== void 0, s = q(() => o ? n : i, [
		o,
		n,
		i
	]);
	Ml(!!s, "Must provide either initialFilters or selectedFilters to useEntityFiltersBar.");
	let c = G((e) => {
		o || a((t) => typeof e == "function" ? e(t) : e), r?.(e);
	}, [r, o]), l = Yc(s);
	return K(() => {
		l && eu(l, t) || l && !eu(s, l) && c(s);
	}, [
		t,
		s,
		l,
		c
	]), {
		selectedFilters: s,
		updateFilter: (e, t) => c((n) => ({
			...n,
			[e]: t
		})),
		clearFilter: (e) => {
			c((t) => ({
				...t,
				[e]: []
			}));
		},
		reinitialize: (e) => c(e),
		previousSelectedFilters: l,
		activeFilterPills: q(() => e.filter((e) => {
			let t = s[e.type];
			return t && t.length > 0;
		}).map((e) => {
			let t = s[e.type];
			return {
				filterType: e.type,
				label: e.label,
				count: t.length,
				icon: e.icon,
				options: e.options,
				asyncConfig: e.asyncConfig,
				selectedIds: t
			};
		}), [e, s]),
		hasActiveFilters: q(() => Object.values(s).some((e) => e.length > 0), [s]),
		availableFilters: q(() => e.filter((e) => !(s[e.type]?.length > 0)), [e, s])
	};
}, VC = gc(({ filterConfigs: e, selectedFilters: t, onFilterChange: n }) => {
	let { selectedFilters: r, updateFilter: i, activeFilterPills: a, hasActiveFilters: o } = BC({
		filters: e,
		selectedFilters: t
	}), s = (e, t) => {
		i(e, t), n(e, t);
	};
	return /* @__PURE__ */ W(B, {
		gap: "8px",
		alignItems: "start",
		flexWrap: "wrap",
		children: [a.map((e) => /* @__PURE__ */ U(NC, {
			filterType: e.filterType,
			label: e.label,
			count: e.count,
			icon: e.icon,
			options: e.options,
			asyncConfig: e.asyncConfig,
			selectedIds: e.selectedIds,
			onChange: (t) => s(e.filterType, t),
			onClear: () => s(e.filterType, [])
		}, e.filterType)), /* @__PURE__ */ U(zC, {
			filterConfigs: e,
			selectedFilters: r,
			hasActiveFilters: o,
			onFilterChange: s
		})]
	});
}), HC = Ol(Wr)`
  ${({ $size: e }) => X(e).with("lg", () => kl(Je)).with("sm", () => kl(j)).otherwise(() => kl(ar))}
`, UC = ({ children: e, size: t, "data-testid": n, ...r }) => e ? /* @__PURE__ */ U(B, {
	color: F,
	alignItems: "end",
	height: "24px",
	pb: 2,
	"data-testid": n,
	children: /* @__PURE__ */ U(HC, {
		$size: t,
		...r,
		children: e
	})
}) : null, WC = Object.assign(({ children: e, "data-testid": t }) => /* @__PURE__ */ U(B, {
	gap: "8px",
	flexDir: "column",
	"data-testid": t,
	children: e
}), { Item: ({ name: e, email: t, icon: n, badgeText: r, "data-testid": i, "data-status": a, "data-notification-status": o, tooltipLabel: s, caption: c, styles: l }) => /* @__PURE__ */ U(m_, {
	label: s ?? t,
	placement: "left",
	children: /* @__PURE__ */ W(B, {
		gap: "8px",
		"data-testid": i,
		"data-status": a,
		"data-notification-status": o,
		children: [/* @__PURE__ */ U(B, {
			paddingY: "4px",
			children: n
		}), /* @__PURE__ */ W(B, {
			flexDir: "column",
			whiteSpace: "nowrap",
			overflow: "hidden",
			gap: "4px",
			width: "100%",
			children: [/* @__PURE__ */ W(B, {
				gap: "8px",
				alignItems: "center",
				paddingY: r ? void 0 : "4px",
				children: [/* @__PURE__ */ U(V, {
					...N,
					color: l?.name?.color ?? "#334155",
					textOverflow: "ellipsis",
					overflow: "hidden",
					flex: "1",
					"data-testid": i ? `${i}.name` : void 0,
					children: e
				}), r && /* @__PURE__ */ U(ig, { children: r })]
			}), c && /* @__PURE__ */ U(V, {
				...tr,
				color: l?.caption?.color ?? "#334155",
				textOverflow: "ellipsis",
				overflow: "hidden",
				flex: "1",
				"data-testid": i ? `${i}.caption` : void 0,
				children: c
			})]
		})]
	})
}) }), GC = (e) => /* @__PURE__ */ U(WC, { ...e }), KC = (e) => /* @__PURE__ */ U(WC.Item, {
	...e,
	icon: /* @__PURE__ */ U(qC, { status: e.status }),
	"data-testid": `signerStatusList.item.${e.email}`,
	"data-status": e.status
}), qC = ({ status: e }) => /* @__PURE__ */ U(z, {
	width: "16px",
	height: "16px",
	color: M,
	flexShrink: "0",
	children: X(e).with("PENDING", () => /* @__PURE__ */ U($p, {})).with("READY", () => /* @__PURE__ */ U(Bf, {})).with("SIGNED", () => /* @__PURE__ */ U(Rp, { color: F })).exhaustive()
}), JC = Object.assign(GC, { Item: KC }), YC = ({ width: e, height: t, data: n, parseDataX: r, parseDataY: i, tooltip: a, axisBottomTickFormat: o, alignFirstXAxisLabelToLeft: s = !0, style: c = {}, showColumnGrid: l = !0, useXAxisLines: u = !0 }) => {
	let d = e - 30, f = t - 12 - 26, p = q(() => cu({
		range: [0, d],
		domain: n.map(r),
		padding: .4,
		align: 0
	}), [
		d,
		n,
		r
	]), m = q(() => {
		let e = Math.max(...n.map(i));
		return lu({
			range: [f, 0],
			domain: [0, e === 0 ? 1 : e],
			nice: !0
		});
	}, [
		f,
		n,
		i
	]), h = m.ticks(), g = q(() => {
		let e = Math.max(...h), t = e / 3;
		return [
			0,
			t,
			2 * t,
			e
		];
	}, [h]), { tooltipData: _, tooltipLeft: v, tooltipTop: y, tooltipOpen: b, showTooltip: x, hideTooltip: S } = fu(), C = (e, t, n) => {
		x({
			tooltipLeft: e,
			tooltipTop: t,
			tooltipData: n
		});
	}, [w, T] = Y();
	return K(() => {
		T(crypto.randomUUID());
	}, []), /* @__PURE__ */ W(R, {
		position: "relative",
		children: [/* @__PURE__ */ W("svg", {
			width: e,
			height: t,
			onMouseLeave: S,
			overflow: "visible",
			children: [
				/* @__PURE__ */ U(au, {
					id: `fill-${w}`,
					from: c.barGradient?.from ?? "rgba(20, 184, 166, 0.69)",
					to: c.barGradient?.to ?? "rgba(20, 184, 166, 1.0)"
				}),
				/* @__PURE__ */ U(su, {
					scale: m,
					width: d,
					tickValues: g,
					top: 12,
					left: 30,
					stroke: P,
					strokeDasharray: c.yAxis?.strokeDash ?? void 0
				}),
				l && /* @__PURE__ */ U(ou, {
					scale: p,
					height: f,
					top: 12,
					left: 30,
					numTicks: n.length,
					stroke: "#e2e8f0",
					strokeDasharray: "2"
				}),
				/* @__PURE__ */ U(jl, {
					initial: !1,
					children: _ && /* @__PURE__ */ U(Nl.g, {
						initial: {
							opacity: 0,
							x: (v || 0) + p.bandwidth() / 2
						},
						animate: {
							opacity: 1,
							x: (v || 0) + p.bandwidth() / 2
						},
						exit: { opacity: 0 },
						transition: {
							ease: "linear",
							duration: .1
						},
						children: /* @__PURE__ */ U(ru, {
							from: {
								x: 0,
								y: 12
							},
							to: {
								x: 0,
								y: 12 + f
							},
							stroke: "rgba(226, 232, 240, 1)",
							strokeWidth: 2,
							pointerEvents: "none"
						})
					})
				}),
				/* @__PURE__ */ U(iu, { children: n.map((e) => {
					let t = r(e), n = p.bandwidth(), a = f - (m(i(e)) ?? 0), o = (p(t) || 0) + 30, s = f - a + 12;
					return /* @__PURE__ */ W(uc, { children: [/* @__PURE__ */ U(tu, {
						width: n,
						height: d - 26,
						fill: "transparent",
						x: o,
						y: 12,
						onMouseOver: () => C(o, s, e)
					}), /* @__PURE__ */ U(nu, {
						x: o || 0,
						y: s,
						width: n,
						height: a,
						fill: `url(#fill-${w})`,
						radius: 2,
						top: !0,
						pointerEvents: "none"
					})] }, `bar-${t}`);
				}) }),
				/* @__PURE__ */ U(jl, {
					initial: !1,
					children: _ && /* @__PURE__ */ U(Nl.circle, {
						initial: { opacity: 0 },
						animate: {
							opacity: 1,
							cx: (v || 0) + p.bandwidth() / 2,
							cy: y
						},
						exit: { opacity: 0 },
						transition: {
							ease: "linear",
							duration: .1
						},
						r: 4,
						fill: "#0d9488",
						stroke: "white",
						strokeWidth: 2,
						pointerEvents: "none"
					})
				}),
				/* @__PURE__ */ U(du, {
					scale: m,
					left: 35,
					top: 12,
					hideAxisLine: !0,
					hideTicks: !0,
					tickFormat: (e, t, n) => t === 0 || t === n.length - 1 ? e.toString() : "",
					tickLabelProps: {
						fill: k,
						...tr
					}
				}),
				/* @__PURE__ */ U(uu, {
					left: 30,
					scale: p,
					top: f + 12,
					tickFormat: o,
					numTicks: 6,
					hideTicks: !0,
					stroke: P,
					tickComponent: ({ x: e, y: t, formattedValue: n }) => {
						let r = e === p.bandwidth() / 2;
						return /* @__PURE__ */ W("g", { children: [u && /* @__PURE__ */ U("line", {
							x1: r && s ? 0 : e,
							x2: r && s ? 0 : e,
							y1: "0",
							y2: "8",
							fill: "transparent",
							shapeRendering: "crispEdges",
							stroke: "#cbd5e1",
							strokeWidth: "1",
							strokeLinecap: "square"
						}), /* @__PURE__ */ U("text", {
							x: r && s ? 0 : e,
							y: t + 4,
							textAnchor: r && s ? "left" : "middle",
							fill: c.xAxis?.labelColor ?? "#475569",
							...tr,
							children: n
						})] });
					}
				})
			]
		}), /* @__PURE__ */ U(jl, {
			initial: !1,
			children: b && _ && /* @__PURE__ */ U(Nl.div, {
				initial: {
					left: (v || 0) + p.bandwidth() / 2,
					opacity: 0
				},
				animate: {
					left: (v || 0) + p.bandwidth() / 2,
					opacity: 1
				},
				exit: { opacity: 0 },
				transition: {
					ease: "linear",
					duration: .1
				},
				style: {
					transform: "translate(-50%, 0px)",
					border: "rgba(226, 232, 240, 1) 1px solid",
					background: "white",
					padding: "4px 8px",
					borderRadius: "44px",
					boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.08)",
					top: 0,
					position: "absolute",
					pointerEvents: "none"
				},
				children: a(_)
			})
		})]
	});
}, XC = ({ width: e, height: t, data: n, parseDataX: r, axisBottomTickFormat: i, alignFirstXAxisLabelToLeft: a = !0, style: o = {} }) => {
	let s = e - 30, c = t - 12 - 26, l = q(() => cu({
		range: [0, s],
		domain: n.map(r),
		padding: .4,
		align: 0
	}), [
		s,
		n,
		r
	]), u = q(() => lu({
		range: [c, 0],
		domain: [0, 1],
		nice: !0
	}), [c]), d = u.ticks(), f = q(() => {
		let e = Math.max(...d);
		return [
			0,
			e / 2,
			e
		];
	}, [d]), [p, m] = Y();
	return K(() => {
		m(crypto.randomUUID());
	}, []), /* @__PURE__ */ U(R, {
		position: "relative",
		children: /* @__PURE__ */ W("svg", {
			width: e,
			height: t,
			overflow: "visible",
			children: [
				/* @__PURE__ */ U(au, {
					id: `fill-${p}`,
					from: o.barGradient?.from ?? "rgba(20, 184, 166, 0.69)",
					to: o.barGradient?.to ?? "rgba(20, 184, 166, 1.0)"
				}),
				/* @__PURE__ */ U(su, {
					scale: u,
					width: s,
					tickValues: f,
					top: 12,
					left: 30,
					stroke: P,
					strokeDasharray: o.yAxis?.strokeDash ?? void 0
				}),
				/* @__PURE__ */ U(iu, {
					top: 12,
					left: 30,
					children: /* @__PURE__ */ U(ru, {
						from: {
							x: 0,
							y: c / 2
						},
						to: {
							x: s,
							y: c / 2
						},
						stroke: "rgba(95, 92, 255, 1)",
						strokeWidth: 1,
						pointerEvents: "none"
					})
				}),
				/* @__PURE__ */ U(du, {
					scale: u,
					left: 35,
					top: 12,
					hideAxisLine: !0,
					hideTicks: !0,
					tickFormat: (e, t, n) => t === 0 || t === n.length - 1 ? "0" : "",
					tickLabelProps: {
						fill: F,
						fontSize: 12
					}
				}),
				/* @__PURE__ */ U(uu, {
					left: 30,
					scale: l,
					top: c + 12,
					tickFormat: i,
					numTicks: 6,
					hideTicks: !0,
					stroke: P,
					tickComponent: ({ x: e, y: t, formattedValue: n }) => {
						let r = e === l.bandwidth() / 2;
						return /* @__PURE__ */ W("g", { children: [/* @__PURE__ */ U("line", {
							x1: r && a ? 0 : e,
							x2: r && a ? 0 : e,
							y1: "0",
							y2: "8",
							fill: "transparent",
							shapeRendering: "crispEdges",
							stroke: M,
							strokeWidth: "1",
							strokeLinecap: "square"
						}), /* @__PURE__ */ U("text", {
							x: r && a ? 0 : e,
							y: t + 4,
							fontSize: 12,
							textAnchor: r && a ? "left" : "middle",
							fill: o.xAxis?.labelColor ?? "#475569",
							children: n
						})] });
					}
				})
			]
		})
	});
}, ZC = [
	{
		id: "CURRENT",
		description: "Current billing period"
	},
	{
		id: "LAST",
		description: "Last billing period"
	},
	{
		id: "LAST_THREE",
		description: "Last 3 billing periods"
	},
	{
		id: "ALL",
		description: "All time"
	}
], QC = ({ usagePeriodType: e, setUsagePeriodType: t, usageDataResponse: n, metricName: r, isUpdating: i = !1, "data-testid": a }) => {
	let [o, s] = Y("d MMM"), [c, l] = Y(!0);
	K(() => {
		let t = e === "LAST_THREE" || e === "ALL";
		s(t ? "MMM yyyy" : "d MMM"), l(!t);
	}, [n]);
	let { data: u } = n;
	return u ? /* @__PURE__ */ W(R, {
		borderRadius: "6px",
		padding: "16px",
		border: `1px solid ${P}`,
		boxShadow: Pn,
		background: I,
		"data-testid": a,
		children: [
			/* @__PURE__ */ W(B, {
				flexDirection: "row",
				alignItems: "flex-start",
				justifyContent: "space-between",
				children: [/* @__PURE__ */ W(B, {
					flexDirection: "column",
					gap: "8px",
					children: [
						/* @__PURE__ */ U(V, {
							...j,
							fontWeight: 600,
							color: k,
							"data-testid": a ? `${a}.metricName` : void 0,
							children: r
						}),
						/* @__PURE__ */ U(V, {
							...Je,
							color: Ft,
							"data-testid": a ? `${a}.total` : void 0,
							children: u.total
						}),
						/* @__PURE__ */ U(V, {
							...N,
							color: k,
							children: rl({
								from: new Date(u.usageStart),
								to: e === "LAST" ? new Date(u.usageEnd) : /* @__PURE__ */ new Date(),
								separator: "-"
							})
						})
					]
				}), /* @__PURE__ */ U(zv, {
					options: ZC.map((e) => ({
						value: e.id,
						label: e.description
					})),
					placeholder: "Choose period",
					initialValue: e,
					onChange: (e) => t(e),
					matchWidth: !0,
					disabled: i,
					"data-testid": a ? `${a}.period` : void 0
				})]
			}),
			/* @__PURE__ */ U(R, { height: "28px" }),
			/* @__PURE__ */ U(R, {
				height: "200px",
				width: "100%",
				opacity: i ? .5 : 1,
				transition: "opacity 250ms",
				children: /* @__PURE__ */ U(pu, { children: (e) => u.total === "0" ? /* @__PURE__ */ U(XC, {
					width: e.width,
					height: e.height,
					data: u.usageData,
					parseDataX: (e) => e.periodStart,
					parseDataY: (e) => Number(e.amount),
					axisBottomTickFormat: (e) => jc(e.toString(), o),
					alignFirstXAxisLabelToLeft: c,
					style: {
						barGradient: {
							from: "rgba(129, 140, 248, 0.69)",
							to: C
						},
						yAxis: { strokeDash: "2" }
					}
				}) : /* @__PURE__ */ U(YC, {
					width: e.width,
					height: e.height,
					data: u.usageData,
					parseDataX: (e) => e.periodStart,
					parseDataY: (e) => Number(e.amount),
					axisBottomTickFormat: (e) => jc(e.toString(), o),
					tooltip: (e) => /* @__PURE__ */ W(V, {
						as: "p",
						whiteSpace: "nowrap",
						...tr,
						children: [
							/* @__PURE__ */ U(V, {
								as: "span",
								...Vt,
								children: e.amount
							}),
							" – ",
							jc(e.periodStart, o)
						]
					}),
					alignFirstXAxisLabelToLeft: c,
					style: {
						barGradient: {
							from: C,
							to: C
						},
						xAxis: { labelColor: k }
					}
				}) })
			})
		]
	}) : /* @__PURE__ */ U(H, {});
}, $C = C, ew = Su({
	backgroundColor: "transparent",
	colors: [$C],
	gridColor: M,
	gridColorDark: M,
	svgLabelSmall: { fill: k },
	tickLength: 0,
	xTickLineStyles: { stroke: "transparent" },
	yTickLineStyles: { stroke: "transparent" },
	gridStyles: { strokeDasharray: "3, 3" }
}), tw = ({ renderTooltip: e }) => /* @__PURE__ */ U(bu, {
	showVerticalCrosshair: !0,
	snapTooltipToDatumY: !0,
	verticalCrosshairStyle: {
		stroke: $C,
		strokeWidth: 1
	},
	style: {
		position: "absolute",
		zIndex: 2e3
	},
	renderTooltip: ({ tooltipData: t }) => !t || !t.nearestDatum ? null : e(t.nearestDatum.datum)
}), nw = ({ data: e, xAccessor: t, yAccessor: n }) => /* @__PURE__ */ U(hu, {
	dataKey: "value",
	data: e,
	radius: 2,
	radiusTop: !0,
	xAccessor: t,
	yAccessor: n
}), rw = ({ data: e, xAccessor: t, yAccessor: n, useLinearCurve: r }) => /* @__PURE__ */ U(_u, {
	dataKey: "value",
	data: e,
	xAccessor: t,
	yAccessor: n,
	curve: r ? wu : Tu
}), iw = ({ data: e, xAccessor: t, yAccessor: n }) => /* @__PURE__ */ U(_u, {
	dataKey: "value",
	data: e,
	xAccessor: t,
	yAccessor: n,
	curve: Eu
}), aw = "max", ow = 2, sw = tr, cw = 6, lw = ({ variant: e, dateFrom: t, dateTo: n, data: r, unit: i, unitTickValues: a, renderTooltip: o, animate: s = !0, dateFormat: c = "MMM yyyy", showAllDateTicks: l = !1, useLinearCurve: u = !1, "data-testid": d, customXAxisDateFormatter: f }) => {
	let p = q(() => ({
		date: (e) => e.date,
		value: (e) => e.value
	}), []), m = G((e) => `${i}${Intl.NumberFormat("en-GB", {
		notation: "compact",
		maximumFractionDigits: 1
	}).format(e)}`, [i]), h = () => X(e).with("line", () => /* @__PURE__ */ U(rw, {
		data: r,
		xAccessor: p.date,
		yAccessor: p.value,
		useLinearCurve: u
	})).with("stepLine", () => /* @__PURE__ */ U(iw, {
		data: r,
		xAccessor: p.date,
		yAccessor: p.value
	})).with("bar", () => /* @__PURE__ */ U(nw, {
		data: r,
		xAccessor: p.date,
		yAccessor: p.value
	})).exhaustive(), g = l ? r.map((e) => e.date) : [t, n], _ = r.length > 0, v = q(() => {
		let e = a.map((e) => m(e)).map((e) => Cu(e, sw) || 0);
		return Math.max(...e) + cw;
	}, [m, a]), y = f || ((e) => nl(new Date(e), c));
	return /* @__PURE__ */ U(pu, { children: ({ width: e, height: i }) => {
		let c = {
			top: 10,
			right: v,
			bottom: 24,
			left: 0
		}, u = cu({
			range: [0, e - c.right],
			domain: r.map((e) => p.date(e)),
			padding: .3,
			align: 0
		});
		return /* @__PURE__ */ W(xu, {
			theme: ew,
			xScale: {
				type: "band",
				padding: .3
			},
			yScale: {
				type: "linear",
				zero: !0,
				domain: _ && a.length > 0 ? [Math.min(0, ...a), Math.max(0, ...a)] : void 0
			},
			height: i,
			width: e,
			margin: c,
			children: [
				s ? /* @__PURE__ */ U(gu, {
					rows: !0,
					columns: !1,
					tickValues: _ ? a : [t, n],
					animationTrajectory: aw
				}) : /* @__PURE__ */ U(yu, {
					rows: !0,
					columns: !1,
					tickValues: _ ? a : [t, n]
				}),
				/* @__PURE__ */ U("g", {
					"data-testid": d ? `${d}.yAxisLabels` : void 0,
					children: s ? /* @__PURE__ */ U(mu, {
						hideAxisLine: !0,
						orientation: "right",
						numTicks: ow,
						animationTrajectory: aw,
						tickLabelProps: sw,
						tickFormat: m,
						tickLength: 3,
						tickValues: _ ? a : [0, 0]
					}) : /* @__PURE__ */ U(vu, {
						hideAxisLine: !0,
						orientation: "right",
						numTicks: ow,
						tickLabelProps: sw,
						tickFormat: m,
						tickLength: 3,
						tickValues: _ ? a : [0, 0]
					})
				}),
				/* @__PURE__ */ U("g", {
					"data-testid": d ? `${d}.xAxisLabels` : void 0,
					children: r.length >= 1 || !s ? /* @__PURE__ */ U(uu, {
						scale: u,
						orientation: "bottom",
						numTicks: l ? r.length : ow,
						tickLabelProps: sw,
						strokeWidth: 1,
						tickFormat: (e) => y(e),
						tickValues: g,
						top: i - c.bottom,
						hideTicks: !0,
						stroke: P,
						tickComponent: ({ x: t, formattedValue: n }) => {
							if (l) return /* @__PURE__ */ U("g", { children: /* @__PURE__ */ U("text", {
								x: t + u.bandwidth() / 2,
								y: 30,
								fontSize: 12,
								textAnchor: "middle",
								fill: k,
								children: n
							}) });
							let r = t === u.bandwidth() / 2, i = Cu(n ?? "", sw) || 0;
							return /* @__PURE__ */ U("g", { children: /* @__PURE__ */ U("text", {
								x: r ? 0 : e - c.right - i - cw,
								y: 22,
								fontSize: 12,
								textAnchor: r ? "left" : "right",
								fill: k,
								children: n
							}) });
						}
					}) : /* @__PURE__ */ U(mu, {
						orientation: "bottom",
						numTicks: ow,
						tickLabelProps: sw,
						strokeWidth: 1,
						tickFormat: (e) => y(e),
						tickValues: g,
						tickLength: 30
					})
				}),
				h(),
				/* @__PURE__ */ U(tw, { renderTooltip: o })
			]
		});
	} });
}, uw = ({ children: e, "data-testid": t }) => /* @__PURE__ */ W(Ar, {
	bg: "white",
	boxShadow: "0 2px 4px 0 rgba(15, 23, 42, 0.08)",
	borderRadius: "md",
	width: "270px",
	border: `1px solid ${P}`,
	"data-testid": t,
	children: [/* @__PURE__ */ U(Mr, {
		px: 3,
		py: 2,
		bg: "gray.10",
		borderBottom: `1px solid ${P}`,
		children: e[0]
	}), /* @__PURE__ */ U(jr, {
		py: 2,
		px: 3,
		as: B,
		justifyContent: "space-between",
		children: e[1]
	})]
}), dw = 50, fw = 20, pw = 100;
//#endregion
//#region ../../node_modules/@tanstack/table-core/build/lib/index.mjs
function mw(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function hw(e, t) {
	return (n) => {
		t.setState((t) => ({
			...t,
			[e]: mw(n, t[e])
		}));
	};
}
function gw(e) {
	return e instanceof Function;
}
function _w(e) {
	return Array.isArray(e) && e.every((e) => typeof e == "number");
}
function vw(e, t) {
	let n = [], r = (e) => {
		e.forEach((e) => {
			n.push(e);
			let i = t(e);
			i != null && i.length && r(i);
		});
	};
	return r(e), n;
}
function $(e, t, n) {
	let r = [], i;
	return () => {
		let a;
		n.key && n.debug && (a = Date.now());
		let o = e();
		if (!(o.length !== r.length || o.some((e, t) => r[t] !== e))) return i;
		r = o;
		let s;
		if (n.key && n.debug && (s = Date.now()), i = t(...o), n == null || n.onChange == null || n.onChange(i), n.key && n.debug && n != null && n.debug()) {
			let e = Math.round((Date.now() - a) * 100) / 100, t = Math.round((Date.now() - s) * 100) / 100, r = t / 16, i = (e, t) => {
				for (e = String(e); e.length < t;) e = " " + e;
				return e;
			};
			console.info(`%c⏱ ${i(t, 5)} /${i(e, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * r, 120))}deg 100% 31%);`, n?.key);
		}
		return i;
	};
}
function yw(e, t, n, r) {
	let i = {
		...e._getDefaultColumnDef(),
		...t
	}, a = i.accessorKey, o = i.id ?? (a ? a.replace(".", "_") : void 0) ?? (typeof i.header == "string" ? i.header : void 0), s;
	if (i.accessorFn ? s = i.accessorFn : a && (s = a.includes(".") ? (e) => {
		let t = e;
		for (let e of a.split(".")) t = t?.[e], process.env.NODE_ENV !== "production" && t === void 0 && console.warn(`"${e}" in deeply nested key "${a}" returned undefined.`);
		return t;
	} : (e) => e[i.accessorKey]), !o) throw process.env.NODE_ENV === "production" ? Error() : Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header");
	let c = {
		id: `${String(o)}`,
		accessorFn: s,
		parent: r,
		depth: n,
		columnDef: i,
		columns: [],
		getFlatColumns: $(() => [!0], () => [c, ...c.columns?.flatMap((e) => e.getFlatColumns())], {
			key: process.env.NODE_ENV === "production" && "column.getFlatColumns",
			debug: () => e.options.debugAll ?? e.options.debugColumns
		}),
		getLeafColumns: $(() => [e._getOrderColumnsFn()], (e) => {
			var t;
			return (t = c.columns) != null && t.length ? e(c.columns.flatMap((e) => e.getLeafColumns())) : [c];
		}, {
			key: process.env.NODE_ENV === "production" && "column.getLeafColumns",
			debug: () => e.options.debugAll ?? e.options.debugColumns
		})
	};
	for (let t of e._features) t.createColumn == null || t.createColumn(c, e);
	return c;
}
function bw(e, t, n) {
	let r = {
		id: n.id ?? t.id,
		column: t,
		index: n.index,
		isPlaceholder: !!n.isPlaceholder,
		placeholderId: n.placeholderId,
		depth: n.depth,
		subHeaders: [],
		colSpan: 0,
		rowSpan: 0,
		headerGroup: null,
		getLeafHeaders: () => {
			let e = [], t = (n) => {
				n.subHeaders && n.subHeaders.length && n.subHeaders.map(t), e.push(n);
			};
			return t(r), e;
		},
		getContext: () => ({
			table: e,
			header: r,
			column: t
		})
	};
	return e._features.forEach((t) => {
		t.createHeader == null || t.createHeader(r, e);
	}), r;
}
var xw = { createTable: (e) => {
	e.getHeaderGroups = $(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left,
		e.getState().columnPinning.right
	], (t, n, r, i) => {
		let a = r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], o = i?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], s = n.filter((e) => !(r != null && r.includes(e.id)) && !(i != null && i.includes(e.id)));
		return Sw(t, [
			...a,
			...s,
			...o
		], e);
	}, {
		key: process.env.NODE_ENV === "development" && "getHeaderGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getCenterHeaderGroups = $(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left,
		e.getState().columnPinning.right
	], (t, n, r, i) => (n = n.filter((e) => !(r != null && r.includes(e.id)) && !(i != null && i.includes(e.id))), Sw(t, n, e, "center")), {
		key: process.env.NODE_ENV === "development" && "getCenterHeaderGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getLeftHeaderGroups = $(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.left
	], (t, n, r) => Sw(t, r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], e, "left"), {
		key: process.env.NODE_ENV === "development" && "getLeftHeaderGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getRightHeaderGroups = $(() => [
		e.getAllColumns(),
		e.getVisibleLeafColumns(),
		e.getState().columnPinning.right
	], (t, n, r) => Sw(t, r?.map((e) => n.find((t) => t.id === e)).filter(Boolean) ?? [], e, "right"), {
		key: process.env.NODE_ENV === "development" && "getRightHeaderGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getFooterGroups = $(() => [e.getHeaderGroups()], (e) => [...e].reverse(), {
		key: process.env.NODE_ENV === "development" && "getFooterGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getLeftFooterGroups = $(() => [e.getLeftHeaderGroups()], (e) => [...e].reverse(), {
		key: process.env.NODE_ENV === "development" && "getLeftFooterGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getCenterFooterGroups = $(() => [e.getCenterHeaderGroups()], (e) => [...e].reverse(), {
		key: process.env.NODE_ENV === "development" && "getCenterFooterGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getRightFooterGroups = $(() => [e.getRightHeaderGroups()], (e) => [...e].reverse(), {
		key: process.env.NODE_ENV === "development" && "getRightFooterGroups",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getFlatHeaders = $(() => [e.getHeaderGroups()], (e) => e.map((e) => e.headers).flat(), {
		key: process.env.NODE_ENV === "development" && "getFlatHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getLeftFlatHeaders = $(() => [e.getLeftHeaderGroups()], (e) => e.map((e) => e.headers).flat(), {
		key: process.env.NODE_ENV === "development" && "getLeftFlatHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getCenterFlatHeaders = $(() => [e.getCenterHeaderGroups()], (e) => e.map((e) => e.headers).flat(), {
		key: process.env.NODE_ENV === "development" && "getCenterFlatHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getRightFlatHeaders = $(() => [e.getRightHeaderGroups()], (e) => e.map((e) => e.headers).flat(), {
		key: process.env.NODE_ENV === "development" && "getRightFlatHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getCenterLeafHeaders = $(() => [e.getCenterFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), {
		key: process.env.NODE_ENV === "development" && "getCenterLeafHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getLeftLeafHeaders = $(() => [e.getLeftFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), {
		key: process.env.NODE_ENV === "development" && "getLeftLeafHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getRightLeafHeaders = $(() => [e.getRightFlatHeaders()], (e) => e.filter((e) => {
		var t;
		return !((t = e.subHeaders) != null && t.length);
	}), {
		key: process.env.NODE_ENV === "development" && "getRightLeafHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	}), e.getLeafHeaders = $(() => [
		e.getLeftHeaderGroups(),
		e.getCenterHeaderGroups(),
		e.getRightHeaderGroups()
	], (e, t, n) => [
		...e[0]?.headers ?? [],
		...t[0]?.headers ?? [],
		...n[0]?.headers ?? []
	].map((e) => e.getLeafHeaders()).flat(), {
		key: process.env.NODE_ENV === "development" && "getLeafHeaders",
		debug: () => e.options.debugAll ?? e.options.debugHeaders
	});
} };
function Sw(e, t, n, r) {
	let i = 0, a = function(e, t) {
		t === void 0 && (t = 1), i = Math.max(i, t), e.filter((e) => e.getIsVisible()).forEach((e) => {
			var n;
			(n = e.columns) != null && n.length && a(e.columns, t + 1);
		}, 0);
	};
	a(e);
	let o = [], s = (e, t) => {
		let i = {
			depth: t,
			id: [r, `${t}`].filter(Boolean).join("_"),
			headers: []
		}, a = [];
		e.forEach((e) => {
			let o = [...a].reverse()[0], s = e.column.depth === i.depth, c, l = !1;
			if (s && e.column.parent ? c = e.column.parent : (c = e.column, l = !0), o && o?.column === c) o.subHeaders.push(e);
			else {
				let i = bw(n, c, {
					id: [
						r,
						t,
						c.id,
						e?.id
					].filter(Boolean).join("_"),
					isPlaceholder: l,
					placeholderId: l ? `${a.filter((e) => e.column === c).length}` : void 0,
					depth: t,
					index: a.length
				});
				i.subHeaders.push(e), a.push(i);
			}
			i.headers.push(e), e.headerGroup = i;
		}), o.push(i), t > 0 && s(a, t - 1);
	};
	s(t.map((e, t) => bw(n, e, {
		depth: i,
		index: t
	})), i - 1), o.reverse();
	let c = (e) => e.filter((e) => e.column.getIsVisible()).map((e) => {
		let t = 0, n = 0, r = [0];
		e.subHeaders && e.subHeaders.length ? (r = [], c(e.subHeaders).forEach((e) => {
			let { colSpan: n, rowSpan: i } = e;
			t += n, r.push(i);
		})) : t = 1;
		let i = Math.min(...r);
		return n += i, e.colSpan = t, e.rowSpan = n, {
			colSpan: t,
			rowSpan: n
		};
	});
	return c(o[0]?.headers ?? []), o;
}
var Cw = {
	size: 150,
	minSize: 20,
	maxSize: 2 ** 53 - 1
}, ww = () => ({
	startOffset: null,
	startSize: null,
	deltaOffset: null,
	deltaPercentage: null,
	isResizingColumn: !1,
	columnSizingStart: []
}), Tw = {
	getDefaultColumnDef: () => Cw,
	getInitialState: (e) => ({
		columnSizing: {},
		columnSizingInfo: ww(),
		...e
	}),
	getDefaultOptions: (e) => ({
		columnResizeMode: "onEnd",
		onColumnSizingChange: hw("columnSizing", e),
		onColumnSizingInfoChange: hw("columnSizingInfo", e)
	}),
	createColumn: (e, t) => {
		e.getSize = () => {
			let n = t.getState().columnSizing[e.id];
			return Math.min(Math.max(e.columnDef.minSize ?? Cw.minSize, n ?? e.columnDef.size ?? Cw.size), e.columnDef.maxSize ?? Cw.maxSize);
		}, e.getStart = (n) => {
			let r = n ? n === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns(), i = r.findIndex((t) => t.id === e.id);
			if (i > 0) {
				let e = r[i - 1];
				return e.getStart(n) + e.getSize();
			}
			return 0;
		}, e.resetSize = () => {
			t.setColumnSizing((t) => {
				let { [e.id]: n, ...r } = t;
				return r;
			});
		}, e.getCanResize = () => (e.columnDef.enableResizing ?? !0) && (t.options.enableColumnResizing ?? !0), e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
	},
	createHeader: (e, t) => {
		e.getSize = () => {
			let t = 0, n = (e) => {
				e.subHeaders.length ? e.subHeaders.forEach(n) : t += e.column.getSize() ?? 0;
			};
			return n(e), t;
		}, e.getStart = () => {
			if (e.index > 0) {
				let t = e.headerGroup.headers[e.index - 1];
				return t.getStart() + t.getSize();
			}
			return 0;
		}, e.getResizeHandler = () => {
			let n = t.getColumn(e.column.id), r = n?.getCanResize();
			return (i) => {
				if (!n || !r || (i.persist == null || i.persist(), Ow(i) && i.touches && i.touches.length > 1)) return;
				let a = e.getSize(), o = e ? e.getLeafHeaders().map((e) => [e.column.id, e.column.getSize()]) : [[n.id, n.getSize()]], s = Ow(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, l = (e, n) => {
					typeof n == "number" && (t.setColumnSizingInfo((e) => {
						let t = n - (e?.startOffset ?? 0), r = Math.max(t / (e?.startSize ?? 0), -.999999);
						return e.columnSizingStart.forEach((e) => {
							let [t, n] = e;
							c[t] = Math.round(Math.max(n + n * r, 0) * 100) / 100;
						}), {
							...e,
							deltaOffset: t,
							deltaPercentage: r
						};
					}), (t.options.columnResizeMode === "onChange" || e === "end") && t.setColumnSizing((e) => ({
						...e,
						...c
					})));
				}, u = (e) => l("move", e), d = (e) => {
					l("end", e), t.setColumnSizingInfo((e) => ({
						...e,
						isResizingColumn: !1,
						startOffset: null,
						startSize: null,
						deltaOffset: null,
						deltaPercentage: null,
						columnSizingStart: []
					}));
				}, f = {
					moveHandler: (e) => u(e.clientX),
					upHandler: (e) => {
						document.removeEventListener("mousemove", f.moveHandler), document.removeEventListener("mouseup", f.upHandler), d(e.clientX);
					}
				}, p = {
					moveHandler: (e) => (e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1),
					upHandler: (e) => {
						document.removeEventListener("touchmove", p.moveHandler), document.removeEventListener("touchend", p.upHandler), e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0]?.clientX);
					}
				}, m = Dw() ? { passive: !1 } : !1;
				Ow(i) ? (document.addEventListener("touchmove", p.moveHandler, m), document.addEventListener("touchend", p.upHandler, m)) : (document.addEventListener("mousemove", f.moveHandler, m), document.addEventListener("mouseup", f.upHandler, m)), t.setColumnSizingInfo((e) => ({
					...e,
					startOffset: s,
					startSize: a,
					deltaOffset: 0,
					deltaPercentage: 0,
					columnSizingStart: o,
					isResizingColumn: n.id
				}));
			};
		};
	},
	createTable: (e) => {
		e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
			e.setColumnSizing(t ? {} : e.initialState.columnSizing ?? {});
		}, e.resetHeaderSizeInfo = (t) => {
			e.setColumnSizingInfo(t ? ww() : e.initialState.columnSizingInfo ?? ww());
		}, e.getTotalSize = () => e.getHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getLeftTotalSize = () => e.getLeftHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getCenterTotalSize = () => e.getCenterHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0, e.getRightTotalSize = () => e.getRightHeaderGroups()[0]?.headers.reduce((e, t) => e + t.getSize(), 0) ?? 0;
	}
}, Ew = null;
function Dw() {
	if (typeof Ew == "boolean") return Ew;
	let e = !1;
	try {
		let t = { get passive() {
			return e = !0, !1;
		} }, n = () => {};
		window.addEventListener("test", n, t), window.removeEventListener("test", n);
	} catch {
		e = !1;
	}
	return Ew = e, Ew;
}
function Ow(e) {
	return e.type === "touchstart";
}
var kw = {
	getInitialState: (e) => ({
		expanded: {},
		...e
	}),
	getDefaultOptions: (e) => ({
		onExpandedChange: hw("expanded", e),
		paginateExpandedRows: !0
	}),
	createTable: (e) => {
		let t = !1, n = !1;
		e._autoResetExpanded = () => {
			if (!t) {
				e._queue(() => {
					t = !0;
				});
				return;
			}
			if (e.options.autoResetAll ?? e.options.autoResetExpanded ?? !e.options.manualExpanding) {
				if (n) return;
				n = !0, e._queue(() => {
					e.resetExpanded(), n = !1;
				});
			}
		}, e.setExpanded = (t) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(t), e.toggleAllRowsExpanded = (t) => {
			t ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
		}, e.resetExpanded = (t) => {
			e.setExpanded(t ? {} : e.initialState?.expanded ?? {});
		}, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((e) => e.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (t) => {
			t.persist == null || t.persist(), e.toggleAllRowsExpanded();
		}, e.getIsSomeRowsExpanded = () => {
			let t = e.getState().expanded;
			return t === !0 || Object.values(t).some(Boolean);
		}, e.getIsAllRowsExpanded = () => {
			let t = e.getState().expanded;
			return typeof t == "boolean" ? t === !0 : !(!Object.keys(t).length || e.getRowModel().flatRows.some((e) => !e.getIsExpanded()));
		}, e.getExpandedDepth = () => {
			let t = 0;
			return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((e) => {
				let n = e.split(".");
				t = Math.max(t, n.length);
			}), t;
		}, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
	},
	createRow: (e, t) => {
		e.toggleExpanded = (n) => {
			t.setExpanded((r) => {
				let i = r === !0 || !!(r != null && r[e.id]), a = {};
				if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((e) => {
					a[e] = !0;
				}) : a = r, n ??= !i, !i && n) return {
					...a,
					[e.id]: !0
				};
				if (i && !n) {
					let { [e.id]: t, ...n } = a;
					return n;
				}
				return r;
			});
		}, e.getIsExpanded = () => {
			let n = t.getState().expanded;
			return !!((t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) ?? (n === !0 || n?.[e.id]));
		}, e.getCanExpand = () => {
			var n;
			return (t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) ?? ((t.options.enableExpanding ?? !0) && !!((n = e.subRows) != null && n.length));
		}, e.getIsAllParentsExpanded = () => {
			let n = !0, r = e;
			for (; n && r.parentId;) r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
			return n;
		}, e.getToggleExpandedHandler = () => {
			let t = e.getCanExpand();
			return () => {
				t && e.toggleExpanded();
			};
		};
	}
}, Aw = (e, t, n) => {
	var r;
	let i = n.toLowerCase();
	return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
Aw.autoRemove = (e) => Bw(e);
var jw = (e, t, n) => {
	var r;
	return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
jw.autoRemove = (e) => Bw(e);
var Mw = (e, t, n) => {
	var r;
	return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === n?.toLowerCase();
};
Mw.autoRemove = (e) => Bw(e);
var Nw = (e, t, n) => e.getValue(t)?.includes(n);
Nw.autoRemove = (e) => Bw(e) || !(e != null && e.length);
var Pw = (e, t, n) => !n.some((n) => {
	var r;
	return !((r = e.getValue(t)) != null && r.includes(n));
});
Pw.autoRemove = (e) => Bw(e) || !(e != null && e.length);
var Fw = (e, t, n) => n.some((n) => e.getValue(t)?.includes(n));
Fw.autoRemove = (e) => Bw(e) || !(e != null && e.length);
var Iw = (e, t, n) => e.getValue(t) === n;
Iw.autoRemove = (e) => Bw(e);
var Lw = (e, t, n) => e.getValue(t) == n;
Lw.autoRemove = (e) => Bw(e);
var Rw = (e, t, n) => {
	let [r, i] = n, a = e.getValue(t);
	return a >= r && a <= i;
};
Rw.resolveFilterValue = (e) => {
	let [t, n] = e, r = typeof t == "number" ? t : parseFloat(t), i = typeof n == "number" ? n : parseFloat(n), a = t === null || Number.isNaN(r) ? -Infinity : r, o = n === null || Number.isNaN(i) ? Infinity : i;
	if (a > o) {
		let e = a;
		a = o, o = e;
	}
	return [a, o];
}, Rw.autoRemove = (e) => Bw(e) || Bw(e[0]) && Bw(e[1]);
var zw = {
	includesString: Aw,
	includesStringSensitive: jw,
	equalsString: Mw,
	arrIncludes: Nw,
	arrIncludesAll: Pw,
	arrIncludesSome: Fw,
	equals: Iw,
	weakEquals: Lw,
	inNumberRange: Rw
};
function Bw(e) {
	return e == null || e === "";
}
var Vw = {
	getDefaultColumnDef: () => ({ filterFn: "auto" }),
	getInitialState: (e) => ({
		columnFilters: [],
		globalFilter: void 0,
		...e
	}),
	getDefaultOptions: (e) => ({
		onColumnFiltersChange: hw("columnFilters", e),
		onGlobalFilterChange: hw("globalFilter", e),
		filterFromLeafRows: !1,
		maxLeafRowFilterDepth: 100,
		globalFilterFn: "auto",
		getColumnCanGlobalFilter: (t) => {
			var n;
			let r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
			return typeof r == "string" || typeof r == "number";
		}
	}),
	createColumn: (e, t) => {
		e.getAutoFilterFn = () => {
			let n = t.getCoreRowModel().flatRows[0]?.getValue(e.id);
			return typeof n == "string" ? zw.includesString : typeof n == "number" ? zw.inNumberRange : typeof n == "boolean" || typeof n == "object" && n ? zw.equals : Array.isArray(n) ? zw.arrIncludes : zw.weakEquals;
		}, e.getFilterFn = () => gw(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : t.options.filterFns?.[e.columnDef.filterFn] ?? zw[e.columnDef.filterFn], e.getCanFilter = () => (e.columnDef.enableColumnFilter ?? !0) && (t.options.enableColumnFilters ?? !0) && (t.options.enableFilters ?? !0) && !!e.accessorFn, e.getCanGlobalFilter = () => (e.columnDef.enableGlobalFilter ?? !0) && (t.options.enableGlobalFilter ?? !0) && (t.options.enableFilters ?? !0) && ((t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) ?? !0) && !!e.accessorFn, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
			var n;
			return (n = t.getState().columnFilters) == null || (n = n.find((t) => t.id === e.id)) == null ? void 0 : n.value;
		}, e.getFilterIndex = () => t.getState().columnFilters?.findIndex((t) => t.id === e.id) ?? -1, e.setFilterValue = (n) => {
			t.setColumnFilters((t) => {
				let r = e.getFilterFn(), i = t?.find((t) => t.id === e.id), a = mw(n, i ? i.value : void 0);
				if (Hw(r, a, e)) return t?.filter((t) => t.id !== e.id) ?? [];
				let o = {
					id: e.id,
					value: a
				};
				return i ? t?.map((t) => t.id === e.id ? o : t) ?? [] : t != null && t.length ? [...t, o] : [o];
			});
		}, e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
			if (e._getFacetedMinMaxValues) return e._getFacetedMinMaxValues();
		};
	},
	createRow: (e, t) => {
		e.columnFilters = {}, e.columnFiltersMeta = {};
	},
	createTable: (e) => {
		e.getGlobalAutoFilterFn = () => zw.includesString, e.getGlobalFilterFn = () => {
			let { globalFilterFn: t } = e.options;
			return gw(t) ? t : t === "auto" ? e.getGlobalAutoFilterFn() : e.options.filterFns?.[t] ?? zw[t];
		}, e.setColumnFilters = (t) => {
			let n = e.getAllLeafColumns();
			e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange((e) => mw(t, e)?.filter((e) => {
				let t = n.find((t) => t.id === e.id);
				return !(t && Hw(t.getFilterFn(), e.value, t));
			}));
		}, e.setGlobalFilter = (t) => {
			e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
		}, e.resetGlobalFilter = (t) => {
			e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
		}, e.resetColumnFilters = (t) => {
			e.setColumnFilters(t ? [] : e.initialState?.columnFilters ?? []);
		}, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel()), e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
			if (e._getGlobalFacetedMinMaxValues) return e._getGlobalFacetedMinMaxValues();
		};
	}
};
function Hw(e, t, n) {
	return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || t === void 0 || typeof t == "string" && !t;
}
var Uw = {
	sum: (e, t, n) => n.reduce((t, n) => {
		let r = n.getValue(e);
		return t + (typeof r == "number" ? r : 0);
	}, 0),
	min: (e, t, n) => {
		let r;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r > n || r === void 0 && n >= n) && (r = n);
		}), r;
	},
	max: (e, t, n) => {
		let r;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r < n || r === void 0 && n >= n) && (r = n);
		}), r;
	},
	extent: (e, t, n) => {
		let r, i;
		return n.forEach((t) => {
			let n = t.getValue(e);
			n != null && (r === void 0 ? n >= n && (r = i = n) : (r > n && (r = n), i < n && (i = n)));
		}), [r, i];
	},
	mean: (e, t) => {
		let n = 0, r = 0;
		if (t.forEach((t) => {
			let i = t.getValue(e);
			i != null && (i = +i) >= i && (++n, r += i);
		}), n) return r / n;
	},
	median: (e, t) => {
		if (!t.length) return;
		let n = t.map((t) => t.getValue(e));
		if (!_w(n)) return;
		if (n.length === 1) return n[0];
		let r = Math.floor(n.length / 2), i = n.sort((e, t) => e - t);
		return n.length % 2 == 0 ? (i[r - 1] + i[r]) / 2 : i[r];
	},
	unique: (e, t) => Array.from(new Set(t.map((t) => t.getValue(e))).values()),
	uniqueCount: (e, t) => new Set(t.map((t) => t.getValue(e))).size,
	count: (e, t) => t.length
}, Ww = {
	getDefaultColumnDef: () => ({
		aggregatedCell: (e) => {
			var t;
			return ((t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) ?? null;
		},
		aggregationFn: "auto"
	}),
	getInitialState: (e) => ({
		grouping: [],
		...e
	}),
	getDefaultOptions: (e) => ({
		onGroupingChange: hw("grouping", e),
		groupedColumnMode: "reorder"
	}),
	createColumn: (e, t) => {
		e.toggleGrouping = () => {
			t.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((t) => t !== e.id) : [...t ?? [], e.id]);
		}, e.getCanGroup = () => e.columnDef.enableGrouping ?? !0 ?? t.options.enableGrouping ?? !0 ?? !!e.accessorFn, e.getIsGrouped = () => t.getState().grouping?.includes(e.id), e.getGroupedIndex = () => t.getState().grouping?.indexOf(e.id), e.getToggleGroupingHandler = () => {
			let t = e.getCanGroup();
			return () => {
				t && e.toggleGrouping();
			};
		}, e.getAutoAggregationFn = () => {
			let n = t.getCoreRowModel().flatRows[0]?.getValue(e.id);
			if (typeof n == "number") return Uw.sum;
			if (Object.prototype.toString.call(n) === "[object Date]") return Uw.extent;
		}, e.getAggregationFn = () => {
			if (!e) throw Error();
			return gw(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : t.options.aggregationFns?.[e.columnDef.aggregationFn] ?? Uw[e.columnDef.aggregationFn];
		};
	},
	createTable: (e) => {
		e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
			e.setGrouping(t ? [] : e.initialState?.grouping ?? []);
		}, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
	},
	createRow: (e, t) => {
		e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
			if (e._groupingValuesCache.hasOwnProperty(n)) return e._groupingValuesCache[n];
			let r = t.getColumn(n);
			return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
		}, e._groupingValuesCache = {};
	},
	createCell: (e, t, n, r) => {
		e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
			var t;
			return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((t = n.subRows) != null && t.length);
		};
	}
};
function Gw(e, t, n) {
	if (!(t != null && t.length) || !n) return e;
	let r = e.filter((e) => !t.includes(e.id));
	return n === "remove" ? r : [...t.map((t) => e.find((e) => e.id === t)).filter(Boolean), ...r];
}
var Kw = {
	getInitialState: (e) => ({
		columnOrder: [],
		...e
	}),
	getDefaultOptions: (e) => ({ onColumnOrderChange: hw("columnOrder", e) }),
	createTable: (e) => {
		e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
			e.setColumnOrder(t ? [] : e.initialState.columnOrder ?? []);
		}, e._getOrderColumnsFn = $(() => [
			e.getState().columnOrder,
			e.getState().grouping,
			e.options.groupedColumnMode
		], (e, t, n) => (r) => {
			let i = [];
			if (!(e != null && e.length)) i = r;
			else {
				let t = [...e], n = [...r];
				for (; n.length && t.length;) {
					let e = t.shift(), r = n.findIndex((t) => t.id === e);
					r > -1 && i.push(n.splice(r, 1)[0]);
				}
				i = [...i, ...n];
			}
			return Gw(i, t, n);
		}, { key: process.env.NODE_ENV === "development" && "getOrderColumnsFn" });
	}
}, qw = 0, Jw = 10, Yw = () => ({
	pageIndex: qw,
	pageSize: Jw
}), Xw = {
	getInitialState: (e) => ({
		...e,
		pagination: {
			...Yw(),
			...e?.pagination
		}
	}),
	getDefaultOptions: (e) => ({ onPaginationChange: hw("pagination", e) }),
	createTable: (e) => {
		let t = !1, n = !1;
		e._autoResetPageIndex = () => {
			if (!t) {
				e._queue(() => {
					t = !0;
				});
				return;
			}
			if (e.options.autoResetAll ?? e.options.autoResetPageIndex ?? !e.options.manualPagination) {
				if (n) return;
				n = !0, e._queue(() => {
					e.resetPageIndex(), n = !1;
				});
			}
		}, e.setPagination = (t) => e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange((e) => mw(t, e)), e.resetPagination = (t) => {
			e.setPagination(t ? Yw() : e.initialState.pagination ?? Yw());
		}, e.setPageIndex = (t) => {
			e.setPagination((n) => {
				let r = mw(t, n.pageIndex), i = e.options.pageCount === void 0 || e.options.pageCount === -1 ? 2 ** 53 - 1 : e.options.pageCount - 1;
				return r = Math.max(0, Math.min(r, i)), {
					...n,
					pageIndex: r
				};
			});
		}, e.resetPageIndex = (t) => {
			var n;
			e.setPageIndex(t ? qw : ((n = e.initialState) == null || (n = n.pagination) == null ? void 0 : n.pageIndex) ?? qw);
		}, e.resetPageSize = (t) => {
			var n;
			e.setPageSize(t ? Jw : ((n = e.initialState) == null || (n = n.pagination) == null ? void 0 : n.pageSize) ?? Jw);
		}, e.setPageSize = (t) => {
			e.setPagination((e) => {
				let n = Math.max(1, mw(t, e.pageSize)), r = e.pageSize * e.pageIndex, i = Math.floor(r / n);
				return {
					...e,
					pageIndex: i,
					pageSize: n
				};
			});
		}, e.setPageCount = (t) => e.setPagination((n) => {
			let r = mw(t, e.options.pageCount ?? -1);
			return typeof r == "number" && (r = Math.max(-1, r)), {
				...n,
				pageCount: r
			};
		}), e.getPageOptions = $(() => [e.getPageCount()], (e) => {
			let t = [];
			return e && e > 0 && (t = [...Array(e)].fill(null).map((e, t) => t)), t;
		}, {
			key: process.env.NODE_ENV === "development" && "getPageOptions",
			debug: () => e.options.debugAll ?? e.options.debugTable
		}), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
			let { pageIndex: t } = e.getState().pagination, n = e.getPageCount();
			return n === -1 || n !== 0 && t < n - 1;
		}, e.previousPage = () => e.setPageIndex((e) => e - 1), e.nextPage = () => e.setPageIndex((e) => e + 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => e.options.pageCount ?? Math.ceil(e.getPrePaginationRowModel().rows.length / e.getState().pagination.pageSize);
	}
}, Zw = () => ({
	left: [],
	right: []
}), Qw = () => ({
	top: [],
	bottom: []
}), $w = {
	getInitialState: (e) => ({
		columnPinning: Zw(),
		rowPinning: Qw(),
		...e
	}),
	getDefaultOptions: (e) => ({
		onColumnPinningChange: hw("columnPinning", e),
		onRowPinningChange: hw("rowPinning", e)
	}),
	createColumn: (e, t) => {
		e.pin = (n) => {
			let r = e.getLeafColumns().map((e) => e.id).filter(Boolean);
			t.setColumnPinning((e) => n === "right" ? {
				left: (e?.left ?? []).filter((e) => !(r != null && r.includes(e))),
				right: [...(e?.right ?? []).filter((e) => !(r != null && r.includes(e))), ...r]
			} : n === "left" ? {
				left: [...(e?.left ?? []).filter((e) => !(r != null && r.includes(e))), ...r],
				right: (e?.right ?? []).filter((e) => !(r != null && r.includes(e)))
			} : {
				left: (e?.left ?? []).filter((e) => !(r != null && r.includes(e))),
				right: (e?.right ?? []).filter((e) => !(r != null && r.includes(e)))
			});
		}, e.getCanPin = () => e.getLeafColumns().some((e) => (e.columnDef.enablePinning ?? !0) && (t.options.enableColumnPinning ?? t.options.enablePinning ?? !0)), e.getIsPinned = () => {
			let n = e.getLeafColumns().map((e) => e.id), { left: r, right: i } = t.getState().columnPinning, a = n.some((e) => r?.includes(e)), o = n.some((e) => i?.includes(e));
			return a ? "left" : o ? "right" : !1;
		}, e.getPinnedIndex = () => {
			var n;
			let r = e.getIsPinned();
			return r ? ((n = t.getState().columnPinning) == null || (n = n[r]) == null ? void 0 : n.indexOf(e.id)) ?? -1 : 0;
		};
	},
	createRow: (e, t) => {
		e.pin = (n, r, i) => {
			let a = r ? e.getLeafRows().map((e) => {
				let { id: t } = e;
				return t;
			}) : [], o = i ? e.getParentRows().map((e) => {
				let { id: t } = e;
				return t;
			}) : [], s = /* @__PURE__ */ new Set([
				...o,
				e.id,
				...a
			]);
			t.setRowPinning((e) => n === "bottom" ? {
				top: (e?.top ?? []).filter((e) => !(s != null && s.has(e))),
				bottom: [...(e?.bottom ?? []).filter((e) => !(s != null && s.has(e))), ...Array.from(s)]
			} : n === "top" ? {
				top: [...(e?.top ?? []).filter((e) => !(s != null && s.has(e))), ...Array.from(s)],
				bottom: (e?.bottom ?? []).filter((e) => !(s != null && s.has(e)))
			} : {
				top: (e?.top ?? []).filter((e) => !(s != null && s.has(e))),
				bottom: (e?.bottom ?? []).filter((e) => !(s != null && s.has(e)))
			});
		}, e.getCanPin = () => {
			let { enableRowPinning: n, enablePinning: r } = t.options;
			return typeof n == "function" ? n(e) : n ?? r ?? !0;
		}, e.getIsPinned = () => {
			let n = [e.id], { top: r, bottom: i } = t.getState().rowPinning, a = n.some((e) => r?.includes(e)), o = n.some((e) => i?.includes(e));
			return a ? "top" : o ? "bottom" : !1;
		}, e.getPinnedIndex = () => {
			let n = e.getIsPinned();
			return n ? (t._getPinnedRows(n)?.map((e) => {
				let { id: t } = e;
				return t;
			}))?.indexOf(e.id) ?? -1 : -1;
		}, e.getCenterVisibleCells = $(() => [
			e._getAllVisibleCells(),
			t.getState().columnPinning.left,
			t.getState().columnPinning.right
		], (e, t, n) => {
			let r = [...t ?? [], ...n ?? []];
			return e.filter((e) => !r.includes(e.column.id));
		}, {
			key: process.env.NODE_ENV === "development" && "row.getCenterVisibleCells",
			debug: () => t.options.debugAll ?? t.options.debugRows
		}), e.getLeftVisibleCells = $(() => [
			e._getAllVisibleCells(),
			t.getState().columnPinning.left,
			,
		], (e, t) => (t ?? []).map((t) => e.find((e) => e.column.id === t)).filter(Boolean).map((e) => ({
			...e,
			position: "left"
		})), {
			key: process.env.NODE_ENV === "development" && "row.getLeftVisibleCells",
			debug: () => t.options.debugAll ?? t.options.debugRows
		}), e.getRightVisibleCells = $(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (e, t) => (t ?? []).map((t) => e.find((e) => e.column.id === t)).filter(Boolean).map((e) => ({
			...e,
			position: "right"
		})), {
			key: process.env.NODE_ENV === "development" && "row.getRightVisibleCells",
			debug: () => t.options.debugAll ?? t.options.debugRows
		});
	},
	createTable: (e) => {
		e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => e.setColumnPinning(t ? Zw() : e.initialState?.columnPinning ?? Zw()), e.getIsSomeColumnsPinned = (t) => {
			let n = e.getState().columnPinning;
			return t ? !!n[t]?.length : !!(n.left?.length || n.right?.length);
		}, e.getLeftLeafColumns = $(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (e, t) => (t ?? []).map((t) => e.find((e) => e.id === t)).filter(Boolean), {
			key: process.env.NODE_ENV === "development" && "getLeftLeafColumns",
			debug: () => e.options.debugAll ?? e.options.debugColumns
		}), e.getRightLeafColumns = $(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (e, t) => (t ?? []).map((t) => e.find((e) => e.id === t)).filter(Boolean), {
			key: process.env.NODE_ENV === "development" && "getRightLeafColumns",
			debug: () => e.options.debugAll ?? e.options.debugColumns
		}), e.getCenterLeafColumns = $(() => [
			e.getAllLeafColumns(),
			e.getState().columnPinning.left,
			e.getState().columnPinning.right
		], (e, t, n) => {
			let r = [...t ?? [], ...n ?? []];
			return e.filter((e) => !r.includes(e.id));
		}, {
			key: process.env.NODE_ENV === "development" && "getCenterLeafColumns",
			debug: () => e.options.debugAll ?? e.options.debugColumns
		}), e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => e.setRowPinning(t ? Qw() : e.initialState?.rowPinning ?? Qw()), e.getIsSomeRowsPinned = (t) => {
			let n = e.getState().rowPinning;
			return t ? !!n[t]?.length : !!(n.top?.length || n.bottom?.length);
		}, e._getPinnedRows = (t) => $(() => [e.getRowModel().rows, e.getState().rowPinning[t]], (n, r) => (e.options.keepPinnedRows ?? !0 ? (r ?? []).map((t) => {
			let n = e.getRow(t, !0);
			return n.getIsAllParentsExpanded() ? n : null;
		}) : (r ?? []).map((e) => n.find((t) => t.id === e))).filter(Boolean).map((e) => ({
			...e,
			position: t
		})), {
			key: process.env.NODE_ENV === "development" && `row.get${t === "top" ? "Top" : "Bottom"}Rows`,
			debug: () => e.options.debugAll ?? e.options.debugRows
		})(), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = $(() => [
			e.getRowModel().rows,
			e.getState().rowPinning.top,
			e.getState().rowPinning.bottom
		], (e, t, n) => {
			let r = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
			return e.filter((e) => !r.has(e.id));
		}, {
			key: process.env.NODE_ENV === "development" && "row.getCenterRows",
			debug: () => e.options.debugAll ?? e.options.debugRows
		});
	}
}, eT = {
	getInitialState: (e) => ({
		rowSelection: {},
		...e
	}),
	getDefaultOptions: (e) => ({
		onRowSelectionChange: hw("rowSelection", e),
		enableRowSelection: !0,
		enableMultiRowSelection: !0,
		enableSubRowSelection: !0
	}),
	createTable: (e) => {
		e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => e.setRowSelection(t ? {} : e.initialState.rowSelection ?? {}), e.toggleAllRowsSelected = (t) => {
			e.setRowSelection((n) => {
				t = t === void 0 ? !e.getIsAllRowsSelected() : t;
				let r = { ...n }, i = e.getPreGroupedRowModel().flatRows;
				return t ? i.forEach((e) => {
					e.getCanSelect() && (r[e.id] = !0);
				}) : i.forEach((e) => {
					delete r[e.id];
				}), r;
			});
		}, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
			let r = t === void 0 ? !e.getIsAllPageRowsSelected() : t, i = { ...n };
			return e.getRowModel().rows.forEach((t) => {
				tT(i, t.id, r, !0, e);
			}), i;
		}), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = $(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? nT(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, {
			key: process.env.NODE_ENV === "development" && "getSelectedRowModel",
			debug: () => e.options.debugAll ?? e.options.debugTable
		}), e.getFilteredSelectedRowModel = $(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? nT(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, {
			key: process.env.NODE_ENV === "production" && "getFilteredSelectedRowModel",
			debug: () => e.options.debugAll ?? e.options.debugTable
		}), e.getGroupedSelectedRowModel = $(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? nT(e, n) : {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, {
			key: process.env.NODE_ENV === "production" && "getGroupedSelectedRowModel",
			debug: () => e.options.debugAll ?? e.options.debugTable
		}), e.getIsAllRowsSelected = () => {
			let t = e.getFilteredRowModel().flatRows, { rowSelection: n } = e.getState(), r = !!(t.length && Object.keys(n).length);
			return r && t.some((e) => e.getCanSelect() && !n[e.id]) && (r = !1), r;
		}, e.getIsAllPageRowsSelected = () => {
			let t = e.getPaginationRowModel().flatRows.filter((e) => e.getCanSelect()), { rowSelection: n } = e.getState(), r = !!t.length;
			return r && t.some((e) => !n[e.id]) && (r = !1), r;
		}, e.getIsSomeRowsSelected = () => {
			let t = Object.keys(e.getState().rowSelection ?? {}).length;
			return t > 0 && t < e.getFilteredRowModel().flatRows.length;
		}, e.getIsSomePageRowsSelected = () => {
			let t = e.getPaginationRowModel().flatRows;
			return !e.getIsAllPageRowsSelected() && t.filter((e) => e.getCanSelect()).some((e) => e.getIsSelected() || e.getIsSomeSelected());
		}, e.getToggleAllRowsSelectedHandler = () => (t) => {
			e.toggleAllRowsSelected(t.target.checked);
		}, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
			e.toggleAllPageRowsSelected(t.target.checked);
		};
	},
	createRow: (e, t) => {
		e.toggleSelected = (n, r) => {
			let i = e.getIsSelected();
			t.setRowSelection((a) => {
				if (n = n === void 0 ? !i : n, e.getCanSelect() && i === n) return a;
				let o = { ...a };
				return tT(o, e.id, n, r?.selectChildren ?? !0, t), o;
			});
		}, e.getIsSelected = () => {
			let { rowSelection: n } = t.getState();
			return rT(e, n);
		}, e.getIsSomeSelected = () => {
			let { rowSelection: n } = t.getState();
			return iT(e, n) === "some";
		}, e.getIsAllSubRowsSelected = () => {
			let { rowSelection: n } = t.getState();
			return iT(e, n) === "all";
		}, e.getCanSelect = () => typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : t.options.enableRowSelection ?? !0, e.getCanSelectSubRows = () => typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : t.options.enableSubRowSelection ?? !0, e.getCanMultiSelect = () => typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : t.options.enableMultiRowSelection ?? !0, e.getToggleSelectedHandler = () => {
			let t = e.getCanSelect();
			return (n) => {
				t && e.toggleSelected(n.target?.checked);
			};
		};
	}
}, tT = (e, t, n, r, i) => {
	var a;
	let o = i.getRow(t);
	n ? (o.getCanMultiSelect() || Object.keys(e).forEach((t) => delete e[t]), o.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = o.subRows) != null && a.length && o.getCanSelectSubRows() && o.subRows.forEach((t) => tT(e, t.id, n, r, i));
};
function nT(e, t) {
	let n = e.getState().rowSelection, r = [], i = {}, a = function(e, t) {
		return e.map((e) => {
			var t;
			let o = rT(e, n);
			if (o && (r.push(e), i[e.id] = e), (t = e.subRows) != null && t.length && (e = {
				...e,
				subRows: a(e.subRows)
			}), o) return e;
		}).filter(Boolean);
	};
	return {
		rows: a(t.rows),
		flatRows: r,
		rowsById: i
	};
}
function rT(e, t) {
	return t[e.id] ?? !1;
}
function iT(e, t, n) {
	var r;
	if (!((r = e.subRows) != null && r.length)) return !1;
	let i = !0, a = !1;
	return e.subRows.forEach((e) => {
		if (!(a && !i) && (e.getCanSelect() && (rT(e, t) ? a = !0 : i = !1), e.subRows && e.subRows.length)) {
			let n = iT(e, t);
			n === "all" ? a = !0 : (n === "some" && (a = !0), i = !1);
		}
	}), i ? "all" : a ? "some" : !1;
}
var aT = /([0-9]+)/gm, oT = (e, t, n) => mT(pT(e.getValue(n)).toLowerCase(), pT(t.getValue(n)).toLowerCase()), sT = (e, t, n) => mT(pT(e.getValue(n)), pT(t.getValue(n))), cT = (e, t, n) => fT(pT(e.getValue(n)).toLowerCase(), pT(t.getValue(n)).toLowerCase()), lT = (e, t, n) => fT(pT(e.getValue(n)), pT(t.getValue(n))), uT = (e, t, n) => {
	let r = e.getValue(n), i = t.getValue(n);
	return r > i ? 1 : r < i ? -1 : 0;
}, dT = (e, t, n) => fT(e.getValue(n), t.getValue(n));
function fT(e, t) {
	return e === t ? 0 : e > t ? 1 : -1;
}
function pT(e) {
	return typeof e == "number" ? isNaN(e) || e === Infinity || e === -Infinity ? "" : String(e) : typeof e == "string" ? e : "";
}
function mT(e, t) {
	let n = e.split(aT).filter(Boolean), r = t.split(aT).filter(Boolean);
	for (; n.length && r.length;) {
		let e = n.shift(), t = r.shift(), i = parseInt(e, 10), a = parseInt(t, 10), o = [i, a].sort();
		if (isNaN(o[0])) {
			if (e > t) return 1;
			if (t > e) return -1;
			continue;
		}
		if (isNaN(o[1])) return isNaN(i) ? -1 : 1;
		if (i > a) return 1;
		if (a > i) return -1;
	}
	return n.length - r.length;
}
var hT = {
	alphanumeric: oT,
	alphanumericCaseSensitive: sT,
	text: cT,
	textCaseSensitive: lT,
	datetime: uT,
	basic: dT
}, gT = [
	xw,
	{
		getInitialState: (e) => ({
			columnVisibility: {},
			...e
		}),
		getDefaultOptions: (e) => ({ onColumnVisibilityChange: hw("columnVisibility", e) }),
		createColumn: (e, t) => {
			e.toggleVisibility = (n) => {
				e.getCanHide() && t.setColumnVisibility((t) => ({
					...t,
					[e.id]: n ?? !e.getIsVisible()
				}));
			}, e.getIsVisible = () => t.getState().columnVisibility?.[e.id] ?? !0, e.getCanHide = () => (e.columnDef.enableHiding ?? !0) && (t.options.enableHiding ?? !0), e.getToggleVisibilityHandler = () => (t) => {
				e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
			};
		},
		createRow: (e, t) => {
			e._getAllVisibleCells = $(() => [e.getAllCells(), t.getState().columnVisibility], (e) => e.filter((e) => e.column.getIsVisible()), {
				key: process.env.NODE_ENV === "production" && "row._getAllVisibleCells",
				debug: () => t.options.debugAll ?? t.options.debugRows
			}), e.getVisibleCells = $(() => [
				e.getLeftVisibleCells(),
				e.getCenterVisibleCells(),
				e.getRightVisibleCells()
			], (e, t, n) => [
				...e,
				...t,
				...n
			], {
				key: process.env.NODE_ENV === "development" && "row.getVisibleCells",
				debug: () => t.options.debugAll ?? t.options.debugRows
			});
		},
		createTable: (e) => {
			let t = (t, n) => $(() => [n(), n().filter((e) => e.getIsVisible()).map((e) => e.id).join("_")], (e) => e.filter((e) => e.getIsVisible == null ? void 0 : e.getIsVisible()), {
				key: t,
				debug: () => e.options.debugAll ?? e.options.debugColumns
			});
			e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
				e.setColumnVisibility(t ? {} : e.initialState.columnVisibility ?? {});
			}, e.toggleAllColumnsVisible = (t) => {
				t ??= !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((e, n) => ({
					...e,
					[n.id]: t || !(n.getCanHide != null && n.getCanHide())
				}), {}));
			}, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((e) => !(e.getIsVisible != null && e.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((e) => e.getIsVisible == null ? void 0 : e.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
				e.toggleAllColumnsVisible(t.target?.checked);
			};
		}
	},
	Kw,
	$w,
	Vw,
	{
		getInitialState: (e) => ({
			sorting: [],
			...e
		}),
		getDefaultColumnDef: () => ({
			sortingFn: "auto",
			sortUndefined: 1
		}),
		getDefaultOptions: (e) => ({
			onSortingChange: hw("sorting", e),
			isMultiSortEvent: (e) => e.shiftKey
		}),
		createColumn: (e, t) => {
			e.getAutoSortingFn = () => {
				let n = t.getFilteredRowModel().flatRows.slice(10), r = !1;
				for (let t of n) {
					let n = t?.getValue(e.id);
					if (Object.prototype.toString.call(n) === "[object Date]") return hT.datetime;
					if (typeof n == "string" && (r = !0, n.split(aT).length > 1)) return hT.alphanumeric;
				}
				return r ? hT.text : hT.basic;
			}, e.getAutoSortDir = () => typeof t.getFilteredRowModel().flatRows[0]?.getValue(e.id) == "string" ? "asc" : "desc", e.getSortingFn = () => {
				if (!e) throw Error();
				return gw(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : t.options.sortingFns?.[e.columnDef.sortingFn] ?? hT[e.columnDef.sortingFn];
			}, e.toggleSorting = (n, r) => {
				let i = e.getNextSortingOrder(), a = n != null;
				t.setSorting((o) => {
					let s = o?.find((t) => t.id === e.id), c = o?.findIndex((t) => t.id === e.id), l = [], u, d = a ? n : i === "desc";
					return u = o != null && o.length && e.getCanMultiSort() && r ? s ? "toggle" : "add" : o != null && o.length && c !== o.length - 1 ? "replace" : s ? "toggle" : "replace", u === "toggle" && (a || i || (u = "remove")), u === "add" ? (l = [...o, {
						id: e.id,
						desc: d
					}], l.splice(0, l.length - (t.options.maxMultiSortColCount ?? 2 ** 53 - 1))) : l = u === "toggle" ? o.map((t) => t.id === e.id ? {
						...t,
						desc: d
					} : t) : u === "remove" ? o.filter((t) => t.id !== e.id) : [{
						id: e.id,
						desc: d
					}], l;
				});
			}, e.getFirstSortDir = () => e.columnDef.sortDescFirst ?? t.options.sortDescFirst ?? e.getAutoSortDir() === "desc" ? "desc" : "asc", e.getNextSortingOrder = (n) => {
				let r = e.getFirstSortDir(), i = e.getIsSorted();
				return i ? i !== r && (t.options.enableSortingRemoval ?? !0) && (!n || (t.options.enableMultiRemove ?? !0)) ? !1 : i === "desc" ? "asc" : "desc" : r;
			}, e.getCanSort = () => (e.columnDef.enableSorting ?? !0) && (t.options.enableSorting ?? !0) && !!e.accessorFn, e.getCanMultiSort = () => e.columnDef.enableMultiSort ?? t.options.enableMultiSort ?? !!e.accessorFn, e.getIsSorted = () => {
				let n = t.getState().sorting?.find((t) => t.id === e.id);
				return n ? n.desc ? "desc" : "asc" : !1;
			}, e.getSortIndex = () => t.getState().sorting?.findIndex((t) => t.id === e.id) ?? -1, e.clearSorting = () => {
				t.setSorting((t) => t != null && t.length ? t.filter((t) => t.id !== e.id) : []);
			}, e.getToggleSortingHandler = () => {
				let n = e.getCanSort();
				return (r) => {
					n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
				};
			};
		},
		createTable: (e) => {
			e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
				e.setSorting(t ? [] : e.initialState?.sorting ?? []);
			}, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
		}
	},
	Ww,
	kw,
	Xw,
	eT,
	Tw
];
function _T(e) {
	(e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
	let t = { _features: gT }, n = t._features.reduce((e, n) => Object.assign(e, n.getDefaultOptions == null ? void 0 : n.getDefaultOptions(t)), {}), r = (e) => t.options.mergeOptions ? t.options.mergeOptions(n, e) : {
		...n,
		...e
	}, i = { ...e.initialState ?? {} };
	t._features.forEach((e) => {
		i = (e.getInitialState == null ? void 0 : e.getInitialState(i)) ?? i;
	});
	let a = [], o = !1, s = {
		_features: gT,
		options: {
			...n,
			...e
		},
		initialState: i,
		_queue: (e) => {
			a.push(e), o || (o = !0, Promise.resolve().then(() => {
				for (; a.length;) a.shift()();
				o = !1;
			}).catch((e) => setTimeout(() => {
				throw e;
			})));
		},
		reset: () => {
			t.setState(t.initialState);
		},
		setOptions: (e) => {
			let n = mw(e, t.options);
			t.options = r(n);
		},
		getState: () => t.options.state,
		setState: (e) => {
			t.options.onStateChange == null || t.options.onStateChange(e);
		},
		_getRowId: (e, n, r) => (t.options.getRowId == null ? void 0 : t.options.getRowId(e, n, r)) ?? `${r ? [r.id, n].join(".") : n}`,
		getCoreRowModel: () => (t._getCoreRowModel ||= t.options.getCoreRowModel(t), t._getCoreRowModel()),
		getRowModel: () => t.getPaginationRowModel(),
		getRow: (e, n) => {
			let r = (n ? t.getCoreRowModel() : t.getRowModel()).rowsById[e];
			if (!r) throw process.env.NODE_ENV === "production" ? Error() : Error(`getRow expected an ID, but got ${e}`);
			return r;
		},
		_getDefaultColumnDef: $(() => [t.options.defaultColumn], (e) => (e ??= {}, {
			header: (e) => {
				let t = e.header.column.columnDef;
				return t.accessorKey ? t.accessorKey : t.accessorFn ? t.id : null;
			},
			cell: (e) => {
				var t;
				return ((t = e.renderValue()) == null || t.toString == null ? void 0 : t.toString()) ?? null;
			},
			...t._features.reduce((e, t) => Object.assign(e, t.getDefaultColumnDef == null ? void 0 : t.getDefaultColumnDef()), {}),
			...e
		}), {
			debug: () => t.options.debugAll ?? t.options.debugColumns,
			key: process.env.NODE_ENV === "development" && "getDefaultColumnDef"
		}),
		_getColumnDefs: () => t.options.columns,
		getAllColumns: $(() => [t._getColumnDefs()], (e) => {
			let n = function(e, r, i) {
				return i === void 0 && (i = 0), e.map((e) => {
					let a = yw(t, e, i, r), o = e;
					return a.columns = o.columns ? n(o.columns, a, i + 1) : [], a;
				});
			};
			return n(e);
		}, {
			key: process.env.NODE_ENV === "development" && "getAllColumns",
			debug: () => t.options.debugAll ?? t.options.debugColumns
		}),
		getAllFlatColumns: $(() => [t.getAllColumns()], (e) => e.flatMap((e) => e.getFlatColumns()), {
			key: process.env.NODE_ENV === "development" && "getAllFlatColumns",
			debug: () => t.options.debugAll ?? t.options.debugColumns
		}),
		_getAllFlatColumnsById: $(() => [t.getAllFlatColumns()], (e) => e.reduce((e, t) => (e[t.id] = t, e), {}), {
			key: process.env.NODE_ENV === "development" && "getAllFlatColumnsById",
			debug: () => t.options.debugAll ?? t.options.debugColumns
		}),
		getAllLeafColumns: $(() => [t.getAllColumns(), t._getOrderColumnsFn()], (e, t) => t(e.flatMap((e) => e.getLeafColumns())), {
			key: process.env.NODE_ENV === "development" && "getAllLeafColumns",
			debug: () => t.options.debugAll ?? t.options.debugColumns
		}),
		getColumn: (e) => {
			let n = t._getAllFlatColumnsById()[e];
			return process.env.NODE_ENV !== "production" && !n && console.error(`[Table] Column with id '${e}' does not exist.`), n;
		}
	};
	Object.assign(t, s);
	for (let e = 0; e < t._features.length; e++) {
		let n = t._features[e];
		n == null || n.createTable == null || n.createTable(t);
	}
	return t;
}
function vT(e, t, n, r) {
	let i = {
		id: `${t.id}_${n.id}`,
		row: t,
		column: n,
		getValue: () => t.getValue(r),
		renderValue: () => i.getValue() ?? e.options.renderFallbackValue,
		getContext: $(() => [
			e,
			n,
			t,
			i
		], (e, t, n, r) => ({
			table: e,
			column: t,
			row: n,
			cell: r,
			getValue: r.getValue,
			renderValue: r.renderValue
		}), {
			key: process.env.NODE_ENV === "development" && "cell.getContext",
			debug: () => e.options.debugAll
		})
	};
	return e._features.forEach((r) => {
		r.createCell == null || r.createCell(i, n, t, e);
	}, {}), i;
}
var yT = (e, t, n, r, i, a, o) => {
	let s = {
		id: t,
		index: r,
		original: n,
		depth: i,
		parentId: o,
		_valuesCache: {},
		_uniqueValuesCache: {},
		getValue: (t) => {
			if (s._valuesCache.hasOwnProperty(t)) return s._valuesCache[t];
			let n = e.getColumn(t);
			if (n != null && n.accessorFn) return s._valuesCache[t] = n.accessorFn(s.original, r), s._valuesCache[t];
		},
		getUniqueValues: (t) => {
			if (s._uniqueValuesCache.hasOwnProperty(t)) return s._uniqueValuesCache[t];
			let n = e.getColumn(t);
			if (n != null && n.accessorFn) return n.columnDef.getUniqueValues ? (s._uniqueValuesCache[t] = n.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[t]) : (s._uniqueValuesCache[t] = [s.getValue(t)], s._uniqueValuesCache[t]);
		},
		renderValue: (t) => s.getValue(t) ?? e.options.renderFallbackValue,
		subRows: a ?? [],
		getLeafRows: () => vw(s.subRows, (e) => e.subRows),
		getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
		getParentRows: () => {
			let e = [], t = s;
			for (;;) {
				let n = t.getParentRow();
				if (!n) break;
				e.push(n), t = n;
			}
			return e.reverse();
		},
		getAllCells: $(() => [e.getAllLeafColumns()], (t) => t.map((t) => vT(e, s, t, t.id)), {
			key: process.env.NODE_ENV === "development" && "row.getAllCells",
			debug: () => e.options.debugAll ?? e.options.debugRows
		}),
		_getAllCellsByColumnId: $(() => [s.getAllCells()], (e) => e.reduce((e, t) => (e[t.column.id] = t, e), {}), {
			key: process.env.NODE_ENV === "production" && "row.getAllCellsByColumnId",
			debug: () => e.options.debugAll ?? e.options.debugRows
		})
	};
	for (let t = 0; t < e._features.length; t++) {
		let n = e._features[t];
		n == null || n.createRow == null || n.createRow(s, e);
	}
	return s;
};
function bT() {
	return (e) => $(() => [e.options.data], (t) => {
		let n = {
			rows: [],
			flatRows: [],
			rowsById: {}
		}, r = function(t, i, a) {
			i === void 0 && (i = 0);
			let o = [];
			for (let c = 0; c < t.length; c++) {
				let l = yT(e, e._getRowId(t[c], c, a), t[c], c, i, void 0, a?.id);
				if (n.flatRows.push(l), n.rowsById[l.id] = l, o.push(l), e.options.getSubRows) {
					var s;
					l.originalSubRows = e.options.getSubRows(t[c], c), (s = l.originalSubRows) != null && s.length && (l.subRows = r(l.originalSubRows, i + 1, l));
				}
			}
			return o;
		};
		return n.rows = r(t), n;
	}, {
		key: process.env.NODE_ENV === "development" && "getRowModel",
		debug: () => e.options.debugAll ?? e.options.debugTable,
		onChange: () => {
			e._autoResetPageIndex();
		}
	});
}
function xT() {
	return (e) => $(() => [
		e.getState().expanded,
		e.getPreExpandedRowModel(),
		e.options.paginateExpandedRows
	], (e, t, n) => !t.rows.length || e !== !0 && !Object.keys(e ?? {}).length || !n ? t : ST(t), {
		key: process.env.NODE_ENV === "development" && "getExpandedRowModel",
		debug: () => e.options.debugAll ?? e.options.debugTable
	});
}
function ST(e) {
	let t = [], n = (e) => {
		var r;
		t.push(e), (r = e.subRows) != null && r.length && e.getIsExpanded() && e.subRows.forEach(n);
	};
	return e.rows.forEach(n), {
		rows: t,
		flatRows: e.flatRows,
		rowsById: e.rowsById
	};
}
//#endregion
//#region ../../node_modules/@tanstack/react-table/build/lib/index.mjs
function CT(e, t) {
	return e ? wT(e) ? /*#__PURE__*/ sc.createElement(e, t) : e : null;
}
function wT(e) {
	return TT(e) || typeof e == "function" || ET(e);
}
function TT(e) {
	return typeof e == "function" && (() => {
		let t = Object.getPrototypeOf(e);
		return t.prototype && t.prototype.isReactComponent;
	})();
}
function ET(e) {
	return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function DT(e) {
	let t = {
		state: {},
		onStateChange: () => {},
		renderFallbackValue: null,
		...e
	}, [n] = sc.useState(() => ({ current: _T(t) })), [r, i] = sc.useState(() => n.current.initialState);
	return n.current.setOptions((t) => ({
		...t,
		...e,
		state: {
			...r,
			...e.state
		},
		onStateChange: (t) => {
			i(t), e.onStateChange == null || e.onStateChange(t);
		}
	})), n.current;
}
//#endregion
//#region src/components/tables/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/resolveFilterPlaceholder.ts
var OT = (e, t, n = "") => e?.searchPlaceholder ? e.searchPlaceholder : e?.label ? t(e.label) : n, kT = {
	data: {
		grouping: {
			groupableColumns: void 0,
			groupBy: void 0,
			onGroupBy: void 0
		},
		menuFilters: [],
		viewSettingsFilters: [],
		columnOrder: [],
		activeFilters: [],
		loading: !1,
		customColumns: {
			available: [],
			selected: []
		},
		optionsCache: {}
	},
	queries: {
		canDisplayAddFiltersMenu: () => !1,
		canChangeFilters: () => !1,
		canClearAllFilters: () => ({
			visible: !1,
			enabled: !1
		}),
		useSmallAddFilterButton: () => !1,
		canAddCustomColumns: () => !1,
		canSaveFilter: () => ({
			visible: !1,
			enabled: !1
		})
	},
	functions: {
		getTableState: () => {},
		getTableAllFlatColumns: () => [],
		setColumnOrder: () => {},
		clearAllFilters: () => {},
		removeFilter: () => {},
		toggleMultiSelectOption: () => {},
		setSingleSelectValue: () => {},
		bulkSetMultiSelectOptions: () => {},
		setMultiSelectOperator: () => {},
		switchToggleOption: () => {},
		setTextFilter: () => {},
		setAddFilterMenuWidth: () => {},
		setDatePreset: () => {},
		addDateCustom: () => {},
		updateDateCustomOperator: () => {},
		updateDateCustomDate: () => {},
		setDateRange: () => {},
		addCustomColumn: () => {},
		removeCustomColumn: () => {},
		tidyEmptyFilters: () => {}
	},
	ui: { addFilterMenuWidth: "154px" }
}, AT = ({ menuFilters: e, activeFilters: t, dispatch: n }) => {
	K(() => {
		(async () => {
			let t = e.filter((e) => (e.type === "multiSelect" || e.type === "multiSelectAliased") && !!e.optionsFunc);
			(await Promise.all(t.map(async (e) => {
				if (e.type !== "multiSelect" && e.type !== "multiSelectAliased" || !e.optionsFunc) return {
					paramName: e.paramName,
					options: []
				};
				try {
					let t = await e.optionsFunc();
					return {
						paramName: e.paramName,
						options: t
					};
				} catch (t) {
					return Mc(t), {
						paramName: e.paramName,
						options: []
					};
				}
			}))).map((e) => {
				n({
					type: "optionsCacheAdd",
					paramName: e.paramName,
					options: e.options
				});
			});
		})();
	}, []);
	let r = J({});
	K(() => {
		let i = e.filter((e) => (e.type === "multiSelectAsync" || e.type === "singleSelect" && "fetcher" in e) && !!e.initializeOptions);
		i.length !== 0 && (async () => {
			await Promise.all(i.map(async (e) => {
				let i = "initializeOptions" in e ? e.initializeOptions : void 0, a = "mapToOption" in e ? e.mapToOption : void 0;
				if (!i || !a) return;
				let o = X(t.find((t) => t.paramName === e.paramName)).with({ type: "multiSelect" }, ({ values: e }) => e).with({ type: "singleSelect" }, ({ value: e }) => [e]).otherwise(() => []);
				if (o.length === 0) return;
				let s = r.current[e.paramName] ?? /* @__PURE__ */ new Set(), c = o.filter((e) => !s.has(e));
				if (c.length !== 0) try {
					let t = (await i(c)).map((e) => a(e)), o = new Set(s);
					t.forEach((e) => o.add(e.value)), r.current[e.paramName] = o, n({
						type: "optionsCacheAdd",
						paramName: e.paramName,
						options: t
					});
				} catch (e) {
					Mc(e);
				}
			}));
		})();
	}, [
		t,
		e,
		n
	]);
}, jT = (e, t) => X(t).with({ type: "optionsCacheAdd" }, ({ paramName: t, options: n }) => {
	let r = e[t] ?? [], i = /* @__PURE__ */ new Map();
	return r.forEach((e) => i.set(e.value, e)), n.forEach((e) => i.set(e.value, e)), {
		...e,
		[t]: Array.from(i.values())
	};
}).exhaustive(), MT = (e, t) => e.paramName === t && (e.type === "datePreset" || e.type === "dateCustom" || e.type === "dateRange"), NT = (e, t, n) => X(t).with({ type: "clearAll" }, () => ({
	...e,
	activeFilters: e.activeFilters.filter((e) => n.find((t) => t.paramName === e.paramName)?.disabled)
})).with({ type: "removeFilter" }, ({ paramName: t, dateCustomOperator: n }) => ({
	...e,
	activeFilters: e.activeFilters.filter((e) => {
		if (n) {
			let r = e.paramName === t && e.type === "dateCustom" && e.operator !== n;
			return e.paramName !== t || r;
		}
		return e.paramName !== t;
	})
})).with({ type: "toggleMultiSelectOption" }, ({ paramName: t, value: n }) => e.activeFilters.find((e) => e.paramName === t) ? {
	...e,
	activeFilters: e.activeFilters.map((e) => {
		if (e.paramName !== t || e.type !== "multiSelect") return e;
		let r = e.values.includes(n);
		return {
			...e,
			values: r ? e.values.filter((e) => e !== n) : [...e.values, n]
		};
	})
} : {
	...e,
	activeFilters: [...e.activeFilters, {
		paramName: t,
		type: "multiSelect",
		values: [n]
	}]
}).with({ type: "setSingleSelectValue" }, ({ paramName: t, value: n }) => {
	let r = e.activeFilters.find((e) => e.paramName === t), i = {
		paramName: t,
		type: "singleSelect",
		value: n
	};
	return r ? {
		...e,
		activeFilters: e.activeFilters.map((e) => e.paramName !== t || e.type !== "singleSelect" ? e : i)
	} : {
		...e,
		activeFilters: [...e.activeFilters, i]
	};
}).with({ type: "switchToggleOption" }, ({ paramName: t, value: n }) => {
	let r = e.activeFilters.find((e) => e.paramName === t), i = {
		paramName: t,
		type: "toggle",
		value: n
	};
	return r ? {
		...e,
		activeFilters: e.activeFilters.map((e) => e.paramName !== t || e.type !== "toggle" ? e : i)
	} : {
		...e,
		activeFilters: [...e.activeFilters, i]
	};
}).with({ type: "setTextFilter" }, ({ paramName: t, value: n }) => {
	let r = e.activeFilters.find((e) => e.paramName === t), i = {
		paramName: t,
		type: "text",
		value: n
	};
	return r ? {
		...e,
		activeFilters: e.activeFilters.map((e) => e.paramName === t ? i : e)
	} : {
		...e,
		activeFilters: [...e.activeFilters, i]
	};
}).with({ type: "bulkSetMultiSelect" }, ({ paramName: t, values: n }) => {
	let r = e.activeFilters.find((e) => e.paramName === t && e.type === "multiSelect"), i = r?.type === "multiSelect" ? r.operator : void 0;
	return {
		...e,
		activeFilters: [...e.activeFilters.filter((e) => e.paramName !== t), {
			paramName: t,
			type: "multiSelect",
			values: n,
			operator: i
		}]
	};
}).with({ type: "setMultiSelectOperator" }, ({ paramName: t, operator: n }) => ({
	...e,
	activeFilters: e.activeFilters.map((e) => e.paramName === t && e.type === "multiSelect" ? {
		...e,
		operator: n
	} : e)
})).with({ type: "setDatePreset" }, ({ paramName: t, preset: n, operator: r }) => {
	let i = {
		type: "datePreset",
		paramName: t,
		preset: n,
		operator: r ?? (n === "TODAY" ? "EQUALS" : "LESS_THAN")
	}, a = e.activeFilters.filter((e) => !(MT(e, t) && e.type !== "datePreset"));
	return a.some((e) => e.paramName === t && e.type === "datePreset") ? {
		...e,
		activeFilters: a.map((e) => e.paramName === t && e.type === "datePreset" ? i : e)
	} : {
		...e,
		activeFilters: [...a, i]
	};
}).with({ type: "addDateCustom" }, ({ paramName: t, date: n }) => ({
	...e,
	activeFilters: [...e.activeFilters.filter((e) => !MT(e, t)), {
		type: "dateCustom",
		paramName: t,
		date: n,
		operator: "EQUALS"
	}]
})).with({ type: "updateDateCustomOperator" }, ({ paramName: t, nextOperator: n }) => ({
	...e,
	activeFilters: e.activeFilters.map((e) => e.type === "dateCustom" && e.paramName === t ? {
		...e,
		operator: n
	} : e)
})).with({ type: "updateDateCustomDate" }, ({ paramName: t, operator: n, date: r }) => ({
	...e,
	activeFilters: e.activeFilters.map((e) => e.type === "dateCustom" && e.paramName === t && e.operator === n ? {
		...e,
		date: r
	} : e)
})).with({ type: "setDateRange" }, ({ paramName: t, from: n, to: r }) => ({
	...e,
	activeFilters: [...e.activeFilters.filter((e) => !MT(e, t)), {
		type: "dateRange",
		paramName: t,
		from: n,
		to: r
	}]
})).with({ type: "tidyEmptyFilters" }, () => ({
	...e,
	activeFilters: e.activeFilters.filter((e) => e.type !== "multiSelect" || e.values.length !== 0)
})).with({ type: "addQueryParamsDatePreset" }, ({ paramName: t, preset: n, operator: r }) => ({
	...e,
	activeFilters: [...e.activeFilters, {
		type: "datePreset",
		paramName: t,
		preset: n,
		operator: r
	}]
})).with({ type: "addQueryParamsDateCustom" }, ({ paramName: t, date: n, operator: r }) => ({
	...e,
	activeFilters: [...e.activeFilters, {
		type: "dateCustom",
		paramName: t,
		date: n,
		operator: r
	}]
})).with({ type: "reinitialize" }, ({ activeFilters: t }) => ({
	...e,
	activeFilters: t
})).exhaustive(), PT = ({ data: e, stateActiveFilters: t, customColumns: n, totalResultSize: r, onSaveFilters: i, onUpdateSavedFilters: a, lockedControls: o, sortBy: s, defaultSortBy: c }) => ({
	canDisplayAddFiltersMenu: G(() => e.menuFilters.length > 0, [e.menuFilters]),
	canChangeFilters: G(() => {
		if (o) return !1;
		let e = typeof r != "number" || r > 0;
		return t.activeFilters.length === 0 && e || t.activeFilters.length > 0;
	}, [
		t.activeFilters,
		r,
		o
	]),
	canClearAllFilters: G(() => ({
		visible: t.activeFilters.filter((e) => e.type !== "multiSelect" || e.values.length !== 0).filter((t) => {
			let n = e.menuFilters.find((e) => e.paramName === t.paramName);
			return n && !n.disabled;
		}).length > 0,
		enabled: o === void 0 || !o
	}), [
		e.menuFilters,
		t.activeFilters,
		o
	]),
	useSmallAddFilterButton: G(() => t.activeFilters.filter((e) => e.type !== "multiSelect" || e.values.length !== 0).filter((t) => e.menuFilters.find((e) => e.paramName === t.paramName)).length > 0, [e.menuFilters, t.activeFilters]),
	canAddCustomColumns: G(() => n.isEnabled && n.available.length !== n.selected.length, [n]),
	canSaveFilter: G(() => ({
		visible: (!!i || !!a) && (!!s && s !== c || !!t.activeFilters.length),
		enabled: o === void 0 || !o
	}), [
		t.activeFilters,
		i,
		a,
		o,
		s,
		c
	])
}), FT = "expand", IT = "select", LT = "addColumn", RT = [
	FT,
	IT,
	LT
], zT = "eventProperty_", BT = ({ dispatchActiveFilters: e, getTableState: t, getTableAllFlatColumns: n, setColumnOrder: r, customColumns: i, setAddFilterMenuWidth: a }) => {
	let o = G((e) => {
		a(e);
	}, [a]), s = G(() => {
		e({ type: "clearAll" });
	}, [e]), c = G(({ paramName: t, dateCustomOperator: n }) => {
		e({
			type: "removeFilter",
			paramName: t,
			dateCustomOperator: n
		});
	}, [e]), l = G(() => {
		e({ type: "tidyEmptyFilters" });
	}, [e]), u = G(({ paramName: t, preset: n, operator: r }) => {
		e({
			type: "setDatePreset",
			paramName: t,
			preset: n,
			operator: r
		});
	}, [e]), d = G(({ paramName: t, date: n }) => {
		e({
			type: "addDateCustom",
			paramName: t,
			date: n
		});
	}, [e]), f = G(({ paramName: t, prevOperator: n, nextOperator: r }) => {
		e({
			type: "updateDateCustomOperator",
			paramName: t,
			prevOperator: n,
			nextOperator: r
		});
	}, [e]), p = G(({ paramName: t, operator: n, date: r }) => {
		e({
			type: "updateDateCustomDate",
			paramName: t,
			operator: n,
			date: r
		});
	}, [e]), m = G(({ paramName: t, from: n, to: r }) => {
		e({
			type: "setDateRange",
			paramName: t,
			from: n,
			to: r
		});
	}, [e]), h = G(({ paramName: t, value: n }) => {
		e({
			type: "toggleMultiSelectOption",
			paramName: t,
			value: n
		});
	}, [e]), g = G(({ paramName: t, value: n }) => {
		e({
			type: "setSingleSelectValue",
			paramName: t,
			value: n
		});
	}, [e]);
	return {
		setAddFilterMenuWidth: o,
		clearAllFilters: s,
		removeFilter: c,
		tidyEmptyFilters: l,
		setDatePreset: u,
		addDateCustom: d,
		updateDateCustomOperator: f,
		updateDateCustomDate: p,
		setDateRange: m,
		toggleMultiSelectOption: h,
		bulkSetMultiSelectOptions: G(({ paramName: t, values: n }) => {
			e({
				type: "bulkSetMultiSelect",
				paramName: t,
				values: n
			});
		}, [e]),
		setMultiSelectOperator: G(({ paramName: t, operator: n }) => {
			e({
				type: "setMultiSelectOperator",
				paramName: t,
				operator: n
			});
		}, [e]),
		setSingleSelectValue: g,
		switchToggleOption: G(({ paramName: t, value: n }) => {
			e({
				type: "switchToggleOption",
				paramName: t,
				value: n
			});
		}, [e]),
		setTextFilter: G(({ paramName: t, value: n }) => {
			e({
				type: "setTextFilter",
				paramName: t,
				value: n
			});
		}, [e]),
		addCustomColumn: G((e) => {
			i.setSelected([...i.selected, e]);
		}, [i]),
		removeCustomColumn: G((e) => {
			let t = e.replace(zT, "");
			i.setSelected(i.selected.filter((e) => e !== t));
		}, [i]),
		getTableState: t,
		getTableAllFlatColumns: n,
		setColumnOrder: r
	};
}, VT = fc(kT), HT = ({ children: e, activeFilters: t, onChangeActiveFilters: n, ...r }) => {
	let i = r.filters ?? [], a = i.filter((e) => !["toggle"].includes(e.type)), o = i.filter((e) => e.type === "toggle" && !e.hidden), [s, c] = bc((e, t) => NT(e, t, a), { activeFilters: t }), [l, u] = bc(jT, {}), [d, f] = Y(kT.ui.addFilterMenuWidth);
	AT({
		menuFilters: a,
		activeFilters: t,
		dispatch: u
	});
	let p = q(() => ({
		columnOrder: r.columnOrder,
		activeFilters: s.activeFilters,
		menuFilters: a,
		viewSettingsFilters: o,
		loading: r.loading,
		customColumns: {
			available: r.customColumns.available,
			selected: r.customColumns.selected,
			menuLabel: r.customColumns.menuLabel,
			searchPlaceholder: r.customColumns.searchPlaceholder,
			inlineInAddColumnMenu: r.customColumns.inlineInAddColumnMenu
		},
		grouping: {
			groupBy: r.groupBy,
			groupableColumns: r.groupableColumns,
			onGroupBy: r.onGroupBy
		},
		optionsCache: l
	}), [
		a,
		r.columnOrder,
		r.customColumns.available,
		r.customColumns.selected,
		r.customColumns.menuLabel,
		r.customColumns.searchPlaceholder,
		r.customColumns.inlineInAddColumnMenu,
		r.groupBy,
		r.groupableColumns,
		r.onGroupBy,
		r.loading,
		s.activeFilters,
		l,
		o
	]), m = PT({
		data: p,
		stateActiveFilters: s,
		customColumns: r.customColumns,
		totalResultSize: r.totalResultSize,
		onSaveFilters: r.onSaveFilters,
		onUpdateSavedFilters: r.onUpdateSavedFilters,
		lockedControls: r.lockedControls,
		sortBy: r.sortBy,
		defaultSortBy: r.defaultSortBy
	}), h = BT({
		dispatchActiveFilters: c,
		getTableState: r.getTableState,
		getTableAllFlatColumns: r.getTableAllFlatColumns,
		setColumnOrder: r.setColumnOrder,
		customColumns: r.customColumns,
		setAddFilterMenuWidth: f
	}), g = Yc(s.activeFilters), _ = Yc(t);
	K(() => {
		eu(g, s.activeFilters) || n(s.activeFilters);
	}, [
		n,
		s.activeFilters,
		g
	]), K(() => {
		!eu(_, t) && !eu(t, s.activeFilters) && c({
			type: "reinitialize",
			activeFilters: t
		});
	}, [
		_,
		t,
		s.activeFilters
	]), K(() => {
		r.refClearFilters.current = () => {
			h.clearAllFilters();
		};
	}, []);
	let v = {
		addFilterMenuWidth: d,
		viewSettingsHeader: r.viewSettingsHeader
	};
	return /* @__PURE__ */ U(VT.Provider, {
		value: {
			data: p,
			queries: m,
			functions: h,
			ui: v
		},
		children: e
	});
}, UT = () => _c(VT), WT = ({ paramName: e, type: t, activeFilter: n }) => {
	let { data: { activeFilters: r, menuFilters: i, optionsCache: a } } = UT(), o = q(() => {
		let n = i.find((n) => n.paramName === e && n.type === t);
		if (n && !(n.type !== "multiSelect" && n.type !== "multiSelectAliased")) return n;
	}, [
		i,
		e,
		t
	]), { results: s, input: c } = PC({
		items: q(() => o ? o.optionsFunc ? a[e] || [] : o.options : [], [
			a,
			e,
			o
		]),
		searchOn: "label"
	}), [l, u] = Y([]);
	K(() => {
		!n || n.type !== "multiSelect" || u(n.values);
	}, []);
	let d = q(() => s.map((t) => {
		let n = r.some((n) => n.paramName === e && n.type === "multiSelect" && n.values.includes(t.value)), i = o?.optionDisabledFn ? o.optionDisabledFn(r, t) : !1;
		return {
			...t,
			isSelected: n,
			isPinned: l.includes(t.value),
			isDisabled: i
		};
	}), [
		r,
		e,
		l,
		s,
		o
	]), f = G((e, t) => e.label.localeCompare(t.label), []), p = q(() => o && o.optionsSortFn ? o.optionsSortFn : f, [f, o]), m = q(() => d.filter((e) => e.isPinned).sort(p), [d, p]), h = q(() => d.filter((e) => !e.isPinned).sort(p), [d, p]), g = OT(o, (e) => `Search ${Tc(e.toLowerCase())}`);
	return {
		optionsPinned: m,
		optionsUnpinned: h,
		searchInput: {
			...c,
			placeholder: g
		},
		isLoading: !!o?.optionsFunc && a[e] === void 0,
		isSearchable: o?.searchable !== !1
	};
}, GT = 150, KT = ({ initialFocus: e = !0 } = {}) => {
	let t = J(null), { setFocusedIndex: n } = Xi(), r = J(!1);
	return K(() => {
		if (!e) return;
		let n = setTimeout(() => {
			t.current?.focus({ preventScroll: !0 });
		}, GT);
		return () => clearTimeout(n);
	}, [e]), yc(() => {
		if (!t.current || r.current) return;
		let e = document.activeElement;
		e?.getAttribute("role") !== "menuitem" && (n(-1), e !== t.current && t.current.focus({ preventScroll: !0 }));
	}), K(() => {
		let e = t.current;
		if (!e) return;
		let n = () => {
			r.current = !1;
		}, i = (e) => {
			e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter" || e.key === "Escape" || e.stopPropagation();
		}, a = (t) => {
			let n = t.relatedTarget;
			if ((n?.getAttribute("role") === "menu" || n === null) && !r.current) {
				e.focus({ preventScroll: !0 }), queueMicrotask(() => {
					if (r.current) return;
					let t = document.activeElement;
					t !== e && t?.getAttribute("role") !== "menuitem" && e.focus({ preventScroll: !0 });
				});
				return;
			}
			r.current = !0;
		};
		return e.addEventListener("focus", n), e.addEventListener("keydown", i, !0), e.addEventListener("focusout", a), () => {
			e.removeEventListener("focus", n), e.removeEventListener("keydown", i, !0), e.removeEventListener("focusout", a);
		};
	}, []), {
		ref: t,
		onKeyDown: G((e) => {
			let n = e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter";
			if (e.key === "Escape") return;
			if (!n) {
				e.stopPropagation();
				return;
			}
			let i = (t.current?.closest("[role=\"menu\"]"))?.querySelectorAll("[role=\"menuitem\"]");
			if (!i || i.length === 0) return;
			e.preventDefault();
			let a = Array.from(i), o = a.find((e) => e.dataset.testid?.endsWith(".back")), s = a.filter((e) => e !== o), c = s[0] ?? a[0];
			if (e.key === "Enter") {
				c?.click();
				return;
			}
			e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
			let l = e.key === "ArrowDown" ? c : o ?? s[s.length - 1];
			r.current = !0, l?.focus();
		}, [])
	};
}, qT = (e) => G((t) => {
	if (t.key !== "Backspace" && t.key !== "Delete") return;
	let n = t.target?.dataset.deselectValue;
	n && (t.preventDefault(), t.stopPropagation(), e(n));
}, [e]), JT = 300, YT = ({ paramName: e, type: t, activeFilter: n, stickyTop: r }) => {
	let { optionsPinned: i, optionsUnpinned: a, searchInput: o, isLoading: s, isSearchable: c } = WT({
		paramName: e,
		type: t,
		activeFilter: n
	}), { functions: l } = UT(), { ref: u, onKeyDown: d } = KT(), f = J(null), p = qT((t) => l.toggleMultiSelectOption({
		paramName: e,
		value: t
	})), m = q(() => a.slice(0, JT), [a]), h = J(!1), g = i.length + a.length;
	return K(() => {
		if (c || h.current || g === 0) return;
		let e = setTimeout(() => {
			let e = (f.current?.closest("[role=\"menu\"]"))?.querySelectorAll("[role=\"menuitem\"]"), t = e ? Array.from(e).find((e) => !e.dataset.testid?.endsWith(".back")) : null;
			t && (t.focus(), h.current = !0);
		}, 150);
		return () => clearTimeout(e);
	}, [c, g]), /* @__PURE__ */ W(H, { children: [
		c && /* @__PURE__ */ U(Q_, {
			ref: u,
			value: o.value,
			onChange: o.onChange,
			onKeyDown: d,
			placeholder: o.placeholder,
			showDivider: a.length > 0 || i.length > 0,
			disableFocusLock: !0,
			stickyTop: r
		}),
		(s || i.length > 0 || a.length > 0) && /* @__PURE__ */ U(R, {
			height: "4px",
			ref: f
		}),
		s && /* @__PURE__ */ U(z, {
			p: "4px",
			children: /* @__PURE__ */ U(ki, {
				boxSize: "16px",
				color: "#94a3b8"
			})
		}),
		/* @__PURE__ */ W(R, {
			onKeyDown: p,
			children: [
				i.map(({ label: t, value: n, isSelected: r, isDisabled: i }) => /* @__PURE__ */ W(si, {
					onClick: () => {
						l.toggleMultiSelectOption({
							paramName: e,
							value: n
						});
					},
					"data-deselect-value": r ? n : void 0,
					"data-testid": `magicTable.filter.${e}.option.${n}`,
					gap: "8px",
					isDisabled: i,
					children: [/* @__PURE__ */ U(Pr, {
						pointerEvents: "none",
						isChecked: r
					}), /* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						wordBreak: "break-word",
						children: t
					})]
				}, n)),
				i.length > 0 && a.length > 0 && /* @__PURE__ */ U(oi, {}),
				m.map(({ label: t, value: n, isSelected: r, isDisabled: i }) => /* @__PURE__ */ W(si, {
					"data-testid": `magicTable.filter.${e}.option.${n}`,
					onClick: () => {
						l.toggleMultiSelectOption({
							paramName: e,
							value: n
						});
					},
					"data-deselect-value": r ? n : void 0,
					gap: "8px",
					isDisabled: i,
					children: [/* @__PURE__ */ U(Pr, {
						pointerEvents: "none",
						isChecked: r
					}), /* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						wordBreak: "break-word",
						children: t
					})]
				}, n))
			]
		})
	] });
}, XT = (e) => !!(e && "fetcher" in e), ZT = () => {
	let [e, t] = Y(""), n = J("");
	return {
		searchTerm: e,
		searchTermRef: n,
		onSearchChange: G((e) => {
			n.current = e, t(e);
		}, [])
	};
}, QT = (e, t) => e.reduce((e, n) => {
	try {
		let r = t(n);
		return typeof r.value != "string" || typeof r.label != "string" && typeof r.label != "number" ? e : [...e, r];
	} catch {
		return e;
	}
}, []), $T = async (e, t) => {
	if (e.paginatedFetcher) {
		let n = await e.paginatedFetcher(t, void 0);
		return {
			mapped: QT(n.items, e.mapToOption),
			cursor: n.cursor,
			hasMore: n.hasMore
		};
	}
	return {
		mapped: QT(await e.fetcher(t), e.mapToOption),
		cursor: void 0,
		hasMore: !1
	};
}, eE = ({ paramName: e, activeFilter: t, filter: n }) => {
	let { data: { activeFilters: r } } = UT(), i = J(n);
	i.current = n;
	let a = t?.type === "singleSelect" ? t : r.find((t) => t.paramName === e && t.type === "singleSelect"), o = a?.type === "singleSelect" ? a.value : void 0, [s, c] = Y(void 0), l = J(!1);
	return K(() => {
		let e = i.current;
		!XT(e) || !e.initializeOptions || l.current || !o || (l.current = !0, e.initializeOptions([o]).then((t) => {
			let n = QT(t, e.mapToOption).find((e) => e.value === o);
			n && c(n);
		}).catch(() => {}));
	}, [o]), {
		selectedValue: o,
		selectedOption: s
	};
}, tE = ({ filter: e, searchTerm: t, searchTermRef: n }) => {
	let r = J(e);
	r.current = e;
	let i = XT(e), [a, o] = Y([]), [s, c] = Y(!1), [l, u] = Y(!1), [d, f] = Y(null), [p, m] = Y(!1), h = J(""), g = J(!1), _ = J(void 0), v = J(!1), y = J(!1);
	K(() => {
		let e = r.current;
		!XT(e) || g.current || (g.current = !0, c(!0), f(null), $T(e, "").then(({ mapped: e, cursor: t, hasMore: n }) => {
			_.current = t, v.current = n, m(n), o(e), h.current = "";
		}).catch((e) => {
			f(e instanceof Error ? e.message : "An error occurred"), o([]), h.current = "";
		}).finally(() => {
			c(!1);
		}));
	}, []), K(() => {
		let e = r.current;
		if (!XT(e)) return;
		let i = t, a = e.debounceMs ?? 300, s = setTimeout(async () => {
			if (i !== h.current) {
				y.current = !1, c(!0), f(null);
				try {
					let { mapped: t, cursor: r, hasMore: a } = await $T(e, i);
					i === n.current && (_.current = r, v.current = a, m(a), o(t)), h.current = i;
				} catch (e) {
					i === n.current && (f(e instanceof Error ? e.message : "An error occurred"), o([])), h.current = i;
				} finally {
					i === n.current && c(!1);
				}
			}
		}, a);
		return () => clearTimeout(s);
	}, [t, n]);
	let b = G(() => {
		let e = r.current;
		if (!XT(e)) return;
		let t = !!e.paginatedFetcher, i = v.current, a = !y.current, s = !!_.current;
		if (!t || !i || !a || !s) return;
		y.current = !0, u(!0);
		let c = _.current, l = n.current;
		e.paginatedFetcher(l, c).then((t) => {
			if (l !== n.current) return;
			let r = QT(t.items, e.mapToOption);
			o((e) => {
				let t = new Set(e.map((e) => e.value)), n = r.filter((e) => !t.has(e.value));
				return [...e, ...n];
			}), _.current = t.cursor, v.current = t.hasMore, m(t.hasMore);
		}).catch((e) => {
			f(e instanceof Error ? e.message : "An error occurred");
		}).finally(() => {
			y.current = !1, u(!1);
		});
	}, [n]);
	return {
		options: a,
		isLoading: i ? s || d !== null : !1,
		hasMore: i ? p : !1,
		isFetchingMore: i ? l : !1,
		fetchMore: b
	};
}, nE = ({ paramName: e, type: t, activeFilter: n }) => {
	let { data: { activeFilters: r, menuFilters: i } } = UT(), a = q(() => {
		let n = i.find((n) => n.paramName === e && n.type === t);
		if (n?.type === "singleSelect") return n;
	}, [
		i,
		e,
		t
	]), o = XT(a), { searchTerm: s, searchTermRef: c, onSearchChange: l } = ZT(), { selectedValue: u, selectedOption: d } = eE({
		paramName: e,
		activeFilter: n,
		filter: a
	}), { options: f, isLoading: p, hasMore: m, isFetchingMore: h, fetchMore: g } = tE({
		filter: a,
		searchTerm: s,
		searchTermRef: c
	}), _ = G((e, t) => String(e.label || "").localeCompare(String(t.label || "")), []), v = a?.optionsSortFn ?? _, y = q(() => a && "options" in a ? a.options : f, [a, f]), b = a?.optionDisabledFn;
	return {
		options: q(() => rE({
			sourceOptions: y,
			selectedOption: d,
			selectedValue: u,
			isAsync: o,
			searchTerm: s,
			activeFilters: r,
			optionDisabledFn: b,
			sortFn: v
		}), [
			y,
			d,
			u,
			o,
			s,
			r,
			b,
			v
		]),
		searchInput: {
			value: s,
			onChange: l,
			placeholder: OT(a, (e) => `Search ${Tc(e.toLowerCase())}`)
		},
		isSearchable: a?.searchable !== !1,
		isLoading: p,
		fetchMore: g,
		hasMore: m,
		isFetchingMore: h
	};
}, rE = ({ sourceOptions: e, selectedOption: t, selectedValue: n, isAsync: r, searchTerm: i, activeFilters: a, optionDisabledFn: o, sortFn: s }) => {
	let c = [...e];
	t && !c.some((e) => e.value === t.value) && c.push(t);
	let l = i.toLowerCase();
	return c.reduce((e, t) => e.some((e) => e.value === t.value) ? e : [...e, t], []).filter((e) => r && e.value === n || !l ? !0 : String(e.label).toLowerCase().includes(l)).map((e) => ({
		...e,
		isSelected: e.value === n,
		isDisabled: o ? o(a, e) : !1
	})).sort(s);
}, iE = ({ paramName: e, type: t, activeFilter: n, stickyTop: r }) => {
	let { options: i, searchInput: a, isSearchable: o, isLoading: s, fetchMore: c, hasMore: l, isFetchingMore: u } = nE({
		paramName: e,
		type: t,
		activeFilter: n
	}), { functions: d } = UT(), { ref: f, onKeyDown: p } = KT(), [m] = wl({
		loading: u,
		hasNextPage: l,
		onLoadMore: c,
		rootMargin: "0px 0px 50px 0px"
	});
	return /* @__PURE__ */ W(H, { children: [
		o && /* @__PURE__ */ U(Q_, {
			ref: f,
			value: a.value,
			onChange: a.onChange,
			onKeyDown: p,
			placeholder: a.placeholder,
			showDivider: i.length > 0,
			isLoading: s,
			disableFocusLock: !0,
			stickyTop: r
		}),
		i.length > 0 && /* @__PURE__ */ U(R, { height: "4px" }),
		/* @__PURE__ */ U(R, { children: i.map(({ label: t, value: n, isSelected: r, isDisabled: i }) => /* @__PURE__ */ W(si, {
			onClick: () => {
				d.setSingleSelectValue({
					paramName: e,
					value: n
				});
			},
			gap: "8px",
			isDisabled: i,
			"data-testid": `magicTable.filter.${e}.option.${n}`,
			sx: { "&:active svg, &[data-active] svg": { color: I } },
			children: [/* @__PURE__ */ U(V, {
				...N,
				color: "inherit",
				wordBreak: "break-word",
				flex: "1",
				children: t
			}), r ? /* @__PURE__ */ U(zp, {
				color: y,
				"aria-hidden": !0
			}) : /* @__PURE__ */ U(R, {
				width: "16px",
				height: "16px",
				color: k
			})]
		}, n)) }),
		(l || u) && /* @__PURE__ */ U("div", {
			ref: m,
			children: u && /* @__PURE__ */ U(z, {
				padding: 2,
				children: /* @__PURE__ */ U(ki, {
					size: "sm",
					color: "#475569"
				})
			})
		})
	] });
}, aE = ({ paramName: e, type: t, activeFilter: n }) => {
	let { data: { activeFilters: r, menuFilters: i } } = UT(), a = q(() => {
		let n = i.find((n) => n.paramName === e && n.type === t);
		if (n?.type === "multiSelectAsync") return n;
	}, [
		i,
		e,
		t
	]), o = J(a);
	o.current = a;
	let [s, c] = Y(""), l = J(""), [u, d] = Y([]), [f, p] = Y([]), [m, h] = Y(!1), [g, _] = Y(!1), [v, y] = Y(null), b = J(""), x = J(!1), S = J(!1), C = J(void 0), w = J(!1), [T, E] = Y(!1), D = J(!1);
	K(() => {
		let e = o.current;
		!e || x.current || (x.current = !0, h(!0), y(null), $T(e, "").then(({ mapped: e, cursor: t, hasMore: n }) => {
			C.current = t, w.current = n, E(n), d(e), b.current = "";
		}).catch((e) => {
			y(e instanceof Error ? e.message : "An error occurred"), d([]), b.current = "";
		}).finally(() => {
			h(!1);
		}));
	}, []), K(() => {
		let e = o.current, t = !!e?.initializeOptions, r = S.current, i = n?.type === "multiSelect" && n.values.length > 0;
		!t || r || !i || (S.current = !0, e.initializeOptions(n.values).then((t) => {
			let n = QT(t, e.mapToOption);
			p((e) => {
				let t = [...e];
				return n.forEach((e) => {
					t.some((t) => t.value === e.value) || t.push(e);
				}), t;
			});
		}).catch(() => {}));
	}, [n]);
	let ee = Yc(r), te = Yc(u);
	K(() => {
		let t = !eu(ee, r), n = !eu(te, u);
		if (!t && !n) return;
		let i = r.find((t) => t.paramName === e && t.type === "multiSelect");
		if (!i || i.type !== "multiSelect") {
			p((e) => e.length === 0 ? e : []);
			return;
		}
		let a = u.filter((e) => i.values.includes(e.value));
		p((e) => {
			let t = e.filter((e) => i.values.includes(e.value)), n = [...a];
			return t.forEach((e) => {
				n.some((t) => t.value === e.value) || n.push(e);
			}), eu(e, n) ? e : n;
		});
	}, [
		r,
		e,
		u,
		ee,
		te
	]), K(() => {
		let e = o.current;
		if (!e) return;
		let t = s, n = e.debounceMs ?? 300, r = setTimeout(async () => {
			if (t !== b.current) {
				D.current = !1, h(!0), y(null);
				try {
					let { mapped: n, cursor: r, hasMore: i } = await $T(e, t);
					t === l.current && (C.current = r, w.current = i, E(i), d(n)), b.current = t;
				} catch (e) {
					t === l.current && (y(e instanceof Error ? e.message : "An error occurred"), d([])), b.current = t;
				} finally {
					t === l.current && h(!1);
				}
			}
		}, n);
		return () => clearTimeout(r);
	}, [s]);
	let O = q(() => {
		let t = [...u];
		f.forEach((e) => {
			t.some((t) => t.value === e.value) || t.push(e);
		});
		let n = s.toLowerCase();
		return t.filter((t) => r.some((n) => n.paramName === e && n.type === "multiSelect" && n.values.includes(t.value)) || !n ? !0 : String(t.label).toLowerCase().includes(n)).map((t) => {
			let n = r.some((n) => n.paramName === e && n.type === "multiSelect" && n.values.includes(t.value)), i = o.current?.optionDisabledFn ? o.current.optionDisabledFn(r, t) : !1;
			return {
				...t,
				isSelected: n,
				isPinned: n,
				isDisabled: i
			};
		});
	}, [
		r,
		e,
		u,
		f,
		s
	]), ne = G((e, t) => {
		let n = String(e.label || ""), r = String(t.label || "");
		return n.localeCompare(r);
	}, []), re = a?.optionsSortFn ?? ne, ie = q(() => oE(O.filter((e) => e.isPinned).sort(re)), [O, re]), ae = q(() => oE(O.filter((e) => !e.isPinned).sort(re)), [O, re]), oe = G(() => {
		let e = o.current;
		if (!e?.paginatedFetcher || !w.current || D.current || !C.current) return;
		D.current = !0, _(!0);
		let t = C.current, n = l.current;
		e.paginatedFetcher(n, t).then((t) => {
			if (n !== l.current) return;
			let r = QT(t.items, e.mapToOption);
			d((e) => {
				let t = new Set(e.map((e) => e.value)), n = r.filter((e) => !t.has(e.value));
				return [...e, ...n];
			}), C.current = t.cursor, w.current = t.hasMore, E(t.hasMore);
		}).catch((e) => {
			y(e instanceof Error ? e.message : "An error occurred");
		}).finally(() => {
			D.current = !1, _(!1);
		});
	}, []);
	return {
		optionsPinned: ie,
		optionsUnpinned: ae,
		searchInput: {
			value: s,
			onChange: G((e) => {
				l.current = e, c(e);
			}, []),
			placeholder: OT(a, (e) => `Search ${Tc(e.toLowerCase())}`)
		},
		isLoading: m || v !== null,
		fetchMore: oe,
		hasMore: T,
		isFetchingMore: g
	};
}, oE = (e) => e.reduce((e, t) => e.find((e) => e.value === t.value) ? e : [...e, t], []), sE = ({ paramName: e, type: t, activeFilter: n, stickyTop: r }) => {
	let { optionsPinned: i, optionsUnpinned: a, searchInput: o, isLoading: s, fetchMore: c, hasMore: l, isFetchingMore: u } = aE({
		paramName: e,
		type: t,
		activeFilter: n
	}), { functions: d } = UT(), { ref: f, onKeyDown: p } = KT(), m = qT((t) => d.toggleMultiSelectOption({
		paramName: e,
		value: t
	})), [h] = wl({
		loading: u,
		hasNextPage: l,
		onLoadMore: c,
		rootMargin: "0px 0px 50px 0px"
	});
	return /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(Q_, {
			ref: f,
			value: o.value,
			onChange: o.onChange,
			onKeyDown: p,
			placeholder: o.placeholder,
			showDivider: a.length > 0 || i.length > 0,
			isLoading: s,
			disableFocusLock: !0,
			stickyTop: r
		}),
		(i.length > 0 || a.length > 0) && /* @__PURE__ */ U(R, { height: "4px" }),
		/* @__PURE__ */ W(R, {
			onKeyDown: m,
			children: [
				i.map(({ label: t, value: n, isSelected: r, isDisabled: i }) => /* @__PURE__ */ W(si, {
					onClick: () => {
						d.toggleMultiSelectOption({
							paramName: e,
							value: n
						});
					},
					"data-deselect-value": r ? n : void 0,
					gap: "8px",
					isDisabled: i,
					"data-testid": `magicTable.filter.${e}.option.${n}`,
					children: [/* @__PURE__ */ U(Pr, {
						pointerEvents: "none",
						isChecked: r
					}), /* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						wordBreak: "break-word",
						children: t
					})]
				}, n)),
				i.length > 0 && a.length > 0 && /* @__PURE__ */ U(oi, {}),
				a.map(({ label: t, value: n, isSelected: r, isDisabled: i }) => /* @__PURE__ */ W(si, {
					onClick: () => {
						d.toggleMultiSelectOption({
							paramName: e,
							value: n
						});
					},
					"data-deselect-value": r ? n : void 0,
					gap: "8px",
					isDisabled: i,
					"data-testid": `magicTable.filter.${e}.option.${n}`,
					children: [/* @__PURE__ */ U(Pr, {
						pointerEvents: "none",
						isChecked: r
					}), /* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						wordBreak: "break-word",
						children: t
					})]
				}, n))
			]
		}),
		(l || u) && /* @__PURE__ */ U("div", {
			ref: h,
			children: u && /* @__PURE__ */ U(z, {
				padding: 2,
				children: /* @__PURE__ */ U(ki, {
					size: "sm",
					color: "#475569"
				})
			})
		})
	] });
}, cE = 500, lE = ({ paramName: e }) => {
	let { data: t, functions: n } = UT(), r = q(() => t.menuFilters.find((t) => t.paramName === e), [t.menuFilters, e]), [i, a] = Y(""), o = J(!1);
	K(() => {
		n.setAddFilterMenuWidth("200px");
	}, []), K(() => {
		let n = t.activeFilters.find((t) => t.paramName === e);
		n && n.type === "text" && a(n.value);
	}, []);
	let s = G((t) => {
		t === "" ? n.removeFilter({ paramName: e }) : n.setTextFilter({
			paramName: e,
			value: t
		});
	}, [n, e]), c = J(null);
	K(() => {
		if (o.current) return c.current = setTimeout(() => {
			c.current = null, s(i);
		}, cE), () => {
			c.current &&= (clearTimeout(c.current), null);
		};
	}, [i, s]);
	let l = G(() => {
		o.current && (c.current &&= (clearTimeout(c.current), null), s(i));
	}, [s, i]);
	return {
		title: r?.label ?? "",
		input: {
			value: i,
			onChange: (e) => {
				o.current = !0, a(e);
			},
			placeholder: OT(r?.type === "text" ? r : void 0, (e) => `Filter by ${e.toLowerCase()}...`, "Filter...")
		},
		commitNow: l
	};
}, uE = ({ paramName: e, type: t, menuOnClose: n, stickyTop: r }) => {
	let { input: i, commitNow: a } = lE({
		paramName: e,
		type: t,
		menuOnClose: n
	}), { ref: o, onKeyDown: s } = KT();
	return /* @__PURE__ */ U(Q_, {
		ref: o,
		value: i.value,
		onChange: i.onChange,
		onKeyDown: (e) => {
			if (e.key === "Enter") {
				e.preventDefault(), e.stopPropagation(), a();
				return;
			}
			s(e);
		},
		placeholder: i.placeholder,
		paddingBottom: "0",
		marginBottom: 1,
		disableFocusLock: !0,
		hideSearchIcon: !0,
		stickyTop: r
	});
}, dE = ({ items: e, searchOn: t }) => {
	let [n, r] = Y(""), i = q(() => e.filter((e) => typeof e[t] == "string" && e[t].toLowerCase().includes(n.toLowerCase())), [
		e,
		n,
		t
	]), a = G(() => {
		r("");
	}, []);
	return {
		results: i,
		input: {
			value: n,
			onChange: (e) => r(e)
		},
		reset: a
	};
}, fE = {
	TODAY: "Today",
	"1_WEEK": "1 week ago",
	"1_MONTH": "1 month ago",
	"3_MONTHS": "3 months ago"
}, pE = {
	EQUALS: "Is",
	LESS_THAN: "Less than",
	MORE_THAN: "More than"
}, mE = {
	EQUALS: "Is",
	LESS_THAN: "Before",
	MORE_THAN: "After"
}, hE = {
	BEFORE: "Before",
	AFTER: "After",
	EQUALS: "Is"
}, gE = ({ paramName: e, type: t, menuOnClose: n, activeFilter: r }) => {
	let { data: { menuFilters: i, activeFilters: a }, functions: o } = UT(), [s, c] = Y(!1), [l, u] = Y(!1), d = q(() => r ?? a.find((t) => t.paramName === e), [
		r,
		a,
		e
	]), f = q(() => a.find((t) => t.type === "dateRange" && t.paramName === e), [a, e]), p = q(() => {
		let n = i.find((n) => n.paramName === e && n.type === t);
		if (!(!n || n && n.type !== "date")) return n;
	}, [
		i,
		e,
		t
	]), { results: m, input: h } = dE({
		items: q(() => {
			if (!p) return [];
			let t = Object.entries(fE).map(([t, n]) => {
				let r = a.find((t) => t.type === "datePreset" && t.paramName === e), i = !!(r && r.paramName === e && r.type === "datePreset" && r.preset === t);
				return {
					label: n,
					testId: `magicTable.filter.date.preset.${t}`,
					onClick: () => {
						if (i) {
							o.removeFilter({ paramName: p.paramName });
							return;
						}
						o.setDatePreset({
							paramName: p.paramName,
							preset: t,
							operator: r && r.type === "datePreset" ? r.operator : t === "TODAY" ? "EQUALS" : "LESS_THAN"
						});
					},
					onDeselect: i ? () => o.removeFilter({ paramName: p.paramName }) : void 0,
					closeOnSelect: !1,
					isSelected: i
				};
			}), n = !!(d && d.type === "dateCustom"), r = {
				label: "Custom date...",
				testId: "magicTable.filter.date.custom",
				onClick: () => {
					o.setAddFilterMenuWidth("298px"), c(!0);
				},
				onDeselect: n && d && d.type === "dateCustom" ? () => o.removeFilter({
					paramName: p.paramName,
					dateCustomOperator: d.operator
				}) : void 0,
				closeOnSelect: !1,
				isSelected: n
			};
			return [
				...t,
				...p.hideCustomDate ? [] : [r],
				{
					label: "Date range...",
					testId: "magicTable.filter.date.range",
					onClick: () => {
						o.setAddFilterMenuWidth("628px"), u(!0);
					},
					onDeselect: f ? () => o.removeFilter({ paramName: p.paramName }) : void 0,
					closeOnSelect: !1,
					isSelected: !!f
				}
			];
		}, [
			d,
			a,
			f,
			o,
			e,
			p
		]),
		searchOn: "label"
	}), g = f?.type === "dateRange" ? [f.from, f.to] : void 0;
	return {
		options: m,
		searchInput: {
			...h,
			placeholder: p?.label ? `Search ${p.label.toLowerCase()}` : ""
		},
		calendar: {
			showCalendar: s,
			onSelect: (t) => {
				d && d.type === "dateCustom" ? o.updateDateCustomDate({
					paramName: e,
					date: t,
					operator: d.operator
				}) : o.addDateCustom({
					paramName: e,
					date: t
				});
			}
		},
		range: {
			showRangeInput: l,
			value: g,
			onChange: ([t, r]) => {
				o.setDateRange({
					paramName: e,
					from: t,
					to: r
				}), n();
			},
			onCancel: () => {
				u(!1), o.setAddFilterMenuWidth(kT.ui.addFilterMenuWidth);
			}
		},
		selectedDate: d && d.type === "dateCustom" ? d.date : void 0
	};
}, _E = ({ onSelect: e, selectedDate: t }) => {
	let n = J(null), r = t ?? /* @__PURE__ */ new Date(), { calendars: i, getDateProps: a, getBackProps: o, getForwardProps: s } = vl({
		selected: t && C_.toDayzed(t),
		date: C_.toDayzed(t ?? /* @__PURE__ */ new Date()),
		monthsToDisplay: 1,
		firstDayOfWeek: 1,
		onDateSelected: ({ date: t }) => {
			e(C_.fromDayzed(t));
		}
	});
	return K(() => {
		let e = setTimeout(() => {
			let e = nl(r, "MMM"), t = r.getDate();
			(n.current?.querySelector(`[data-testid="datePicker.button.${e}.${t}"]`))?.focus();
		}, 0);
		return () => clearTimeout(e);
	}, []), /* @__PURE__ */ U(R, {
		ref: n,
		children: /* @__PURE__ */ U(k_, {
			calendar: i[0],
			getDateProps: a,
			getBackProps: o,
			getForwardProps: s,
			selectedDate: t ?? /* @__PURE__ */ new Date(),
			type: "single"
		})
	});
}, vE = ({ paramName: e, type: t, menuOnClose: n, activeFilter: r, stickyTop: i }) => {
	let { options: a, searchInput: o, calendar: s, range: c, selectedDate: l } = gE({
		paramName: e,
		type: t,
		menuOnClose: n,
		activeFilter: r
	}), { ref: u, onKeyDown: d } = KT(), f = qT((e) => {
		a.find((t) => t.label === e)?.onDeselect?.();
	});
	return s.showCalendar ? /* @__PURE__ */ U(z, {
		p: "4px",
		paddingTop: "8px",
		children: /* @__PURE__ */ U(_E, {
			onSelect: s.onSelect,
			selectedDate: l
		})
	}) : c.showRangeInput ? /* @__PURE__ */ U(Av, {
		defaultDates: c.value,
		onSubmit: c.onChange,
		onCancel: c.onCancel,
		"data-testid": "magicTable.filter.date.rangeCalendar"
	}) : /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(Q_, {
			ref: u,
			value: o.value,
			onChange: o.onChange,
			onKeyDown: d,
			placeholder: o.placeholder,
			showDivider: a.length > 0,
			disableFocusLock: !0,
			stickyTop: i
		}),
		a.length > 0 && /* @__PURE__ */ U(R, { height: "4px" }),
		/* @__PURE__ */ U(R, {
			onKeyDown: f,
			children: a.map(({ label: e, onClick: t, onDeselect: n, closeOnSelect: r, isSelected: i, testId: a }) => /* @__PURE__ */ U(si, {
				onClick: t,
				"data-testid": a,
				"data-deselect-value": n ? e : void 0,
				closeOnSelect: r,
				children: /* @__PURE__ */ W(B, {
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					children: [/* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						children: e
					}), i && /* @__PURE__ */ U(zp, { color: "inherit" })]
				})
			}, e))
		})
	] });
}, yE = (e) => {
	let t = e.type === "text" || e.type === "date", { setFocusedIndex: n } = Xi();
	return yc(() => {
		t && n(-1);
	}, [t, n]), X(e.type).with("multiSelect", "multiSelectAliased", () => /* @__PURE__ */ U(YT, { ...e })).with("singleSelect", () => /* @__PURE__ */ U(iE, { ...e })).with("multiSelectAsync", () => /* @__PURE__ */ U(sE, { ...e })).with("text", () => /* @__PURE__ */ U(uE, { ...e })).with("date", () => /* @__PURE__ */ U(vE, { ...e })).with("toggle", () => null).with("group", () => null).with("boolean", "checkbox", () => null).exhaustive();
}, bE = ({ label: e, isDisabled: t, "data-testid": n }) => /* @__PURE__ */ U(ai, {
	"data-testid": n,
	background: Fn,
	py: "4px",
	px: "6px",
	borderRadius: "4px",
	height: "24px",
	maxWidth: "200px",
	_focus: { appearance: "none" },
	...t ? { cursor: "default" } : {
		_hover: { background: P },
		_active: { background: P }
	},
	children: /* @__PURE__ */ U(V, {
		...j,
		color: "inherit",
		noOfLines: 1,
		children: e
	})
}), xE = ({ icon: e, label: t, operatorLabel: n, operatorOptions: r, value: i, onRemove: a, paramName: o, type: s, isHidden: c, activeFilter: l, isDisabled: u, testId: d }) => {
	let { functions: f, ui: p } = UT(), m = qc().replace(/:/g, ""), { isOpen: h, onOpen: g, onClose: _ } = Kc();
	K(() => {
		h ? Oc(m) : Gc(m);
	}, [h, p.addFilterMenuWidth]);
	let v = G(() => {
		_(), setTimeout(() => {
			f.setAddFilterMenuWidth(kT.ui.addFilterMenuWidth), f.tidyEmptyFilters();
		}, 150);
	}, [f, _]);
	return /* @__PURE__ */ W(B, {
		background: I,
		borderRadius: "8px",
		border: `${M} 1px solid`,
		color: u ? en : F,
		width: "fit-content",
		boxShadow: Ht,
		display: c ? "none" : void 0,
		pr: u ? "3px" : void 0,
		"data-testid": d,
		children: [
			/* @__PURE__ */ W(B, {
				gap: "5px",
				p: "7px",
				alignItems: "center",
				children: [e && /* @__PURE__ */ U(e, { color: "inherit" }), /* @__PURE__ */ U(V, {
					...j,
					color: "inherit",
					children: t
				})]
			}),
			/* @__PURE__ */ W(B, {
				py: "3px",
				gap: "4px",
				children: [/* @__PURE__ */ W(ii, {
					variant: "component-library",
					isLazy: !0,
					children: [/* @__PURE__ */ U(bE, {
						label: n,
						isDisabled: u,
						"data-testid": d ? `${d}.operator` : void 0
					}), !u && /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(ci, { children: r.map((e) => /* @__PURE__ */ U(si, {
						icon: e.icon,
						iconSpacing: "8px",
						onClick: e.onClick,
						children: /* @__PURE__ */ W(B, {
							justifyContent: "space-between",
							alignItems: "center",
							children: [/* @__PURE__ */ U(V, {
								...N,
								color: "inherit",
								children: e.label
							}), e.isSelected && /* @__PURE__ */ U(zp, { color: "inherit" })]
						})
					}, e.label)) }) })]
				}), /* @__PURE__ */ W(ii, {
					id: m,
					variant: "component-library",
					isOpen: !u && h,
					onOpen: u ? SE : g,
					onClose: u ? SE : v,
					closeOnSelect: !1,
					isLazy: !0,
					children: [/* @__PURE__ */ U(bE, {
						label: i,
						isDisabled: u,
						"data-testid": d ? `${d}.value` : void 0
					}), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(ci, {
						width: p.addFilterMenuWidth,
						maxHeight: "516px",
						overflowY: "auto",
						overflowX: "hidden",
						paddingTop: "0px !important",
						paddingBottom: "0px !important",
						children: /* @__PURE__ */ U(yE, {
							paramName: o,
							type: s,
							menuOnClose: v,
							activeFilter: l
						})
					}) })]
				})]
			}),
			!u && /* @__PURE__ */ U(B, {
				p: "3px",
				children: /* @__PURE__ */ U(Or, {
					"data-testid": d ? `${d}.clear` : void 0,
					"aria-label": "Remove filter",
					onClick: a,
					variant: "unstyled",
					minWidth: "initial",
					height: "initial",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: "4px",
					boxSize: "24px",
					color: "#64748b",
					_hover: {
						color: "#334155",
						background: "#e2e8f0"
					},
					children: /* @__PURE__ */ U($h, { color: "inherit" })
				})
			})
		]
	});
}, SE = () => {}, CE = () => void 0, wE = () => {
	let { data: e, functions: t } = UT(), n = G((e) => X(e.type).with("multiSelect", () => {
		if (e.type !== "multiSelect") return "";
		let t = e.operator === "IS_NOT";
		return e.values.length >= 2 ? t ? "is none of" : "is any of" : t ? "is not" : "is";
	}).with("singleSelect", () => "is").with("text", () => "contains").with("datePreset", () => e.type === "datePreset" ? e.preset === "TODAY" ? mE[e.operator].toLowerCase() : pE[e.operator].toLowerCase() : "").with("dateCustom", () => e.type === "dateCustom" ? hE[e.operator].toLowerCase() : "").with("dateRange", () => "is").with("toggle", () => "").exhaustive(), []), r = G((e, n) => X(e.type).with("multiSelect", () => {
		if (e.type !== "multiSelect") return [];
		let r = e.values.length >= 2;
		return (n.type === "multiSelect" || n.type === "multiSelectAsync") && n.excludeParamName && !n.paramNameAliasOf ? [{
			label: r ? "Is any of" : "Is",
			icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
			onClick: () => {
				t.setMultiSelectOperator({
					paramName: e.paramName,
					operator: "IS"
				});
			},
			isSelected: e.operator !== "IS_NOT"
		}, {
			label: r ? "Is none of" : "Is not",
			icon: /* @__PURE__ */ U(Qp, { color: "inherit" }),
			onClick: () => {
				t.setMultiSelectOperator({
					paramName: e.paramName,
					operator: "IS_NOT"
				});
			},
			isSelected: e.operator === "IS_NOT"
		}] : [{
			label: r ? "Is any of" : "Is",
			icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
			onClick: CE,
			isSelected: !0
		}];
	}).with("singleSelect", () => [{
		label: "Is",
		icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
		onClick: CE,
		isSelected: !0
	}]).with("text", () => [{
		label: "Contains",
		icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
		onClick: CE,
		isSelected: !0
	}]).with("datePreset", () => e.type === "datePreset" ? [
		{
			label: e.preset === "TODAY" ? mE.LESS_THAN : pE.LESS_THAN,
			icon: /* @__PURE__ */ U(op, { color: "inherit" }),
			onClick: () => {
				t.setDatePreset({
					paramName: e.paramName,
					preset: e.preset,
					operator: "LESS_THAN"
				});
			},
			isSelected: e.operator === "LESS_THAN"
		},
		{
			label: e.preset === "TODAY" ? mE.MORE_THAN : pE.MORE_THAN,
			icon: /* @__PURE__ */ U(cp, { color: "inherit" }),
			onClick: () => {
				t.setDatePreset({
					paramName: e.paramName,
					preset: e.preset,
					operator: "MORE_THAN"
				});
			},
			isSelected: e.operator === "MORE_THAN"
		},
		{
			label: e.preset === "TODAY" ? mE.EQUALS : pE.EQUALS,
			icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
			onClick: () => {
				t.setDatePreset({
					paramName: e.paramName,
					preset: e.preset,
					operator: "EQUALS"
				});
			},
			isSelected: e.operator === "EQUALS"
		}
	] : []).with("dateCustom", () => e.type === "dateCustom" ? [
		{
			label: hE.BEFORE,
			icon: /* @__PURE__ */ U(op, { color: "inherit" }),
			onClick: () => {
				t.updateDateCustomOperator({
					paramName: e.paramName,
					prevOperator: e.operator,
					nextOperator: "BEFORE"
				});
			},
			isSelected: e.operator === "BEFORE"
		},
		{
			label: hE.AFTER,
			icon: /* @__PURE__ */ U(cp, { color: "inherit" }),
			onClick: () => {
				t.updateDateCustomOperator({
					paramName: e.paramName,
					prevOperator: e.operator,
					nextOperator: "AFTER"
				});
			},
			isSelected: e.operator === "AFTER"
		},
		{
			label: hE.EQUALS,
			icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
			onClick: () => {
				t.updateDateCustomOperator({
					paramName: e.paramName,
					prevOperator: e.operator,
					nextOperator: "EQUALS"
				});
			},
			isSelected: e.operator === "EQUALS"
		}
	] : []).with("dateRange", () => [{
		label: "Is",
		icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
		onClick: CE,
		isSelected: !0
	}]).with("toggle", () => []).exhaustive(), [t]), i = G(({ thisFilter: t, activeFilter: n }) => X(n.type).with("multiSelect", () => {
		if (n.type !== "multiSelect") return "";
		if (n.values.length === 1) {
			let r = t.type === "multiSelect" && t.options.find((e) => e.value === n.values[0]);
			if (r) return r.label;
			let i = e.optionsCache[t.paramName]?.find((e) => e.value === n.values[0]);
			return i ? i.label : "1 option";
		}
		return `${n.values.length} options`;
	}).with("singleSelect", () => n.type === "singleSelect" ? t.type === "singleSelect" && "options" in t ? t.options.find((e) => e.value === n.value)?.label ?? n.value : e.optionsCache[t.paramName]?.find((e) => e.value === n.value)?.label ?? n.value : "").with("text", () => n.type === "text" ? n.value : "").with("datePreset", () => n.type === "datePreset" ? fE[n.preset] : "").with("dateCustom", () => n.type === "dateCustom" ? Dc(new Date(n.date).toISOString(), "d MMM yyyy") : "").with("dateRange", () => n.type === "dateRange" ? `${Dc(new Date(n.from).toISOString(), "d MMM yyyy")} to ${Dc(new Date(n.to).toISOString(), "d MMM yyyy")}` : "").with("toggle", () => "").exhaustive(), [e.optionsCache]);
	return { activeFilters: q(() => e.activeFilters.reduce((a, o) => {
		let s = e.menuFilters?.find((e) => e.paramName === o.paramName);
		if (!s) return [...a];
		let { paramName: c, icon: l, label: u, type: d } = s;
		return [...a, {
			paramName: c,
			icon: l,
			testId: `magicTable.filter.${c}`,
			label: u,
			type: d,
			operatorLabel: n(o),
			operatorOptions: r(o, s),
			value: i({
				thisFilter: s,
				activeFilter: o
			}),
			onRemove: () => {
				t.removeFilter({
					paramName: c,
					dateCustomOperator: o.type === "dateCustom" ? o.operator : void 0
				});
			},
			isHidden: o.type === "multiSelect" && o.values.length === 0,
			isDisabled: !!s.disabled,
			activeFilter: o
		}];
	}, []), [
		e.activeFilters,
		e.menuFilters,
		t,
		n,
		r,
		i
	]) };
}, TE = () => {
	let { activeFilters: e } = wE(), { queries: t } = UT(), n = t.canChangeFilters();
	return e.map((e) => /* @__PURE__ */ U(xE, {
		...e,
		isDisabled: !n || e.isDisabled
	}, e.paramName));
}, EE = ({ useSmallVersion: e, isDisabled: t }) => e ? /* @__PURE__ */ U(ai, {
	as: Zr,
	variant: "component-library-secondary",
	icon: /* @__PURE__ */ U(Tm, { color: "inherit" }),
	minWidth: "initial",
	width: "32px",
	padding: "8px",
	isDisabled: t,
	"data-testid": "magicTable.filters",
	"data-keyboard-shortcut-target": "magicTable.filters"
}) : /* @__PURE__ */ U(ai, {
	as: Or,
	leftIcon: /* @__PURE__ */ U(Tm, { color: "inherit" }),
	iconSpacing: "4px",
	variant: "component-library-secondary",
	isDisabled: t,
	"data-testid": "magicTable.filters",
	"data-keyboard-shortcut-target": "magicTable.filters",
	children: "Filters"
}), DE = () => {
	let { data: e, queries: t, ui: n, functions: r } = UT(), [i, a] = Y(), [o, s] = Y(), [c, l] = Y(void 0), [u, d] = Y(""), f = q(() => new Set(e.menuFilters.filter((e) => e.type === "group").flatMap((e) => e.subFilters.map((e) => e.paramName))), [e.menuFilters]), p = q(() => {
		if (c) {
			let t = e.menuFilters.find((e) => e.type === "group" && e.paramName === c);
			return t?.type === "group" ? t.subFilters : [];
		}
		return u.length > 0 ? e.menuFilters.filter((e) => e.type === "group" || !f.has(e.paramName)).flatMap((e) => e.type === "group" ? e.subFilters : [e]) : e.menuFilters.filter((e) => !f.has(e.paramName));
	}, [
		e.menuFilters,
		c,
		f,
		u
	]), m = q(() => {
		if (u.length === 0) return p;
		let e = u.toLowerCase();
		return p.filter((t) => t.label.toLowerCase().includes(e));
	}, [p, u]), h = q(() => ({
		value: u,
		onChange: (e) => d(e)
	}), [u]), g = G(() => d(""), []), _ = q(() => m.map((e) => ({
		paramName: e.paramName,
		label: e.label,
		icon: (() => {
			if (!e.icon) return;
			let t = e.icon;
			return /* @__PURE__ */ U(t, { color: "inherit" });
		})(),
		type: e.type
	})), [m]), v = q(() => {
		if (c) return e.menuFilters.find((e) => e.type === "group" && e.paramName === c)?.label;
	}, [e.menuFilters, c]);
	return {
		displayedFilters: _,
		searchInput: h,
		selectedFilter: {
			filter: i,
			label: q(() => {
				if (!i) return;
				if (c) {
					let t = e.menuFilters.find((e) => e.type === "group" && e.paramName === c);
					if (t?.type === "group") {
						let e = t.subFilters.find((e) => e.paramName === i.paramName);
						if (e) return e.label;
					}
				}
				let t = e.menuFilters.find((e) => e.type !== "group" && e.paramName === i.paramName);
				return t ? t.label : e.menuFilters.flatMap((e) => e.type === "group" ? e.subFilters : []).find((e) => e.paramName === i.paramName)?.label;
			}, [
				e.menuFilters,
				i,
				c
			]),
			previouslySelectedParamName: o,
			onSelect: ({ paramName: e, type: t }) => {
				a({
					paramName: e,
					type: t
				}), s(e);
			},
			onClear: () => {
				a(void 0);
			}
		},
		selectedGroup: {
			label: v,
			onSelect: (e) => {
				l(e), g();
			},
			onClear: () => {
				l(void 0), g();
			}
		},
		ui: {
			isAddFilterButtonVisible: t.canDisplayAddFiltersMenu(),
			isAddFilterButtonEnabled: t.canChangeFilters(),
			useSmallAddFilterButton: t.useSmallAddFilterButton(),
			menuWidth: n.addFilterMenuWidth,
			reset: () => {
				g(), r.setAddFilterMenuWidth(kT.ui.addFilterMenuWidth), a(void 0), l(void 0), s(void 0);
			}
		}
	};
}, OE = ({ hook: { searchInput: e, displayedFilters: t, selectedFilter: n, selectedGroup: r } }) => {
	let i = !!r.label, a = !i && !!n.previouslySelectedParamName, { ref: o, onKeyDown: s } = KT({ initialFocus: !a }), c = J(null);
	return K(() => {
		if (!i) return;
		let e = c.current;
		e && setTimeout(() => {
			let t = e.closest("[role=\"menu\"]")?.querySelectorAll("[role=\"menuitem\"]");
			!t || t.length === 0 || (t[1] ?? t[0]).focus();
		}, 0);
	}, [i, r.label]), K(() => {
		if (!a) return;
		let e = n.previouslySelectedParamName;
		if (!e) return;
		let t = setTimeout(() => {
			((o.current?.closest("[role=\"menu\"]"))?.querySelector(`[data-testid="magicTable.filter.add.${CSS.escape(e)}"]`))?.focus();
		}, 0);
		return () => clearTimeout(t);
	}, [
		a,
		n.previouslySelectedParamName,
		o
	]), /* @__PURE__ */ W(H, { children: [
		i && /* @__PURE__ */ W(R, {
			position: "sticky",
			top: "0",
			zIndex: "1",
			background: "#ffffff",
			children: [/* @__PURE__ */ U(si, {
				ref: c,
				"data-testid": "magicTable.filter.group.back",
				icon: /* @__PURE__ */ U(Kp, { color: "inherit" }),
				iconSpacing: "8px",
				onClick: r.onClear,
				closeOnSelect: !1,
				mt: "4px",
				paddingY: "6px",
				color: "#475569",
				children: /* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					children: r.label
				})
			}), /* @__PURE__ */ U(oi, {
				margin: "0",
				borderColor: "#e2e8f0"
			})]
		}),
		!i && /* @__PURE__ */ U(Q_, {
			ref: o,
			value: e.value,
			onChange: e.onChange,
			onKeyDown: s,
			placeholder: "Search filters",
			showDivider: t.length > 0,
			disableFocusLock: !0,
			"data-testid": "magicTable.filter.search"
		}),
		t.length > 0 && /* @__PURE__ */ U(R, { height: "4px" }),
		t.map(({ label: e, icon: t, paramName: i, type: a }) => a === "group" ? /* @__PURE__ */ U(si, {
			"data-testid": `magicTable.filter.group.${i}`,
			icon: t,
			iconSpacing: "8px",
			onClick: () => r.onSelect(i),
			closeOnSelect: !1,
			children: /* @__PURE__ */ W(B, {
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				children: [/* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					children: e
				}), /* @__PURE__ */ U(qp, { color: "inherit" })]
			})
		}, i) : /* @__PURE__ */ U(si, {
			"data-testid": `magicTable.filter.add.${i}`,
			icon: t,
			iconSpacing: "8px",
			onClick: () => n.onSelect({
				paramName: i,
				type: a
			}),
			children: e
		}, i))
	] });
}, kE = (e) => {
	if (e.key !== "ArrowDown") return;
	let t = e.currentTarget.closest("[role=\"menu\"]")?.querySelector("input:not([type=\"checkbox\"])");
	t && (e.preventDefault(), e.stopPropagation(), t.focus());
}, AE = (e) => {
	let t = J(null);
	return K(() => {
		if (!e) return;
		let n = t.current;
		if (!n) return;
		let r = (e) => {
			n.dataset.inputMode = e;
		}, i = (e) => {
			let t = e.key;
			(t === "Tab" || t.startsWith("Arrow")) && r("keyboard");
		}, a = () => r("mouse");
		document.addEventListener("keydown", i, !0), document.addEventListener("mousemove", a, !0);
		let o = (e) => {
			let t = e;
			if (t.key !== "ArrowUp" && t.key !== "ArrowDown") return;
			let r = t.target;
			if (!r || r.getAttribute("role") !== "menuitem") return;
			let i = n.querySelector("input:not([type=\"checkbox\"])");
			if (!i) return;
			let a = Array.from(n.querySelectorAll("[role=\"menuitem\"]")), o = (e) => !!e.dataset.testid?.endsWith(".back"), s = a.findIndex((e) => !o(e)), c = a.indexOf(r);
			if (t.key === "ArrowUp" && c === s) {
				t.preventDefault(), t.stopPropagation(), i.focus();
				return;
			}
			t.key === "ArrowDown" && c === a.length - 1 && (t.preventDefault(), t.stopPropagation(), i.focus());
		}, s = (e) => {
			let t = e.target;
			!t || t.getAttribute("role") !== "menuitem" || t.scrollIntoView({ block: "nearest" });
		};
		return n.addEventListener("keydown", o, !0), n.addEventListener("focusin", s), () => {
			document.removeEventListener("keydown", i, !0), document.removeEventListener("mousemove", a, !0), n.removeEventListener("keydown", o, !0), n.removeEventListener("focusin", s);
		};
	}, [e]), t;
}, jE = () => {
	let e = qc().replace(/:/g, ""), { functions: t } = UT(), { isOpen: n, onOpen: r, onClose: i } = Kc(), a = DE(), o = AE(n), { selectedFilter: s, ui: c } = a, l = J(null), u = G(() => {
		l.current &&= (clearTimeout(l.current), null), t.tidyEmptyFilters(), c.reset();
	}, [t, c]), d = G(() => {
		i(), l.current && clearTimeout(l.current), l.current = setTimeout(() => {
			l.current = null, t.tidyEmptyFilters(), c.reset();
		}, 150);
	}, [
		t,
		i,
		c
	]), f = G(() => {
		l.current && u(), r();
	}, [r, u]);
	return K(() => {
		n ? Oc(e) : Gc(e);
	}, [n, c.menuWidth]), K(() => () => {
		l.current && clearTimeout(l.current);
	}, []), c.isAddFilterButtonVisible ? /* @__PURE__ */ W(ii, {
		id: e,
		variant: "component-library",
		isOpen: n,
		closeOnSelect: !1,
		offset: [0, 4],
		onOpen: f,
		onClose: d,
		autoSelect: !1,
		isLazy: !0,
		children: [/* @__PURE__ */ U(EE, {
			useSmallVersion: c.useSmallAddFilterButton,
			isDisabled: !c.isAddFilterButtonEnabled
		}), /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(ci, {
			width: c.menuWidth,
			padding: "0 !important",
			overflow: "hidden",
			background: I,
			children: /* @__PURE__ */ U(R, {
				ref: o,
				maxHeight: "516px",
				overflowY: "auto",
				overflowX: "hidden",
				overscrollBehavior: "none",
				px: "4px",
				sx: { "&[data-input-mode=\"keyboard\"] [role=\"menuitem\"]:not(:focus):hover": { backgroundColor: "transparent" } },
				children: s.filter === void 0 ? /* @__PURE__ */ U(OE, { hook: a }) : /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ W(R, {
					position: "sticky",
					top: "0",
					zIndex: "2",
					background: I,
					paddingTop: "4px",
					height: "36px",
					children: [
						/* @__PURE__ */ U(si, {
							"data-testid": "magicTable.filter.selected.back",
							icon: /* @__PURE__ */ U(Kp, { color: "inherit" }),
							iconSpacing: "8px",
							onClick: s.onClear,
							closeOnSelect: !1,
							marginTop: "0",
							marginBottom: "0",
							paddingY: "6px",
							height: "27px",
							color: F,
							onKeyDown: kE,
							children: /* @__PURE__ */ U(V, {
								...N,
								color: "inherit",
								children: s.label ?? "Filters"
							})
						}),
						/* @__PURE__ */ U(R, { height: "4px" }),
						/* @__PURE__ */ U(oi, {
							marginTop: "0",
							marginBottom: "0",
							borderColor: P
						})
					]
				}), /* @__PURE__ */ U(yE, {
					...s.filter,
					menuOnClose: d,
					stickyTop: "36px"
				})] })
			})
		}) })]
	}) : null;
};
//#endregion
//#region src/components/tables/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/CopyTableResults.tsx
function ME(e) {
	return e == null ? "" : e instanceof Date ? e.toISOString() : typeof e == "object" ? JSON.stringify(e) : String(e);
}
function NE({ table: e, isEnabled: t = !0 }) {
	let { displayNotification: n } = jx();
	return /* @__PURE__ */ U(si, {
		onClick: async () => {
			try {
				let t = e.getAllColumns().filter((e) => !RT.includes(e.id) && e.getIsVisible() && !e.id.startsWith("eventProperty_") && !e.id.includes("eventProperties")), r = e.getRowModel().rows.some((e) => e.original.eventProperties), i = [r ? [...t.map((e) => e.columnDef.header?.toString() || ""), "Event Properties"] : t.map((e) => e.columnDef.header?.toString() || ""), ...e.getRowModel().rows.map((e) => {
					let n = t.map((t) => ME(e.getValue(t.id)));
					if (!r) return n;
					let i = ME(e.original.eventProperties);
					return [...n, i];
				})].map((e) => e.join("	")).join("\n");
				await navigator.clipboard.writeText(i), n("Table copied to clipboard", {
					description: "You can now paste it into a spreadsheet",
					type: "success",
					duration: 3e3
				});
			} catch {
				n("Failed to copy table", {
					description: "Please try again",
					type: "error",
					duration: 3e3
				});
			}
		},
		isDisabled: !t,
		icon: /* @__PURE__ */ U(Oh, { color: "inherit" }),
		children: /* @__PURE__ */ U(V, {
			...N,
			color: "inherit",
			children: "Copy results"
		})
	});
}
//#endregion
//#region src/components/tables/components/MagicTable/utils/useMultiSelectAsync.ts
var PE = ({ paramName: e, label: t, icon: n, disabled: r = !1, debounceMs: i = 300, cachedOptions: a = [], searchFetcher: o, entityFetcher: s, optionsSortFn: c, optionDisabledFn: l, activeFilterValues: u = [] }) => {
	let [d, f] = Y([]), [p, m] = Y(!1);
	K(() => {
		if (u.length === 0 || p) {
			m(!0);
			return;
		}
		let e = u.filter((e) => !a.some((t) => t.value === e));
		if (e.length === 0) {
			m(!0);
			return;
		}
		(async () => {
			let t = e.map(async (e) => {
				try {
					return await s(e);
				} catch (t) {
					return console.warn(`Failed to rehydrate option for ID ${e}:`, t), null;
				}
			}), n = (await Promise.all(t)).filter((e) => e !== null);
			f(n), m(!0);
		})();
	}, [
		u,
		a,
		s,
		p
	]);
	let h = q(() => async (e) => {
		let t = [];
		if (!e && a.length > 0) t = a;
		else try {
			t = await o(e);
		} catch (e) {
			console.error("Search fetch failed:", e), t = [];
		}
		let n = [...t];
		return d.forEach((e) => {
			n.some((t) => t.value === e.value) || n.push(e);
		}), n;
	}, [
		a,
		o,
		d
	]);
	return q(() => ({
		type: "multiSelectAsync",
		paramName: e,
		label: t,
		icon: n,
		disabled: r,
		debounceMs: i,
		fetcher: h,
		mapToOption: (e) => e,
		optionsSortFn: c,
		optionDisabledFn: l ? (e, t) => l(t) : void 0
	}), [
		e,
		t,
		n,
		r,
		i,
		h,
		c,
		l
	]);
}, FE = (e) => {
	let t = e.getState(), n = e.getAllFlatColumns(), r = n.map((e) => e.id).filter((e) => !RT.includes(e));
	return {
		allColumns: n,
		allColumnIds: r,
		allVisibleColumnIds: r.filter((e) => t.columnVisibility[e] === void 0 || t.columnVisibility[e] !== void 0 && !!t.columnVisibility[e]),
		allInvisibleColumnIds: r.filter((e) => t.columnVisibility[e] !== void 0 && !t.columnVisibility[e])
	};
}, IE = (e, t) => e.find((e) => e.id === t), LE = (e, t, n) => (typeof e != "string" || typeof t != "string" || n.splice(n.indexOf(t), 0, n.splice(n.indexOf(e), 1)[0]), [...n]), RE = (e) => {
	let t = e;
	for (; t;) {
		if (t.dataset && t.dataset.noDnd) return !1;
		t = t.parentElement;
	}
	return !0;
}, zE = ({ columns: e, containerWidth: t = 0, showCheckboxes: n, showExpandButtons: r, showAddColumn: i }) => {
	let a = r ? 52 : 0, o = (t - (n ? r ? 40 : 52 : 0) - a - (i ? 40 : 0) - 40) / e.length;
	return e.map((e) => ({ [e.id || ""]: o })).reduce((e, t) => ({
		...e,
		...t
	}), {});
}, BE = (e) => e.endsWith(".0"), VE = (e) => e.includes("."), HE = (e) => "columnVisibility" in e, UE = () => {
	let { data: e, functions: t, ui: n, queries: r } = UT(), i = t.getTableState(), a = t.getTableAllFlatColumns(), o = q(() => {
		if (!HE(i)) return [];
		let t = Object.entries(i.columnVisibility).filter(([, e]) => e).filter(([e]) => !RT.includes(e)).reduce((e, [t]) => {
			let n = IE(a, t);
			return n ? [...e, {
				id: t,
				label: n.columnDef.header?.toString() || ""
			}] : [...e];
		}, []), n = e.customColumns.selected.map((e) => ({
			id: `${zT}${e}`,
			label: e
		})), r = [...t, ...n];
		return e.columnOrder.map((e) => r.find(({ id: t }) => t === e)).filter(Boolean);
	}, [
		e.columnOrder,
		e.customColumns,
		a,
		i
	]), s = q(() => {
		let t = o.map(({ id: e }) => e), n = a.filter((e) => !t.includes(e.id) && !RT.includes(e.id) && !e.id.startsWith("eventProperty_")).reduce((e, t) => [...e, {
			id: t.id,
			label: t.columnDef.header?.toString() || ""
		}], []);
		if (!e.customColumns.inlineInAddColumnMenu) return n;
		let r = e.customColumns.available.filter((t) => !e.customColumns.selected.includes(t)).map((e) => ({
			id: `${zT}${e}`,
			label: e
		}));
		return [...n, ...r];
	}, [
		o,
		a,
		e.customColumns.inlineInAddColumnMenu,
		e.customColumns.available,
		e.customColumns.selected
	]), c = G((n) => {
		if (n.startsWith("eventProperty_")) {
			let r = n.replace(zT, "");
			e.customColumns.selected.includes(r) ? t.removeCustomColumn(n) : t.addCustomColumn(r);
			return;
		}
		let r = IE(a, n);
		r && r.toggleVisibility();
	}, [
		e.customColumns.selected,
		t,
		a
	]), l = q(() => s.length > 0 || r.canAddCustomColumns(), [s.length, r]), u = G(({ active: n, over: r }) => {
		r && t.setColumnOrder(LE(n.id, r.id, e.columnOrder));
	}, [e.columnOrder, t]), d = q(() => e.viewSettingsFilters.map((n) => {
		let r = e.activeFilters.find((e) => e.paramName === n.paramName), i = !r || r && r.type != "toggle" ? !1 : r.value;
		return {
			paramName: n.paramName,
			label: n.label,
			isChecked: i,
			onChange: () => {
				t.switchToggleOption({
					paramName: n.paramName,
					value: !i
				});
			}
		};
	}), [
		e.activeFilters,
		e.viewSettingsFilters,
		t
	]), f = q(() => d.length > 0, [d.length]), [p, m] = Y(!1), h = q(() => o.length > 1, [o]);
	return {
		toggles: d,
		grouping: {
			enabled: !Iu(e.grouping?.groupableColumns),
			options: [{
				label: "No grouping",
				value: ""
			}, ...e.grouping?.groupableColumns?.map((e) => ({
				label: a.find((t) => t.id === e)?.columnDef.header?.toString() || "",
				value: e
			})) || []],
			onChange: (t) => {
				e.grouping?.onGroupBy?.(t);
			},
			value: e.grouping?.groupBy || ""
		},
		columns: {
			visible: o,
			invisible: s,
			canRemoveColumns: h
		},
		actions: {
			onColumnToggleVisibility: c,
			onColumnDragEnd: u
		},
		ui: {
			buttonEnabled: r.canChangeFilters(),
			viewSettingsHeader: n.viewSettingsHeader,
			showViewSettingsHeaderDivider: !!n.viewSettingsHeader,
			showTogglesDivider: f,
			showVisibleInvisibleDivider: l,
			reset: () => {
				m(!1);
			}
		},
		customColumns: {
			enabled: r.canAddCustomColumns(),
			onToggleMenu: () => {
				m(!0);
			},
			onCloseSubMenu: () => {
				m(!1);
			},
			showMenu: p,
			label: e.customColumns.menuLabel ?? "Event property",
			inlineInAddColumnMenu: !!e.customColumns.inlineInAddColumnMenu
		}
	};
}, WE = ({ id: e, label: t, type: n, onColumnToggleVisibility: r, canToggleColumnVisibility: i, enableColumnReordering: a }) => {
	let { attributes: o, listeners: s, setNodeRef: c, transform: l, transition: u } = Pu({ id: e });
	return /* @__PURE__ */ U(si, {
		as: R,
		"data-testid": `magicTable.viewSettings.column.${e}`,
		onClick: () => {
			n === "invisible" && r(e);
		},
		_active: n === "visible" ? {} : void 0,
		ref: c,
		style: {
			transform: Lu.Transform.toString(l),
			transition: u
		},
		children: /* @__PURE__ */ W(B, {
			width: "100%",
			gap: "8px",
			children: [
				n === "visible" && a && /* @__PURE__ */ U(z, {
					...s,
					...o,
					cursor: "move",
					children: /* @__PURE__ */ U(fm, { color: "#94a3b8" })
				}),
				/* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					flex: "1",
					overflow: "hidden",
					display: "-webkit-box",
					sx: {
						WebkitBoxOrient: "vertical",
						WebkitLineClamp: 1,
						lineBreak: "anywhere"
					},
					children: t
				}),
				/* @__PURE__ */ W(Or, {
					variant: "unstyled",
					minWidth: "initial",
					height: "initial",
					borderRadius: "0px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					onClick: () => {
						n === "visible" && i && r(e);
					},
					children: [n === "visible" && i && /* @__PURE__ */ U(tm, { color: "inherit" }), n === "invisible" && /* @__PURE__ */ U(nm, { color: "inherit" })]
				})
			]
		})
	});
}, GE = () => {
	let { data: e, functions: t } = UT(), { results: n, input: r } = PC({
		items: q(() => e.customColumns.available.filter((t) => !e.customColumns.selected.includes(t)).map((e) => ({
			label: e,
			value: e
		})), [e.customColumns]),
		searchOn: "label"
	});
	return {
		options: n,
		onSelectOption: G((e) => {
			t.addCustomColumn(e);
		}, [t]),
		searchInput: {
			...r,
			placeholder: e.customColumns.searchPlaceholder ?? e.customColumns.menuLabel ?? "Event property"
		}
	};
}, KE = ({ onBack: e, backLabel: t } = {}) => {
	let { options: n, onSelectOption: r } = GE(), i = J(null);
	return K(() => {
		let t = i.current;
		t && setTimeout(() => {
			let n = t.querySelectorAll("[role=\"menuitem\"]");
			!n || n.length === 0 || (n[+!!e] ?? n[0])?.focus();
		}, 0);
	}, [e]), /* @__PURE__ */ W(ci, {
		ref: i,
		width: "216px",
		maxHeight: "516px",
		overflowY: "auto",
		overflowX: "hidden",
		paddingTop: "0px !important",
		paddingBottom: "0px !important",
		children: [e && /* @__PURE__ */ U(R, {
			position: "sticky",
			top: "0",
			zIndex: "1",
			background: "#ffffff",
			children: /* @__PURE__ */ U(si, {
				"data-testid": "magicTable.viewSettings.customColumns.back",
				onClick: e,
				closeOnSelect: !1,
				mt: "4px",
				paddingY: "6px",
				color: "#475569",
				children: /* @__PURE__ */ W(B, {
					alignItems: "center",
					justifyContent: "space-between",
					width: "100%",
					children: [/* @__PURE__ */ U(V, {
						...N,
						color: "inherit",
						children: t ?? "Back"
					}), /* @__PURE__ */ U(qp, { color: "inherit" })]
				})
			})
		}), n.map(({ label: e, value: t }) => /* @__PURE__ */ U(si, {
			onClick: () => {
				setTimeout(() => {
					r(t);
				}, 1);
			},
			closeOnSelect: !0,
			children: /* @__PURE__ */ W(B, {
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				children: [/* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					children: e
				}), /* @__PURE__ */ U(nm, { color: "inherit" })]
			})
		}, t))]
	});
}, qE = ({ enableColumnReordering: e, table: t, enableCopyResults: n = !1 }) => {
	let { toggles: r, columns: i, actions: a, ui: o, customColumns: s, grouping: c } = UE(), l = ju(Au(Ou, {})), u = /* @__PURE__ */ W(ci, {
		width: "250px",
		children: [
			o.viewSettingsHeader,
			o.showViewSettingsHeaderDivider && /* @__PURE__ */ U(oi, {}),
			n && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(NE, { table: t }), /* @__PURE__ */ U(oi, {})] }),
			c.enabled && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ W(B, {
				p: "8px",
				gap: "8px",
				justifyContent: "space-between",
				alignItems: "center",
				alignContent: "center",
				flexDirection: "row",
				children: [/* @__PURE__ */ U(Wr, { children: /* @__PURE__ */ U(V, {
					...j,
					color: "#334155",
					children: "Grouping"
				}) }), /* @__PURE__ */ U(zv, {
					options: c.options,
					onChange: c.onChange,
					initialValue: c.value,
					placeholder: "No grouping"
				})]
			}), /* @__PURE__ */ U(oi, {})] }),
			r.map(({ paramName: e, label: t, isChecked: n, onChange: r }) => /* @__PURE__ */ W(B, {
				p: "8px",
				gap: "8px",
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ U(Wr, {
					htmlFor: `switch-${e}`,
					children: /* @__PURE__ */ U(V, {
						...j,
						color: L,
						children: t
					})
				}), /* @__PURE__ */ U(ay, {
					id: `switch-${e}`,
					"data-testid": `magicTable.viewSettings.toggle.${e}`,
					isChecked: n,
					onChange: r
				})]
			}, e)),
			o.showTogglesDivider && /* @__PURE__ */ U(oi, {}),
			e ? /* @__PURE__ */ U(Du, {
				sensors: l,
				collisionDetection: ku,
				onDragEnd: a.onColumnDragEnd,
				children: /* @__PURE__ */ U(Mu, {
					items: i.visible,
					strategy: Fu,
					children: i.visible.map((t) => /* @__PURE__ */ U(WE, {
						type: "visible",
						onColumnToggleVisibility: a.onColumnToggleVisibility,
						canToggleColumnVisibility: i.canRemoveColumns,
						enableColumnReordering: e,
						...t
					}, t.id))
				})
			}) : i.visible.map((t) => /* @__PURE__ */ U(WE, {
				type: "visible",
				onColumnToggleVisibility: a.onColumnToggleVisibility,
				canToggleColumnVisibility: i.canRemoveColumns,
				enableColumnReordering: e,
				...t
			}, t.id)),
			o.showVisibleInvisibleDivider && /* @__PURE__ */ U(oi, {}),
			i.invisible.map((e) => /* @__PURE__ */ U(WE, {
				type: "invisible",
				onColumnToggleVisibility: a.onColumnToggleVisibility,
				canToggleColumnVisibility: !0,
				...e
			}, e.id)),
			s.enabled && !s.inlineInAddColumnMenu && /* @__PURE__ */ U(si, {
				onClick: s.onToggleMenu,
				closeOnSelect: !1,
				icon: /* @__PURE__ */ U(Kp, { color: "inherit" }),
				iconSpacing: "8px",
				children: /* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					children: s.label
				})
			})
		]
	});
	return /* @__PURE__ */ W(ii, {
		variant: "component-library",
		closeOnSelect: !1,
		offset: [0, 4],
		onClose: () => {
			setTimeout(() => {
				o.reset();
			}, 150);
		},
		isLazy: !0,
		children: [/* @__PURE__ */ U(ai, {
			as: Or,
			leftIcon: /* @__PURE__ */ U(xh, { color: "inherit" }),
			iconSpacing: "4px",
			variant: "component-library-secondary",
			isDisabled: !o.buttonEnabled,
			"data-testid": "magicTable.viewSettings",
			"data-keyboard-shortcut-target": "magicTable.viewSettings",
			children: "View settings"
		}), /* @__PURE__ */ U(Si, { children: s.showMenu ? /* @__PURE__ */ U(KE, {
			onBack: s.onCloseSubMenu,
			backLabel: s.label
		}) : u })]
	});
}, JE = () => {
	let { queries: e, functions: t } = UT(), { visible: n, enabled: r } = e.canClearAllFilters();
	return n ? /* @__PURE__ */ U(Q, {
		variant: "ghost",
		onClick: () => {
			t.clearAllFilters();
		},
		disabled: !r,
		children: "Clear"
	}) : null;
}, YE = ({ onSaveFilters: e, onUpdateSavedFilters: t }) => {
	let { queries: n } = UT(), { visible: r, enabled: i } = n.canSaveFilter();
	return r ? t ? /* @__PURE__ */ U(Xb, {
		width: 195,
		alignment: "bottom-right",
		items: [{
			label: "Save to this view",
			onClick: () => {
				t();
			}
		}, ...e ? [{
			label: "Create new view...",
			onClick: () => {
				e();
			}
		}] : []],
		menuButton: /* @__PURE__ */ U(Q, {
			variant: "secondary",
			trailingIcon: /* @__PURE__ */ U(Hp, {}),
			disabled: !i,
			children: "Save filter"
		})
	}) : /* @__PURE__ */ U(Q, {
		variant: "secondary",
		onClick: e,
		disabled: !i,
		children: "Save filter"
	}) : null;
}, XE = ({ onSaveFilters: e, onUpdateSavedFilters: t }) => {
	let { data: n } = UT();
	return /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(JE, {}),
		/* @__PURE__ */ U(YE, {
			onSaveFilters: e,
			onUpdateSavedFilters: t
		}),
		n.activeFilters.length > 0 && /* @__PURE__ */ U(z, {
			height: "24px",
			px: 1,
			children: /* @__PURE__ */ U(Rr, {
				orientation: "vertical",
				color: "#e2e8f0"
			})
		})
	] });
}, ZE = (e) => /* @__PURE__ */ U(HT, {
	...e,
	children: /* @__PURE__ */ W(B, {
		borderBottom: `${P} 1px solid`,
		px: "8px",
		py: "8px",
		width: "100%",
		gap: "8px",
		direction: {
			base: "column",
			md: "row"
		},
		justifyContent: "space-between",
		alignItems: {
			base: "stretch",
			md: "start"
		},
		children: [e.additionalToolbarComponentsV3?.start && /* @__PURE__ */ U(R, {
			width: {
				base: "100%",
				md: "auto"
			},
			flexShrink: 0,
			sx: { "& > *, & [role=\"group\"], & [role=\"radiogroup\"]": { width: {
				base: "100%",
				md: "auto"
			} } },
			children: e.additionalToolbarComponentsV3.start
		}), /* @__PURE__ */ W(B, {
			gap: "8px",
			width: {
				base: "100%",
				md: "auto"
			},
			flex: { md: 1 },
			justifyContent: "space-between",
			alignItems: {
				base: "center",
				md: "start"
			},
			children: [/* @__PURE__ */ W(B, {
				gap: "8px",
				flexWrap: "wrap",
				children: [/* @__PURE__ */ U(TE, {}), /* @__PURE__ */ U(jE, {})]
			}), /* @__PURE__ */ W(B, {
				gap: "8px",
				alignItems: "center",
				children: [
					/* @__PURE__ */ U(XE, {
						onSaveFilters: e.onSaveFilters,
						onUpdateSavedFilters: e.onUpdateSavedFilters
					}),
					e.additionalToolbarComponentsV3?.end && e.additionalToolbarComponentsV3.end,
					/* @__PURE__ */ U(qE, {
						enableColumnReordering: e.enableColumnReordering,
						table: e.table,
						enableCopyResults: e.enableCopyResults
					})
				]
			})]
		})]
	})
}), QE = (e) => {
	let [t, n] = Y(!1), r = e.getTableState(), i = e.getTableAllFlatColumns(), a = q(() => {
		let e = Object.entries(r.columnVisibility).filter(([, e]) => e).filter(([e]) => !RT.includes(e)).map(([e]) => e);
		return i.filter((t) => !e.includes(t.id) && !RT.includes(t.id) && !t.id.startsWith("eventProperty_"));
	}, [i, r.columnVisibility]), o = q(() => {
		let t = a.reduce((e, t) => [...e, {
			id: t.id,
			label: t.columnDef.header?.toString() || "",
			onClick: () => {
				t.toggleVisibility();
			},
			closeOnSelect: !0
		}], []);
		if (!(e.customColumns.isEnabled && e.customColumns.available.length !== e.customColumns.selected.length)) return t;
		if (e.customColumns.inlineInAddColumnMenu) {
			let n = e.customColumns.available.filter((t) => !e.customColumns.selected.includes(t)).map((t) => ({
				id: t,
				label: t,
				onClick: () => {
					e.customColumns.setSelected([...e.customColumns.selected, t]);
				},
				closeOnSelect: !0
			}));
			return [...t, ...n];
		}
		return [...t, {
			id: "custom-columns",
			label: e.customColumns.menuLabel ?? "Event property",
			onClick: () => {
				n(!0);
			},
			closeOnSelect: !1,
			hasSubMenu: !0
		}];
	}, [
		a,
		e.customColumns.available,
		e.customColumns.inlineInAddColumnMenu,
		e.customColumns.isEnabled,
		e.customColumns.menuLabel,
		e.customColumns.selected,
		e.customColumns.setSelected
	]), s = q(() => {
		let t = e.customColumns.isEnabled && e.customColumns.available.length !== e.customColumns.selected.length;
		return a.length === 0 && !t;
	}, [
		a.length,
		e.customColumns.available.length,
		e.customColumns.isEnabled,
		e.customColumns.selected.length
	]), { results: c, input: l } = dE({
		items: q(() => e.customColumns.available.filter((t) => !e.customColumns.selected.includes(t)).map((t) => ({
			id: t,
			label: t,
			onClick: () => {
				e.customColumns.setSelected([...e.customColumns.selected, t]);
			},
			closeOnSelect: !0
		})), [e.customColumns]),
		searchOn: "label"
	});
	return {
		menuItems: o,
		button: { disabled: s },
		customColumns: {
			showMenu: t,
			menuItems: c,
			searchInput: l
		},
		ui: { reset: () => {
			n(!1);
		} }
	};
}, $E = 216, eD = ({ customColumns: e, getTableState: t, getTableAllFlatColumns: n }) => {
	let { menuItems: r, button: i, customColumns: a, ui: o } = QE({
		getTableState: t,
		getTableAllFlatColumns: n,
		customColumns: e
	}), [s, c] = Y("right"), l = G((e) => {
		if (!e) return;
		let t = e.getBoundingClientRect(), n = window.innerWidth - t.right;
		c(n >= $E ? "right" : "left");
	}, []), u = s === "right" ? qp : Kp, d = /* @__PURE__ */ U(ci, {
		ref: l,
		children: r.map(({ id: e, label: t, onClick: n, closeOnSelect: r, hasSubMenu: i }) => /* @__PURE__ */ U(si, {
			onClick: n,
			closeOnSelect: r,
			children: i ? /* @__PURE__ */ W(B, {
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				children: [/* @__PURE__ */ U(V, {
					...N,
					color: "inherit",
					children: t
				}), /* @__PURE__ */ U(u, { color: "inherit" })]
			}) : t
		}, e))
	}), f = /* @__PURE__ */ W(ci, {
		maxHeight: "516px",
		overflowY: "scroll",
		paddingTop: "0px !important",
		children: [
			/* @__PURE__ */ U(Q_, {
				value: a.searchInput.value,
				onChange: a.searchInput.onChange,
				placeholder: e.searchPlaceholder ?? e.menuLabel ?? "Event property",
				showDivider: a.menuItems.length > 0
			}),
			a.menuItems.length > 0 && /* @__PURE__ */ U(R, { height: "4px" }),
			a.menuItems.map(({ id: e, label: t, onClick: n, closeOnSelect: r }) => /* @__PURE__ */ U(si, {
				onClick: n,
				closeOnSelect: r,
				children: t
			}, e))
		]
	});
	return /* @__PURE__ */ U(z, {
		height: "100%",
		children: /* @__PURE__ */ W(ii, {
			variant: "component-library",
			closeOnSelect: !1,
			offset: [0, 4],
			onClose: () => {
				setTimeout(() => {
					o.reset();
				}, 150);
			},
			isLazy: !0,
			children: [/* @__PURE__ */ U(ai, {
				as: Zr,
				variant: "component-library-secondary",
				icon: /* @__PURE__ */ U(dh, { color: "inherit" }),
				minWidth: "initial",
				width: "24px",
				height: "24px",
				padding: "4px",
				borderRadius: "6px",
				isDisabled: i.disabled,
				"data-testid": "magicTable.addColumn",
				"data-keyboard-shortcut-target": "magicTable.addColumn"
			}), /* @__PURE__ */ U(Si, { children: a.showMenu ? f : d })]
		})
	});
}, tD = class extends Ou {
	static activators = [{
		eventName: "onPointerDown",
		handler: ({ nativeEvent: e }) => RE(e.target)
	}];
}, nD = ({ header: e, isSpecialColumn: t, isSorting: n, setIsColumnsResizing: r }) => {
	if (t || n) return null;
	let i = e.getResizeHandler();
	return /* @__PURE__ */ U(R, {
		"data-no-dnd": "true",
		userSelect: "none",
		position: "absolute",
		top: "0",
		height: "100%",
		width: "16px",
		right: `-${16 / 2}px`,
		cursor: "col-resize",
		zIndex: "2",
		opacity: e.column.getIsResizing() ? "1" : "0",
		_hover: { opacity: "1" },
		onMouseDown: (e) => {
			i(e), r(!0);
		},
		onMouseUp: () => {
			r(!1);
		},
		children: /* @__PURE__ */ U(R, {
			position: "absolute",
			left: "50%",
			transform: "translateX(-50%)",
			top: "0",
			height: "100%",
			width: "2px",
			background: C
		})
	});
}, rD = ({ header: e, column: t, isSpecialColumn: n, isSorting: r, activeId: i, isColumnsResizing: a, setIsColumnsResizing: o, onMenuOpen: s, enableColumnReordering: c, showPaddingLeft: l }) => {
	let { attributes: u, listeners: d, setNodeRef: f, transform: p, transition: m } = Pu({
		id: e.id,
		disabled: !c || n
	}), h = e.id === LT, g = t?.columnDef.meta?.textAlign, _ = n ? { style: { width: e.getSize() } } : {
		ref: f,
		style: {
			transform: Lu.Translate.toString(p),
			transition: m,
			width: e.getSize()
		},
		...u,
		...d
	};
	return /* @__PURE__ */ W(R, {
		padding: n ? "0px" : "12px",
		paddingLeft: l ? "24px" : void 0,
		position: "relative",
		borderLeft: h ? "1px" : "0px",
		borderColor: P,
		..._,
		onMouseUp: () => {
			e.column.getIsResizing() || r || n || s();
		},
		zIndex: i === e.id ? "1" : void 0,
		children: [e.isPlaceholder ? null : n ? CT(e.column.columnDef.header, e.getContext()) : /* @__PURE__ */ U(hi, { children: /* @__PURE__ */ W(R, {
			"data-testid": `magicTable.header.${e.id}.content`,
			children: [/* @__PURE__ */ U(V, {
				color: k,
				overflow: "hidden",
				display: "-webkit-box",
				sx: {
					WebkitBoxOrient: "vertical",
					WebkitLineClamp: 1,
					lineBreak: "anywhere"
				},
				textAlign: g,
				position: "relative",
				zIndex: "1",
				pointerEvents: "none",
				...j,
				children: CT(e.column.columnDef.header, e.getContext())
			}), !a && /* @__PURE__ */ U(R, {
				width: "100%",
				height: "100%",
				position: "absolute",
				top: "0",
				right: "0",
				_hover: { background: "#f1f5f9" }
			})]
		}) }), /* @__PURE__ */ U(nD, {
			header: e,
			isSpecialColumn: n,
			isSorting: r,
			setIsColumnsResizing: o
		})]
	});
}, iD = ({ sortBy: e, sortName: t, sortingConfiguration: n }) => t ? !n.appendDirectionToSortKey && e === t ? n.sortingDirections[0] ?? "NONE" : e === `${t}_asc` ? "ASC" : e === `${t}_desc` ? "DESC" : "NONE" : "NONE", aD = 220, oD = ({ table: e, header: t, column: n, columnOrder: r, setColumnOrder: i, isMenuOpen: a, onMenuOpen: o, onMenuClose: s, children: c, setEventPropertyColumns: l, sortBy: u, onChangeSortBy: d, enableColumnReordering: f, onGroupBy: p, isGrouped: m, isGroupable: h }) => {
	let { allColumnIds: g, allVisibleColumnIds: _, allInvisibleColumnIds: v } = FE(e), y = g.length - v.length === 1, b = r.filter((e) => !RT.includes(e)), x = b.filter((e) => _.includes(e)), S = x.indexOf(t.id) !== 0, C = x.indexOf(t.id) !== x.length - 1 && !y, w = !!n?.columnDef.enableSorting, T = n?.columnDef, E = !T || !("sortingConfiguration" in T) ? {} : T.sortingConfiguration, D = {
		availableDirections: ["ASC", "DESC"],
		sortProperty: t.id,
		appendDirectionToSortKey: !0,
		...E
	}, ee = (e) => {
		if (D.sortProperty) {
			if (!D.appendDirectionToSortKey) {
				d(e === "NONE" ? null : D.sortProperty);
				return;
			}
			d(e === "NONE" ? null : `${D.sortProperty}_${e.toLowerCase()}`);
		}
	}, te = iD({
		sortBy: u,
		sortName: D.sortProperty,
		sortingConfiguration: {
			appendDirectionToSortKey: D.appendDirectionToSortKey,
			sortingDirections: D.availableDirections || []
		}
	}), O = (e) => {
		i(LE(t.id, b[b.indexOf(t.id) + e], r));
	}, ne = () => {
		t.id.startsWith("eventProperty_") ? l((e) => e.filter((e) => e !== t.id.replace(zT, ""))) : n?.toggleVisibility();
	}, re = f || w || h;
	return /* @__PURE__ */ W(mi, {
		isOpen: a,
		onOpen: o,
		onClose: s,
		placement: "bottom-start",
		children: [c, /* @__PURE__ */ U(vi, {
			width: "auto",
			background: "transparent",
			border: "none",
			boxShadow: "none",
			borderRadius: "0",
			padding: "0",
			outline: "none",
			_focus: {
				boxShadow: "none",
				outline: "none"
			},
			_focusVisible: {
				boxShadow: "none",
				outline: "none"
			},
			zIndex: "3",
			children: /* @__PURE__ */ W(kb, {
				width: aD,
				"data-testid": `magicTable.header.${t.id}.menu`,
				children: [
					h && /* @__PURE__ */ U(Xb.Item, {
						uuid: "magicTableHeaderMenu.groupBy",
						label: m ? "Ungroup" : "Group by column",
						onClick: () => p?.(),
						setIsOpen: s
					}),
					w && /* @__PURE__ */ W(H, { children: [
						te !== "NONE" && /* @__PURE__ */ U(Xb.Item, {
							uuid: "magicTableHeaderMenu.resetSort",
							label: "Reset sort",
							iconLeft: /* @__PURE__ */ U(im, {}),
							onClick: () => ee("NONE"),
							setIsOpen: s,
							"data-testid": `magicTable.header.${t.id}.menu.resetSort`
						}),
						te !== "ASC" && D.availableDirections?.includes("ASC") && /* @__PURE__ */ U(Xb.Item, {
							uuid: "magicTableHeaderMenu.sortAscending",
							label: "Sort ascending",
							iconLeft: /* @__PURE__ */ U(fp, {}),
							onClick: () => ee("ASC"),
							setIsOpen: s,
							"data-testid": `magicTable.header.${t.id}.menu.sortAscending`
						}),
						te !== "DESC" && D.availableDirections?.includes("DESC") && /* @__PURE__ */ U(Xb.Item, {
							uuid: "magicTableHeaderMenu.sortDescending",
							label: "Sort descending",
							iconLeft: /* @__PURE__ */ U(ip, {}),
							onClick: () => ee("DESC"),
							setIsOpen: s,
							"data-testid": `magicTable.header.${t.id}.menu.sortDescending`
						})
					] }),
					f && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Xb.Item, {
						uuid: "magicTableHeaderMenu.moveLeft",
						label: "Move left",
						iconLeft: /* @__PURE__ */ U(op, {}),
						isDisabled: !S,
						onClick: () => O(-1),
						setIsOpen: s
					}), /* @__PURE__ */ U(Xb.Item, {
						uuid: "magicTableHeaderMenu.moveRight",
						label: "Move right",
						iconLeft: /* @__PURE__ */ U(cp, {}),
						isDisabled: !C,
						onClick: () => O(1),
						setIsOpen: s
					})] }),
					re && /* @__PURE__ */ U(Fb, {}),
					/* @__PURE__ */ U(Xb.Item, {
						uuid: "magicTableHeaderMenu.hideColumn",
						label: "Hide column",
						iconLeft: /* @__PURE__ */ U(xm, {}),
						isDisabled: y,
						onClick: ne,
						setIsOpen: s
					})
				]
			})
		})]
	});
}, sD = ({ header: e, isSorting: t, table: n, columnOrder: r, setColumnOrder: i, isColumnsResizing: a, setIsColumnsResizing: o, activeId: s, setEventPropertyColumns: c, sortBy: l, onChangeSortBy: u, enableColumnReordering: d, onGroupBy: f, isGrouped: p, isGroupable: m, showPaddingLeft: h }) => {
	let g = n.getColumn(e.id), _ = RT.includes(e.id), { isOpen: v, onOpen: y, onClose: b } = Kc(), x = /* @__PURE__ */ U(rD, {
		header: e,
		column: g,
		isSpecialColumn: _,
		isSorting: t,
		activeId: s,
		isColumnsResizing: a,
		setIsColumnsResizing: o,
		onMenuOpen: y,
		enableColumnReordering: d,
		showPaddingLeft: h
	});
	return _ ? x : /* @__PURE__ */ U(oD, {
		table: n,
		header: e,
		column: g,
		columnOrder: r,
		setColumnOrder: i,
		isMenuOpen: v,
		onMenuOpen: y,
		onMenuClose: b,
		setEventPropertyColumns: c,
		sortBy: l,
		onChangeSortBy: u,
		enableColumnReordering: d,
		onGroupBy: f,
		isGrouped: p,
		isGroupable: m,
		children: x
	});
}, cD = ({ table: e, headerGroups: t, setIsSorting: n, isSorting: r, columnOrder: i, setColumnOrder: a, showCheckboxes: o = !1, setEventPropertyColumns: s, showExpandButtons: c = !1, sortBy: l, onChangeSortBy: u, onGroupBy: d, groupBy: f, groupableColumns: p, enableColumnReordering: m }) => {
	let [h, g] = Y(null), _ = ju(Au(tD, { activationConstraint: {
		delay: 100,
		tolerance: 10
	} })), v = (e) => {
		m && (g(e.active.id), n(!0));
	}, y = (e) => {
		if (!m) return;
		let { active: t, over: r } = e;
		if (!r) {
			g(null), n(!1);
			return;
		}
		a(LE(t.id, r.id, i)), g(null), n(!1);
	}, [b, x] = Y(!1);
	K(() => {
		setTimeout(() => {
			x(r);
		}, 1);
	}, [r]);
	let [S, C] = Y(!1), w = !o && !c, T = m ? Du : uc, E = m ? {
		sensors: _,
		collisionDetection: ku,
		onDragStart: v,
		onDragEnd: y
	} : {};
	return /* @__PURE__ */ U(B, {
		role: "rowheader",
		position: "sticky",
		top: "0px",
		background: "#FFF",
		borderBottom: "1px",
		borderColor: P,
		zIndex: "2",
		children: t.map((t) => {
			let n = t.headers;
			return /* @__PURE__ */ U(B, { children: /* @__PURE__ */ U(T, {
				...E,
				children: /* @__PURE__ */ U(Mu, {
					items: n,
					strategy: Nu,
					children: n.map((t, n) => /* @__PURE__ */ U(sD, {
						header: t,
						isSorting: b,
						table: e,
						columnOrder: i,
						setColumnOrder: a,
						isColumnsResizing: S,
						setIsColumnsResizing: C,
						activeId: h,
						setEventPropertyColumns: s,
						sortBy: l,
						onChangeSortBy: u,
						enableColumnReordering: m,
						onGroupBy: () => f === t.id ? d?.(void 0) : d?.(t.id),
						isGroupable: p?.includes(t.id),
						isGrouped: f === t.id,
						showPaddingLeft: w && n === 0
					}, t.id))
				})
			}) }, t.id);
		})
	});
}, lD = (e) => !e || !e.isCollapsed || e.togglableColumn, uD = ({ cell: e, width: t, isOverflowing: n, rowPath: r, cellGroupInfo: i, showPaddingLeft: a }) => {
	let { column: o, row: s } = e, { columnDef: c, id: l } = o, u = l === LT, d = "hasLink" in c && c.hasLink, f = r && !RT.includes(l) && !d, p = i !== void 0, m = i?.togglableColumn, h = i?.toggleCollapsed, g = i?.isCollapsed, _ = i?.isCollapsedSynthetic, v = i?.collapsedVisibleColumns, y = i?.collapsedBorderedColumns, b = _ && (m || v?.includes(l)), x = !p || i?.isFirstInGroup && lD(i) || b, S = p && s.index !== 0 && i.isFirstInGroup, C = _ && y?.includes(l) && !i?.isLastInGroup, w = /* @__PURE__ */ W(B, {
		height: "100%",
		alignItems: "center",
		overflow: "hidden",
		minWidth: 0,
		maxWidth: "100%",
		onClick: (e) => {
			h && (e.stopPropagation(), h());
		},
		children: [/* @__PURE__ */ U(dD, { isCollapsed: g ?? !1 }), /* @__PURE__ */ U(R, {
			overflow: "hidden",
			minWidth: 0,
			flex: 1,
			children: CT(c.cell, e.getContext())
		})]
	}), T = /* @__PURE__ */ W(H, { children: [u && /* @__PURE__ */ U(R, {
		width: "1px",
		height: "100%",
		background: "#e2e8f0"
	}), /* @__PURE__ */ W(R, {
		style: u ? {} : { width: t },
		position: u ? "sticky" : void 0,
		right: u && n ? "20px" : u && !n ? "0px" : void 0,
		transition: u ? "right 150ms" : void 0,
		borderTop: S ? `1px solid ${P}` : void 0,
		borderBottom: C ? `1px solid ${P}` : void 0,
		flexGrow: u ? 1 : void 0,
		paddingLeft: a ? "12px" : "0px",
		children: [x && !m ? CT(c.cell, e.getContext()) : null, m && w]
	})] });
	return f ? /* @__PURE__ */ U(ri, {
		as: Il,
		to: r,
		_hover: { textDecoration: "none" },
		children: T
	}) : T;
}, dD = ({ isCollapsed: e }) => /* @__PURE__ */ U(z, {
	zIndex: 1,
	as: "button",
	height: "100%",
	width: "fit-content",
	children: U(e ? Jp : Up, { fill: k })
}), fD = gc(uD, (e, t) => {
	let n = e.width === t.width, r = e.isSelected === t.isSelected, i = eu(e.value, t.value), a = eu(e.columnOrder, t.columnOrder), o = eu(e.columnVisibility, t.columnVisibility), s = e.isOverflowing === t.isOverflowing, c = e.isExpanded === t.isExpanded, l = e.canExpand === t.canExpand, u = e.rowPath === t.rowPath, d = e.cell === t.cell, f = e.cellGroupInfo?.isFirstInGroup === t.cellGroupInfo?.isFirstInGroup, p = e.cellGroupInfo?.togglableColumn === t.cellGroupInfo?.togglableColumn, m = e.showPaddingLeft === t.showPaddingLeft;
	return n && i && r && a && o && s && c && l && u && d && f && p && m;
}), pD = gc(({ height: e = "24px", width: t = "100%" }) => /* @__PURE__ */ U(Ei, {
	height: e,
	width: t,
	borderRadius: "12px",
	backgroundColor: "#F2F4F7",
	endColor: "gray.20",
	startColor: "gray.0",
	opacity: "unset"
})), mD = ({ index: e, showCheckboxes: t, showExpandButtons: n, column: r, visibleColumns: i }) => {
	let a = hD({
		index: e,
		showCheckboxes: t,
		showExpandButtons: n,
		visibleColsLength: i.length
	});
	return /* @__PURE__ */ U(R, {
		style: { width: r.getSize() },
		padding: "8px 12px",
		borderLeft: r.id === "addColumn" ? "1px" : "0px",
		borderColor: P,
		children: a && /* @__PURE__ */ U(pD, {})
	});
}, hD = ({ index: e, showCheckboxes: t, showExpandButtons: n, visibleColsLength: r }) => !(e === r - 1 || n && t && [0, 1].includes(e) || n !== t && e === 0), gD = (e, t) => e?.[t] ?? {
	togglableColumn: !1,
	isFirstInGroup: !0,
	isLastInGroup: !0,
	isInSameGroupAsNextRow: !1
}, _D = ({ row: e, virtualRow: t, showCheckboxes: n = !1, table: r, columnOrder: i, columnVisibility: a, forceRowBorderBottom: o, rowPath: s, onRowClick: c, isOverflowing: l, showExpandButtons: u = !1, highlightRowGroup: d, isActive: f, disableActiveRowScroll: p = !1 }) => {
	let { pathname: m } = Rl(), h = !!e, g = r.getVisibleFlatColumns(), _ = e ? e.getVisibleCells() : [], v = e ? e.getIsSelected() : !1, y = e && c, b = !n && !u, x = !!e && BE(e.id), S = J(null), C = f || e && s?.(e.original, VE(e.id)) === m;
	K(() => {
		C && !p && S.current?.scrollIntoView({
			behavior: "smooth",
			block: "nearest"
		});
	}, [C, p]);
	let w = q(() => {
		if (e && d) {
			let t = d(e.original);
			return t === null ? void 0 : String(t);
		}
	}, [e, d]), T = G(() => {
		let t = Object.values(e?.original?._groupInfo ?? {});
		if (t && t.length > 0 && t.some((e) => e.isCollapsed) && t[0]?.toggleCollapsed) {
			t[0].toggleCollapsed();
			return;
		}
		e && c && c(e.original);
	}, [e, c]), E = o || e?.original && !("_groupInfo" in e.original);
	return /* @__PURE__ */ W(B, {
		"data-testid": `magicTable.row.${e?.id}`,
		height: `${t.size}px`,
		padding: "0",
		borderBottomWidth: E ? "1px" : "0px",
		borderColor: P,
		borderStyle: "solid",
		background: v || C ? A : "#FFF",
		role: "row",
		"data-group": "true",
		"data-row-group-id": w,
		_hover: {
			[`~ [data-row-group-id="${w}"]`]: { background: A },
			background: A
		},
		css: { [`:has(~ [data-row-group-id="${w}"]:hover)`]: { background: A } },
		transition: "background 150ms ease-in-out",
		position: "relative",
		onClick: y ? T : void 0,
		cursor: y ? "pointer" : void 0,
		ref: S,
		children: [x && /* @__PURE__ */ U(R, {
			width: "100%",
			height: "8px",
			background: "linear-gradient(180deg, rgba(15,23,42,0.03) 0%, rgba(255,255,255,0) 100%)",
			position: "absolute",
			pointerEvents: "none"
		}), h ? _.map((t, n) => {
			let r = t.column.getSize(), o = t.getValue(), c = t.row.getIsExpanded(), u = t.row.getCanExpand(), d = s?.(e.original, VE(e.id)), f = e.original && "_groupInfo" in e.original ? gD(e.original._groupInfo, t.column.id) : void 0;
			return /* @__PURE__ */ U(fD, {
				cell: t,
				width: r,
				value: o,
				isSelected: v,
				columnOrder: i,
				columnVisibility: a,
				isOverflowing: l,
				rowPath: d,
				isExpanded: c,
				canExpand: u,
				cellGroupInfo: f,
				showPaddingLeft: b && n === 0
			}, t.id);
		}) : g.map((e, t) => /* @__PURE__ */ U(mD, {
			index: t,
			showCheckboxes: n,
			showExpandButtons: u,
			column: e,
			visibleColumns: g
		}, e.id))]
	});
}, vD = ({ isOverflowing: e, numRows: t, containerHeight: n }) => {
	let r = q(() => {
		let e = t * 40 + 41 - 1;
		return typeof n == "number" && e >= n ? "100%" : e;
	}, [n, t]);
	return e ? /* @__PURE__ */ U(R, {
		width: "8px",
		height: r,
		position: "absolute",
		top: "0px",
		right: "0",
		zIndex: "1",
		pointerEvents: "none",
		background: I,
		boxShadow: "0px 0px 16px 0px rgba(15, 23, 42, 0.08)",
		borderLeft: "1px",
		borderLeftColor: P,
		transform: "translateZ(0)"
	}) : null;
}, yD = Ru({}), bD = (e, t, n, r, i) => {
	let [a, o] = zu(yD), s = a[e], c = G((t) => {
		o((n) => ({
			...n,
			[e]: t(n[e])
		}));
	}, [e, o]), l = zl();
	return K(() => {
		let e = (e) => {
			let a = e.target;
			a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement || a instanceof HTMLSelectElement || a?.isContentEditable === !0 || a?.closest("[role=\"menu\"], [role=\"listbox\"], [role=\"dialog\"], [role=\"combobox\"], [role=\"radiogroup\"], [contenteditable=\"true\"]") || X(e.key).with("ArrowDown", () => {
				e.preventDefault(), t.current?.focus(), c((e) => Math.min(i - 1, (e ?? -1) + 1));
			}).with("ArrowUp", () => {
				e.preventDefault(), t.current?.focus(), c((e) => Math.max(0, (e ?? 1) - 1));
			}).with("Enter", () => {
				if (e.target !== t.current) return;
				let i = n[s ?? 0];
				i && r && l(r(i.original, !1));
			}).with("Escape", () => {
				c(() => null);
			});
		};
		return document.addEventListener("keydown", e), () => {
			document.removeEventListener("keydown", e);
		};
	}, [
		n,
		r,
		s,
		i,
		l,
		t,
		c
	]), s;
}, xD = (e) => {
	let { table: t, refContainer: n, rowVirtualizer: r, showCheckboxes: i = !1, columnOrder: a, setColumnOrder: o, emptyStateUnfiltered: s, emptyStateFiltered: c, containerWidth: l, containerHeight: u, columnVisibility: d, rowPath: f, onRowClick: p, entityNamePlural: m, setEventPropertyColumns: h, showExpandButtons: g = !1, clearFilters: _, totalResultSize: v, sortBy: y, onChangeSortBy: b, groupableColumns: x, enableColumnReordering: S, onGroupBy: C, groupBy: w, highlightRowGroup: T, disableActiveRowScroll: E = !1, scrollAreaHeader: D } = e, [ee, te] = Y(!1), { rows: O } = t.getRowModel(), ne = v === 0, re = v === void 0 && O.length === 0, ie = X({
		hasEmptyResult: !e.loading && (ne || re),
		hasFilters: e.hasFilters
	}).with({
		hasEmptyResult: !0,
		hasFilters: !0
	}, () => "FILTERED_EMPTY").with({
		hasEmptyResult: !0,
		hasFilters: !1
	}, () => "EMPTY").otherwise(() => "TABLE"), ae = r.getVirtualItems(), oe = ae.length > 0 ? (ae[0]?.start ?? 0) - r.options.scrollMargin : 0, se = ae.length > 0 ? r.getTotalSize() - ((ae[ae.length - 1]?.end ?? 0) - r.options.scrollMargin) : 0, [ce, le] = Y(!1), ue = J(null);
	K(() => {
		if (!ue.current) return;
		let e = new IntersectionObserver((e) => {
			let t = e[0];
			t && le(!t.isIntersecting);
		});
		return e.observe(ue.current), () => {
			e.disconnect();
		};
	}, [ue.current]);
	let de = D ? `calc(100% - ${D.height}px)` : "100%", fe = bD(m, n, O, f, r.getTotalSize());
	return /* @__PURE__ */ W(R, {
		position: "relative",
		flex: "1",
		overflow: "hidden",
		children: [/* @__PURE__ */ W(B, {
			ref: n,
			"data-testid": "magicTable.scrollContainer",
			direction: "row",
			width: "100%",
			height: "100%",
			overflow: ee ? "hidden" : "auto",
			children: [/* @__PURE__ */ W(R, {
				role: "table",
				width: typeof l == "number" && t.getTotalSize() > l ? t.getTotalSize() + (i ? 0 : 12) + 1 : "100%",
				height: ie === "TABLE" ? r.getTotalSize() + (D?.height ?? 0) : "100%",
				children: [D && /* @__PURE__ */ U(R, {
					position: "sticky",
					left: "0px",
					width: typeof l == "number" ? `${l}px` : "100%",
					zIndex: 1,
					height: `${D.height}px`,
					overflow: "hidden",
					children: D.content
				}), X(ie).with("EMPTY", () => s ? /* @__PURE__ */ U(R, {
					height: de,
					children: s(m)
				}) : null).with("FILTERED_EMPTY", () => c ? /* @__PURE__ */ U(R, {
					height: de,
					children: c(m, _)
				}) : null).with("TABLE", () => /* @__PURE__ */ W(H, { children: [
					/* @__PURE__ */ U(cD, {
						table: t,
						headerGroups: t.getHeaderGroups(),
						setIsSorting: te,
						isSorting: ee,
						columnOrder: a,
						setColumnOrder: o,
						showCheckboxes: i,
						setEventPropertyColumns: h,
						showExpandButtons: g,
						sortBy: y,
						onChangeSortBy: b,
						enableColumnReordering: S,
						groupableColumns: x,
						onGroupBy: C,
						groupBy: w
					}),
					/* @__PURE__ */ U(R, {
						position: "sticky",
						top: "41px",
						width: "100%",
						zIndex: 3,
						children: e.additionalTableHeaderRow && pc(e.additionalTableHeaderRow, { visibleTableWidth: l })
					}),
					/* @__PURE__ */ W(R, { children: [
						oe > 0 && /* @__PURE__ */ U(R, { height: oe }),
						ae.map((e) => /* @__PURE__ */ U(_D, {
							row: O[e.index],
							isActive: e.index === fe,
							virtualRow: e,
							showCheckboxes: i,
							table: t,
							columnOrder: a,
							columnVisibility: d,
							forceRowBorderBottom: e.index === O.length - 1,
							rowPath: f,
							onRowClick: p,
							isOverflowing: ce,
							showExpandButtons: g,
							highlightRowGroup: T,
							disableActiveRowScroll: E
						}, e.key)),
						se > 0 && /* @__PURE__ */ U(R, { height: se })
					] })
				] })).exhaustive()]
			}), /* @__PURE__ */ U(R, {
				ref: ue,
				display: ie === "TABLE" ? void 0 : "none",
				visibility: "hidden",
				width: "1px",
				flexShrink: "0",
				height: ie === "TABLE" ? r.getTotalSize() : "100%"
			})]
		}), v && v > 0 && /* @__PURE__ */ U(vD, {
			isOverflowing: ce,
			numRows: ae.length,
			containerHeight: u
		})]
	});
}, SD = ({ checked: e, disabled: t, indeterminate: n, onChange: r, showExpandButtons: i, "data-testid": a }) => /* @__PURE__ */ U(B, {
	paddingLeft: i ? "12px" : "24px",
	paddingRight: "12px",
	height: "100%",
	width: "fit-content",
	onClick: (e) => e.stopPropagation(),
	alignItems: "center",
	"data-testid": a,
	children: /* @__PURE__ */ U(Vy, {
		isChecked: e,
		disabled: t,
		onChange: r,
		isIndeterminate: n
	})
}), CD = ({ row: e }) => {
	if (!e.getCanExpand()) return null;
	let t = e.getIsExpanded();
	return /* @__PURE__ */ U(z, {
		"data-testid": `magicTable.row.${e.id}.expandToggle`,
		as: "button",
		paddingLeft: "24px",
		paddingRight: "12px",
		height: "100%",
		width: "fit-content",
		onClick: (t) => {
			t.stopPropagation(), e.toggleExpanded();
		},
		children: U(t ? Xp : Up, { fill: k })
	});
}, wD = ({ row: e, kebabMenu: t }) => {
	let [n, r] = Y(!1);
	return /* @__PURE__ */ U(z, {
		height: "100%",
		opacity: n ? "1" : "0",
		_groupHover: { opacity: "1" },
		width: "39px",
		children: t(e.original, {
			onOpen: () => r(!0),
			onClose: () => r(!1),
			stopPropogation: !0,
			useMagicTableStyle: !0
		})
	});
}, TD = ({ totalResultSize: e, bulkActions: t, rows: n, rowSelection: r, setRowSelection: i, additionalComponents: a, loading: o }) => {
	let s = q(() => Object.keys(r).map(Number).map((e) => n[e]).filter((e) => !!e), [r, n]), c = n.length > 0, l = !c && !!o;
	if (!c && !l) return null;
	let u = ED({
		rows: n,
		totalResultSize: e
	});
	return /* @__PURE__ */ W(B, {
		borderTopStyle: "solid",
		borderTopWidth: "1px",
		borderTopColor: M,
		position: "relative",
		height: "40px",
		alignItems: "center",
		padding: "0 16px",
		children: [
			l ? /* @__PURE__ */ U(pD, {
				height: "16px",
				width: "100px"
			}) : /* @__PURE__ */ W(B, {
				alignItems: "center",
				gap: "8px",
				minWidth: "100px",
				children: [/* @__PURE__ */ U(V, {
					...N,
					color: F,
					children: u
				}), /* @__PURE__ */ U(jl, {
					initial: !1,
					children: o && /* @__PURE__ */ U(Nl.div, {
						initial: { opacity: 0 },
						animate: { opacity: 1 },
						exit: { opacity: 0 },
						transition: {
							ease: "linear",
							duration: .15
						},
						style: {
							display: "flex",
							alignItems: "center",
							position: "relative",
							top: "1px"
						},
						children: /* @__PURE__ */ U(ki, {
							height: "16px",
							width: "16px",
							color: "#94a3b8"
						})
					})
				})]
			}),
			/* @__PURE__ */ U(B, { flexGrow: "1" }),
			/* @__PURE__ */ U(V, {
				...N,
				color: F,
				children: a
			}),
			t && t(s, () => i({}))
		]
	});
}, ED = ({ rows: e, totalResultSize: t }) => typeof t == "number" ? `${e.length} displayed (${t} total)` : `${e.length} displayed`, DD = ({ setColumnOrder: e, setColumnSizing: t, setColumnVisibility: n }) => {
	let [r, i] = Y([]), a = J(0), o = J([]), s = J(!1);
	return K(() => {
		if (!s.current) {
			o.current = r, s.current = !0;
			return;
		}
		let i = r.find((e) => !o.current.includes(e)), c = o.current.find((e) => !r.includes(e));
		i && e((e) => [
			...e.filter((e) => e !== "addColumn" && e !== `eventProperty_${i}`),
			`${zT}${i}`,
			LT
		]), c && (t((e) => {
			let t = { ...e };
			return delete t[`${zT}${c}`], t;
		}), e((e) => e.filter((e) => e !== `${zT}${c}`)), n((e) => {
			let t = { ...e };
			return delete t[`${zT}${c}`], t;
		})), (i || c) && (o.current = r, a.current += 1);
	}, [r]), {
		eventPropertyColumns: r,
		setEventPropertyColumns: i,
		refUpdateEventPropertyColumns: a
	};
}, OD = ({ refContainer: e, initialWidth: t, initialHeight: n }) => {
	let [r, i] = Y(t), [a, o] = Y(n);
	return K(() => {
		let t = new ResizeObserver((e) => {
			e.forEach((e) => {
				i(e.contentRect.width), o(e.contentRect.height);
			});
		});
		if (e.current) return t.observe(e.current), () => {
			t.disconnect();
		};
	}, [e.current]), {
		width: r,
		height: a
	};
}, kD = (e) => Array.isArray(e) && e.every((e) => typeof e == "string"), AD = (e) => typeof e == "object" && !!e && !Array.isArray(e) && Object.keys(e).every((e) => typeof e == "string") && Object.values(e).every((e) => typeof e == "number"), jD = (e) => typeof e == "object" && !!e && !Array.isArray(e) && Object.keys(e).every((e) => typeof e == "string") && Object.values(e).every((e) => typeof e == "boolean"), MD = (e) => "columnOrder" in e && kD(e.columnOrder) && "columnVisibility" in e && jD(e.columnVisibility) && "columnSizing" in e && AD(e.columnSizing) && "eventPropertyColumns" in e, ND = ({ state: e, columns: t, showCheckboxes: n, objectPropertyColumns: r, showExpandButtons: i }) => {
	let { columnOrder: a, columnVisibility: o, columnSizing: s, eventPropertyColumns: c } = e, l = t.map((e) => e.id), u = !!r && !r.isLoading, d = u ? r.allEventProperties.map((e) => `${zT}${e}`) : a.filter((e) => e.startsWith(zT)), f = a.reduce((e, t) => l.includes(t) || d.includes(t) ? [...e, t] : e, []), p = l.filter((e) => !f.includes(e));
	return {
		columnOrder: [
			...i ? [FT] : [],
			...n ? [IT] : [],
			...f,
			...p,
			LT
		],
		columnVisibility: t.reduce((e, t) => t.id in e ? e : {
			...e,
			[t.id]: !t.hiddenByDefault
		}, { ...o }),
		columnSizing: Object.keys(s).reduce((e, t) => l.includes(t) || d.includes(t) ? {
			...e,
			[t]: s[t] >= 100 ? s[t] : 100
		} : e, {}),
		eventPropertyColumns: r && u ? c.filter((e) => r.allEventProperties.includes(e)) : c
	};
}, PD = ({ sequenceUserId: e, entityNamePlural: t, columnOrder: n, setColumnOrder: r, columnVisibility: i, setColumnVisibility: a, columnSizing: o, setColumnSizing: s, columns: c, showCheckboxes: l, eventPropertyColumns: u, setEventPropertyColumns: d, objectPropertyColumns: f, showExpandButtons: p, enableColumnReordering: m }) => {
	let h = J(!1), g = J(!1), _ = `${e}:table_${t.replace(/ /g, "")}`, v = window.localStorage.getItem(_), y = G((e) => {
		if (!h.current) {
			h.current = !0;
			return;
		}
		let t = {
			columnOrder: m ? e.columnOrder : [],
			columnVisibility: e.columnVisibility,
			columnSizing: e.columnSizing,
			eventPropertyColumns: e.eventPropertyColumns
		};
		window.localStorage.setItem(_, JSON.stringify(t));
	}, []), b = G(() => {
		if (v) try {
			let e = JSON.parse(v), t = e.eventPropertyColumns === void 0 ? {
				...e,
				eventPropertyColumns: []
			} : e;
			if (!MD(t)) return;
			let n = ND({
				state: t,
				columns: c,
				showCheckboxes: l,
				objectPropertyColumns: f,
				showExpandButtons: p
			});
			return y({
				columnOrder: n.columnOrder,
				columnVisibility: n.columnVisibility,
				columnSizing: n.columnSizing,
				eventPropertyColumns: n.eventPropertyColumns
			}), n;
		} catch {
			window.localStorage.removeItem(_);
			return;
		}
	}, [v])(), x = q(() => Fl(y, 250), [y]);
	return K(() => () => {
		x.cancel();
	}, []), K(() => {
		x({
			columnOrder: n,
			columnVisibility: i,
			columnSizing: o,
			eventPropertyColumns: u
		});
	}, [
		n,
		o,
		i,
		u
	]), {
		restoreSavedState: G((e) => {
			g.current ||= (b ? (r(b.columnOrder), a(b.columnVisibility), s(b.columnSizing), d(b.eventPropertyColumns)) : e(), !0);
		}, [
			b,
			r,
			s,
			a,
			d
		]),
		isStateRestored: g
	};
}, FD = /* @__PURE__ */ function(e) {
	return e.Before = "Before", e.After = "After", e;
}({}), ID = "sortBy";
//#endregion
//#region src/components/tables/components/MagicTable/utils/parseActiveFiltersFromSearchParams.ts
function LD(e, t = new URLSearchParams(window.location.search)) {
	let n = Array.from(t.entries()).reduce((e, [t, n]) => ({
		...e,
		[t]: n
	}), {});
	return e.flatMap((e) => X(e.type).with("multiSelect", () => {
		let t = e.type === "multiSelect" && !e.paramNameAliasOf ? e.excludeParamName : void 0;
		return t && n[t] ? {
			type: "multiSelect",
			paramName: e.paramName,
			operator: "IS_NOT",
			values: n[t].split(",").map(zD)
		} : n[e.paramName] ? {
			type: "multiSelect",
			paramName: e.paramName,
			values: n[e.paramName].split(",").map(zD)
		} : [];
	}).with("singleSelect", () => n[e.paramName] ? {
		type: "singleSelect",
		paramName: e.paramName,
		value: n[e.paramName]
	} : []).with("multiSelectAliased", () => n[e.paramName] ? {
		type: "multiSelect",
		paramName: e.paramName,
		values: n[e.paramName].split(";")
	} : []).with("multiSelectAsync", () => {
		let t = e.type === "multiSelectAsync" && e.paramNameAliasOf ? ";" : ",", r = e.type === "multiSelectAsync" && !e.paramNameAliasOf ? e.excludeParamName : void 0;
		return r && n[r] ? {
			type: "multiSelect",
			paramName: e.paramName,
			operator: "IS_NOT",
			values: n[r].split(t)
		} : n[e.paramName] ? {
			type: "multiSelect",
			paramName: e.paramName,
			values: n[e.paramName].split(t)
		} : [];
	}).with("text", () => n[e.paramName] ? {
		type: "text",
		paramName: e.paramName,
		value: n[e.paramName]
	} : []).with("date", () => {
		if (e.type !== "date") return [];
		let t = n[e.paramNameBefore], r = n[e.paramNameAfter], i = {
			hasParamBefore: t !== void 0,
			hasParamAfter: r !== void 0
		};
		if (!i.hasParamBefore && !i.hasParamAfter) return [];
		let a = BD(t) ? t.split("T")[0] : t, o = BD(r) ? r.split("T")[0] : r;
		return X(i).with({
			hasParamBefore: !1,
			hasParamAfter: !1
		}, () => []).with({
			hasParamBefore: !0,
			hasParamAfter: !0
		}, () => {
			if (a === o) {
				let t = VD(a);
				return t ? {
					type: "datePreset",
					paramName: e.paramName,
					preset: t,
					operator: "EQUALS"
				} : {
					type: "dateCustom",
					date: new Date(a),
					operator: "EQUALS",
					paramName: e.paramName
				};
			}
			if (cl(new Date(a), RD())) {
				let t = VD(o);
				if (t) return {
					type: "datePreset",
					paramName: e.paramName,
					preset: t,
					operator: "LESS_THAN"
				};
			}
			return {
				type: "dateRange",
				paramName: e.paramName,
				from: new Date(o),
				to: new Date(a)
			};
		}).with({
			hasParamBefore: !0,
			hasParamAfter: !1
		}, () => {
			let t = VD(a);
			return t && t !== "TODAY" ? {
				type: "datePreset",
				paramName: e.paramName,
				preset: t,
				operator: "MORE_THAN"
			} : cl(new Date(a), dl(gl(RD(), { days: 1 }))) ? {
				type: "datePreset",
				paramName: e.paramName,
				preset: "TODAY",
				operator: "LESS_THAN"
			} : {
				type: "dateCustom",
				date: new Date(a),
				operator: "BEFORE",
				paramName: e.paramName
			};
		}).with({
			hasParamBefore: !1,
			hasParamAfter: !0
		}, () => ({
			type: "dateCustom",
			date: new Date(o),
			operator: "AFTER",
			paramName: e.paramName
		})).exhaustive();
	}).with("toggle", () => n[e.paramName] ? {
		type: "toggle",
		paramName: e.paramName,
		value: n[e.paramName] === "true"
	} : []).with("group", () => []).with("boolean", "checkbox", () => []).exhaustive());
}
var RD = () => {
	let e = /* @__PURE__ */ new Date();
	return new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()));
};
function zD(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}
function BD(e) {
	if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e)) return !1;
	let t = new Date(e);
	return !isNaN(t.getTime()) && t.toISOString() === e;
}
function VD(e) {
	let t = new Date(e);
	if (cl(t, RD())) return "TODAY";
	if (cl(t, dl(gl(RD(), { weeks: 1 })))) return "1_WEEK";
	if (cl(t, dl(gl(RD(), { months: 1 })))) return "1_MONTH";
	if (cl(t, dl(gl(RD(), { months: 3 })))) return "3_MONTHS";
}
//#endregion
//#region src/components/tables/components/MagicTable/hooks/useLinkMagicTableWithSearchParams.ts
var HD = (e, t) => {
	let [n, r] = Bl(new URLSearchParams(window.location.search)), [i, a] = Y(LD(e, n)), o = n.get(ID);
	return K(() => {
		a((t) => {
			let r = LD(e, n);
			return eu(r, t) ? t : r;
		});
	}, [n, e]), {
		activeFilters: i,
		onChangeActiveFilters: G((n) => {
			if (eu(n, i)) return;
			let o = new URLSearchParams(window.location.search);
			a(n);
			let s = UD(e, n);
			t?.forEach((e) => {
				let t = o.get(e);
				t && s.set(e, t);
			}), o.get("sortBy") && s.set(ID, o.get(ID)), s.toString() !== window.location.search.toString().replace("?", "") && r(s.toString());
		}, [
			t,
			e,
			r,
			i
		]),
		sortBy: o,
		onChangeSortBy: G((e) => {
			r((t) => (e ? t.set(ID, e) : t.delete(ID), t));
		}, [r])
	};
}, UD = (e, t) => {
	let n = new URLSearchParams();
	return t.forEach((t) => {
		let r = e.find((e) => e.paramName === t.paramName);
		r && X(t.type).with("multiSelect", () => {
			if (!(t.type !== "multiSelect" || t.values.length === 0)) {
				if (r.type === "multiSelect") {
					if (r.setQueryParamsFn) {
						r.setQueryParamsFn(r, t, n);
						return;
					}
					let e = t.operator === "IS_NOT" && r.excludeParamName && !r.paramNameAliasOf ? r.excludeParamName : r.paramName;
					n.set(e, t.values.map(encodeURIComponent).join(","));
					return;
				}
				if (r.type === "multiSelectAliased") {
					n.set(r.paramName, t.values.join(";"));
					return;
				}
				if (r.type === "multiSelectAsync") {
					if (r.setQueryParamsFn) {
						r.setQueryParamsFn(r, t, n);
						return;
					}
					let e = r.paramNameAliasOf ? ";" : ",", i = t.operator === "IS_NOT" && r.excludeParamName && !r.paramNameAliasOf ? r.excludeParamName : r.paramName;
					n.set(i, t.values.join(e));
					return;
				}
			}
		}).with("text", () => {
			t.type === "text" && n.set(t.paramName, t.value);
		}).with("datePreset", () => {
			if (t.type !== "datePreset" || !r || r.type !== "date") return;
			let e = X(t.preset).with("TODAY", () => dl(RD())).with("1_WEEK", () => dl(gl(RD(), { weeks: 1 }))).with("1_MONTH", () => dl(gl(RD(), { months: 1 }))).with("3_MONTHS", () => dl(gl(RD(), { months: 3 }))).exhaustive();
			X(t.operator).with("LESS_THAN", () => {
				if (t.preset === "TODAY") {
					n.set(r.paramNameBefore, r.stringifyDate(dl(gl(RD(), { days: 1 })))), n.delete(r.paramNameAfter);
					return;
				}
				n.set(r.paramNameBefore, r.stringifyDate(RD())), n.set(r.paramNameAfter, r.stringifyDate(e));
			}).with("MORE_THAN", () => {
				if (t.preset === "TODAY") {
					n.set(r.paramNameAfter, r.stringifyDate(e)), n.delete(r.paramNameBefore);
					return;
				}
				n.set(r.paramNameBefore, r.stringifyDate(e)), n.delete(r.paramNameAfter);
			}).with("EQUALS", () => {
				n.set(r.paramNameBefore, r.stringifyDate(e)), n.set(r.paramNameAfter, r.stringifyDate(e));
			}).exhaustive();
		}).with("dateCustom", () => {
			t.type !== "dateCustom" || !r || r.type !== "date" || X(t.operator).with("BEFORE", () => {
				n.set(r.paramNameBefore, r.stringifyDate(t.date));
			}).with("AFTER", () => {
				n.set(r.paramNameAfter, r.stringifyDate(t.date));
			}).with("EQUALS", () => {
				n.set(r.paramNameBefore, r.stringifyDateBefore ? r.stringifyDateBefore(t.date) : r.stringifyDate(t.date)), n.set(r.paramNameAfter, r.stringifyDateAfter ? r.stringifyDateAfter(t.date) : r.stringifyDate(t.date));
			}).exhaustive();
		}).with("dateRange", () => {
			t.type !== "dateRange" || !r || r.type !== "date" || (n.set(r.paramNameAfter, r.stringifyDateAfter ? r.stringifyDateAfter(t.from) : r.stringifyDate(t.from)), n.set(r.paramNameBefore, r.stringifyDateBefore ? r.stringifyDateBefore(t.to) : r.stringifyDate(t.to)));
		}).with("toggle", () => {
			t.type === "toggle" && n.set(t.paramName, t.value ? "true" : "false");
		}).with("singleSelect", () => {
			t.type === "singleSelect" && n.set(t.paramName, t.value);
		}).exhaustive();
	}), n;
}, WD = Hu.MAX_PAGES, GD = 100, KD = (e, t = [], n = [], r = null, i = GD, a = WD, o, s) => {
	let { infiniteQuery: c } = Hu(e, {
		...YD(t, n, r),
		...o,
		limit: i
	}, {
		maxPages: a,
		staleTime: 0,
		...s
	});
	return { infiniteQuery: c };
}, qD = (e, t) => {
	let n = t ?? [];
	return JD({
		filterValues: n.reduce((t, n) => {
			if (n.type === "date") {
				let r = e.get(n.paramNameBefore), i = e.get(n.paramNameAfter);
				return {
					...t,
					...r ? { [n.paramNameBefore]: r } : {},
					...i ? { [n.paramNameAfter]: i } : {}
				};
			} else {
				let r = e.get(n.paramName), i = r ? {
					...t,
					[n.paramName]: r
				} : t, a = (n.type === "multiSelect" || n.type === "multiSelectAsync") && !n.paramNameAliasOf ? n.excludeParamName : void 0, o = a ? e.get(a) : null;
				return o && a ? {
					...i,
					[a]: o
				} : i;
			}
		}, {}),
		filterConfig: n
	});
}, JD = ({ filterValues: e, filterConfig: t }) => (e && Object.keys(e).reduce((n, r) => {
	let i = t.find((e) => e.paramName === r), a = n[r] && typeof n[r] == "string" ? n[r] : e[r], o = i?.type === "multiSelectAliased", s = i?.type === "multiSelectAsync" && !!i.paramNameAliasOf;
	if (!i || !(o || s) || typeof a != "string") return {
		...n,
		[r]: a
	};
	let c = i.paramNameAliasOf, l = a.split(";").reduce((e, t) => [...e, ...t.split(",")], []), u = e[c];
	return !u || typeof u != "string" ? {
		...n,
		[c]: l.join(",")
	} : {
		...n,
		[c]: Array.from([.../* @__PURE__ */ new Set([...u.split(","), ...l])]).join(",")
	};
}, {})) ?? {}, YD = (e, t, n) => {
	let r = qD(UD(e, t), e);
	return {
		...XD(n),
		...r
	};
};
function XD(e) {
	if (!e) return {};
	let t = e.match(/^(.+)_(asc|desc)$/i);
	if (!t) return { sortBy: e };
	let [, n, r] = t;
	return {
		sortBy: n,
		sortOrder: r.toUpperCase()
	};
}
//#endregion
//#region src/components/tables/components/MagicTable/utils/enhanceRowsWithGroupInfo.ts
function ZD({ items: e, rowSpanningRules: t, getGroupKey: n, groupBy: r, isCollapsed: i, toggleCollapsed: a, renderCollapsedRow: o, collapsedVisibleColumns: s, collapsedBorderedColumns: c }) {
	if (!t) return e;
	let l = /* @__PURE__ */ new Map();
	o && r && n && e.forEach((e) => {
		let t = n(e);
		l.has(t) || l.set(t, []), l.get(t).push(e);
	});
	let u = e.map((s, c) => {
		let u = {};
		return t.forEach(({ columnId: t, spanBy: d }) => {
			let f = e[c + 1], p = c > 0 ? e[c - 1] : void 0, m = f ? d(s, f) : !1, h = p ? d(p, s) : !1, g = n?.(s), _ = r === t && (!p || n?.(p) !== g), v;
			_ && o && g && r && l.has(g) && (v = o(g, l.get(g), r)), u[t] = {
				togglableColumn: _,
				groupKey: n?.(s),
				isFirstInGroup: !h,
				isLastInGroup: !m,
				isInSameGroupAsNextRow: m,
				isCollapsed: g ? i?.(g) : void 0,
				toggleCollapsed: g ? () => a?.(g) : void 0,
				customCollapsedContent: v
			};
		}), {
			...s,
			_groupInfo: u
		};
	});
	if (!r) return u;
	if (o && r && n) {
		let e = [], t = /* @__PURE__ */ new Set();
		return u.forEach((i) => {
			let a = n(i);
			if (i._groupInfo[r]?.isCollapsed) {
				if (!t.has(a)) {
					t.add(a);
					let l = o(a, u.filter((e) => n(e) === a).map((e) => e), r);
					Array.isArray(l) ? l.forEach((t, n) => {
						let a = {};
						Object.keys(i._groupInfo).forEach((e) => {
							let t = i._groupInfo[e];
							a[e] = {
								...t,
								togglableColumn: e === r && n === 0,
								isFirstInGroup: n === 0,
								isLastInGroup: n === l.length - 1,
								isInSameGroupAsNextRow: n < l.length - 1,
								isCollapsedSynthetic: !0,
								collapsedVisibleColumns: s,
								collapsedBorderedColumns: c
							};
						}), e.push({
							...t,
							_groupInfo: a
						});
					}) : e.push(i);
				}
			} else e.push(i);
		}), e;
	}
	return u.reduce((e, t) => t._groupInfo[r]?.togglableColumn ? [...e, t] : t._groupInfo[r]?.isCollapsed ? e : [...e, t], []);
}
//#endregion
//#region src/components/tables/components/MagicTable/hooks/useMagicTable.tsx
var QD = 50, $D = ({ activeFilters: e, containerHeight: t, refContainer: n, expandedRows: r, getSubRows: i, infiniteQuery: a, rowSpanningRules: o, getGroupKey: s, groupBy: c, transformGroupData: l, resultSizeMultiplier: u, renderCollapsedRow: d, collapsedVisibleColumns: f, collapsedBorderedColumns: p, scrollMargin: m = 0 }) => {
	let [h, g] = Y({}), _ = q(() => {
		let e = a.data?.pages.flatMap((e) => e.items) ?? [];
		return l && (e = l(e, c)), ZD({
			items: e,
			rowSpanningRules: o,
			getGroupKey: s,
			groupBy: c,
			isCollapsed: (e) => h[e],
			toggleCollapsed: (e) => {
				g((t) => ({
					...t,
					[e]: !t[e]
				}));
			},
			renderCollapsedRow: d,
			collapsedVisibleColumns: f,
			collapsedBorderedColumns: p
		});
	}, [
		a.data?.pages,
		o,
		h,
		g,
		c,
		l,
		s,
		d,
		f,
		p
	]), v = a.data?.pages[0]?.items.length ?? QD, y = eO({
		pages: a.data?.pages,
		resultSizeMultiplier: u
	}), b = t ? Math.floor(t / 40) - 1 : 10, [x, S] = Y(0), C = tO({
		totalResultSize: y,
		isFetching: a.isFetching,
		enhancedRowsLength: _.length,
		rowCountToFitSpace: b,
		rowsPerPage: v,
		expandedRowCount: x
	}), w = !!(o && o.length > 0), T = Bu({
		count: nO({
			enhancedRowsLength: _.length + x,
			collapsedGroupKeys: h,
			hasNextPage: a.hasNextPage,
			isFetchingNextPage: a.isFetchingNextPage,
			hasGrouping: w,
			rowCountToShow: C
		}),
		getScrollElement: () => n.current,
		estimateSize: () => 40,
		scrollMargin: m,
		overscan: 20,
		getItemKey: (e) => _[e] ? String(e) : `LOADING-${e}`
	}), E = T.getVirtualItems().slice().pop(), D = !E || E?.index + 5 > _.length;
	K(() => {
		D && a.hasNextPage && !a.isFetchingNextPage && a.fetchNextPage();
	}, [D, a]);
	let ee = Yc(r);
	return K(() => {
		if (!i || eu(ee, r)) return;
		let e = Object.keys(r).map((e) => Number(e)).map((e) => i(_[e], e).length).reduce((e, t) => e + t, 0);
		S(e);
	}, [
		r,
		_,
		i,
		ee
	]), {
		rowVirtualizer: T,
		rows: _,
		totalResultSize: y,
		hasFilters: !Iu(e),
		loading: a.isFetching
	};
}, eO = ({ pages: e, resultSizeMultiplier: t }) => {
	let n = (e?.findLast((e) => typeof e.pagination.totalResultSize == "number"))?.pagination.totalResultSize;
	return typeof n == "number" ? n * (t ?? 1) : void 0;
}, tO = ({ totalResultSize: e, isFetching: t, enhancedRowsLength: n, rowCountToFitSpace: r, rowsPerPage: i, expandedRowCount: a }) => typeof e == "number" ? Math.min(WD * i, e) + a : t && n === 0 ? r : n + a, nO = ({ enhancedRowsLength: e, collapsedGroupKeys: t, hasNextPage: n, isFetchingNextPage: r, hasGrouping: i, rowCountToShow: a }) => {
	if (Object.keys(t).length > 0 && n) return Math.max(e, a);
	if (r && !i) {
		let t = e + 20;
		return a > e ? Math.min(t, a) : t;
	}
	return e > 0 ? e : a;
}, rO = (e) => {
	let t = !!(e.selectedItems && e.onSelectedItemsChange), [n, r] = Y({}), i = q(() => {
		let t = e.selectedItems?.reduce((e, t) => ({
			...e,
			[t]: t
		}), {}) ?? {};
		return e.rows.map((e) => t[e.id]).reduce((t, n) => n ? {
			...t,
			[e.rows.findIndex((e) => e.id === n)]: n
		} : t, {});
	}, [e.selectedItems, e.rows]);
	return {
		rowSelection: q(() => t ? i : n, [
			t,
			n,
			i
		]),
		setRowSelection: (n) => {
			if (!t) {
				r(n);
				return;
			}
			let a = Uu(n) ? n(i) : n, o = Object.entries(a).filter(([e, t]) => t).map(([t]) => e.rows[Number(t)].id);
			eu(o, e.selectedItems) || e.onSelectedItemsChange?.(o);
		}
	};
}, iO = ({ icon: e, text: t, textAlign: n = "left", showCopyButton: r = !1, withBorder: i = !1, borderColor: a, textColor: o, backgroundColor: s, fontStyle: c = "sans-serif", overflow: l = "hidden", "data-testid": u }) => {
	if (!t) return null;
	let d = i || s ? {
		width: "fit-content",
		padding: "3px 6px",
		borderRadius: "6px",
		backgroundColor: s,
		...i ? {
			borderWidth: "1px",
			borderColor: a
		} : {}
	} : {}, f = c === "sans-serif" ? N : ne;
	return /* @__PURE__ */ U(R, {
		padding: i || s ? "8px 12px" : "12px",
		sx: r ? { ".mt-cell:hover .mt-cell-copy": { display: "block" } } : void 0,
		"data-testid": u,
		children: /* @__PURE__ */ W(B, {
			className: r ? "mt-cell" : void 0,
			justifyContent: "space-between",
			alignItems: "center",
			position: "relative",
			_hover: r ? { paddingRight: "38px" } : void 0,
			...d,
			children: [
				e && /* @__PURE__ */ W(H, { children: [e, /* @__PURE__ */ U(R, { width: "6px" })] }),
				/* @__PURE__ */ U(V, {
					textAlign: n,
					width: "100%",
					overflow: l,
					display: "-webkit-box",
					sx: {
						WebkitBoxOrient: "vertical",
						WebkitLineClamp: 1,
						lineBreak: "anywhere"
					},
					color: o,
					...f,
					children: t
				}),
				r && typeof t == "string" && /* @__PURE__ */ U(R, {
					boxSize: "24px",
					flexShrink: "0",
					position: "absolute",
					right: "8px",
					display: "none",
					className: "mt-cell-copy",
					children: /* @__PURE__ */ U(fx, {
						value: t,
						enableGroupHover: !1
					})
				})
			]
		})
	});
}, aO = (e) => {
	let { entityNamePlural: t, additionalHeaderRows: n, scrollAreaHeader: r, columns: i, filters: a, emptyStateUnfiltered: o, emptyStateFiltered: s, kebabMenu: c, rowPath: l, onRowClick: u, bulkActions: d, sequenceUserId: f, objectPropertyColumns: p, getSubRows: m, viewSettingsHeader: h, additionalToolbarComponentsV3: g, additionalStatusBarComponents: _, activeFilters: v = [], onChangeActiveFilters: y = () => {}, sortBy: b = null, onChangeSortBy: x = () => {}, defaultSortBy: S = null, onSaveFilters: C, onUpdateSavedFilters: w, lockedControls: T, disableCheckboxes: E, grouping: D, enableColumnReordering: ee = !0, showAddColumn: te = !0, enableCopyResults: O, disableActiveRowScroll: ne = !1, requiredColumnIds: re } = e, { groupableColumns: ie, onGroupBy: ae, groupBy: oe, highlightRowGroup: se, rowSpanningRules: ce, getGroupKey: le, transformGroupData: ue, resultSizeMultiplier: de, renderCollapsedRow: fe, collapsedVisibleColumns: pe, collapsedBorderedColumns: me } = D ?? {}, he = J(null), ge = J(null), { width: _e, height: ve } = OD({
		refContainer: he,
		initialWidth: window.innerWidth - 206
	}), [ye, be] = Y([]), [xe, Se] = Y({}), [Ce, we] = Y({}), [Te, Ee] = Y({}), { rowVirtualizer: De, rows: Oe, totalResultSize: ke, hasFilters: Ae, loading: je } = $D({
		...e,
		containerHeight: ve,
		scrollMargin: r?.height ?? 0,
		refContainer: he,
		expandedRows: Te,
		rowSpanningRules: ce,
		getGroupKey: le,
		groupBy: oe,
		transformGroupData: ue,
		resultSizeMultiplier: de,
		renderCollapsedRow: fe,
		collapsedVisibleColumns: pe,
		collapsedBorderedColumns: me
	}), { rowSelection: Me, setRowSelection: Ne } = rO({
		rows: Oe,
		selectedItems: d?.selectedItems,
		onSelectedItemsChange: d?.onSelectedItemsChange
	}), { eventPropertyColumns: Pe, setEventPropertyColumns: Fe, refUpdateEventPropertyColumns: Ie } = DD({
		setColumnOrder: be,
		setColumnSizing: we,
		setColumnVisibility: Se
	}), Le = p?.onSelectedChange;
	K(() => {
		Le?.(Pe);
	}, [Pe, Le]);
	let Re = p?.requiredKeys;
	K(() => {
		!Re || Re.length === 0 || Fe((e) => {
			let t = Re.filter((t) => !e.includes(t));
			return t.length === 0 ? e : [...e, ...t];
		});
	}, [Re, Fe]), K(() => {
		!re || re.length === 0 || Se((e) => {
			let t = re.filter((t) => !e[t]);
			return t.length === 0 ? e : {
				...e,
				...Object.fromEntries(t.map((e) => [e, !0]))
			};
		});
	}, [re]);
	let ze = !!p, Be = !!d, Ve = !!m, { restoreSavedState: He, isStateRestored: Ue } = PD({
		sequenceUserId: f,
		entityNamePlural: t,
		columnOrder: ye,
		setColumnOrder: be,
		columnVisibility: xe,
		setColumnVisibility: Se,
		columnSizing: Ce,
		setColumnSizing: we,
		columns: i,
		showCheckboxes: Be,
		eventPropertyColumns: Pe,
		setEventPropertyColumns: Fe,
		objectPropertyColumns: p,
		showExpandButtons: Ve,
		enableColumnReordering: ee
	}), We = i.map((e) => `${e.id}:${e.hiddenByDefault ? "hidden" : "shown"}`).join("|"), Ge = q(() => {
		let e = [
			...Ve ? [{
				id: FT,
				header: () => null,
				cell: ({ row: e }) => /* @__PURE__ */ U(CD, { row: e }),
				size: 52
			}] : [],
			...Be ? [{
				id: IT,
				header: ({ table: e }) => /* @__PURE__ */ U(SD, {
					checked: e.getIsAllRowsSelected(),
					indeterminate: e.getIsSomeRowsSelected(),
					onChange: e.getToggleAllRowsSelectedHandler(),
					showExpandButtons: Ve,
					disabled: E,
					"data-testid": "magicTable.header.selectAll"
				}),
				cell: ({ row: e }) => /* @__PURE__ */ U(SD, {
					"data-testid": `magicTable.row.${e.id}.checkbox`,
					checked: e.getIsSelected(),
					disabled: E || !e.getCanSelect(),
					indeterminate: e.getIsSomeSelected(),
					onChange: e.getToggleSelectedHandler(),
					showExpandButtons: Ve
				}),
				size: Ve ? 40 : 52
			}] : [],
			...i.map((e) => ({
				...e,
				minSize: 100
			})),
			...p ? Pe.map((e) => {
				let t = p.sortPropertyForKey?.(e);
				return {
					id: `${zT}${e}`,
					header: e,
					enableSorting: !!t,
					sortingConfiguration: t ? {
						sortProperty: t,
						appendDirectionToSortKey: !0,
						availableDirections: ["ASC", "DESC"]
					} : void 0,
					cell: ({ row: t }) => {
						let n = p.getObject(t.original)[e];
						if (typeof n != "string" && typeof n != "number") return null;
						let { valueAsPill: r = !0 } = p;
						return /* @__PURE__ */ U(iO, {
							text: String(n),
							fontStyle: r ? "monospace" : "sans-serif",
							backgroundColor: r ? Fn : void 0
						});
					},
					minSize: 100
				};
			}) : [],
			...te ? [{
				id: LT,
				size: 40,
				header: ({ table: e }) => /* @__PURE__ */ U(eD, {
					getTableState: e.getState,
					getTableAllFlatColumns: e.getAllFlatColumns,
					customColumns: {
						isEnabled: ze,
						available: p?.allEventProperties ?? [],
						selected: Pe,
						setSelected: Fe,
						menuLabel: p?.menuLabel,
						searchPlaceholder: p?.searchPlaceholder,
						inlineInAddColumnMenu: p?.inlineInAddColumnMenu
					}
				}),
				cell: ({ row: e }) => c ? /* @__PURE__ */ U(wD, {
					row: e,
					kebabMenu: c
				}) : null
			}] : []
		];
		return He(() => {
			we(zE({
				columns: i,
				containerWidth: _e,
				showCheckboxes: Be,
				showExpandButtons: Ve,
				showAddColumn: te
			})), be(e.map((e) => e.id));
			let t = e.reduce((e, t) => {
				let n = i.find((e) => e.id === t.id);
				return n ? {
					...e,
					[t.id]: !n.hiddenByDefault
				} : {
					...e,
					[t.id]: !0
				};
			}, {});
			Se(t);
		}), e;
	}, [
		Ue.current,
		Ie.current,
		E,
		p?.allEventProperties,
		We
	]);
	K(() => {
		Se((e) => i.reduce((e, t) => t.id in e ? e : {
			...e,
			[t.id]: !t.hiddenByDefault
		}, e));
	}, [We]);
	let Ke = DT({
		data: Oe,
		columns: Ge,
		state: {
			columnOrder: ye,
			rowSelection: Me,
			columnVisibility: xe,
			columnSizing: Ce,
			expanded: Te
		},
		onColumnOrderChange: ee ? be : void 0,
		onColumnVisibilityChange: Se,
		onColumnSizingChange: we,
		getCoreRowModel: bT(),
		columnResizeMode: "onChange",
		enableRowSelection: !0,
		onRowSelectionChange: Ne,
		onExpandedChange: Ee,
		getSubRows: m,
		getExpandedRowModel: m ? xT() : void 0
	}), qe = J(() => {});
	return /* @__PURE__ */ W(Kr, {
		gridTemplateRows: "auto 1fr auto",
		overflow: "hidden",
		height: "100%",
		width: "100%",
		role: "table",
		backgroundColor: "white",
		ref: ge,
		children: [
			/* @__PURE__ */ W(R, {
				width: "100%",
				overflow: "hidden",
				children: [/* @__PURE__ */ U(ZE, {
					filters: a,
					getTableState: Ke.getState,
					getTableAllFlatColumns: Ke.getAllFlatColumns,
					columnOrder: ye,
					setColumnOrder: be,
					viewSettingsHeader: h,
					additionalToolbarComponentsV3: g,
					loading: je,
					customColumns: {
						isEnabled: ze,
						available: p?.allEventProperties ?? [],
						selected: Pe,
						setSelected: Fe,
						menuLabel: p?.menuLabel,
						searchPlaceholder: p?.searchPlaceholder,
						inlineInAddColumnMenu: p?.inlineInAddColumnMenu
					},
					refClearFilters: qe,
					totalResultSize: ke,
					activeFilters: v,
					onChangeActiveFilters: y,
					onSaveFilters: C,
					onUpdateSavedFilters: w,
					lockedControls: T,
					enableColumnReordering: ee,
					groupableColumns: ie,
					groupBy: oe,
					onGroupBy: ae,
					sortBy: b,
					defaultSortBy: S,
					table: Ke,
					entityNamePlural: t,
					enableCopyResults: O
				}), n]
			}),
			/* @__PURE__ */ U(xD, {
				table: Ke,
				refContainer: he,
				rowVirtualizer: De,
				columnVisibility: xe,
				columnOrder: ye,
				setColumnOrder: be,
				hasFilters: Ae,
				totalResultSize: ke,
				containerWidth: _e,
				containerHeight: ve,
				showCheckboxes: Be,
				entityNamePlural: t,
				emptyStateFiltered: s,
				emptyStateUnfiltered: o,
				rowPath: l,
				onRowClick: u,
				setEventPropertyColumns: Fe,
				showExpandButtons: Ve,
				clearFilters: () => {
					qe.current();
				},
				loading: je,
				sortBy: b,
				onChangeSortBy: x,
				additionalTableHeaderRow: e.additionalTableHeaderRow,
				scrollAreaHeader: r,
				enableColumnReordering: ee,
				groupableColumns: ie,
				onGroupBy: ae,
				groupBy: oe,
				highlightRowGroup: se,
				disableActiveRowScroll: ne
			}),
			/* @__PURE__ */ U(TD, {
				totalResultSize: ke,
				rows: Oe,
				rowSelection: Me,
				setRowSelection: Ne,
				bulkActions: d?.bar,
				additionalComponents: _,
				loading: je
			})
		]
	});
}, oO = ({ to: e, label: t, "data-testid": n }) => {
	let r = zl();
	return /* @__PURE__ */ U(R, {
		padding: "8px 5px",
		children: /* @__PURE__ */ U(B, {
			"data-testid": n,
			borderWidth: "1px",
			borderColor: "transparent",
			borderRadius: "8px",
			width: "fit-content",
			alignItems: "center",
			gap: "8px",
			padding: "3px 6px",
			onClick: (t) => {
				t.preventDefault(), t.stopPropagation(), r(e);
			},
			color: y,
			_hover: {
				borderColor: Cn,
				cursor: "pointer"
			},
			children: /* @__PURE__ */ U(V, {
				overflow: "hidden",
				display: "-webkit-box",
				sx: {
					WebkitBoxOrient: "vertical",
					WebkitLineClamp: 1,
					lineBreak: "anywhere"
				},
				color: "inherit",
				...N,
				children: t
			})
		})
	});
}, sO = ({ children: e, gap: t, "data-testid": n }) => /* @__PURE__ */ U(B, {
	padding: "8px 12px",
	gap: t,
	"data-testid": n,
	children: e
}), cO = ({ invoiceStatus: e, paymentStatus: t }) => /* @__PURE__ */ W(sO, {
	gap: "8px",
	children: [/* @__PURE__ */ U(ig, { ...Vc({ status: e }) }), t && e === "SENT" && /* @__PURE__ */ U(ig, {
		truncate: !0,
		...Bc({ status: t })
	})]
}), lO = ({ status: e, applicationStatus: t }) => /* @__PURE__ */ W(sO, {
	gap: "8px",
	children: [/* @__PURE__ */ U(ig, { ...Rc({ status: e }) }), Ac(t) && /* @__PURE__ */ U(ig, {
		truncate: !0,
		...Lc({ status: t })
	})]
}), uO = {
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	ACTIVE: {
		children: "Active",
		sentiment: "info"
	},
	ARCHIVED: {
		children: "Archived",
		sentiment: "error"
	}
}, dO = ({ status: e, size: t = "md" }) => ({
	...uO[e],
	size: t
}), fO = ({ productStatus: e }) => /* @__PURE__ */ U(R, {
	padding: "8px 12px",
	children: /* @__PURE__ */ U(ig, { ...dO({ status: e }) })
}), pO = ({ status: e, isArchived: t, isPublished: n, isExpired: r, hasApprovalWorkflow: i }) => /* @__PURE__ */ W(sO, {
	gap: "8px",
	children: [/* @__PURE__ */ U(ig, {
		truncate: !0,
		...Wc({
			status: e,
			isPublished: n,
			isExpired: r,
			hasApprovalWorkflow: i
		})
	}), t && /* @__PURE__ */ U(ig, {
		sentiment: "neutral",
		size: "md",
		truncate: !0,
		children: "Archived"
	})]
}), mO = ({ status: e, isArchived: t }) => /* @__PURE__ */ U(R, {
	padding: "8px 12px",
	children: /* @__PURE__ */ W(B, { children: [/* @__PURE__ */ U(ig, { ...Ic({ status: e }) }), t && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(R, { width: "8px" }), /* @__PURE__ */ U(ig, {
		sentiment: "neutral",
		size: "md",
		children: "Archived"
	})] })] })
}), hO = ({ aggregationType: e }) => /* @__PURE__ */ U(R, {
	padding: "8px 12px",
	children: /* @__PURE__ */ U(ig, {
		sentiment: "neutral",
		size: "md",
		children: e
	})
}), gO = () => {
	let { search: e, pathname: t } = Rl();
	return {
		persistMagicTableQueryParams: (n, r = !1) => n !== t && r ? n : `${n}${e}`,
		magicTableQueryParams: e
	};
}, _O = () => ({}), vO = () => [], yO = (() => {}), bO = (() => {}), xO = ({ filters: e, activeFilters: t, onChangeActiveFilters: n, lockedControls: r, gap: i = "8px", flexWrap: a = "wrap", alignItems: o = "center" }) => {
	let s = J(() => {});
	return /* @__PURE__ */ U(HT, {
		filters: e,
		activeFilters: t,
		onChangeActiveFilters: n,
		lockedControls: r,
		columnOrder: [],
		getTableState: _O,
		getTableAllFlatColumns: vO,
		setColumnOrder: yO,
		loading: !1,
		customColumns: {
			isEnabled: !1,
			available: [],
			selected: [],
			setSelected: bO
		},
		refClearFilters: s,
		totalResultSize: 2 ** 53 - 1,
		children: /* @__PURE__ */ W(B, {
			gap: i,
			flexWrap: a,
			alignItems: o,
			children: [/* @__PURE__ */ U(TE, {}), /* @__PURE__ */ U(jE, {})]
		})
	});
}, SO = (e, t = { limit: 100 }) => {
	let n = Vu(e, t, {
		staleTime: 1e3 * 5,
		select: (e) => ({
			pages: [{
				items: e?.items ?? [],
				pagination: {
					totalResultSize: e?.items.length ?? 0,
					after: "",
					before: ""
				}
			}],
			pageParams: []
		})
	});
	return { query: {
		...n,
		fetchNextPage: () => n.data,
		hasNextPage: !1,
		isFetchingNextPage: !1
	} };
}, CO = (e) => {
	let { infiniteQuery: t, activeFilters: n, pageSize: r } = e, [i, a] = Y([]), [o, s] = Y({
		loading: !1,
		loaded: !1
	}), c = q(() => t.data?.pages.flatMap((e) => e.items) ?? [], [t.data]), l = t.data?.pages[0]?.pagination.totalResultSize ?? 0, u = i.length, d = c.length, f = q(() => o.loading ? !0 : l === u && !o.loaded && l <= r ? !1 : u === d, [
		o.loading,
		o.loaded,
		l,
		u,
		d,
		r
	]), p = f && l === u, m = () => {
		s({
			loading: !0,
			loaded: !1
		});
	}, h = () => {
		a([]), s({
			loading: !1,
			loaded: !1
		});
	};
	K(() => {
		if (!o.loading) return;
		let e = c.map((e) => e.id);
		if (t.error) {
			a(e), s({
				loading: !1,
				loaded: !1
			});
			return;
		}
		t.hasNextPage && !t.isFetchingNextPage && t.fetchNextPage(), !t.hasNextPage && !t.isFetchingNextPage && (a(e), s({
			loading: !1,
			loaded: !0
		}));
	}, [
		o,
		t,
		c
	]);
	let g = Yc(n);
	return K(() => {
		eu(g, n) || (a([]), s({
			loading: !1,
			loaded: !1
		}));
	}, [n, g]), {
		selectedIds: i,
		setSelectedIds: a,
		selectAll: {
			showPrompt: f,
			showClearSelection: p,
			onSelectAll: m,
			onClearSelection: h,
			loading: o.loading,
			total: l,
			totalSelected: u
		}
	};
}, wO = ({ entityName: e, total: t, totalSelected: n, showClearSelection: r, onClearSelection: i, onSelectAll: a, loading: o, visibleTableWidth: s }) => {
	let c = `${e}.selectAllPrompt`;
	return /* @__PURE__ */ U(B, {
		"data-testid": c,
		...N,
		backgroundColor: yt,
		color: wn,
		position: "relative",
		borderBottom: `1px solid ${P}`,
		children: /* @__PURE__ */ U(B, {
			padding: "0 10px",
			height: "36px",
			width: s ? `${s}px` : "100%",
			position: "relative",
			transition: "width 0.25s",
			children: /* @__PURE__ */ W(B, {
				alignItems: "center",
				justifyContent: "center",
				width: "100%",
				gap: "4px",
				children: [
					"All ",
					n,
					" ",
					e,
					" on this page are selected.",
					" ",
					r ? /* @__PURE__ */ U(R, {
						...j,
						color: y,
						onClick: i,
						cursor: "pointer",
						"data-testid": `${c}.clear`,
						children: "Clear selection"
					}) : /* @__PURE__ */ W(R, {
						...j,
						opacity: o ? .7 : 1,
						color: y,
						onClick: () => !o && a(),
						cursor: o ? "not-allowed" : "pointer",
						marginRight: "2px",
						transition: "opacity 0.25s",
						"data-testid": `${c}.selectAll`,
						children: [
							"Select all ",
							t,
							" ",
							e
						]
					}),
					o && /* @__PURE__ */ U(ki, {
						"data-testid": `${c}.loading`,
						height: "14px",
						width: "14px",
						color: "#d97706"
					})
				]
			})
		})
	});
}, TO = (e) => {
	let t = typeof e == "object" && !!e;
	return hc(e) || !t;
}, EO = ({ "data-testid": e, entityNamePlural: t, imageSrc: n, learnMoreText: r, learnMoreHref: i, buttonNew: a }) => /* @__PURE__ */ U(z, {
	height: "100%",
	background: I,
	children: /* @__PURE__ */ W(B, {
		"data-testid": e ?? "magicTable.emptyState",
		width: "280px",
		flexDir: "column",
		gap: "8px",
		alignItems: "center",
		children: [/* @__PURE__ */ U(R, {
			width: "217px",
			height: "200px",
			children: /* @__PURE__ */ U(Qr, {
				src: n,
				width: "100%",
				height: "100%",
				objectFit: "contain"
			})
		}), /* @__PURE__ */ W(B, {
			flexDir: "column",
			textAlign: "center",
			gap: "16px",
			alignItems: "center",
			children: [/* @__PURE__ */ W(B, {
				flexDir: "column",
				gap: "4px",
				children: [/* @__PURE__ */ W(V, {
					...ar,
					color: L,
					children: [
						"No ",
						t,
						" to show"
					]
				}), /* @__PURE__ */ W(V, {
					...N,
					color: k,
					children: [
						r,
						", ",
						/* @__PURE__ */ U(ri, {
							href: i,
							color: y,
							children: "learn more"
						})
					]
				})]
			}), TO(a) ? a : a != null && /* @__PURE__ */ U(Q, {
				variant: "primary",
				leadingIcon: /* @__PURE__ */ U(dh, {}),
				onClick: a.onClick,
				children: a.label
			})]
		})]
	})
}), DO = ({ entityIcon: e, entityNamePlural: t, actionClearFilters: n, actionViewAll: r, variant: i, "data-testid": a }) => {
	let o = X(i).with("TABLE", () => `Your filters have not returned any ${t}, try clearing or changing your filters.`).with("SAVED_VIEW", () => `Your saved view has not returned any ${t}.`).exhaustive(), s = X(i).with("TABLE", () => /* @__PURE__ */ U(Q, {
		variant: "secondary",
		leadingIcon: /* @__PURE__ */ U(im, {}),
		onClick: n,
		children: "Clear filters"
	})).with("SAVED_VIEW", () => /* @__PURE__ */ W(Q, {
		variant: "secondary",
		onClick: r,
		children: ["View all ", t]
	})).exhaustive();
	return /* @__PURE__ */ U(z, {
		background: I,
		height: "100%",
		children: /* @__PURE__ */ U(R, {
			width: "360px",
			"data-testid": a ?? "magicTable.filter.emptyState",
			children: /* @__PURE__ */ U(aC, {
				icon: e,
				title: `No ${t} to show`,
				body: o,
				button: s
			})
		})
	});
}, OO = Object.assign(({ children: e, backgroundUrl: t, environment: n, logo: r }) => {
	let i = J(null);
	return K(() => {
		document.addEventListener("pointermove", (e) => {
			let t = e.clientX / window.innerWidth * 100, n = e.clientY / window.innerHeight * 100;
			i.current?.style.setProperty("--mouse-x", t + "%"), i.current?.style.setProperty("--mouse-y", n + "%");
		});
	}, []), /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(R, {
			"data-testid": "authEnvironmentBanner",
			width: "100%",
			position: "fixed",
			zIndex: 3,
			children: n === "demo" ? /* @__PURE__ */ W(mx, {
				environment: n,
				children: [
					"Demo -",
					" ",
					/* @__PURE__ */ U(ri, {
						href: "https://access.sequencehq.com",
						isExternal: !0,
						children: "Request a Sandbox"
					})
				]
			}) : /* @__PURE__ */ U(mx, { environment: n })
		}),
		r,
		/* @__PURE__ */ W(B, {
			height: "100vh",
			width: "100%",
			direction: "row",
			position: "relative",
			children: [
				/* @__PURE__ */ U(B, {
					width: {
						base: "100%",
						lg: "50%"
					},
					backgroundColor: I,
					direction: "column",
					position: "relative",
					alignItems: "center",
					justifyContent: "center",
					padding: "0 40px",
					minHeight: "100vh",
					children: /* @__PURE__ */ U(B, {
						"data-testid": "authUI.content",
						direction: "column",
						alignItems: "center",
						justifyContent: "center",
						width: "100%",
						maxWidth: "480px",
						margin: "0 auto",
						children: e
					})
				}),
				/* @__PURE__ */ U(R, {
					display: {
						base: "none",
						lg: "block"
					},
					width: "50%",
					height: "100vh",
					position: "relative",
					bgImage: `url('${t}')`,
					bgSize: "cover",
					bgPosition: "top left",
					bgRepeat: "no-repeat"
				}),
				/* @__PURE__ */ U(R, {
					display: {
						base: "block",
						lg: "none"
					},
					position: "absolute",
					top: "0",
					left: "0",
					width: "100%",
					height: "100%",
					backgroundColor: I,
					zIndex: -1
				})
			]
		})
	] });
}, { Section: ({ children: e, ...t }) => /* @__PURE__ */ U(B, {
	backgroundColor: "white",
	maxWidth: "480px",
	width: "100%",
	flexDirection: "column",
	gap: "24px",
	...t,
	children: e
}) }), kO = {
	fontSize: Qt.fontSize,
	borderRadius: "8px"
}, AO = "[A-Za-z0-9._%+\\-]+@(?:[A-Za-z0-9\\-]+\\.)+[A-Za-z]{2,}", jO = ({ "data-testid": e, value: t, onChange: n, isInvalid: r, onInvalid: i, onBlur: a }) => /* @__PURE__ */ U(Lg, {
	"data-testid": e,
	value: t,
	onChange: n,
	placeholder: "Email address",
	type: "email",
	height: "40px",
	fontSize: "14px",
	borderRadius: "8px",
	autoFocus: !0,
	isRequired: !0,
	isInvalid: r,
	pattern: AO,
	onInvalid: i,
	onBlur: a
}), MO = () => /* @__PURE__ */ W(B, {
	role: "separator",
	"aria-label": "Or",
	alignItems: "center",
	gap: "12px",
	width: "100%",
	children: [
		/* @__PURE__ */ U(R, {
			"aria-hidden": !0,
			height: "1px",
			flex: "1",
			backgroundImage: `linear-gradient(to right, transparent, ${M})`
		}),
		/* @__PURE__ */ U(V, {
			"aria-hidden": !0,
			...Qt,
			color: F,
			children: "Or"
		}),
		/* @__PURE__ */ U(R, {
			"aria-hidden": !0,
			height: "1px",
			flex: "1",
			backgroundImage: `linear-gradient(to left, transparent, ${M})`
		})
	]
}), NO = ({ email: e, setEmail: t, setStage: n, onSubmit: r, nextStage: i = "CHECK_EMAIL", contentWidth: a, header: o, submitLabel: s = "Continue", footer: c, socialOptions: l = [], ssoEntry: u }) => {
	let [d, f] = Y(!1), [p, m] = Y(null), [h, g] = Y(!1), [_, v] = Y(!1), y = Pl(), b = () => {
		y.start({
			x: [
				0,
				-4,
				8,
				-8,
				4,
				0
			],
			transition: { duration: .5 }
		});
	}, x = async (t) => {
		if (t.preventDefault(), !e || d) {
			b();
			return;
		}
		let a = t.currentTarget.querySelector("input[type=\"email\"]");
		if (a && !a.checkValidity()) {
			_ || b(), v(!0);
			return;
		}
		v(!1), f(!0);
		try {
			if (await r(e) === !1) {
				f(!1);
				return;
			}
			n(i);
		} catch (e) {
			console.error("Failed to send magic link:", e), f(!1);
		}
	}, S = async (e) => {
		if (!p) {
			m(e.id), g(!1);
			try {
				await e.onSelect();
			} catch {
				g(!0), m(null);
			}
		}
	};
	K(() => {
		let e = (e) => {
			e.persisted && m(null);
		};
		return window.addEventListener("pageshow", e), () => window.removeEventListener("pageshow", e);
	}, []);
	let C = l.length > 0 || !!u;
	return /* @__PURE__ */ W(OO.Section, {
		as: Nl.section,
		animate: y,
		children: [
			/* @__PURE__ */ U(Nl.div, {
				initial: {
					transform: "translateY(20px)",
					opacity: 0
				},
				animate: {
					transform: "translateY(0px)",
					opacity: 1
				},
				transition: {
					duration: .2,
					ease: "easeOut"
				},
				style: {
					willChange: "transform, opacity",
					width: a ? `min(100%, ${a})` : void 0
				},
				children: o
			}),
			C && /* @__PURE__ */ U(Nl.div, {
				initial: {
					transform: "translateY(20px)",
					opacity: 0
				},
				animate: {
					transform: "translateY(0px)",
					opacity: 1
				},
				transition: {
					duration: .2,
					ease: "easeOut"
				},
				style: {
					willChange: "transform, opacity",
					width: "100%"
				},
				children: /* @__PURE__ */ W(B, {
					flexDirection: "column",
					gap: "16px",
					width: "100%",
					children: [
						l.map((e) => /* @__PURE__ */ U(Q, {
							"data-testid": `authUI.emailLoginForm.socialEntry.${e.id}`,
							variant: "secondary",
							fullWidth: !0,
							size: "40px",
							style: kO,
							leadingIcon: e.icon,
							disabled: p !== null,
							submitting: p === e.id,
							onClick: () => {
								S(e);
							},
							children: e.label
						}, e.id)),
						h && /* @__PURE__ */ U(V, {
							...Qt,
							role: "alert",
							"data-testid": "authUI.emailLoginForm.socialEntryError",
							color: "#dc2626",
							textAlign: "left",
							children: "We couldn't reach that provider. Please try again."
						}),
						u && /* @__PURE__ */ U(Q, {
							"data-testid": "authUI.emailLoginForm.ssoEntry",
							variant: "secondary",
							fullWidth: !0,
							size: "40px",
							style: kO,
							leadingIcon: /* @__PURE__ */ U(Gm, {}),
							disabled: p !== null,
							onClick: u.onClick,
							children: u.label
						}),
						/* @__PURE__ */ U(MO, {})
					]
				})
			}),
			/* @__PURE__ */ U(Nl.div, {
				initial: {
					transform: "translateY(20px)",
					opacity: 0
				},
				animate: {
					transform: "translateY(0px)",
					opacity: 1
				},
				transition: {
					duration: .2,
					ease: "easeOut"
				},
				style: {
					willChange: "transform, opacity",
					width: a ? `min(100%, ${a})` : void 0
				},
				children: /* @__PURE__ */ W(B, {
					as: "form",
					onSubmit: (e) => {
						x(e);
					},
					onInvalid: () => {
						_ || b(), v(!0);
					},
					flexDirection: "column",
					gap: "16px",
					width: "100%",
					children: [/* @__PURE__ */ U(jO, {
						"data-testid": "authUI.emailLoginForm.emailInput",
						value: e,
						onChange: (e) => {
							if (t(e), _) {
								let e = document.querySelector("input[type=\"email\"]");
								e && e.checkValidity() && v(!1);
							}
						},
						isInvalid: _,
						onInvalid: () => {
							v(!0);
						},
						onBlur: () => {
							_ && v(!1);
						}
					}), /* @__PURE__ */ U(Nl.div, {
						initial: { transform: "translateY(-20px)" },
						animate: { transform: "translateY(0px)" },
						transition: {
							duration: .2,
							ease: "easeOut"
						},
						style: { willChange: "transform, opacity" },
						children: /* @__PURE__ */ U(Q, {
							"data-testid": "authUI.emailLoginForm.submitButton",
							variant: "primary",
							fullWidth: !0,
							type: "submit",
							size: "40px",
							style: kO,
							disabled: d,
							children: /* @__PURE__ */ W(B, {
								gap: "8px",
								alignItems: "center",
								children: [d && /* @__PURE__ */ U(ki, {
									height: "16px",
									width: "16px",
									color: "white"
								}), s]
							})
						})
					})]
				})
			}),
			/* @__PURE__ */ U(Nl.div, {
				initial: {
					transform: "translateY(-20px)",
					opacity: 0
				},
				animate: {
					transform: "translateY(0px)",
					opacity: 1
				},
				transition: {
					duration: .2,
					ease: "easeOut"
				},
				style: {
					willChange: "transform, opacity",
					width: "100%"
				},
				children: c
			})
		]
	});
}, PO = ({ email: e, header: t, subjectLineFilter: n, setStage: r }) => {
	let i = `%22${n.replace(/ /g, "+")}%22`;
	return /* @__PURE__ */ W(OO.Section, {
		"data-testid": "authUI.checkEmail",
		gap: "0",
		padding: 0,
		overflow: "hidden",
		children: [
			/* @__PURE__ */ W(B, {
				flexDirection: "column",
				gap: "8px",
				children: [t, /* @__PURE__ */ W(V, {
					...Qt,
					color: L,
					children: [
						"An email was sent to ",
						/* @__PURE__ */ U("strong", { children: e }),
						". The sign in link expires shortly and can only be used once."
					]
				})]
			}),
			/* @__PURE__ */ W(B, {
				width: "100%",
				border: "1px solid",
				borderColor: M,
				flexDirection: "column",
				borderRadius: "8px",
				boxShadow: Pn,
				overflow: "hidden",
				marginTop: "24px",
				marginBottom: "24px",
				children: [/* @__PURE__ */ W(ri, {
					href: `https://mail.google.com/mail/u/0/#advanced-search/subset=all&has=${i}`,
					target: "_blank",
					_hover: {
						textDecoration: "none",
						backgroundColor: A
					},
					display: "flex",
					alignItems: "center",
					width: "100%",
					px: "16px",
					py: "12px",
					color: L,
					borderBottom: "1px solid",
					borderBottomColor: M,
					_focus: { boxShadow: "none" },
					children: [
						/* @__PURE__ */ U(Wf, {}),
						/* @__PURE__ */ U(V, {
							flex: "1",
							textAlign: "left",
							ml: "16px",
							...ar,
							children: "Open Gmail"
						}),
						/* @__PURE__ */ U(pp, { color: k })
					]
				}), /* @__PURE__ */ W(ri, {
					href: "https://outlook.office.com/mail/",
					target: "_blank",
					_hover: {
						textDecoration: "none",
						backgroundColor: A
					},
					display: "flex",
					alignItems: "center",
					width: "100%",
					px: "16px",
					py: "12px",
					color: L,
					_focus: { boxShadow: "none" },
					children: [
						/* @__PURE__ */ U(Gf, {}),
						/* @__PURE__ */ U(V, {
							flex: "1",
							textAlign: "left",
							ml: "16px",
							...ar,
							children: "Open Outlook"
						}),
						/* @__PURE__ */ U(pp, { color: k })
					]
				})]
			}),
			/* @__PURE__ */ W(V, {
				...Qt,
				textAlign: "left",
				color: F,
				children: [
					"No email? Check your spam folder or",
					" ",
					/* @__PURE__ */ U(V, {
						...Qt,
						as: "span",
						color: y,
						onClick: () => {
							r("FORM");
						},
						cursor: "pointer",
						_hover: { textDecoration: "underline" },
						children: "try again"
					})
				]
			})
		]
	});
}, FO = ({ children: e }) => /* @__PURE__ */ U(Nl.div, {
	initial: {
		transform: "translateY(20px)",
		opacity: 0
	},
	animate: {
		transform: "translateY(0px)",
		opacity: 1
	},
	transition: {
		duration: .2,
		ease: "easeOut"
	},
	style: {
		willChange: "transform, opacity",
		width: "100%"
	},
	children: e
}), IO = ({ header: e, helper: t }) => /* @__PURE__ */ U(FO, { children: /* @__PURE__ */ W(B, {
	flexDirection: "column",
	gap: "8px",
	width: "100%",
	children: [e, t]
}) }), LO = ({ email: e, setEmail: t, header: n, helper: r, submitLabel: i, noConnectionsMessage: a, unavailableMessage: o, magicLinkLabel: s, onSubmit: c, onUseMagicLink: l }) => {
	let [u, d] = Y(!1), [f, p] = Y(null), m = f?.email === e ? f.status : null, h = async (t) => {
		if (t.preventDefault(), !e || u) return;
		let n = e;
		d(!0);
		let r = await c(n);
		r !== "found" && (p({
			email: n,
			status: r
		}), d(!1));
	};
	return /* @__PURE__ */ W(OO.Section, {
		"data-testid": "authUI.ssoEmail",
		children: [
			/* @__PURE__ */ U(IO, {
				header: n,
				helper: r
			}),
			/* @__PURE__ */ W(B, {
				as: "form",
				onSubmit: (e) => {
					h(e);
				},
				flexDirection: "column",
				gap: "16px",
				width: "100%",
				children: [
					/* @__PURE__ */ U(jO, {
						"data-testid": "authUI.ssoEmail.emailInput",
						value: e,
						onChange: t,
						isInvalid: m !== null
					}),
					m && /* @__PURE__ */ U(V, {
						...Qt,
						role: "alert",
						"data-testid": m === "none" ? "authUI.ssoEmail.noConnections" : "authUI.ssoEmail.unavailable",
						color: "#dc2626",
						textAlign: "left",
						children: m === "none" ? a : o
					}),
					/* @__PURE__ */ U(Q, {
						"data-testid": "authUI.ssoEmail.submitButton",
						variant: "primary",
						fullWidth: !0,
						type: "submit",
						size: "40px",
						style: kO,
						submitting: u,
						children: i
					})
				]
			}),
			/* @__PURE__ */ U(Q, {
				"data-testid": "authUI.ssoEmail.useMagicLink",
				variant: "unstyled",
				disabled: u,
				style: {
					...Qt,
					color: y
				},
				onClick: l,
				children: s
			})
		]
	});
}, RO = {
	start: "We couldn't reach that provider. Please try again.",
	send: "We couldn't send that email. Please try again."
}, zO = {
	display: "flex",
	alignItems: "center",
	width: "100%",
	height: "48px",
	padding: "0 16px",
	borderRadius: 0,
	fontSize: Qt.fontSize,
	color: L
}, BO = ({ header: e, helper: t, magicLinkLabel: n, goBackLabel: r, options: i, onSelectOption: a, onUseMagicLink: o, onUseDifferentEmail: s }) => {
	let [c, l] = Y(null), [u, d] = Y(null), f = c !== null, p = async (e, t) => {
		if (!f) {
			l(e), d(null);
			try {
				await t();
			} catch {
				d(e.kind === "sso" ? "start" : "send"), l(null);
			}
		}
	};
	return /* @__PURE__ */ W(OO.Section, {
		"data-testid": "authUI.selectConnection",
		children: [
			/* @__PURE__ */ U(IO, {
				header: e,
				helper: t
			}),
			/* @__PURE__ */ U(B, {
				width: "100%",
				border: "1px solid",
				borderColor: M,
				flexDirection: "column",
				borderRadius: "8px",
				boxShadow: Pn,
				overflow: "hidden",
				css: { "& > *:not(:last-child)": {
					borderBottom: "1px solid",
					borderColor: M
				} },
				children: i.map((e) => /* @__PURE__ */ W(Q, {
					"data-testid": `authUI.selectConnection.option.${e.id}`,
					variant: "unstyled",
					disabled: f,
					onClick: () => {
						p({
							kind: "sso",
							id: e.id
						}, () => a(e));
					},
					style: zO,
					children: [/* @__PURE__ */ W(R, {
						flex: "1",
						textAlign: "left",
						children: ["Continue with ", e.label]
					}), c?.kind === "sso" && c.id === e.id ? /* @__PURE__ */ U(ki, {
						height: "16px",
						width: "16px"
					}) : /* @__PURE__ */ U(pp, { color: k })]
				}, e.id))
			}),
			/* @__PURE__ */ U(MO, {}),
			/* @__PURE__ */ W(B, {
				flexDirection: "column",
				gap: "16px",
				width: "100%",
				children: [
					u && /* @__PURE__ */ U(V, {
						...Qt,
						role: "alert",
						"data-testid": `authUI.selectConnection.${u}Error`,
						color: "#dc2626",
						textAlign: "left",
						children: RO[u]
					}),
					/* @__PURE__ */ U(Q, {
						"data-testid": "authUI.selectConnection.useMagicLink",
						variant: "secondary",
						fullWidth: !0,
						size: "40px",
						style: kO,
						disabled: f,
						submitting: c?.kind === "magicLink",
						onClick: () => {
							p({ kind: "magicLink" }, o);
						},
						children: n
					}),
					/* @__PURE__ */ W(B, {
						alignItems: "center",
						gap: "4px",
						children: [/* @__PURE__ */ U(V, {
							...Qt,
							color: F,
							children: "Wrong email?"
						}), /* @__PURE__ */ U(Q, {
							"data-testid": "authUI.selectConnection.useDifferentEmail",
							variant: "unstyled",
							disabled: f,
							style: {
								...Qt,
								color: y,
								height: "auto"
							},
							onClick: s,
							children: r
						})]
					})
				]
			})
		]
	});
}, VO = Al`
  0%, 70% { opacity: 1; }
  20%, 50% { opacity: 0; }
`, HO = Ol.div`
  position: absolute;
  inset: 0;
  margin: auto;
  width: 1px;
  height: 24px;
  background-color: ${L};
  pointer-events: none;
  animation: ${VO} 1250ms ease-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`, UO = kl`
  &[data-active='true'] {
    border-color: ${C};
  }

  /* The left edge of an active slot is the previous slot's right border. */
  &:has(+ [data-active='true']) {
    border-right-color: ${C};
  }
`, WO = Ol.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 66px;
  height: 64px;
  ${kl(ve)}
  color: ${L};
  background-color: ${I};
  border: 1px solid ${M};
  border-left-width: 0;
  outline: none;
  transition: border-color 150ms ease;

  &:first-of-type {
    border-left-width: 1px;
    border-radius: ${"6px"} 0 0 ${"6px"};
  }

  &:last-of-type {
    border-radius: 0 ${"6px"} ${"6px"} 0;
  }

  ${UO}
`, GO = Ol.div`
  display: flex;
  align-items: center;
  min-width: 0;
  border-radius: ${"6px"};

  &[aria-invalid='true'] ${WO} {
    border-color: ${En};

    ${UO}
  }
`, KO = Ol.div`
  display: flex;
  align-items: center;
`, qO = Ol.div`
  [data-input-otp-container] {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &:has([data-input-otp]:disabled) ${WO} {
    background-color: ${A};
    color: ${en};
  }

  [data-input-otp]:disabled {
    cursor: not-allowed;
  }
`, JO = mc((e, t) => /* @__PURE__ */ U(qO, { children: /* @__PURE__ */ U(Wu, {
	...e,
	ref: t,
	"data-testid": e["data-testid"] ?? "inputOTP"
}) }));
JO.displayName = "InputOTP";
var YO = ({ isInvalid: e = !1, ...t }) => /* @__PURE__ */ U(GO, {
	"aria-invalid": e || void 0,
	...t
}), XO = ({ index: e, ...t }) => {
	let { char: n, hasFakeCaret: r, isActive: i } = _c(Gu).slots?.at(e) ?? {};
	return /* @__PURE__ */ W(WO, {
		"data-testid": `inputOTP.slot.${e}`,
		"data-active": i,
		...t,
		children: [n, r && /* @__PURE__ */ U(HO, {})]
	});
}, ZO = (e) => /* @__PURE__ */ U(KO, {
	role: "separator",
	...e,
	children: /* @__PURE__ */ U(Zm, { color: en })
}), QO = 6, $O = Ol(B)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media (min-width: 48em) {
    width: 396px;
  }
`, ek = Ol(YO)`
  width: 100%;

  > div {
    width: calc(100% / ${QO});
  }

  @media (min-width: 48em) {
    > div {
      width: 66px;
    }
  }
`, tk = ({ email: e, footer: t, error: n, isSending: r = !1, isVerifying: i = !1, onVerifyCode: a, onResendCode: o }) => {
	let [s, c] = Y("");
	return /* @__PURE__ */ W(OO.Section, {
		"data-testid": "authUI.emailLoginForm.enterCode",
		children: [/* @__PURE__ */ U(FO, { children: /* @__PURE__ */ W($O, { children: [/* @__PURE__ */ W(B, {
			flexDirection: "column",
			gap: "8px",
			children: [/* @__PURE__ */ U(V, {
				...cr,
				color: Ft,
				"data-testid": "authUI.emailLoginForm.enterCode.heading",
				children: "Enter your code"
			}), /* @__PURE__ */ W(V, {
				...Qt,
				color: L,
				"data-testid": "authUI.emailLoginForm.enterCode.message",
				children: [
					"We’ve sent a ",
					QO,
					"-digit code to",
					" ",
					/* @__PURE__ */ U(V, {
						as: "strong",
						children: e
					}),
					". Enter it below to continue."
				]
			})]
		}), /* @__PURE__ */ W(B, {
			flexDirection: "column",
			gap: "16px",
			children: [/* @__PURE__ */ W(B, {
				flexDirection: "column",
				gap: "8px",
				children: [/* @__PURE__ */ U(JO, {
					"data-testid": "authUI.emailLoginForm.enterCode.input",
					maxLength: QO,
					pattern: qu,
					value: s,
					onChange: c,
					disabled: i || r,
					autoFocus: !0,
					children: /* @__PURE__ */ U(ek, {
						isInvalid: !!n,
						children: Array.from({ length: QO }, (e, t) => /* @__PURE__ */ U(XO, { index: t }, t))
					})
				}), n && /* @__PURE__ */ U(V, {
					...tr,
					color: "#dc2626",
					role: "alert",
					"data-testid": "authUI.emailLoginForm.enterCode.error",
					children: n
				})]
			}), /* @__PURE__ */ W(B, {
				flexDirection: "column",
				gap: "8px",
				children: [/* @__PURE__ */ U(Q, {
					"data-testid": "authUI.emailLoginForm.enterCode.verifyButton",
					variant: "primary",
					fullWidth: !0,
					size: "40px",
					style: kO,
					disabled: r || s.length !== QO,
					submitting: i,
					submittingText: "Verifying...",
					onClick: () => {
						a(s).then(() => c(""));
					},
					children: "Verify and continue"
				}), /* @__PURE__ */ U(B, {
					alignSelf: "flex-start",
					children: /* @__PURE__ */ U(Q, {
						"data-testid": "authUI.emailLoginForm.enterCode.resendButton",
						variant: "unstyled",
						size: "auto",
						color: y,
						...Qt,
						disabled: i,
						submitting: r,
						submittingText: "Sending...",
						onClick: () => {
							c(""), o();
						},
						children: "Resend code"
					})
				})]
			})]
		})] }) }), /* @__PURE__ */ U(B, {
			width: "max-content",
			maxWidth: "calc(100vw - 32px)",
			whiteSpace: "nowrap",
			"data-testid": "authUI.emailLoginForm.enterCode.footer",
			children: t
		})]
	});
}, nk = 5 * Xc, rk = { status: "unavailable" }, ik = (e, t) => {
	if (!e) return Promise.resolve({ status: "none" });
	let n = Promise.resolve().then(() => e(t)).then((e) => e.length > 0 ? {
		status: "found",
		options: e
	} : { status: "none" }).catch(() => rk), r, i = new Promise((e) => {
		r = setTimeout(() => e(rk), nk);
	});
	return Promise.race([n, i]).finally(() => {
		clearTimeout(r);
	});
}, ak = (e) => {
	let [t] = Bl(), [n, r] = Y(t.get("email") || ""), [i, a] = Y("FORM"), [o, s] = Y([]), c = async () => {
		await e.onSubmit(n), a("CHECK_EMAIL");
	}, l = async (t) => {
		let n = await ik(e.ssoStage?.resolveOptions, t);
		return n.status === "found" && (s(n.options), a("SELECT_CONNECTION")), n.status;
	};
	return X(i).with("FORM", () => /* @__PURE__ */ U(NO, {
		email: n,
		setEmail: r,
		setStage: a,
		onSubmit: e.otpStage?.onSendCode ?? e.onSubmit,
		nextStage: e.otpStage ? "ENTER_CODE" : "CHECK_EMAIL",
		contentWidth: e.otpStage ? "396px" : void 0,
		socialOptions: e.socialOptions,
		ssoEntry: e.ssoStage && {
			label: e.ssoStage.entryLabel,
			onClick: () => {
				a("SSO_EMAIL");
			}
		},
		...e.formStage
	})).with("CHECK_EMAIL", () => /* @__PURE__ */ U(PO, {
		email: n,
		setStage: a,
		...e.checkEmailStage
	})).with("ENTER_CODE", () => e.otpStage ? /* @__PURE__ */ U(tk, {
		email: n,
		footer: e.formStage.footer,
		...e.otpStage
	}) : null).with("SSO_EMAIL", () => e.ssoStage ? /* @__PURE__ */ U(LO, {
		email: n,
		setEmail: r,
		onSubmit: l,
		onUseMagicLink: () => {
			a("FORM");
		},
		...e.ssoStage.email
	}) : null).with("SELECT_CONNECTION", () => e.ssoStage ? /* @__PURE__ */ U(BO, {
		options: o,
		onSelectOption: e.ssoStage.onSelectOption,
		onUseMagicLink: c,
		onUseDifferentEmail: () => {
			a("SSO_EMAIL");
		},
		...e.ssoStage.connections
	}) : null).exhaustive();
}, ok = Object.assign({}, {
	Group: ({ items: e, children: t, onDragEnd: n, modifiers: r = [] }) => /* @__PURE__ */ U(Du, {
		sensors: ju(Au(Ou)),
		collisionDetection: ku,
		onDragEnd: n,
		modifiers: r,
		children: /* @__PURE__ */ U(Mu, {
			items: e,
			strategy: Fu,
			children: t
		})
	}),
	Item: ({ children: e, id: t }) => {
		let { attributes: n, listeners: r, setNodeRef: i, transform: a, transition: o, active: s } = Pu({ id: t }), c = !!s && s.id === t;
		return /* @__PURE__ */ U("div", {
			ref: i,
			style: {
				transform: Lu.Translate.toString(a),
				transition: o,
				...c ? {
					position: "relative",
					zIndex: 1
				} : {}
			},
			children: e({
				attributes: n,
				listeners: r
			})
		});
	}
}), sk = (e) => {
	let t = G((t) => {
		t.key === "Enter" && (t.preventDefault(), t.stopPropagation(), e.onClick());
	}, [e.onClick]);
	return /* @__PURE__ */ W(B, {
		"data-testid": e["data-testid"],
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		borderRadius: "6px",
		padding: "8px 10px",
		gap: "8px",
		transition: "background-color 0.2s ease-in-out",
		userSelect: "none",
		border: `1px dashed ${M}`,
		...N,
		...e.isDisabled ? {
			color: en,
			cursor: "not-allowed"
		} : {
			color: L,
			onClick: e.onClick,
			onKeyDown: t,
			cursor: "pointer",
			_hover: { backgroundColor: A },
			_focus: {
				backgroundColor: A,
				outline: "none"
			}
		},
		tabIndex: e.isDisabled ? -1 : 0,
		role: "button",
		children: [/* @__PURE__ */ U(dh, {}), e.text]
	});
}, ck = (e) => X(e).with("default", () => ({ marginBottom: "32px" })).with("emphasized", () => ({
	backgroundColor: A,
	borderRadius: "6px",
	width: "100%",
	padding: "8px",
	...N
})).exhaustive(), lk = ({ children: e, title: t, variant: n = "default", "data-testid": r, ...i }) => /* @__PURE__ */ W(R, {
	"data-testid": r,
	...ck(n),
	...i,
	children: [t && /* @__PURE__ */ U(V, {
		...j,
		color: "#1e293b",
		marginBottom: "8px",
		children: t
	}), e]
}), uk = ({ title: e, children: t, isOpen: n, onToggle: r, "data-testid": i }) => {
	let [a, o] = Y(!0), s = n ?? a;
	return /* @__PURE__ */ W(R, {
		"data-testid": i,
		children: [/* @__PURE__ */ W(Q, {
			variant: "unstyled",
			onClick: r ?? (() => o(!s)),
			"aria-expanded": s,
			"data-testid": i ? `${i}.collapseToggle` : void 0,
			style: {
				display: "flex",
				alignItems: "center",
				gap: "8px"
			},
			children: [/* @__PURE__ */ U(R, {
				as: "span",
				...ar,
				color: Ft,
				children: e
			}), /* @__PURE__ */ U(z, {
				as: "span",
				boxSize: "16px",
				color: Ft,
				transform: s ? "rotate(0deg)" : "rotate(-90deg)",
				transition: "transform 250ms",
				children: /* @__PURE__ */ U(Hp, {})
			})]
		}), /* @__PURE__ */ U(Nl.div, {
			initial: !1,
			animate: s ? {
				height: "auto",
				opacity: 1,
				visibility: "visible",
				transitionEnd: { overflow: "visible" }
			} : {
				height: 0,
				opacity: 0,
				overflow: "hidden",
				visibility: "hidden",
				transition: {
					duration: .25,
					visibility: { delay: .25 }
				}
			},
			transition: { duration: .25 },
			children: /* @__PURE__ */ U(R, {
				paddingTop: "16px",
				children: t
			})
		})]
	});
}, dk = ({ label: e, value: t, "data-testid": n }) => /* @__PURE__ */ W(B, {
	alignItems: "center",
	justifyContent: "center",
	flexDirection: "column",
	height: "96px",
	padding: "24px",
	gap: "8px",
	backgroundColor: A,
	borderRadius: "6px",
	"data-testid": n,
	children: [/* @__PURE__ */ U(R, {
		...j,
		color: k,
		userSelect: "none",
		children: e
	}), /* @__PURE__ */ U(R, {
		...ar,
		color: L,
		children: t
	})]
}), fk = kd.create({
	name: "disableNewline",
	addKeyboardShortcuts() {
		return { Enter: () => !0 };
	}
}), pk = kd.create({
	name: "shiftEnterNewline",
	addKeyboardShortcuts() {
		return { "Shift-Enter": ({ editor: e }) => Bd.Enter(e.state, e.view.dispatch, e.view) };
	}
}), mk = /\{\{\s*([^{}]+?)\s*\}\}/g, hk = (e) => Object.entries(e).reduce((e, [t, n]) => (e.set(t.toLowerCase(), {
	key: t,
	label: n
}), e.set(n.toLowerCase(), {
	key: t,
	label: n
}), e), /* @__PURE__ */ new Map()), gk = kd.create({
	name: "parsePastedVariables",
	addOptions() {
		return { variables: {} };
	},
	addProseMirrorPlugins() {
		let { variables: e } = this.options, { schema: t } = this.editor, n = t.nodes.mention;
		if (!n || Object.keys(e).length === 0) return [];
		let r = hk(e);
		return [new sd({
			key: new cd("parsePastedVariables"),
			props: { transformPasted: (e) => new Ud(_k(e.content, t, n, r), e.openStart, e.openEnd) }
		})];
	}
}), _k = (e, t, n, r) => {
	let i = e.content.reduce((e, i) => i.isText ? [...e, ...vk(i, t, n, r)] : i.content.size > 0 ? [...e, i.copy(_k(i.content, t, n, r))] : [...e, i], []);
	return Hd.fromArray(i);
}, vk = (e, t, n, r) => {
	let i = e.text ?? "", a = Array.from(i.matchAll(mk)).map((e) => {
		let t = e.index ?? 0;
		return {
			start: t,
			end: t + e[0].length,
			entry: r.get(e[1].trim().toLowerCase())
		};
	}).filter((e) => e.entry !== void 0);
	if (a.length === 0) return [e];
	let { nodes: o, lastIndex: s } = a.reduce((r, a) => {
		let o = a.start > r.lastIndex ? [t.text(i.slice(r.lastIndex, a.start), e.marks)] : [];
		return {
			nodes: [
				...r.nodes,
				...o,
				n.create({
					id: a.entry.key,
					label: a.entry.label,
					mentionSuggestionChar: "{"
				})
			],
			lastIndex: a.end
		};
	}, {
		nodes: [],
		lastIndex: 0
	});
	return s < i.length ? [...o, t.text(i.slice(s), e.marks)] : o;
}, yk = 8, bk = (e) => {
	if (e.isDestroyed) return;
	let t = e.view.dom;
	if (t.scrollWidth <= t.clientWidth) return;
	let { $from: n } = e.state.selection;
	if (n.parentOffset === 0) {
		t.scrollLeft = 0;
		return;
	}
	if (n.parentOffset === n.parent.content.size) {
		t.scrollLeft = t.scrollWidth - t.clientWidth;
		return;
	}
	let { left: r } = e.view.coordsAtPos(e.state.selection.head), { left: i } = t.getBoundingClientRect(), a = r - i + t.scrollLeft, o = t.scrollWidth - t.clientWidth;
	a < t.scrollLeft + yk ? t.scrollLeft = Math.max(0, a - yk) : a > t.scrollLeft + t.clientWidth - yk && (t.scrollLeft = Math.min(o, a - t.clientWidth + yk));
}, xk = /^\{\{\s*([^{}]+?)\s*\}\}$/, Sk = (e, t) => {
	let n = e.match(xk), r = n ? t.get(n[1].trim().toLowerCase()) : void 0;
	return r ? {
		value: `{{${r.key}}}`,
		kind: "variable",
		label: r.label
	} : {
		value: e,
		kind: "email"
	};
}, Ck = (e) => e.split(/[\s,]+/).map((e) => e.trim()).filter(Boolean).map((e) => ({
	value: e,
	kind: "email"
})), wk = (e, t) => {
	let n = hk(t), { tokens: r, lastIndex: i } = Array.from(e.matchAll(mk)).reduce((t, r) => {
		let i = r.index ?? 0;
		return {
			tokens: [
				...t.tokens,
				...Ck(e.slice(t.lastIndex, i)),
				Sk(r[0].trim(), n)
			],
			lastIndex: i + r[0].length
		};
	}, {
		tokens: [],
		lastIndex: 0
	});
	return [...r, ...Ck(e.slice(i))];
}, Tk = (e, t) => {
	let n = hk(t);
	return {
		type: "doc",
		content: [{
			type: "paragraph",
			content: e.map((e) => ({
				type: "recipientChip",
				attrs: Sk(e, n)
			}))
		}]
	};
}, Ek = (e) => {
	let t = [];
	return e.state.doc.descendants((e) => {
		e.type.name === "recipientChip" && t.push(e.attrs.value);
	}), t;
}, Dk = (e) => {
	let t = [];
	return e.descendants((e, n) => {
		e.isText && e.text && t.push({
			from: n,
			to: n + e.nodeSize,
			text: e.text
		});
	}), t;
}, Ok = (e, t) => {
	let { state: n } = e, r = n.schema.nodes.recipientChip;
	if (!r) return !1;
	let i = Dk(n.doc);
	if (i.length === 0) return !1;
	let a = [...i].reverse().reduce((e, n) => {
		let i = wk(n.text, t).map((e) => r.create(e));
		return e.replaceWith(n.from, n.to, i);
	}, n.tr);
	return a.docChanged ? (e.view.dispatch(a), !0) : !1;
}, kk = (e, t) => {
	let n = /* @__PURE__ */ new Set();
	return e.state.doc.descendants((e) => {
		e.type.name === "recipientChip" && e.attrs.kind === "variable" && n.add(e.attrs.value), e.type.name === "mention" && n.add(e.attrs.id);
	}), Object.keys(t).filter((e) => n.has(`{{${e}}}`) || n.has(e));
}, Ak = /<br\s*\/?>/i, jk = (e) => {
	let t = new DOMParser().parseFromString(e, "text/html");
	return Array.from(t.body.querySelectorAll(":scope > p")).map((e) => e.innerHTML).join("<br>");
}, Mk = (e) => e.includes("<p") ? e : e.split(Ak).map((e) => `<p>${e}</p>`).join(""), Nk = (e) => e.length > 0 ? [{
	type: "text",
	text: e
}] : [], Pk = (e, t) => {
	let n = hk(t), { content: r, lastIndex: i } = Array.from(e.matchAll(mk)).reduce((t, r) => {
		let i = r.index ?? 0, a = n.get(r[1].trim().toLowerCase()), o = a ? [{
			type: "mention",
			attrs: {
				id: a.key,
				label: a.label,
				mentionSuggestionChar: "{"
			}
		}] : Nk(r[0]);
		return {
			content: [
				...t.content,
				...Nk(e.slice(t.lastIndex, i)),
				...o
			],
			lastIndex: i + r[0].length
		};
	}, {
		content: [],
		lastIndex: 0
	});
	return {
		type: "doc",
		content: [{
			type: "paragraph",
			content: [...r, ...Nk(e.slice(i))]
		}]
	};
}, Fk = /^\s*\{\{/, Ik = /^[a-z][a-z0-9+.-]*:/i, Lk = (e) => {
	let t = e.trim();
	return t === "" ? "" : Fk.test(t) || Ik.test(t) ? t : yl.test(t) ? `mailto:${t}` : `https://${t}`;
}, Rk = mc((e, t) => {
	let { activeIndex: n, handleKeyDown: r } = Vb({
		itemCount: e.items.length,
		onSelect: (t) => {
			let n = e.items[t];
			n && e.command(n);
		},
		highlightFirstItemOnOpen: !0
	});
	return vc(t, () => ({ onKeyDown: ({ event: e }) => r(e) }), [r]), e.items.length === 0 ? null : /* @__PURE__ */ U(Xb.Container, {
		width: 220,
		"data-testid": "richTextEditor.variableMenu",
		children: e.items.map((t, r) => /* @__PURE__ */ U(Xb.Item, {
			uuid: t.id,
			label: t.label,
			onClick: () => e.command(t),
			selected: r === n,
			"data-testid": `richTextEditor.variableMenu.item.${t.label}`
		}, t.id))
	});
}), zk = (e, t) => {
	Cd({ getBoundingClientRect: () => nd(e.view, e.state.selection.from, e.state.selection.to) }, t, {
		placement: "bottom-start",
		strategy: "absolute",
		middleware: [Dd(), wd()]
	}).then(({ x: e, y: n, strategy: r }) => {
		t.style.width = "max-content", t.style.position = r, t.style.left = `${e}px`, t.style.top = `${n}px`;
	});
}, Bk = (e, t) => {
	let n = Object.entries(e).map(([e, t]) => ({
		id: e,
		label: t
	}));
	return [{
		char: "{",
		allowToIncludeChar: !0,
		...t?.command ? { command: t.command } : {},
		items: ({ query: r, editor: i }) => {
			let a = t?.allowVariableUseOnce ? kk(i, e) : [], o = r.replace(/^\{+/, "");
			return n.filter((e) => !a.includes(e.id) && e.label.toLowerCase().startsWith(o.toLowerCase()));
		},
		render: () => {
			let e = null;
			return {
				onStart: (t) => {
					e = new ed(Rk, {
						props: t,
						editor: t.editor
					}), t.clientRect && (e.element.style.position = "absolute", e.element.addEventListener("mousedown", (e) => e.preventDefault()), document.body.appendChild(e.element), zk(t.editor, e.element));
				},
				onUpdate: (t) => {
					e && (e.updateProps(t), t.clientRect && zk(t.editor, e.element));
				},
				onKeyDown: (t) => e ? t.event.key === "Escape" ? (e.destroy(), !0) : e.ref?.onKeyDown(t) ?? !1 : !1,
				onExit: () => {
					e?.destroy();
				}
			};
		}
	}];
}, Vk = [
	"ArrowUp",
	"ArrowDown",
	"Enter"
], Hk = "mention", Uk = ({ editor: e, variables: t }) => {
	let n = J(null), [r, i] = Y(null), [a, o] = Y(null), s = q(() => Object.entries(t).map(([e, t]) => ({
		id: e,
		label: t
	})), [t]), c = G((e) => {
		o((t) => t?.anchorEl === e.anchorEl ? null : e);
	}, []), l = G(() => o(null), []);
	Wk({
		editor: e,
		isDisabled: !e,
		onOpen: c
	});
	let u = Gk({
		anchorEl: a?.anchorEl ?? null,
		floatingEl: r,
		isDisabled: !a
	});
	return Kk({
		isDisabled: !a,
		anchorEl: a?.anchorEl ?? null,
		floatingEl: r,
		menuRef: n,
		onClose: l
	}), !e || !a || s.length === 0 ? null : /* @__PURE__ */ U(Si, { children: /* @__PURE__ */ U(R, {
		ref: i,
		position: "absolute",
		left: u ? `${u.x}px` : 0,
		top: u ? `${u.y}px` : 0,
		visibility: u ? "visible" : "hidden",
		zIndex: "popover",
		onMouseDown: (e) => e.preventDefault(),
		children: /* @__PURE__ */ U(Rk, {
			ref: n,
			items: s,
			command: (t) => {
				let { pos: n } = a;
				e.chain().command(({ tr: e }) => {
					let r = e.doc.nodeAt(n);
					return !r || r.type.name !== Hk ? !1 : (e.setNodeMarkup(n, void 0, {
						...r.attrs,
						id: t.id,
						label: t.label
					}), !0);
				}).run(), o(null);
			}
		})
	}) });
}, Wk = ({ editor: e, isDisabled: t, onOpen: n }) => {
	K(() => {
		if (t || !e) return;
		let r = e.view.dom, i = (t) => {
			let r = t.target?.closest("[data-type=\"mention\"]");
			if (!r) return;
			let i = qk(e, r);
			i && n({
				anchorEl: r,
				pos: i.pos
			});
		};
		return r.addEventListener("click", i), () => r.removeEventListener("click", i);
	}, [
		e,
		t,
		n
	]);
}, Gk = ({ anchorEl: e, floatingEl: t, isDisabled: n }) => {
	let [r, i] = Y(null);
	return K(() => {
		if (n || !e || !t) {
			i(null);
			return;
		}
		let r = { getBoundingClientRect: () => e.getBoundingClientRect() }, a = !1;
		return i(null), Cd(r, t, {
			placement: "bottom-start",
			strategy: "absolute",
			middleware: [Dd(), wd()]
		}).then(({ x: e, y: t }) => {
			a || i({
				x: e,
				y: t
			});
		}), () => {
			a = !0;
		};
	}, [
		e,
		t,
		n
	]), r;
}, Kk = ({ isDisabled: e, anchorEl: t, floatingEl: n, menuRef: r, onClose: i }) => {
	K(() => {
		if (e || !t) return;
		let a = (e) => {
			let r = e.target, a = n?.contains(r) ?? !1, o = t.contains(r);
			!a && !o && i();
		}, o = (e) => {
			if (e.key === "Escape") {
				e.preventDefault(), i();
				return;
			}
			Vk.includes(e.key) && (r.current?.onKeyDown({ event: e }) ?? !1) && (e.preventDefault(), e.stopPropagation());
		};
		return document.addEventListener("mousedown", a, !0), document.addEventListener("keydown", o, !0), () => {
			document.removeEventListener("mousedown", a, !0), document.removeEventListener("keydown", o, !0);
		};
	}, [
		e,
		t,
		n,
		r,
		i
	]);
}, qk = (e, t) => {
	let { view: n } = e, r = n.posAtDOM(t, 0);
	return [
		r,
		r - 1,
		r + 1
	].reduce((e, r) => {
		if (e || r < 0) return e;
		let i = n.state.doc.nodeAt(r), a = n.nodeDOM(r);
		return i?.type.name === Hk && (a?.contains(t) ?? !1) ? { pos: r } : e;
	}, null);
}, Jk = ({ "aria-label": e, isActive: t, onClick: n, icon: r, href: i, "data-testid": a }) => /* @__PURE__ */ U(Q, {
	variant: "ghost",
	"aria-label": e,
	icon: r,
	active: t,
	color: L,
	"data-testid": a,
	...i === void 0 ? { onClick: n } : {
		as: "a",
		href: i,
		target: "_blank",
		rel: "noopener noreferrer"
	}
}), Yk = ({ node: e, deleteNode: t, editor: n }) => {
	let r = e.attrs.value, i = e.attrs.kind, a = e.attrs.label, o = X(i).with("variable", () => a ? `{{${a.toLowerCase()}}}` : r).with("email", () => r).exhaustive();
	return /* @__PURE__ */ W(Qu, {
		as: "span",
		contentEditable: !1,
		"data-recipient-chip": "",
		"data-kind": i,
		"data-testid": `richTextEditor.recipientChip.${r}`,
		children: [o, n.isEditable && /* @__PURE__ */ U(Zr, {
			"aria-label": `Delete ${r}`,
			"data-testid": `richTextEditor.recipientChip.${r}.delete`,
			icon: /* @__PURE__ */ U($h, {}),
			onClick: () => t(),
			variant: "clear",
			minWidth: "16px",
			height: "16px"
		})]
	});
}, Xk = Md.create({
	name: "recipientChip",
	inline: !0,
	group: "inline",
	atom: !0,
	selectable: !0,
	addAttributes() {
		return {
			value: {
				default: "",
				parseHTML: (e) => e.getAttribute("data-value") ?? "",
				renderHTML: (e) => ({ "data-value": e.value })
			},
			kind: {
				default: "email",
				parseHTML: (e) => e.getAttribute("data-kind") ?? "email",
				renderHTML: (e) => ({ "data-kind": e.kind })
			},
			label: {
				default: "",
				parseHTML: (e) => e.getAttribute("data-label") ?? "",
				renderHTML: (e) => ({ "data-label": e.label })
			}
		};
	},
	parseHTML() {
		return [{ tag: "span[data-recipient-chip]" }];
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		return [
			"span",
			Id(t, { "data-recipient-chip": "" }),
			e.attrs.value
		];
	},
	addNodeView() {
		return $u(Yk);
	}
}), Zk = kd.create({
	name: "commitEmailRecipients",
	addOptions() {
		return { variables: {} };
	},
	addKeyboardShortcuts() {
		let e = () => (Ok(this.editor, this.options.variables), !0);
		return {
			Enter: e,
			Space: e,
			",": e
		};
	},
	addProseMirrorPlugins() {
		let e = this.editor, { variables: t } = this.options;
		return [new sd({
			key: new cd("commitEmailRecipients"),
			props: {
				handlePaste: (e, n) => {
					let r = wk(n.clipboardData?.getData("text/plain") ?? "", t);
					if (r.length === 0) return !1;
					let i = e.state.schema.nodes.recipientChip;
					if (!i) return !1;
					let a = r.map((e) => i.create(e)), { from: o, to: s } = e.state.selection, c = e.state.tr.replaceWith(o, s, Hd.fromArray(a)), l = c.mapping.map(s);
					return c.setSelection(ud.near(c.doc.resolve(l))), e.dispatch(c.scrollIntoView()), !0;
				},
				handleDOMEvents: { blur: () => (Kd.getState(e.state)?.active || Ok(e, t), !1) }
			}
		})];
	}
}), Qk = ({ node: e, editor: t }) => {
	let n = e.attrs.id, r = e.attrs.label ?? n;
	return /* @__PURE__ */ U(Qu, {
		as: "span",
		contentEditable: !1,
		"data-type": "mention",
		"data-id": n,
		style: { cursor: t.isEditable ? "pointer" : "default" },
		children: `{{${r.toLowerCase()}}}`
	});
}, $k = kd.create({
	name: "variableSuggestion",
	addOptions() {
		return { suggestion: { char: "{" } };
	},
	addProseMirrorPlugins() {
		return [Gd({
			editor: this.editor,
			...this.options.suggestion
		})];
	}
}), eA = (e, t) => [Yd.extend({ addNodeView() {
	return $u(Qk);
} }).configure({
	suggestions: Bk(e, t),
	renderHTML: ({ options: e, node: t }) => [
		"span",
		td(e.HTMLAttributes),
		`{{${t.attrs.id}}}`
	],
	renderText: ({ node: e }) => `{{${e.attrs.id}}}`
}), gk.configure({ variables: e })], tA = ({ initialHref: e, onSubmit: t, onCancel: n, linkVariables: r }) => {
	let i = J(null), a = J({
		onSubmit: t,
		onCancel: n
	});
	a.current = {
		onSubmit: t,
		onCancel: n
	};
	let o = q(() => kd.create({
		name: "linkInputKeyboard",
		addKeyboardShortcuts() {
			let { editor: e } = this;
			return {
				Enter: () => (a.current.onSubmit(e.getText({ blockSeparator: "" }).trim()), !0),
				Escape: () => (a.current.onCancel(), !0)
			};
		}
	}), []), s = r ? "Enter a URL, email or type { for variables" : "Enter a URL or email", c = rd({
		autofocus: "end",
		extensions: [
			dd,
			pd,
			fd,
			bd.configure({ placeholder: s }),
			o,
			...r ? eA(r) : []
		],
		content: Pk(e, r ?? {}),
		editorProps: {
			attributes: { class: "tiptap-single-line" },
			transformPastedText: (e) => e.replace(/[\r\n]+/g, " ")
		}
	});
	return Jc({
		ref: i,
		handler: (e) => {
			if (e.target?.closest("[data-testid=\"richTextEditor.variableMenu\"]")) return;
			let r = c?.getText({ blockSeparator: "" }).trim() ?? "";
			r === "" ? n() : t(r);
		}
	}), /* @__PURE__ */ W(B, {
		ref: i,
		padding: "4px 8px",
		marginTop: "4px",
		width: "260px",
		backgroundColor: I,
		border: `${P} 1px solid`,
		borderRadius: "8px",
		boxShadow: yn,
		children: [/* @__PURE__ */ U(Zu, {
			editor: c,
			className: "rich-text-editor",
			"data-testid": "richTextEditor.formattingToolbar.linkUrlInput.input",
			style: {
				width: "100%",
				color: L,
				...N,
				lineHeight: "22px"
			}
		}), r && /* @__PURE__ */ U(Uk, {
			editor: c,
			variables: r
		})]
	});
}, nA = ({ editor: e, linkBeingEdited: t, openLinkEditor: n, closeLinkEditor: r, linkVariables: i }) => {
	let a = id({
		editor: e,
		selector: ({ editor: e }) => ({
			bold: e?.isActive("bold") ?? !1,
			italic: e?.isActive("italic") ?? !1,
			underline: e?.isActive("underline") ?? !1,
			link: e?.isActive("link") ?? !1
		})
	});
	if (!e) return null;
	let o = (a?.link ?? !1) || t !== null;
	return /* @__PURE__ */ U(Wd, {
		editor: e,
		shouldShow: ({ editor: e, from: t, to: n }) => t !== n && e.isEditable,
		children: /* @__PURE__ */ W(B, {
			flexDirection: "column",
			alignItems: "flex-start",
			children: [/* @__PURE__ */ W(B, {
				flexDirection: "row",
				padding: "4px",
				backgroundColor: I,
				border: `${P} 1px solid`,
				borderRadius: "8px",
				boxShadow: yn,
				"data-testid": "richTextEditor.formattingToolbar",
				children: [
					/* @__PURE__ */ U(Jk, {
						"aria-label": "Bold",
						isActive: a?.bold ?? !1,
						onClick: () => e.chain().focus().toggleBold().run(),
						icon: /* @__PURE__ */ U(wp, {}),
						"data-testid": "richTextEditor.formattingToolbar.bold"
					}),
					/* @__PURE__ */ U(Jk, {
						"aria-label": "Italic",
						isActive: a?.italic ?? !1,
						onClick: () => e.chain().focus().toggleItalic().run(),
						icon: /* @__PURE__ */ U(Fm, {}),
						"data-testid": "richTextEditor.formattingToolbar.italic"
					}),
					/* @__PURE__ */ U(Jk, {
						"aria-label": "Underline",
						isActive: a?.underline ?? !1,
						onClick: () => e.chain().focus().toggleUnderline().run(),
						icon: /* @__PURE__ */ U(qh, {}),
						"data-testid": "richTextEditor.formattingToolbar.underline"
					}),
					/* @__PURE__ */ U(Jk, {
						"aria-label": "Link",
						isActive: o,
						onClick: () => {
							n(e.getAttributes("link").href ?? "");
						},
						icon: /* @__PURE__ */ U(Ip, {}),
						"data-testid": "richTextEditor.formattingToolbar.link"
					})
				]
			}), t !== null && /* @__PURE__ */ U(tA, {
				initialHref: t.href,
				onSubmit: (n) => {
					if (t === null) return;
					let i = Lk(n), a = e.chain().focus().setTextSelection(t.selection).extendMarkRange("link");
					i === "" ? a.unsetLink().run() : a.setLink({ href: i }).run(), r();
				},
				onCancel: r,
				linkVariables: i
			})]
		})
	});
}, rA = 150, iA = "link-menu", aA = ({ editor: e, hidden: t, onEdit: n }) => {
	let [r, i] = Y(null), a = J(null), o = id({
		editor: e,
		selector: ({ editor: e }) => ({
			isLinkActive: e?.isActive("link") ?? !1,
			isSelectionCollapsed: e?.state.selection.from === e?.state.selection.to,
			href: e?.getAttributes("link").href ?? ""
		})
	}), s = () => {
		a.current !== null && (clearTimeout(a.current), a.current = null);
	}, c = () => {
		s(), a.current = setTimeout(() => {
			i(null);
		}, rA);
	};
	K(() => {
		if (!e) return;
		let t = e.view.dom, n = (e) => {
			let t = e.target?.closest("a");
			t && (s(), i(t));
		}, r = (e) => {
			e.target?.closest("a") && c();
		};
		return t.addEventListener("mouseover", n), t.addEventListener("mouseout", r), () => {
			t.removeEventListener("mouseover", n), t.removeEventListener("mouseout", r), s();
		};
	}, [e]);
	let l = o?.isLinkActive ?? !1, u = o?.isSelectionCollapsed ?? !0;
	if (K(() => {
		if (!e) return;
		let n = l && u ? oA(e) : null;
		!t && (r !== null || n !== null) ? (e.view.dispatch(e.state.tr.setMeta(iA, "show")), e.view.dispatch(e.state.tr.setMeta(iA, "updatePosition"))) : e.view.dispatch(e.state.tr.setMeta(iA, "hide"));
	}, [
		e,
		t,
		r,
		l,
		u
	]), !e) return null;
	let d = () => t ? !1 : r === null ? !l || !u ? !1 : oA(e) !== null : !0, f = () => {
		if (r) return sA(r);
		if (!l || !u) return null;
		let t = oA(e);
		return t ? sA(t) : null;
	}, p = r?.getAttribute("href") ?? o?.href ?? "", m = p !== "" && !p.startsWith("mailto:") && !p.includes("{{"), h = () => {
		let t = e.chain().focus();
		if (r) {
			let n = cA(e, r);
			if (n) return t.setTextSelection(n);
		}
		return t.extendMarkRange("link");
	};
	return /* @__PURE__ */ U(Wd, {
		editor: e,
		pluginKey: iA,
		shouldShow: d,
		getReferencedVirtualElement: f,
		options: {
			placement: "top",
			offset: 8,
			flip: {},
			shift: { padding: 8 }
		},
		appendTo: () => document.body,
		children: /* @__PURE__ */ W(B, {
			flexDirection: "row",
			padding: "4px",
			backgroundColor: I,
			border: `${P} 1px solid`,
			borderRadius: "8px",
			boxShadow: yn,
			onMouseEnter: s,
			onMouseLeave: c,
			"data-testid": "richTextEditor.linkHoverMenu",
			children: [
				/* @__PURE__ */ U(Jk, {
					"aria-label": "Edit link",
					isActive: !1,
					onClick: () => {
						h().run(), n(p), i(null);
					},
					icon: /* @__PURE__ */ U(ih, {}),
					"data-testid": "richTextEditor.linkHoverMenu.edit"
				}),
				m && /* @__PURE__ */ U(Jk, {
					"aria-label": "Open link",
					isActive: !1,
					href: p,
					icon: /* @__PURE__ */ U(Dh, {}),
					"data-testid": "richTextEditor.linkHoverMenu.open"
				}),
				/* @__PURE__ */ U(Jk, {
					"aria-label": "Unlink",
					isActive: !1,
					onClick: () => {
						h().unsetLink().run(), i(null);
					},
					icon: /* @__PURE__ */ U(Op, {}),
					"data-testid": "richTextEditor.linkHoverMenu.unlink"
				})
			]
		})
	});
}, oA = (e) => {
	let { from: t, to: n } = e.state.selection;
	if (t !== n || !e.isActive("link")) return null;
	let r = e.view.domAtPos(t).node;
	return (r?.nodeType === Node.ELEMENT_NODE ? r : r?.parentElement ?? null)?.closest("a") ?? null;
}, sA = (e) => ({
	getBoundingClientRect: () => e.getBoundingClientRect(),
	getClientRects: () => Array.from(e.getClientRects())
}), cA = (e, t) => {
	let n = e.view.posAtDOM(t, 0);
	if (n < 0) return null;
	let r = e.schema.marks.link;
	return r ? Pd(e.state.doc.resolve(n), r) ?? null : null;
}, lA = Xu`
  .rich-text-editor {
    .tiptap {
      width: 100%;
      height: 100%;
      outline: none;
      overflow-y: auto;
    }

    .tiptap-single-line {
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      p {
        margin: 0;
        white-space: pre;
      }

      /* react-renderer is tiptap's inline node-view wrapper; inline-block + vertical-align keep the mention pill aligned with the line text */
      .react-renderer {
        display: inline-block;
        vertical-align: top;
      }

      [data-type='mention'] {
        display: inline-block;
      }
    }

    .tiptap-email {
      /*
       * inline-block (not inline) so the chip is an atomic box: the empty caret
       * after the last chip then renders past the chip's margin-right, keeping a
       * consistent gap whether or not text has been typed.
       */
      .react-renderer,
      [data-node-view-wrapper] {
        display: inline-block;
        white-space: nowrap;
        vertical-align: top;
      }

      [data-recipient-chip] {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-right: 8px;
        height: 22px;
      }
    }

    .tiptap-single-line [data-type='mention'],
    .tiptap-email [data-recipient-chip] {
      line-height: 22px;
      vertical-align: top;
      padding-top: 0;
      padding-bottom: 0;
    }

    p.is-empty::before {
      color: ${en};
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
    }

    [data-type='mention'],
    [data-recipient-chip] {
      background-color: ${Fn};
      color: ${F};
      padding: 2px 4px;
      border-radius: 4px;
    }

    [data-type='mention'],
    [data-recipient-chip][data-kind='variable'] {
      font-family: ${Ue};
    }

    a {
      color: ${C};
      text-decoration: underline;
      cursor: pointer;

      [data-type='mention'] {
        color: ${C};
      }
    }
  }
`, uA = (e) => {
	let { placeholder: t, variables: n, allowVariableUseOnce: r, autoFocus: i = !1, readOnly: a = !1, variant: o = "MULTI_LINE", "data-testid": s } = e, c = X(o).with("SINGLE_LINE", "EMAIL", () => !0).with("MULTI_LINE", () => !1).exhaustive() && !a, l = !a && X(e).with({ variant: "EMAIL" }, () => !1).otherwise((e) => e.formattingEnabled ?? !0), u = X(e).with({ variant: "EMAIL" }, () => "TEXT").otherwise((e) => e.outputFormat ?? "HTML"), d = X(e).with({ variant: "EMAIL" }, () => void 0).otherwise((e) => e.linkVariables), f = !!n && o !== "EMAIL" && !a, [p, m] = Y(null), h = q(() => {
		if (!(!n || o !== "EMAIL")) return Bk(n, {
			allowVariableUseOnce: r,
			command: ({ editor: e, range: t, props: n }) => {
				e.chain().focus().insertContentAt(t, {
					type: "recipientChip",
					attrs: {
						value: `{{${n.id}}}`,
						kind: "variable",
						label: n.label
					}
				}).run();
			}
		})[0];
	}, [
		n,
		o,
		r
	]), g = J(e.content), _ = q(() => X(e).with({ variant: "EMAIL" }, (e) => Tk(e.content, n ?? {})).otherwise((e) => X(u).with("HTML", () => Mk(e.content)).with("TEXT", () => n ? Pk(e.content, n) : e.content).exhaustive()), [
		e.content,
		o,
		n,
		u
	]), v = rd({
		editable: !a,
		autofocus: !a && i ? "end" : !1,
		extensions: [
			dd,
			pd,
			fd,
			bd.configure({ placeholder: t }),
			...X(o).with("EMAIL", () => [
				Xk,
				Zk.configure({ variables: n ?? {} }),
				...h ? [$k.configure({ suggestion: h })] : []
			]).otherwise(() => [
				md.extend({ renderHTML: ({ HTMLAttributes: e }) => [
					"b",
					e,
					0
				] }),
				hd.extend({ renderHTML: ({ HTMLAttributes: e }) => [
					"i",
					e,
					0
				] }),
				gd,
				_d.configure({
					openOnClick: !1,
					HTMLAttributes: {
						rel: null,
						target: null
					}
				}),
				...n ? eA(n, { allowVariableUseOnce: r }) : [],
				...X(o).with("SINGLE_LINE", () => [fk]).otherwise(() => [pk])
			])
		],
		content: _,
		editorProps: X(o).with("SINGLE_LINE", () => ({
			attributes: { class: "tiptap-single-line" },
			transformPastedText: (e) => e.replace(/[\r\n]+/g, " ")
		})).with("EMAIL", () => ({
			attributes: {
				class: "tiptap-single-line tiptap-email",
				autocapitalize: "none",
				autocorrect: "off",
				autocomplete: "off",
				spellcheck: "false"
			},
			transformPastedText: (e) => e.replace(/[\r\n]+/g, " "),
			handleDOMEvents: { mousedown: (e, t) => {
				if (t.button !== 0 || t.target.closest("button")) return !1;
				t.preventDefault(), e.focus();
				let { state: n } = e;
				return e.dispatch(n.tr.setSelection(ud.atEnd(n.doc))), !0;
			} }
		})).with("MULTI_LINE", () => ({})).exhaustive(),
		onUpdate: ({ editor: t }) => {
			X(e).with({ variant: "EMAIL" }, (e) => {
				let n = Ek(t);
				g.current = n, e.setContent?.(n);
			}).otherwise((e) => {
				let n = X(u).with("TEXT", () => t.getText({ blockSeparator: "\n" })).with("HTML", () => jk(t.getHTML())).exhaustive();
				g.current = n, e.setContent?.(n);
			}), c && requestAnimationFrame(() => bk(t));
		},
		onSelectionUpdate: ({ editor: e }) => {
			c && requestAnimationFrame(() => bk(e));
		}
	}), y = (e) => {
		if (!v) return;
		let { from: t, to: n } = v.state.selection;
		m({
			href: e,
			selection: {
				from: t,
				to: n
			}
		});
	};
	return K(() => {
		if (!v) return;
		let t = () => {
			eu(e.content, g.current) || (g.current = e.content, v.commands.setContent(_, { emitUpdate: !1 }));
		};
		if (a) {
			t();
			return;
		}
		return v.isFocused || t(), v.on("blur", t), () => {
			v.off("blur", t);
		};
	}, [
		v,
		a,
		_,
		e.content
	]), /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(Yu, { styles: lA }),
		/* @__PURE__ */ U(Zu, {
			editor: v,
			className: "rich-text-editor",
			"data-testid": s,
			style: {
				width: "100%",
				height: "100%",
				color: L,
				...N,
				lineHeight: "22px"
			}
		}),
		l && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(nA, {
			editor: v,
			linkBeingEdited: p,
			openLinkEditor: y,
			closeLinkEditor: () => m(null),
			linkVariables: d
		}), /* @__PURE__ */ U(aA, {
			editor: v,
			hidden: p !== null,
			onEdit: y
		})] }),
		f && n && /* @__PURE__ */ U(Uk, {
			editor: v,
			variables: n
		})
	] });
}, dA = ({ value: e }) => /* @__PURE__ */ U(vy, {
	icon: /* @__PURE__ */ U(oh, { color: "inherit" }),
	children: e
}), fA = {
	paddingX: "16px",
	borderSeparator: `${P} 1px solid`
}, pA = ({ label: e, emails: t, "data-testid": n }) => /* @__PURE__ */ W(B, {
	paddingX: fA.paddingX,
	borderBottom: fA.borderSeparator,
	paddingY: "8px",
	gap: "8px",
	alignItems: "center",
	"data-testid": n,
	children: [/* @__PURE__ */ U(V, {
		...N,
		color: k,
		minW: "20px",
		flexShrink: "0",
		children: e
	}), /* @__PURE__ */ U(B, {
		flexWrap: "wrap",
		gap: "4px",
		children: t.map((e) => /* @__PURE__ */ U(dA, { value: e }, e))
	})]
}), mA = ({ fileName: e, fileUrl: t, onClick: n, "data-testid": r }) => {
	let i = /* @__PURE__ */ U(vy, {
		icon: /* @__PURE__ */ U(nh, { color: "inherit" }),
		interactive: !!t || !!n,
		onClick: n,
		"data-testid": r,
		children: e
	});
	return t ? /* @__PURE__ */ U(ri, {
		href: t,
		isExternal: !0,
		_hover: { textDecoration: "none" },
		children: i
	}) : i;
}, hA = ({ attachments: e }) => e ? /* @__PURE__ */ U(B, {
	paddingX: fA.paddingX,
	borderTop: fA.borderSeparator,
	paddingY: "8px",
	flexWrap: "wrap",
	gap: "4px",
	children: e.map((e) => /* @__PURE__ */ U(mA, { ...e }, e.fileName))
}) : null, gA = ({ from: e }) => /* @__PURE__ */ U(z, {
	boxSize: "20px",
	borderRadius: "4px",
	overflow: "hidden",
	backgroundColor: M,
	flexShrink: "0",
	children: e.logoUrl ? /* @__PURE__ */ U(Qr, {
		src: e.logoUrl,
		alt: `Logo for ${e.name}`,
		objectFit: "cover"
	}) : /* @__PURE__ */ U(Jh, {
		size: 14,
		color: F
	})
}), _A = ({ from: e, onClick: t, "data-testid": n }) => /* @__PURE__ */ W(B, {
	paddingX: fA.paddingX,
	borderBottom: fA.borderSeparator,
	paddingY: "12px",
	gap: "8px",
	onClick: t,
	cursor: t ? "pointer" : void 0,
	userSelect: "none",
	children: [/* @__PURE__ */ U(gA, { from: e }), /* @__PURE__ */ W(B, {
		flexDir: "column",
		gap: "4px",
		children: [/* @__PURE__ */ U(V, {
			...j,
			color: Ft,
			"data-testid": n && `${n}.name`,
			children: e.name
		}), /* @__PURE__ */ U(V, {
			...N,
			color: F,
			"data-testid": n && `${n}.email`,
			children: e.email
		})]
	})]
}), vA, yA = () => (vA || (vA = Zd(window), vA.addHook("afterSanitizeAttributes", (e) => {
	e.tagName === "A" && (e.setAttribute("target", "_blank"), e.setAttribute("rel", "noopener noreferrer"));
})), vA), bA = ({ body: e, plainTextBody: t, hasClickableLinks: n = !0, typography: r = N, "data-testid": i }) => {
	let a = Qd(t ? $d(e) : e, { defaultProtocol: "https" }), o = n ? yA().sanitize(a) : yA().sanitize(a, { FORBID_ATTR: ["href"] });
	return /* @__PURE__ */ U(R, {
		...r,
		color: Ft,
		whiteSpace: t ? "pre-wrap" : void 0,
		overflowWrap: "anywhere",
		sx: { "& a": {
			color: y,
			textDecoration: "underline"
		} },
		"data-testid": i && `${i}.body`,
		dangerouslySetInnerHTML: { __html: o }
	});
}, xA = ({ subject: e, body: t, plainTextBody: n, "data-testid": r }) => /* @__PURE__ */ W(B, {
	flexDir: "column",
	padding: "16px",
	gap: "16px",
	overflowY: "auto",
	children: [/* @__PURE__ */ U(V, {
		...ar,
		color: L,
		"data-testid": r && `${r}.subject`,
		children: e
	}), /* @__PURE__ */ U(bA, {
		body: t,
		plainTextBody: n,
		"data-testid": r
	})]
}), SA = ({ from: e, subject: t, onClick: n, "data-testid": r }) => /* @__PURE__ */ W(B, {
	padding: "8px",
	gap: "8px",
	alignItems: "center",
	onClick: n,
	cursor: "pointer",
	"data-testid": r,
	userSelect: "none",
	children: [/* @__PURE__ */ U(gA, { from: e }), /* @__PURE__ */ U(V, {
		...j,
		color: L,
		noOfLines: 1,
		children: t
	})]
}), CA = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 },
	transition: {
		duration: .2,
		ease: "easeInOut"
	}
}, wA = ({ from: e, to: t, cc: n, bcc: r, subject: i, body: a, plainTextBody: o = !1, attachments: s, startCollapsed: c = !1, collapsible: l = !0, "data-testid": u, width: d = "520px", maxHeight: f }) => {
	let [p, m] = Y(l && c), [h, g] = Xd(), _ = (e) => u ? `${u}.${e}` : void 0;
	return /* @__PURE__ */ U(B, {
		width: d,
		flexDir: "column",
		borderRadius: p ? "8px" : "12px",
		border: `${M} 1px solid`,
		transition: "border-radius 0.2s",
		"data-testid": u,
		background: I,
		maxHeight: f,
		children: /* @__PURE__ */ U(Nl.div, {
			initial: !1,
			animate: { height: g.height || "auto" },
			transition: {
				duration: .2,
				ease: "easeInOut"
			},
			style: { overflow: "hidden" },
			children: /* @__PURE__ */ U(R, {
				ref: h,
				position: "relative",
				children: /* @__PURE__ */ U(jl, {
					initial: !1,
					mode: "popLayout",
					children: p ? /* @__PURE__ */ U(Nl.div, {
						...CA,
						children: /* @__PURE__ */ U(SA, {
							from: e,
							subject: i,
							onClick: () => m(!1),
							"data-testid": _("collapsed")
						})
					}, "collapsed") : /* @__PURE__ */ W(Nl.div, {
						...CA,
						children: [
							/* @__PURE__ */ U(_A, {
								from: e,
								onClick: l ? () => m(!0) : void 0,
								"data-testid": _("from")
							}),
							!!t.length && /* @__PURE__ */ U(pA, {
								label: "To",
								emails: t,
								"data-testid": _("recipients.to")
							}),
							!!n?.length && /* @__PURE__ */ U(pA, {
								label: "CC",
								emails: n,
								"data-testid": _("recipients.cc")
							}),
							!!r?.length && /* @__PURE__ */ U(pA, {
								label: "BCC",
								emails: r,
								"data-testid": _("recipients.bcc")
							}),
							/* @__PURE__ */ U(xA, {
								subject: i,
								body: a,
								plainTextBody: o,
								"data-testid": u
							}),
							/* @__PURE__ */ U(hA, { attachments: s })
						]
					}, "expanded")
				})
			})
		})
	});
}, TA = 110, EA = "40px", DA = ({ body: e, plainTextBody: t, "data-testid": n }) => {
	let [r, i] = Y(!1), [a, o] = Y(!1), [s, c] = Y(0), l = J(null), u = J(!1);
	yc(() => {
		let e = l.current;
		if (!e) return;
		let t = () => c(e.getBoundingClientRect().height);
		t();
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []), yc(() => {
		s && (u.current = !0);
	}, [s]);
	let d = s > TA, f = X({
		measuredHeight: s,
		isExpanded: r,
		isExpandable: d
	}).with({ measuredHeight: 0 }, () => "auto").with(Sc.union({ isExpanded: !0 }, { isExpandable: !1 }), () => s).otherwise(() => TA);
	return /* @__PURE__ */ U(R, {
		width: "100%",
		borderRadius: "12px",
		border: `${M} 1px solid`,
		background: I,
		overflow: "hidden",
		"data-testid": n,
		children: /* @__PURE__ */ W(Nl.div, {
			initial: !1,
			animate: { height: f },
			transition: u.current ? {
				duration: .2,
				ease: "easeInOut"
			} : { duration: 0 },
			onClick: d ? () => {
				i((e) => !e), o(!0);
			} : void 0,
			style: {
				overflow: "hidden",
				position: "relative",
				cursor: d ? "pointer" : void 0,
				maxHeight: a ? void 0 : `${TA}px`
			},
			children: [/* @__PURE__ */ U(R, {
				ref: l,
				padding: "12px",
				children: /* @__PURE__ */ U(bA, {
					body: e,
					plainTextBody: t,
					hasClickableLinks: !1,
					typography: tr,
					"data-testid": n
				})
			}), d && !r && /* @__PURE__ */ U(R, {
				position: "absolute",
				left: "0",
				right: "0",
				bottom: "0",
				height: EA,
				background: "linear-gradient(to bottom, transparent, #ffffff)",
				pointerEvents: "none",
				"data-testid": n && `${n}.fade`
			})]
		})
	});
}, OA = [
	"default",
	"gray",
	"brown",
	"red",
	"orange",
	"yellow",
	"green",
	"blue",
	"purple",
	"pink"
], kA = (e) => e !== "default" && OA.includes(e), AA = {
	default: "Auto",
	gray: "Gray",
	brown: "Brown",
	red: "Red",
	orange: "Orange",
	yellow: "Yellow",
	green: "Green",
	blue: "Blue",
	purple: "Purple",
	pink: "Pink"
}, jA = {
	gray: "#9b9a97",
	brown: "#64473a",
	red: "#e03e3e",
	orange: "#d9730d",
	yellow: "#dfab01",
	green: "#4d6461",
	blue: "#0b6e99",
	purple: "#6940a5",
	pink: "#ad1a72"
}, MA = {
	gray: "#ebeced",
	brown: "#e9e5e3",
	red: "#fbe4e4",
	orange: "#f6e9d9",
	yellow: "#fbf3db",
	green: "#ddedea",
	blue: "#ddebf1",
	purple: "#eae4f2",
	pink: "#f4dfeb"
}, NA = "#3f3f3f", PA = (e, t) => {
	let n = FA(e);
	if (n) return Object.entries(X(t).with("text", () => ({
		default: NA,
		...jA
	})).with("background", () => ({
		default: I,
		...MA
	})).exhaustive()).reduce((e, [t, r]) => {
		let i = IA(n, FA(r) ?? [
			0,
			0,
			0
		]);
		return i < e.distance ? {
			color: t,
			distance: i
		} : e;
	}, {
		color: "default",
		distance: Infinity
	}).color;
}, FA = (e) => {
	let t = e.trim().toLowerCase(), n = t.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/)?.[1];
	if (n) {
		let e = n.length === 3 ? n.split("").map((e) => e + e).join("") : n;
		return [
			0,
			2,
			4
		].map((t) => Number.parseInt(e.slice(t, t + 2), 16));
	}
	let r = t.match(/^rgba?\(([^)]+)\)$/)?.[1].split(/[\s,/]+/).filter(Boolean).map(Number), i = r?.[3] === 0;
	if (!(!r || r.length < 3 || i)) return r.slice(0, 3);
}, IA = (e, t) => Math.hypot(e[0] - t[0], e[1] - t[1], e[2] - t[2]), LA = Ol.div`
  position: relative;

  .tiptap {
    outline: none;
    padding-inline: 54px;
    color: ${NA};
    font-family: ${N.fontFamily};
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    ::selection {
      background: Highlight;
    }

    > * {
      margin: 0;
      padding: 3px 0;
    }

    p {
      font-size: 14px;
      line-height: 20px;
    }

    h1,
    h2,
    h3 {
      font-weight: bold;
      line-height: 1.3;
    }

    h1 {
      font-size: 20px;
    }

    h2 {
      font-size: 16px;
    }

    h3 {
      font-size: 14px;
    }

    ul,
    ol {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li > * {
      margin: 0;
      padding: 3px 0;
    }

    li > ul,
    li > ol {
      padding: 0;
    }

    li > :not(:first-child) {
      margin-left: 24px;
    }

    /**
     * The marker is drawn inside the item's own text, so it takes the item's
     * colours and alignment, and any lines after the first hang under the text.
     */
    li > p:first-child {
      padding-left: 24px;
      text-indent: -24px;
    }

    li > p:first-child::before {
      display: inline-block;
      box-sizing: border-box;
      width: 24px;
      padding-right: 4px;
      text-align: center;
      text-indent: 0;
    }

    ol > li {
      counter-increment: block-editor-list-number;
    }

    ol > li > p:first-child::before {
      content: counter(block-editor-list-number) '.';
    }

    ${[
	"•",
	"◦",
	"▪",
	"•",
	"◦",
	"▪"
].map((e, t) => kl`
        ${"ul ".repeat(t)}ul > li > p:first-child::before {
          content: '${e}';
          font-size: 20px;
          line-height: 19px;
        }
      `)}

    hr {
      position: relative;
      margin: 11px 0;
      padding: 0;
      border: none;
      border-top: 1px solid ${P};
    }

    /**
     * Stretches the click target over the margins, so the 1px line is easy to
     * select. It's measured from below the border, hence the extra 1px on top.
     */
    hr::before {
      content: '';
      position: absolute;
      inset: -12px 0 -11px;
    }

    a {
      color: ${y};
      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    /**
     * Only the font changes, so a variable keeps the size and weight of the
     * text around it.
     */
    .block-editor-variable {
      font-family: ${ft.fontFamily};

      &::before {
        content: '{';
      }

      &::after {
        content: '}';
      }
    }

    /**
     * The inset leaves room for the handles, which sit on the table's edges.
     * A table wider than the editor scrolls sideways.
     */
    .tableWrapper {
      padding: 10px 0 16px 10px;
      overflow-x: auto;
    }

    /**
     * Overrides the width the resizing plugin sets, so a table stops growing at
     * the editor's width and its columns share it.
     */
    table {
      width: auto !important;
      border-collapse: collapse;
      table-layout: fixed;
    }

    td {
      position: relative;
      box-sizing: border-box;
      padding: 7px 10px;
      border: 1px solid ${P};
      vertical-align: top;
    }

    table[data-header-row] tr:first-child td,
    table[data-header-column] td:first-child {
      font-weight: bold;
    }

    /**
     * Selected cells are tinted instead, as the text selection is hidden
     * while cells are selected.
     */
    &.ProseMirror-hideselection ::selection {
      background: transparent;
    }

    .selectedCell::after {
      content: '';
      position: absolute;
      inset: 0;
      background-color: ${C};
      opacity: 0.15;
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      top: 0;
      right: -2px;
      bottom: 0;
      width: 4px;
      background-color: ${C};
      pointer-events: none;
    }

    &.resize-cursor {
      cursor: col-resize;
    }

    ${Object.entries(jA).map(([e, t]) => kl`
        [data-text-color='${e}'] {
          color: ${t};
        }
      `)}

    ${Object.entries(MA).map(([e, t]) => kl`
        [data-background-color='${e}'] {
          background-color: ${t};
        }
      `)}

    /**
     * Absolutely positioned so it doesn't take up inline space, otherwise the
     * cursor would sit after the placeholder instead of at the start. It takes
     * the block's font, so it lines up with the cursor in a heading too.
     */
    .block-editor-placeholder {
      position: relative;
    }

    .block-editor-placeholder::after {
      content: attr(data-placeholder);
      position: absolute;
      top: 3px;
      left: 0;
      text-indent: 0;
      color: ${en};
      pointer-events: none;
    }

    li > .block-editor-placeholder:first-child::after {
      left: 24px;
    }

    .ProseMirror-selectednode:not([data-custom-block], [data-image-block]) {
      outline: 2px solid ${C};
    }

    /**
     * The image block is as wide as the editor, so the outline goes around
     * the image, or its "Add image" button, instead.
     */
    [data-image-block].ProseMirror-selectednode [data-image-anchor] {
      outline: 2px solid ${C};
    }

    /**
     * Custom blocks are worked with rather than read as text, so they never
     * show as selected, even when the whole document is.
     */
    [data-custom-block] ::selection {
      background: none;
    }

    &[contenteditable='false']
      [data-custom-block]:not([data-interactive-when-read-only]) {
      pointer-events: none;
    }
  }

  /**
   * The drop cursor is added to the wrapper rather than the editor. It glides
   * between gaps.
   */
  .prosemirror-dropcursor-block {
    transition-property: top, bottom;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;
  }

  .block-editor-trailing-click-area {
    height: 30px;
    cursor: text;
  }

  ${({ $dimmed: e }) => X(e).with("all", () => kl`
          .tiptap > * {
            opacity: 0.8;
          }
        `).with("allExceptCustomBlocks", () => kl`
          .tiptap > *:not([data-custom-block]) {
            opacity: 0.8;
          }
        `).with("none", () => "").exhaustive()}
`, RA = (e, t) => {
	let n = zA(e, t);
	return e.setSelection(od.create(e.doc, n)), n;
}, zA = (e, t) => {
	let { $from: n } = e.selection, r = n.parent.content.size === 0, i = r ? n.before() : n.after();
	return e.replaceWith(i, r ? n.after() : i, t), i;
}, BA = (e) => HA(WA.lexer(e)), VA = [
	"heading",
	"blockquote",
	"table",
	"strong",
	"em",
	"del",
	"codespan"
], HA = (e) => e.some((e) => X(e).with({ type: "list" }, (e) => e.items.length > 1 || HA(e.items.flatMap((e) => e.tokens))).with({ type: "code" }, (e) => e.codeBlockStyle !== "indented").with({ type: "link" }, (e) => e.raw.startsWith("[")).otherwise((e) => VA.includes(e.type) || HA("tokens" in e && e.tokens || []))), UA = (e) => WA.parse(e, { async: !1 }), WA = new Df({
	gfm: !0,
	renderer: { code: (e) => new Of().code(e).replace("\n</code>", "</code>") }
}), GA = (e, t) => {
	let n = KA(e), r = n.at(0);
	if (n.length === 1 && r?.type === t.nodes.paragraph) return r;
	let i = n.flatMap((e, n) => [...n > 0 ? [t.nodes.hardBreak.create()] : [], ...e.content.content]);
	return t.nodes.paragraph.create(r?.attrs, i);
}, KA = (e) => e.content.flatMap((e) => e.isTextblock ? [e] : KA(e.content)), qA = (e, t) => Hd.fromArray(e.content.map((e) => t(e) ?? (e.isLeaf ? e : e.copy(qA(e.content, t))))), JA = (e) => {
	let t = hf.get(e);
	if (!(new Set(t.map).size < t.map.length)) return e;
	let n = e.type.schema.nodes.tableCell, r = Array.from({ length: t.height }, (r, i) => e.child(i).copy(Hd.fromArray(Array.from({ length: t.width }).flatMap((r, a) => {
		let o = t.map[i * t.width + a], s = e.nodeAt(o), { left: c, top: l } = t.findCell(o), u = s?.attrs.colwidth?.[a - c], d = {
			...s?.attrs,
			colspan: 1,
			rowspan: 1,
			colwidth: u ? [u] : null
		}, f = s && c === a && l === i ? n.create(d, s.content, s.marks) : n.createAndFill(d);
		return f ? [f] : [];
	}))));
	return e.copy(Hd.fromArray(r));
}, YA = (e) => {
	let t = (n, r) => {
		let i = n.childCount === 1 ? n.firstChild : null, a = e.openStart > r && e.openEnd > r;
		return i !== null && (a || i.type.spec.tableRole === "table") ? t(i.content, r + 1) : n;
	}, n = t(e.content, 0), r = n.firstChild?.type.spec.tableRole, i = n !== e.content;
	return r === "row" || r === "cell" && i;
}, XA = kd.create({
	name: "textBlockAttributes",
	addGlobalAttributes() {
		return [{
			types: ["paragraph", "heading"],
			attributes: {
				textColor: ZA({
					name: "textColor",
					dataAttribute: "data-text-color",
					fallback: "default"
				}),
				backgroundColor: ZA({
					name: "backgroundColor",
					dataAttribute: "data-background-color",
					fallback: "default"
				})
			}
		}];
	}
}), ZA = ({ name: e, dataAttribute: t, fallback: n }) => ({
	default: n,
	keepOnSplit: !0,
	parseHTML: (e) => e.getAttribute(t) ?? n,
	renderHTML: (n) => ({ [t]: n[e] })
}), QA = 35, $A = 120, ej = /* @__PURE__ */ new WeakMap(), tj = (e) => ej.get(e)?.(), nj = class extends gf {
	constructor(e, t, n) {
		super(e, $A), ej.set(this.table, t), rj(this.table, e), n && (this.dom.dataset.testid = n);
	}
	update(e) {
		return super.update(e) ? (rj(this.table, e), !0) : !1;
	}
}, rj = (e, t) => {
	e.dataset.textColor = t.attrs.textColor, e.toggleAttribute("data-header-row", t.attrs.headerRow), e.toggleAttribute("data-header-column", t.attrs.headerColumn);
}, ij = df.extend({
	addOptions() {
		return {
			...this.parent?.(),
			cellMinWidth: $A,
			"data-testid": void 0
		};
	},
	addAttributes() {
		return {
			textColor: ZA({
				name: "textColor",
				dataAttribute: "data-text-color",
				fallback: "default"
			}),
			headerRow: dj("headerRow", "data-header-row"),
			headerColumn: dj("headerColumn", "data-header-column")
		};
	},
	addNodeView() {
		let e = this.options["data-testid"];
		return ({ node: t, getPos: n }) => new nj(t, n, e);
	},
	addKeyboardShortcuts() {
		return {};
	},
	addProseMirrorPlugins() {
		return [bf({
			cellMinWidth: QA,
			defaultCellMinWidth: $A,
			View: null
		}), Ef({ allowTableNodeSelection: !1 })];
	},
	addCommands() {
		return {
			...this.parent?.(),
			insertEmptyTable: (e) => ({ tr: t, dispatch: n, editor: r }) => {
				if (n) {
					let n = zA(t, fj(r.schema, e));
					t.setSelection(ld.near(t.doc.resolve(n + 1))), t.scrollIntoView();
				}
				return !0;
			},
			toggleTableHeader: ({ position: e, header: t }) => ({ tr: n, dispatch: r }) => {
				let i = n.doc.nodeAt(e);
				return i?.type === this.type ? (r && n.setNodeAttribute(e, t, !i.attrs[t]), !0) : !1;
			},
			moveTableLine: ({ position: e, axis: t, from: n, to: r }) => ({ state: i, tr: a, dispatch: o }) => (a.setSelection(ld.near(a.doc.resolve(e + 1))), X(t).with("row", () => Cf).with("column", () => Sf).exhaustive()({
				from: n,
				to: r,
				pos: e + 1,
				select: !1
			})(i, o)),
			goToCellBelow: () => ({ tr: e, dispatch: t }) => {
				let n = yf(e.selection.$head);
				if (!n) return !1;
				let r = n.node(-1), i = n.start(-1), a = hf.get(r), { left: o, bottom: s } = a.findCell(n.pos - i);
				if (s >= a.height || !t) return !0;
				let c = a.positionAt(s, o, r), l = i + c + (r.nodeAt(c)?.nodeSize ?? 0);
				return e.setSelection(ld.near(e.doc.resolve(l - 1), -1)), !0;
			}
		};
	}
}), aj = ff.extend({
	content: "paragraph",
	parseHTML() {
		let e = (e, t) => Hd.from(GA(Vd.fromSchema(t).parse(e).content, t));
		return [{
			tag: "td",
			getContent: e
		}, {
			tag: "th",
			getContent: e
		}];
	},
	addAttributes() {
		let { align: e, ...t } = this.parent?.() ?? {};
		return {
			...t,
			textColor: ZA({
				name: "textColor",
				dataAttribute: "data-text-color",
				fallback: "default"
			}),
			backgroundColor: ZA({
				name: "backgroundColor",
				dataAttribute: "data-background-color",
				fallback: "default"
			})
		};
	}
}), oj = pf.extend({ content: "tableCell+" }), sj = (e) => [
	ij.configure({ "data-testid": e }),
	oj,
	aj
], cj = (e) => e.firstChild?.content.size === 0, lj = (e) => yf(e) !== null, uj = (e) => e.map((e) => new Ad({
	find: e.find,
	handler: (t) => lj(t.state.selection.$from) ? null : e.handler(t)
})), dj = (e, t) => ({
	default: !1,
	parseHTML: (e) => e.hasAttribute(t),
	renderHTML: (n) => n[e] ? { [t]: "" } : {}
}), fj = (e, { rows: t, columns: n, columnWidth: r }) => {
	let { table: i, tableRow: a, tableCell: o, paragraph: s } = e.nodes, c = r === void 0 ? null : [r], l = () => a.create(null, Array.from({ length: n }, () => o.create({ colwidth: c }, s.create())));
	return i.create(null, Array.from({ length: t }, () => l()));
}, pj = ["bulletList", "orderedList"], mj = (e) => pj.includes(e.type.name), hj = (e) => e.depth >= 2 && e.node(-1).type.name === "listItem" && e.index(-1) === 0 ? e.node(-2) : void 0, gj = lf.extend({
	addAttributes() {
		let { start: e, ...t } = this.parent?.() ?? {};
		return {
			...t,
			start: {
				...e,
				renderHTML: (e) => ({
					start: e.start,
					style: `counter-reset: block-editor-list-number ${e.start - 1}`
				})
			}
		};
	},
	addKeyboardShortcuts() {
		return {};
	},
	addInputRules() {
		return uj([xj({
			find: /^(\d+)\.\s$/,
			type: this.type,
			getStart: (e) => Number(e[1])
		})]);
	}
}), _j = sf.extend({
	addKeyboardShortcuts() {
		return {};
	},
	addInputRules() {
		return uj([xj({
			find: /^\s*([-+*])\s$/,
			type: this.type
		})]);
	}
}), vj = kd.create({
	name: "listDelete",
	addKeyboardShortcuts() {
		return {
			Delete: ({ editor: e }) => uf.handleDelete(e, "listItem"),
			"Mod-Delete": ({ editor: e }) => uf.handleDelete(e, "listItem")
		};
	}
}), yj = (e) => [
	_j.configure({ HTMLAttributes: { "data-testid": e && `${e}.bulletList` } }),
	gj.configure({ HTMLAttributes: { "data-testid": e && `${e}.numberedList` } }),
	cf.extend({ addKeyboardShortcuts() {
		return {};
	} }).configure({ HTMLAttributes: { "data-testid": e && `${e}.listItem` } }),
	vj
], bj = ({ tr: e, range: t, type: n, start: r = 1 }) => {
	let i = t.parent, a = t.endIndex < i.childCount, o = t.startIndex > 0;
	a && Cj(e, t.end), o && e.split(t.start);
	let s = o ? t.start + 1 : t.$from.before(t.depth);
	e.setNodeMarkup(s, n, n.name === "orderedList" ? { start: r } : null);
}, xj = ({ find: e, type: t, getStart: n }) => {
	let r = zd({
		find: e,
		type: t,
		getAttributes: (e) => n ? { start: n(e) } : {}
	});
	return new Ad({
		find: e,
		handler: (e) => {
			let { state: i, range: a, match: o } = e;
			if (!hj(i.doc.resolve(a.from))) return r.handler(e);
			let s = i.tr.delete(a.from, a.to), c = s.doc.resolve(a.from).blockRange(void 0, mj);
			if (!c) return null;
			let l = n?.(o), u = c.parent.type === t, d = c.startIndex === 0;
			u ? l !== void 0 && d && s.setNodeMarkup(c.$from.before(c.depth), void 0, {
				...c.parent.attrs,
				start: l
			}) : bj({
				tr: s,
				range: c,
				type: t,
				start: l
			});
		}
	});
}, Sj = (e, t) => {
	let { schema: n } = e.doc.type, r = t.node(-1), i = t.node(-2), a = t.index(-1), o = t.index(-2), s = a === 0, [c, ...l] = r.children.slice(a), u = s ? n.nodes.paragraph.create(c.attrs, c.content) : c, d = [...i.children.slice(0, o), ...s ? [] : [r.copy(Hd.from(r.children.slice(0, a)))]], f = i.children.slice(o + 1), p = d.length > 0 ? [i.copy(Hd.from(d))] : [], m = f.length > 0 ? [i.type.create(wj(i), Hd.from(f))] : [], h = t.before(-2), g = h + p.reduce((e, t) => e + t.nodeSize, 0);
	return e.replaceWith(h, t.after(-2), [
		...p,
		u,
		...l,
		...m
	]), e.setSelection(ud.create(e.doc, g + 1 + t.parentOffset)), !0;
}, Cj = (e, t) => {
	let n = e.doc.resolve(t).parent;
	e.split(t), e.setNodeMarkup(t + 1, void 0, wj(n));
}, wj = (e) => e.type.name === "orderedList" ? {
	...e.attrs,
	start: 1
} : e.attrs, Tj = /* @__PURE__ */ new WeakMap(), Ej = ({ view: e, event: t, range: n }) => {
	if (!t.dataTransfer) return;
	let r = Mj(e.state.doc, n), { dom: i, text: a } = e.serializeForClipboard(r), o = e.nodeDOM(n.from);
	t.dataTransfer.clearData(), t.dataTransfer.setData("text/html", i.innerHTML), t.dataTransfer.setData("text/plain", a), t.dataTransfer.effectAllowed = "move", o instanceof HTMLElement && Dj({
		view: e,
		dataTransfer: t.dataTransfer,
		blockElement: o
	}), e.dragging = {
		slice: r,
		move: !0
	}, Tj.set(e, n);
}, Dj = ({ view: e, dataTransfer: t, blockElement: n }) => {
	let r = e.dom.parentElement;
	if (!(n.hasAttribute("data-custom-block") && r !== null)) {
		t.setDragImage(n, 0, 0);
		return;
	}
	let { width: i, height: a } = n.getBoundingClientRect(), o = document.createElement("div");
	o.className = e.dom.className, Object.assign(o.style, {
		position: "fixed",
		top: `${-a}px`,
		left: "0",
		width: `${i}px`,
		height: `${a}px`,
		padding: "0",
		overflow: "hidden",
		pointerEvents: "none"
	}), o.appendChild(n.cloneNode(!0)), r.appendChild(o), t.setDragImage(o, 0, 0), requestAnimationFrame(() => o.remove());
}, Oj = (e) => {
	Tj.delete(e), e.dragging = null;
}, kj = kd.create({
	name: "blockDragAndDrop",
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("blockDragAndDrop"),
			props: { handleDrop: (e, t) => {
				let n = Tj.get(e);
				return n ? (Tj.delete(e), Aj(e, n, t), !0) : !1;
			} }
		})];
	}
}), Aj = (e, t, n) => {
	let { doc: r } = e.state, i = e.posAtCoords({
		left: n.clientX,
		top: n.clientY
	}), a = i && jj(r, i.pos, t);
	if (!a || a.position >= t.from && a.position <= t.to) return;
	let o = e.state.tr.deleteRange(t.from, t.to), s = o.mapping.map(a.position);
	o.replaceRange(s, s, a.slice), o.setSelection(ld.near(o.doc.resolve(s), 1)), e.dispatch(o.scrollIntoView()), e.focus();
}, jj = (e, t, n) => {
	let r = Mj(e, n), i = new Ud(r.content, 0, 0), a = af(e, t, r);
	if (a !== null) return {
		position: a,
		slice: r
	};
	let o = af(e, t, i);
	return o === null ? null : {
		position: o,
		slice: i
	};
}, Mj = (e, t) => {
	let n = e.resolve(t.from), r = e.slice(t.from, t.to);
	return mj(n.parent) && n.sameParent(e.resolve(t.to)) ? new Ud(Hd.from(n.parent.copy(r.content)), 1, 1) : r;
}, Nj = [
	{
		id: "paragraph",
		label: "Paragraph",
		icon: zh,
		nodeType: "paragraph"
	},
	{
		id: "heading1",
		label: "Heading 1",
		icon: km,
		nodeType: "heading",
		level: 1
	},
	{
		id: "heading2",
		label: "Heading 2",
		icon: Am,
		nodeType: "heading",
		level: 2
	},
	{
		id: "heading3",
		label: "Heading 3",
		icon: jm,
		nodeType: "heading",
		level: 3
	},
	{
		id: "bulletList",
		label: "Bullet List",
		icon: Wm,
		nodeType: "bulletList"
	},
	{
		id: "numberedList",
		label: "Numbered List",
		icon: $m,
		nodeType: "orderedList"
	}
], Pj = (e) => {
	let { $from: t } = e.state.selection, n = hj(t) ?? t.parent;
	return Nj.find((e) => e.nodeType === n.type.name && (e.level === void 0 || e.level === n.attrs.level)) ?? Nj[0];
}, Fj = (e, t) => X(t.nodeType).with("bulletList", "orderedList", (t) => Rj(e, t)).with("paragraph", "heading", (n) => Ij(e, {
	nodeType: n,
	level: t.level
})).exhaustive(), Ij = (e, { nodeType: t, level: n }) => (Lj(e), e.chain().focus().command(({ tr: e, state: r }) => (e.setBlockType(e.selection.from, e.selection.to, r.schema.nodes[t], (e) => ({
	...e.attrs,
	level: n
})), !0)).run()), Lj = (e) => {
	hj(e.state.selection.$from) && e.commands.liftListItem("listItem") && Lj(e);
}, Rj = (e, t) => e.chain().focus().command(({ tr: e, state: n }) => {
	let r = n.schema.nodes[t];
	e.setBlockType(e.selection.from, e.selection.to, n.schema.nodes.paragraph, (e) => e.attrs);
	let { $from: i, $to: a } = e.selection;
	if (hj(i)) {
		let t = i.blockRange(a, mj);
		return t && t.parent.type !== r && bj({
			tr: e,
			range: t,
			type: r
		}), !!t;
	}
	let o = i.blockRange(a);
	return o !== null && kf(e, o, r);
}).run(), zj = (e, t) => {
	let { doc: n } = e.state, r = Bj(e.state), i = r.at(0), a = r.at(-1);
	if (!i || !a) return !1;
	let o = X(t).with("up", () => Vj(n, i)).with("down", () => Hj(n, a)).exhaustive();
	return o === void 0 || e.commands.command(({ tr: e }) => {
		let { selection: t } = e, i = r.map((e) => Qj(n, e));
		$j(e, r);
		let a = eM(e, e.mapping.map(o));
		e.insert(a, i);
		let s = tM(i, a);
		return e.setSelection(nM(t, e.doc, (e) => {
			let t = r.findIndex((t) => e >= t.pos && e <= Uj(t));
			return s[t] + e - r[t].pos;
		})), e.scrollIntoView(), !0;
	});
}, Bj = (e) => {
	let { selection: t, doc: n } = e;
	if (t instanceof od) return t.node.isBlock && !mj(t.node) ? [{
		pos: t.from,
		node: t.node
	}] : [];
	let r = Wj(t.$from), i = Wj(t.$to);
	if (!r || !i || r.pos === i.pos) return r ? [r] : [];
	let a = qj(n, r), o = qj(n, i), s = a.findIndex((e) => o.some((t) => Kj(n, t)?.pos === Kj(n, e)?.pos)), c = a[s], l = o.find((e) => Kj(n, e)?.pos === Kj(n, c)?.pos), u = a.slice(0, s).flatMap((e) => Yj(n, e)), d = Jj(n, c).filter((e) => e.pos > c.pos && e.pos <= (l?.pos ?? c.pos));
	return [
		r,
		...u,
		...d
	];
}, Vj = (e, t) => {
	let n = Jj(e, t), r = n.findIndex((e) => e.pos === t.pos), i = r > 0 ? n[r - 1] : void 0;
	if (!i) return Kj(e, t)?.pos;
	let a = Xj(i).at(-1);
	return a ? Uj(a) : i.pos;
}, Hj = (e, t) => {
	let n = Jj(e, t), r = n.findIndex((e) => e.pos === t.pos), i = r >= 0 ? n.at(r + 1) : void 0;
	if (!i) {
		let n = Kj(e, t);
		return n && Uj(n);
	}
	let a = Xj(i).at(0);
	return a ? a.pos : Uj(i);
}, Uj = (e) => e.pos + e.node.nodeSize, Wj = (e) => {
	let t = Gj(e, e.depth);
	return t === void 0 ? void 0 : {
		pos: e.before(t),
		node: e.node(t)
	};
}, Gj = (e, t) => {
	if (t < 1) return;
	let n = e.node(t - 1);
	return t === 1 || mj(n) || n.type.name === "listItem" && e.index(t - 1) > 0 ? t : Gj(e, t - 1);
}, Kj = (e, t) => {
	let n = e.resolve(t.pos), r = mj(n.parent) ? n.depth - 1 : n.depth;
	return r > 0 ? {
		pos: n.before(r),
		node: n.node(r)
	} : void 0;
}, qj = (e, t) => {
	let n = Kj(e, t);
	return n ? [t, ...qj(e, n)] : [t];
}, Jj = (e, t) => {
	let n = Kj(e, t);
	return n ? Xj(n) : Zj(e, 0);
}, Yj = (e, t) => Jj(e, t).filter((e) => e.pos > t.pos), Xj = (e) => e.node.type.name === "listItem" ? Zj(e.node, e.pos + 1) : [], Zj = (e, t) => e.children.reduce((t, n, r) => {
	let i = e.type.name === "listItem" && r === 0, a = mj(n) ? Zj(n, t.position + 1) : [{
		pos: t.position,
		node: n
	}];
	return {
		position: t.position + n.nodeSize,
		blocks: i ? t.blocks : [...t.blocks, ...a]
	};
}, {
	position: t,
	blocks: []
}).blocks, Qj = (e, t) => {
	let n = e.resolve(t.pos).parent;
	return mj(n) ? n.type.create(null, t.node) : t.node;
}, $j = (e, t) => t.reduceRight((e, t) => {
	let n = e.doc.resolve(t.pos);
	return mj(n.parent) && n.parent.childCount === 1 ? e.delete(n.before(), n.after()) : e.delete(t.pos, Uj(t));
}, e), eM = (e, t) => {
	let n = e.doc.resolve(t), r = n.parent;
	return mj(r) ? n.index() === 0 ? n.before() : n.index() === r.childCount ? n.after() : (Cj(e, t), t + 1) : t;
}, tM = (e, t) => e.reduce((e, t) => ({
	position: e.position + t.nodeSize,
	starts: [...e.starts, e.position + +!!mj(t)]
}), {
	position: t,
	starts: []
}).starts, nM = (e, t, n) => e instanceof od ? od.create(t, n(e.from)) : e instanceof mf ? mf.create(t, n(e.$anchorCell.pos), n(e.$headCell.pos)) : ud.create(t, n(e.anchor), n(e.head)), rM = kd.create({
	name: "blockKeys",
	priority: 900,
	addKeyboardShortcuts() {
		return {
			Tab: ({ editor: e }) => (iM(e.state.selection.$from) && e.commands.sinkListItem("listItem"), !0),
			"Shift-Tab": ({ editor: e }) => sM(e),
			Enter: ({ editor: e }) => cM(e),
			Backspace: ({ editor: e }) => uM(e),
			"Mod-Alt-0": ({ editor: e }) => pM(e, { nodeType: "paragraph" }),
			"Mod-Alt-1": ({ editor: e }) => pM(e, {
				nodeType: "heading",
				level: 1
			}),
			"Mod-Alt-2": ({ editor: e }) => pM(e, {
				nodeType: "heading",
				level: 2
			}),
			"Mod-Alt-3": ({ editor: e }) => pM(e, {
				nodeType: "heading",
				level: 3
			}),
			"Mod-Shift-7": ({ editor: e }) => pM(e, { nodeType: "orderedList" }),
			"Mod-Shift-8": ({ editor: e }) => pM(e, { nodeType: "bulletList" }),
			"Mod-Shift-ArrowUp": ({ editor: e }) => zj(e, "up"),
			"Mod-Shift-ArrowDown": ({ editor: e }) => zj(e, "down")
		};
	}
}), iM = (e) => !!hj(e), aM = (e) => e.depth >= 2 && e.node(-1).type.name === "listItem" && e.index(-1) > 0, oM = (e) => {
	let { selection: t } = e, n = t instanceof ud ? t.$cursor : null;
	return n?.parent.isTextblock && !lj(n) ? n : null;
}, sM = (e) => {
	let { $from: t } = e.state.selection;
	return iM(t) ? t.depth >= 4 && t.node(-3).type.name === "listItem" && e.commands.liftListItem("listItem") : aM(t) && t.parent.isTextblock && e.commands.command(({ tr: e }) => Sj(e, t));
}, cM = (e) => {
	let { selection: t } = e.state;
	return t instanceof ud && t.$from.parent.isTextblock && !lj(t.$from) ? e.commands.command(({ tr: e }) => (e.selection.empty || e.deleteSelection(), e.selection.$from.parent.isTextblock && lM(e, e.selection.$from), e.scrollIntoView(), !0)) : !1;
}, lM = (e, t) => {
	let { schema: n } = e.doc.type, r = t.parent, i = r.content.size === 0, a = t.parentOffset === 0;
	return iM(t) && i ? Sj(e, t) : iM(t) && a ? (e.insert(t.before(-1), n.nodes.listItem.create(null, n.nodes.paragraph.create())), !0) : iM(t) ? (e.split(t.pos, 2, [{ type: n.nodes.listItem }, { type: n.nodes.paragraph }]), e.setSelection(ud.create(e.doc, t.pos + 4)), !0) : i && aM(t) ? Sj(e, t) : i ? (e.insert(t.after(), n.nodes.paragraph.create()), e.setSelection(ud.create(e.doc, t.after() + 1)), !0) : (e.split(t.pos, 1, [a ? {
		type: r.type,
		attrs: r.attrs
	} : { type: n.nodes.paragraph }]), e.setSelection(ud.create(e.doc, t.pos + 2)), !0);
}, uM = (e) => {
	if (e.commands.undoInputRule()) return !0;
	let t = oM(e.state);
	return !t || t.parentOffset !== 0 ? !1 : iM(t) ? e.commands.command(({ tr: e }) => Sj(e, t)) : t.parent.type.name === "heading" ? e.commands.command(({ tr: e, state: n }) => (e.setNodeMarkup(t.before(), n.schema.nodes.paragraph, t.parent.attrs), !0)) : aM(t) ? e.commands.command(({ tr: e }) => Sj(e, t)) : dM(e, t);
}, dM = (e, t) => {
	let n = t.before(), r = e.state.doc.resolve(n).nodeBefore, i = r && mj(r) ? fM(r, n - r.nodeSize) : null;
	return i !== null && e.commands.command(({ tr: e }) => (t.parent.content.size === 0 ? e.delete(n, t.after()) : e.delete(i, t.pos), e.setSelection(ud.create(e.doc, i)), e.scrollIntoView(), !0));
}, fM = (e, t) => {
	let n = t + e.nodeSize - 1, r = e.lastChild, i = mj(e) || e.type.name === "listItem";
	return e.isTextblock ? n : r && i ? fM(r, n - r.nodeSize) : null;
}, pM = (e, t) => {
	let { $from: n } = e.state.selection;
	return n.parent.isTextblock && !lj(n) && Fj(e, t);
}, mM = kd.create({
	name: "blurOnEscape",
	priority: 0,
	addKeyboardShortcuts() {
		return { Escape: ({ editor: e }) => e.commands.blur() };
	}
}), hM = kd.create({
	name: "clipboard",
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("clipboard"),
			props: {
				handlePaste: (e, t) => {
					let n = gM(t.clipboardData);
					return n !== void 0 && e.pasteHTML(UA(n));
				},
				transformPastedHTML: (e) => Zd.sanitize(e),
				transformPasted: (e, t) => {
					let n = qA(e.content, (e) => e.type.spec.tableRole === "table" ? JA(e) : void 0);
					return lj(t.state.selection.$from) && !YA(e) ? new Ud(Hd.from(GA(n, t.state.schema)), 1, 1) : new Ud(n, e.openStart, e.openEnd);
				}
			}
		})];
	}
}), gM = (e) => {
	let t = e?.getData("text/html").includes("data-pm-slice");
	if (!e || t) return;
	let n = e.getData("text/markdown"), r = e.getData("text/plain");
	return n || (BA(r) ? r : void 0);
}, _M = jd.create({
	name: "textColor",
	addAttributes() {
		return { color: {
			default: "default",
			parseHTML: (e) => e.getAttribute("data-text-color"),
			renderHTML: (e) => ({ "data-text-color": e.color })
		} };
	},
	parseHTML() {
		return [{ tag: "span[data-text-color]" }, {
			style: "color",
			getAttrs: yM("text")
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"span",
			e,
			0
		];
	},
	addCommands() {
		return { setTextColor: (e) => ({ commands: t }) => e === "default" ? t.unsetMark(this.name) : t.setMark(this.name, { color: e }) };
	}
}), vM = jd.create({
	name: "backgroundColor",
	addAttributes() {
		return { color: {
			default: "default",
			parseHTML: (e) => e.getAttribute("data-background-color"),
			renderHTML: (e) => ({ "data-background-color": e.color })
		} };
	},
	parseHTML() {
		return [{ tag: "span[data-background-color]" }, {
			style: "background-color",
			getAttrs: yM("background")
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"span",
			e,
			0
		];
	},
	addCommands() {
		return { setBackgroundColor: (e) => ({ commands: t }) => e === "default" ? t.unsetMark(this.name) : t.setMark(this.name, { color: e }) };
	}
}), yM = (e) => (t) => {
	let n = PA(t, e);
	return kA(n) ? { color: n } : !1;
}, bM = kd.create({
	name: "currentBlockPlaceholder",
	addOptions() {
		return {
			placeholder: "",
			"data-testid": void 0
		};
	},
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("currentBlockPlaceholder"),
			props: { decorations: ({ doc: e, selection: t }) => {
				let n = t.$anchor.parent, r = n.isTextblock && n.content.size === 0, i = !!yf(t.$anchor);
				if (!(this.editor.isEditable && t.empty && r && !i)) return null;
				let a = t.$anchor.before();
				return jf.create(e, [Af.node(a, a + n.nodeSize, {
					class: "block-editor-placeholder",
					"data-placeholder": this.options.placeholder,
					...this.options["data-testid"] && { "data-testid": this.options["data-testid"] }
				})]);
			} }
		})];
	}
}), xM = Md.create({
	name: "customBlock",
	group: "block",
	atom: !0,
	selectable: !0,
	addOptions() {
		return { customBlocks: [] };
	},
	addAttributes() {
		return { blockType: {
			default: null,
			parseHTML: (e) => e.getAttribute("data-custom-block"),
			renderHTML: (e) => ({ "data-custom-block": e.blockType })
		} };
	},
	parseHTML() {
		return [{ tag: "div[data-custom-block]" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["div", e];
	},
	addNodeView() {
		return $u(SM, { attrs: ({ node: e }) => ({
			"data-custom-block": e.attrs.blockType,
			...wM(this.options.customBlocks, e)?.isInteractiveWhenReadOnly && { "data-interactive-when-read-only": "" }
		}) });
	},
	addCommands() {
		return { insertCustomBlock: (e) => ({ tr: t, dispatch: n }) => (n && RA(t, this.type.create({ blockType: e })), !0) };
	},
	addProseMirrorPlugins() {
		return [EM(this.options.customBlocks.filter((e) => e.isSingleton).map((e) => e.type))];
	}
}), SM = ({ node: e, extension: t }) => /* @__PURE__ */ U(Qu, { children: wM(t.options.customBlocks, e)?.render() }), CM = (e, t) => TM(e, t).length > 0, wM = (e, t) => e.find((e) => e.type === t.attrs.blockType), TM = (e, t) => Nd(e, (e) => e.type.name === "customBlock" && e.attrs.blockType === t), EM = (e) => new sd({
	key: new cd("customBlockSingletons"),
	appendTransaction: (t, n, r) => {
		let i = e.flatMap((e) => DM({
			blockType: e,
			transactions: t,
			oldState: n,
			newState: r
		}));
		return i.length === 0 ? null : i.sort((e, t) => t.pos - e.pos).reduce((e, { pos: t, node: n }) => e.delete(t, t + n.nodeSize), r.tr);
	}
}), DM = ({ blockType: e, transactions: t, oldState: n, newState: r }) => {
	let i = TM(r.doc, e);
	if (i.length <= 1) return [];
	let a = TM(n.doc, e).at(0)?.pos, o = a === void 0 ? void 0 : t.reduce((e, t) => t.mapping.map(e), a), s = i.find(({ pos: e }) => e === o) ?? i.at(0);
	return i.filter((e) => e !== s);
}, OM = Mf.extend({
	name: "divider",
	addInputRules() {
		return uj([Ld({
			find: /^---$/,
			type: this.type
		})]);
	},
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("dividerMouseDown"),
			props: { handleDOMEvents: { mousedown: (e, t) => {
				let n = e.posAtCoords({
					left: t.clientX,
					top: t.clientY
				}), r = t.button === 0 && !t.shiftKey, i = n !== null && n.inside > -1 && e.state.doc.nodeAt(n.inside)?.type === this.type;
				return !e.editable || !r || !i ? !1 : (t.preventDefault(), e.focus(), e.dispatch(e.state.tr.setSelection(od.create(e.state.doc, n.inside))), !0);
			} } }
		})];
	}
}), kM = 64, AM = ["left", "right"], jM = ({ src: e, alt: t, width: n, textAlign: r, resolveUrl: i, isEditable: a, onResize: o, "data-testid": s }) => {
	let c = MM(e, i), l = J(null), u = J(null), d = J(null), [f, p] = Y(null), m = (e) => (t) => {
		t.preventDefault(), t.stopPropagation(), t.currentTarget.setPointerCapture(t.pointerId);
		let n = u.current?.getBoundingClientRect().width ?? 0;
		d.current = {
			side: e,
			startX: t.clientX,
			startWidth: n,
			maxWidth: l.current?.clientWidth ?? n
		}, p(n);
	}, h = (e) => {
		d.current && p(NM(d.current, e.clientX, r));
	}, g = (e) => {
		let t = d.current, n = t !== null && e.clientX !== t.startX;
		d.current = null, p(null), n && o(Math.round(NM(t, e.clientX, r)));
	}, _ = () => {
		d.current = null, p(null);
	};
	return c ? /* @__PURE__ */ U(B, {
		ref: l,
		justifyContent: PM(r),
		children: /* @__PURE__ */ W(IM, {
			ref: u,
			"data-image-anchor": !0,
			"data-resizing": f === null ? void 0 : "",
			$width: f ?? n,
			children: [/* @__PURE__ */ U(LM, {
				src: c,
				alt: t,
				draggable: !1,
				"data-testid": s
			}), a && AM.map((e) => /* @__PURE__ */ U(FM, {
				$side: e,
				onPointerDown: m(e),
				onPointerMove: h,
				onPointerUp: g,
				onPointerCancel: _,
				"data-testid": `${s}.resizeHandle.${e}`
			}, e))]
		})
	}) : null;
}, MM = (e, t) => {
	let [n, r] = Y(null);
	return K(() => {
		if (!t) return;
		let n = !0;
		return t(e).catch(() => null).then((e) => {
			n && r(e);
		}), () => {
			n = !1;
		};
	}, [e, t]), t ? n : e;
}, NM = ({ side: e, startX: t, startWidth: n, maxWidth: r }, i, a) => {
	let o = X(e).with("left", () => -1).with("right", () => 1).exhaustive(), s = X(a).with("center", () => 2).otherwise(() => 1);
	return Nf(n + (i - t) * o * s, kM, Math.max(r, kM));
}, PM = (e) => X(e).with("left", () => "flex-start").with("center", () => "center").with("right", () => "flex-end").exhaustive(), FM = Ol.div`
  position: absolute;
  top: 50%;
  ${({ $side: e }) => e}: 4px;
  display: none;
  width: 8px;
  height: 30px;
  transform: translateY(-50%);
  box-sizing: border-box;
  border: 1px solid ${I};
  border-radius: ${"4px"};
  background-color: ${Xt};
  cursor: ew-resize;
  touch-action: none;
`, IM = Ol.div`
  position: relative;
  width: ${({ $width: e }) => e === null ? "fit-content" : `${e}px`};
  max-width: 100%;

  &:hover > ${FM}, &[data-resizing] > ${FM} {
    display: block;
  }
`, LM = Ol.img`
  display: block;
  width: 100%;
`, RM = ({ node: e, editor: t, getPos: n, decorations: r, extension: i }) => {
	let { src: a, alt: o, width: s, textAlign: c } = e.attrs, { images: l, "data-testid": u } = i.options, d = id({
		editor: t,
		selector: ({ editor: e }) => e.isEditable
	}), f = r.some((e) => !!e.spec.uploadId), p = d && l !== void 0, m = () => {
		let e = n();
		p && e !== void 0 && t.chain().openImageFilePanel(e).focus().run();
	};
	return /* @__PURE__ */ U(Qu, { children: X({
		isUploading: f,
		hasImage: a !== ""
	}).with({ isUploading: !0 }, () => /* @__PURE__ */ W(zM, {
		"data-testid": `${u}.uploading`,
		children: [/* @__PURE__ */ U(Oi, { size: "sm" }), "Uploading image"]
	})).with({ hasImage: !0 }, () => /* @__PURE__ */ U(jM, {
		src: a,
		alt: o,
		width: s,
		textAlign: c,
		resolveUrl: l?.resolveUrl,
		isEditable: d,
		onResize: (e) => {
			let r = n();
			r !== void 0 && t.commands.setImageAttributes(r, { width: e });
		},
		"data-testid": u
	})).otherwise(() => /* @__PURE__ */ W(zM, {
		isClickable: p,
		onMouseDown: (e) => e.preventDefault(),
		onClick: m,
		"data-testid": `${u}.addImage`,
		children: [/* @__PURE__ */ U(Pm, {}), "Add image"]
	})) });
}, zM = ({ isClickable: e = !1, children: t, ...n }) => /* @__PURE__ */ U(B, {
	"data-image-anchor": !0,
	alignItems: "center",
	gap: "8px",
	padding: "12px",
	borderRadius: "4px",
	backgroundColor: A,
	color: k,
	cursor: e ? "pointer" : "default",
	userSelect: "none",
	_hover: e ? { backgroundColor: Fn } : void 0,
	...N,
	...n,
	children: t
}), BM = "image", VM = new cd("image"), HM = new cd("imageFilePanel"), UM = (e, t) => e.setMeta(VM, t), WM = new sd({
	key: VM,
	state: {
		init: () => ({
			filePanelPosition: null,
			uploads: jf.empty
		}),
		apply: (e, t, n, r) => {
			let i = e.getMeta(VM), a = GM(t.uploads.map(e.mapping, e.doc), i, e.doc);
			return {
				uploads: a,
				filePanelPosition: X(i).with({ type: "openFilePanel" }, ({ position: e }) => e).with({ type: "closeFilePanel" }, () => null).otherwise(() => KM({
					tr: e,
					position: t.filePanelPosition,
					state: r,
					uploads: a
				}))
			};
		}
	},
	props: { decorations: (e) => VM.getState(e)?.uploads }
}), GM = (e, t, n) => X(t).with({ type: "startUpload" }, ({ position: t, id: r }) => e.add(n, [Af.node(t, t + 1, {}, { uploadId: r })])).with({ type: "endUpload" }, ({ id: t }) => e.remove(e.find(void 0, void 0, qM(t)))).otherwise(() => e), KM = ({ tr: e, position: t, state: n, uploads: r }) => {
	if (t === null) return null;
	let { pos: i, deleted: a } = e.mapping.mapResult(t), o = !a && n.doc.nodeAt(i)?.type.name === "image", s = QM(n.selection)?.pos === i, c = XM(r, i);
	return o && (s || c) ? i : null;
}, qM = (e) => (t) => t.uploadId === e, JM = (e, t) => VM.getState(e)?.uploads.find(void 0, void 0, qM(t)).at(0)?.from, YM = (e, t) => XM(VM.getState(e)?.uploads, t), XM = (e, t) => !!e?.find(t, t + 1).some((e) => e.from === t), ZM = (e) => VM.getState(e)?.filePanelPosition ?? null, QM = (e) => e instanceof od && e.node.type.name === "image" ? {
	pos: e.from,
	attrs: e.node.attrs
} : null, $M = (e) => {
	let t = ZM(e);
	return t !== null && QM(e.selection)?.pos === t;
}, eN = (e) => e instanceof HTMLElement ? e.querySelector("[data-image-anchor]") : null, tN = ({ editor: e, element: t, view: n, state: r, from: i, to: a, isMouseDown: o }) => {
	let { selection: s } = r, c = Fd(s) && r.doc.textBetween(i, a).length > 0, l = s instanceof ad, u = s instanceof mf, d = QM(s) !== null && ZM(r) === null, f = n.hasFocus() || t.contains(document.activeElement);
	return e.isEditable && f && !o && (c || l || u || d);
}, nN = (e) => X(e).returnType().with("left", () => "top-start").with("center", () => "top").with("right", () => "top-end").exhaustive(), rN = (e) => {
	let t = e instanceof mf ? e.$from.parent.firstChild : e.$from.parent;
	return QM(e)?.attrs.textAlign ?? t?.attrs.textAlign ?? "left";
}, iN = new cd("formattingToolbar"), aN = (e) => e.view.dispatch(e.state.tr.setMeta(iN, "hide")), oN = (e, t) => {
	let n = J(!1);
	return K(() => {
		let r = () => {
			n.current = !0;
		}, i = () => {
			if (!n.current || !t.current) return;
			n.current = !1;
			let { view: r, state: i } = e;
			tN({
				editor: e,
				element: t.current,
				view: r,
				state: i,
				from: i.selection.from,
				to: i.selection.to,
				isMouseDown: !1
			}) && (r.dispatch(i.tr.setMeta(iN, "show")), r.dispatch(r.state.tr.setMeta(iN, "updatePosition")));
		}, a = e.view.dom;
		return a.addEventListener("mousedown", r), document.addEventListener("mouseup", i), () => {
			a.removeEventListener("mousedown", r), document.removeEventListener("mouseup", i);
		};
	}, [e, t]), n;
}, sN = (e, t, n) => {
	K(() => {
		let r = ({ event: r }) => {
			let i = r.relatedTarget, a = i instanceof Node && (t.contains(i) || e.view.dom.contains(i));
			n.current || a || aN(e);
		};
		return e.on("blur", r), () => {
			e.off("blur", r);
		};
	}, [
		e,
		t,
		n
	]);
}, cN = (e) => {
	let [t] = Y(() => document.createElement("div"));
	return K(() => (e.current?.appendChild(t), () => t.remove()), [e, t]), t;
}, lN = (e, t, n) => {
	K(() => {
		let r = (r) => {
			let i = r.target instanceof Node && r.target.contains(e.view.dom), a = !!n.current?.isConnected;
			i && a && e.view.dispatch(e.state.tr.setMeta(t, "updatePosition"));
		};
		return document.addEventListener("scroll", r, {
			capture: !0,
			passive: !0
		}), () => document.removeEventListener("scroll", r, { capture: !0 });
	}, [
		e,
		t,
		n
	]);
}, uN = (e) => {
	if (!e) return;
	let { overflowY: t } = window.getComputedStyle(e);
	return [
		"auto",
		"scroll",
		"overlay"
	].includes(t) ? e : uN(e.parentElement);
}, dN = (e, t, n) => {
	let r = J(n);
	r.current = n, K(() => {
		let n = (e) => {
			let n = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k", i = !!t.current?.isConnected;
			n && i && (e.preventDefault(), r.current());
		}, i = e.view.dom;
		return i.addEventListener("keydown", n), () => i.removeEventListener("keydown", n);
	}, [e, t]);
}, fN = ({ doc: e, selection: t }) => {
	let n = pN(t.$from), r = e.resolve(mN(t.$to)), i = e.resolve(n).sharedDepth(r.pos);
	if (r.depth <= i) return {
		from: n,
		to: r.pos
	};
	let a = mj(r.node(i + 1)) ? i + 2 : i + 1;
	return {
		from: n,
		to: r.depth >= a ? r.after(a) : r.pos
	};
}, pN = (e) => {
	let t = e.nodeAfter !== null && gN(e.parent, e.index()), n = hN(e);
	return t || n === void 0 ? e.pos : e.before(n);
}, mN = (e) => {
	let t = e.nodeBefore !== null && gN(e.parent, e.index() - 1), n = hN(e);
	return t || n === void 0 ? e.pos : e.after(n);
}, hN = (e) => Array.from({ length: e.depth }, (t, n) => e.depth - n).find((t) => gN(e.node(t - 1), e.index(t - 1))), gN = (e, t) => {
	let n = e.type.name === "doc" && !mj(e.child(t)), r = e.type.name === "listItem" && t > 0;
	return mj(e) || n || r;
}, _N = (e, t, n = e.state.doc, r = 0) => {
	let i = n.type.name === "listItem", a = DN(n, r).filter((e, t) => !i || t > 0).find(({ pos: n }) => ON(e.nodeDOM(n), t));
	if (!a) return;
	let o = mj(a.node) || a.node.type.name === "listItem" ? _N(e, t, a.node, a.pos + 1) : void 0;
	return mj(a.node) ? o : o ?? a;
}, vN = (e, t) => {
	let n = e.selection.empty ? null : fN(e);
	return n !== null && t.pos >= n.from && t.pos < n.to ? n : {
		from: t.pos,
		to: t.pos + t.node.nodeSize
	};
}, yN = (e, t) => e.chain().focus().command(({ tr: e }) => (e.deleteRange(t.from, t.to), !0)).run(), bN = (e) => {
	if (e.node.isTextblock || xN(e)) return e;
	let t = e.node.firstChild;
	return e.node.type.name === "listItem" && t ? {
		pos: e.pos + 1,
		node: t
	} : void 0;
}, xN = (e) => e.node.type.name === "table", SN = (e, t) => {
	let n = e.nodeAt(t.pos)?.attrs;
	return {
		textColor: n?.textColor ?? "default",
		backgroundColor: n?.backgroundColor ?? "default"
	};
}, CN = (e, t, n) => e.chain().focus().command(({ tr: e }) => {
	let r = e.doc.nodeAt(t.pos);
	return r && e.setNodeMarkup(t.pos, void 0, {
		...r.attrs,
		...n
	}), !!r;
}).run(), wN = (e, t) => e.chain().focus().command(({ tr: e }) => {
	let n = TN(t) ? (bN(t)?.pos ?? t.pos) + 1 : EN(e, t);
	return e.setSelection(ud.create(e.doc, n)), e.scrollIntoView(), !0;
}).openSlashMenu().run(), TN = (e) => {
	let t = bN(e), n = e.node.childCount <= 1;
	return t !== void 0 && t.node.content.size === 0 && n;
}, EN = (e, t) => {
	let n = t.pos + t.node.nodeSize, r = e.doc.type.schema.nodes.paragraph.create();
	if (t.node.type.name !== "listItem") return e.insert(n, r), n + 1;
	let i = e.doc.resolve(t.pos);
	return i.index() < i.parent.childCount - 1 && Cj(e, n), e.insert(n + 1, r), n + 2;
}, DN = (e, t) => e.children.reduce((e, t) => ({
	position: e.position + t.nodeSize,
	blocks: [...e.blocks, {
		pos: e.position,
		node: t
	}]
}), {
	position: t,
	blocks: []
}).blocks, ON = (e, t) => {
	if (!(e instanceof HTMLElement)) return !1;
	let { top: n, bottom: r } = e.getBoundingClientRect();
	return t >= n && t < r;
}, kN = async ({ editor: e, position: t, file: n, images: r, isRemovedOnFailure: i }) => {
	let a = Symbol("imageUpload");
	e.view.dispatch(UM(e.state.tr, {
		type: "startUpload",
		position: t,
		id: a
	}));
	let o = r.acceptedMimeTypes.includes(n.type) ? await r.upload(n).catch(() => void 0) : void 0;
	if (e.isDestroyed) return !1;
	let s = JM(e.state, a), c = UM(e.state.tr, {
		type: "endUpload",
		id: a
	}), l = o !== void 0, u = !l && i;
	return s !== void 0 && l && c.setNodeAttribute(s, "src", o), s !== void 0 && u && c.delete(s, s + 1), e.view.dispatch(c), l;
}, AN = ({ editor: e, images: t, onUploadFailed: n }) => {
	let r = (r, i) => MN({
		editor: e,
		files: r,
		range: i,
		images: t,
		onUploadFailed: n
	});
	return new sd({
		key: new cd("imageFiles"),
		props: {
			handlePaste: (e, t) => {
				let n = jN(t.clipboardData);
				return n ? (r(n, NN(e.state)), !0) : !1;
			},
			handleDrop: (e, t) => {
				let n = jN(t.dataTransfer);
				if (!n) return !1;
				let i = PN(e, t);
				return r(n, {
					from: i,
					to: i
				}), !0;
			}
		}
	});
}, jN = (e) => {
	let t = Array.from(e?.files ?? []), n = ["text/html", "text/plain"].some((t) => e?.types.includes(t));
	return t.length > 0 && !n ? t : null;
}, MN = ({ editor: e, files: t, range: n, images: r, onUploadFailed: i }) => {
	let a = t.filter((e) => e.type.startsWith("image/"));
	if (a.length === 0) return;
	let o = e.schema.nodes[BM], { tr: s } = e.state, c = n.from !== n.to, l = c ? n.from : of(s.doc, n.from, o) ?? s.doc.resolve(n.from).after(1);
	s.replaceWith(l, c ? n.to : l, Hd.from(a.map(() => o.create()))), e.view.dispatch(s.scrollIntoView()), a.forEach((t, n) => {
		kN({
			editor: e,
			position: l + n,
			file: t,
			images: r,
			isRemovedOnFailure: !0
		}).then((e) => {
			e || i();
		});
	});
}, NN = (e) => {
	let { selection: t } = e, { $to: n } = t, r = n.parent.isTextblock, i = t.empty && r && n.depth === 1 && n.parent.content.size === 0, a = r ? n.after() : t.to;
	return i ? {
		from: n.before(),
		to: n.after()
	} : {
		from: a,
		to: a
	};
}, PN = (e, t) => {
	let n = _N(e, t.clientY), r = n && e.nodeDOM(n.pos);
	if (!n || !(r instanceof HTMLElement)) return e.state.doc.content.size;
	let { top: i, bottom: a } = r.getBoundingClientRect();
	return t.clientY > (i + a) / 2 ? n.pos + n.node.nodeSize : n.pos;
}, FN = Md.create({
	name: BM,
	group: "block",
	atom: !0,
	selectable: !0,
	addOptions() {
		return {
			images: void 0,
			onUploadFailed: () => void 0,
			"data-testid": "blockEditor.image"
		};
	},
	addAttributes() {
		return {
			src: {
				default: "",
				parseHTML: (e) => e.getAttribute("data-src") ?? e.getAttribute("src") ?? "",
				renderHTML: ({ src: e }) => ({ "data-src": e })
			},
			alt: {
				default: "",
				parseHTML: (e) => e.getAttribute("data-alt") ?? e.getAttribute("alt") ?? "",
				renderHTML: ({ alt: e }) => ({ "data-alt": e })
			},
			width: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("data-width");
					return t ? Number(t) : null;
				},
				renderHTML: ({ width: e }) => e === null ? {} : { "data-width": String(e) }
			},
			textAlign: {
				default: "left",
				parseHTML: (e) => e.getAttribute("data-text-align") ?? "left",
				renderHTML: ({ textAlign: e }) => ({ "data-text-align": e })
			}
		};
	},
	parseHTML() {
		return [{ tag: "div[data-image-block]" }, { tag: "img[src^=\"http\"]" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["div", {
			...e,
			"data-image-block": ""
		}];
	},
	addNodeView() {
		return $u(RM, {
			attrs: { "data-image-block": "" },
			update: ({ updateProps: e }) => (e(), !0)
		});
	},
	addCommands() {
		return {
			insertImage: () => ({ tr: e, dispatch: t }) => (t && IN(e, RA(e, this.type.create())), !0),
			openImageFilePanel: (e) => ({ tr: t, dispatch: n }) => t.doc.nodeAt(e)?.type === this.type ? (n && (t.setSelection(od.create(t.doc, e)), IN(t, e)), !0) : !1,
			closeImageFilePanel: () => ({ tr: e, dispatch: t }) => (t && (UM(e, { type: "closeFilePanel" }), e.setMeta(HM, "hide")), !0),
			setImageAttributes: (e, t) => ({ tr: n, dispatch: r }) => n.doc.nodeAt(e)?.type === this.type ? (r && Object.entries(t).forEach(([t, r]) => n.setNodeAttribute(e, t, r)), !0) : !1
		};
	},
	addKeyboardShortcuts() {
		return { Escape: ({ editor: e }) => ZM(e.state) !== null && e.commands.closeImageFilePanel() };
	},
	addProseMirrorPlugins() {
		let { images: e, onUploadFailed: t } = this.options;
		return [WM, ...e ? [AN({
			editor: this.editor,
			images: e,
			onUploadFailed: t
		})] : []];
	}
}), IN = (e, t) => {
	UM(e, {
		type: "openFilePanel",
		position: t
	}), e.setMeta(iN, "hide"), e.setMeta(HM, "show");
}, LN = Md.create({
	name: "inlineVariable",
	group: "inline",
	inline: !0,
	atom: !0,
	addOptions() {
		return { variables: [] };
	},
	addStorage() {
		return { values: void 0 };
	},
	addAttributes() {
		return {
			variableType: {
				default: null,
				parseHTML: (e) => e.getAttribute("data-variable-type"),
				renderHTML: (e) => ({ "data-variable-type": e.variableType })
			},
			text: {
				default: "",
				parseHTML: (e) => e.textContent ?? "",
				renderHTML: () => ({})
			}
		};
	},
	parseHTML() {
		return [{ tag: "span[data-variable-type]" }];
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		return [
			"span",
			Id(t, { class: "block-editor-variable" }),
			e.attrs.text
		];
	},
	renderText({ node: e }) {
		return e.attrs.text;
	},
	addCommands() {
		let e = (e) => RN(this.storage.values, this.options.variables, e);
		return {
			insertVariable: (t, n) => ({ commands: r }) => r.insertContentAt(t, [{
				type: this.name,
				attrs: {
					variableType: n,
					text: e(n)
				}
			}, {
				type: "text",
				text: " "
			}]),
			setVariableValues: (t) => ({ tr: n, dispatch: r }) => r ? (this.storage.values = t, Nd(n.doc, (e) => e.type === this.type).map(({ node: t, pos: n }) => ({
				pos: n,
				text: t.attrs.text,
				nextText: e(t.attrs.variableType)
			})).filter(({ text: e, nextText: t }) => e !== t).forEach(({ pos: e, nextText: t }) => n.setNodeAttribute(e, "text", t)), n.setMeta("addToHistory", !1), !0) : !0
		};
	},
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("pastedVariables"),
			props: { transformPasted: (e) => {
				let { values: t } = this.storage;
				return t ? new Ud(qA(e.content, (e) => e.type === this.type ? e.type.create({
					...e.attrs,
					text: RN(t, this.options.variables, e.attrs.variableType)
				}, null, e.marks) : void 0), e.openStart, e.openEnd) : e;
			} }
		})];
	},
	addKeyboardShortcuts() {
		return { Backspace: ({ editor: e }) => {
			let { empty: t, $from: n } = e.state.selection, r = n.nodeBefore;
			return !t || r?.type !== this.type ? !1 : e.commands.deleteRange({
				from: n.pos - r.nodeSize,
				to: n.pos
			});
		} };
	}
}), RN = (e, t, n) => e?.[n] ?? t.find(({ type: e }) => e === n)?.label ?? "", zN = kd.create({
	name: "joinAdjacentLists",
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("joinAdjacentLists"),
			appendTransaction: (e, t, n) => {
				let r = e.some((e) => e.docChanged) ? BN(n.doc, 0) : [];
				return r.length === 0 ? null : r.reduceRight((e, t) => e.join(t), n.tr);
			}
		})];
	}
}), BN = (e, t) => e.children.reduce((t, n, r) => {
	let i = e.children[r - 1], a = i !== void 0 && mj(n) && i.type === n.type, o = !n.isTextblock && !n.isLeaf;
	return {
		position: t.position + n.nodeSize,
		joins: [
			...t.joins,
			...a ? [t.position] : [],
			...o ? BN(n, t.position + 1) : []
		]
	};
}, {
	position: t,
	joins: []
}).joins, VN = _d.extend({
	inclusive: !1,
	addAttributes() {
		return {
			...this.parent?.(),
			href: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("href");
					return t === null ? null : Lk(t);
				}
			}
		};
	}
}).configure({
	autolink: !0,
	linkOnPaste: !0,
	openOnClick: !0,
	defaultProtocol: "https"
}), HN = kd.create({
	name: "selectedAtomKeys",
	priority: 1e3,
	addKeyboardShortcuts() {
		return {
			Enter: ({ editor: e }) => GN(e),
			Backspace: ({ editor: e }) => KN(e, "before"),
			Delete: ({ editor: e }) => KN(e, "after")
		};
	},
	addProseMirrorPlugins() {
		return [new sd({
			key: new cd("selectedAtomKeys"),
			props: {
				handleKeyDown: (e, t) => {
					let n = t.key.length === 1 && !t.metaKey && !t.ctrlKey;
					return !WN(e.state.selection) || !n ? !1 : (t.preventDefault(), !0);
				},
				handleTextInput: (e) => WN(e.state.selection)
			}
		})];
	}
}), UN = (e) => !!(e?.isBlock && e.isAtom && od.isSelectable(e)), WN = (e) => e instanceof od && UN(e.node), GN = (e) => WN(e.state.selection) && e.commands.command(({ tr: e, state: t }) => {
	let n = e.selection.to;
	return e.insert(n, t.schema.nodes.paragraph.create()), e.setSelection(ud.create(e.doc, n + 1)), e.scrollIntoView(), !0;
}), KN = (e, t) => {
	let { selection: n, doc: r } = e.state, i = n instanceof ud ? n.$cursor : null;
	if (!i?.parent.isTextblock || i.parent.content.size === 0 || t === "before" && i.parent.type.name === "heading") return !1;
	let a = X(t).with("before", () => {
		let e = r.resolve(i.before()), t = e.nodeBefore;
		return {
			isAtEdge: i.parentOffset === 0,
			atom: t,
			atomPosition: e.pos - (t?.nodeSize ?? 0)
		};
	}).with("after", () => {
		let e = r.resolve(i.after());
		return {
			isAtEdge: i.parentOffset === i.parent.content.size,
			atom: e.nodeAfter,
			atomPosition: e.pos
		};
	}).exhaustive();
	return !a.isAtEdge || !UN(a.atom) ? !1 : e.commands.setNodeSelection(a.atomPosition);
}, qN = [
	{
		id: "heading1",
		title: "Heading 1",
		icon: km,
		nodeType: "heading",
		level: 1
	},
	{
		id: "heading2",
		title: "Heading 2",
		icon: Am,
		nodeType: "heading",
		level: 2
	},
	{
		id: "heading3",
		title: "Heading 3",
		icon: jm,
		nodeType: "heading",
		level: 3
	},
	{
		id: "paragraph",
		title: "Paragraph",
		icon: xp,
		nodeType: "paragraph"
	},
	{
		id: "bulletList",
		title: "Bullet list",
		icon: Wm,
		nodeType: "bulletList"
	},
	{
		id: "numberedList",
		title: "Numbered list",
		icon: $m,
		nodeType: "orderedList"
	}
], JN = {
	id: "image",
	title: "Image",
	icon: Pm,
	isImage: !0
}, YN = {
	id: "table",
	title: "Table",
	icon: Lh,
	isTable: !0
}, XN = 3, ZN = ["paragraph", "numberedList"], QN = ({ editor: e, query: t, customBlocks: n, hasImages: r }) => {
	let i = !!hj(e.state.selection.$from), a = n.map((t) => ({
		id: `customBlock.${t.type}`,
		title: t.title,
		icon: t.icon,
		customBlockType: t.type,
		isDisabled: t.isSingleton && CM(e.state.doc, t.type)
	})), o = [
		...qN,
		...a,
		...r ? [JN] : [],
		YN
	], s = [...ZN, a.at(-1)?.id], c = o.filter((e) => (!i || tP(e)) && e.title.toLowerCase().includes(t.toLowerCase())), l = c.length === o.length;
	return c.map((e, t) => ({
		...e,
		hasSeparatorAfter: l && s.includes(e.id) && t < c.length - 1
	}));
}, $N = ({ editor: e, range: t, item: n, newTableColumnWidth: r }) => {
	if (e.chain().focus().deleteRange(t).run(), "customBlockType" in n) {
		e.commands.insertCustomBlock(n.customBlockType);
		return;
	}
	if ("isImage" in n) {
		e.commands.insertImage();
		return;
	}
	if ("isTable" in n) {
		e.commands.insertEmptyTable({
			rows: XN,
			columns: XN,
			columnWidth: r
		});
		return;
	}
	e.state.selection.$from.parent.content.size !== 0 && eP(e), Fj(e, n);
}, eP = (e) => {
	let { $from: t } = e.state.selection;
	if (hj(t)) {
		let n = t.after(-1);
		e.chain().insertContentAt(n, {
			type: "listItem",
			content: [{ type: "paragraph" }]
		}).setTextSelection(n + 2).run();
		return;
	}
	let n = t.after();
	e.chain().insertContentAt(n, { type: "paragraph" }).setTextSelection(n + 1).run();
}, tP = (e) => "nodeType" in e && pj.includes(e.nodeType), nP = mc(({ items: e, command: t, "data-testid": n, itemTestIdPrefix: r }, i) => {
	let a = J(null), o = (e) => {
		e && !e.isDisabled && t(e);
	}, { activeIndex: s, handleKeyDown: c } = Vb({
		itemCount: e.length,
		onSelect: (t) => o(e.at(t)),
		highlightFirstItemOnOpen: !0
	});
	return vc(i, () => ({ onKeyDown: c }), [c]), K(() => {
		s !== null && a.current?.querySelectorAll(`[${Ab}]`)[s]?.scrollIntoView({ block: "nearest" });
	}, [s]), e.length === 0 ? null : /* @__PURE__ */ U(Xb.Container, {
		refMenu: a,
		width: 220,
		maxHeight: "inherit",
		overflowY: "auto",
		"data-testid": n,
		children: e.map((e, t) => /* @__PURE__ */ W(uc, { children: [/* @__PURE__ */ U(Xb.Item, {
			uuid: e.id,
			label: e.title,
			iconLeft: e.icon && /* @__PURE__ */ U(e.icon, {}),
			labelStyle: e.labelStyle,
			isDisabled: e.isDisabled,
			selected: t === s,
			onClick: () => o(e),
			"data-testid": `${r}.${rP(e.title)}`
		}), e.hasSeparatorAfter && /* @__PURE__ */ U(Fb, {})] }, e.id))
	});
}), rP = (e) => e.toLowerCase().replace(/ /g, "-"), iP = 3, aP = "9999", oP = ({ editor: e, char: t, name: n, items: r, command: i, opened: a = { blockStart: null }, allowSpaces: o, allowedPrefixes: s, allow: c, "data-testid": l }) => {
	let u = new cd(`${n}SuggestionMenu`), d = !1;
	return Gd({
		editor: e,
		pluginKey: u,
		char: t,
		allowSpaces: o,
		allowedPrefixes: s,
		allow: c,
		items: r,
		findSuggestionMatch: (e) => Jd(e) ?? sP(e.$position, a.blockStart),
		shouldResetDismissed: ({ editor: e, match: t }) => {
			let n = a.blockStart !== null, i = d && r({
				editor: e,
				query: t.query
			}).length > 0;
			return n || i;
		},
		command: ({ editor: e, range: t, props: n }) => {
			a.blockStart = null, i({
				editor: e,
				range: t,
				item: n
			});
		},
		placement: "bottom-start",
		flip: !1,
		floatingUi: { middleware: [
			cP,
			wd({ padding: 8 }),
			Od({
				padding: 8,
				apply: ({ availableHeight: e, elements: t }) => {
					t.floating.style.maxHeight = `${e}px`;
				}
			})
		] },
		render: () => {
			let e = null, t = null;
			return {
				onStart: (r) => {
					d = !1, e = new ed(nP, {
						props: {
							...r,
							"data-testid": `${l}.${n}`,
							itemTestIdPrefix: `${l}.items`
						},
						editor: r.editor
					}), e.element.style.zIndex = aP, e.element.addEventListener("mousedown", (e) => e.preventDefault()), r.editor.view.dom.parentElement?.appendChild(e.element), t = r.mount(e.element);
				},
				onUpdate: (t) => {
					e?.updateProps(t), !t.loading && t.items.length === 0 && t.query.length > iP && (d = !0, qd(t.editor.view, u));
				},
				onKeyDown: ({ event: t }) => e?.ref?.onKeyDown(t) ?? !1,
				onExit: () => {
					a.blockStart = null, t?.(), e?.destroy(), e = null, t = null;
				}
			};
		}
	});
}, sP = (e, t) => {
	if (!(t !== null && e.start() === t)) return null;
	let n = e.doc.textBetween(t, e.pos);
	return {
		range: {
			from: t,
			to: e.pos
		},
		query: n,
		text: n
	};
}, cP = {
	name: "clearMaxHeight",
	fn: ({ elements: e, middlewareData: t }) => t.clearMaxHeight?.isCleared ? {} : (e.floating.style.maxHeight = "", {
		data: { isCleared: !0 },
		reset: { rects: !0 }
	})
}, lP = kd.create({
	name: "slashMenu",
	priority: 1100,
	addOptions() {
		return {
			customBlocks: [],
			hasImages: !1,
			newTableColumnWidth: void 0,
			"data-testid": "suggestionMenu"
		};
	},
	addStorage() {
		return { opened: { blockStart: null } };
	},
	addCommands() {
		return { openSlashMenu: () => ({ tr: e, dispatch: t }) => (t && (this.storage.opened.blockStart = e.selection.$from.start()), !0) };
	},
	addProseMirrorPlugins() {
		return [oP({
			editor: this.editor,
			char: "/",
			name: "blocks",
			allowSpaces: !0,
			allow: ({ state: e }) => !lj(e.selection.$from),
			items: ({ editor: e, query: t }) => QN({
				editor: e,
				query: t,
				customBlocks: this.options.customBlocks,
				hasImages: this.options.hasImages
			}),
			command: (e) => $N({
				...e,
				newTableColumnWidth: this.options.newTableColumnWidth
			}),
			opened: this.storage.opened,
			"data-testid": this.options["data-testid"]
		})];
	}
}), uP = kd.create({
	name: "tableKeys",
	priority: 1e3,
	addKeyboardShortcuts() {
		return {
			Tab: ({ editor: e }) => xf(e.state) && (e.commands.goToNextCell() || !0),
			"Shift-Tab": ({ editor: e }) => xf(e.state) && (e.commands.goToPreviousCell() || !0),
			Enter: ({ editor: e }) => xf(e.state) && e.commands.goToCellBelow(),
			Backspace: ({ editor: e }) => dP(e) || pP(e) || mP(e),
			Delete: ({ editor: e }) => dP(e),
			"Mod-Backspace": ({ editor: e }) => dP(e),
			"Mod-Delete": ({ editor: e }) => dP(e)
		};
	}
}), dP = (e) => {
	let { selection: t } = e.state;
	if (!(t instanceof mf)) return !1;
	let n = t.$anchorCell.node(-1), r = t.ranges.length === hf.get(n).map.length, i = n.children.every((e) => e.children.every(cj));
	return r && i && e.commands.deleteTable();
}, fP = (e) => {
	let { selection: t } = e.state;
	return t instanceof ud ? t.$cursor : null;
}, pP = (e) => {
	let t = fP(e);
	return !!(t && t.parentOffset === 0 && lj(t));
}, mP = (e) => {
	let t = fP(e), n = t?.parentOffset === 0 && t.depth === 1;
	if (!t || !n) return !1;
	let r = t.before();
	return e.state.doc.resolve(r).nodeBefore?.type.name === "table" && e.commands.command(({ tr: e }) => (t.parent.content.size === 0 && e.delete(t.before(), t.after()), e.setSelection(ld.near(e.doc.resolve(r - 1), -1)), !0));
}, hP = kd.create({
	name: "trailingClickArea",
	priority: 1e3,
	addOptions() {
		return { "data-testid": void 0 };
	},
	addKeyboardShortcuts() {
		return { ArrowDown: ({ editor: e }) => _P(e) };
	},
	addProseMirrorPlugins() {
		let e = (e) => {
			let t = document.createElement("div");
			return t.className = "block-editor-trailing-click-area", t.contentEditable = "false", this.options["data-testid"] && (t.dataset.testid = this.options["data-testid"]), t.addEventListener("mousedown", (t) => {
				t.preventDefault(), yP(e);
			}), t;
		};
		return [new sd({
			key: new cd("trailingClickArea"),
			props: { decorations: ({ doc: t }) => this.editor.isEditable && !gP(t) ? jf.create(t, [Af.widget(t.content.size, e, {
				side: 1,
				key: "trailingClickArea"
			})]) : null }
		})];
	}
}), gP = (e) => {
	let t = e.lastChild;
	return t?.type.name === "paragraph" && t.content.size === 0;
}, _P = (e) => gP(e.state.doc) || !vP(e) ? !1 : (yP(e.view), !0), vP = (e) => {
	let { selection: t, doc: n } = e.state, r = t instanceof ud ? t.$cursor : null, i = (e) => ld.findFrom(n.resolve(e), 1) === null;
	if (r) {
		let t = yf(r)?.after() ?? r.after();
		return e.view.endOfTextblock("down") && i(t);
	}
	return (t instanceof od || t instanceof Pf) && i(t.to);
}, yP = (e) => {
	let { state: t } = e, n = t.doc.content.size, r = t.tr.insert(n, t.schema.nodes.paragraph.create());
	e.dispatch(r.setSelection(ud.create(r.doc, n + 1)).scrollIntoView()), e.focus();
}, bP = (e) => ({ query: t }) => e.map(({ type: e, label: t }) => ({
	id: e,
	title: `{${t}}`,
	labelStyle: ft
})).filter((e) => e.title.toLowerCase().includes(t.toLowerCase())), xP = ({ editor: e, range: t, item: n }) => e.chain().focus().insertVariable(t, n.id).run(), SP = ["{", "@"], CP = [
	" ",
	"\xA0",
	"(",
	"\\[",
	"\"",
	"'",
	",",
	".",
	";",
	":",
	"!",
	"?"
], wP = kd.create({
	name: "variableMenu",
	priority: 1100,
	addOptions() {
		return {
			variables: [],
			"data-testid": "suggestionMenu"
		};
	},
	addProseMirrorPlugins() {
		return SP.map((e) => oP({
			editor: this.editor,
			char: e,
			name: "variables",
			allowedPrefixes: CP,
			items: bP(this.options.variables),
			command: xP,
			"data-testid": this.options["data-testid"]
		}));
	}
}), TP = "#ddeeff", EP = tf.extend({
	parseHTML() {
		return [...this.parent?.() ?? [], ...[
			"h4",
			"h5",
			"h6"
		].map((e) => ({
			tag: e,
			attrs: { level: 3 }
		}))];
	},
	addKeyboardShortcuts() {
		return {};
	},
	addInputRules() {
		return uj(this.parent?.() ?? []);
	}
}), DP = ({ placeholder: e, variables: t, customBlocks: n, images: r, newTableColumnWidth: i, onUploadFailed: a, suggestionMenuTestId: o, "data-testid": s }) => [
	dd,
	hM,
	fd.extend({ addKeyboardShortcuts: () => ({}) }),
	EP.configure({ levels: [
		1,
		2,
		3
	] }),
	OM.configure({ HTMLAttributes: { "data-testid": s && `${s}.divider` } }),
	...yj(s),
	zN,
	xM.configure({ customBlocks: n }),
	FN.configure({
		images: r,
		onUploadFailed: a,
		"data-testid": `${s ?? "blockEditor"}.image`
	}),
	...sj(s && `${s}.table`),
	uP,
	HN,
	rM,
	pd,
	LN.configure({ variables: t }),
	md,
	hd,
	gd,
	nf,
	_M,
	vM,
	VN,
	ef,
	xd,
	vd.configure({
		width: 5,
		color: TP
	}),
	yd,
	XA,
	rf.extend({ addKeyboardShortcuts: () => ({}) }).configure({
		types: ["paragraph", "heading"],
		alignments: [
			"left",
			"center",
			"right"
		],
		defaultAlignment: "left"
	}),
	bM.configure({
		placeholder: e,
		"data-testid": s && `${s}.placeholder`
	}),
	hP.configure({ "data-testid": s && `${s}.trailingClickArea` }),
	lP.configure({
		customBlocks: n,
		hasImages: r !== void 0,
		newTableColumnWidth: i,
		"data-testid": o
	}),
	...t.length > 0 ? [wP.configure({
		variables: t,
		"data-testid": o
	})] : [],
	kj,
	mM
], OP = ({ initialHref: e, initialText: t, onSubmit: n, onCancel: r, "data-testid": i }) => {
	let [a, o] = Y(e), [s, c] = Y(t ?? ""), l = (e) => {
		e.nativeEvent.isComposing || (e.key === "Enter" && (e.preventDefault(), n({
			href: Lk(a),
			text: s.trim()
		})), e.key === "Escape" && (e.preventDefault(), r()));
	};
	return /* @__PURE__ */ W(B, {
		"data-testid": i,
		flexDirection: "column",
		gap: "4px",
		width: "280px",
		padding: "4px",
		backgroundColor: I,
		border: `1px solid ${P}`,
		borderRadius: "8px",
		boxShadow: yn,
		children: [/* @__PURE__ */ U(Hg, {
			autoFocus: !0,
			preventScrollOnAutoFocus: !0,
			prefix: /* @__PURE__ */ U(Ip, {}),
			placeholder: "Edit URL",
			value: a,
			onChange: (e) => o(e.target.value),
			onKeyDown: l,
			"data-testid": `${i}.url`
		}), t !== void 0 && /* @__PURE__ */ U(Hg, {
			prefix: /* @__PURE__ */ U(zh, {}),
			placeholder: "Edit title",
			value: s,
			onChange: (e) => c(e.target.value),
			onKeyDown: l,
			"data-testid": `${i}.title`
		})]
	});
}, kP = (e, t) => {
	let { doc: n, schema: r } = e.state, i = Pd(n.resolve(t), r.marks.link);
	if (!i) return null;
	let a = n.nodeAt(i.from)?.marks.find((e) => e.type === r.marks.link)?.attrs.href;
	return {
		...i,
		href: a ?? "",
		text: n.textBetween(i.from, i.to)
	};
}, AP = (e) => {
	let { selection: t } = e.state;
	return t.empty ? kP(e, t.anchor) : null;
}, jP = (e, t) => kP(e, e.view.posAtDOM(t, 0)), MP = (e, t) => {
	let n = e.chain().focus();
	return t ? n.setLink({ href: t }).run() : n.unsetLink().run();
}, NP = (e, t, { href: n, text: r }) => e.chain().focus().command(({ tr: e, state: i }) => {
	let a = i.schema.marks.link, o = r || t.text, s = t.from + o.length;
	return o !== t.text && e.insertText(o, t.from, t.to), e.removeMark(t.from, s, a), n && e.addMark(t.from, s, a.create({ href: n })), e.setMeta("preventAutolink", !0), !0;
}).run(), PP = (e, t) => e.chain().focus().command(({ tr: e, state: n }) => (e.removeMark(t.from, t.to, n.schema.marks.link), e.setMeta("preventAutolink", !0), !0)).run(), FP = ({ editor: e, activeBlockType: t, onOpenChange: n, "data-testid": r }) => {
	let [i, a] = Y(!1);
	return /* @__PURE__ */ U(Xb, {
		"data-testid": r,
		canFlip: !0,
		closeMenuOnItemClick: !0,
		onOpenChange: (e) => {
			a(e), n(e);
		},
		width: 180,
		menuButton: /* @__PURE__ */ U(Q, {
			variant: "ghost",
			active: i,
			leadingIcon: /* @__PURE__ */ U(t.icon, {}),
			trailingIcon: U(i ? Yp : Hp, {}),
			color: L,
			children: t.label
		}),
		items: Nj.map((n) => ({
			label: n.label,
			iconLeft: /* @__PURE__ */ U(n.icon, {}),
			iconRight: n.id === t.id ? /* @__PURE__ */ U(zp, {}) : void 0,
			onClick: () => Fj(e, n),
			"data-testid": `${r}.${n.id}`
		}))
	});
}, IP = ({ kind: e, color: t, size: n }) => X(e).with("text", () => /* @__PURE__ */ U(z, {
	boxSize: `${n}px`,
	border: `1px solid ${P}`,
	borderRadius: "4px",
	color: LP(t),
	...Vt,
	children: "A"
})).with("background", () => /* @__PURE__ */ U(R, {
	boxSize: `${n}px`,
	border: `1px solid ${P}`,
	borderRadius: "4px",
	backgroundColor: RP(t)
})).exhaustive(), LP = (e) => e === "default" ? L : jA[e], RP = (e) => e === "default" ? I : MA[e], zP = ({ label: e, isDisabled: t, children: n, "data-testid": r }) => /* @__PURE__ */ U(m_, {
	label: e,
	isDisabled: t,
	shouldWrapChildren: !1,
	"data-testid": r,
	children: /* @__PURE__ */ U(R, {
		display: "flex",
		children: n
	})
}), BP = 28, VP = 4, HP = 5, UP = 4, WP = ({ textColor: e, backgroundColor: t, onTextColorChange: n, onBackgroundColorChange: r, "data-testid": i }) => /* @__PURE__ */ W(B, {
	flexDirection: "column",
	gap: "4px",
	padding: `${UP}px`,
	onMouseDown: (e) => e.preventDefault(),
	"data-testid": `${i}.palette`,
	children: [
		/* @__PURE__ */ U(GP, { children: "Text" }),
		/* @__PURE__ */ U(KP, { children: OA.map((t) => /* @__PURE__ */ U(zP, {
			label: AA[t],
			"data-testid": `${i}.text.${t}.tooltip`,
			children: /* @__PURE__ */ U(Q, {
				variant: "ghost",
				size: `${BP}px`,
				"aria-label": `${AA[t]} text`,
				active: t === e,
				onClick: () => n(t),
				"data-testid": `${i}.text.${t}`,
				icon: /* @__PURE__ */ U(IP, {
					kind: "text",
					color: t,
					size: 20
				})
			})
		}, t)) }),
		r && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(GP, { children: "Background" }), /* @__PURE__ */ U(KP, { children: OA.map((e) => /* @__PURE__ */ U(zP, {
			label: AA[e],
			"data-testid": `${i}.background.${e}.tooltip`,
			children: /* @__PURE__ */ U(Q, {
				variant: "ghost",
				size: `${BP}px`,
				"aria-label": `${AA[e]} background`,
				active: e === t,
				onClick: () => r(e),
				"data-testid": `${i}.background.${e}`,
				icon: /* @__PURE__ */ U(IP, {
					kind: "background",
					color: e,
					size: 20
				})
			})
		}, e)) })] })
	]
}), GP = ({ children: e }) => /* @__PURE__ */ U(R, {
	...Vt,
	color: k,
	paddingX: "4px",
	paddingY: "2px",
	children: e
}), KP = ({ children: e }) => /* @__PURE__ */ U(Kr, {
	templateColumns: `repeat(${HP}, ${BP}px)`,
	gap: `${VP}px`,
	children: e
}), qP = ({ editor: e, textColor: t, backgroundColor: n, onOpenChange: r, "data-testid": i }) => {
	let [a, o] = Y(!1);
	return /* @__PURE__ */ U(zP, {
		label: "Colors",
		isDisabled: a,
		"data-testid": `${i}.tooltip`,
		children: /* @__PURE__ */ U(Xb, {
			"data-testid": i,
			canFlip: !0,
			closeMenuOnItemClick: !0,
			onOpenChange: (e) => {
				o(e), r(e);
			},
			width: 174,
			menuButton: /* @__PURE__ */ U(Q, {
				variant: "ghost",
				"aria-label": "Colors",
				active: a,
				icon: /* @__PURE__ */ U(Bh, {}),
				color: L
			}),
			items: /* @__PURE__ */ U(WP, {
				textColor: t,
				backgroundColor: n,
				onTextColorChange: (t) => e.chain().focus().setTextColor(t).run(),
				onBackgroundColorChange: (t) => e.chain().focus().setBackgroundColor(t).run(),
				"data-testid": i
			})
		})
	});
}, JP = [
	{
		mark: "bold",
		label: "Bold",
		icon: /* @__PURE__ */ U(wp, {})
	},
	{
		mark: "italic",
		label: "Italic",
		icon: /* @__PURE__ */ U(Fm, {})
	},
	{
		mark: "underline",
		label: "Underline",
		icon: /* @__PURE__ */ U(qh, {})
	},
	{
		mark: "strike",
		label: "Strikethrough",
		icon: /* @__PURE__ */ U(Fh, {})
	}
], YP = [
	{
		alignment: "left",
		label: "Align left",
		icon: /* @__PURE__ */ U(Zf, {})
	},
	{
		alignment: "center",
		label: "Align center",
		icon: /* @__PURE__ */ U(Xf, {})
	},
	{
		alignment: "right",
		label: "Align right",
		icon: /* @__PURE__ */ U(Qf, {})
	}
], XP = ({ editor: e, canReplaceImage: t, containerRef: n, "data-testid": r }) => {
	let i = J(null), a = J(null), [o, s] = Y(!1), [c, l] = bc((e) => e + 1, 0), u = J(!1), d = oN(e, i), f = cN(n);
	sN(e, f, u), lN(e, iN, i), dN(e, i, () => s(!0));
	let p = id({
		editor: e,
		selector: ({ editor: e }) => ({
			selectedImage: QM(e.state.selection),
			bold: e.isActive("bold"),
			italic: e.isActive("italic"),
			underline: e.isActive("underline"),
			strike: e.isActive("strike"),
			link: e.isActive("link"),
			href: e.getAttributes("link").href ?? "",
			alignment: rN(e.state.selection),
			isInTable: lj(e.state.selection.$from),
			isCellSelection: e.state.selection instanceof mf,
			blockType: Pj(e),
			textColor: e.getAttributes("textColor").color ?? "default",
			backgroundColor: e.getAttributes("backgroundColor").color ?? "default"
		})
	}), m = G((e) => tN({
		...e,
		isMouseDown: d.current
	}), [d]), h = q(() => ({
		placement: nN(p.alignment),
		offset: 8,
		flip: {},
		shift: { padding: 8 },
		hide: () => ({ boundary: uN(e.view.dom.parentElement) ?? "clippingAncestors" }),
		onHide: () => {
			s(!1), l();
		}
	}), [p.alignment, e]), g = G(() => {
		let t = QM(e.state.selection), n = t && eN(e.view.nodeDOM(t.pos));
		return n && {
			getBoundingClientRect: () => n.getBoundingClientRect(),
			getClientRects: () => [n.getBoundingClientRect()]
		};
	}, [e]);
	Jc({
		ref: a,
		enabled: o,
		handler: () => aN(e)
	});
	let _ = () => e.commands.focus(), v = (e) => {
		u.current = e, e || _();
	}, { selectedImage: y } = p, b = (t) => y ? e.chain().focus().setImageAttributes(y.pos, { textAlign: t }).run() : e.chain().focus().setTextAlign(t).run(), x = YP.map(({ alignment: e, label: t, icon: n }) => /* @__PURE__ */ U(zP, {
		label: t,
		"data-testid": `${r}.align.${e}.tooltip`,
		children: /* @__PURE__ */ U(Jk, {
			"aria-label": t,
			icon: n,
			isActive: p.alignment === e,
			onClick: () => b(e),
			"data-testid": `${r}.align.${e}`
		})
	}, e)), S = (t) => {
		MP(e, t), aN(e);
	};
	return /* @__PURE__ */ U(Wd, {
		ref: i,
		editor: e,
		pluginKey: iN,
		shouldShow: m,
		getReferencedVirtualElement: g,
		appendTo: f,
		options: h,
		style: { zIndex: aP },
		children: /* @__PURE__ */ W(R, {
			ref: a,
			position: "relative",
			children: [/* @__PURE__ */ U(B, {
				role: "toolbar",
				"aria-label": "Formatting",
				"data-testid": r,
				alignItems: "center",
				gap: "2px",
				padding: "4px",
				backgroundColor: I,
				border: `1px solid ${P}`,
				borderRadius: "8px",
				boxShadow: yn,
				onMouseDown: (e) => e.preventDefault(),
				children: y ? /* @__PURE__ */ W(H, { children: [t && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(zP, {
					label: "Replace image",
					"data-testid": `${r}.replaceImage.tooltip`,
					children: /* @__PURE__ */ U(Jk, {
						"aria-label": "Replace image",
						icon: /* @__PURE__ */ U(Pm, {}),
						isActive: !1,
						onClick: () => e.commands.openImageFilePanel(y.pos),
						"data-testid": `${r}.replaceImage`
					})
				}), /* @__PURE__ */ U(ZP, {})] }), x] }) : /* @__PURE__ */ W(H, { children: [
					!p.isInTable && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(FP, {
						editor: e,
						activeBlockType: p.blockType,
						onOpenChange: v,
						"data-testid": `${r}.blockType`
					}), /* @__PURE__ */ U(ZP, {})] }),
					JP.map(({ mark: t, label: n, icon: i }) => /* @__PURE__ */ U(zP, {
						label: n,
						"data-testid": `${r}.${t}.tooltip`,
						children: /* @__PURE__ */ U(Jk, {
							"aria-label": n,
							icon: i,
							isActive: p[t],
							onClick: () => QP(e, t),
							"data-testid": `${r}.${t}`
						})
					}, t)),
					/* @__PURE__ */ U(ZP, {}),
					x,
					/* @__PURE__ */ U(ZP, {}),
					/* @__PURE__ */ U(qP, {
						editor: e,
						textColor: p.textColor,
						backgroundColor: p.backgroundColor,
						onOpenChange: v,
						"data-testid": `${r}.colors`
					}),
					!p.isCellSelection && /* @__PURE__ */ U(zP, {
						label: "Link",
						"data-testid": `${r}.link.tooltip`,
						children: /* @__PURE__ */ U(Jk, {
							"aria-label": "Link",
							icon: /* @__PURE__ */ U(Ip, {}),
							isActive: p.link || o,
							onClick: () => s((e) => !e),
							"data-testid": `${r}.link`
						})
					})
				] })
			}), o && /* @__PURE__ */ U(R, {
				position: "absolute",
				top: "calc(100% + 4px)",
				right: "0",
				children: /* @__PURE__ */ U(OP, {
					initialHref: p.href,
					onSubmit: ({ href: e }) => S(e),
					onCancel: () => {
						s(!1), _();
					},
					"data-testid": `${r}.linkForm`
				})
			})]
		}, c)
	});
}, ZP = () => /* @__PURE__ */ U(R, {
	width: "1px",
	height: "20px",
	marginX: "2px",
	backgroundColor: P
}), QP = (e, t) => X(t).with("bold", () => e.chain().focus().toggleBold().run()).with("italic", () => e.chain().focus().toggleItalic().run()).with("underline", () => e.chain().focus().toggleUnderline().run()).with("strike", () => e.chain().focus().toggleStrike().run()).exhaustive(), $P = [{
	value: "upload",
	label: "Upload"
}, {
	value: "embed",
	label: "Embed"
}], eF = 3 * Xc, tF = ({ editor: e, images: t, containerRef: n, "data-testid": r }) => {
	let i = J(null), a = cN(n);
	lN(e, HM, i);
	let o = id({
		editor: e,
		selector: ({ editor: e }) => ZM(e.state)
	});
	return /* @__PURE__ */ U(Wd, {
		ref: i,
		editor: e,
		pluginKey: HM,
		shouldShow: ({ editor: e, state: t }) => e.isEditable && $M(t),
		getReferencedVirtualElement: G(() => {
			let t = ZM(e.state), n = t === null ? null : eN(e.view.nodeDOM(t));
			return n && {
				getBoundingClientRect: () => n.getBoundingClientRect(),
				getClientRects: () => [n.getBoundingClientRect()]
			};
		}, [e]),
		appendTo: a,
		options: q(() => ({
			placement: "bottom",
			offset: 10,
			flip: {},
			shift: {},
			hide: () => ({ boundary: uN(e.view.dom.parentElement) ?? "clippingAncestors" }),
			onShow: () => requestAnimationFrame(() => {
				e.isDestroyed || e.view.dispatch(e.state.tr.setMeta(HM, "updatePosition"));
			})
		}), [e]),
		style: { zIndex: aP },
		children: /* @__PURE__ */ U(nF, {
			editor: e,
			images: t,
			"data-testid": r
		}, o ?? "closed")
	});
}, nF = ({ editor: e, images: t, "data-testid": n }) => {
	let [r, i] = Y("upload"), [a, o] = Y(""), [s, c] = Y(!1), l = id({
		editor: e,
		selector: ({ editor: e }) => {
			let t = ZM(e.state);
			return t !== null && YM(e.state, t);
		}
	});
	K(() => {
		if (!s) return;
		let e = setTimeout(() => c(!1), eF);
		return () => clearTimeout(e);
	}, [s]);
	let u = async ([n]) => {
		let r = ZM(e.state);
		!n || r === null || (c(!1), await kN({
			editor: e,
			position: r,
			file: n,
			images: t,
			isRemovedOnFailure: !1
		}) ? e.commands.closeImageFilePanel() : c(!0));
	}, d = () => {
		let t = ZM(e.state);
		t !== null && e.chain().focus().setImageAttributes(t, { src: a }).closeImageFilePanel().run();
	};
	return /* @__PURE__ */ W(B, {
		"data-testid": n,
		flexDirection: "column",
		width: "360px",
		backgroundColor: I,
		border: `1px solid ${P}`,
		borderRadius: "8px",
		boxShadow: yn,
		onMouseDown: (e) => {
			e.target instanceof HTMLInputElement || e.preventDefault();
		},
		onKeyDown: (t) => {
			t.key === "Escape" && (t.preventDefault(), e.chain().focus().closeImageFilePanel().run());
		},
		children: [/* @__PURE__ */ U(R, {
			paddingX: "12px",
			children: /* @__PURE__ */ U(B, {
				role: "tablist",
				gap: "16px",
				borderBottom: `1px solid ${P}`,
				"data-testid": `${n}.tabs`,
				children: $P.map(({ value: e, label: t }) => {
					let a = e === r;
					return /* @__PURE__ */ U(R, {
						as: "button",
						type: "button",
						role: "tab",
						"aria-selected": a,
						paddingY: "8px",
						marginBottom: "-1px",
						borderBottom: `2px solid ${a ? L : "transparent"}`,
						color: a ? L : k,
						_hover: { color: L },
						onClick: () => i(e),
						"data-testid": `${n}.tabs.${e}`,
						...j,
						children: t
					}, e);
				})
			})
		}), /* @__PURE__ */ W(B, {
			flexDirection: "column",
			gap: "8px",
			padding: "12px",
			children: [X(r).with("upload", () => /* @__PURE__ */ U(tS, {
				variant: "secondary",
				fullWidth: !0,
				accept: t.acceptedMimeTypes.join(","),
				onFilesPicked: (e) => void u(e),
				submitting: l,
				"data-testid": `${n}.upload`,
				children: "Upload image"
			})).with("embed", () => /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(Hg, {
				autoFocus: !0,
				preventScrollOnAutoFocus: !0,
				placeholder: "Enter URL",
				value: a,
				onChange: (e) => o(e.target.value),
				onKeyDown: (e) => {
					e.key === "Enter" && !e.nativeEvent.isComposing && (e.preventDefault(), d());
				},
				"data-testid": `${n}.embed.url`
			}), /* @__PURE__ */ U(Q, {
				variant: "primary",
				fullWidth: !0,
				onClick: d,
				"data-testid": `${n}.embed.submit`,
				children: "Embed image"
			})] })).exhaustive(), s && /* @__PURE__ */ U(R, {
				color: "#dc2626",
				...tr,
				"data-testid": `${n}.error`,
				children: "Upload failed"
			})]
		})]
	});
}, rF = 250, iF = (e) => {
	let [t, n] = Y(null), r = J(), i = G(() => clearTimeout(r.current), []), a = G((e) => {
		i(), r.current = setTimeout(() => n(e), rF);
	}, [i]);
	return K(() => {
		let t = (t) => {
			let n = oF(t.target), r = oF(t.relatedTarget) === n;
			n && !r && a(jP(e, n));
		}, r = (e) => {
			let t = oF(e.target), n = oF(e.relatedTarget) === t;
			t && !n && a(null);
		}, o = () => {
			i(), n(null);
		}, s = e.view.dom;
		return s.addEventListener("mouseover", t), s.addEventListener("mouseout", r), e.on("update", o), () => {
			i(), s.removeEventListener("mouseover", t), s.removeEventListener("mouseout", r), e.off("update", o);
		};
	}, [
		e,
		a,
		i
	]), {
		hoveredLink: t,
		keepHoveredLink: i,
		dropHoveredLink: () => a(null)
	};
}, aF = (e, t, n) => {
	let r = n?.from, i = n?.to;
	yc(() => {
		let n = t.current;
		if (r === void 0 || i === void 0 || !n) return;
		let a = {
			getBoundingClientRect: () => Rd(e.view, r, i),
			contextElement: e.view.dom
		};
		return Sd(a, n, () => {
			Cd(a, n, {
				strategy: "absolute",
				placement: "top-start",
				middleware: [
					Ed(10),
					wd(),
					Dd({ padding: 8 }),
					Td({ boundary: uN(e.view.dom.parentElement) ?? "clippingAncestors" })
				]
			}).then(({ x: e, y: t, middlewareData: r }) => {
				Object.assign(n.style, {
					left: `${e}px`,
					top: `${t}px`,
					visibility: r.hide?.referenceHidden ? "hidden" : "visible"
				});
			});
		});
	}, [
		e,
		t,
		r,
		i
	]);
}, oF = (e) => e instanceof Element ? e.closest("a") : null, sF = ({ editor: e, containerRef: t, "data-testid": n }) => {
	let r = J(null), i = cN(t), [a, o] = Y(null), { hoveredLink: s, keepHoveredLink: c, dropHoveredLink: l } = iF(e), { isEditable: u, linkAtSelection: d } = id({
		editor: e,
		selector: ({ editor: e }) => ({
			isEditable: e.isEditable,
			linkAtSelection: e.isFocused ? AP(e) : null
		})
	}), f = a ?? d ?? s, p = u && f !== null;
	return aF(e, r, p ? f : null), Jc({
		ref: r,
		enabled: a !== null,
		handler: () => o(null)
	}), p ? Wl(/* @__PURE__ */ U(R, {
		ref: r,
		position: "absolute",
		top: "0",
		left: "0",
		zIndex: aP,
		visibility: "hidden",
		onMouseEnter: c,
		onMouseLeave: l,
		children: a ? /* @__PURE__ */ U(OP, {
			initialHref: a.href,
			initialText: a.text,
			onSubmit: (t) => {
				NP(e, a, t), o(null);
			},
			onCancel: () => {
				o(null), e.commands.focus();
			},
			"data-testid": `${n}.editForm`
		}) : /* @__PURE__ */ W(B, {
			role: "toolbar",
			"aria-label": "Link",
			"data-testid": n,
			gap: "2px",
			padding: "4px",
			backgroundColor: I,
			border: `1px solid ${P}`,
			borderRadius: "8px",
			boxShadow: yn,
			onMouseDown: (e) => e.preventDefault(),
			children: [
				/* @__PURE__ */ U(zP, {
					label: "Edit link",
					"data-testid": `${n}.edit.tooltip`,
					children: /* @__PURE__ */ U(Jk, {
						"aria-label": "Edit link",
						icon: /* @__PURE__ */ U(ih, {}),
						isActive: !1,
						onClick: () => o(f),
						"data-testid": `${n}.edit`
					})
				}),
				/* @__PURE__ */ U(zP, {
					label: "Open in new tab",
					"data-testid": `${n}.open.tooltip`,
					children: /* @__PURE__ */ U(Jk, {
						"aria-label": "Open in new tab",
						icon: /* @__PURE__ */ U(Dh, {}),
						isActive: !1,
						href: f.href,
						"data-testid": `${n}.open`
					})
				}),
				/* @__PURE__ */ U(zP, {
					label: "Remove link",
					"data-testid": `${n}.remove.tooltip`,
					children: /* @__PURE__ */ U(Jk, {
						"aria-label": "Remove link",
						icon: /* @__PURE__ */ U(Op, {}),
						isActive: !1,
						onClick: () => PP(e, f),
						"data-testid": `${n}.remove`
					})
				})
			]
		})
	}), i) : null;
}, cF = ({ editor: e, block: t, onOpenChange: n, onDraggingChange: r, "data-testid": i }) => {
	let a = bN(t), o = a && SN(e.state.doc, a);
	return /* @__PURE__ */ U(Xb, {
		"data-testid": i,
		canFlip: !0,
		width: 176,
		onOpenChange: n,
		menuButton: /* @__PURE__ */ U(Q, {
			variant: "ghost",
			size: "24px",
			"aria-label": "Open block menu",
			icon: /* @__PURE__ */ U(fm, { color: k }),
			draggable: !0,
			onDragStart: (n) => {
				r(!0), Ej({
					view: e.view,
					event: n.nativeEvent,
					range: vN(e.state, t)
				});
			},
			onDragEnd: () => {
				r(!1), Oj(e.view);
			}
		}),
		items: [
			{
				label: "Colors",
				iconLeft: /* @__PURE__ */ U(Bh, {}),
				hidden: !a,
				subMenuWidth: 174,
				renderSubMenu: ({ closeMenu: t }) => a && o && /* @__PURE__ */ U(WP, {
					textColor: o.textColor,
					backgroundColor: o.backgroundColor,
					onTextColorChange: (n) => {
						CN(e, a, { textColor: n }), t();
					},
					onBackgroundColorChange: xN(a) ? void 0 : (n) => {
						CN(e, a, { backgroundColor: n }), t();
					},
					"data-testid": `${i}.colors`
				}),
				"data-testid": `${i}.colors`
			},
			{
				label: "Header row",
				iconLeft: /* @__PURE__ */ U(Vm, {}),
				iconRight: t.node.attrs.headerRow ? /* @__PURE__ */ U(zp, {}) : void 0,
				hidden: !xN(t),
				onClick: () => e.chain().focus().toggleTableHeader({
					position: t.pos,
					header: "headerRow"
				}).run(),
				"data-testid": `${i}.headerRow`
			},
			{
				label: "Header column",
				iconLeft: /* @__PURE__ */ U(Bm, {}),
				iconRight: t.node.attrs.headerColumn ? /* @__PURE__ */ U(zp, {}) : void 0,
				hidden: !xN(t),
				onClick: () => e.chain().focus().toggleTableHeader({
					position: t.pos,
					header: "headerColumn"
				}).run(),
				"data-testid": `${i}.headerColumn`
			},
			{
				label: "Delete",
				iconLeft: /* @__PURE__ */ U(Wh, {}),
				style: { color: En },
				onClick: () => yN(e, vN(e.state, t)),
				"data-testid": `${i}.delete`
			}
		]
	});
}, lF = ({ editor: e, containerRef: t, isLocked: n }) => {
	let [r, i] = Y(null), a = J(n);
	return a.current = n, K(() => {
		let n = t.current;
		if (!n) return;
		let r = (t) => {
			let n = a.current ? void 0 : _N(e.view, t.clientY);
			n && i((e) => e?.pos === n.pos && e.node === n.node ? e : n);
		}, o = () => {
			a.current || i(null);
		}, s = ({ transaction: e }) => {
			e.docChanged && i((t) => uF(t, e));
		}, c = e.view.dom;
		return n.addEventListener("mousemove", r), n.addEventListener("mouseleave", o), c.addEventListener("keydown", o), e.on("transaction", s), () => {
			n.removeEventListener("mousemove", r), n.removeEventListener("mouseleave", o), c.removeEventListener("keydown", o), e.off("transaction", s);
		};
	}, [e, t]), r;
}, uF = (e, t) => {
	if (!e) return null;
	let { pos: n, deleted: r } = t.mapping.mapResult(e.pos, 1), i = t.doc.nodeAt(n);
	return !r && i ? {
		pos: n,
		node: i
	} : null;
}, dF = 24, fF = 4, pF = ({ editor: e, containerRef: t, "data-testid": n }) => {
	let [r, i] = Y(!1), [a, o] = Y(!1), s = lF({
		editor: e,
		containerRef: t,
		isLocked: r || a
	});
	K(() => {
		let t = e.view.dom, n = () => o(!1);
		return t.addEventListener("drop", n), () => t.removeEventListener("drop", n);
	}, [e]);
	let c = s && mF(e, s, t.current);
	return /* @__PURE__ */ U(jl, { children: s && c && /* @__PURE__ */ W(Nl.div, {
		"data-testid": n,
		style: {
			display: "flex",
			position: "absolute",
			top: c.top,
			left: c.left,
			zIndex: 1
		},
		initial: { opacity: 0 },
		animate: { opacity: 1 },
		exit: {
			opacity: 0,
			pointerEvents: "none"
		},
		transition: { duration: .25 },
		children: [/* @__PURE__ */ U(Q, {
			variant: "ghost",
			size: `${dF}px`,
			"aria-label": "Add block",
			icon: /* @__PURE__ */ U(dh, { color: "#64748b" }),
			onMouseDown: (e) => e.preventDefault(),
			onClick: () => wN(e, s),
			"data-testid": `${n}.addBlock`
		}), /* @__PURE__ */ U(cF, {
			editor: e,
			block: s,
			onOpenChange: i,
			onDraggingChange: o,
			"data-testid": `${n}.dragHandle`
		})]
	}) });
}, mF = (e, t, n) => {
	let r = e.view.nodeDOM(t.pos);
	if (!(r instanceof HTMLElement) || !n) return;
	let i = n.getBoundingClientRect(), a = r.getBoundingClientRect(), o = hF(t, r);
	return {
		top: (o ? gF(o) - dF / 2 : a.top) - i.top,
		left: a.left - i.left - dF * 2 - fF
	};
}, hF = (e, t) => e.node.isTextblock ? t : e.node.firstChild?.isTextblock ? t.firstElementChild : null, gF = (e) => {
	let { top: t, height: n } = e.getBoundingClientRect(), r = window.getComputedStyle(e), i = Number.parseFloat(r.paddingTop) || 0, a = Number.parseFloat(r.lineHeight);
	return Number.isNaN(a) ? t + n / 2 : t + i + a / 2;
}, _F = (e, { table: t, axis: n, index: r }, i) => {
	let a = tj(t);
	a !== void 0 && i(e.chain().focus().command(({ tr: e }) => {
		let t = e.doc.resolve(a + 1 + wF(e.doc, a, {
			axis: n,
			index: r
		}));
		return e.setSelection(X(n).with("row", () => mf.rowSelection(t)).with("column", () => mf.colSelection(t)).exhaustive()), !0;
	})).command(({ tr: e }) => (e.setSelection(ud.near(e.selection.$from)), !0)).run();
}, vF = (e, { table: t, axis: n, index: r }) => {
	let i = tj(t), a = i === void 0 ? null : e.state.doc.nodeAt(i + 1 + wF(e.state.doc, i, {
		axis: n,
		index: r
	}));
	return {
		textColor: a?.attrs.textColor ?? "default",
		backgroundColor: a?.attrs.backgroundColor ?? "default"
	};
}, yF = (e, { table: t, axis: n, count: r }) => {
	let i = tj(t);
	i !== void 0 && e.chain().command(({ tr: e }) => (TF(e, {
		position: i,
		axis: n,
		count: r
	}), e.docChanged)).run();
}, bF = (e, { table: t, axis: n, from: r, to: i }) => {
	let a = tj(t);
	a === void 0 || r === i || e.chain().focus().moveTableLine({
		position: a,
		axis: n,
		from: r,
		to: i
	}).command(({ tr: e }) => (e.setSelection(ud.near(e.selection.$from)), !0)).run();
}, xF = (e, { table: t, header: n }) => {
	let r = tj(t);
	r !== void 0 && e.chain().focus().toggleTableHeader({
		position: r,
		header: n
	}).run();
}, SF = (e, t) => {
	let n = tj(t);
	return n === void 0 ? null : e.state.doc.nodeAt(n);
}, CF = (e, { table: t, row: n, column: r }) => {
	let i = tj(t), a = SF(e, t);
	if (i === void 0 || !a) return null;
	let o = hf.get(a);
	return n < o.height && r < o.width ? i + 1 + o.positionAt(n, r, a) : null;
}, wF = (e, t, { axis: n, index: r }) => {
	let i = e.nodeAt(t);
	if (!i) return 0;
	let a = hf.get(i);
	return X(n).with("row", () => a.positionAt(r, 0, i)).with("column", () => a.positionAt(0, r, i)).exhaustive();
}, TF = (e, { position: t, axis: n, count: r }) => {
	let i = e.doc.nodeAt(t);
	if (!i) return;
	let a = hf.get(i), o = {
		map: a,
		table: i,
		tableStart: t + 1,
		left: 0,
		top: 0,
		right: a.width,
		bottom: a.height
	}, s = X(n).with("row", () => a.height).with("column", () => a.width).exhaustive(), c = s - 1, l = s > 1 && EF(i, a, {
		axis: n,
		index: c
	}).every(cj);
	if (s < r) {
		X(n).with("row", () => vf(e, o, s)).with("column", () => _f(e, o, s)).exhaustive(), TF(e, {
			position: t,
			axis: n,
			count: r
		});
		return;
	}
	s > r && l && (X(n).with("row", () => Tf(e, o, c)).with("column", () => wf(e, o, c)).exhaustive(), TF(e, {
		position: t,
		axis: n,
		count: r
	}));
}, EF = (e, t, { axis: n, index: r }) => t.map.filter((e, i) => X(n).with("row", () => Math.floor(i / t.width) === r).with("column", () => i % t.width === r).exhaustive()).flatMap((t) => e.nodeAt(t) ?? []), DF = 24, OF = (e, t) => {
	let n = e.findIndex(({ end: e }) => t < e);
	return n === -1 ? e.length - 1 : n;
}, kF = (e, t) => X(t).with("row", () => Array.from(e.rows).map((e) => {
	let { top: t, bottom: n } = e.getBoundingClientRect();
	return {
		start: t,
		end: n
	};
})).with("column", () => Array.from(e.rows.item(0)?.cells ?? []).map((e) => {
	let { left: t, right: n } = e.getBoundingClientRect();
	return {
		start: t,
		end: n
	};
})).exhaustive(), AF = (e) => {
	let { left: t, right: n } = (e.parentElement ?? e).getBoundingClientRect();
	return {
		start: t,
		end: n
	};
}, jF = (e, t) => ({
	start: Math.max(e.start, t.start),
	end: Math.min(e.end, t.end)
}), MF = ({ start: e, end: t }) => t <= e, NF = (e) => {
	let { left: t, right: n } = e.getBoundingClientRect();
	return jF({
		start: t,
		end: n
	}, AF(e));
}, PF = (e, t, n) => {
	let r = Array.from(e.querySelectorAll("table")).find((e) => {
		let { top: r, bottom: i } = e.getBoundingClientRect(), a = NF(e);
		return t >= a.start - DF && t <= a.end + DF && n >= r - DF && n <= i + DF;
	});
	if (!r) return null;
	let i = NF(r);
	return {
		table: r,
		row: OF(kF(r, "row"), n),
		column: OF(kF(r, "column"), Nf(t, i.start, i.end - 1))
	};
}, FF = (e, t) => e?.table === t?.table && e?.row === t?.row && e?.column === t?.column, IF = (e, t) => X(t).with("row", () => e.clientY).with("column", () => e.clientX).exhaustive(), LF = 16, RF = 10, zF = ({ editor: e, hoveredCell: t, container: n, onMenuOpenChange: r, "data-testid": i }) => {
	let a = t.table.rows.item(t.row)?.cells.item(t.column), o = CF(e, t);
	if (!a || o === null) return null;
	let s = n.getBoundingClientRect(), c = a.getBoundingClientRect(), l = NF(t.table), u = Math.min(c.right, l.end) - LF - RF;
	if (!(u >= Math.max(c.left, l.start))) return null;
	let d = BF(e, o), f = (t) => e.chain().focus().command(({ tr: e }) => (Object.entries(t).forEach(([t, n]) => e.setNodeAttribute(o, t, n)), !0)).run();
	return /* @__PURE__ */ U(R, {
		position: "absolute",
		top: `${c.top - s.top + RF}px`,
		left: `${u - s.left}px`,
		zIndex: 1,
		display: "flex",
		onMouseDown: (e) => e.preventDefault(),
		children: /* @__PURE__ */ U(Xb, {
			"data-testid": i,
			canFlip: !0,
			width: 174,
			onOpenChange: r,
			menuButton: /* @__PURE__ */ U(Q, {
				variant: "secondary",
				size: `${LF}px`,
				"aria-label": "Cell menu",
				icon: /* @__PURE__ */ U(Wp, {
					size: 12,
					color: k
				})
			}),
			items: [{
				label: "Colors",
				iconLeft: /* @__PURE__ */ U(Bh, {}),
				renderSubMenu: ({ closeMenu: e }) => /* @__PURE__ */ U(WP, {
					textColor: d.textColor,
					backgroundColor: d.backgroundColor,
					onTextColorChange: (t) => {
						f({ textColor: t }), e();
					},
					onBackgroundColorChange: (t) => {
						f({ backgroundColor: t }), e();
					},
					"data-testid": `${i}.colors`
				}),
				"data-testid": `${i}.colors`
			}]
		})
	});
}, BF = (e, t) => {
	let n = e.state.doc.nodeAt(t)?.attrs;
	return {
		textColor: n?.textColor ?? "default",
		backgroundColor: n?.backgroundColor ?? "default"
	};
}, VF = 16, HF = 4, UF = ({ editor: e, table: t, axis: n, length: r, onExtendingChange: i, "data-testid": a }) => {
	let o = (r) => {
		r.preventDefault(), i(!0);
		let a = kF(t, n), o = a.at(-1), s = o ? o.end - o.start : 1, c = IF(r, n), l = a.length, u = !1, d = (r) => {
			let i = IF(r, n) - c;
			Math.abs(i) < HF && !u || (u = !0, yF(e, {
				table: t,
				axis: n,
				count: Math.max(1, l + Math.round(i / s))
			}));
		}, f = () => {
			document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", f), u || yF(e, {
				table: t,
				axis: n,
				count: l + 1
			}), i(!1);
		};
		document.addEventListener("mousemove", d), document.addEventListener("mouseup", f);
	}, s = X(n).with("row", () => ({
		width: r,
		height: VF
	})).with("column", () => ({
		width: VF,
		height: r
	})).exhaustive();
	return /* @__PURE__ */ U(R, {
		as: "button",
		type: "button",
		"aria-label": X(n).with("row", () => "Add row").with("column", () => "Add column").exhaustive(),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: `${s.width}px`,
		height: `${s.height}px`,
		color: k,
		backgroundColor: A,
		borderRadius: "4px",
		cursor: X(n).with("row", () => "row-resize").with("column", () => "col-resize").exhaustive(),
		onMouseDown: o,
		"data-testid": a,
		children: /* @__PURE__ */ U(dh, { size: 12 })
	});
}, WF = 4, GF = ({ editor: e, table: t, axis: n, index: r, lineCount: i, onMenuOpenChange: a, onDragChange: o, "data-testid": s }) => {
	let c = J(!1);
	return /* @__PURE__ */ U(R, {
		display: "flex",
		transform: X(n).with("row", () => void 0).with("column", () => "rotate(90deg)").exhaustive(),
		cursor: "grab",
		onMouseDown: (i) => {
			i.preventDefault(), c.current = !1;
			let a = {
				x: i.clientX,
				y: i.clientY
			}, s = (e) => OF(kF(t, n), IF(e, n)), l = (e) => {
				Math.hypot(e.clientX - a.x, e.clientY - a.y) < WF && !c.current || (c.current = !0, o({
					axis: n,
					from: r,
					to: s(e)
				}));
			}, u = (i) => {
				document.removeEventListener("mousemove", l), document.removeEventListener("mouseup", u), c.current && bF(e, {
					table: t,
					axis: n,
					from: r,
					to: s(i)
				}), o(null);
			};
			document.addEventListener("mousemove", l), document.addEventListener("mouseup", u);
		},
		onClickCapture: (e) => {
			c.current &&= (e.stopPropagation(), !1);
		},
		children: /* @__PURE__ */ U(Xb, {
			"data-testid": s,
			canFlip: !0,
			width: 200,
			onOpenChange: a,
			menuButton: /* @__PURE__ */ U(Q, {
				variant: "secondary",
				size: "20px",
				"aria-label": X(n).with("row", () => "Row menu").with("column", () => "Column menu").exhaustive(),
				icon: /* @__PURE__ */ U(fm, {
					size: 14,
					color: k
				})
			}),
			items: KF({
				editor: e,
				table: t,
				axis: n,
				index: r,
				lineCount: i,
				"data-testid": s
			})
		})
	});
}, KF = ({ editor: e, table: t, axis: n, index: r, lineCount: i, "data-testid": a }) => {
	let o = {
		table: t,
		axis: n,
		index: r
	}, s = (t) => _F(e, o, t), c = X(n).returnType().with("row", () => "headerRow").with("column", () => "headerColumn").exhaustive(), l = !!SF(e, t)?.attrs[c], u = vF(e, o), d = X(n).with("row", () => ({
		delete: "Delete row",
		addBefore: "Add row above",
		addAfter: "Add row below",
		header: "Header row"
	})).with("column", () => ({
		delete: "Delete column",
		addBefore: "Add column left",
		addAfter: "Add column right",
		header: "Header column"
	})).exhaustive();
	return [
		{
			label: "Colors",
			iconLeft: /* @__PURE__ */ U(Bh, {}),
			subMenuWidth: 174,
			renderSubMenu: ({ closeMenu: e }) => /* @__PURE__ */ U(WP, {
				textColor: u.textColor,
				backgroundColor: u.backgroundColor,
				onTextColorChange: (t) => {
					s((e) => e.setCellAttribute("textColor", t)), e();
				},
				onBackgroundColorChange: (t) => {
					s((e) => e.setCellAttribute("backgroundColor", t)), e();
				},
				"data-testid": `${a}.colors`
			}),
			"data-testid": `${a}.colors`
		},
		{
			label: d.addBefore,
			iconLeft: /* @__PURE__ */ U(dh, {}),
			onClick: () => s((e) => X(n).with("row", () => e.addRowBefore()).with("column", () => e.addColumnBefore()).exhaustive()),
			"data-testid": `${a}.addBefore`
		},
		{
			label: d.addAfter,
			iconLeft: /* @__PURE__ */ U(dh, {}),
			onClick: () => s((e) => X(n).with("row", () => e.addRowAfter()).with("column", () => e.addColumnAfter()).exhaustive()),
			"data-testid": `${a}.addAfter`
		},
		{
			label: d.header,
			iconLeft: X(n).with("row", () => /* @__PURE__ */ U(Vm, {})).with("column", () => /* @__PURE__ */ U(Bm, {})).exhaustive(),
			iconRight: l ? /* @__PURE__ */ U(zp, {}) : void 0,
			hidden: r > 0,
			onClick: () => xF(e, {
				table: t,
				header: c
			}),
			"data-testid": `${a}.header`
		},
		{
			label: d.delete,
			iconLeft: /* @__PURE__ */ U(Wh, {}),
			style: { color: En },
			isDisabled: i === 1,
			onClick: () => s((e) => X(n).with("row", () => e.deleteRow()).with("column", () => e.deleteColumn()).exhaustive()),
			"data-testid": `${a}.delete`
		}
	];
}, qF = ({ editor: e, containerRef: t, isLocked: n }) => {
	let [r, i] = Y(null), a = J(n);
	return a.current = n, K(() => {
		let n = t.current;
		if (!n) return;
		let r = (t) => {
			if (a.current) return;
			let n = PF(e.view.dom, t.clientX, t.clientY);
			i((e) => FF(e, n) ? e : n);
		}, o = () => {
			a.current || i(null);
		}, s = e.view.dom;
		return n.addEventListener("mousemove", r), n.addEventListener("mouseleave", o), s.addEventListener("keydown", o), () => {
			n.removeEventListener("mousemove", r), n.removeEventListener("mouseleave", o), s.removeEventListener("keydown", o);
		};
	}, [e, t]), r;
}, JF = (e) => {
	let [, t] = bc((e) => e + 1, 0);
	K(() => {
		let n = e?.parentElement;
		if (!e || !n) return;
		let r = new ResizeObserver(t);
		return r.observe(e), n.addEventListener("scroll", t, { passive: !0 }), () => {
			r.disconnect(), n.removeEventListener("scroll", t);
		};
	}, [e]);
}, YF = (e) => {
	let [t, n] = Y(!1);
	return K(() => {
		let t = () => n(!0), r = () => n(!1), i = e.view.dom;
		return i.addEventListener("mousedown", t), document.addEventListener("mouseup", r), () => {
			i.removeEventListener("mousedown", t), document.removeEventListener("mouseup", r);
		};
	}, [e]), t;
}, XF = 2, ZF = 1, QF = ({ editor: e, containerRef: t, "data-testid": n }) => {
	let [r, i] = Y(!1), [a, o] = Y(!1), [s, c] = Y(null), l = YF(e), u = qF({
		editor: e,
		containerRef: t,
		isLocked: r || a || s !== null
	});
	JF(u?.table);
	let d = t.current;
	return !(u !== null && u.table.isConnected && !l) || !d ? null : /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U($F, {
		editor: e,
		hoveredCell: u,
		container: d,
		drag: s,
		onDragChange: c,
		onMenuOpenChange: i,
		onExtendingChange: o,
		"data-testid": n
	}), /* @__PURE__ */ U(zF, {
		editor: e,
		hoveredCell: u,
		container: d,
		onMenuOpenChange: i,
		"data-testid": `${n}.cellButton`
	})] });
}, $F = ({ editor: e, hoveredCell: { table: t, row: n, column: r }, container: i, drag: a, onDragChange: o, onMenuOpenChange: s, onExtendingChange: c, "data-testid": l }) => {
	let u = i.getBoundingClientRect(), d = t.getBoundingClientRect(), f = AF(t), p = NF(t), m = kF(t, "row"), h = kF(t, "column"), g = m.at(n), _ = h.at(r);
	if (!g || !_) return null;
	let v = jF(_, p), y = !MF(v), b = d.right <= f.end + ZF, x = (e) => e - u.left, S = (e) => e - u.top;
	return /* @__PURE__ */ W(H, { children: [
		/* @__PURE__ */ U(tI, {
			left: Math.max(x(d.left) - 20 / 2, x(f.start)),
			top: S(nI(g)) - 20 / 2,
			children: /* @__PURE__ */ U(GF, {
				editor: e,
				table: t,
				axis: "row",
				index: n,
				lineCount: m.length,
				onMenuOpenChange: s,
				onDragChange: o,
				"data-testid": `${l}.rowHandle`
			})
		}),
		y && /* @__PURE__ */ U(tI, {
			left: x(Nf(nI(v), p.start + 20 / 2, p.end - 20 / 2) - 20 / 2),
			top: S(d.top) - 20 / 2,
			children: /* @__PURE__ */ U(GF, {
				editor: e,
				table: t,
				axis: "column",
				index: r,
				lineCount: h.length,
				onMenuOpenChange: s,
				onDragChange: o,
				"data-testid": `${l}.columnHandle`
			})
		}),
		/* @__PURE__ */ U(tI, {
			left: x(p.start),
			top: S(d.bottom) + XF,
			children: /* @__PURE__ */ U(UF, {
				editor: e,
				table: t,
				axis: "row",
				length: p.end - p.start,
				onExtendingChange: c,
				"data-testid": `${l}.addRow`
			})
		}),
		b && /* @__PURE__ */ U(tI, {
			left: x(d.right) + XF,
			top: S(d.top),
			children: /* @__PURE__ */ U(UF, {
				editor: e,
				table: t,
				axis: "column",
				length: d.height,
				onExtendingChange: c,
				"data-testid": `${l}.addColumn`
			})
		}),
		a && /* @__PURE__ */ U(eI, {
			drag: a,
			spans: X(a.axis).with("row", () => m).with("column", () => h).exhaustive(),
			tableRect: d,
			visible: p,
			containerRect: u,
			"data-testid": `${l}.dropIndicator`
		})
	] });
}, eI = ({ drag: e, spans: t, tableRect: n, visible: r, containerRect: i, "data-testid": a }) => {
	let o = t.at(e.to);
	if (!o) return null;
	let s = e.to > e.from ? o.end : o.start, c = s >= r.start && s <= r.end;
	return e.axis === "column" && !c ? null : X(e.axis).with("row", () => /* @__PURE__ */ U(tI, {
		left: r.start - i.left,
		top: s - i.top - 1,
		children: /* @__PURE__ */ U(R, {
			width: `${r.end - r.start}px`,
			height: "2px",
			backgroundColor: C,
			"data-testid": a
		})
	})).with("column", () => /* @__PURE__ */ U(tI, {
		left: s - i.left - 1,
		top: n.top - i.top,
		children: /* @__PURE__ */ U(R, {
			width: "2px",
			height: `${n.height}px`,
			backgroundColor: C,
			"data-testid": a
		})
	})).exhaustive();
}, tI = ({ left: e, top: t, children: n }) => /* @__PURE__ */ U(R, {
	position: "absolute",
	left: `${e}px`,
	top: `${t}px`,
	zIndex: 1,
	children: n
}), nI = ({ start: e, end: t }) => e + (t - e) / 2, rI = ({ initialContent: e, onChange: t, isEditable: n, dimmed: r = "none", placeholder: i, variables: a = [], variableValues: o, customBlocks: s = [], images: c, newTableColumnWidth: l, "data-testid": u = "blockEditor", suggestionMenuTestId: d = `${u}.suggestionMenu` }) => {
	let f = J(null), { displayNotification: p } = jx(), { extensions: m, editorProps: h } = q(() => ({
		extensions: DP({
			placeholder: i,
			variables: a,
			customBlocks: s,
			images: c,
			newTableColumnWidth: l,
			onUploadFailed: () => p("Upload failed", { type: "error" }),
			suggestionMenuTestId: d,
			"data-testid": u
		}),
		editorProps: { attributes: {
			tabindex: "0",
			"data-testid": `${u}.content`
		} }
	}), []), g = rd({
		extensions: m,
		content: e,
		editable: n,
		editorProps: h,
		onUpdate: ({ editor: e }) => t(e.getJSON())
	});
	return K(() => {
		g.setEditable(n, !1);
	}, [g, n]), K(() => {
		o && g.commands.setVariableValues(o);
	}, [g, o]), /* @__PURE__ */ W(LA, {
		ref: f,
		$dimmed: r,
		"data-dimmed": r,
		"data-testid": u,
		children: [
			/* @__PURE__ */ U(Zu, { editor: g }),
			/* @__PURE__ */ U(XP, {
				editor: g,
				canReplaceImage: c !== void 0,
				containerRef: f,
				"data-testid": `${u}.formattingToolbar`
			}),
			c && /* @__PURE__ */ U(tF, {
				editor: g,
				images: c,
				containerRef: f,
				"data-testid": `${u}.imageFilePanel`
			}),
			/* @__PURE__ */ U(sF, {
				editor: g,
				containerRef: f,
				"data-testid": `${u}.linkToolbar`
			}),
			n && /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(pF, {
				editor: g,
				containerRef: f,
				"data-testid": `${u}.sideMenu`
			}), /* @__PURE__ */ U(QF, {
				editor: g,
				containerRef: f,
				"data-testid": `${u}.table`
			})] })
		]
	});
}, iI = ({ name: e, type: t, metadata: n, preview: r, menuItems: i, additionalContent: a, onClick: o }) => /* @__PURE__ */ W(B, {
	direction: "column",
	gap: 2,
	padding: 2,
	borderRadius: 8,
	role: "group",
	border: `1px solid ${P}`,
	transition: "background 0.2s ease-in-out",
	_hover: { background: A },
	_focusWithin: { background: A },
	onClick: o,
	cursor: o ? "pointer" : "default",
	background: I,
	minW: "296px",
	children: [
		/* @__PURE__ */ W(B, {
			gap: 2,
			alignItems: "center",
			height: "16px",
			children: [
				/* @__PURE__ */ U(aI, { type: t }),
				/* @__PURE__ */ U(V, {
					...N,
					fontWeight: "semibold",
					color: L,
					flex: 1,
					overflow: "hidden",
					children: /* @__PURE__ */ U(mv, {
						splitPercentage: 80,
						children: e
					})
				}),
				i && /* @__PURE__ */ U(Xb, {
					items: i,
					variant: "ghost"
				})
			]
		}),
		/* @__PURE__ */ W(B, {
			background: A,
			padding: 1,
			borderRadius: 4,
			gap: 2,
			children: [/* @__PURE__ */ U(R, {
				pointerEvents: "none",
				overflow: "hidden",
				borderRadius: 4,
				border: `0.5px solid ${P}`,
				width: "52px",
				height: "73px",
				children: r
			}), /* @__PURE__ */ U(Kr, {
				templateColumns: "auto 1fr",
				gap: 2,
				flex: 1,
				...N,
				padding: 1,
				children: n.map(([e, t]) => /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(V, {
					color: k,
					children: e
				}, e), /* @__PURE__ */ U(V, {
					justifySelf: "end",
					color: F,
					children: t
				}, `${e}-${t}`)] }))
			})]
		}),
		a
	]
}), aI = ({ type: e }) => U(e === "document" ? Sm : Pm, { color: F }), oI = "sequence_cookie_consent", sI = 1, cI = (e) => {
	if (!e) return null;
	try {
		let { status: t, version: n, timestamp: r } = JSON.parse(e);
		return t !== "accepted" && t !== "rejected" || n !== 1 ? null : {
			status: t,
			timestamp: r ?? "",
			version: n
		};
	} catch {
		return null;
	}
}, lI = {
	consent: (() => {
		if (typeof window > "u") return null;
		try {
			return cI(window.localStorage.getItem(oI));
		} catch {
			return null;
		}
	})(),
	isBannerForcedOpen: !1
}, uI = /* @__PURE__ */ new Set(), dI = (e) => {
	lI = e, uI.forEach((e) => e());
}, fI = (e) => (uI.add(e), () => uI.delete(e)), pI = () => lI, mI = () => lI.consent, hI = (e) => {
	let t = {
		status: e,
		timestamp: (/* @__PURE__ */ new Date()).toISOString(),
		version: 1
	};
	if (typeof window < "u") try {
		window.localStorage.setItem(oI, JSON.stringify(t));
	} catch {}
	dI({
		consent: t,
		isBannerForcedOpen: !1
	});
}, gI = () => {
	dI({
		...lI,
		isBannerForcedOpen: !0
	});
};
typeof window < "u" && window.addEventListener("storage", (e) => {
	e.key === "sequence_cookie_consent" && dI({
		...lI,
		consent: cI(e.newValue)
	});
});
//#endregion
//#region src/features/consent/useCookieConsent.ts
var _I = () => {
	let e = xc(fI, pI), t = G(() => hI("accepted"), []), n = G(() => hI("rejected"), []), r = G(() => gI(), []), i = e.consent !== null;
	return {
		status: e.consent?.status ?? null,
		hasResponded: i,
		isBannerOpen: e.isBannerForcedOpen || !i,
		accept: t,
		reject: n,
		reopen: r
	};
}, vI = "customFields", yI = ({ fields: e, renderCells: t, onAdd: n, onRemove: r, disabled: i = !1, title: a, addButtonLabel: o = "Add custom field", addButtonTestId: s, addButtonVariant: c = "dashed", alwaysShowOneRow: l = !0, width: u = "100%", "data-testid": d = vI }) => {
	K(() => {
		l && e.length === 0 && !i && n();
	}, [
		l,
		e.length,
		i,
		n
	]);
	let f = J(null), p = J(!1), m = G(() => {
		p.current = !0, n();
	}, [n]);
	K(() => {
		if (!p.current) return;
		p.current = !1;
		let e = f.current?.children;
		(e?.[e.length - 1])?.querySelector("input, button, [tabindex]:not([tabindex=\"-1\"])")?.focus();
	}, [e.length]);
	let h = e.length > 1, g = s ?? `${d}.add`;
	return /* @__PURE__ */ W(B, {
		width: u,
		flexDirection: "column",
		gap: 2,
		"data-testid": d,
		children: [
			a && /* @__PURE__ */ U(V, {
				...j,
				color: "#475569",
				children: a
			}),
			/* @__PURE__ */ U(B, {
				flexDirection: "column",
				gap: "8px",
				ref: f,
				children: e.map((n, a) => {
					let o = e.filter((e) => e.id !== n.id);
					return /* @__PURE__ */ W(B, {
						gap: "8px",
						alignItems: "center",
						width: "100%",
						"data-testid": `${d}.row.${a}`,
						children: [t(n, o, a), h && /* @__PURE__ */ U(Q, {
							variant: "ghost",
							size: "24px",
							"aria-label": "Remove row",
							icon: /* @__PURE__ */ U(Wh, {}),
							color: "#64748b",
							hover: i ? void 0 : { color: "#ef4444" },
							style: { flexShrink: 0 },
							"data-testid": `${d}.row.${a}.remove`,
							onClick: () => r(n.id),
							disabled: i
						})]
					}, n.id);
				})
			}),
			X(c).with("dashed", () => /* @__PURE__ */ U(sk, {
				text: o,
				onClick: m,
				isDisabled: i,
				"data-testid": g
			})).with("ghost", () => /* @__PURE__ */ U(Q, {
				variant: "ghost",
				fullWidth: !0,
				leadingIcon: /* @__PURE__ */ U(dh, {}),
				onClick: m,
				disabled: i,
				"data-testid": g,
				children: o
			})).with("inline", () => /* @__PURE__ */ W(B, {
				as: "button",
				type: "button",
				"data-testid": g,
				onClick: m,
				onKeyDown: (e) => {
					e.key === "Enter" && e.stopPropagation();
				},
				gap: "8px",
				alignItems: "center",
				alignSelf: "flex-start",
				marginTop: "4px",
				color: y,
				cursor: i ? "default" : "pointer",
				opacity: i ? .5 : 1,
				_hover: { opacity: i ? void 0 : .8 },
				disabled: i,
				...j,
				children: [/* @__PURE__ */ U(Xr, {
					as: dh,
					height: "16px",
					width: "16px",
					color: y
				}), o]
			})).exhaustive()
		]
	});
}, bI = { flex: "1 1 0" }, xI = ({ keyValue: e, onKeyChange: t, keyOptions: n, keyPlaceholder: r = "Select or add a key", keyControl: i = "tag", keyCellSizing: a = bI, siblingFields: o, value: s, onValueChange: c, valuePlaceholder: l = "Value", valueCellSizing: u = bI, disabled: d = !1, testIdPrefix: f }) => {
	let p = J(null), m = q(() => o.map((e) => e.key), [o]), h = q(() => {
		let e = o.map((e) => e.key);
		return n.filter((t) => !e.includes(t.value));
	}, [n, o]);
	return /* @__PURE__ */ W(H, { children: [/* @__PURE__ */ U(R, {
		minWidth: "0",
		...a,
		"data-testid": f ? `${f}.key` : void 0,
		children: X(i).with("select", () => /* @__PURE__ */ U(zv, {
			value: e,
			onChange: t,
			options: h,
			placeholder: r,
			disabled: d,
			triggerStyle: { width: "100%" },
			"data-testid": f ? `${f}.keyControl` : void 0
		})).with("tag", () => /* @__PURE__ */ U(zy, {
			allowCreate: !0,
			value: e,
			onChange: t,
			options: h,
			unavailableKeys: m,
			placeholder: r,
			disabled: d,
			triggerStyle: { width: "100%" },
			"data-testid": f ? `${f}.keyControl` : void 0,
			onCommitWithEnter: () => p.current?.querySelector("input")?.focus()
		})).exhaustive()
	}), /* @__PURE__ */ U(R, {
		minWidth: "0",
		...u,
		ref: p,
		"data-testid": f ? `${f}.value` : void 0,
		children: /* @__PURE__ */ U(Qy, {
			label: "",
			placeholder: l,
			value: s,
			onChange: (e) => c(e.target.value),
			disabled: d,
			styles: { wrapper: {
				width: "100%",
				marginBottom: 0
			} }
		})
	})] });
}, SI = (e) => Object.entries(e ?? {}).map(([e, t]) => ({
	id: e,
	key: e,
	value: t
})), CI = (e) => e.reduce((e, t) => {
	let n = t.key.trim();
	return n ? {
		...e,
		[n]: t.value
	} : e;
}, {}), wI = ({ value: e, onChange: t, availableKeys: n }) => {
	let r = q(() => {
		let t = e.map((e) => e.key).filter(Boolean);
		return Array.from(/* @__PURE__ */ new Set([...n, ...t])).sort((e, t) => e.localeCompare(t)).map((e) => ({
			id: e,
			label: e,
			value: e
		}));
	}, [e, n]), i = G(() => {
		t([...e, {
			id: `new-${crypto.randomUUID()}`,
			key: "",
			value: ""
		}]);
	}, [e, t]), a = G((n, r) => {
		t(e.map((e) => e.id === n ? {
			...e,
			...r
		} : e));
	}, [e, t]), o = G((n) => {
		t(e.filter((e) => e.id !== n));
	}, [e, t]);
	return q(() => ({
		keyOptions: r,
		onAdd: i,
		onUpdate: a,
		onRemove: o
	}), [
		r,
		i,
		a,
		o
	]);
}, TI = Object.assign(yI, { Row: xI });
//#endregion
export { xr as Accordion, Sr as AccordionButton, Cr as AccordionIcon, wr as AccordionItem, Tr as AccordionPanel, NC as ActiveFilterPill, WS as ActivityCard, sk as AddButton, zC as AddFilterButton, sC as ArrowLongRightPdfIcon, ky as AsyncInputSelectControl, Ay as AsyncInputSelectControlField, Iy as AsyncMultiSelectControl, iI as AttachmentUIV2, OO as AuthUI, Ff as Avatar, MA as BACKGROUND_COLOR_HEX, er as BackgroundColoursCtaBackgroundColour, Bt as BackgroundColoursError, qt as BackgroundColoursHighlight, Mn as BackgroundColoursInformative, xn as BackgroundColoursNeutral, tn as BackgroundColoursSuccess, Zt as BackgroundColoursWarning, ig as Badge, Tt as BadgeMdContainerError, ir as BadgeMdContainerHighlight, mr as BadgeMdContainerInfo, Mt as BadgeMdContainerNeutral, dr as BadgeMdContainerSuccess, qe as BadgeMdContainerWarning, f as BadgeSmContainerError, sr as BadgeSmContainerHighlight, Ze as BadgeSmContainerInfo, b as BadgeSmContainerNeutral, g as BadgeSmContainerSuccess, je as BadgeSmContainerWarning, pn as BadgeTextLabelError, i as BadgeTextLabelHighlight, ln as BadgeTextLabelInfo, Ce as BadgeTextLabelNeutral, De as BadgeTextLabelSuccess, Fe as BadgeTextLabelWarning, Rx as Banner, YC as BarChart, rI as BlockEditor, Mg as BlockerDialog, w as BorderRadius4, se as BorderRadius6, ye as BorderRadius8, Dr as Box, bb as BulkActionActionsList, $b as BulkActionBar, Cb as BulkActions, wb as BulkActionsPositioner, ex as BulkActionsSummary, Q as Button, dg as ButtonGroup, oI as CONSENT_STORAGE_KEY, sI as CONSENT_VERSION, k_ as CalendarView, Tg as CancelButton, Mx as Card, Nr as Center, Vy as Checkbox, lb as CheckboxGroupField, Qv as CheckboxGroupInput, cb as CheckboxLineField, Zv as CheckboxLineInput, fg as ClearButton, Ir as Collapse, uk as CollapsibleSection, Hx as ConsentBanner, OC as ContactList, Gy as ContextControl, K_ as Control, U_ as ControlContext, G_ as ControlContextProvider, Ev as ControlEmptyState, ux as ConvertInvoicesToDraftDialog, fx as CopyButton, sv as CreateMenuItem, TI as CustomFieldsEditor, SC as CustomerCard, JS as CustomerLogo, Z_ as DateControl, sb as DateDurationField, Xy as DateDurationInput, L_ as DateDurationPopover, my as DateInputControl, ab as DatePickerField, F_ as DatePickerInput, jv as DateRangePicker, Av as DateRangePickerCalendars, ob as DateRangePickerField, Xv as DateRangePickerInput, rb as DayOfMonthField, Ug as DayOfMonthInput, Dv as DaysDurationPicker, lx as DeleteInvoicesDialog, wC as DismissableFloatingCard, Lr as Divider, Nx as Drawer, DA as EmailBodyPreview, ak as EmailLoginForm, wA as EmailPreview, XC as EmptyChart, aC as EmptyState, VC as EntityFiltersBar, px as EntityLink, mx as EnvironmentBanner, qS as ErrorMessage, pb as FieldValidationError, tS as FilePickerButton, ax as FinalizeInvoicesDialog, Hr as Flex, Ue as FontFamiliesInconsolata, _r as FontFamiliesLato, c as FontFamiliesModerat, at as FontFamiliesSystem, re as FontSize12, tt as FontSize13, lt as FontSize14, ee as FontSize16, he as FontSize18, In as FontSize20, de as FontSize24, _t as FontSize28, pt as FontSize32, xt as FontSize40, ze as FontWeightsBold, e as FontWeightsRegular, Kt as FontWeightsSemiBold, $n as GreenGreen10, Dn as GreenGreen20, Wn as GreenGreen30, cn as GreenGreen40, jt as GreenGreen50, jn as GreenGreen60, Jn as GreenGreen70, zt as GreenGreen80, bn as GreenGreen90, rr as GreyGrey0, A as GreyGrey10, Xt as GreyGrey100, Fn as GreyGrey20, P as GreyGrey30, M as GreyGrey40, en as GreyGrey50, k as GreyGrey60, F as GreyGrey70, L as GreyGrey80, Ft as GreyGrey90, I as GreyWhite, Gr as Grid, qr as GridItem, pw as INCREASED_TABLE_FETCH_LIMIT, qf as Icon3dBox, Jf as Icon3dPackage2, Yf as IconAgent, Xf as IconAlignmentCenter, Zf as IconAlignmentLeft, Qf as IconAlignmentRight, $f as IconArchive, ep as IconArmchair, tp as IconArrowBoxLeft, np as IconArrowCornerDownLeft, rp as IconArrowCornerDownRight, ip as IconArrowDown, ap as IconArrowInbox, op as IconArrowLeft, sp as IconArrowOutOfBox, cp as IconArrowRight, lp as IconArrowRightLeft, up as IconArrowRotateRightLeft, dp as IconArrowTopBottom, fp as IconArrowUp, pp as IconArrowUpRight, mp as IconArrowsRepeat, hp as IconAt, gp as IconBag, _p as IconBank, vp as IconBanknote, yp as IconBarChart, bp as IconBarChartPresentation, xp as IconBarsThree, Sp as IconBarsThreeBottomLeft, Cp as IconBell, wp as IconBold, Tp as IconBookOpen, Ep as IconBookmark, Dp as IconBooks, Op as IconBrokenChainLink, kp as IconBubbleDots, Ap as IconBug, jp as IconBuildings, Mp as IconCalculator, Np as IconCalendar, Pp as IconCalendarDays, Fp as IconCalendarRemove, Ip as IconChainLink, Lp as IconChairModern, Rp as IconCheckCircle, zp as IconCheckmark, Bp as IconChevronDoubleLeft, Vp as IconChevronDoubleRight, Hp as IconChevronDown, Up as IconChevronDownLarge, Wp as IconChevronDownSmall, Gp as IconChevronGrabberVertical, Kp as IconChevronLeft, qp as IconChevronRight, Jp as IconChevronRightLarge, Yp as IconChevronTop, Xp as IconChevronTopLarge, Zp as IconChip, Bf as IconCircle, Qp as IconCircleBanSign, $p as IconCircleDashed, em as IconCircleInfo, tm as IconCircleMinus, nm as IconCirclePlus, rm as IconCircleQuestionmark, im as IconCircleX, am as IconClipboard, om as IconClock, sm as IconCode, cm as IconCoinStack, lm as IconColumns, um as IconConsole, dm as IconCreditCard, fm as IconDragHandle, pm as IconEdit, mm as IconEllipsisHorizontal, hm as IconEllipsisVertical, gm as IconEmail, _m as IconExclamationCircle, vm as IconExclamationTriangle, ym as IconExpand, bm as IconEyeOpen, xm as IconEyeSlash, Sm as IconFileBend, Cm as IconFilePdf, wm as IconFileText, Tm as IconFilter, Em as IconFlag, Dm as IconFocusExposure, Uf as IconGoogle, Wf as IconGoogleMail, Om as IconGraduateCap, km as IconH1, Am as IconH2, jm as IconH3, Mm as IconHashtag, Nm as IconHome, Pm as IconImages, Fm as IconItalic, Im as IconKey, Lm as IconLab, Rm as IconLayers, zm as IconLayoutGrid, Bm as IconLayoutSidebar, Vm as IconLayoutTopbar, Hm as IconLightningBolt, Um as IconLightningBoltOff, Wm as IconListBullets, Gm as IconLock, Km as IconMagnifyingGlass, qm as IconMaintenance, Jm as IconMapPin, Ym as IconMathScientific, Xm as IconMinimize, Zm as IconMinus, Qm as IconNewspaper, $m as IconNumberedList, Gf as IconOutlook, eh as IconPageAdd, th as IconPageText, Lf as IconPaid, rh as IconPaperPlaneTopRight, nh as IconPaperclip, zf as IconPartiallyPaid, ih as IconPencil, ah as IconPencilWave, oh as IconPeopleCircle, sh as IconPeopleIdCard, ch as IconPieChart, lh as IconPlay, uh as IconPlayCircle, dh as IconPlus, If as IconProgress100, Rf as IconProgress50, fh as IconProjects, ph as IconReceiptBill, mh as IconReceiptCredit, hh as IconReceiptTax, gh as IconRescueRing, _h as IconRocket, vh as IconScale, Kf as IconSequence, yh as IconServer, bh as IconSettingsGear, xh as IconSettingsSliderHorizontal, Sh as IconShieldCheck, Ch as IconSignal, wh as IconSignature, Th as IconSparkles, Eh as IconSpeedHigh, Dh as IconSquareArrowTopRight, Oh as IconSquareBehindSquare, kh as IconSquareGridCircle, Ah as IconStackedBarChart, jh as IconStepBack, Mh as IconStepForwards, Nh as IconStop, Ph as IconStore, Fh as IconStrikeThrough, Ih as IconSubscriptionTick, Lh as IconTable, Rh as IconTag, zh as IconText, Bh as IconTextColor, Vh as IconThumbsDown, Hh as IconThumbsUp, Uh as IconTower, Wh as IconTrashCan, Gh as IconTrendingDown, Kh as IconTrendingUp, Vf as IconUncollectible, qh as IconUnderline, Hf as IconUnpaid, Jh as IconUser, Yh as IconUserDuo, Xh as IconUserGroup, Zh as IconWallet, Qh as IconWorld, $h as IconXMark, eg as IconXMarkLarge, tg as IconZoomIn, ng as IconZoomOut, rg as Icons, nS as Image, Xe as IndigoIndigo10, h as IndigoIndigo20, ur as IndigoIndigo30, et as IndigoIndigo40, C as IndigoIndigo50, y as IndigoIndigo60, Pe as IndigoIndigo70, gn as IndigoIndigo80, s as IndigoIndigo90, hx as InfoBox, __ as InfoPopover, gx as InfoRow, ny as InputLabel, JO as InputOTP, YO as InputOTPGroup, ZO as InputOTPSeparator, XO as InputOTPSlot, zv as InputSelectControl, Bv as InputSelectControlField, Uv as InputSelectControlLegacyStyleBridge, Wv as InputSelectControlLegacyStyleBridgeField, eS as Inspector, tx as InvoiceBulkActionBar, UC as Label, fn as Lato12Bold, Ee as Lato12Regular, Ae as Lato16Bold, Re as Lato24Bold, mS as LayoutChromeLeading, fS as LayoutChromeProvider, D as LetterSpacingSm, ue as LineHeights16, Se as LineHeights20, Ke as LineHeights24, br as LineHeights28, d as LineHeights32, ct as LineHeights40, oe as LineHeights48, it as LineHeights64, FS as LineItemGroup, xx as Link, aS as ListItem, pD as Loading, WD as MAX_PAGES, aO as MagicTable, iO as MagicTableCell, hO as MagicTableCellAggregationType, lO as MagicTableCellCreditNoteStatus, sO as MagicTableCellEmpty, cO as MagicTableCellInvoiceStatus, oO as MagicTableCellLink, fO as MagicTableCellProductStatus, pO as MagicTableCellQuoteStatus, mO as MagicTableCellScheduleStatus, FD as MagicTableDateFilterType, EO as MagicTableEmptyState, DO as MagicTableFilterEmptyState, xO as MagicTableFilters, dx as MarkAsSentInvoicesDialog, cx as MergeInvoicesDialog, oS as MetricCard, Eg as Modal, ft as MonoSpaced12SemiBold, ne as MonoSpaced13SemiBold, ve as MonoSpaced20Regular, Py as MultiSelectControl, vv as MultiSelectControlCore, Fy as MultiSelectControlField, hv as MultiSelectTrigger, ub as MultiTagField, $v as MultiTagInput, Ry as NEW_TAG_PATTERN, sy as NumberFieldInput, fw as OVERSCAN, zn as OnBackgroundColoursError, me as OnBackgroundColoursHighlight, bt as OnBackgroundColoursInformative, gt as OnBackgroundColoursMainDark, wt as OnBackgroundColoursMainLight, He as OnBackgroundColoursNeutral, r as OnBackgroundColoursSuccess, Wt as OnBackgroundColoursWarning, Zn as OrangeOrange10, Tn as OrangeOrange20, Hn as OrangeOrange30, on as OrangeOrange40, kt as OrangeOrange50, kn as OrangeOrange60, Kn as OrangeOrange70, Lt as OrangeOrange80, vn as OrangeOrange90, rS as OrderedList, US as OverviewCard, cS as PANEL_GUTTER, lS as PANEL_RADIUS, Sx as PageTitle, uS as Panel, nb as PercentageField, $g as PercentageInput, vy as Pill, yy as PillRow, Ey as PillSelectControl, Ky as PillSelectControlDropdown, Ty as Popover, wy as PopoverWrapper, xi as Portal, wS as PreviewCard, tb as PriceField, i_ as PriceInput, tr as Primary12Regular, Vt as Primary12SemiBold, Jt as Primary12UppercaseRegular, Nn as Primary12UppercaseSemiBold, N as Primary13Regular, j as Primary13SemiBold, Qt as Primary14ExtendedRegular, Et as Primary14ExtendedSemiBold, ar as Primary14SemiBold, hr as Primary16Regular, Nt as Primary16SemiBold, fr as Primary18Regular, Je as Primary18SemiBold, p as Primary20Regular, cr as Primary20SemiBold, Qe as Primary24Regular, x as Primary24SemiBold, _ as Primary28Regular, Me as Primary28SemiBold, mn as Primary32Regular, a as Primary32SemiBold, un as Primary40Regular, we as Primary40SemiBold, Oe as PrimaryHeader32Regular, Ie as PrimaryPrimary10, T as PrimaryPrimary20, ce as PrimaryPrimary30, be as PrimaryPrimary40, We as PrimaryPrimary50, vr as PrimaryPrimary60, l as PrimaryPrimary70, ot as PrimaryPrimary80, ie as PrimaryPrimary90, kC as ProgressDonut, nt as PurplePurple10, ut as PurplePurple20, te as PurplePurple30, ge as PurplePurple40, Ln as PurplePurple50, fe as PurplePurple60, vt as PurplePurple70, mt as PurplePurple80, St as PurplePurple90, lC as REACT_TO_PDF_SCALE, Ku as REGEXP_ONLY_CHARS, qu as REGEXP_ONLY_DIGITS, Ju as REGEXP_ONLY_DIGITS_AND_CHARS, uy as RadioButton, ly as RadioButtonGroup, fb as RadioButtonGroupField, oC as RadioGroup, ib as RadioGroupField, b_ as RadioGroupInput, yC as ReactPdfBullet, bC as ReactPdfHollowBullet, gC as ReactPdfImage, hC as ReactPdfLink, mC as ReactPdfPage, xC as ReactPdfSquareBullet, vC as ReactPdfSvg, pC as ReactPdfText, fC as ReactPdfView, rx as RecalculateInvoicesDialog, Be as RedRed10, t as RedRed20, Gt as RedRed30, Qn as RedRed40, En as RedRed50, Un as RedRed60, sn as RedRed70, At as RedRed80, An as RedRed90, uA as RichTextEditor, ID as SORT_BY_KEY, cC as SaveStatus, hb as ScrollFade, lk as Section, wO as SelectAllPrompt, bv as SelectControl, ix as SendInvoicesDialog, sx as SendPaymentReminderForInvoicesDialog, Xb as SequenceKebabMenu, Xb as SequenceMenu, kb as SequenceMenuContainer, Fb as SequenceMenuDivider, zb as SequenceMenuItem, Yn as SequenceThemeProvider, nC as SettingsAdditionalField, $S as SettingsFormControl, eC as SettingsFormControlIcon, QS as SettingsGroup, tC as SettingsGroupSearch, qn as Shadow1, Rt as ShadowColourGrey100, yn as ShadowL, nr as ShadowM, Ht as ShadowS, Yt as ShadowSEmboss, Pn as ShadowXs, WC as SignerList, JC as SignerStatusList, jg as SimpleModal, Q_ as SimpleSearchMenuInput, iy as SimpleTableInput, Sn as Sizing12, nn as Sizing16, $t as Sizing18, Dt as Sizing20, or as Sizing24, gr as Sizing32, Pt as Sizing40, pr as Sizing48, Ye as Sizing56, m as Sizing72, lr as Sizing8, $e as Sizing80, $_ as Skeleton, ok as Sortable, S as Spacing12, v as Spacing16, Ne as Spacing20, hn as Spacing24, o as Spacing32, dn as Spacing4, Te as Spacing40, ke as Spacing48, Le as Spacing56, E as Spacing72, le as Spacing8, xe as Spacing80, Oi as Spinner, SS as SplitContent, CS as StandardLayout, dk as StatTile, eb as SteppedNumberField, Qg as SteppedNumberInput, AC as StepsProgressBar, ay as Switch, db as SwitchLineField, oy as SwitchLineInput, jA as TEXT_COLOR_HEX, Mi as Table, Pi as TableContainer, zy as TagInputSelectControl, By as TagInputSelectControlField, Fi as Tbody, Li as Td, zi as Text, $y as TextAreaField, p_ as TextAreaFieldInput, l_ as TextAreaInput, Ge as TextCaseUppercase, Zy as TextField, Hg as TextFieldInput, Lg as TextInput, Qy as TextInputField, mv as TextOverflow, Vi as Tfoot, Hi as Th, Wi as Thead, wx as Toaster, yr as TokenSetOrder0, m_ as Tooltip, g_ as TooltipLegacy, BS as Totals, qi as Tr, u as TurquoiseTurquoise10, st as TurquoiseTurquoise20, ae as TurquoiseTurquoise30, rt as TurquoiseTurquoise40, dt as TurquoiseTurquoise50, O as TurquoiseTurquoise60, _e as TurquoiseTurquoise70, Rn as TurquoiseTurquoise80, pe as TurquoiseTurquoise90, iS as UnorderedList, QC as UsageChart, mk as VARIABLE_TOKEN_PATTERN, dw as VIRTUAL_TABLE_FETCH_LIMIT, ox as VoidInvoicesDialog, YS as Wordmark, lw as XYChart, tw as XYChartTooltip, uw as XYChartTooltipTemplate, yt as YellowYellow10, ht as YellowYellow20, Ct as YellowYellow30, Ve as YellowYellow40, n as YellowYellow50, Ut as YellowYellow60, Xn as YellowYellow70, wn as YellowYellow80, Vn as YellowYellow90, UD as activeFiltersToSearchParams, og as badgeSizes, Cn as borderColor, hk as buildVariableLookup, SI as customFieldsFromRecord, CI as customFieldsToRecord, C_ as dayzedAdapter, Jy as defaultDurationOptions, _v as defaultEmptyLabel, Bn as errorBoxShadow, Cv as filterOptionGroupsOnGroupNameOnly, rn as focusedBoxShadow, Gg as formatWithCommas, mI as getStoredConsent, rC as highlightQueryMatch, Ot as inputBorderRadius, On as internalBorder, Gn as internalBorderColor, kA as isNamedPaletteColor, YD as magicTableToApiQueryParams, ag as sentiments, XD as sortByToParams, It as standardBorder, _n as standardHoverBackground, fI as subscribeToConsent, gv as summariseSelection, wv as toOptionGroupArray, Cx as toasterColors, Oy as useAsyncOptions, W_ as useControlContext, _I as useCookieConsent, wI as useCustomFieldsEditor, kv as useDateRangePickerCalendars, BC as useEntityFiltersBar, $x as useInspectorContext, Jx as useInspectorItem, pS as useLayoutChrome, HD as useLinkMagicTableWithSearchParams, KD as useMagicTableInfiniteQuery, SO as useMagicTableQuery, CO as useMagicTableSelectAll, UT as useMagicTableToolbarContext, Vb as useMenuKeyboardNavigation, gg as useModalClose, Dg as useModalState, PE as useMultiSelectAsync, jx as useNotifications, gO as usePersistMagicTableQueryParams, PC as useSimpleSearch };

//# sourceMappingURL=index.js.map